export interface ISpecEnums {
  name: string;
  id: string;
  tag: number;
  type: string;
  codeSet: string;
  value: string;
  sort?: number;
  group?: string;
  added?: string;
  addedEP?: string;
  updated?: string;
  updatedEP?: string;
  deprecated?: string;
  deprecatedEP?: string;
  description?: string;
}
const batch1: ISpecEnums[] = [
  {
    name: 'Buy',
    id: '4001',
    value: 'B',
    sort: 1,
    added: 'FIX.2.7',
    tag: 4,
    type: 'char',
    codeSet: 'AdvSideCodeSet',
    description: 'Buy',
  },
  {
    name: 'Sell',
    id: '4002',
    value: 'S',
    sort: 2,
    added: 'FIX.2.7',
    tag: 4,
    type: 'char',
    codeSet: 'AdvSideCodeSet',
    description: 'Sell',
  },
  {
    name: 'Trade',
    id: '4003',
    value: 'T',
    sort: 3,
    added: 'FIX.2.7',
    tag: 4,
    type: 'char',
    codeSet: 'AdvSideCodeSet',
    description: 'Trade',
  },
  {
    name: 'Cross',
    id: '4004',
    value: 'X',
    sort: 4,
    added: 'FIX.2.7',
    tag: 4,
    type: 'char',
    codeSet: 'AdvSideCodeSet',
    description: 'Cross',
  },
  {
    name: 'New',
    id: '5001',
    value: 'N',
    sort: 1,
    added: 'FIX.2.7',
    tag: 5,
    type: 'String',
    codeSet: 'AdvTransTypeCodeSet',
    description: 'New',
  },
  {
    name: 'Cancel',
    id: '5002',
    value: 'C',
    sort: 2,
    added: 'FIX.2.7',
    tag: 5,
    type: 'String',
    codeSet: 'AdvTransTypeCodeSet',
    description: 'Cancel',
  },
  {
    name: 'Replace',
    id: '5003',
    value: 'R',
    sort: 3,
    added: 'FIX.2.7',
    tag: 5,
    type: 'String',
    codeSet: 'AdvTransTypeCodeSet',
    description: 'Replace',
  },
  {
    name: 'FIX42',
    id: '8001',
    value: 'FIX.4.2',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '270',
    tag: 8,
    type: 'String',
    codeSet: 'BeginStringCodeSet',
    description: 'Session profile FIX.4.2',
  },
  {
    name: 'FIX44',
    id: '8002',
    value: 'FIX.4.4',
    sort: 2,
    added: 'FIX.Latest',
    addedEP: '270',
    tag: 8,
    type: 'String',
    codeSet: 'BeginStringCodeSet',
    description: 'Session profile FIX4',
  },
  {
    name: 'FIXT11',
    id: '8003',
    value: 'FIXT.1.1',
    sort: 3,
    added: 'FIX.Latest',
    addedEP: '270',
    tag: 8,
    type: 'String',
    codeSet: 'BeginStringCodeSet',
    description:
      'Session profile FIXT or LFXIT\n\nThe choice between FIXT and LFIXT is subject to counterparty agreement.',
  },
  {
    name: 'PerUnit',
    id: '13001',
    value: '1',
    sort: 1,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 13,
    type: 'char',
    codeSet: 'CommTypeCodeSet',
    description:
      'Amount per unit\n\nImplying shares, par, currency, physical unit etc. Use CommissionUnitOfMeasure(1238) to clarify for commodities.',
  },
  {
    name: 'Percent',
    id: '13002',
    value: '2',
    sort: 2,
    added: 'FIX.2.7',
    tag: 13,
    type: 'char',
    codeSet: 'CommTypeCodeSet',
    description: 'Percent',
  },
  {
    name: 'Absolute',
    id: '13003',
    value: '3',
    sort: 3,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 13,
    type: 'char',
    codeSet: 'CommTypeCodeSet',
    description: 'Absolute\n\nTotal monetary amount.',
  },
  {
    name: 'PercentageWaivedCashDiscount',
    id: '13004',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 13,
    type: 'char',
    codeSet: 'CommTypeCodeSet',
    description: 'Percentage waived, cash discount basis\n\nFor use with CIV buy orders.',
  },
  {
    name: 'PercentageWaivedEnhancedUnits',
    id: '13005',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 13,
    type: 'char',
    codeSet: 'CommTypeCodeSet',
    description:
      'Percentage waived, enhanced units basis\n\nFor use with CIV buy orders.',
  },
  {
    name: 'PointsPerBondOrContract',
    id: '13006',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 13,
    type: 'char',
    codeSet: 'CommTypeCodeSet',
    description:
      'Points per bond or contract\n\nSpecify ContractMultiplier(231) in the Instrument component if the security is denominated in a size other than the market convention, e.g. 1000 par for bonds.',
  },
  {
    name: 'BasisPoints',
    id: '13007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 13,
    type: 'char',
    codeSet: 'CommTypeCodeSet',
    description:
      'Basis points\n\nThe commission is expressed in basis points in reference to the gross price of the reference asset.',
  },
  {
    name: 'AmountPerContract',
    id: '13008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '204',
    tag: 13,
    type: 'char',
    codeSet: 'CommTypeCodeSet',
    description:
      'Amount per contract\n\nSpecify ContractMultiplier(231) in the Instrument component if the security is denominated in a size other than the market convention.',
  },
  {
    name: 'StayOnOfferSide',
    id: '18001',
    value: '0',
    sort: 1,
    added: 'FIX.2.7',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Stay on offer side',
  },
  {
    name: 'NotHeld',
    id: '18002',
    value: '1',
    sort: 2,
    added: 'FIX.2.7',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Not held',
  },
  {
    name: 'Work',
    id: '18003',
    value: '2',
    sort: 3,
    added: 'FIX.2.7',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Work',
  },
  {
    name: 'GoAlong',
    id: '18004',
    value: '3',
    sort: 4,
    added: 'FIX.2.7',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Go along',
  },
  {
    name: 'OverTheDay',
    id: '18005',
    value: '4',
    sort: 5,
    added: 'FIX.2.7',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Over the day',
  },
  {
    name: 'Held',
    id: '18006',
    value: '5',
    sort: 6,
    added: 'FIX.2.7',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Held',
  },
  {
    name: 'ParticipateDoNotInitiate',
    id: '18007',
    value: '6',
    sort: 7,
    added: 'FIX.2.7',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: "Participate don't initiate",
  },
  {
    name: 'StrictScale',
    id: '18008',
    value: '7',
    sort: 8,
    added: 'FIX.2.7',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Strict scale',
  },
  {
    name: 'TryToScale',
    id: '18009',
    value: '8',
    sort: 9,
    added: 'FIX.2.7',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Try to scale',
  },
  {
    name: 'StayOnBidSide',
    id: '18010',
    value: '9',
    sort: 10,
    added: 'FIX.2.7',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Stay on bid side',
  },
  {
    name: 'NoCross',
    id: '18011',
    value: 'A',
    sort: 11,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'No cross\n\nCross is forbidden.',
  },
  {
    name: 'OKToCross',
    id: '18012',
    value: 'B',
    sort: 12,
    added: 'FIX.2.7',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'OK to cross',
  },
  {
    name: 'CallFirst',
    id: '18013',
    value: 'C',
    sort: 13,
    added: 'FIX.2.7',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Call first',
  },
  {
    name: 'PercentOfVolume',
    id: '18014',
    value: 'D',
    sort: 14,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description:
      'Percent of volume\n\nIndicates that the sender does not want to be all of the volume on the floor vs. a specific percentage.',
  },
  {
    name: 'DoNotIncrease',
    id: '18015',
    value: 'E',
    sort: 15,
    added: 'FIX.2.7',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Do not increase - DNI',
  },
  {
    name: 'DoNotReduce',
    id: '18016',
    value: 'F',
    sort: 16,
    added: 'FIX.2.7',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Do not reduce - DNR',
  },
  {
    name: 'AllOrNone',
    id: '18017',
    value: 'G',
    sort: 17,
    added: 'FIX.2.7',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'All or none - AON',
  },
  {
    name: 'ReinstateOnSystemFailure',
    id: '18018',
    value: 'H',
    sort: 18,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description:
      'Reinstate on system failure\n\nMutually exclusive with Q and l (lower case L).',
  },
  {
    name: 'InstitutionsOnly',
    id: '18019',
    value: 'I',
    sort: 19,
    added: 'FIX.3.0',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Institutions only',
  },
  {
    name: 'ReinstateOnTradingHalt',
    id: '18020',
    value: 'J',
    sort: 20,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Reinstate on trading halt\n\nMutually exclusive with K and m.',
  },
  {
    name: 'CancelOnTradingHalt',
    id: '18021',
    value: 'K',
    sort: 21,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Cancel on trading halt\n\nMutually exclusive with J and m.',
  },
  {
    name: 'LastPeg',
    id: '18022',
    value: 'L',
    sort: 22,
    added: 'FIX.3.0',
    deprecated: 'FIX.5.0',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Last peg (last sale)',
  },
  {
    name: 'MidPricePeg',
    id: '18023',
    value: 'M',
    sort: 23,
    added: 'FIX.3.0',
    deprecated: 'FIX.5.0',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Mid-price peg (midprice of inside quote)',
  },
  {
    name: 'NonNegotiable',
    id: '18024',
    value: 'N',
    sort: 24,
    added: 'FIX.3.0',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Non-negotiable',
  },
  {
    name: 'OpeningPeg',
    id: '18025',
    value: 'O',
    sort: 25,
    added: 'FIX.3.0',
    deprecated: 'FIX.5.0',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Opening peg',
  },
  {
    name: 'MarketPeg',
    id: '18026',
    value: 'P',
    sort: 26,
    added: 'FIX.3.0',
    deprecated: 'FIX.5.0',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Market peg',
  },
  {
    name: 'CancelOnSystemFailure',
    id: '18027',
    value: 'Q',
    sort: 27,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description:
      'Cancel on system failure\n\nMutually exclusive with H and l(lower case L).',
  },
  {
    name: 'PrimaryPeg',
    id: '18028',
    value: 'R',
    sort: 28,
    added: 'FIX.3.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    deprecated: 'FIX.5.0',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Primary peg\n\nPrimary market - buy at bid, sell at offer.',
  },
  {
    name: 'Suspend',
    id: '18029',
    value: 'S',
    sort: 29,
    added: 'FIX.3.0',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Suspend',
  },
  {
    name: 'FixedPegToLocalBestBidOrOfferAtTimeOfOrder',
    id: '18030',
    value: 'T',
    sort: 30,
    added: 'FIX.4.4',
    addedEP: '35',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    deprecated: 'FIX.5.0',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Fixed peg to local best bid or offer at time of order',
  },
  {
    name: 'CustomerDisplayInstruction',
    id: '18031',
    value: 'U',
    sort: 31,
    added: 'FIX.4.1',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description:
      'Customer display instruction\n\nUsed in US Markets for: SEC Rule 11Ac1-1/4.',
  },
  {
    name: 'Netting',
    id: '18032',
    value: 'V',
    sort: 32,
    added: 'FIX.4.1',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Netting (for Forex)',
  },
  {
    name: 'PegToVWAP',
    id: '18033',
    value: 'W',
    sort: 33,
    added: 'FIX.4.2',
    deprecated: 'FIX.5.0',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Peg to VWAP',
  },
  {
    name: 'TradeAlong',
    id: '18034',
    value: 'X',
    sort: 34,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Trade along',
  },
  {
    name: 'TryToStop',
    id: '18035',
    value: 'Y',
    sort: 35,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Try to stop',
  },
  {
    name: 'CancelIfNotBest',
    id: '18036',
    value: 'Z',
    sort: 36,
    added: 'FIX.4.4',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Cancel if not best',
  },
  {
    name: 'TrailingStopPeg',
    id: '18037',
    value: 'a',
    sort: 37,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    deprecated: 'FIX.5.0',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Trailing stop peg',
  },
  {
    name: 'StrictLimit',
    id: '18038',
    value: 'b',
    sort: 38,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Strict limit\n\nNo price improvement.',
  },
  {
    name: 'IgnorePriceValidityChecks',
    id: '18039',
    value: 'c',
    sort: 39,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Ignore price validity checks',
  },
  {
    name: 'PegToLimitPrice',
    id: '18040',
    value: 'd',
    sort: 40,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    deprecated: 'FIX.5.0',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Peg to limit price',
  },
  {
    name: 'WorkToTargetStrategy',
    id: '18041',
    value: 'e',
    sort: 41,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Work to target strategy',
  },
  {
    name: 'IntermarketSweep',
    id: '18042',
    value: 'f',
    sort: 42,
    added: 'FIX.4.4',
    addedEP: '6',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Intermarket sweep',
  },
  {
    name: 'ExternalRoutingAllowed',
    id: '18043',
    value: 'g',
    sort: 43,
    added: 'FIX.4.4',
    addedEP: '14',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'External routing allowed',
  },
  {
    name: 'ExternalRoutingNotAllowed',
    id: '18044',
    value: 'h',
    sort: 44,
    added: 'FIX.4.4',
    addedEP: '14',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'External routing not allowed',
  },
  {
    name: 'ImbalanceOnly',
    id: '18045',
    value: 'i',
    sort: 45,
    added: 'FIX.4.4',
    addedEP: '22',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Imbalance only',
  },
  {
    name: 'SingleExecutionRequestedForBlockTrade',
    id: '18046',
    value: 'j',
    sort: 46,
    added: 'FIX.4.4',
    addedEP: '6',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Single execution requested for block trade',
  },
  {
    name: 'BestExecution',
    id: '18047',
    value: 'k',
    sort: 47,
    added: 'FIX.4.4',
    addedEP: '35',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Best execution',
  },
  {
    name: 'SuspendOnSystemFailure',
    id: '18048',
    value: 'l',
    sort: 48,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Suspend on system failure\n\nMutually exclusive with H and Q.',
  },
  {
    name: 'SuspendOnTradingHalt',
    id: '18049',
    value: 'm',
    sort: 49,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Suspend on trading halt\n\nMutually exclusive with J and K.',
  },
  {
    name: 'ReinstateOnConnectionLoss',
    id: '18050',
    value: 'n',
    sort: 50,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Reinstate on connection loss\n\nMutually exclusive with o and p.',
  },
  {
    name: 'CancelOnConnectionLoss',
    id: '18051',
    value: 'o',
    sort: 51,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Cancel on connection loss\n\nMutually exclusive with n and p.',
  },
  {
    name: 'SuspendOnConnectionLoss',
    id: '18052',
    value: 'p',
    sort: 52,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Suspend on connection loss\n\nMutually exclusive with n and o.',
  },
  {
    name: 'Release',
    id: '18053',
    value: 'q',
    sort: 53,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Release\n\nMutually exclusive with S and w.',
  },
  {
    name: 'ExecuteAsDeltaNeutral',
    id: '18054',
    value: 'r',
    sort: 54,
    added: 'FIX.5.0',
    addedEP: '59',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Execute as delta neutral using volatility provided',
  },
  {
    name: 'ExecuteAsDurationNeutral',
    id: '18055',
    value: 's',
    sort: 55,
    added: 'FIX.5.0',
    addedEP: '59',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Execute as duration neutral',
  },
  {
    name: 'ExecuteAsFXNeutral',
    id: '18056',
    value: 't',
    sort: 56,
    added: 'FIX.5.0',
    addedEP: '59',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Execute as FX neutral',
  },
  {
    name: 'MinGuaranteedFillEligible',
    id: '18057',
    value: 'u',
    sort: 57,
    added: 'FIX.5.0SP2',
    addedEP: '101',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Minimum guaranteed fill eligible',
  },
  {
    name: 'BypassNonDisplayLiquidity',
    id: '18058',
    value: 'v',
    sort: 58,
    added: 'FIX.5.0SP2',
    addedEP: '101',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Bypass non-displayed liquidity',
  },
  {
    name: 'Lock',
    id: '18059',
    value: 'w',
    sort: 59,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    updated: 'FIX.5.0SP2',
    updatedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Lock\n\nMutually exclusive with q.',
  },
  {
    name: 'IgnoreNotionalValueChecks',
    id: '18060',
    value: 'x',
    sort: 60,
    added: 'FIX.5.0SP2',
    addedEP: '134',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description: 'Ignore notional value checks',
  },
  {
    name: 'TrdAtRefPx',
    id: '18061',
    value: 'y',
    sort: 61,
    added: 'FIX.5.0SP2',
    addedEP: '210',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description:
      'Trade at reference price\n\nIn the context of Reg NMS and the Tick Size Pilot Program, this is intended to indicate the order should Trade At Intermarket Sweep Order (TAISO) price.',
  },
  {
    name: 'AllowFacilitation',
    id: '18062',
    value: 'z',
    sort: 62,
    added: 'FIX.5.0SP2',
    addedEP: '251',
    tag: 18,
    type: 'MultipleCharValue',
    codeSet: 'ExecInstCodeSet',
    description:
      "Allow facilitation\n\nExpress explicit consent to receive facilitation services from the counterparty. Facilitation services are when an institutional client allows a broker to assume a risk-taking principal position rather than an agency position, to obtain liquidity or achieve a guaranteed execution price on the client's behalf. Interpretation of absence of this value needs to be bilaterally agreed, if applicable. In the context of Hong Kong's SFC, this can be used to comply with SFC regulations for disclosure of client facilitation.",
  },
  {
    name: 'AutomatedExecutionNoIntervention',
    id: '21001',
    value: '1',
    sort: 1,
    added: 'FIX.2.7',
    tag: 21,
    type: 'char',
    codeSet: 'HandlInstCodeSet',
    description: 'Automated execution order, private, no Broker intervention',
  },
  {
    name: 'AutomatedExecutionInterventionOK',
    id: '21002',
    value: '2',
    sort: 2,
    added: 'FIX.2.7',
    tag: 21,
    type: 'char',
    codeSet: 'HandlInstCodeSet',
    description: 'Automated execution order, public, Broker intervention OK',
  },
  {
    name: 'ManualOrder',
    id: '21003',
    value: '3',
    sort: 3,
    added: 'FIX.2.7',
    tag: 21,
    type: 'char',
    codeSet: 'HandlInstCodeSet',
    description: 'Manual order, best execution',
  },
  {
    name: 'CUSIP',
    id: '22001',
    value: '1',
    sort: 1,
    added: 'FIX.2.7',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'CUSIP',
  },
  {
    name: 'SEDOL',
    id: '22002',
    value: '2',
    sort: 2,
    added: 'FIX.2.7',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'SEDOL',
  },
  {
    name: 'QUIK',
    id: '22003',
    value: '3',
    sort: 3,
    added: 'FIX.2.7',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'QUIK',
  },
  {
    name: 'ISINNumber',
    id: '22004',
    value: '4',
    sort: 4,
    added: 'FIX.3.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '232',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'ISIN',
  },
  {
    name: 'RICCode',
    id: '22005',
    value: '5',
    sort: 5,
    added: 'FIX.3.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '232',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'RIC',
  },
  {
    name: 'ISOCurrencyCode',
    id: '22006',
    value: '6',
    sort: 6,
    added: 'FIX.4.1',
    updated: 'FIX.Latest',
    updatedEP: '273',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'ISO Currency Code (ISO 4217)',
  },
  {
    name: 'ISOCountryCode',
    id: '22007',
    value: '7',
    sort: 7,
    added: 'FIX.4.1',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'ISO Country Code',
  },
  {
    name: 'ExchangeSymbol',
    id: '22008',
    value: '8',
    sort: 8,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP2',
    updatedEP: '119',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'Exchange symbol',
  },
  {
    name: 'ConsolidatedTapeAssociation',
    id: '22009',
    value: '9',
    sort: 9,
    added: 'FIX.4.2',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'Consolidated Tape Association (CTA) Symbol (SIAC CTS/CQS line format)',
  },
  {
    name: 'BloombergSymbol',
    id: '22010',
    value: 'A',
    sort: 10,
    added: 'FIX.4.3',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'Bloomberg Symbol',
  },
  {
    name: 'Wertpapier',
    id: '22011',
    value: 'B',
    sort: 11,
    added: 'FIX.4.3',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'Wertpapier',
  },
  {
    name: 'Dutch',
    id: '22012',
    value: 'C',
    sort: 12,
    added: 'FIX.4.3',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'Dutch',
  },
  {
    name: 'Valoren',
    id: '22013',
    value: 'D',
    sort: 13,
    added: 'FIX.4.3',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'Valoren',
  },
  {
    name: 'Sicovam',
    id: '22014',
    value: 'E',
    sort: 14,
    added: 'FIX.4.3',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'Sicovam',
  },
  {
    name: 'Belgian',
    id: '22015',
    value: 'F',
    sort: 15,
    added: 'FIX.4.3',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'Belgian',
  },
  {
    name: 'Common',
    id: '22016',
    value: 'G',
    sort: 16,
    added: 'FIX.4.3',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: '"Common" (Clearstream and Euroclear)',
  },
  {
    name: 'ClearingHouse',
    id: '22017',
    value: 'H',
    sort: 17,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '119',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'Clearing house / Clearing organization',
  },
  {
    name: 'ISDAFpMLSpecification',
    id: '22018',
    value: 'I',
    sort: 18,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '119',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'ISDA/FpML product specification (XML in SecurityXML(1185))',
  },
  {
    name: 'OptionPriceReportingAuthority',
    id: '22019',
    value: 'J',
    sort: 19,
    added: 'FIX.4.4',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'Option Price Reporting Authority',
  },
  {
    name: 'ISDAFpMLURL',
    id: '22020',
    value: 'K',
    sort: 20,
    added: 'FIX.4.4',
    addedEP: '15',
    updated: 'FIX.5.0SP2',
    updatedEP: '119',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'ISDA/FpML product URL (URL in SecurityID(48))',
  },
  {
    name: 'LetterOfCredit',
    id: '22021',
    value: 'L',
    sort: 21,
    added: 'FIX.4.4',
    addedEP: '8',
    updated: 'FIX.5.0SP2',
    updatedEP: '119',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'Letter of credit',
  },
  {
    name: 'MarketplaceAssignedIdentifier',
    id: '22022',
    value: 'M',
    sort: 22,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'Marketplace-assigned Identifier',
  },
  {
    name: 'MarkitREDEntityCLIP',
    id: '22023',
    value: 'N',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '119',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'Markit RED entity CLIP',
  },
  {
    name: 'MarkitREDPairCLIP',
    id: '22024',
    value: 'P',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '119',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'Markit RED pair CLIP',
  },
  {
    name: 'CFTCCommodityCode',
    id: '22025',
    value: 'Q',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '140',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'CFTC commodity code',
  },
  {
    name: 'ISDACommodityReferencePrice',
    id: '22026',
    value: 'R',
    sort: 26,
    added: 'FIX.5.0SP2',
    addedEP: '140',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'ISDA Commodity Reference Price',
  },
  {
    name: 'FinancialInstrumentGlobalIdentifier',
    id: '22027',
    value: 'S',
    sort: 27,
    added: 'FIX.5.0SP2',
    addedEP: '158',
    updated: 'FIX.5.0SP2',
    updatedEP: '202',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description:
      'Financial Instrument Global Identifier\n\nAn Object Management Group (OMG) standard. Also referred to as FIGI. Formerly known as "Bloomberg Open Symbology BBGID".',
  },
  {
    name: 'LegalEntityIdentifier',
    id: '22028',
    value: 'T',
    sort: 28,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'Legal entity identifier',
  },
  {
    name: 'Synthetic',
    id: '22029',
    value: 'U',
    sort: 29,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description:
      'Synthetic\n\nUsed to specify that the security identifier is synthetic for linking nested underliers when there is no market identifier for the collection.',
  },
  {
    name: 'FidessaInstrumentMnemonic',
    id: '22030',
    value: 'V',
    sort: 30,
    added: 'FIX.5.0SP2',
    addedEP: '220',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'Fidessa Instrument Mnemonic (FIM)',
  },
  {
    name: 'IndexName',
    id: '22031',
    value: 'W',
    sort: 31,
    added: 'FIX.5.0SP2',
    addedEP: '232',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description:
      'Index name\n\nStandard name of the index or rate index, e.g. "LIBOR" or "iTraxx Australia".',
  },
  {
    name: 'UniformSymbol',
    id: '22032',
    value: 'X',
    sort: 32,
    added: 'FIX.5.0SP2',
    addedEP: '242',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'Uniform Symbol (UMTF Symbol)',
  },
  {
    name: 'DigitalTokenIdentifier',
    id: '22033',
    value: 'Y',
    sort: 33,
    added: 'FIX.Latest',
    addedEP: '273',
    tag: 22,
    type: 'String',
    codeSet: 'SecurityIDSourceCodeSet',
    description: 'Digital Token Identifier (ISO 24165)',
  },
  {
    name: 'High',
    id: '25001',
    value: 'H',
    sort: 1,
    added: 'FIX.2.7',
    tag: 25,
    type: 'char',
    codeSet: 'IOIQltyIndCodeSet',
    description: 'High',
  },
  {
    name: 'Low',
    id: '25002',
    value: 'L',
    sort: 2,
    added: 'FIX.2.7',
    tag: 25,
    type: 'char',
    codeSet: 'IOIQltyIndCodeSet',
    description: 'Low',
  },
  {
    name: 'Medium',
    id: '25003',
    value: 'M',
    sort: 3,
    added: 'FIX.2.7',
    tag: 25,
    type: 'char',
    codeSet: 'IOIQltyIndCodeSet',
    description: 'Medium',
  },
  {
    name: 'Small',
    id: '27001',
    value: 'S',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '25',
    tag: 27,
    type: 'String',
    codeSet: 'IOIQtyCodeSet',
    description: 'Small',
  },
  {
    name: 'Medium',
    id: '27002',
    value: 'M',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '25',
    tag: 27,
    type: 'String',
    codeSet: 'IOIQtyCodeSet',
    description: 'Medium',
  },
  {
    name: 'Large',
    id: '27003',
    value: 'L',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '25',
    tag: 27,
    type: 'String',
    codeSet: 'IOIQtyCodeSet',
    description: 'Large',
  },
  {
    name: 'UndisclosedQuantity',
    id: '27004',
    value: 'U',
    sort: 5,
    added: 'FIX.4.4',
    addedEP: '25',
    tag: 27,
    type: 'String',
    codeSet: 'IOIQtyCodeSet',
    description: 'Undisclosed Quantity',
  },
  {
    name: 'New',
    id: '28001',
    value: 'N',
    sort: 1,
    added: 'FIX.2.7',
    tag: 28,
    type: 'char',
    codeSet: 'IOITransTypeCodeSet',
    description: 'New',
  },
  {
    name: 'Cancel',
    id: '28002',
    value: 'C',
    sort: 2,
    added: 'FIX.2.7',
    tag: 28,
    type: 'char',
    codeSet: 'IOITransTypeCodeSet',
    description: 'Cancel',
  },
  {
    name: 'Replace',
    id: '28003',
    value: 'R',
    sort: 3,
    added: 'FIX.2.7',
    tag: 28,
    type: 'char',
    codeSet: 'IOITransTypeCodeSet',
    description: 'Replace',
  },
  {
    name: 'Agent',
    id: '29001',
    value: '1',
    sort: 1,
    added: 'FIX.2.7',
    tag: 29,
    type: 'char',
    codeSet: 'LastCapacityCodeSet',
    description: 'Agent',
  },
  {
    name: 'CrossAsAgent',
    id: '29002',
    value: '2',
    sort: 2,
    added: 'FIX.2.7',
    tag: 29,
    type: 'char',
    codeSet: 'LastCapacityCodeSet',
    description: 'Cross as agent',
  },
  {
    name: 'CrossAsPrincipal',
    id: '29003',
    value: '3',
    sort: 3,
    added: 'FIX.2.7',
    tag: 29,
    type: 'char',
    codeSet: 'LastCapacityCodeSet',
    description: 'Cross as principal',
  },
  {
    name: 'Principal',
    id: '29004',
    value: '4',
    sort: 4,
    added: 'FIX.2.7',
    tag: 29,
    type: 'char',
    codeSet: 'LastCapacityCodeSet',
    description: 'Principal',
  },
  {
    name: 'RisklessPrincipal',
    id: '29005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '222',
    tag: 29,
    type: 'char',
    codeSet: 'LastCapacityCodeSet',
    description: 'Riskless principal',
  },
  {
    name: 'Heartbeat',
    id: '35001',
    value: '0',
    sort: 1,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'Heartbeat\n\nThe Heartbeat monitors the status of the communication link and identifies when the last of a string of messages was not received.',
  },
  {
    name: 'TestRequest',
    id: '35002',
    value: '1',
    sort: 2,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TestRequest\n\nThe test request message forces a heartbeat from the opposing application. The test request message checks sequence numbers or verifies communication line status. The opposite application responds to the Test Request with a Heartbeat containing the TestReqID.',
  },
  {
    name: 'ResendRequest',
    id: '35003',
    value: '2',
    sort: 3,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'ResendRequest\n\nThe resend request is sent by the receiving application to initiate the retransmission of messages. This function is utilized if a sequence number gap is detected, if the receiving application lost a message, or as a function of the initialization process.',
  },
  {
    name: 'Reject',
    id: '35004',
    value: '3',
    sort: 4,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'Reject\n\nThe reject message should be issued when a message is received but cannot be properly processed due to a session-level rule violation. An example of when a reject may be appropriate would be the receipt of a message with invalid basic data which successfully passes de-encryption, CheckSum and BodyLength checks.',
  },
  {
    name: 'SequenceReset',
    id: '35005',
    value: '4',
    sort: 5,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'SequenceReset\n\nThe sequence reset message is used by the sending application to reset the incoming sequence number on the opposing side.',
  },
  {
    name: 'Logout',
    id: '35006',
    value: '5',
    sort: 6,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'Logout\n\nThe logout message initiates or confirms the termination of a FIX session. Disconnection without the exchange of logout messages should be interpreted as an abnormal condition.',
  },
  {
    name: 'IOI',
    id: '35007',
    value: '6',
    sort: 7,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'IOI\n\nIndication of interest messages are used to market merchandise which the broker is buying or selling in either a proprietary or agency capacity. The indications can be time bound with a specific expiration value. Indications are distributed with the understanding that other firms may react to the message first and that the merchandise may no longer be available due to prior trade.\n\nIndication messages can be transmitted in various transaction types; NEW, CANCEL, and REPLACE. All message types other than NEW modify the state of the message identified in IOIRefID.',
  },
  {
    name: 'Advertisement',
    id: '35008',
    value: '7',
    sort: 8,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'Advertisement\n\nAdvertisement messages are used to announce completed transactions. The advertisement message can be transmitted in various transaction types; NEW, CANCEL and REPLACE. All message types other than NEW modify the state of a previously transmitted advertisement identified in AdvRefID.',
  },
  {
    name: 'ExecutionReport',
    id: '35009',
    value: '8',
    sort: 9,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'ExecutionReport\n\nThe execution report message is used to:\n\n1. confirm the receipt of an order\n\n2. confirm changes to an existing order (i.e. accept cancel and replace requests)\n\n3. relay order status information\n\n4. relay fill information on working orders\n\n5. relay fill information on tradeable or restricted tradeable quotes\n\n6. reject orders\n\n7. report post-trade fees calculations associated with a trade',
  },
  {
    name: 'OrderCancelReject',
    id: '35010',
    value: '9',
    sort: 10,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'OrderCancelReject\n\nThe order cancel reject message is issued by the broker upon receipt of a cancel request or cancel/replace request message which cannot be honored.',
  },
  {
    name: 'Logon',
    id: '35011',
    value: 'A',
    sort: 11,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'Logon\n\nThe logon message authenticates a user establishing a connection to a remote system. The logon message must be the first message sent by the application requesting to initiate a FIX session.',
  },
  {
    name: 'News',
    id: '35012',
    value: 'B',
    sort: 12,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      "News\n\nThe news message is a general free format message between the broker and institution. The message contains flags to identify the news item's urgency and to allow sorting by subject company (symbol). The News message can be originated at either the broker or institution side, or exchanges and other marketplace venues.",
  },
  {
    name: 'Email',
    id: '35013',
    value: 'C',
    sort: 13,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'Email\n\nThe email message is similar to the format and purpose of the News message, however, it is intended for private use between two parties.',
  },
  {
    name: 'NewOrderSingle',
    id: '35014',
    value: 'D',
    sort: 14,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'NewOrderSingle\n\nThe new order message type is used by institutions wishing to electronically submit securities and forex orders to a broker for execution.\n\nThe New Order message type may also be used by institutions or retail intermediaries wishing to electronically submit Collective Investment Vehicle (CIV) orders to a broker or fund manager for execution.',
  },
  {
    name: 'NewOrderList',
    id: '35015',
    value: 'E',
    sort: 15,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'NewOrderList\n\nThe NewOrderList Message can be used in one of two ways depending on which market conventions are being followed.',
  },
  {
    name: 'OrderCancelRequest',
    id: '35016',
    value: 'F',
    sort: 16,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'OrderCancelRequest\n\nThe order cancel request message requests the cancellation of all of the remaining quantity of an existing order. Note that the Order Cancel/Replace Request should be used to partially cancel (reduce) an order).',
  },
  {
    name: 'OrderCancelReplaceRequest',
    id: '35017',
    value: 'G',
    sort: 17,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'OrderCancelReplaceRequest\n\nThe order cancel/replace request is used to change the parameters of an existing order.\n\nDo not use this message to cancel the remaining quantity of an outstanding order, use the Order Cancel Request message for this purpose.',
  },
  {
    name: 'OrderStatusRequest',
    id: '35018',
    value: 'H',
    sort: 18,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'OrderStatusRequest\n\nThe order status request message is used by the institution to generate an order status message back from the broker.',
  },
  {
    name: 'AllocationInstruction',
    id: '35019',
    value: 'J',
    sort: 19,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'AllocationInstruction\n\nThe AllocationInstruction(35=J) message provides the ability to specify how an order or set of orders should be subdivided amongst one or more accounts.',
  },
  {
    name: 'ListCancelRequest',
    id: '35020',
    value: 'K',
    sort: 20,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'ListCancelRequest\n\nThe List Cancel Request message type is used by institutions wishing to cancel previously submitted lists either before or during execution.',
  },
  {
    name: 'ListExecute',
    id: '35021',
    value: 'L',
    sort: 21,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'ListExecute\n\nThe List Execute message type is used by institutions to instruct the broker to begin execution of a previously submitted list. This message may or may not be used, as it may be mirroring a phone conversation.',
  },
  {
    name: 'ListStatusRequest',
    id: '35022',
    value: 'M',
    sort: 22,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'ListStatusRequest\n\nThe list status request message type is used by institutions to instruct the broker to generate status messages for a list.',
  },
  {
    name: 'ListStatus',
    id: '35023',
    value: 'N',
    sort: 23,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      "ListStatus\n\nThe list status message is issued as the response to a List Status Request message sent in an unsolicited fashion by the sell-side. It indicates the current state of the orders within the list as they exist at the broker's site. This message may also be used to respond to the List Cancel Request.",
  },
  {
    name: 'AllocationInstructionAck',
    id: '35024',
    value: 'P',
    sort: 24,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'AllocationInstructionAck\n\nIn versions of FIX prior to version 4.4, this message was known as the Allocation ACK message.\n\nThe Allocation Instruction Ack message is used to acknowledge the receipt of and provide status for an Allocation Instruction message.',
  },
  {
    name: 'DontKnowTrade',
    id: '35025',
    value: 'Q',
    sort: 25,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'DontKnowTrade\n\nThe Don’t Know Trade (DK) message notifies a trading partner that an electronically received execution has been rejected. This message can be thought of as an execution reject message.',
  },
  {
    name: 'QuoteRequest',
    id: '35026',
    value: 'R',
    sort: 26,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'QuoteRequest\n\nIn some markets it is the practice to request quotes from brokers prior to placement of an order. The quote request message is used for this purpose. This message is commonly referred to as an Request For Quote (RFQ)',
  },
  {
    name: 'Quote',
    id: '35027',
    value: 'S',
    sort: 27,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'Quote\n\nThe Quote message is used as the response to a Quote Request or a Quote Response message in both indicative, tradeable, and restricted tradeable quoting markets.',
  },
  {
    name: 'SettlementInstructions',
    id: '35028',
    value: 'T',
    sort: 28,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'SettlementInstructions\n\nThe Settlement Instructions message provides the broker’s, the institution’s, or the intermediary’s instructions for trade settlement. This message has been designed so that it can be sent from the broker to the institution, from the institution to the broker, or from either to an independent "standing instructions" database or matching system or, for CIV, from an intermediary to a fund manager.',
  },
  {
    name: 'MarketDataRequest',
    id: '35029',
    value: 'V',
    sort: 29,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'MarketDataRequest\n\nSome systems allow the transmission of real-time quote, order, trade, trade volume, open interest, and/or other price information on a subscription basis. A MarketDataRequest(35=V) is a general request for market data on specific securities or forex quotes. The values in the fields provided within the request will serve as further filter criteria for the result set.',
  },
  {
    name: 'MarketDataSnapshotFullRefresh',
    id: '35030',
    value: 'W',
    sort: 30,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'MarketDataSnapshotFullRefresh\n\nThe Market Data messages are used as the response to a Market Data Request message. In all cases, one Market Data message refers only to one Market Data Request. It can be used to transmit a 2-sided book of orders or list of quotes, a list of trades, index values, opening, closing, settlement, high, low, or VWAP prices, the trade volume or open interest for a security, or any combination of these.',
  },
  {
    name: 'MarketDataIncrementalRefresh',
    id: '35031',
    value: 'X',
    sort: 31,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'MarketDataIncrementalRefresh\n\nThe Market Data message for incremental updates may contain any combination of new, changed, or deleted Market Data Entries, for any combination of instruments, with any combination of trades, imbalances, quotes, index values, open, close, settlement, high, low, and VWAP prices, trade volume and open interest so long as the maximum FIX message size is not exceeded. All of these types of Market Data Entries can be changed and deleted.',
  },
  {
    name: 'MarketDataRequestReject',
    id: '35032',
    value: 'Y',
    sort: 32,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'MarketDataRequestReject\n\nThe Market Data Request Reject is used when the broker cannot honor the Market Data Request, due to business or technical reasons. Brokers may choose to limit various parameters, such as the size of requests, whether just the top of book or the entire book may be displayed, and whether Full or Incremental updates must be used.',
  },
  {
    name: 'QuoteCancel',
    id: '35033',
    value: 'Z',
    sort: 33,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'QuoteCancel\n\nThe Quote Cancel message is used by an originator of quotes to cancel quotes.\n\nThe Quote Cancel message supports cancellation of:\n\n• All quotes\n\n• Quotes for a specific symbol or security ID\n\n• All quotes for a security type\n\n• All quotes for an underlying',
  },
  {
    name: 'QuoteStatusRequest',
    id: '35034',
    value: 'a',
    sort: 34,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'QuoteStatusRequest\n\nThe quote status request message is used for the following purposes in markets that employ tradeable or restricted tradeable quotes:\n\n• For the issuer of a quote in a market to query the status of that quote (using the QuoteID to specify the target quote).\n\n• To subscribe and unsubscribe for Quote Status Report messages for one or more securities.',
  },
  {
    name: 'MassQuoteAck',
    id: '35035',
    value: 'b',
    sort: 35,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'MassQuoteAck\n\nMass Quote Acknowledgement is used as the application level response to a Mass Quote message.',
  },
  {
    name: 'SecurityDefinitionRequest',
    id: '35036',
    value: 'c',
    sort: 36,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'SecurityDefinitionRequest\n\nThe SecurityDefinitionRequest(35=c) message is used for the following:\n\n1. Request a specific security to be traded with the second party. The requested security can be defined as a multileg security made up of one or more instrument legs.\n\n2. Request a set of individual securities for a single market segment.\n\n3. Request all securities, independent of market segment.',
  },
  {
    name: 'SecurityDefinition',
    id: '35037',
    value: 'd',
    sort: 37,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      "SecurityDefinition\n\nThe SecurityDefinition(35=d) message is used for the following:\n\n1. Accept the security defined in a SecurityDefinition(35=d) message.\n\n2. Accept the security defined in a SecurityDefinition(35=d) message with changes to the definition and/or identity of the security.\n\n3. Reject the security requested in a SecurityDefinition(35=d) message.\n\n4. Respond to a request for securities within a specified market segment.\n\n5. Convey comprehensive security definition for all market segments that the security participates in.\n\n6. Convey the security's trading rules that differ from default rules for the market segment.",
  },
  {
    name: 'SecurityStatusRequest',
    id: '35038',
    value: 'e',
    sort: 38,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'SecurityStatusRequest\n\nThe Security Status Request message provides for the ability to request the status of a security. One or more Security Status messages are returned as a result of a Security Status Request message.',
  },
  {
    name: 'SecurityStatus',
    id: '35039',
    value: 'f',
    sort: 39,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'SecurityStatus\n\nThe Security Status message provides for the ability to report changes in status to a security. The Security Status message contains fields to indicate trading status, corporate actions, financial status of the company. The Security Status message is used by one trading entity (for instance an exchange) to report changes in the state of a security.',
  },
  {
    name: 'TradingSessionStatusRequest',
    id: '35040',
    value: 'g',
    sort: 40,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TradingSessionStatusRequest\n\nThe Trading Session Status Request is used to request information on the status of a market. With the move to multiple sessions occurring for a given trading party (morning and evening sessions for instance) there is a need to be able to provide information on what product is trading on what market.',
  },
  {
    name: 'TradingSessionStatus',
    id: '35041',
    value: 'h',
    sort: 41,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TradingSessionStatus\n\nThe Trading Session Status provides information on the status of a market. For markets multiple trading sessions on multiple-markets occurring (morning and evening sessions for instance), this message is able to provide information on what products are trading on what market during what trading session.',
  },
  {
    name: 'MassQuote',
    id: '35042',
    value: 'i',
    sort: 42,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'MassQuote\n\nThe Mass Quote message can contain quotes for multiple securities to support applications that allow for the mass quoting of an option series. Two levels of repeating groups have been provided to minimize the amount of data required to submit a set of quotes for a class of options (e.g. all option series for IBM).',
  },
  {
    name: 'BusinessMessageReject',
    id: '35043',
    value: 'j',
    sort: 43,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'BusinessMessageReject\n\nThe Business Message Reject message can reject an application-level message which fulfills session-level rules and cannot be rejected via any other means. Note if the message fails a session-level rule (e.g. body length is incorrect), a session-level Reject message should be issued.',
  },
  {
    name: 'BidRequest',
    id: '35044',
    value: 'k',
    sort: 44,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'BidRequest\n\nThe BidRequest Message can be used in one of two ways depending on which market conventions are being followed.\n\nIn the "Non disclosed" convention (e.g. US/European model) the BidRequest message can be used to request a bid based on the sector, country, index and liquidity information contained within the message itself. In the "Non disclosed" convention the entry repeating group is used to define liquidity of the program. See " Program/Basket/List Trading" for an example.\n\nIn the "Disclosed" convention (e.g. Japanese model) the BidRequest message can be used to request bids based on the ListOrderDetail messages sent in advance of BidRequest message. In the "Disclosed" convention the list repeating group is used to define which ListOrderDetail messages a bid is being sort for and the directions of the required bids.',
  },
  {
    name: 'BidResponse',
    id: '35045',
    value: 'l',
    sort: 45,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'BidResponse\n\nThe Bid Response message can be used in one of two ways depending on which market conventions are being followed.\n\nIn the "Non disclosed" convention the Bid Response message can be used to supply a bid based on the sector, country, index and liquidity information contained within the corresponding bid request message. See "Program/Basket/List Trading" for an example.\n\nIn the "Disclosed" convention the Bid Response message can be used to supply bids based on the List Order Detail messages sent in advance of the corresponding Bid Request message.',
  },
  {
    name: 'ListStrikePrice',
    id: '35046',
    value: 'm',
    sort: 46,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'ListStrikePrice\n\nThe strike price message is used to exchange strike price information for principal trades. It can also be used to exchange reference prices for agency trades.',
  },
  {
    name: 'XMLnonFIX',
    id: '35047',
    value: 'n',
    sort: 47,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description: 'XMLnonFIX\n\n',
  },
  {
    name: 'RegistrationInstructions',
    id: '35048',
    value: 'o',
    sort: 48,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'RegistrationInstructions\n\nThe Registration Instructions message type may be used by institutions or retail intermediaries wishing to electronically submit registration information to a broker or fund manager (for CIV) for an order or for an allocation.',
  },
  {
    name: 'RegistrationInstructionsResponse',
    id: '35049',
    value: 'p',
    sort: 49,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'RegistrationInstructionsResponse\n\nThe Registration Instructions Response message type may be used by broker or fund manager (for CIV) in response to a Registration Instructions message submitted by an institution or retail intermediary for an order or for an allocation.',
  },
  {
    name: 'OrderMassCancelRequest',
    id: '35050',
    value: 'q',
    sort: 50,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'OrderMassCancelRequest\n\nThe order mass cancel request message requests the cancellation of all of the remaining quantity of a group of orders matching criteria specified within the request. NOTE: This message can only be used to cancel order messages (reduce the full quantity).',
  },
  {
    name: 'OrderMassCancelReport',
    id: '35051',
    value: 'r',
    sort: 51,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'OrderMassCancelReport\n\nThe Order Mass Cancel Report is used to acknowledge an Order Mass Cancel Request. Note that each affected order that is canceled is acknowledged with a separate Execution Report or Order Cancel Reject message.',
  },
  {
    name: 'NewOrderCross',
    id: '35052',
    value: 's',
    sort: 52,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'NewOrderCross\n\nUsed to submit a cross order into a market. The cross order contains two order sides (a buy and a sell). The cross order is identified by its CrossID.',
  },
  {
    name: 'CrossOrderCancelReplaceRequest',
    id: '35053',
    value: 't',
    sort: 53,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'CrossOrderCancelReplaceRequest\n\nUsed to modify a cross order previously submitted using the New Order - Cross message. See Order Cancel Replace Request for details concerning message usage.',
  },
  {
    name: 'CrossOrderCancelRequest',
    id: '35054',
    value: 'u',
    sort: 54,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'CrossOrderCancelRequest\n\nUsed to fully cancel the remaining open quantity of a cross order.',
  },
  {
    name: 'SecurityTypeRequest',
    id: '35055',
    value: 'v',
    sort: 55,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'SecurityTypeRequest\n\nThe Security Type Request message is used to return a list of security types available from a counterparty or market.',
  },
  {
    name: 'SecurityTypes',
    id: '35056',
    value: 'w',
    sort: 56,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'SecurityTypes\n\nThe Security Type Request message is used to return a list of security types available from a counterparty or market.',
  },
  {
    name: 'SecurityListRequest',
    id: '35057',
    value: 'x',
    sort: 57,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'SecurityListRequest\n\nThe Security List Request message is used to return a list of securities from the counterparty that match criteria provided on the request',
  },
  {
    name: 'SecurityList',
    id: '35058',
    value: 'y',
    sort: 58,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'SecurityList\n\nThe Security List message is used to return a list of securities that matches the criteria specified in a Security List Request.',
  },
  {
    name: 'DerivativeSecurityListRequest',
    id: '35059',
    value: 'z',
    sort: 59,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'DerivativeSecurityListRequest\n\nThe Derivative Security List Request message is used to return a list of securities from the counterparty that match criteria provided on the request',
  },
  {
    name: 'DerivativeSecurityList',
    id: '35060',
    value: 'AA',
    sort: 60,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'DerivativeSecurityList\n\nThe Derivative Security List message is used to return a list of securities that matches the criteria specified in a Derivative Security List Request.',
  },
  {
    name: 'NewOrderMultileg',
    id: '35061',
    value: 'AB',
    sort: 61,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'NewOrderMultileg\n\nThe New Order - Multileg is provided to submit orders for securities that are made up of multiple securities, known as legs.',
  },
  {
    name: 'MultilegOrderCancelReplace',
    id: '35062',
    value: 'AC',
    sort: 62,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'MultilegOrderCancelReplace\n\nUsed to modify a multileg order previously submitted using the New Order - Multileg message. See Order Cancel Replace Request for details concerning message usage.',
  },
  {
    name: 'TradeCaptureReportRequest',
    id: '35063',
    value: 'AD',
    sort: 63,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TradeCaptureReportRequest\n\nThe Trade Capture Report Request can be used to:\n\n• Request one or more trade capture reports based upon selection criteria provided on the trade capture report request\n\n• Subscribe for trade capture reports based upon selection criteria provided on the trade capture report request.',
  },
  {
    name: 'TradeCaptureReport',
    id: '35064',
    value: 'AE',
    sort: 64,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TradeCaptureReport\n\nThe Trade Capture Report message can be:\n\n- Used to report trades between counterparties.\n\n- Used to report trades to a trade matching system.\n\n- Sent unsolicited between counterparties.\n\n- Sent as a reply to a Trade Capture Report Request.\n\n- Used to report unmatched and matched trades.',
  },
  {
    name: 'OrderMassStatusRequest',
    id: '35065',
    value: 'AF',
    sort: 65,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'OrderMassStatusRequest\n\nThe order mass status request message requests the status for orders matching criteria specified within the request.',
  },
  {
    name: 'QuoteRequestReject',
    id: '35066',
    value: 'AG',
    sort: 66,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'QuoteRequestReject\n\nThe Quote Request Reject message is used to reject Quote Request messages for all quoting models.',
  },
  {
    name: 'RFQRequest',
    id: '35067',
    value: 'AH',
    sort: 67,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'RFQRequest\n\nIn tradeable and restricted tradeable quoting markets – Quote Requests are issued by counterparties interested in ascertaining the market for an instrument. Quote Requests are then distributed by the market to liquidity providers who make markets in the instrument. The RFQ Request is used by liquidity providers to indicate to the market for which instruments they are interested in receiving Quote Requests. It can be used to register interest in receiving quote requests for a single instrument or for multiple instruments',
  },
  {
    name: 'QuoteStatusReport',
    id: '35068',
    value: 'AI',
    sort: 68,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'QuoteStatusReport\n\nThe quote status report message is used:\n\n• as the response to a Quote Status Request message\n\n• as a response to a Quote Cancel message\n\n• as a response to a Quote Response message in a negotiation dialog (see Volume 7 – PRODUCT: FIXED INCOME and USER GROUP: EXCHANGES AND MARKETS)',
  },
  {
    name: 'QuoteResponse',
    id: '35069',
    value: 'AJ',
    sort: 69,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'QuoteResponse\n\nThe QuoteResponse(35=AJ) message is used for the following purposes:\n\n1. Respond to an IOI(35=6) message\n\n2. Respond to a Quote(35=S) message\n\n3. Counter a Quote\n\n4. End a negotiation dialog\n\n5. Follow-up or end a QuoteRequest(35=R) dialog that did not receive a response.',
  },
  {
    name: 'Confirmation',
    id: '35070',
    value: 'AK',
    sort: 70,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'Confirmation\n\nThe Confirmation messages are used to provide individual trade level confirmations from the sell side to the buy side. In versions of FIX prior to version 4.4, this role was performed by the allocation message. Unlike the allocation message, the confirmation message operates at an allocation account (trade) level rather than block level, allowing for the affirmation or rejection of individual confirmations.',
  },
  {
    name: 'PositionMaintenanceRequest',
    id: '35071',
    value: 'AL',
    sort: 71,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PositionMaintenanceRequest\n\nThe Position Maintenance Request message allows the position owner to submit requests to the holder of a position which will result in a specific action being taken which will affect the position. Generally, the holder of the position is a central counter party or clearing organization but can also be a party providing investment services.',
  },
  {
    name: 'PositionMaintenanceReport',
    id: '35072',
    value: 'AM',
    sort: 72,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PositionMaintenanceReport\n\nThe Position Maintenance Report message is sent by the holder of a position in response to a Position Maintenance Request and is used to confirm that a request has been successfully processed or rejected.',
  },
  {
    name: 'RequestForPositions',
    id: '35073',
    value: 'AN',
    sort: 73,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'RequestForPositions\n\nThe Request For Positions message is used by the owner of a position to request a Position Report from the holder of the position, usually the central counter party or clearing organization. The request can be made at several levels of granularity.',
  },
  {
    name: 'RequestForPositionsAck',
    id: '35074',
    value: 'AO',
    sort: 74,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'RequestForPositionsAck\n\nThe Request for Positions Ack message is returned by the holder of the position in response to a Request for Positions message. The purpose of the message is to acknowledge that a request has been received and is being processed.',
  },
  {
    name: 'PositionReport',
    id: '35075',
    value: 'AP',
    sort: 75,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PositionReport\n\nThe Position Report message is returned by the holder of a position in response to a Request for Position message. The purpose of the message is to report all aspects of a position and may be provided on a standing basis to report end of day positions to an owner.',
  },
  {
    name: 'TradeCaptureReportRequestAck',
    id: '35076',
    value: 'AQ',
    sort: 76,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TradeCaptureReportRequestAck\n\nThe Trade Capture Request Ack message is used to:\n\n- Provide an acknowledgement to a Trade Capture Report Request in the case where the Trade Capture Report Request is used to specify a subscription or delivery of reports via an out-of-band ResponseTransmissionMethod.\n\n- Provide an acknowledgement to a Trade Capture Report Request in the case when the return of the Trade Capture Reports matching that request will be delayed or delivered asynchronously. This is useful in distributed trading system environments.\n\n- Indicate that no trades were found that matched the selection criteria specified on the Trade Capture Report Request or the Trade Capture Request was invalid for some business reason, such as request is not authorized, invalid or unknown instrument, party, trading session, etc.',
  },
  {
    name: 'TradeCaptureReportAck',
    id: '35077',
    value: 'AR',
    sort: 77,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TradeCaptureReportAck\n\nThe Trade Capture Report Ack message can be:\n\n- Used to acknowledge trade capture reports received from a counterparty.\n\n- Used to reject a trade capture report received from a counterparty.',
  },
  {
    name: 'AllocationReport',
    id: '35078',
    value: 'AS',
    sort: 78,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'AllocationReport\n\nSent from sell-side to buy-side, sell-side to 3rd-party or 3rd-party to buy-side, the AllocationReport(35=AS) message (Claim) provides account breakdown of an order or set of orders plus any additional follow-up front-office information developed post-trade during the trade allocation, matching and calculation phase.',
  },
  {
    name: 'AllocationReportAck',
    id: '35079',
    value: 'AT',
    sort: 79,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'AllocationReportAck\n\nThe Allocation Report Ack message is used to acknowledge the receipt of and provide status for an Allocation Report message.',
  },
  {
    name: 'ConfirmationAck',
    id: '35080',
    value: 'AU',
    sort: 80,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'ConfirmationAck\n\nThe Confirmation Ack (aka Affirmation) message is used to respond to a Confirmation message.',
  },
  {
    name: 'SettlementInstructionRequest',
    id: '35081',
    value: 'AV',
    sort: 81,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'SettlementInstructionRequest\n\nThe Settlement Instruction Request message is used to request standing settlement instructions from another party.',
  },
  {
    name: 'AssignmentReport',
    id: '35082',
    value: 'AW',
    sort: 82,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'AssignmentReport\n\nAssignment Reports are sent from a clearing house to counterparties, such as a clearing firm as a result of the assignment process.',
  },
  {
    name: 'CollateralRequest',
    id: '35083',
    value: 'AX',
    sort: 83,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'CollateralRequest\n\nAn initiator that requires collateral from a respondent sends a Collateral Request. The initiator can be either counterparty to a trade in a two party model or an intermediary such as an ATS or clearinghouse in a three party model. A Collateral Assignment is expected as a response to a request for collateral.',
  },
  {
    name: 'CollateralAssignment',
    id: '35084',
    value: 'AY',
    sort: 84,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'CollateralAssignment\n\nUsed to assign collateral to cover a trading position. This message can be sent unsolicited or in reply to a Collateral Request message.',
  },
  {
    name: 'CollateralResponse',
    id: '35085',
    value: 'AZ',
    sort: 85,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'CollateralResponse\n\nUsed to respond to a Collateral Assignment message.',
  },
  {
    name: 'CollateralReport',
    id: '35086',
    value: 'BA',
    sort: 86,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'CollateralReport\n\nUsed to report collateral status when responding to a Collateral Inquiry message.',
  },
  {
    name: 'CollateralInquiry',
    id: '35087',
    value: 'BB',
    sort: 87,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description: 'CollateralInquiry\n\nUsed to inquire for collateral status.',
  },
  {
    name: 'NetworkCounterpartySystemStatusRequest',
    id: '35088',
    value: 'BC',
    sort: 88,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'NetworkCounterpartySystemStatusRequest\n\nThis message is send either immediately after logging on to inform a network (counterparty system) of the type of updates required or to at any other time in the FIX conversation to change the nature of the types of status updates required. It can also be used with a NetworkRequestType of Snapshot to request a one-off report of the status of a network (or counterparty) system. Finally this message can also be used to cancel a request to receive updates into the status of the counterparties on a network by sending a NetworkRequestStatusMessage with a NetworkRequestType of StopSubscribing.',
  },
  {
    name: 'NetworkCounterpartySystemStatusResponse',
    id: '35089',
    value: 'BD',
    sort: 89,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'NetworkCounterpartySystemStatusResponse\n\nThis message is sent in response to a Network (Counterparty System) Status Request Message.',
  },
  {
    name: 'UserRequest',
    id: '35090',
    value: 'BE',
    sort: 90,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      "UserRequest\n\nThis message is used to initiate a user action, logon, logout or password change. It can also be used to request a report on a user's status.",
  },
  {
    name: 'UserResponse',
    id: '35091',
    value: 'BF',
    sort: 91,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'UserResponse\n\nThis message is used to respond to a user request message, it reports the status of the user after the completion of any action requested in the user request message.',
  },
  {
    name: 'CollateralInquiryAck',
    id: '35092',
    value: 'BG',
    sort: 92,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'CollateralInquiryAck\n\nUsed to respond to a Collateral Inquiry in the following situations:\n\n• When the CollateralInquiry will result in an out of band response (such as a file transfer).\n\n• When the inquiry is otherwise valid but no collateral is found to match the criteria specified on the Collateral Inquiry message.\n\n• When the Collateral Inquiry is invalid based upon the business rules of the counterparty.',
  },
  {
    name: 'ConfirmationRequest',
    id: '35093',
    value: 'BH',
    sort: 93,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'ConfirmationRequest\n\nThe Confirmation Request message is used to request a Confirmation message.',
  },
  {
    name: 'ContraryIntentionReport',
    id: '35094',
    value: 'BO',
    sort: 94,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'ContraryIntentionReport\n\nThe Contrary Intention Report is used for reporting of contrary expiration quantities for Saturday expiring options. This information is required by options exchanges for regulatory purposes.',
  },
  {
    name: 'SecurityDefinitionUpdateReport',
    id: '35095',
    value: 'BP',
    sort: 95,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'SecurityDefinitionUpdateReport\n\nThis message is used for reporting updates to a product security master file. Updates could be the result of corporate actions or other business events. Updates may include additions, modifications or deletions.',
  },
  {
    name: 'SecurityListUpdateReport',
    id: '35096',
    value: 'BK',
    sort: 96,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'SecurityListUpdateReport\n\nThe Security List Update Report is used for reporting updates to a Contract Security Masterfile. Updates could be due to Corporate Actions or other business events. Update may include additions, modifications and deletions.',
  },
  {
    name: 'AdjustedPositionReport',
    id: '35097',
    value: 'BL',
    sort: 97,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'AdjustedPositionReport\n\nUsed to report changes in position, primarily in equity options, due to modifications to the underlying due to corporate actions',
  },
  {
    name: 'AllocationInstructionAlert',
    id: '35098',
    value: 'BM',
    sort: 98,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'AllocationInstructionAlert\n\nThis message is used in a 3-party allocation model (buy-side and sell-side using a central clearing entity) where notification of group creation and group updates to counterparties is needed. The message will also carry trade information that comprised the group to the counterparties.',
  },
  {
    name: 'ExecutionAck',
    id: '35099',
    value: 'BN',
    sort: 99,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      "ExecutionAck\n\nThe Execution Report Acknowledgement message is an optional message that provides dual functionality to notify a trading partner that an electronically received execution has either been accepted or rejected (DK'd).",
  },
  {
    name: 'TradingSessionList',
    id: '35100',
    value: 'BJ',
    sort: 100,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TradingSessionList\n\nThe Trading Session List message is sent as a response to a Trading Session List Request. The Trading Session List should contain the characteristics of the trading session and the current state of the trading session.',
  },
  {
    name: 'TradingSessionListRequest',
    id: '35101',
    value: 'BI',
    sort: 101,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TradingSessionListRequest\n\nThe Trading Session List Request is used to request a list of trading sessions available in a market place and the state of those trading sessions. A successful request will result in a response from the counterparty of a Trading Session List (MsgType=BJ) message that contains a list of zero or more trading sessions.',
  },
  {
    name: 'SettlementObligationReport',
    id: '35102',
    value: 'BQ',
    sort: 102,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'SettlementObligationReport\n\nThe Settlement Obligation Report message provides a central counterparty, institution, or individual counterparty with a capacity for reporting the final details of a currency settlement obligation.',
  },
  {
    name: 'DerivativeSecurityListUpdateReport',
    id: '35103',
    value: 'BR',
    sort: 103,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'DerivativeSecurityListUpdateReport\n\nThe Derivative Security List Update Report message is used to send updates to an option family or the strikes that comprise an option family.',
  },
  {
    name: 'TradingSessionListUpdateReport',
    id: '35104',
    value: 'BS',
    sort: 104,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TradingSessionListUpdateReport\n\nThe Trading Session List Update Report is used by marketplaces to provide intra-day updates of trading sessions when there are changes to one or more trading sessions.',
  },
  {
    name: 'MarketDefinitionRequest',
    id: '35105',
    value: 'BT',
    sort: 105,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'MarketDefinitionRequest\n\nThe Market Definition Request message is used to request for market structure information from the Respondent that receives this request.',
  },
  {
    name: 'MarketDefinition',
    id: '35106',
    value: 'BU',
    sort: 106,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'MarketDefinition\n\nThe MarketDefinition(35=BU) message is used to respond to MarketDefinitionRequest(35=BT). In a subscription, it will be used to provide the initial snapshot of the information requested. Subsequent updates are provided by the MarketDefinitionUpdateReport(35=BV).',
  },
  {
    name: 'MarketDefinitionUpdateReport',
    id: '35107',
    value: 'BV',
    sort: 107,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'MarketDefinitionUpdateReport\n\nIn a subscription for market structure information, this message is used once the initial snapshot of the information has been sent using the MarketDefinition(35=BU) message.',
  },
  {
    name: 'ApplicationMessageRequest',
    id: '35108',
    value: 'BW',
    sort: 108,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'ApplicationMessageRequest\n\nThis message is used to request a retransmission of a set of one or more messages generated by the application specified in RefApplID (1355).',
  },
  {
    name: 'ApplicationMessageRequestAck',
    id: '35109',
    value: 'BX',
    sort: 109,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'ApplicationMessageRequestAck\n\nThis message is used to acknowledge an Application Message Request providing a status on the request (i.e. whether successful or not). This message does not provide the actual content of the messages to be resent.',
  },
  {
    name: 'ApplicationMessageReport',
    id: '35110',
    value: 'BY',
    sort: 110,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'ApplicationMessageReport\n\nThis message is used for three difference purposes: to reset the ApplSeqNum (1181) of a specified ApplID (1180). to indicate that the last message has been sent for a particular ApplID, or as a keep-alive mechanism for ApplIDs with infrequent message traffic.',
  },
  {
    name: 'OrderMassActionReport',
    id: '35111',
    value: 'BZ',
    sort: 111,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'OrderMassActionReport\n\nThe Order Mass Action Report is used to acknowledge an Order Mass Action Request. Note that each affected order that is suspended or released or canceled is acknowledged with a separate Execution Report for each order.',
  },
  {
    name: 'OrderMassActionRequest',
    id: '35112',
    value: 'CA',
    sort: 112,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'OrderMassActionRequest\n\nThe Order Mass Action Request message can be used to request the suspension or release of a group of orders that match the criteria specified within the request. This is equivalent to individual Order Cancel Replace Requests for each order with or without adding "S" to the ExecInst values. It can also be used for mass order cancellation.',
  },
  {
    name: 'UserNotification',
    id: '35113',
    value: 'CB',
    sort: 113,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'UserNotification\n\nThe User Notification message is used to notify one or more users of an event or information from the sender of the message. This message is usually sent unsolicited from a marketplace (e.g. Exchange, ECN) to a market participant.',
  },
  {
    name: 'StreamAssignmentRequest',
    id: '35114',
    value: 'CC',
    sort: 114,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'StreamAssignmentRequest\n\nIn certain markets where market data aggregators fan out to end clients the pricing streams provided by the price makers, the price maker may assign the clients to certain pricing streams that the price maker publishes via the aggregator. An example of this use is in the FX markets where clients may be assigned to different pricing streams based on volume bands and currency pairs.',
  },
  {
    name: 'StreamAssignmentReport',
    id: '35115',
    value: 'CD',
    sort: 115,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'StreamAssignmentReport\n\nhe StreamAssignmentReport message is in response to the StreamAssignmentRequest message. It provides information back to the aggregator as to which clients to assign to receive which price stream based on requested CCY pair. This message can be sent unsolicited to the Aggregator from the Price Maker.',
  },
  {
    name: 'StreamAssignmentReportACK',
    id: '35116',
    value: 'CE',
    sort: 116,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'StreamAssignmentReportACK\n\nThis message is used to respond to the Stream Assignment Report, to either accept or reject an unsolicited assingment.',
  },
  {
    name: 'PartyDetailsListRequest',
    id: '35117',
    value: 'CF',
    sort: 117,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyDetailsListRequest\n\nThe PartyDetailsListRequest is used to request party detail information.',
  },
  {
    name: 'PartyDetailsListReport',
    id: '35118',
    value: 'CG',
    sort: 118,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyDetailsListReport\n\nThe PartyDetailsListReport message is used to disseminate party details between counterparties. PartyDetailsListReport messages may be sent in response to a PartyDetailsListRequest message or sent unsolicited.',
  },
  {
    name: 'MarginRequirementInquiry',
    id: '35119',
    value: 'CH',
    sort: 119,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'MarginRequirementInquiry\n\nThe purpose of this message is to initiate a margin requirement inquiry for a margin account. The inquiry may be submitted at the detail level or the summary level. It can also be used to inquire margin excess/deficit or net position information. Margin excess/deficit will provide information about the surplus or shortfall compared to the previous trading day or a more recent margin calculation. An inquiry for net position information will trigger one or more PositionReport messages instead of one or more MarginRequirementReport messages.\n\nIf the inquiry is made at the detail level, an Instrument block must be provided with the desired level of detail. If the inquiry is made at the summary level, the Instrument block is not provided, implying a summary request is being made. For example, if the inquiring firm specifies the Security Type of “FUT” in the Instrument block, then a detail report will be generated containing the margin requirements for all futures positions for the inquiring account. Similarly, if the inquiry is made at the summary level, the report will contain the total margin requirement aggregated to the margin account level.',
  },
  {
    name: 'MarginRequirementInquiryAck',
    id: '35120',
    value: 'CI',
    sort: 120,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'MarginRequirementInquiryAck\n\nUsed to respond to a Margin Requirement Inquiry.',
  },
  {
    name: 'MarginRequirementReport',
    id: '35121',
    value: 'CJ',
    sort: 121,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'MarginRequirementReport\n\nThe Margin Requirement Report returns information about margin requirement either as on overview across all margin accounts or on a detailed level due to the inquiry making use of the optional Instrument component block. Application sequencing can be used to re-request a range of reports.',
  },
  {
    name: 'PartyDetailsListUpdateReport',
    id: '35122',
    value: 'CK',
    sort: 122,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyDetailsListUpdateReport\n\nThe PartyDetailsListUpdateReport(35=CK) is used to disseminate updates to party detail information.',
  },
  {
    name: 'PartyRiskLimitsRequest',
    id: '35123',
    value: 'CL',
    sort: 123,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyRiskLimitsRequest\n\nThe PartyRiskLimitsRequest message is used to request for risk information for specific parties, specific party roles or specific instruments.',
  },
  {
    name: 'PartyRiskLimitsReport',
    id: '35124',
    value: 'CM',
    sort: 124,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyRiskLimitsReport\n\nThe PartyRiskLimitsReport message is used to communicate party risk limits. The message can either be sent as a response to the PartyRiskLimitsRequest message or can be published unsolicited.',
  },
  {
    name: 'SecurityMassStatusRequest',
    id: '35125',
    value: 'CN',
    sort: 125,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description: 'SecurityMassStatusRequest\n\n',
  },
  {
    name: 'SecurityMassStatus',
    id: '35126',
    value: 'CO',
    sort: 126,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description: 'SecurityMassStatus\n\n',
  },
  {
    name: 'AccountSummaryReport',
    id: '35127',
    value: 'CQ',
    sort: 127,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'AccountSummaryReport\n\nThe AccountSummaryReport is provided by the clearinghouse to its clearing members on a daily basis. It contains margin, settlement, collateral and pay/collect data for each clearing member level account type. Clearing member account types will be described through use of the Parties component and PtysSubGrp sub-component.\n\nIn certain usages, the clearing members can send the AccountSummaryReport message to the clearinghouse as needed. For example, clearing members can send this message to the clearinghouse to identify the value of collateral for each customer (to satisfy CFTC Legally Segregated Operationally Commingled (LSOC) regulatory reporting obligations).\n\nClearing organizations can also send the AccountSummaryReport message to regulators to meet regulatory reporting obligations. For example, clearing organizations can use this message to submit daily reports for each clearing member (“CM”) by house origin and by each customer origin for all futures, options, and swaps positions, and all securities positions held in a segregated account or pursuant to a cross margining agreement, to a regulator (e.g. to the CFTC to meet Part 39, Section 39.19 reporting obligations).',
  },
  {
    name: 'PartyRiskLimitsUpdateReport',
    id: '35128',
    value: 'CR',
    sort: 128,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyRiskLimitsUpdateReport\n\nThe PartyRiskLimitsUpdateReport(35=CR) is used to convey incremental changes to risk limits. It is similar to the regular report but uses the PartyRiskLimitsUpdateGrp component instead of the PartyRiskLimitsGrp component to include an update action.',
  },
  {
    name: 'PartyRiskLimitsDefinitionRequest',
    id: '35129',
    value: 'CS',
    sort: 129,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyRiskLimitsDefinitionRequest\n\nPartyRiskLimitDefinitionRequest is used for defining new risk limits.',
  },
  {
    name: 'PartyRiskLimitsDefinitionRequestAck',
    id: '35130',
    value: 'CT',
    sort: 130,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyRiskLimitsDefinitionRequestAck\n\nPartyRiskLimitDefinitionRequestAck is used for accepting (with or without changes) or rejecting the definition of risk limits.',
  },
  {
    name: 'PartyEntitlementsRequest',
    id: '35131',
    value: 'CU',
    sort: 131,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyEntitlementsRequest\n\nThe PartyEntitlementsRequest message is used to request for entitlement information for one or more party(-ies), specific party role(s), or specific instruments(s).',
  },
  {
    name: 'PartyEntitlementsReport',
    id: '35132',
    value: 'CV',
    sort: 132,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyEntitlementsReport\n\nThe PartyEntitlementsReport is used to report entitlements for one or more parties, party role(s), or specific instrument(s).',
  },
  {
    name: 'QuoteAck',
    id: '35133',
    value: 'CW',
    sort: 133,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'QuoteAck\n\nThe QuoteAck(35=CW) message is used to acknowledge a Quote(35=S) submittal or request to cancel an individual quote using the QuoteCancel(35=Z) message during a Quote/Negotiation dialog.',
  },
  {
    name: 'PartyDetailsDefinitionRequest',
    id: '35134',
    value: 'CX',
    sort: 134,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyDetailsDefinitionRequest\n\nThe PartyDetailsDefinitionRequest(35=CX) is used for defining new parties and modifying or deleting existing parties information, including the relationships between parties.\n\nThe recipient of the message responds with a PartyDetailsDefinitionRequestAck(35=CY) to indicate whether the request was accepted or rejected.',
  },
  {
    name: 'PartyDetailsDefinitionRequestAck',
    id: '35135',
    value: 'CY',
    sort: 135,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyDetailsDefinitionRequestAck\n\nThe PartyDetailsDefinitionRequestAck(35=CY) is used as a response to the PartyDetailsDefinitionRequest(35=CX) message. The request can be accepted (with or without changes) or rejected.',
  },
  {
    name: 'PartyEntitlementsUpdateReport',
    id: '35136',
    value: 'CZ',
    sort: 136,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyEntitlementsUpdateReport\n\nThe PartyEntitlementsUpdateReport(35=CZ) is used to convey incremental changes to party entitlements. It is similar to the PartyEntitlementsReport(35=CV). This message uses the PartyEntitlementsUpdateGrp component which includes the ability to specify an update action using ListUpdateAction(1324).',
  },
  {
    name: 'PartyEntitlementsDefinitionRequest',
    id: '35137',
    value: 'DA',
    sort: 137,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyEntitlementsDefinitionRequest\n\nThe PartyEntitlementsDefinitionRequest(35=DA) is used for defining new entitlements, and modifying or deleting existing entitlements for the specified party(-ies).',
  },
  {
    name: 'PartyEntitlementsDefinitionRequestAck',
    id: '35138',
    value: 'DB',
    sort: 138,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyEntitlementsDefinitionRequestAck\n\nThe PartyEntitlementsDefinitionRequestAck(35=DB) is used as a response to the PartyEntitlemensDefinitionRequest(35=DA) to accept (with or without changes) or reject the definition of party entitlements.',
  },
  {
    name: 'TradeMatchReport',
    id: '35139',
    value: 'DC',
    sort: 139,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TradeMatchReport\n\nThe TradeMatchReport(35=DC) message is used by exchanges and ECN’s to report matched trades to central counterparties (CCPs) as an atomic event. The message is used to express the one-to-one, one-to-many and many-to-many matches as well as implied matches in which more complex instruments can match with simpler instruments.',
  },
  {
    name: 'TradeMatchReportAck',
    id: '35140',
    value: 'DD',
    sort: 140,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TradeMatchReportAck\n\nThe TradeMatchReportAck(35=DD) is used to respond to theTradeMatchReport(35=DC) message. It may be used to report on the status of the request (e.g. accepting the request or rejecting the request).',
  },
  {
    name: 'PartyRiskLimitsReportAck',
    id: '35141',
    value: 'DE',
    sort: 141,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyRiskLimitsReportAck\n\nPartyRiskLimitsReportAck is an optional message used as a response to the PartyRiskLimitReport(35=CM) or PartyRiskLimitUpdateReport(35=CR) messages to acknowledge or reject those messages.',
  },
  {
    name: 'PartyRiskLimitCheckRequest',
    id: '35142',
    value: 'DF',
    sort: 142,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyRiskLimitCheckRequest\n\nPartyRiskLimitCheckRequest is used to request for approval of credit or risk limit amount intended to be used by a party in a transaction from another party that holds the information.',
  },
  {
    name: 'PartyRiskLimitCheckRequestAck',
    id: '35143',
    value: 'DG',
    sort: 143,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyRiskLimitCheckRequestAck\n\nPartyRiskLimitCheckRequestAck is used to acknowledge a PartyRiskLimitCheckRequest(35=DF) message and to respond whether the limit check request was approved or not. When used to accept the PartyRiskLimitCheckRequest(35=DF) message the Respondent may also include the limit amount that was approved.',
  },
  {
    name: 'PartyActionRequest',
    id: '35144',
    value: 'DH',
    sort: 144,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyActionRequest\n\nThe PartyActionRequest message is used suspend or halt the specified party from further trading activities at the Respondent. The Respondent must respond with a PartyActionReport(35=DI) message.',
  },
  {
    name: 'PartyActionReport',
    id: '35145',
    value: 'DI',
    sort: 145,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PartyActionReport\n\nUsed to respond to the PartyActionRequest(35=DH) message, indicating whether the request has been received, accepted or rejected. Can also be used in an unsolicited manner to report party actions, e.g. reinstatements after a manual intervention out of band.',
  },
  {
    name: 'MassOrder',
    id: '35146',
    value: 'DJ',
    sort: 146,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'MassOrder\n\nThe MassOrder(35=DJ) message can be used to add, modify or delete multiple unrelated orders with a single message. Apart from clearing related attributes, only the key order attributes for high performance trading are available.',
  },
  {
    name: 'MassOrderAck',
    id: '35147',
    value: 'DK',
    sort: 147,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'MassOrderAck\n\nThe mass order acknowledgement message is used to acknowledge the receipt of and the status for a MassOrder(35=DJ) message.',
  },
  {
    name: 'PositionTransferInstruction',
    id: '35148',
    value: 'DL',
    sort: 148,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PositionTransferInstruction\n\nThe PositionTransferInstruction(35=DL) is sent by clearing firms to CCPs to initiate position transfers, or to accept or decline position transfers.',
  },
  {
    name: 'PositionTransferInstructionAck',
    id: '35149',
    value: 'DM',
    sort: 149,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PositionTransferInstructionAck\n\nThe PositionTransferInstructionAck(35=DM) is sent by CCPs to clearing firms to acknowledge position transfer instructions, and to report errors processing position transfer instructions.',
  },
  {
    name: 'PositionTransferReport',
    id: '35150',
    value: 'DN',
    sort: 150,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PositionTransferReport\n\nThe PositionTransferReport(35=DN) is sent by CCPs to clearing firms indicating of positions that are to be transferred to the clearing firm, or to report on status of the transfer to the clearing firms involved in the transfer process.',
  },
  {
    name: 'MarketDataStatisticsRequest',
    id: '35151',
    value: 'DO',
    sort: 151,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'MarketDataStatisticsRequest\n\nThe MarketDataStatisticsRequest(35=DO) is used to request for statistical data. The simple form is to use an identifier (MDStatisticID(2475)) assigned by the market place which would denote a pre-defined statistical report. Alternatively, or also in addition, the request can define a number of parameters for the desired statistical information.',
  },
  {
    name: 'MarketDataStatisticsReport',
    id: '35152',
    value: 'DP',
    sort: 152,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'MarketDataStatisticsReport\n\nThe MarketDataStatisticsReport(35=DP) is used to provide unsolicited statistical information or in response to a specific request. Each report contains a set of statistics for a single entity which could be a market, a market segment, a security list or an instrument.',
  },
  {
    name: 'CollateralReportAck',
    id: '35153',
    value: 'DQ',
    sort: 153,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'CollateralReportAck\n\nCollateralReportAck(35=DQ) is used as a response to the CollateralReport(35=BA). It can be used to reject a CollateralReport(35=BA) when the content of the report is invalid based on the business rules of the receiver. The message may also be used to acknowledge receipt of a valid CollateralReport(35=BA).',
  },
  {
    name: 'MarketDataReport',
    id: '35154',
    value: 'DR',
    sort: 154,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'MarketDataReport\n\nThe MarketDataReport(35=DR) message is used to provide delimiting references (e.g. start and end markers in a continuous broadcast) and details about the number of market data messages sent in a given distribution cycle.',
  },
  {
    name: 'CrossRequest',
    id: '35155',
    value: 'DS',
    sort: 155,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'CrossRequest\n\nThe CrossRequest(35=DS) message is used to indicate the submission of orders or quotes that may result in a crossed trade.',
  },
  {
    name: 'CrossRequestAck',
    id: '35156',
    value: 'DT',
    sort: 156,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'CrossRequestAck\n\nThe CrossRequestAck(35=DT) message is used to confirm the receipt of a CrossRequest(35=DS) message.',
  },
  {
    name: 'AllocationInstructionAlertRequest',
    id: '35157',
    value: 'DU',
    sort: 157,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'AllocationInstructionAlertRequest\n\nThis message is used in a clearinghouse 3-party allocation model to request for AllocationInstructionAlert(35=BM) from the clearinghouse. The request may be used to obtain a one-time notification of the status of an allocation group.',
  },
  {
    name: 'AllocationInstructionAlertRequestAck',
    id: '35158',
    value: 'DV',
    sort: 158,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'AllocationInstructionAlertRequestAck\n\nThis message is used in a clearinghouse 3-party allocation model to acknowledge a AllocationInstructionAlertRequest(35=DU) message for an AllocationInstructionAlert(35=BM) message from the clearinghouse.',
  },
  {
    name: 'TradeAggregationRequest',
    id: '35159',
    value: 'DW',
    sort: 159,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TradeAggregationRequest\n\nTradeAggregationRequest(35=DW) is used to request that the identified trades between the initiator and respondent be aggregated together for further processing.',
  },
  {
    name: 'TradeAggregationReport',
    id: '35160',
    value: 'DX',
    sort: 160,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TradeAggregationReport\n\nTradeAggregationReport(35=DX) is used to respond to the TradeAggregationRequest(35=DW) message. It provides the status of the request (e.g. accepted or rejected) and may also provide additional information supplied by the respondent.',
  },
  {
    name: 'PayManagementReport',
    id: '35161',
    value: 'EA',
    sort: 161,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PayManagementReport\n\nPayManagementReport(35=EA) may be used to respond to the PayManagementRequest(35=DY) message. It provides the status of the request (e.g. accepted, disputed) and may provide additional information related to the request.\n\nPayManagementReport(35=EA) may also be sent unsolicited by the broker to a client. In which case the client may acknowledge and resolve disputes out-of-band or with a simple PayManagementReportAck(35=EB).\n\nPayManagementReport(35=EA) may also be sent unsolicited to report the progress status of the payment itself with PayReportTransType(2804)=2 (Status).',
  },
  {
    name: 'PayManagementReportAck',
    id: '35162',
    value: 'EB',
    sort: 162,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PayManagementReportAck\n\nPayManagementReportAck(35=EB) is used as a response to the PayManagementReport(35=EA) message. It may be used to accept, reject or dispute the details of the PayManagementReport(35=EA) depending on the business rules of the receiver. This message may also be used to acknowledge the receipt of a PayManagementReport(35=EA) message.',
  },
  {
    name: 'PayManagementRequest',
    id: '35163',
    value: 'DY',
    sort: 163,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PayManagementRequest\n\nPayManagementRequest(35=DY) message is used to communicate a future or expected payment to be made or received related to a trade or contract after its settlement.',
  },
  {
    name: 'PayManagementRequestAck',
    id: '35164',
    value: 'DZ',
    sort: 164,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'PayManagementRequestAck\n\nPayManagementRequestAck(35=DZ) is used to acknowledge the receipt of the PayManagementRequest(35=DY) message (i.e. a technical acknowledgement of receipt). Acceptance or rejection of the request is reported in the corresponding PayManagementReport(35=EA).',
  },
  {
    name: 'SettlementStatusRequest',
    id: '35165',
    value: 'EC',
    sort: 165,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'SettlementStatusRequest\n\nSettlementStatusRequest(35=EC) is used to request for the settlement status of a trade.',
  },
  {
    name: 'SettlementStatusRequestAck',
    id: '35166',
    value: 'ED',
    sort: 166,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'SettlementStatusRequestAck\n\nSettlementStatusRequestAck(35=ED) is used to respond to the SettlementStatusRequest(35=EC) to acknowledge the request and provide status for the request message.',
  },
  {
    name: 'SettlementStatusReport',
    id: '35167',
    value: 'EE',
    sort: 167,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'SettlementStatusReport\n\nSettlementStatusReport(35=EE) is a response to the SettlementStatusRequest(35=EC) to provide settlement status for the requested trade. It may also be sent unsolicited without an explicit request message by the party able to provide the settlement status for the trade identified in the report message.',
  },
  {
    name: 'SettlementStatusReportAck',
    id: '35168',
    value: 'EF',
    sort: 168,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'SettlementStatusReportAck\n\nSettlementStatusReportAck(35=EF) is used to respond to the SettlementStatusReport(35=EE) to acknowledge or reject the report.',
  },
  {
    name: 'SecurityRiskMetricsReport',
    id: '35169',
    value: 'EG',
    sort: 169,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'SecurityRiskMetricsReport\n\nSecurityRiskMetricsReport(35=EG) is used for publishing the risk metrics, valuation metrics or analytics of one or more securities, or for an option series.',
  },
  {
    name: 'AlgoCertificateRequest',
    id: '35170',
    value: 'EH',
    sort: 170,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'AlgoCertificateRequest\n\nAlgoCertificateRequest(35=EH) is used to request for algo testing certificate information for one or more algorithms.',
  },
  {
    name: 'AlgoCertificateRequestAck',
    id: '35171',
    value: 'EI',
    sort: 171,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'AlgoCertificateRequestAck\n\nAlgoCertificateRequestAck(35=EI) is used to respond to the AlgoCertificateRequest(35=EH) to acknowledge the request and provide status for the request message.',
  },
  {
    name: 'AlgoCertificateReport',
    id: '35172',
    value: 'EJ',
    sort: 172,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'AlgoCertificateReport\n\nAlgoCertificateReport(35=EJ) is a response to the AlgoCertificateRequest(35=EH) to certify an algo. It may also be sent unsolicited without an explicit request message by the party able to provide certificate information for the algo identified in the report message.',
  },
  {
    name: 'AlgoCertificateReportAck',
    id: '35173',
    value: 'EK',
    sort: 173,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'AlgoCertificateReportAck\n\nAlgoCertificateReportAck(35=EK) is used to respond to the AlgoCertificateReport(35=EJ) to acknowledge or reject the report message.',
  },
  {
    name: 'TestSuiteDefinitionRequest',
    id: '35174',
    value: 'EL',
    sort: 174,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TestSuiteDefinitionRequest\n\nTestSuiteDefinitionRequest(35=EL) is used to convey to the test system the suite of test scenarios to perform.',
  },
  {
    name: 'TestSuiteDefinitionRequestAck',
    id: '35175',
    value: 'EM',
    sort: 175,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TestSuiteDefinitionRequestAck\n\nTestSuiteDefinitionRequestAck(35=EM) is used to respond to the TestSuiteDefinitionRequest(35= EL) to acknowledge the request and provide status for the request message.',
  },
  {
    name: 'TestActionRequest',
    id: '35176',
    value: 'EN',
    sort: 176,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TestActionRequest\n\nTestActionRequest(35=EN) is used to manage test executions or request for testing activity state of the identified test suite.',
  },
  {
    name: 'TestActionRequestAck',
    id: '35177',
    value: 'EO',
    sort: 177,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TestActionRequestAck\n\nTestActionRequestAck(35=EO) is used to respond to the TestActionRequest(35=EN) to acknowledge the request and provide status for the request message.',
  },
  {
    name: 'TestActionReport',
    id: '35178',
    value: 'EP',
    sort: 178,
    tag: 35,
    type: 'String',
    codeSet: 'MsgTypeCodeSet',
    description:
      'TestActionReport\n\nTestActionReport(35=EP) is used to report the testing results of the identified test suite that has been executed with TestActionRequest(35=EN). In the context of algorithmic trading, the results may be used to create a certificate for the algorithm upon meeting the success criteria.',
  },
  {
    name: 'New',
    id: '39001',
    value: '0',
    sort: 1,
    added: 'FIX.2.7',
    tag: 39,
    type: 'char',
    codeSet: 'OrdStatusCodeSet',
    description: 'New',
  },
  {
    name: 'PartiallyFilled',
    id: '39002',
    value: '1',
    sort: 2,
    added: 'FIX.2.7',
    tag: 39,
    type: 'char',
    codeSet: 'OrdStatusCodeSet',
    description: 'Partially filled',
  },
  {
    name: 'Filled',
    id: '39003',
    value: '2',
    sort: 3,
    added: 'FIX.2.7',
    tag: 39,
    type: 'char',
    codeSet: 'OrdStatusCodeSet',
    description: 'Filled',
  },
  {
    name: 'DoneForDay',
    id: '39004',
    value: '3',
    sort: 4,
    added: 'FIX.2.7',
    tag: 39,
    type: 'char',
    codeSet: 'OrdStatusCodeSet',
    description: 'Done for day',
  },
  {
    name: 'Canceled',
    id: '39005',
    value: '4',
    sort: 5,
    added: 'FIX.2.7',
    tag: 39,
    type: 'char',
    codeSet: 'OrdStatusCodeSet',
    description: 'Canceled',
  },
  {
    name: 'Replaced',
    id: '39006',
    value: '5',
    sort: 6,
    added: 'FIX.4.4',
    addedEP: '35',
    deprecated: 'FIX.4.3',
    tag: 39,
    type: 'char',
    codeSet: 'OrdStatusCodeSet',
    description: 'Replaced (No longer used)',
  },
  {
    name: 'PendingCancel',
    id: '39007',
    value: '6',
    sort: 7,
    added: 'FIX.2.7',
    tag: 39,
    type: 'char',
    codeSet: 'OrdStatusCodeSet',
    description: 'Pending Cancel (i.e. result of Order Cancel Request)',
  },
  {
    name: 'Stopped',
    id: '39008',
    value: '7',
    sort: 8,
    added: 'FIX.2.7',
    tag: 39,
    type: 'char',
    codeSet: 'OrdStatusCodeSet',
    description: 'Stopped',
  },
  {
    name: 'Rejected',
    id: '39009',
    value: '8',
    sort: 9,
    added: 'FIX.2.7',
    tag: 39,
    type: 'char',
    codeSet: 'OrdStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'Suspended',
    id: '39010',
    value: '9',
    sort: 10,
    added: 'FIX.3.0',
    tag: 39,
    type: 'char',
    codeSet: 'OrdStatusCodeSet',
    description: 'Suspended',
  },
  {
    name: 'PendingNew',
    id: '39011',
    value: 'A',
    sort: 11,
    added: 'FIX.3.0',
    tag: 39,
    type: 'char',
    codeSet: 'OrdStatusCodeSet',
    description: 'Pending New',
  },
  {
    name: 'Calculated',
    id: '39012',
    value: 'B',
    sort: 12,
    added: 'FIX.4.0',
    tag: 39,
    type: 'char',
    codeSet: 'OrdStatusCodeSet',
    description: 'Calculated',
  },
  {
    name: 'Expired',
    id: '39013',
    value: 'C',
    sort: 13,
    added: 'FIX.4.0',
    tag: 39,
    type: 'char',
    codeSet: 'OrdStatusCodeSet',
    description: 'Expired',
  },
  {
    name: 'AcceptedForBidding',
    id: '39014',
    value: 'D',
    sort: 14,
    added: 'FIX.4.2',
    tag: 39,
    type: 'char',
    codeSet: 'OrdStatusCodeSet',
    description: 'Accepted for Bidding',
  },
  {
    name: 'PendingReplace',
    id: '39015',
    value: 'E',
    sort: 15,
    added: 'FIX.4.2',
    tag: 39,
    type: 'char',
    codeSet: 'OrdStatusCodeSet',
    description: 'Pending Replace (i.e. result of Order Cancel/Replace Request)',
  },
  {
    name: 'Market',
    id: '40001',
    value: '1',
    sort: 1,
    added: 'FIX.2.7',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'Market',
  },
  {
    name: 'Limit',
    id: '40002',
    value: '2',
    sort: 2,
    added: 'FIX.2.7',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'Limit',
  },
  {
    name: 'Stop',
    id: '40003',
    value: '3',
    sort: 3,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '166',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description:
      'Stop/Stop Loss.\n\nA stop order that is triggered as a result of a trade in the market at which point the stopped order becomes a market order.',
  },
  {
    name: 'StopLimit',
    id: '40004',
    value: '4',
    sort: 4,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '166',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description:
      'Stop Limit.\n\nA stop limit order that is triggered as a result of a trade in the market at which point the stopped order becomes a limit order.',
  },
  {
    name: 'MarketOnClose',
    id: '40005',
    value: '5',
    sort: 5,
    added: 'FIX.2.7',
    deprecated: 'FIX.4.3',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'Market On Close (No longer used)',
  },
  {
    name: 'WithOrWithout',
    id: '40006',
    value: '6',
    sort: 6,
    added: 'FIX.2.7',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'With Or Without',
  },
  {
    name: 'LimitOrBetter',
    id: '40007',
    value: '7',
    sort: 7,
    added: 'FIX.2.7',
    deprecated: 'FIX.4.4',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'Limit Or Better',
  },
  {
    name: 'LimitWithOrWithout',
    id: '40008',
    value: '8',
    sort: 8,
    added: 'FIX.2.7',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'Limit With Or Without',
  },
  {
    name: 'OnBasis',
    id: '40009',
    value: '9',
    sort: 9,
    added: 'FIX.2.7',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'On Basis',
  },
  {
    name: 'OnClose',
    id: '40010',
    value: 'A',
    sort: 10,
    added: 'FIX.2.7',
    deprecated: 'FIX.4.3',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'On Close (No longer used)',
  },
  {
    name: 'LimitOnClose',
    id: '40011',
    value: 'B',
    sort: 11,
    added: 'FIX.2.7',
    deprecated: 'FIX.4.3',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'Limit On Close (No longer used)',
  },
  {
    name: 'ForexMarket',
    id: '40012',
    value: 'C',
    sort: 12,
    added: 'FIX.4.0',
    deprecated: 'FIX.4.3',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'Forex Market (No longer used)',
  },
  {
    name: 'PreviouslyQuoted',
    id: '40013',
    value: 'D',
    sort: 13,
    added: 'FIX.4.0',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'Previously Quoted',
  },
  {
    name: 'PreviouslyIndicated',
    id: '40014',
    value: 'E',
    sort: 14,
    added: 'FIX.4.0',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'Previously Indicated',
  },
  {
    name: 'ForexLimit',
    id: '40015',
    value: 'F',
    sort: 15,
    added: 'FIX.4.1',
    deprecated: 'FIX.4.3',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'Forex Limit (No longer used)',
  },
  {
    name: 'ForexSwap',
    id: '40016',
    value: 'G',
    sort: 16,
    added: 'FIX.4.1',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'Forex Swap',
  },
  {
    name: 'ForexPreviouslyQuoted',
    id: '40017',
    value: 'H',
    sort: 17,
    added: 'FIX.4.1',
    deprecated: 'FIX.4.3',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'Forex Previously Quoted (No longer used)',
  },
  {
    name: 'Funari',
    id: '40018',
    value: 'I',
    sort: 18,
    added: 'FIX.4.2',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description:
      'Funari (Limit day order with unexecuted portion handles as Market On Close. E.g. Japan)',
  },
  {
    name: 'MarketIfTouched',
    id: '40019',
    value: 'J',
    sort: 19,
    added: 'FIX.4.3',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'Market If Touched (MIT)',
  },
  {
    name: 'MarketWithLeftOverAsLimit',
    id: '40020',
    value: 'K',
    sort: 20,
    added: 'FIX.4.3',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description:
      'Market With Left Over as Limit (market order with unexecuted quantity becoming limit order at last price)',
  },
  {
    name: 'PreviousFundValuationPoint',
    id: '40021',
    value: 'L',
    sort: 21,
    added: 'FIX.4.3',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'Previous Fund Valuation Point (Historic pricing; for CIV)',
  },
  {
    name: 'NextFundValuationPoint',
    id: '40022',
    value: 'M',
    sort: 22,
    added: 'FIX.4.3',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'Next Fund Valuation Point (Forward pricing; for CIV)',
  },
  {
    name: 'Pegged',
    id: '40023',
    value: 'P',
    sort: 23,
    added: 'FIX.3.0',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'Pegged',
  },
  {
    name: 'CounterOrderSelection',
    id: '40024',
    value: 'Q',
    sort: 24,
    added: 'FIX.4.4',
    addedEP: '22',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description: 'Counter-order selection',
  },
  {
    name: 'StopOnBidOrOffer',
    id: '40025',
    value: 'R',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '166',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description:
      'Stop on Bid or Offer\n\nA stop order that is triggered by a bid or offer price movement (quote) at which point the stopped order becomes a market order, also known as "stop on quote" in some markets (e.g. US markets). In the US equities market it is common to trigger a stop off the National Best Bid or Offer (NBBO).',
  },
  {
    name: 'StopLimitOnBidOrOffer',
    id: '40026',
    value: 'S',
    sort: 26,
    added: 'FIX.5.0SP2',
    addedEP: '166',
    tag: 40,
    type: 'char',
    codeSet: 'OrdTypeCodeSet',
    description:
      'Stop Limit on Bid or Offer\n\nA stop order that is triggered by a bid or offer price movement (quote) at which point the stopped order becomes a limit order, also known as "stop limit on quote" in some markets (e.g. US markets). In the US equities market it is common to trigger a stop off the National Best Bid or Offer (NBBO).',
  },
  {
    name: 'OriginalTransmission',
    id: '43001',
    value: 'N',
    sort: 1,
    added: 'FIX.2.7',
    tag: 43,
    type: 'Boolean',
    codeSet: 'PossDupFlagCodeSet',
    description: 'Original transmission',
  },
  {
    name: 'PossibleDuplicate',
    id: '43002',
    value: 'Y',
    sort: 2,
    added: 'FIX.2.7',
    tag: 43,
    type: 'Boolean',
    codeSet: 'PossDupFlagCodeSet',
    description: 'Possible duplicate',
  },
  {
    name: 'Buy',
    id: '54001',
    value: '1',
    sort: 1,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 54,
    type: 'char',
    codeSet: 'SideCodeSet',
    description:
      'Buy\n\nFor Securities Financing indicates the receipt of securities or collateral.',
  },
  {
    name: 'Sell',
    id: '54002',
    value: '2',
    sort: 2,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 54,
    type: 'char',
    codeSet: 'SideCodeSet',
    description:
      'Sell\n\nFor Securities Financing indicates the delivery of securities or collateral.',
  },
  {
    name: 'BuyMinus',
    id: '54003',
    value: '3',
    sort: 3,
    added: 'FIX.2.7',
    tag: 54,
    type: 'char',
    codeSet: 'SideCodeSet',
    description: 'Buy minus',
  },
  {
    name: 'SellPlus',
    id: '54004',
    value: '4',
    sort: 4,
    added: 'FIX.2.7',
    tag: 54,
    type: 'char',
    codeSet: 'SideCodeSet',
    description: 'Sell plus',
  },
  {
    name: 'SellShort',
    id: '54005',
    value: '5',
    sort: 5,
    added: 'FIX.2.7',
    tag: 54,
    type: 'char',
    codeSet: 'SideCodeSet',
    description: 'Sell short',
  },
  {
    name: 'SellShortExempt',
    id: '54006',
    value: '6',
    sort: 6,
    added: 'FIX.2.7',
    tag: 54,
    type: 'char',
    codeSet: 'SideCodeSet',
    description: 'Sell short exempt',
  },
  {
    name: 'Undisclosed',
    id: '54007',
    value: '7',
    sort: 7,
    added: 'FIX.4.1',
    updated: 'FIX.5.0SP2',
    updatedEP: '131',
    tag: 54,
    type: 'char',
    codeSet: 'SideCodeSet',
    description: 'Undisclosed',
  },
  {
    name: 'Cross',
    id: '54008',
    value: '8',
    sort: 8,
    added: 'FIX.4.1',
    tag: 54,
    type: 'char',
    codeSet: 'SideCodeSet',
    description:
      'Cross (orders where counterparty is an exchange, valid for all messages except IOIs)',
  },
  {
    name: 'CrossShort',
    id: '54009',
    value: '9',
    sort: 9,
    added: 'FIX.4.2',
    tag: 54,
    type: 'char',
    codeSet: 'SideCodeSet',
    description: 'Cross short',
  },
  {
    name: 'CrossShortExempt',
    id: '54010',
    value: 'A',
    sort: 10,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 54,
    type: 'char',
    codeSet: 'SideCodeSet',
    description: 'Cross short exempt',
  },
  {
    name: 'AsDefined',
    id: '54011',
    value: 'B',
    sort: 11,
    added: 'FIX.4.3',
    tag: 54,
    type: 'char',
    codeSet: 'SideCodeSet',
    description: '"As Defined" (for use with multileg instruments)',
  },
  {
    name: 'Opposite',
    id: '54012',
    value: 'C',
    sort: 12,
    added: 'FIX.4.3',
    tag: 54,
    type: 'char',
    codeSet: 'SideCodeSet',
    description: '"Opposite" (for use with multileg instruments)',
  },
  {
    name: 'Subscribe',
    id: '54013',
    value: 'D',
    sort: 13,
    added: 'FIX.4.4',
    tag: 54,
    type: 'char',
    codeSet: 'SideCodeSet',
    description: 'Subscribe (e.g. CIV)',
  },
  {
    name: 'Redeem',
    id: '54014',
    value: 'E',
    sort: 14,
    added: 'FIX.4.4',
    tag: 54,
    type: 'char',
    codeSet: 'SideCodeSet',
    description: 'Redeem (e.g. CIV)',
  },
  {
    name: 'Lend',
    id: '54015',
    value: 'F',
    sort: 15,
    added: 'FIX.4.4',
    tag: 54,
    type: 'char',
    codeSet: 'SideCodeSet',
    description: 'Lend (FINANCING - identifies direction of collateral)',
  },
  {
    name: 'Borrow',
    id: '54016',
    value: 'G',
    sort: 16,
    added: 'FIX.4.4',
    tag: 54,
    type: 'char',
    codeSet: 'SideCodeSet',
    description: 'Borrow (FINANCING - identifies direction of collateral)',
  },
  {
    name: 'SellUndisclosed',
    id: '54017',
    value: 'H',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '222',
    tag: 54,
    type: 'char',
    codeSet: 'SideCodeSet',
    description:
      'Sell undisclosed\n\nIn the context of ESMA RTS 22, this allows for reporting of transactions where the investment firm (broker) is not able to determine whether the sell is a short sale transaction. Corresponds to RTS 22 "short selling indicator" value of \'UNDI\'.',
  },
  {
    name: 'Day',
    id: '59001',
    value: '0',
    sort: 1,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 59,
    type: 'char',
    codeSet: 'TimeInForceCodeSet',
    description:
      'Day (or session)\n\nA buy or sell order that, if not executed expires at the end of the trading day on which it was entered.',
  },
  {
    name: 'GoodTillCancel',
    id: '59002',
    value: '1',
    sort: 2,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 59,
    type: 'char',
    codeSet: 'TimeInForceCodeSet',
    description:
      'Good Till Cancel (GTC)\n\nAn order to buy or sell that remains in effect until it is either executed or canceled; sometimes called an “open order”.',
  },
  {
    name: 'AtTheOpening',
    id: '59003',
    value: '2',
    sort: 3,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 59,
    type: 'char',
    codeSet: 'TimeInForceCodeSet',
    description:
      'At the Opening (OPG)\n\nA market or limit-price order to be executed at the opening of the stock or not at all; all or part of any order not executed at the opening is treated as canceled.',
  },
  {
    name: 'ImmediateOrCancel',
    id: '59004',
    value: '3',
    sort: 4,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 59,
    type: 'char',
    codeSet: 'TimeInForceCodeSet',
    description:
      'Immediate Or Cancel (IOC)\n\nA market or limit-price order that is to be executed in whole or in part as soon as it is available in the market; any portion not so executed is to be canceled.',
  },
  {
    name: 'FillOrKill',
    id: '59005',
    value: '4',
    sort: 5,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 59,
    type: 'char',
    codeSet: 'TimeInForceCodeSet',
    description:
      'Fill Or Kill (FOK)\n\nA market or limit-price order that is to be executed in its entirety as soon as it is available in the market; if not so executed, the order is to be canceled.',
  },
  {
    name: 'GoodTillCrossing',
    id: '59006',
    value: '5',
    sort: 6,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 59,
    type: 'char',
    codeSet: 'TimeInForceCodeSet',
    description:
      'Good Till Crossing (GTX)\n\nAn order to buy or sell that is canceled prior to the market entering into an auction or crossing phase.',
  },
  {
    name: 'GoodTillDate',
    id: '59007',
    value: '6',
    sort: 7,
    added: 'FIX.4.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 59,
    type: 'char',
    codeSet: 'TimeInForceCodeSet',
    description:
      'Good Till Date (GTD)\n\nAn order to buy or sell that remains in effect until it expires, defined by ExpireDate(432) or ExpireTime(126).',
  },
  {
    name: 'AtTheClose',
    id: '59008',
    value: '7',
    sort: 8,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 59,
    type: 'char',
    codeSet: 'TimeInForceCodeSet',
    description:
      'At the Close\n\nIndicated price is to be around the closing price, however, not held to the closing price.',
  },
  {
    name: 'GoodThroughCrossing',
    id: '59009',
    value: '8',
    sort: 9,
    added: 'FIX.5.0',
    addedEP: '61',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 59,
    type: 'char',
    codeSet: 'TimeInForceCodeSet',
    description:
      'Good Through Crossing\n\nAn order that is valid up till and including a crossing phase.]',
  },
  {
    name: 'AtCrossing',
    id: '59010',
    value: '9',
    sort: 10,
    added: 'FIX.5.0',
    addedEP: '61',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 59,
    type: 'char',
    codeSet: 'TimeInForceCodeSet',
    description:
      'At Crossing\n\nAn order that is valid only during crossing (auction) phases. The order is valid during the day or up to and including a specified trading (sub) session.',
  },
  {
    name: 'GoodForTime',
    id: '59011',
    value: 'A',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 59,
    type: 'char',
    codeSet: 'TimeInForceCodeSet',
    description:
      'Good for Time (GFT)\n\nAn order that is valid for a pre-defined time period expressed with ExposureDuration(1629) and (optionally) ExposureDurationUnit(1916).',
  },
  {
    name: 'GoodForAuction',
    id: '59012',
    value: 'B',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 59,
    type: 'char',
    codeSet: 'TimeInForceCodeSet',
    description:
      'Good for Auction (GFA)\n\nAn order that is valid for an auction initiated by a trading firm (see AuctionType(1803) for examples.',
  },
  {
    name: 'GoodForMonth',
    id: '59013',
    value: 'C',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 59,
    type: 'char',
    codeSet: 'TimeInForceCodeSet',
    description:
      'Good for this Month (GFM)\n\nAn order that is valid until the end of the current month, i.e. from the time of order submission until the end of the last trading day of the current month.',
  },
  {
    name: 'Normal',
    id: '61001',
    value: '0',
    sort: 1,
    added: 'FIX.2.7',
    tag: 61,
    type: 'char',
    codeSet: 'UrgencyCodeSet',
    description: 'Normal',
  },
  {
    name: 'Flash',
    id: '61002',
    value: '1',
    sort: 2,
    added: 'FIX.2.7',
    tag: 61,
    type: 'char',
    codeSet: 'UrgencyCodeSet',
    description: 'Flash',
  },
  {
    name: 'Background',
    id: '61003',
    value: '2',
    sort: 3,
    added: 'FIX.2.7',
    tag: 61,
    type: 'char',
    codeSet: 'UrgencyCodeSet',
    description: 'Background',
  },
  {
    name: 'Regular',
    id: '63001',
    value: '0',
    sort: 1,
    added: 'FIX.2.7',
    tag: 63,
    type: 'String',
    codeSet: 'SettlTypeCodeSet',
    description: 'Regular / FX Spot settlement (T+1 or T+2 depending on currency)',
  },
  {
    name: 'Cash',
    id: '63002',
    value: '1',
    sort: 2,
    added: 'FIX.2.7',
    tag: 63,
    type: 'String',
    codeSet: 'SettlTypeCodeSet',
    description: 'Cash (TOD / T+0)',
  },
  {
    name: 'NextDay',
    id: '63003',
    value: '2',
    sort: 3,
    added: 'FIX.2.7',
    tag: 63,
    type: 'String',
    codeSet: 'SettlTypeCodeSet',
    description: 'Next Day (TOM / T+1)',
  },
  {
    name: 'TPlus2',
    id: '63004',
    value: '3',
    sort: 4,
    added: 'FIX.2.7',
    tag: 63,
    type: 'String',
    codeSet: 'SettlTypeCodeSet',
    description: 'T+2',
  },
  {
    name: 'TPlus3',
    id: '63005',
    value: '4',
    sort: 5,
    added: 'FIX.2.7',
    tag: 63,
    type: 'String',
    codeSet: 'SettlTypeCodeSet',
    description: 'T+3',
  },
  {
    name: 'TPlus4',
    id: '63006',
    value: '5',
    sort: 6,
    added: 'FIX.2.7',
    tag: 63,
    type: 'String',
    codeSet: 'SettlTypeCodeSet',
    description: 'T+4',
  },
  {
    name: 'Future',
    id: '63007',
    value: '6',
    sort: 7,
    added: 'FIX.2.7',
    tag: 63,
    type: 'String',
    codeSet: 'SettlTypeCodeSet',
    description: 'Future',
  },
  {
    name: 'WhenAndIfIssued',
    id: '63008',
    value: '7',
    sort: 8,
    added: 'FIX.2.7',
    tag: 63,
    type: 'String',
    codeSet: 'SettlTypeCodeSet',
    description: 'When And If Issued',
  },
  {
    name: 'SellersOption',
    id: '63009',
    value: '8',
    sort: 9,
    added: 'FIX.2.7',
    tag: 63,
    type: 'String',
    codeSet: 'SettlTypeCodeSet',
    description: 'Sellers Option',
  },
  {
    name: 'TPlus5',
    id: '63010',
    value: '9',
    sort: 10,
    added: 'FIX.3.0',
    tag: 63,
    type: 'String',
    codeSet: 'SettlTypeCodeSet',
    description: 'T+5',
  },
  {
    name: 'BrokenDate',
    id: '63011',
    value: 'B',
    sort: 12,
    added: 'FIX.4.4',
    addedEP: '25',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 63,
    type: 'String',
    codeSet: 'SettlTypeCodeSet',
    description:
      'Broken date\n\nUse within FX to specify a non-standard tenor. The use of SettlDate(64) is required to specify the actual settlement date when SettlType(63) = B (Broken date).',
  },
  {
    name: 'FXSpotNextSettlement',
    id: '63012',
    value: 'C',
    sort: 99,
    added: 'FIX.4.4',
    addedEP: '21',
    tag: 63,
    type: 'String',
    codeSet: 'SettlTypeCodeSet',
    description: 'FX Spot Next settlement (Spot+1, aka next day)',
  },
  {
    name: 'EUCPWithLumpSumInterest',
    id: '65001',
    value: 'CD',
    sort: 1,
    group: 'For Fixed Income',
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 65,
    type: 'String',
    codeSet: 'SymbolSfxCodeSet',
    description: 'EUCP with lump-sum interest rather than discount price',
  },
  {
    name: 'WhenIssued',
    id: '65002',
    value: 'WI',
    sort: 2,
    group: 'For Fixed Income',
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 65,
    type: 'String',
    codeSet: 'SymbolSfxCodeSet',
    description: '"When Issued" for a security to be reissued under an old CUSIP or ISIN',
  },
  {
    name: 'New',
    id: '71001',
    value: '0',
    sort: 1,
    added: 'FIX.2.7',
    tag: 71,
    type: 'char',
    codeSet: 'AllocTransTypeCodeSet',
    description: 'New',
  },
  {
    name: 'Replace',
    id: '71002',
    value: '1',
    sort: 2,
    added: 'FIX.2.7',
    tag: 71,
    type: 'char',
    codeSet: 'AllocTransTypeCodeSet',
    description: 'Replace',
  },
  {
    name: 'Cancel',
    id: '71003',
    value: '2',
    sort: 3,
    added: 'FIX.2.7',
    tag: 71,
    type: 'char',
    codeSet: 'AllocTransTypeCodeSet',
    description: 'Cancel',
  },
  {
    name: 'Preliminary',
    id: '71004',
    value: '3',
    sort: 4,
    added: 'FIX.4.1',
    deprecated: 'FIX.4.2',
    tag: 71,
    type: 'char',
    codeSet: 'AllocTransTypeCodeSet',
    description: 'Preliminary (without MiscFees and NetMoney) (Removed/Replaced)',
  },
  {
    name: 'Calculated',
    id: '71005',
    value: '4',
    sort: 5,
    added: 'FIX.4.1',
    deprecated: 'FIX.4.2',
    tag: 71,
    type: 'char',
    codeSet: 'AllocTransTypeCodeSet',
    description: 'Calculated (includes MiscFees and NetMoney) (Removed/Replaced)',
  },
  {
    name: 'CalculatedWithoutPreliminary',
    id: '71006',
    value: '5',
    sort: 6,
    added: 'FIX.4.2',
    deprecated: 'FIX.4.2',
    tag: 71,
    type: 'char',
    codeSet: 'AllocTransTypeCodeSet',
    description:
      'Calculated without Preliminary (sent unsolicited by broker, includes MiscFees and NetMoney) (Removed/Replaced)',
  },
  {
    name: 'Reversal',
    id: '71007',
    value: '6',
    sort: 7,
    added: 'FIX.4.4',
    addedEP: '5',
    tag: 71,
    type: 'char',
    codeSet: 'AllocTransTypeCodeSet',
    description: 'Reversal',
  },
  {
    name: 'Close',
    id: '77001',
    value: 'C',
    sort: 1,
    added: 'FIX.4.1',
    tag: 77,
    type: 'char',
    codeSet: 'PositionEffectCodeSet',
    description: 'Close',
  },
  {
    name: 'FIFO',
    id: '77002',
    value: 'F',
    sort: 2,
    added: 'FIX.4.3',
    tag: 77,
    type: 'char',
    codeSet: 'PositionEffectCodeSet',
    description: 'FIFO',
  },
  {
    name: 'Open',
    id: '77003',
    value: 'O',
    sort: 3,
    added: 'FIX.4.1',
    tag: 77,
    type: 'char',
    codeSet: 'PositionEffectCodeSet',
    description: 'Open',
  },
  {
    name: 'Rolled',
    id: '77004',
    value: 'R',
    sort: 4,
    added: 'FIX.4.3',
    tag: 77,
    type: 'char',
    codeSet: 'PositionEffectCodeSet',
    description: 'Rolled',
  },
  {
    name: 'CloseButNotifyOnOpen',
    id: '77005',
    value: 'N',
    sort: 5,
    added: 'FIX.5.0',
    addedEP: '61',
    tag: 77,
    type: 'char',
    codeSet: 'PositionEffectCodeSet',
    description: 'Close but notify on open',
  },
  {
    name: 'Default',
    id: '77006',
    value: 'D',
    sort: 6,
    added: 'FIX.5.0',
    addedEP: '61',
    tag: 77,
    type: 'char',
    codeSet: 'PositionEffectCodeSet',
    description: 'Default',
  },
  {
    name: 'Regular',
    id: '81001',
    value: '0',
    sort: 1,
    added: 'FIX.2.7',
    tag: 81,
    type: 'char',
    codeSet: 'ProcessCodeCodeSet',
    description: 'Regular',
  },
  {
    name: 'SoftDollar',
    id: '81002',
    value: '1',
    sort: 2,
    added: 'FIX.2.7',
    tag: 81,
    type: 'char',
    codeSet: 'ProcessCodeCodeSet',
    description: 'Soft Dollar',
  },
  {
    name: 'StepIn',
    id: '81003',
    value: '2',
    sort: 3,
    added: 'FIX.2.7',
    tag: 81,
    type: 'char',
    codeSet: 'ProcessCodeCodeSet',
    description: 'Step-In',
  },
  {
    name: 'StepOut',
    id: '81004',
    value: '3',
    sort: 4,
    added: 'FIX.2.7',
    tag: 81,
    type: 'char',
    codeSet: 'ProcessCodeCodeSet',
    description: 'Step-Out',
  },
  {
    name: 'SoftDollarStepIn',
    id: '81005',
    value: '4',
    sort: 5,
    added: 'FIX.2.7',
    tag: 81,
    type: 'char',
    codeSet: 'ProcessCodeCodeSet',
    description: 'Soft-dollar Step-In',
  },
  {
    name: 'SoftDollarStepOut',
    id: '81006',
    value: '5',
    sort: 6,
    added: 'FIX.2.7',
    tag: 81,
    type: 'char',
    codeSet: 'ProcessCodeCodeSet',
    description: 'Soft-dollar Step-Out',
  },
  {
    name: 'PlanSponsor',
    id: '81007',
    value: '6',
    sort: 7,
    added: 'FIX.4.0',
    tag: 81,
    type: 'char',
    codeSet: 'ProcessCodeCodeSet',
    description: 'Plan Sponsor',
  },
  {
    name: 'Accepted',
    id: '87001',
    value: '0',
    sort: 0,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 87,
    type: 'int',
    codeSet: 'AllocStatusCodeSet',
    description: 'Accepted (successfully processed)',
  },
  {
    name: 'BlockLevelReject',
    id: '87002',
    value: '1',
    sort: 1,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 87,
    type: 'int',
    codeSet: 'AllocStatusCodeSet',
    description: 'Block level reject',
  },
  {
    name: 'AccountLevelReject',
    id: '87003',
    value: '2',
    sort: 2,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 87,
    type: 'int',
    codeSet: 'AllocStatusCodeSet',
    description: 'Account level reject',
  },
  {
    name: 'Received',
    id: '87004',
    value: '3',
    sort: 3,
    added: 'FIX.4.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 87,
    type: 'int',
    codeSet: 'AllocStatusCodeSet',
    description: 'Received (received not yet processed)',
  },
  {
    name: 'Incomplete',
    id: '87005',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 87,
    type: 'int',
    codeSet: 'AllocStatusCodeSet',
    description: 'Incomplete',
  },
  {
    name: 'RejectedByIntermediary',
    id: '87006',
    value: '5',
    sort: 5,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 87,
    type: 'int',
    codeSet: 'AllocStatusCodeSet',
    description: 'Rejected by intermediary',
  },
  {
    name: 'AllocationPending',
    id: '87007',
    value: '6',
    sort: 6,
    added: 'FIX.4.4',
    addedEP: '5',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 87,
    type: 'int',
    codeSet: 'AllocStatusCodeSet',
    description: 'Allocation pending',
  },
  {
    name: 'Reversed',
    id: '87008',
    value: '7',
    sort: 7,
    added: 'FIX.4.4',
    addedEP: '5',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 87,
    type: 'int',
    codeSet: 'AllocStatusCodeSet',
    description: 'Reversed',
  },
  {
    name: 'CancelledByIntermediary',
    id: '87009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 87,
    type: 'int',
    codeSet: 'AllocStatusCodeSet',
    description: 'Cancelled by intermediary\n\n',
  },
  {
    name: 'Claimed',
    id: '87010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 87,
    type: 'int',
    codeSet: 'AllocStatusCodeSet',
    description: 'Claimed',
  },
  {
    name: 'Refused',
    id: '87011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 87,
    type: 'int',
    codeSet: 'AllocStatusCodeSet',
    description: 'Refused',
  },
  {
    name: 'PendingGiveUpApproval',
    id: '87012',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 87,
    type: 'int',
    codeSet: 'AllocStatusCodeSet',
    description: 'Pending give-up approval',
  },
  {
    name: 'Cancelled',
    id: '87013',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 87,
    type: 'int',
    codeSet: 'AllocStatusCodeSet',
    description: 'Cancelled',
  },
  {
    name: 'PendingTakeUpApproval',
    id: '87014',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 87,
    type: 'int',
    codeSet: 'AllocStatusCodeSet',
    description: 'Pending take-up approval',
  },
  {
    name: 'ReversalPending',
    id: '87015',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 87,
    type: 'int',
    codeSet: 'AllocStatusCodeSet',
    description: 'Reversal pending',
  },
  {
    name: 'UnknownAccount',
    id: '88001',
    value: '0',
    sort: 1,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '170',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Unknown or missing account(s)',
  },
  {
    name: 'IncorrectQuantity',
    id: '88002',
    value: '1',
    sort: 2,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '170',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Incorrect or missing block quantity',
  },
  {
    name: 'IncorrectAveragePrice',
    id: '88003',
    value: '2',
    sort: 3,
    added: 'FIX.2.7',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Incorrect or missing average price',
  },
  {
    name: 'UnknownExecutingBrokerMnemonic',
    id: '88004',
    value: '3',
    sort: 4,
    added: 'FIX.2.7',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Unknown executing broker mnemonic',
  },
  {
    name: 'CommissionDifference',
    id: '88005',
    value: '4',
    sort: 5,
    added: 'FIX.2.7',
    updated: 'FIX.5.0SP2',
    updatedEP: '170',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Incorrect or missing commission',
  },
  {
    name: 'UnknownOrderID',
    id: '88006',
    value: '5',
    sort: 6,
    added: 'FIX.2.7',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Unknown OrderID(37)',
  },
  {
    name: 'UnknownListID',
    id: '88007',
    value: '6',
    sort: 7,
    added: 'FIX.2.7',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Unknown ListID(66)',
  },
  {
    name: 'OtherSeeText',
    id: '88008',
    value: '7',
    sort: 8,
    added: 'FIX.2.7',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Other (further in Text (58))',
  },
  {
    name: 'IncorrectAllocatedQuantity',
    id: '88009',
    value: '8',
    sort: 9,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '170',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Incorrect or missing allocated quantity',
  },
  {
    name: 'CalculationDifference',
    id: '88010',
    value: '9',
    sort: 10,
    added: 'FIX.4.4',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Calculation difference',
  },
  {
    name: 'UnknownOrStaleExecID',
    id: '88011',
    value: '10',
    sort: 11,
    added: 'FIX.4.4',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Unknown or Stale ExecID(17)',
  },
  {
    name: 'MismatchedData',
    id: '88012',
    value: '11',
    sort: 12,
    added: 'FIX.4.4',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Mismatched data',
  },
  {
    name: 'UnknownClOrdID',
    id: '88013',
    value: '12',
    sort: 13,
    added: 'FIX.4.4',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Unknown ClOrdID(11)',
  },
  {
    name: 'WarehouseRequestRejected',
    id: '88014',
    value: '13',
    sort: 14,
    added: 'FIX.4.4',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Warehouse request rejected',
  },
  {
    name: 'DuplicateOrMissingIndividualAllocID',
    id: '88015',
    value: '14',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Duplicate or missing IndividualAllocID(467)',
  },
  {
    name: 'TradeNotRecognized',
    id: '88016',
    value: '15',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Trade not recognized',
  },
  {
    name: 'DuplicateTrade',
    id: '88017',
    value: '16',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Trade previously allocated',
  },
  {
    name: 'IncorrectOrMissingInstrument',
    id: '88018',
    value: '17',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Incorrect or missing instrument',
  },
  {
    name: 'IncorrectOrMissingSettlDate',
    id: '88019',
    value: '18',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Incorrect or missing settlement date',
  },
  {
    name: 'IncorrectOrMissingFundIDOrFundName',
    id: '88020',
    value: '19',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Incorrect or missing fund ID or fund name',
  },
  {
    name: 'IncorrectOrMissingSettlInstructions',
    id: '88021',
    value: '20',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Incorrect or missing settlement instructions',
  },
  {
    name: 'IncorrectOrMissingFees',
    id: '88022',
    value: '21',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Incorrect or missing fees',
  },
  {
    name: 'IncorrectOrMissingTax',
    id: '88023',
    value: '22',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Incorrect or missing tax',
  },
  {
    name: 'UnknownOrMissingParty',
    id: '88024',
    value: '23',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Unknown or missing party',
  },
  {
    name: 'IncorrectOrMissingSide',
    id: '88025',
    value: '24',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Incorrect or missing side',
  },
  {
    name: 'IncorrectOrMissingNetMoney',
    id: '88026',
    value: '25',
    sort: 26,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Incorrect or missing net-money',
  },
  {
    name: 'IncorrectOrMissingTradeDate',
    id: '88027',
    value: '26',
    sort: 27,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Incorrect or missing trade date',
  },
  {
    name: 'IncorrectOrMissingSettlCcyInstructions',
    id: '88028',
    value: '27',
    sort: 28,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Incorrect or missing settlement currency instructions',
  },
  {
    name: 'IncorrectOrMissingProcessCode',
    id: '88029',
    value: '28',
    sort: 29,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Incorrrect or missing ProcessCode(81)',
  },
  {
    name: 'Other',
    id: '88030',
    value: '99',
    sort: 100,
    added: 'FIX.5.0SP1',
    addedEP: '95',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 88,
    type: 'int',
    codeSet: 'AllocRejCodeCodeSet',
    description: 'Other\n\nUse Text(58) for further reject reasons.',
  },
  {
    name: 'New',
    id: '94001',
    value: '0',
    sort: 1,
    added: 'FIX.2.7',
    tag: 94,
    type: 'char',
    codeSet: 'EmailTypeCodeSet',
    description: 'New',
  },
  {
    name: 'Reply',
    id: '94002',
    value: '1',
    sort: 2,
    added: 'FIX.2.7',
    tag: 94,
    type: 'char',
    codeSet: 'EmailTypeCodeSet',
    description: 'Reply',
  },
  {
    name: 'AdminReply',
    id: '94003',
    value: '2',
    sort: 3,
    added: 'FIX.2.7',
    tag: 94,
    type: 'char',
    codeSet: 'EmailTypeCodeSet',
    description: 'Admin Reply',
  },
  {
    name: 'OriginalTransmission',
    id: '97001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.1',
    tag: 97,
    type: 'Boolean',
    codeSet: 'PossResendCodeSet',
    description: 'Original Transmission',
  },
  {
    name: 'PossibleResend',
    id: '97002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.1',
    tag: 97,
    type: 'Boolean',
    codeSet: 'PossResendCodeSet',
    description: 'Possible Resend',
  },
  {
    name: 'None',
    id: '98001',
    value: '0',
    sort: 1,
    added: 'FIX.2.7',
    tag: 98,
    type: 'int',
    codeSet: 'EncryptMethodCodeSet',
    description: 'None / Other',
  },
  {
    name: 'PKCS',
    id: '98002',
    value: '1',
    sort: 2,
    added: 'FIX.2.7',
    tag: 98,
    type: 'int',
    codeSet: 'EncryptMethodCodeSet',
    description: 'PKCS (Proprietary)',
  },
  {
    name: 'DES',
    id: '98003',
    value: '2',
    sort: 3,
    added: 'FIX.2.7',
    tag: 98,
    type: 'int',
    codeSet: 'EncryptMethodCodeSet',
    description: 'DES (ECB Mode)',
  },
  {
    name: 'PKCSDES',
    id: '98004',
    value: '3',
    sort: 4,
    added: 'FIX.2.7',
    tag: 98,
    type: 'int',
    codeSet: 'EncryptMethodCodeSet',
    description: 'PKCS / DES (Proprietary)',
  },
  {
    name: 'PGPDES',
    id: '98005',
    value: '4',
    sort: 5,
    added: 'FIX.3.0',
    tag: 98,
    type: 'int',
    codeSet: 'EncryptMethodCodeSet',
    description: 'PGP / DES (Defunct)',
  },
  {
    name: 'PGPDESMD5',
    id: '98006',
    value: '5',
    sort: 6,
    added: 'FIX.4.0',
    tag: 98,
    type: 'int',
    codeSet: 'EncryptMethodCodeSet',
    description: 'PGP / DES-MD5 (See app note on FIX web site)',
  },
  {
    name: 'PEM',
    id: '98007',
    value: '6',
    sort: 7,
    added: 'FIX.4.0',
    tag: 98,
    type: 'int',
    codeSet: 'EncryptMethodCodeSet',
    description: 'PEM / DES-MD5 (see app note on FIX web site)',
  },
  {
    name: 'TooLateToCancel',
    id: '102001',
    value: '0',
    sort: 1,
    added: 'FIX.2.7',
    tag: 102,
    type: 'int',
    codeSet: 'CxlRejReasonCodeSet',
    description: 'Too late to cancel',
  },
  {
    name: 'UnknownOrder',
    id: '102002',
    value: '1',
    sort: 2,
    added: 'FIX.2.7',
    tag: 102,
    type: 'int',
    codeSet: 'CxlRejReasonCodeSet',
    description: 'Unknown order',
  },
  {
    name: 'BrokerCredit',
    id: '102003',
    value: '2',
    sort: 3,
    added: 'FIX.4.2',
    tag: 102,
    type: 'int',
    codeSet: 'CxlRejReasonCodeSet',
    description: 'Broker / Exchange Option',
  },
  {
    name: 'OrderAlreadyInPendingStatus',
    id: '102004',
    value: '3',
    sort: 4,
    added: 'FIX.4.2',
    tag: 102,
    type: 'int',
    codeSet: 'CxlRejReasonCodeSet',
    description: 'Order already in Pending Cancel or Pending Replace status',
  },
  {
    name: 'UnableToProcessOrderMassCancelRequest',
    id: '102005',
    value: '4',
    sort: 5,
    added: 'FIX.4.3',
    tag: 102,
    type: 'int',
    codeSet: 'CxlRejReasonCodeSet',
    description: 'Unable to process Order Mass Cancel Request',
  },
  {
    name: 'OrigOrdModTime',
    id: '102006',
    value: '5',
    sort: 6,
    added: 'FIX.4.3',
    tag: 102,
    type: 'int',
    codeSet: 'CxlRejReasonCodeSet',
    description: 'OrigOrdModTime (586) did not match last TransactTime (60) of order',
  },
  {
    name: 'DuplicateClOrdID',
    id: '102007',
    value: '6',
    sort: 7,
    added: 'FIX.4.3',
    tag: 102,
    type: 'int',
    codeSet: 'CxlRejReasonCodeSet',
    description: 'Duplicate ClOrdID (11) received',
  },
  {
    name: 'PriceExceedsCurrentPrice',
    id: '102008',
    value: '7',
    sort: 8,
    added: 'FIX.5.0',
    addedEP: '-1',
    tag: 102,
    type: 'int',
    codeSet: 'CxlRejReasonCodeSet',
    description: 'Price exceeds current price',
  },
  {
    name: 'PriceExceedsCurrentPriceBand',
    id: '102009',
    value: '8',
    sort: 9,
    added: 'FIX.5.0',
    addedEP: '43',
    tag: 102,
    type: 'int',
    codeSet: 'CxlRejReasonCodeSet',
    description: 'Price exceeds current price band',
  },
  {
    name: 'InvalidPriceIncrement',
    id: '102010',
    value: '18',
    sort: 18,
    added: 'FIX.4.4',
    addedEP: '6',
    tag: 102,
    type: 'int',
    codeSet: 'CxlRejReasonCodeSet',
    description: 'Invalid price increment',
  },
  {
    name: 'Other',
    id: '102011',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    tag: 102,
    type: 'int',
    codeSet: 'CxlRejReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'BrokerCredit',
    id: '103001',
    value: '0',
    sort: 0,
    added: 'FIX.2.7',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Broker / Exchange option',
  },
  {
    name: 'UnknownSymbol',
    id: '103002',
    value: '1',
    sort: 1,
    added: 'FIX.2.7',
    updated: 'FIX.Latest',
    updatedEP: '290',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description:
      'Unknown symbol\n\nIn the context of IA FX Reject codes, Trade Request Rejection Category F, order rejected due to the product not being supported, e.g. by the specific venue, tenor restrictions on the market participant(s) involved.',
  },
  {
    name: 'ExchangeClosed',
    id: '103003',
    value: '2',
    sort: 2,
    added: 'FIX.2.7',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Exchange closed',
  },
  {
    name: 'OrderExceedsLimit',
    id: '103004',
    value: '3',
    sort: 3,
    added: 'FIX.2.7',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Order exceeds limit',
  },
  {
    name: 'TooLateToEnter',
    id: '103005',
    value: '4',
    sort: 4,
    added: 'FIX.4.0',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Too late to enter',
  },
  {
    name: 'UnknownOrder',
    id: '103006',
    value: '5',
    sort: 5,
    added: 'FIX.4.1',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Unknown order',
  },
  {
    name: 'DuplicateOrder',
    id: '103007',
    value: '6',
    sort: 6,
    added: 'FIX.4.1',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Duplicate Order (e.g. dupe ClOrdID)',
  },
  {
    name: 'DuplicateOfAVerballyCommunicatedOrder',
    id: '103008',
    value: '7',
    sort: 7,
    added: 'FIX.4.2',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Duplicate of a verbally communicated order',
  },
  {
    name: 'StaleOrder',
    id: '103009',
    value: '8',
    sort: 8,
    added: 'FIX.4.2',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Stale order',
  },
  {
    name: 'TradeAlongRequired',
    id: '103010',
    value: '9',
    sort: 9,
    added: 'FIX.4.3',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Trade along required',
  },
  {
    name: 'InvalidInvestorID',
    id: '103011',
    value: '10',
    sort: 10,
    added: 'FIX.4.3',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Invalid Investor ID',
  },
  {
    name: 'UnsupportedOrderCharacteristic',
    id: '103012',
    value: '11',
    sort: 11,
    added: 'FIX.4.3',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Unsupported order characteristic',
  },
  {
    name: 'SurveillanceOption',
    id: '103013',
    value: '12',
    sort: 12,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Surveillance option',
  },
  {
    name: 'IncorrectQuantity',
    id: '103014',
    value: '13',
    sort: 13,
    added: 'FIX.4.4',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Incorrect quantity',
  },
  {
    name: 'IncorrectAllocatedQuantity',
    id: '103015',
    value: '14',
    sort: 14,
    added: 'FIX.4.4',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Incorrect allocated quantity',
  },
  {
    name: 'UnknownAccount',
    id: '103016',
    value: '15',
    sort: 15,
    added: 'FIX.4.4',
    updated: 'FIX.Latest',
    updatedEP: '290',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description:
      'Unknown account(s)\n\nIn the context of IA FX Reject codes, Trade Request Rejection Category D, order rejected due to static data when the account/fund is not setup or unknown.',
  },
  {
    name: 'PriceExceedsCurrentPriceBand',
    id: '103017',
    value: '16',
    sort: 16,
    added: 'FIX.5.0',
    addedEP: '-1',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Price exceeds current price band',
  },
  {
    name: 'InvalidPriceIncrement',
    id: '103018',
    value: '18',
    sort: 18,
    added: 'FIX.4.4',
    addedEP: '6',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Invalid price increment',
  },
  {
    name: 'ReferencePriceNotAvailable',
    id: '103019',
    value: '19',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '134',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Reference price not available',
  },
  {
    name: 'NotionalValueExceedsThreshold',
    id: '103020',
    value: '20',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '134',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Notional value exceeds threshold',
  },
  {
    name: 'AlgorithmRiskThresholdBreached',
    id: '103021',
    value: '21',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '149',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description:
      'Algorithm risk threshold breached\n\nA sell-side broker algorithm has detected that a risk limit has been breached which requires further communication with the client. Used in conjunction with Text(58) to convey the details of the specific event.',
  },
  {
    name: 'ShortSellNotPermitted',
    id: '103022',
    value: '22',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '164',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Short sell not permitted',
  },
  {
    name: 'ShortSellSecurityPreBorrowRestriction',
    id: '103023',
    value: '23',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '164',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Short sell rejected due to security pre-borrow restriction',
  },
  {
    name: 'ShortSellAccountPreBorrowRestriction',
    id: '103024',
    value: '24',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '164',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Short sell rejected due to account pre-borrow restriction',
  },
  {
    name: 'InsufficientCreditLimit',
    id: '103025',
    value: '25',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    updated: 'FIX.Latest',
    updatedEP: '290',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description:
      'Insufficient credit limit\n\nIn the context of IA FX Reject codes, Trade Request Rejection Category C, order rejected due to credit limit exceeded or not in place.',
  },
  {
    name: 'ExceededClipSizeLimit',
    id: '103026',
    value: '26',
    sort: 26,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Exceeded clip size limit',
  },
  {
    name: 'ExceededMaxNotionalOrderAmt',
    id: '103027',
    value: '27',
    sort: 27,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Exceeded maximum notional order amount',
  },
  {
    name: 'ExceededDV01PV01Limit',
    id: '103028',
    value: '28',
    sort: 28,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Exceeded DV01/PV01 limit',
  },
  {
    name: 'ExceededCS01Limit',
    id: '103029',
    value: '29',
    sort: 29,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description: 'Exceeded CS01 limit',
  },
  {
    name: 'LastLook',
    id: '103030',
    value: '30',
    sort: 30,
    added: 'FIX.Latest',
    addedEP: '290',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description:
      'Last look\n\nIn the context of IA FX Reject codes, Trade Request Rejection Category A-1, order rejected due to a "last look".',
  },
  {
    name: 'LastLookLatency',
    id: '103031',
    value: '31',
    sort: 31,
    added: 'FIX.Latest',
    addedEP: '290',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description:
      'Last look latency\n\nIn the context of IA FX Reject codes, Trade Request Rejection Category A-2, order rejected due to "last look latency", therefore price or liquidity is unavailable.',
  },
  {
    name: 'UnavailablePriceLiquidity',
    id: '103032',
    value: '32',
    sort: 32,
    added: 'FIX.Latest',
    addedEP: '290',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description:
      'Unavailable price or liquidity\n\nIn the context of IA FX Reject codes, Trade Request Rejection Category B, the order was not subjected to last look but rejected due to pricing or liquidity being no longer available for execution.',
  },
  {
    name: 'InvalidMissingEntitlements',
    id: '103033',
    value: '33',
    sort: 33,
    added: 'FIX.Latest',
    addedEP: '290',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description:
      'Invalid or missing entitlements\n\nIn the context of IA FX Reject codes, Trade Request Rejection Category D, order rejected due to static/reference data error where counterparty is not permissioned or entitled.',
  },
  {
    name: 'Other',
    id: '103034',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    updated: 'FIX.Latest',
    updatedEP: '290',
    tag: 103,
    type: 'int',
    codeSet: 'OrdRejReasonCodeSet',
    description:
      'Other\n\nIn the context of IA FX Reject codes, Trade Request Rejection Category E, order rejected due to other exceptions. Further detail may be provided in RejectText(1328) or Text(58), with preference for RejectText(1328) if field is present in the message.',
  },
  {
    name: 'AllOrNone',
    id: '104001',
    value: 'A',
    sort: 1,
    added: 'FIX.3.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description: 'All or None (AON)',
  },
  {
    name: 'MarketOnClose',
    id: '104002',
    value: 'B',
    sort: 2,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description: 'Market On Close (MOC) (held to close)',
  },
  {
    name: 'AtTheClose',
    id: '104003',
    value: 'C',
    sort: 3,
    added: 'FIX.3.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description: 'At the close (around/not held to close)',
  },
  {
    name: 'VWAP',
    id: '104004',
    value: 'D',
    sort: 4,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description: 'VWAP (Volume Weighted Average Price)',
  },
  {
    name: 'Axe',
    id: '104005',
    value: 'E',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '184',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description:
      'Axe\n\nIndicates that a quote is an Axe, without specifying a side preference. Mutually exclusive with F(Axe on bid) and G(Axe on offer).',
  },
  {
    name: 'AxeOnBid',
    id: '104006',
    value: 'F',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '184',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description:
      'Axe on bid\n\nIndicates that a quote is an Axe, with a preference to execute on the bid side. Mutually exclusive with E(Axe) and G (Axe on offer)',
  },
  {
    name: 'AxeOnOffer',
    id: '104007',
    value: 'G',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '184',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description:
      'Axe on offer\n\nIndicates that a quote is an Axe, with a preference to execute on the offer side. Mutually exclusive with E(Axe) and F (Axe on bid)',
  },
  {
    name: 'ClientNaturalWorking',
    id: '104008',
    value: 'H',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description:
      'Client natural working\n\nWith reference to the AFME/IA Framework for Indications of Interest, this is to be used to denote IOIs of type C2 – Client Natural (Working). A client should be able to seek verification (from IOI publisher’s management/compliance) that, for any C2 IOIs received, there was a corresponding live client order for at least the advertised size prior to the IOI being generated. Resulting trades are expected to be of a riskless nature.',
  },
  {
    name: 'InTouchWith',
    id: '104009',
    value: 'I',
    sort: 9,
    added: 'FIX.3.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description:
      'In touch with\n\nWith reference to the AFME/IA Framework for Indications of Interest, this is to be used to denote IOIs of type P1 - Potential. Post-execution, a client should be able to seek verification (from IOI publisher’s management/ compliance) that, for any P1 IOIs received and executed against, there was by time of the execution, an opposing specific client order. Resulting trades are expected to be of a riskless nature. If the anticipated client order does not materialise, and the broker elects to commit capital, this must be disclosed prior to execution.',
  },
  {
    name: 'PositionWanted',
    id: '104010',
    value: 'J',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description:
      'Position wanted\n\nWith reference to the AFME/IA Framework for Indications of Interest, this is to be used to denote IOIs of type H2 – Position Wanted. Brokers will be likely be sourcing liquidity and therefore may advertise the size of IOI they wish; however, clients can expect the broker to honour the size of IOI shown. The presumption is that there is no intent to immediately unwind the position without notification, however, brokers may provide additional granularity to the category and may offer bilateral post trade commitments. Brokers will also offer clients a feedback mechanism.',
  },
  {
    name: 'MarketMaking',
    id: '104011',
    value: 'K',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description:
      'Market making\n\nWith reference to the AFME/IA Framework for Indications of Interest, this is to be used to denote IOIs of type H3 – Market Making, no enforcement is required.',
  },
  {
    name: 'Limit',
    id: '104012',
    value: 'L',
    sort: 12,
    added: 'FIX.3.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description: 'Limit',
  },
  {
    name: 'MoreBehind',
    id: '104013',
    value: 'M',
    sort: 13,
    added: 'FIX.3.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description: 'More Behind',
  },
  {
    name: 'ClientNaturalBlock',
    id: '104014',
    value: 'N',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description:
      'Client natural block\n\nWith reference to the AFME/IA Framework for Indications of Interest, this is to be used to denote IOIs of type C1 - Client Natural (Block). A client should be able to seek verification (from IOI publisher’s management/compliance) that, for any C1 IOIs received, there was a corresponding live client order for at least the advertised size prior to the IOI being generated. Resulting trades are expected to be of a riskless nature.',
  },
  {
    name: 'AtTheOpen',
    id: '104015',
    value: 'O',
    sort: 15,
    added: 'FIX.3.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description: 'At the Open',
  },
  {
    name: 'TakingAPosition',
    id: '104016',
    value: 'P',
    sort: 16,
    added: 'FIX.3.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description: 'Taking a Position',
  },
  {
    name: 'AtTheMarket',
    id: '104017',
    value: 'Q',
    sort: 17,
    added: 'FIX.3.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description: 'At the Market (previously called Current Quote)',
  },
  {
    name: 'ReadyToTrade',
    id: '104018',
    value: 'R',
    sort: 18,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description: 'Ready to Trade',
  },
  {
    name: 'PortfolioShown',
    id: '104019',
    value: 'S',
    sort: 19,
    added: 'FIX.3.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description: 'Inventory or Portfolio Shown',
  },
  {
    name: 'ThroughTheDay',
    id: '104020',
    value: 'T',
    sort: 20,
    added: 'FIX.3.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description: 'Through the Day',
  },
  {
    name: 'Unwind',
    id: '104021',
    value: 'U',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description:
      'Unwind\n\nWith reference to the AFME/IA Framework for Indications of Interest, this is to be used to denote IOIs of type H1 - Unwind. Brokers will be responsible for ensuring that the size of the IOI reflects the actual house position in the relevant business unit and should not inflate the size of the IOI. The presumption is that there is no intent to immediately replace the position without notification, however, brokers may provide additional granularity to the category and may offer bilateral post trade commitments. Brokers will also offer clients a feedback mechanism.',
  },
  {
    name: 'Versus',
    id: '104022',
    value: 'V',
    sort: 22,
    added: 'FIX.3.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description: 'Versus',
  },
  {
    name: 'Indication',
    id: '104023',
    value: 'W',
    sort: 23,
    added: 'FIX.3.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description: 'Indication - Working Away',
  },
  {
    name: 'CrossingOpportunity',
    id: '104024',
    value: 'X',
    sort: 24,
    added: 'FIX.3.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description: 'Crossing Opportunity',
  },
  {
    name: 'AtTheMidpoint',
    id: '104025',
    value: 'Y',
    sort: 25,
    added: 'FIX.4.1',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description: 'At the Midpoint',
  },
  {
    name: 'PreOpen',
    id: '104026',
    value: 'Z',
    sort: 26,
    added: 'FIX.4.1',
    updated: 'FIX.5.0SP2',
    updatedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description: 'Pre-open',
  },
  {
    name: 'QuantityNegotiable',
    id: '104027',
    value: '1',
    sort: 28,
    added: 'FIX.5.0SP2',
    addedEP: '226',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description:
      'Quantity is negotiable\n\nWhen specified, the dealer may counter with a reduced quantity in its Quotes in response to QuoteRequest(35=R). All-or-none if omitted.',
  },
  {
    name: 'AllowLateBids',
    id: '104028',
    value: '2',
    sort: 29,
    added: 'FIX.5.0SP2',
    addedEP: '226',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description:
      'Allow late bids\n\nWhen specified in QuoteRequest(35=R) the dealer may submit quotes after curtain time has elapsed.',
  },
  {
    name: 'ImmediateOrCounter',
    id: '104029',
    value: '3',
    sort: 30,
    added: 'FIX.5.0SP2',
    addedEP: '226',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description:
      'Immediate or counter\n\nWhen specified, the buy-side customer is permitted to counter a firm quote during wiretime.',
  },
  {
    name: 'AutoTrade',
    id: '104030',
    value: '4',
    sort: 31,
    added: 'FIX.5.0SP2',
    addedEP: '226',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description:
      'Auto trade\n\nTrade is in an auto-trading mode whereby the best quote that satisfies user criteria as determined by the trading platform will be accepted automatically.',
  },
  {
    name: 'AutomaticSpot',
    id: '104031',
    value: 'a',
    sort: 37,
    added: 'FIX.5.0SP2',
    addedEP: '226',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description:
      'Automatic spot\n\nAt completion of price negotiation based on spread the trading platform will propose a benchmark spot price which may be filled immediately by the dealer or countered.',
  },
  {
    name: 'PlatformCalculatedSpot',
    id: '104032',
    value: 'b',
    sort: 38,
    added: 'FIX.5.0SP2',
    addedEP: '226',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description:
      'Platform calculated spot\n\nAt completion of price negotiation based on spread the trading platform will supply a benchmark spot price and immediately complete the trade reporting fill. There is no dealer last look.',
  },
  {
    name: 'OutsideSpread',
    id: '104033',
    value: 'c',
    sort: 39,
    added: 'FIX.5.0SP2',
    addedEP: '225',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description:
      'Outside spread\n\nThe IOI is identifiable outside the current bid/offer.',
  },
  {
    name: 'DeferredSpot',
    id: '104034',
    value: 'd',
    sort: 40,
    added: 'FIX.5.0SP2',
    addedEP: '226',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description:
      'Deferred spot\n\nAt a future time after completion of price negotiation based on spread and reported in StrikeTime(443) the trading platform will propose a benchmark spot price which may be filled immediately by the dealer or countered.',
  },
  {
    name: 'NegotiatedSpot',
    id: '104035',
    value: 'n',
    sort: 50,
    added: 'FIX.5.0SP2',
    addedEP: '226',
    tag: 104,
    type: 'char',
    codeSet: 'IOIQualifierCodeSet',
    description:
      'Negotiated spot\n\nOnce price negotiation based on spread is completed negotiation of the benchmark spot price proceeds immediately.',
  },
  {
    name: 'SenderReports',
    id: '113001',
    value: 'N',
    sort: 1,
    added: 'FIX.3.0',
    tag: 113,
    type: 'Boolean',
    codeSet: 'ReportToExchCodeSet',
    description: 'Indicates the party sending message will report trade',
  },
  {
    name: 'ReceiverReports',
    id: '113002',
    value: 'Y',
    sort: 2,
    added: 'FIX.3.0',
    tag: 113,
    type: 'Boolean',
    codeSet: 'ReportToExchCodeSet',
    description: 'Indicates the party receiving message must report trade',
  },
  {
    name: 'No',
    id: '114001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.0',
    tag: 114,
    type: 'Boolean',
    codeSet: 'LocateReqdCodeSet',
    description: 'Indicates the broker is not required to locate',
  },
  {
    name: 'Yes',
    id: '114002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.0',
    tag: 114,
    type: 'Boolean',
    codeSet: 'LocateReqdCodeSet',
    description: 'Indicates the broker is responsible for locating the stock',
  },
  {
    name: 'DoNotExecuteForexAfterSecurityTrade',
    id: '121001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.0',
    tag: 121,
    type: 'Boolean',
    codeSet: 'ForexReqCodeSet',
    description: 'Do Not Execute Forex After Security Trade',
  },
  {
    name: 'ExecuteForexAfterSecurityTrade',
    id: '121002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.0',
    tag: 121,
    type: 'Boolean',
    codeSet: 'ForexReqCodeSet',
    description: 'Execute Forex After Security Trade',
  },
  {
    name: 'SequenceReset',
    id: '123001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.0',
    tag: 123,
    type: 'Boolean',
    codeSet: 'GapFillFlagCodeSet',
    description: 'Sequence Reset, Ignore Msg Seq Num (N/A For FIXML - Not Used)',
  },
  {
    name: 'GapFillMessage',
    id: '123002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.0',
    tag: 123,
    type: 'Boolean',
    codeSet: 'GapFillFlagCodeSet',
    description: 'Gap Fill Message, Msg Seq Num Field Valid',
  },
  {
    name: 'UnknownSymbol',
    id: '127001',
    value: 'A',
    sort: 1,
    added: 'FIX.4.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '131',
    tag: 127,
    type: 'char',
    codeSet: 'DKReasonCodeSet',
    description: 'Unknown security',
  },
  {
    name: 'WrongSide',
    id: '127002',
    value: 'B',
    sort: 2,
    added: 'FIX.4.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '131',
    tag: 127,
    type: 'char',
    codeSet: 'DKReasonCodeSet',
    description: 'Wrong side',
  },
  {
    name: 'QuantityExceedsOrder',
    id: '127003',
    value: 'C',
    sort: 3,
    added: 'FIX.4.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '131',
    tag: 127,
    type: 'char',
    codeSet: 'DKReasonCodeSet',
    description: 'Quantity exceeds order',
  },
  {
    name: 'NoMatchingOrder',
    id: '127004',
    value: 'D',
    sort: 4,
    added: 'FIX.4.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '131',
    tag: 127,
    type: 'char',
    codeSet: 'DKReasonCodeSet',
    description: 'No matching order',
  },
  {
    name: 'PriceExceedsLimit',
    id: '127005',
    value: 'E',
    sort: 5,
    added: 'FIX.4.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '131',
    tag: 127,
    type: 'char',
    codeSet: 'DKReasonCodeSet',
    description: 'Price exceeds limit',
  },
  {
    name: 'CalculationDifference',
    id: '127006',
    value: 'F',
    sort: 6,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '131',
    tag: 127,
    type: 'char',
    codeSet: 'DKReasonCodeSet',
    description: 'Calculation difference',
  },
  {
    name: 'NoMatchingExecutionReport',
    id: '127007',
    value: 'G',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 127,
    type: 'char',
    codeSet: 'DKReasonCodeSet',
    description: 'No matching ExecutionReport(35=8)',
  },
  {
    name: 'Other',
    id: '127008',
    value: 'Z',
    sort: 100,
    added: 'FIX.4.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '131',
    tag: 127,
    type: 'char',
    codeSet: 'DKReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'NotNatural',
    id: '130001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.0',
    tag: 130,
    type: 'Boolean',
    codeSet: 'IOINaturalFlagCodeSet',
    description: 'Not Natural',
  },
  {
    name: 'Natural',
    id: '130002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.0',
    tag: 130,
    type: 'Boolean',
    codeSet: 'IOINaturalFlagCodeSet',
    description: 'Natural',
  },
  {
    name: 'Regulatory',
    id: '139001',
    value: '1',
    sort: 0,
    added: 'FIX.4.0',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Regulatory (e.g. SEC)',
  },
  {
    name: 'Tax',
    id: '139002',
    value: '2',
    sort: 1,
    added: 'FIX.4.0',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Tax',
  },
  {
    name: 'LocalCommission',
    id: '139003',
    value: '3',
    sort: 2,
    added: 'FIX.4.0',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    deprecated: 'FIX.5.0SP2',
    deprecatedEP: '204',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description:
      'Local Commission\n\nDEPRECATE - use <CommissionDataGrp> component instead',
  },
  {
    name: 'ExchangeFees',
    id: '139004',
    value: '4',
    sort: 3,
    added: 'FIX.4.0',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Exchange Fees',
  },
  {
    name: 'Stamp',
    id: '139005',
    value: '5',
    sort: 4,
    added: 'FIX.4.0',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Stamp',
  },
  {
    name: 'Levy',
    id: '139006',
    value: '6',
    sort: 5,
    added: 'FIX.4.0',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Levy',
  },
  {
    name: 'Other',
    id: '139007',
    value: '7',
    sort: 6,
    added: 'FIX.4.0',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Other',
  },
  {
    name: 'Markup',
    id: '139008',
    value: '8',
    sort: 7,
    added: 'FIX.4.1',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Markup',
  },
  {
    name: 'ConsumptionTax',
    id: '139009',
    value: '9',
    sort: 8,
    added: 'FIX.4.2',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Consumption Tax',
  },
  {
    name: 'PerTransaction',
    id: '139010',
    value: '10',
    sort: 9,
    added: 'FIX.4.4',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Per transaction',
  },
  {
    name: 'Conversion',
    id: '139011',
    value: '11',
    sort: 10,
    added: 'FIX.4.4',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Conversion',
  },
  {
    name: 'Agent',
    id: '139012',
    value: '12',
    sort: 11,
    added: 'FIX.4.4',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Agent',
  },
  {
    name: 'TransferFee',
    id: '139013',
    value: '13',
    sort: 15,
    added: 'FIX.4.4',
    addedEP: '25',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Transfer Fee',
  },
  {
    name: 'SecurityLending',
    id: '139014',
    value: '14',
    sort: 16,
    added: 'FIX.4.4',
    addedEP: '25',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Security Lending',
  },
  {
    name: 'TradeReporting',
    id: '139015',
    value: '15',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '204',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description:
      'Trade reporting\n\nTrade reporting [Elaboration: The fee charged to recover the cost of trade reporting, e.g. corporate bonds and structured products reported to FINRA TRACE.',
  },
  {
    name: 'TaxOnPrincipalAmount',
    id: '139016',
    value: '16',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '204',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Tax on principal amount',
  },
  {
    name: 'TaxOnAccruedInterestAmount',
    id: '139017',
    value: '17',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '204',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Tax on accrued interest amount',
  },
  {
    name: 'NewIssuanceFee',
    id: '139018',
    value: '18',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '204',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'New issuance fee',
  },
  {
    name: 'ServiceFee',
    id: '139019',
    value: '19',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '204',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Service fee',
  },
  {
    name: 'OddLotFee',
    id: '139020',
    value: '20',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '204',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Odd lot fee',
  },
  {
    name: 'AuctionFee',
    id: '139021',
    value: '21',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '204',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Auction fee',
  },
  {
    name: 'ValueAddedTax',
    id: '139022',
    value: '22',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '204',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Value Added tax - VAT',
  },
  {
    name: 'SalesTax',
    id: '139023',
    value: '23',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '204',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Sales tax',
  },
  {
    name: 'ExecutionFee',
    id: '139024',
    value: '24',
    sort: 26,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    updated: 'FIX.5.0SP2',
    updatedEP: '236',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Execution venue fee',
  },
  {
    name: 'OrderEntryFee',
    id: '139025',
    value: '25',
    sort: 27,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description:
      'Order or quote entry fee\n\nOrder or quote submission fees per transaction.',
  },
  {
    name: 'OrderModificationFee',
    id: '139026',
    value: '26',
    sort: 28,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description:
      'Order or quote modification fee\n\nOrder or quote modification fees per transaction.',
  },
  {
    name: 'OrdersCancellationFee',
    id: '139027',
    value: '27',
    sort: 29,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description:
      'Orders or quote cancellation fee\n\nOrder or quote cancellation fees per transaction.',
  },
  {
    name: 'MarketDataAccessFee',
    id: '139028',
    value: '28',
    sort: 30,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Market data access fee\n\nFee for market data access.',
  },
  {
    name: 'MarketDataTerminalFee',
    id: '139029',
    value: '29',
    sort: 31,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Market data terminal fee\n\nFee for market data terminal.',
  },
  {
    name: 'MarketDataVolumeFee',
    id: '139030',
    value: '30',
    sort: 32,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Market data volume fee\n\nFee for market data per volume group.',
  },
  {
    name: 'ClearingFee',
    id: '139031',
    value: '31',
    sort: 33,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Clearing fee\n\nFee for clearing of trades.',
  },
  {
    name: 'SettlementFee',
    id: '139032',
    value: '32',
    sort: 34,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Settlement fee\n\nFee for settlement of trades.',
  },
  {
    name: 'Rebates',
    id: '139033',
    value: '33',
    sort: 35,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Rebates\n\nRebates offered to the client.',
  },
  {
    name: 'Discounts',
    id: '139034',
    value: '34',
    sort: 36,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Discounts\n\nDiscounts offered to the client.',
  },
  {
    name: 'Payments',
    id: '139035',
    value: '35',
    sort: 37,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Payments\n\nOther benefits offered to the client.',
  },
  {
    name: 'NonMonetaryPayments',
    id: '139036',
    value: '36',
    sort: 38,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 139,
    type: 'String',
    codeSet: 'MiscFeeTypeCodeSet',
    description: 'Non-monetary payments\n\nNon-monetary benefits offered to the client.',
  },
  {
    name: 'No',
    id: '141001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.1',
    tag: 141,
    type: 'Boolean',
    codeSet: 'ResetSeqNumFlagCodeSet',
    description: 'No',
  },
  {
    name: 'Yes',
    id: '141002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.1',
    tag: 141,
    type: 'Boolean',
    codeSet: 'ResetSeqNumFlagCodeSet',
    description: 'Yes, reset sequence numbers',
  },
  {
    name: 'New',
    id: '150001',
    value: '0',
    sort: 1,
    added: 'FIX.4.1',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'New',
  },
  {
    name: 'DoneForDay',
    id: '150002',
    value: '3',
    sort: 2,
    added: 'FIX.4.1',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Done for day',
  },
  {
    name: 'Canceled',
    id: '150003',
    value: '4',
    sort: 3,
    added: 'FIX.4.1',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Canceled',
  },
  {
    name: 'Replaced',
    id: '150004',
    value: '5',
    sort: 4,
    added: 'FIX.4.1',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Replaced',
  },
  {
    name: 'PendingCancel',
    id: '150005',
    value: '6',
    sort: 5,
    added: 'FIX.4.1',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Pending Cancel (e.g. result of Order Cancel Request)',
  },
  {
    name: 'Stopped',
    id: '150006',
    value: '7',
    sort: 6,
    added: 'FIX.4.1',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Stopped',
  },
  {
    name: 'Rejected',
    id: '150007',
    value: '8',
    sort: 7,
    added: 'FIX.4.1',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Rejected',
  },
  {
    name: 'Suspended',
    id: '150008',
    value: '9',
    sort: 8,
    added: 'FIX.4.1',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Suspended',
  },
  {
    name: 'PendingNew',
    id: '150009',
    value: 'A',
    sort: 9,
    added: 'FIX.4.1',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Pending New',
  },
  {
    name: 'Calculated',
    id: '150010',
    value: 'B',
    sort: 10,
    added: 'FIX.4.1',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Calculated',
  },
  {
    name: 'Expired',
    id: '150011',
    value: 'C',
    sort: 11,
    added: 'FIX.4.1',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Expired',
  },
  {
    name: 'Restated',
    id: '150012',
    value: 'D',
    sort: 12,
    added: 'FIX.4.2',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description:
      'Restated (Execution Report sent unsolicited by sellside, with ExecRestatementReason (378) set)',
  },
  {
    name: 'PendingReplace',
    id: '150013',
    value: 'E',
    sort: 13,
    added: 'FIX.4.2',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Pending Replace (e.g. result of Order Cancel/Replace Request)',
  },
  {
    name: 'Trade',
    id: '150014',
    value: 'F',
    sort: 14,
    added: 'FIX.4.3',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Trade (partial fill or fill)',
  },
  {
    name: 'TradeCorrect',
    id: '150015',
    value: 'G',
    sort: 15,
    added: 'FIX.4.3',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Trade Correct',
  },
  {
    name: 'TradeCancel',
    id: '150016',
    value: 'H',
    sort: 16,
    added: 'FIX.4.3',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Trade Cancel',
  },
  {
    name: 'OrderStatus',
    id: '150017',
    value: 'I',
    sort: 17,
    added: 'FIX.4.3',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Order Status',
  },
  {
    name: 'TradeInAClearingHold',
    id: '150018',
    value: 'J',
    sort: 18,
    added: 'FIX.4.4',
    addedEP: '5',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Trade in a Clearing Hold',
  },
  {
    name: 'TradeHasBeenReleasedToClearing',
    id: '150019',
    value: 'K',
    sort: 19,
    added: 'FIX.4.4',
    addedEP: '5',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Trade has been released to Clearing',
  },
  {
    name: 'TriggeredOrActivatedBySystem',
    id: '150020',
    value: 'L',
    sort: 20,
    added: 'FIX.4.4',
    addedEP: '22',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Triggered or Activated by System',
  },
  {
    name: 'Locked',
    id: '150021',
    value: 'M',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Locked',
  },
  {
    name: 'Released',
    id: '150022',
    value: 'N',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 150,
    type: 'char',
    codeSet: 'ExecTypeCodeSet',
    description: 'Released',
  },
  {
    name: 'Multiply',
    id: '156001',
    value: 'M',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '38',
    tag: 156,
    type: 'char',
    codeSet: 'SettlCurrFxRateCalcCodeSet',
    description: 'Multiply',
  },
  {
    name: 'Divide',
    id: '156002',
    value: 'D',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '38',
    tag: 156,
    type: 'char',
    codeSet: 'SettlCurrFxRateCalcCodeSet',
    description: 'Divide',
  },
  {
    name: 'Default',
    id: '160001',
    value: '0',
    sort: 1,
    added: 'FIX.4.1',
    deprecated: 'FIX.Latest',
    deprecatedEP: '271',
    tag: 160,
    type: 'char',
    codeSet: 'SettlInstModeCodeSet',
    description: 'Default (Replaced)',
  },
  {
    name: 'StandingInstructionsProvided',
    id: '160002',
    value: '1',
    sort: 2,
    added: 'FIX.4.1',
    tag: 160,
    type: 'char',
    codeSet: 'SettlInstModeCodeSet',
    description: 'Standing Instructions Provided',
  },
  {
    name: 'SpecificAllocationAccountOverriding',
    id: '160003',
    value: '2',
    sort: 3,
    added: 'FIX.4.1',
    deprecated: 'FIX.Latest',
    deprecatedEP: '271',
    tag: 160,
    type: 'char',
    codeSet: 'SettlInstModeCodeSet',
    description: 'Specific Allocation Account Overriding (Replaced)',
  },
  {
    name: 'SpecificAllocationAccountStanding',
    id: '160004',
    value: '3',
    sort: 4,
    added: 'FIX.4.1',
    deprecated: 'FIX.Latest',
    deprecatedEP: '271',
    tag: 160,
    type: 'char',
    codeSet: 'SettlInstModeCodeSet',
    description: 'Specific Allocation Account Standing (Replaced)',
  },
  {
    name: 'SpecificOrderForASingleAccount',
    id: '160005',
    value: '4',
    sort: 5,
    added: 'FIX.4.3',
    tag: 160,
    type: 'char',
    codeSet: 'SettlInstModeCodeSet',
    description: 'Specific Order for a single account (for CIV)',
  },
  {
    name: 'RequestReject',
    id: '160006',
    value: '5',
    sort: 6,
    added: 'FIX.4.4',
    tag: 160,
    type: 'char',
    codeSet: 'SettlInstModeCodeSet',
    description: 'Request reject',
  },
  {
    name: 'New',
    id: '163001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.1',
    tag: 163,
    type: 'char',
    codeSet: 'SettlInstTransTypeCodeSet',
    description: 'New',
  },
  {
    name: 'Cancel',
    id: '163002',
    value: 'C',
    sort: 2,
    added: 'FIX.4.1',
    tag: 163,
    type: 'char',
    codeSet: 'SettlInstTransTypeCodeSet',
    description: 'Cancel',
  },
  {
    name: 'Replace',
    id: '163003',
    value: 'R',
    sort: 3,
    added: 'FIX.4.1',
    tag: 163,
    type: 'char',
    codeSet: 'SettlInstTransTypeCodeSet',
    description: 'Replace',
  },
  {
    name: 'Restate',
    id: '163004',
    value: 'T',
    sort: 4,
    added: 'FIX.4.4',
    tag: 163,
    type: 'char',
    codeSet: 'SettlInstTransTypeCodeSet',
    description: 'Restate',
  },
  {
    name: 'BrokerCredit',
    id: '165001',
    value: '1',
    sort: 1,
    added: 'FIX.4.1',
    tag: 165,
    type: 'char',
    codeSet: 'SettlInstSourceCodeSet',
    description: "Broker's Instructions",
  },
  {
    name: 'Institution',
    id: '165002',
    value: '2',
    sort: 2,
    added: 'FIX.4.1',
    tag: 165,
    type: 'char',
    codeSet: 'SettlInstSourceCodeSet',
    description: "Institution's Instructions",
  },
  {
    name: 'Investor',
    id: '165003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 165,
    type: 'char',
    codeSet: 'SettlInstSourceCodeSet',
    description: 'Investor (e.g. CIV use)',
  },
  {
    name: 'USTreasuryNoteOld',
    id: '167001',
    value: 'UST',
    sort: 3,
    added: 'FIX.4.3',
    deprecated: 'FIX.4.4',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'US Treasury Note (Deprecated Value Use TNOTE)',
  },
  {
    name: 'USTreasuryBillOld',
    id: '167002',
    value: 'USTB',
    sort: 4,
    added: 'FIX.4.1',
    deprecated: 'FIX.4.4',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'US Treasury Bill (Deprecated Value Use TBILL)',
  },
  {
    name: 'EuroSupranationalCoupons',
    id: '167003',
    value: 'EUSUPRA',
    sort: 0,
    group: 'Agency',
    added: 'FIX.4.4',
    updated: 'FIX.Latest',
    updatedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Euro Supranational Coupons\n\nIdentify the issuer name in Issuer(106).',
  },
  {
    name: 'FederalAgencyCoupon',
    id: '167004',
    value: 'FAC',
    sort: 1,
    group: 'Agency',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Federal Agency Coupon',
  },
  {
    name: 'FederalAgencyDiscountNote',
    id: '167005',
    value: 'FADN',
    sort: 2,
    group: 'Agency',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Federal Agency Discount Note',
  },
  {
    name: 'PrivateExportFunding',
    id: '167006',
    value: 'PEF',
    sort: 3,
    group: 'Agency',
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Private Export Funding\n\nIdentify the issuer name in Issuer(106).',
  },
  {
    name: 'USDSupranationalCoupons',
    id: '167007',
    value: 'SUPRA',
    sort: 4,
    group: 'Agency',
    added: 'FIX.4.4',
    updated: 'FIX.Latest',
    updatedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'USD Supranational Coupons\n\nIdentify the issuer name in Issuer(106).',
  },
  {
    name: 'CorporateBond',
    id: '167008',
    value: 'CORP',
    sort: 0,
    group: 'Corporate',
    added: 'FIX.4.1',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Corporate Bond',
  },
  {
    name: 'CorporatePrivatePlacement',
    id: '167009',
    value: 'CPP',
    sort: 1,
    group: 'Corporate',
    added: 'FIX.4.1',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Corporate Private Placement',
  },
  {
    name: 'ConvertibleBond',
    id: '167010',
    value: 'CB',
    sort: 2,
    group: 'Corporate',
    added: 'FIX.4.2',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Convertible Bond',
  },
  {
    name: 'DualCurrency',
    id: '167011',
    value: 'DUAL',
    sort: 3,
    group: 'Corporate',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Dual Currency',
  },
  {
    name: 'EuroCorporateBond',
    id: '167012',
    value: 'EUCORP',
    sort: 4,
    group: 'Corporate',
    added: 'FIX.4.4',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Euro Corporate Bond',
  },
  {
    name: 'EuroCorporateFloatingRateNotes',
    id: '167013',
    value: 'EUFRN',
    sort: 5,
    group: 'Corporate',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Euro Corporate Floating Rate Notes',
  },
  {
    name: 'USCorporateFloatingRateNotes',
    id: '167014',
    value: 'FRN',
    sort: 6,
    group: 'Corporate',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'US Corporate Floating Rate Notes',
  },
  {
    name: 'IndexedLinked',
    id: '167015',
    value: 'XLINKD',
    sort: 7,
    group: 'Corporate',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Indexed Linked',
  },
  {
    name: 'StructuredNotes',
    id: '167016',
    value: 'STRUCT',
    sort: 8,
    group: 'Corporate',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Structured Notes',
  },
  {
    name: 'YankeeCorporateBond',
    id: '167017',
    value: 'YANK',
    sort: 9,
    group: 'Corporate',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Yankee Corporate Bond',
  },
  {
    name: 'OffshoreIssuedChineseYuanCorporateBond',
    id: '167018',
    value: 'DIMSUMCORP',
    sort: 10,
    group: 'Corporate',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Offshore issued Chinese Yuan (CNY) denominated corporate bond',
  },
  {
    name: 'PreferredCorporateBond',
    id: '167019',
    value: 'PRCORP',
    sort: 11,
    group: 'Corporate',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Preferred Corporate Bond',
  },
  {
    name: 'ForeignExchangeContract',
    id: '167020',
    value: 'FOR',
    sort: 0,
    group: 'Currency',
    added: 'FIX.4.1',
    deprecated: 'FIX.5.0SP1',
    deprecatedEP: '82',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Foreign Exchange Contract',
  },
  {
    name: 'NonDeliverableForward',
    id: '167021',
    value: 'FXNDF',
    sort: 1,
    group: 'Currency',
    added: 'FIX.5.0SP1',
    addedEP: '82',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Non-deliverable forward',
  },
  {
    name: 'FXSpot',
    id: '167022',
    value: 'FXSPOT',
    sort: 2,
    group: 'Currency',
    added: 'FIX.5.0SP1',
    addedEP: '82',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'FX Spot',
  },
  {
    name: 'FXForward',
    id: '167023',
    value: 'FXFWD',
    sort: 3,
    group: 'Currency',
    added: 'FIX.5.0SP1',
    addedEP: '82',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'FX Forward',
  },
  {
    name: 'FXSwap',
    id: '167024',
    value: 'FXSWAP',
    sort: 4,
    group: 'Currency',
    added: 'FIX.5.0SP1',
    addedEP: '82',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'FX Swap',
  },
  {
    name: 'NonDeliverableSwap',
    id: '167025',
    value: 'FXNDS',
    sort: 5,
    group: 'Currency',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Non-deliverable Swap',
  },
  {
    name: 'FXBankNote',
    id: '167026',
    value: 'FXBN',
    sort: 6,
    group: 'Currency',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'FX Bank Note',
  },
  {
    name: 'ForeignCurrencyDiscountNote',
    id: '167027',
    value: 'FXDN',
    sort: 7,
    group: 'Currency',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description:
      'Foreign Currency Discount Note\n\nDiscount notes issued in foreign currency by Fannie Mae.',
  },
  {
    name: 'Cap',
    id: '167028',
    value: 'CAP',
    sort: 1,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description:
      'Cap\n\nIn an interest rate cap, the buyer receives payments at the end of each period in which the rate indec exceeds the agreed strike rate.',
  },
  {
    name: 'CreditDefaultSwap',
    id: '167029',
    value: 'CDS',
    sort: 2,
    group: 'Derivatives',
    added: 'FIX.5.0',
    addedEP: '68',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Credit Default Swap',
  },
  {
    name: 'Collar',
    id: '167030',
    value: 'CLLR',
    sort: 3,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description:
      'Collar\n\nIn an interest rate collar, this is a combination of a cap and a floor.',
  },
  {
    name: 'CommoditySwap',
    id: '167031',
    value: 'CMDTYSWAP',
    sort: 4,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '140',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Commodity swap',
  },
  {
    name: 'Exotic',
    id: '167032',
    value: 'EXOTIC',
    sort: 5,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Exotic',
  },
  {
    name: 'OptionsOnCombo',
    id: '167033',
    value: 'OOC',
    sort: 6,
    group: 'Derivatives',
    added: 'FIX.5.0',
    addedEP: '-1',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Options on Combo',
  },
  {
    name: 'Floor',
    id: '167034',
    value: 'FLR',
    sort: 6,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description:
      'Floor\n\nIn an interest rate floor, the buyer receives payments at the end of each period in which the rate index is below the agreed strike rate.',
  },
  {
    name: 'FRA',
    id: '167035',
    value: 'FRA',
    sort: 7,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Forward Rate Agreement',
  },
  {
    name: 'Future',
    id: '167036',
    value: 'FUT',
    sort: 8,
    group: 'Derivatives',
    added: 'FIX.4.1',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Future',
  },
  {
    name: 'DerivativeForward',
    id: '167037',
    value: 'FWD',
    sort: 9,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Derivative forward',
  },
  {
    name: 'InterestRateSwap',
    id: '167038',
    value: 'IRS',
    sort: 10,
    group: 'Derivatives',
    added: 'FIX.5.0',
    addedEP: '54',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Interest Rate Swap',
  },
  {
    name: 'TotalReturnSwap',
    id: '167039',
    value: 'TRS',
    sort: 10,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Total return swap',
  },
  {
    name: 'LoanLease',
    id: '167040',
    value: 'LOANLEASE',
    sort: 11,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Loan/lease',
  },
  {
    name: 'OptionsOnFutures',
    id: '167041',
    value: 'OOF',
    sort: 13,
    group: 'Derivatives',
    added: 'FIX.4.4',
    addedEP: '19',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Options on Futures',
  },
  {
    name: 'OptionsOnPhysical',
    id: '167042',
    value: 'OOP',
    sort: 14,
    group: 'Derivatives',
    added: 'FIX.4.4',
    addedEP: '19',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Options on Physical - use not recommended',
  },
  {
    name: 'Option',
    id: '167043',
    value: 'OPT',
    sort: 15,
    group: 'Derivatives',
    added: 'FIX.4.1',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Option',
  },
  {
    name: 'SpotForward',
    id: '167044',
    value: 'SPOTFWD',
    sort: 16,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Spot forward',
  },
  {
    name: 'SwapOption',
    id: '167045',
    value: 'SWAPTION',
    sort: 17,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '140',
    updated: 'FIX.5.0SP2',
    updatedEP: '187',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Swap option',
  },
  {
    name: 'Transmission',
    id: '167046',
    value: 'XMISSION',
    sort: 18,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Transmission',
  },
  {
    name: 'Index',
    id: '167047',
    value: 'INDEX',
    sort: 19,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'General type for a contract based on an established index',
  },
  {
    name: 'BondBasket',
    id: '167048',
    value: 'BDBSKT',
    sort: 20,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Bond basket',
  },
  {
    name: 'ContractForDifference',
    id: '167049',
    value: 'CFD',
    sort: 21,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Contract for difference',
  },
  {
    name: 'CorrelationSwap',
    id: '167050',
    value: 'CRLTNSWAP',
    sort: 22,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Correlation swap',
  },
  {
    name: 'DiviendSwap',
    id: '167051',
    value: 'DVDNDSWAP',
    sort: 23,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Dividend swap',
  },
  {
    name: 'EquityBasket',
    id: '167052',
    value: 'EQBSKT',
    sort: 24,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Equity basket',
  },
  {
    name: 'EquityForward',
    id: '167053',
    value: 'EQFWD',
    sort: 25,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Equity forward',
  },
  {
    name: 'ReturnSwap',
    id: '167054',
    value: 'RTRNSWAP',
    sort: 26,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Return swap',
  },
  {
    name: 'VarianceSwap',
    id: '167055',
    value: 'VARSWAP',
    sort: 27,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Variance swap',
  },
  {
    name: 'PortfolioSwaps',
    id: '167056',
    value: 'PRTFLIOSWAP',
    sort: 28,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    updated: 'FIX.5.0SP2',
    updatedEP: '238',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Portfolio swap',
  },
  {
    name: 'FuturesOnASwap',
    id: '167057',
    value: 'FUTSWAP',
    sort: 29,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Futures on a Swap',
  },
  {
    name: 'ForwardsOnASwap',
    id: '167058',
    value: 'FWDSWAP',
    sort: 30,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Forwards on a Swap',
  },
  {
    name: 'ForwardFreightAgreement',
    id: '167059',
    value: 'FWDFRTAGMT',
    sort: 31,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Forward Freight Agreement',
  },
  {
    name: 'SpreadBetting',
    id: '167060',
    value: 'SPREADBET',
    sort: 32,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Spread Betting',
  },
  {
    name: 'ExchangeTradedCommodity',
    id: '167061',
    value: 'ETC',
    sort: 33,
    group: 'Derivatives',
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Exchange traded commodity',
  },
  {
    name: 'CommonStock',
    id: '167062',
    value: 'CS',
    sort: 0,
    group: 'Equity',
    added: 'FIX.4.1',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Common Stock',
  },
  {
    name: 'PreferredStock',
    id: '167063',
    value: 'PS',
    sort: 1,
    group: 'Equity',
    added: 'FIX.4.1',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Preferred Stock',
  },
  {
    name: 'DepositoryReceipts',
    id: '167064',
    value: 'DR',
    sort: 2,
    group: 'Equity',
    added: 'FIX.5.0SP2',
    addedEP: '236',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Depository Receipts',
  },
  {
    name: 'Repurchase',
    id: '167065',
    value: 'REPO',
    sort: 0,
    group: 'Financing',
    added: 'FIX.4.4',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Repurchase',
  },
  {
    name: 'Forward',
    id: '167066',
    value: 'FORWARD',
    sort: 1,
    group: 'Financing',
    added: 'FIX.4.4',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Forward',
  },
  {
    name: 'BuySellback',
    id: '167067',
    value: 'BUYSELL',
    sort: 2,
    group: 'Financing',
    added: 'FIX.4.4',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Buy Sellback',
  },
  {
    name: 'SecuritiesLoan',
    id: '167068',
    value: 'SECLOAN',
    sort: 3,
    group: 'Financing',
    added: 'FIX.4.4',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Securities Loan',
  },
  {
    name: 'SecuritiesPledge',
    id: '167069',
    value: 'SECPLEDGE',
    sort: 4,
    group: 'Financing',
    added: 'FIX.4.4',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Securities Pledge',
  },
  {
    name: 'DeliveryVersusPledge',
    id: '167070',
    value: 'DVPLDG',
    sort: 5,
    group: 'Financing',
    added: 'FIX.5.0SP2',
    addedEP: '132',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Delivery versus pledge',
  },
  {
    name: 'CollateralBasket',
    id: '167071',
    value: 'COLLBSKT',
    sort: 6,
    group: 'Financing',
    added: 'FIX.5.0SP2',
    addedEP: '197',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description:
      "Collateral basket\n\nA collection of securities held as collateral in the customer's collateral fund. The collateral fund is usually managed by a custodian.",
  },
  {
    name: 'StructuredFinanceProduct',
    id: '167072',
    value: 'SFP',
    sort: 7,
    group: 'Financing',
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Structured finance product',
  },
  {
    name: 'MarginLoan',
    id: '167073',
    value: 'MRGNLOAN',
    sort: 9,
    group: 'Financing',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Margin loan',
  },
  {
    name: 'BradyBond',
    id: '167074',
    value: 'BRADY',
    sort: 0,
    group: 'Government',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Brady Bond',
  },
  {
    name: 'CanadianTreasuryNotes',
    id: '167075',
    value: 'CAN',
    sort: 1,
    group: 'Government',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Canadian Treasury Notes',
  },
  {
    name: 'CanadianTreasuryBills',
    id: '167076',
    value: 'CTB',
    sort: 2,
    group: 'Government',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Canadian Treasury Bills',
  },
  {
    name: 'EuroSovereigns',
    id: '167077',
    value: 'EUSOV',
    sort: 3,
    group: 'Government',
    added: 'FIX.4.4',
    updated: 'FIX.Latest',
    updatedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Euro Sovereigns\n\nIdentify the issuer name in Issuer(106).',
  },
  {
    name: 'CanadianProvincialBonds',
    id: '167078',
    value: 'PROV',
    sort: 4,
    group: 'Government',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Canadian Provincial Bonds',
  },
  {
    name: 'TreasuryBill',
    id: '167079',
    value: 'TB',
    sort: 5,
    group: 'Government',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Treasury Bill - non US',
  },
  {
    name: 'USTreasuryBond',
    id: '167080',
    value: 'TBOND',
    sort: 6,
    group: 'Government',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'US Treasury Bond',
  },
  {
    name: 'InterestStripFromAnyBondOrNote',
    id: '167081',
    value: 'TINT',
    sort: 7,
    group: 'Government',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Interest Strip From Any Bond Or Note',
  },
  {
    name: 'USTreasuryBill',
    id: '167082',
    value: 'TBILL',
    sort: 8,
    group: 'Government',
    added: 'FIX.4.4',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'US Treasury Bill',
  },
  {
    name: 'TreasuryInflationProtectedSecurities',
    id: '167083',
    value: 'TIPS',
    sort: 8,
    group: 'Government',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Treasury Inflation Protected Securities',
  },
  {
    name: 'PrincipalStripOfACallableBondOrNote',
    id: '167084',
    value: 'TCAL',
    sort: 9,
    group: 'Government',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Principal Strip Of A Callable Bond Or Note',
  },
  {
    name: 'PrincipalStripFromANonCallableBondOrNote',
    id: '167085',
    value: 'TPRN',
    sort: 10,
    group: 'Government',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Principal Strip From A Non-Callable Bond Or Note',
  },
  {
    name: 'USTreasuryNote',
    id: '167086',
    value: 'TNOTE',
    sort: 11,
    group: 'Government',
    added: 'FIX.4.4',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'US Treasury Note',
  },
  {
    name: 'OffshoreIssuedChineseYuanSovereignBond',
    id: '167087',
    value: 'DIMSUMSOV',
    sort: 12,
    group: 'Government',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Offshore issued Chinese Yuan (CNY) denominated sovereign bond',
  },
  {
    name: 'SovereignBond',
    id: '167088',
    value: 'SOV',
    sort: 13,
    group: 'Government',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description:
      'Sovereign Bond\n\nSovereign or government bond other than Euro and US issuer. Specify sovereign issuer in Issuer(106).',
  },
  {
    name: 'USTreasuryFloatingRateNote',
    id: '167089',
    value: 'TFRN',
    sort: 14,
    group: 'Government',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'US Treasury Floating Rate Note',
  },
  {
    name: 'TermLoan',
    id: '167090',
    value: 'TERM',
    sort: 0,
    group: 'Loan',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Term Loan',
  },
  {
    name: 'RevolverLoan',
    id: '167091',
    value: 'RVLV',
    sort: 1,
    group: 'Loan',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Revolver Loan',
  },
  {
    name: 'Revolver',
    id: '167092',
    value: 'RVLVTRM',
    sort: 2,
    group: 'Loan',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Revolver/Term Loan',
  },
  {
    name: 'BridgeLoan',
    id: '167093',
    value: 'BRIDGE',
    sort: 3,
    group: 'Loan',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Bridge Loan',
  },
  {
    name: 'LetterOfCredit',
    id: '167094',
    value: 'LOFC',
    sort: 4,
    group: 'Loan',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Letter Of Credit',
  },
  {
    name: 'SwingLineFacility',
    id: '167095',
    value: 'SWING',
    sort: 5,
    group: 'Loan',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Swing Line Facility',
  },
  {
    name: 'DebtorInPossession',
    id: '167096',
    value: 'DINP',
    sort: 6,
    group: 'Loan',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Debtor In Possession',
  },
  {
    name: 'Defaulted',
    id: '167097',
    value: 'DEFLTED',
    sort: 7,
    group: 'Loan',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Defaulted',
  },
  {
    name: 'Withdrawn',
    id: '167098',
    value: 'WITHDRN',
    sort: 8,
    group: 'Loan',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Withdrawn',
  },
  {
    name: 'Replaced',
    id: '167099',
    value: 'REPLACD',
    sort: 9,
    group: 'Loan',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Replaced',
  },
  {
    name: 'Matured',
    id: '167100',
    value: 'MATURED',
    sort: 10,
    group: 'Loan',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Matured',
  },
  {
    name: 'Amended',
    id: '167101',
    value: 'AMENDED',
    sort: 11,
    group: 'Loan',
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Amended and restated',
  },
  {
    name: 'Retired',
    id: '167102',
    value: 'RETIRED',
    sort: 12,
    group: 'Loan',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Retired',
  },
  {
    name: 'BankersAcceptance',
    id: '167103',
    value: 'BA',
    sort: 0,
    group: 'Money Market',
    added: 'FIX.4.1',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Bankers Acceptance',
  },
  {
    name: 'BankDepositoryNote',
    id: '167104',
    value: 'BDN',
    sort: 1,
    group: 'Money Market',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Bank Depository Note',
  },
  {
    name: 'BankNotes',
    id: '167105',
    value: 'BN',
    sort: 2,
    group: 'Money Market',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Bank Notes',
  },
  {
    name: 'BillOfExchanges',
    id: '167106',
    value: 'BOX',
    sort: 3,
    group: 'Money Market',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Bill Of Exchanges',
  },
  {
    name: 'CanadianMoneyMarkets',
    id: '167107',
    value: 'CAMM',
    sort: 4,
    group: 'Money Market',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Canadian Money Markets',
  },
  {
    name: 'CertificateOfDeposit',
    id: '167108',
    value: 'CD',
    sort: 5,
    group: 'Money Market',
    added: 'FIX.4.1',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Certificate Of Deposit',
  },
  {
    name: 'CallLoans',
    id: '167109',
    value: 'CL',
    sort: 6,
    group: 'Money Market',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Call Loans',
  },
  {
    name: 'CommercialPaper',
    id: '167110',
    value: 'CP',
    sort: 7,
    group: 'Money Market',
    added: 'FIX.4.1',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Commercial Paper',
  },
  {
    name: 'DepositNotes',
    id: '167111',
    value: 'DN',
    sort: 8,
    group: 'Money Market',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Deposit Notes',
  },
  {
    name: 'EuroCertificateOfDeposit',
    id: '167112',
    value: 'EUCD',
    sort: 9,
    group: 'Money Market',
    added: 'FIX.4.4',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Euro Certificate Of Deposit',
  },
  {
    name: 'EuroCommercialPaper',
    id: '167113',
    value: 'EUCP',
    sort: 10,
    group: 'Money Market',
    added: 'FIX.4.4',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Euro Commercial Paper',
  },
  {
    name: 'LiquidityNote',
    id: '167114',
    value: 'LQN',
    sort: 11,
    group: 'Money Market',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Liquidity Note',
  },
  {
    name: 'MediumTermNotes',
    id: '167115',
    value: 'MTN',
    sort: 12,
    group: 'Money Market',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Medium Term Notes',
  },
  {
    name: 'Overnight',
    id: '167116',
    value: 'ONITE',
    sort: 13,
    group: 'Money Market',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Overnight',
  },
  {
    name: 'PromissoryNote',
    id: '167117',
    value: 'PN',
    sort: 14,
    group: 'Money Market',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Promissory Note',
  },
  {
    name: 'ShortTermLoanNote',
    id: '167118',
    value: 'STN',
    sort: 14,
    group: 'Money Market',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Short Term Loan Note',
  },
  {
    name: 'PlazosFijos',
    id: '167119',
    value: 'PZFJ',
    sort: 15,
    group: 'Money Market',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Plazos Fijos',
  },
  {
    name: 'SecuredLiquidityNote',
    id: '167120',
    value: 'SLQN',
    sort: 16,
    group: 'Money Market',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Secured Liquidity Note',
  },
  {
    name: 'TimeDeposit',
    id: '167121',
    value: 'TD',
    sort: 17,
    group: 'Money Market',
    added: 'FIX.4.1',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Time Deposit',
  },
  {
    name: 'TermLiquidityNote',
    id: '167122',
    value: 'TLQN',
    sort: 19,
    group: 'Money Market',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Term Liquidity Note',
  },
  {
    name: 'ExtendedCommNote',
    id: '167123',
    value: 'XCN',
    sort: 20,
    group: 'Money Market',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Extended Comm Note',
  },
  {
    name: 'YankeeCertificateOfDeposit',
    id: '167124',
    value: 'YCD',
    sort: 21,
    group: 'Money Market',
    added: 'FIX.4.4',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Yankee Certificate Of Deposit',
  },
  {
    name: 'BankAcceptedBill',
    id: '167125',
    value: 'BAB',
    sort: 22,
    group: 'Money Market',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Bank Accepted Bill\n\nAlso known as Bank Bill.',
  },
  {
    name: 'ShortTermBankNote',
    id: '167126',
    value: 'BNST',
    sort: 23,
    group: 'Money Market',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Short Term Bank Note',
  },
  {
    name: 'CallableCommercialPaper',
    id: '167127',
    value: 'CLCP',
    sort: 24,
    group: 'Money Market',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Callable Commercial Paper',
  },
  {
    name: 'CommercialNote',
    id: '167128',
    value: 'CN',
    sort: 25,
    group: 'Money Market',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Commercial Note',
  },
  {
    name: 'InterestBearingCommercialPaper',
    id: '167129',
    value: 'CPIB',
    sort: 26,
    group: 'Money Market',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Interest Bearing Commercial Paper',
  },
  {
    name: 'EuroMediumTermNote',
    id: '167130',
    value: 'EUMTN',
    sort: 27,
    group: 'Money Market',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Euro Medium Term Note',
  },
  {
    name: 'EuroNegotiableCommercialPaper',
    id: '167131',
    value: 'EUNCP',
    sort: 28,
    group: 'Money Market',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Euro Negotiable Commercial Paper',
  },
  {
    name: 'EuroStructuredLiquidityNote',
    id: '167132',
    value: 'EUSTLQN',
    sort: 29,
    group: 'Money Market',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Euro Structured Liquidity Note',
  },
  {
    name: 'EuroTimeDeposit',
    id: '167133',
    value: 'EUTD',
    sort: 30,
    group: 'Money Market',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Euro Time Deposit',
  },
  {
    name: 'JumboCertificateOfDeposit',
    id: '167134',
    value: 'JCD',
    sort: 31,
    group: 'Money Market',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Jumbo Certificate of Deposit',
  },
  {
    name: 'MoneyMarketFund',
    id: '167135',
    value: 'MMF',
    sort: 32,
    group: 'Money Market',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Money Market Fund',
  },
  {
    name: 'MasterNote',
    id: '167136',
    value: 'MN',
    sort: 33,
    group: 'Money Market',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description:
      'Master Note\n\nShort term notes issued by Federal Farm Credit Banks Funding Corporation to provide loans and funding under Federal Farm Credit System (FFCS).',
  },
  {
    name: 'NegotiableCertificateOfDeposit',
    id: '167137',
    value: 'NCD',
    sort: 34,
    group: 'Money Market',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Negotiable Certificate of Deposit',
  },
  {
    name: 'NegotiableCommercialPaper',
    id: '167138',
    value: 'NCP',
    sort: 35,
    group: 'Money Market',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Negotiable Commercial Paper',
  },
  {
    name: 'RetailCertificateOfDeposit',
    id: '167139',
    value: 'RCD',
    sort: 36,
    group: 'Money Market',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Retail Certificate of Deposit',
  },
  {
    name: 'TermDepositReceipt',
    id: '167140',
    value: 'TDR',
    sort: 37,
    group: 'Money Market',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Term Deposit Receipt',
  },
  {
    name: 'AssetBackedSecurities',
    id: '167141',
    value: 'ABS',
    sort: 0,
    group: 'Mortgage',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Asset-backed Securities',
  },
  {
    name: 'CanadianMortgageBonds',
    id: '167142',
    value: 'CMB',
    sort: 1,
    group: 'Mortgage',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Canadian Mortgage Bonds',
  },
  {
    name: 'Corp',
    id: '167143',
    value: 'CMBS',
    sort: 2,
    group: 'Mortgage',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Corp. Mortgage-backed Securities',
  },
  {
    name: 'CollateralizedMortgageObligation',
    id: '167144',
    value: 'CMO',
    sort: 3,
    group: 'Mortgage',
    added: 'FIX.4.1',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Collateralized Mortgage Obligation',
  },
  {
    name: 'IOETTEMortgage',
    id: '167145',
    value: 'IET',
    sort: 4,
    group: 'Mortgage',
    added: 'FIX.4.2',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'IOETTE Mortgage',
  },
  {
    name: 'MortgageBackedSecurities',
    id: '167146',
    value: 'MBS',
    sort: 5,
    group: 'Mortgage',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Mortgage-backed Securities',
  },
  {
    name: 'MortgageInterestOnly',
    id: '167147',
    value: 'MIO',
    sort: 6,
    group: 'Mortgage',
    added: 'FIX.4.1',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Mortgage Interest Only',
  },
  {
    name: 'MortgagePrincipalOnly',
    id: '167148',
    value: 'MPO',
    sort: 7,
    group: 'Mortgage',
    added: 'FIX.4.1',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Mortgage Principal Only',
  },
  {
    name: 'MortgagePrivatePlacement',
    id: '167149',
    value: 'MPP',
    sort: 8,
    group: 'Mortgage',
    added: 'FIX.4.1',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Mortgage Private Placement',
  },
  {
    name: 'MiscellaneousPassThrough',
    id: '167150',
    value: 'MPT',
    sort: 9,
    group: 'Mortgage',
    added: 'FIX.4.1',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Miscellaneous Pass-through',
  },
  {
    name: 'Pfandbrief',
    id: '167151',
    value: 'PFAND',
    sort: 10,
    group: 'Mortgage',
    added: 'FIX.4.4',
    updated: 'FIX.Latest',
    updatedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Pfandbrief\n\nIdentify the issuer name in Issuer(106).',
  },
  {
    name: 'ToBeAnnounced',
    id: '167152',
    value: 'TBA',
    sort: 11,
    group: 'Mortgage',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'To Be Announced',
  },
  {
    name: 'OtherAnticipationNotes',
    id: '167153',
    value: 'AN',
    sort: 0,
    group: 'Municipal',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Other Anticipation Notes (BAN, GAN, etc.)',
  },
  {
    name: 'CertificateOfObligation',
    id: '167154',
    value: 'COFO',
    sort: 1,
    group: 'Municipal',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Certificate Of Obligation',
  },
  {
    name: 'CertificateOfParticipation',
    id: '167155',
    value: 'COFP',
    sort: 2,
    group: 'Municipal',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Certificate Of Participation',
  },
  {
    name: 'GeneralObligationBonds',
    id: '167156',
    value: 'GO',
    sort: 3,
    group: 'Municipal',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'General Obligation Bonds',
  },
  {
    name: 'MandatoryTender',
    id: '167157',
    value: 'MT',
    sort: 4,
    group: 'Municipal',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Mandatory Tender',
  },
  {
    name: 'RevenueAnticipationNote',
    id: '167158',
    value: 'RAN',
    sort: 5,
    group: 'Municipal',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Revenue Anticipation Note',
  },
  {
    name: 'RevenueBonds',
    id: '167159',
    value: 'REV',
    sort: 6,
    group: 'Municipal',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Revenue Bonds',
  },
  {
    name: 'SpecialAssessment',
    id: '167160',
    value: 'SPCLA',
    sort: 7,
    group: 'Municipal',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Special Assessment',
  },
  {
    name: 'SpecialObligation',
    id: '167161',
    value: 'SPCLO',
    sort: 8,
    group: 'Municipal',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Special Obligation',
  },
  {
    name: 'SpecialTax',
    id: '167162',
    value: 'SPCLT',
    sort: 9,
    group: 'Municipal',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Special Tax',
  },
  {
    name: 'TaxAnticipationNote',
    id: '167163',
    value: 'TAN',
    sort: 10,
    group: 'Municipal',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Tax Anticipation Note',
  },
  {
    name: 'TaxAllocation',
    id: '167164',
    value: 'TAXA',
    sort: 11,
    group: 'Municipal',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Tax Allocation',
  },
  {
    name: 'TaxExemptCommercialPaper',
    id: '167165',
    value: 'TECP',
    sort: 12,
    group: 'Municipal',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Tax Exempt Commercial Paper',
  },
  {
    name: 'TaxableMunicipalCP',
    id: '167166',
    value: 'TMCP',
    sort: 13,
    group: 'Municipal',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Taxable Municipal CP',
  },
  {
    name: 'TaxRevenueAnticipationNote',
    id: '167167',
    value: 'TRAN',
    sort: 14,
    group: 'Municipal',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Tax Revenue Anticipation Note',
  },
  {
    name: 'VariableRateDemandNote',
    id: '167168',
    value: 'VRDN',
    sort: 15,
    group: 'Municipal',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Variable Rate Demand Note',
  },
  {
    name: 'Warrant',
    id: '167169',
    value: 'WAR',
    sort: 16,
    group: 'Municipal',
    added: 'FIX.4.1',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Warrant',
  },
  {
    name: 'MunicipalInterestBearingCommercialPaper',
    id: '167170',
    value: 'MCPIB',
    sort: 17,
    group: 'Municipal',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Municipal Interest Bearing Commercial Paper',
  },
  {
    name: 'TaxableMunicipalBond',
    id: '167171',
    value: 'TMB',
    sort: 18,
    group: 'Municipal',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Taxable Municipal Bond',
  },
  {
    name: 'VariableRateDemandObligation',
    id: '167172',
    value: 'VRDO',
    sort: 19,
    group: 'Municipal',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Variable Rate Demand Obligation',
  },
  {
    name: 'MutualFund',
    id: '167173',
    value: 'MF',
    sort: 0,
    group: 'Other',
    added: 'FIX.4.1',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Mutual Fund',
  },
  {
    name: 'MultilegInstrument',
    id: '167174',
    value: 'MLEG',
    sort: 1,
    group: 'Other',
    added: 'FIX.4.3',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Multileg Instrument',
  },
  {
    name: 'NoSecurityType',
    id: '167175',
    value: 'NONE',
    sort: 2,
    group: 'Other',
    added: 'FIX.4.1',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'No Security Type',
  },
  {
    name: 'Wildcard',
    id: '167176',
    value: '?',
    sort: 5,
    group: 'Other',
    added: 'FIX.4.2',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Wildcard entry for use on Security Definition Request',
  },
  {
    name: 'Cash',
    id: '167177',
    value: 'CASH',
    sort: 6,
    group: 'Other',
    added: 'FIX.4.4',
    addedEP: '28',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Cash',
  },
  {
    name: 'Other',
    id: '167178',
    value: 'Other',
    sort: 7,
    group: 'Other',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Other',
  },
  {
    name: 'ExchangeTradedNote',
    id: '167179',
    value: 'ETN',
    sort: 8,
    group: 'Other',
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Exchange traded note',
  },
  {
    name: 'SecuritizedDerivative',
    id: '167180',
    value: 'SECDERIV',
    sort: 10,
    group: 'Other',
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Securitized derivative',
  },
  {
    name: 'ExchangeTradedFund',
    id: '167181',
    value: 'ETF',
    sort: 11,
    group: 'Other',
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description: 'Exchange Traded Fund',
  },
  {
    name: 'DigitalAsset',
    id: '167182',
    value: 'DIGITAL',
    sort: 12,
    group: 'Other',
    added: 'FIX.Latest',
    addedEP: '273',
    tag: 167,
    type: 'String',
    codeSet: 'SecurityTypeCodeSet',
    description:
      'Digital Asset\n\nAsset that exists only in digital form or which is the digital representation of another asset (Source: ISO 24165 - Terms and Definitions).',
  },
  {
    name: 'Other',
    id: '169001',
    value: '0',
    sort: 1,
    added: 'FIX.4.1',
    tag: 169,
    type: 'int',
    codeSet: 'StandInstDbTypeCodeSet',
    description: 'Other',
  },
  {
    name: 'DTCSID',
    id: '169002',
    value: '1',
    sort: 2,
    added: 'FIX.4.1',
    tag: 169,
    type: 'int',
    codeSet: 'StandInstDbTypeCodeSet',
    description: 'DTC SID',
  },
  {
    name: 'ThomsonALERT',
    id: '169003',
    value: '2',
    sort: 3,
    added: 'FIX.4.1',
    tag: 169,
    type: 'int',
    codeSet: 'StandInstDbTypeCodeSet',
    description: 'Thomson ALERT',
  },
  {
    name: 'AGlobalCustodian',
    id: '169004',
    value: '3',
    sort: 4,
    added: 'FIX.4.1',
    tag: 169,
    type: 'int',
    codeSet: 'StandInstDbTypeCodeSet',
    description: 'A Global Custodian (StandInstDBName (70) must be provided)',
  },
  {
    name: 'AccountNet',
    id: '169005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    tag: 169,
    type: 'int',
    codeSet: 'StandInstDbTypeCodeSet',
    description: 'AccountNet',
  },
  {
    name: 'Versus',
    id: '172001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '35',
    tag: 172,
    type: 'int',
    codeSet: 'SettlDeliveryTypeCodeSet',
    description:
      '"Versus. Payment": Deliver (if Sell) or Receive (if Buy) vs. (Against) Payment',
  },
  {
    name: 'Free',
    id: '172002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '35',
    tag: 172,
    type: 'int',
    codeSet: 'SettlDeliveryTypeCodeSet',
    description: '"Free": Deliver (if Sell) or Receive (if Buy) Free',
  },
  {
    name: 'TriParty',
    id: '172003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '35',
    tag: 172,
    type: 'int',
    codeSet: 'SettlDeliveryTypeCodeSet',
    description: 'Tri-Party',
  },
  {
    name: 'HoldInCustody',
    id: '172004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '35',
    tag: 172,
    type: 'int',
    codeSet: 'SettlDeliveryTypeCodeSet',
    description: 'Hold In Custody',
  },
  {
    name: 'FXNetting',
    id: '197001',
    value: '0',
    sort: 1,
    added: 'FIX.4.1',
    tag: 197,
    type: 'int',
    codeSet: 'AllocLinkTypeCodeSet',
    description: 'FX Netting',
  },
  {
    name: 'FXSwap',
    id: '197002',
    value: '1',
    sort: 2,
    added: 'FIX.4.1',
    tag: 197,
    type: 'int',
    codeSet: 'AllocLinkTypeCodeSet',
    description: 'FX Swap',
  },
  {
    name: 'Put',
    id: '201001',
    value: '0',
    sort: 1,
    added: 'FIX.4.1',
    updated: 'FIX.5.0SP2',
    updatedEP: '238',
    tag: 201,
    type: 'int',
    codeSet: 'PutOrCallCodeSet',
    description:
      'Put\n\nAlso used for the case in which the buyer of a Swaption has the right to enter into an IRS contract as a fixed-rate receiver or into a CDS contract as a seller of protection or for the case of a Floor.',
  },
  {
    name: 'Call',
    id: '201002',
    value: '1',
    sort: 2,
    added: 'FIX.4.1',
    updated: 'FIX.5.0SP2',
    updatedEP: '238',
    tag: 201,
    type: 'int',
    codeSet: 'PutOrCallCodeSet',
    description:
      'Call\n\nAlso used for the case in which the buyer of a Swaption has the right to enter into an IRS contract as a fixed-rate payer or into a CDS contract as a buyer of protection or for the case of a Cap.',
  },
  {
    name: 'Other',
    id: '201003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '232',
    tag: 201,
    type: 'int',
    codeSet: 'PutOrCallCodeSet',
    description:
      'Other\n\nIn the context of ESMA RTS 22 reporting, this value may be used when, at the time of execution, the option right cannot be determined.',
  },
  {
    name: 'Chooser',
    id: '201004',
    value: '3',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 201,
    type: 'int',
    codeSet: 'PutOrCallCodeSet',
    description:
      'Chooser\n\nIndicates that the option buyer may choose to buy or sell the underlying security on exercise or if a Swaption to pay or receive the underlying IRS cash flow stream or to buy or sell CDS protection.',
  },
  {
    name: 'Covered',
    id: '203001',
    value: '0',
    sort: 1,
    added: 'FIX.4.1',
    tag: 203,
    type: 'int',
    codeSet: 'CoveredOrUncoveredCodeSet',
    description: 'Covered',
  },
  {
    name: 'Uncovered',
    id: '203002',
    value: '1',
    sort: 2,
    added: 'FIX.4.1',
    tag: 203,
    type: 'int',
    codeSet: 'CoveredOrUncoveredCodeSet',
    description: 'Uncovered',
  },
  {
    name: 'DetailsShouldNotBeCommunicated',
    id: '208001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.1',
    tag: 208,
    type: 'Boolean',
    codeSet: 'NotifyBrokerOfCreditCodeSet',
    description: 'Details should not be communicated',
  },
  {
    name: 'DetailsShouldBeCommunicated',
    id: '208002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.1',
    tag: 208,
    type: 'Boolean',
    codeSet: 'NotifyBrokerOfCreditCodeSet',
    description: 'Details should be communicated',
  },
  {
    name: 'Match',
    id: '209001',
    value: '1',
    sort: 1,
    added: 'FIX.4.1',
    tag: 209,
    type: 'int',
    codeSet: 'AllocHandlInstCodeSet',
    description: 'Match',
  },
  {
    name: 'Forward',
    id: '209002',
    value: '2',
    sort: 2,
    added: 'FIX.4.1',
    tag: 209,
    type: 'int',
    codeSet: 'AllocHandlInstCodeSet',
    description: 'Forward',
  },
  {
    name: 'ForwardAndMatch',
    id: '209003',
    value: '3',
    sort: 3,
    added: 'FIX.4.1',
    tag: 209,
    type: 'int',
    codeSet: 'AllocHandlInstCodeSet',
    description: 'Forward and Match',
  },
  {
    name: 'AutoClaimGiveUp',
    id: '209004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '245',
    tag: 209,
    type: 'int',
    codeSet: 'AllocHandlInstCodeSet',
    description:
      'Auto claim give-up\n\nIndicates that the give-up and take-up party are the same and that trade give-up is to be claimed automatically.',
  },
  {
    name: 'TargetFirm',
    id: '216001',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    tag: 216,
    type: 'int',
    codeSet: 'RoutingTypeCodeSet',
    description: 'Target Firm',
  },
  {
    name: 'TargetList',
    id: '216002',
    value: '2',
    sort: 2,
    added: 'FIX.4.2',
    tag: 216,
    type: 'int',
    codeSet: 'RoutingTypeCodeSet',
    description: 'Target List',
  },
  {
    name: 'BlockFirm',
    id: '216003',
    value: '3',
    sort: 3,
    added: 'FIX.4.2',
    tag: 216,
    type: 'int',
    codeSet: 'RoutingTypeCodeSet',
    description: 'Block Firm',
  },
  {
    name: 'BlockList',
    id: '216004',
    value: '4',
    sort: 4,
    added: 'FIX.4.2',
    tag: 216,
    type: 'int',
    codeSet: 'RoutingTypeCodeSet',
    description: 'Block List',
  },
  {
    name: 'TargetPerson',
    id: '216005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '194',
    tag: 216,
    type: 'int',
    codeSet: 'RoutingTypeCodeSet',
    description: 'Target Person',
  },
  {
    name: 'BlockPerson',
    id: '216006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '194',
    tag: 216,
    type: 'int',
    codeSet: 'RoutingTypeCodeSet',
    description: 'Block Person',
  },
  {
    name: 'EONIA',
    id: '221001',
    value: 'EONIA',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'EONIA',
  },
  {
    name: 'EUREPO',
    id: '221002',
    value: 'EUREPO',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'EUREPO',
  },
  {
    name: 'Euribor',
    id: '221003',
    value: 'Euribor',
    sort: 3,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '132',
    deprecated: 'FIX.5.0SP2',
    deprecatedEP: '132',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description:
      'EURIBOR (deprecated use enum EURIBOR instead)\n\nDeprecated use of EURIBOR for the enumeration.',
  },
  {
    name: 'FutureSWAP',
    id: '221004',
    value: 'FutureSWAP',
    sort: 4,
    added: 'FIX.4.3',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'FutureSWAP',
  },
  {
    name: 'LIBID',
    id: '221005',
    value: 'LIBID',
    sort: 5,
    added: 'FIX.4.3',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'LIBID',
  },
  {
    name: 'LIBOR',
    id: '221006',
    value: 'LIBOR',
    sort: 6,
    added: 'FIX.4.3',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'LIBOR (London Inter-Bank Offer)',
  },
  {
    name: 'MuniAAA',
    id: '221007',
    value: 'MuniAAA',
    sort: 7,
    added: 'FIX.4.3',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'MuniAAA',
  },
  {
    name: 'OTHER',
    id: '221008',
    value: 'OTHER',
    sort: 8,
    added: 'FIX.4.3',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'OTHER',
  },
  {
    name: 'Pfandbriefe',
    id: '221009',
    value: 'Pfandbriefe',
    sort: 9,
    added: 'FIX.4.3',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Pfandbriefe',
  },
  {
    name: 'SONIA',
    id: '221010',
    value: 'SONIA',
    sort: 10,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'SONIA',
  },
  {
    name: 'SWAP',
    id: '221011',
    value: 'SWAP',
    sort: 11,
    added: 'FIX.4.3',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'SWAP',
  },
  {
    name: 'Treasury',
    id: '221012',
    value: 'Treasury',
    sort: 12,
    added: 'FIX.4.3',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Treasury',
  },
  {
    name: 'FedFundRateEffective',
    id: '221013',
    value: 'FEDEFF',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '132',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description:
      'US Federal Reserve fed funds effective rate\n\nUS Federal Reserve fed funds effective rate or the weighted average of the actual negotiated rates banks pay each other to to borrow funds.',
  },
  {
    name: 'FedOpen',
    id: '221014',
    value: 'FEDOPEN',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '132',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description:
      'US fed funds target rate\n\nFed funds target rate as determined by the US Federal Reserve Federal Open Market Committee.',
  },
  {
    name: 'EURIBOR',
    id: '221015',
    value: 'EURIBOR',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '132',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Euro interbank offer rate',
  },
  {
    name: 'AUBSW',
    id: '221016',
    value: 'AUBSW',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Australian Bank Bill Swap Rate',
  },
  {
    name: 'BUBOR',
    id: '221017',
    value: 'BUBOR',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Budapest Bank Offered Rate',
  },
  {
    name: 'CDOR',
    id: '221018',
    value: 'CDOR',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Canadian Dollar Offered Rate',
  },
  {
    name: 'CIBOR',
    id: '221019',
    value: 'CIBOR',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Copenhagen Interbank Offered Rate',
  },
  {
    name: 'EONIASWAP',
    id: '221020',
    value: 'EONIASWAP',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Euro Overnight Index Average Swap Rate',
  },
  {
    name: 'ESTR',
    id: '221021',
    value: 'ESTR',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Euro Short Term Rate\n\nReplaces EONIA.',
  },
  {
    name: 'EURODOLLAR',
    id: '221022',
    value: 'EURODOLLAR',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Euro Dollar Rate',
  },
  {
    name: 'EUROSWISS',
    id: '221023',
    value: 'EUROSWISS',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Euro Swiss Franc Rate',
  },
  {
    name: 'GCFREPO',
    id: '221024',
    value: 'GCFREPO',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'DTCC General Collateral Finance Repo Index',
  },
  {
    name: 'ISDAFIX',
    id: '221025',
    value: 'ISDAFIX',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'ICE Swap Rate',
  },
  {
    name: 'JIBAR',
    id: '221026',
    value: 'JIBAR',
    sort: 26,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Johannesburg Interbank Agreed Rate',
  },
  {
    name: 'MOSPRIM',
    id: '221027',
    value: 'MOSPRIM',
    sort: 27,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Moscow Prime Offered Rate',
  },
  {
    name: 'NIBOR',
    id: '221028',
    value: 'NIBOR',
    sort: 28,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Nigeria Three Month Interbank Rate',
  },
  {
    name: 'PRIBOR',
    id: '221029',
    value: 'PRIBOR',
    sort: 29,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Czech Republic Interbank Offered Rate',
  },
  {
    name: 'SOFR',
    id: '221030',
    value: 'SOFR',
    sort: 30,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Secured Overnight Financing Rate\n\nReplaces LIBOR.',
  },
  {
    name: 'STIBOR',
    id: '221031',
    value: 'STIBOR',
    sort: 31,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Stockholm Interbank Offered Rate',
  },
  {
    name: 'TELBOR',
    id: '221032',
    value: 'TELBOR',
    sort: 32,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Bank of Israel Interbank Offered Rate',
  },
  {
    name: 'TIBOR',
    id: '221033',
    value: 'TIBOR',
    sort: 33,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Tokyo Interbank Offered Rate',
  },
  {
    name: 'WIBOR',
    id: '221034',
    value: 'WIBOR',
    sort: 34,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Warsaw Interbank Offered Rate',
  },
  {
    name: 'AONIA',
    id: '221035',
    value: 'AONIA',
    sort: 35,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description:
      'Reserve Bank of Australia Interbank Overnight Cash Rate\n\nAlso known as AUD Overnight Index Average.',
  },
  {
    name: 'AONIAR',
    id: '221036',
    value: 'AONIA-R',
    sort: 36,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description:
      'Realised AONIA\n\n"Realised AONIA applies a compounding formula to the daily AONIA rate, to determine the compounded average rate over the prior 1 to 6 month period." (source https://www.asx.com.au/documents/products/realised-aonia-explained.pdf).',
  },
  {
    name: 'BKBM',
    id: '221037',
    value: 'BKBM',
    sort: 37,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'New Zealand Bank Bill Market Rate',
  },
  {
    name: 'CD19D',
    id: '221038',
    value: 'CD91D',
    sort: 38,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Republic of Korea 90-Day Certificate of Deposit Rate',
  },
  {
    name: 'CORRA',
    id: '221039',
    value: 'CORRA',
    sort: 39,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Canadian Overnight Repo Rate Average',
  },
  {
    name: 'DIRRTN',
    id: '221040',
    value: 'DIRR-TN',
    sort: 40,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Danish Interbank Interest Rate-Tomorrow or Next',
  },
  {
    name: 'EIBOR',
    id: '221041',
    value: 'EIBOR',
    sort: 41,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Emirates Interbank Offered Rate',
  },
  {
    name: 'FixingRepoRate',
    id: '221042',
    value: 'FixingRepoRate',
    sort: 42,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'China Interbank Overnight Repo Rate',
  },
  {
    name: 'HIBOR',
    id: '221043',
    value: 'HIBOR',
    sort: 43,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Hong Kong Interbank Offered Rate',
  },
  {
    name: 'IBR',
    id: '221044',
    value: 'IBR',
    sort: 44,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Colombia Overnight Interbank Reference Rate',
  },
  {
    name: 'KLIBOR',
    id: '221045',
    value: 'KLIBOR',
    sort: 45,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Kuala Lumpur Interbank Offered Rate',
  },
  {
    name: 'MIBOR',
    id: '221046',
    value: 'MIBOR',
    sort: 46,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Mumbia Interbank Offered Rate',
  },
  {
    name: 'NZONIA',
    id: '221047',
    value: 'NZONIA',
    sort: 47,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'New Zealand Overnight Indexed Swaps (OIS)',
  },
  {
    name: 'PHIREF',
    id: '221048',
    value: 'PHIREF',
    sort: 48,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Philippines Interbank Reference Rate',
  },
  {
    name: 'REIBOR',
    id: '221049',
    value: 'REIBOR',
    sort: 49,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Reykjavik Interbank Offered Rate',
  },
  {
    name: 'SAIBOR',
    id: '221050',
    value: 'SAIBOR',
    sort: 50,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Saudi Arabian Interbank Offered Rate',
  },
  {
    name: 'SARON',
    id: '221051',
    value: 'SARON',
    sort: 51,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Swiss Average Rate Overnight',
  },
  {
    name: 'SORA',
    id: '221052',
    value: 'SORA',
    sort: 52,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Singapore Swap Offer Rate',
  },
  {
    name: 'TLREF',
    id: '221053',
    value: 'TLREF',
    sort: 53,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Turkish Lira Overnight Reference Rate',
  },
  {
    name: 'TIIE',
    id: '221054',
    value: 'TIIE',
    sort: 54,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Mexico Interbank Equilibrium Interest Rate',
  },
  {
    name: 'THBFIX',
    id: '221055',
    value: 'THBFIX',
    sort: 55,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Thai Baht Interest Rate Fixing',
  },
  {
    name: 'TONAR',
    id: '221056',
    value: 'TONAR',
    sort: 56,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 221,
    type: 'String',
    codeSet: 'BenchmarkCurveNameCodeSet',
    description: 'Tokyo Overnight Average Rate',
  },
  {
    name: 'AlternativeMinimumTax',
    id: '233001',
    value: 'AMT',
    sort: 1,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Alternative Minimum Tax (Y/N)',
  },
  {
    name: 'AutoReinvestment',
    id: '233002',
    value: 'AUTOREINV',
    sort: 2,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Auto Reinvestment at <rate> or better',
  },
  {
    name: 'BankQualified',
    id: '233003',
    value: 'BANKQUAL',
    sort: 3,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Bank qualified (Y/N)',
  },
  {
    name: 'BargainConditions',
    id: '233004',
    value: 'BGNCON',
    sort: 4,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Bargain conditions (see StipulationValue (234) for values)',
  },
  {
    name: 'CouponRange',
    id: '233005',
    value: 'COUPON',
    sort: 5,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Coupon range',
  },
  {
    name: 'ISOCurrencyCode',
    id: '233006',
    value: 'CURRENCY',
    sort: 6,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'ISO Currency Code',
  },
  {
    name: 'CustomStart',
    id: '233007',
    value: 'CUSTOMDATE',
    sort: 7,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Custom start/end date',
  },
  {
    name: 'Geographics',
    id: '233008',
    value: 'GEOG',
    sort: 8,
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Geographics and % range (ex. 234=CA 0-80 [minimum of 80% California assets])',
  },
  {
    name: 'ValuationDiscount',
    id: '233009',
    value: 'HAIRCUT',
    sort: 9,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Valuation Discount',
  },
  {
    name: 'Insured',
    id: '233010',
    value: 'INSURED',
    sort: 10,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Insured (Y/N)',
  },
  {
    name: 'IssueDate',
    id: '233011',
    value: 'ISSUE',
    sort: 11,
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Year Or Year/Month of Issue (ex. 234=2002/09)',
  },
  {
    name: 'Issuer',
    id: '233012',
    value: 'ISSUER',
    sort: 12,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: "Issuer's ticker",
  },
  {
    name: 'IssueSizeRange',
    id: '233013',
    value: 'ISSUESIZE',
    sort: 13,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'issue size range',
  },
  {
    name: 'LookbackDays',
    id: '233014',
    value: 'LOOKBACK',
    sort: 14,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Lookback Days',
  },
  {
    name: 'ExplicitLotIdentifier',
    id: '233015',
    value: 'LOT',
    sort: 15,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Explicit lot identifier',
  },
  {
    name: 'LotVariance',
    id: '233016',
    value: 'LOTVAR',
    sort: 16,
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Lot Variance (value in percent maximum over- or under-allocation allowed)',
  },
  {
    name: 'MaturityYearAndMonth',
    id: '233017',
    value: 'MAT',
    sort: 17,
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Maturity Year And Month',
  },
  {
    name: 'MaturityRange',
    id: '233018',
    value: 'MATURITY',
    sort: 18,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Maturity range',
  },
  {
    name: 'MaximumSubstitutions',
    id: '233019',
    value: 'MAXSUBS',
    sort: 19,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Maximum substitutions (Repo)',
  },
  {
    name: 'MinimumDenomination',
    id: '233020',
    value: 'MINDNOM',
    sort: 20,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Minimum denomination',
  },
  {
    name: 'MinimumIncrement',
    id: '233021',
    value: 'MININCR',
    sort: 21,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Minimum increment',
  },
  {
    name: 'MinimumQuantity',
    id: '233022',
    value: 'MINQTY',
    sort: 22,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Minimum quantity',
  },
  {
    name: 'PaymentFrequency',
    id: '233023',
    value: 'PAYFREQ',
    sort: 23,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Payment frequency, calendar',
  },
  {
    name: 'NumberOfPieces',
    id: '233024',
    value: 'PIECES',
    sort: 24,
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Number Of Pieces',
  },
  {
    name: 'PoolsMaximum',
    id: '233025',
    value: 'PMAX',
    sort: 25,
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Pools Maximum',
  },
  {
    name: 'PoolsPerLot',
    id: '233026',
    value: 'PPL',
    sort: 26,
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Pools per Lot',
  },
  {
    name: 'PoolsPerMillion',
    id: '233027',
    value: 'PPM',
    sort: 27,
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Pools per Million',
  },
  {
    name: 'PoolsPerTrade',
    id: '233028',
    value: 'PPT',
    sort: 28,
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Pools per Trade',
  },
  {
    name: 'PriceRange',
    id: '233029',
    value: 'PRICE',
    sort: 29,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Price Range',
  },
  {
    name: 'PricingFrequency',
    id: '233030',
    value: 'PRICEFREQ',
    sort: 30,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Pricing frequency',
  },
  {
    name: 'ProductionYear',
    id: '233031',
    value: 'PROD',
    sort: 31,
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Production Year',
  },
  {
    name: 'CallProtection',
    id: '233032',
    value: 'PROTECT',
    sort: 32,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Call protection',
  },
  {
    name: 'Purpose',
    id: '233033',
    value: 'PURPOSE',
    sort: 33,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Purpose',
  },
  {
    name: 'BenchmarkPriceSource',
    id: '233034',
    value: 'PXSOURCE',
    sort: 34,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Benchmark price source',
  },
  {
    name: 'RatingSourceAndRange',
    id: '233035',
    value: 'RATING',
    sort: 35,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Rating source and range',
  },
  {
    name: 'TypeOfRedemption',
    id: '233036',
    value: 'REDEMPTION',
    sort: 36,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Type Of Redemption - values are: NonCallable, Prefunded, EscrowedToMaturity, Putable, Convertible',
  },
  {
    name: 'Restricted',
    id: '233037',
    value: 'RESTRICTED',
    sort: 37,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Restricted (Y/N)',
  },
  {
    name: 'MarketSector',
    id: '233038',
    value: 'SECTOR',
    sort: 38,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Market Sector',
  },
  {
    name: 'SecurityTypeIncludedOrExcluded',
    id: '233039',
    value: 'SECTYPE',
    sort: 39,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Security Type included or excluded',
  },
  {
    name: 'Structure',
    id: '233040',
    value: 'STRUCT',
    sort: 40,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Structure',
  },
  {
    name: 'SubstitutionsFrequency',
    id: '233041',
    value: 'SUBSFREQ',
    sort: 41,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Substitutions frequency (Repo)',
  },
  {
    name: 'SubstitutionsLeft',
    id: '233042',
    value: 'SUBSLEFT',
    sort: 42,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Substitutions left (Repo)',
  },
  {
    name: 'FreeformText',
    id: '233043',
    value: 'TEXT',
    sort: 43,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Freeform Text',
  },
  {
    name: 'TradeVariance',
    id: '233044',
    value: 'TRDVAR',
    sort: 44,
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Trade Variance (value in percent maximum over- or under-allocation allowed)',
  },
  {
    name: 'WeightedAverageCoupon',
    id: '233045',
    value: 'WAC',
    sort: 45,
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Weighted Average Coupon - value in percent (exact or range) plus "Gross" or "Net" of servicing spread (the default) (ex. 234=6.5-Net [minimum of 6.5% net of servicing fee])',
  },
  {
    name: 'WeightedAverageLifeCoupon',
    id: '233046',
    value: 'WAL',
    sort: 46,
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Weighted Average Life Coupon - value in percent (exact or range)',
  },
  {
    name: 'WeightedAverageLoanAge',
    id: '233047',
    value: 'WALA',
    sort: 47,
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Weighted Average Loan Age - value in months (exact or range)',
  },
  {
    name: 'WeightedAverageMaturity',
    id: '233048',
    value: 'WAM',
    sort: 48,
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Weighted Average Maturity - value in months (exact or range)',
  },
  {
    name: 'WholePool',
    id: '233049',
    value: 'WHOLE',
    sort: 49,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Whole Pool (Y/N)',
  },
  {
    name: 'YieldRange',
    id: '233050',
    value: 'YIELD',
    sort: 50,
    added: 'FIX.4.4',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Yield Range',
  },
  {
    name: 'OriginalAmount',
    id: '233051',
    value: 'ORIGAMT',
    sort: 51,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Original amount\n\nThe original issued amount of a mortgage backed security or other loan/asset backed security.',
  },
  {
    name: 'PoolEffectiveDate',
    id: '233052',
    value: 'POOLEFFDT',
    sort: 52,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Pool effective date',
  },
  {
    name: 'PoolInitialFactor',
    id: '233053',
    value: 'POOLINITFCTR',
    sort: 53,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Pool initial factor\n\nFor morttgage backed securities, the part of the mortgage that is outstanding on trade inception, i.e. has not been repaid yet as principal. It is expressed as a multiplier factor to the mortgage: where 1 means that the whole mortage amount is outstanding, 0.8 means that80% remains to be repaid and 20% has been repaid.',
  },
  {
    name: 'Tranche',
    id: '233054',
    value: 'TRANCHE',
    sort: 54,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Tranche identifier\n\nIdentifies the tranche of a mortgage backed security, loan, collateralized mortgage obligation or similar securities that can be split into different risk or maturity (for example) classes.',
  },
  {
    name: 'Substitution',
    id: '233055',
    value: 'SUBSTITUTION',
    sort: 55,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Substitution (Y/N)\n\nIndicates whether substitution is applicable (Y) or (N).',
  },
  {
    name: 'MULTEXCHFLLBCK',
    id: '233056',
    value: 'MULTEXCHFLLBCK',
    sort: 56,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Multiple exchange fallback (Y/N)\n\nFor an index option transaction, indicates whether a relevant "Multiple Exchange Index Annex" is applicable (Y) to the transaction or not (N). This annex defines additional provisions which are applicable where an index is comprised of component securities that are traded on multiple exchanges.',
  },
  {
    name: 'COMPSECFLLBCK',
    id: '233057',
    value: 'COMPSECFLLBCK',
    sort: 57,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Component security fallback (Y/N)\n\nFor an index option transaction, indicates whether a relevant "Component Security Index Annex" is applicable (Y) to the transaction or not (N).',
  },
  {
    name: 'LOCLJRSDCTN',
    id: '233058',
    value: 'LOCLJRSDCTN',
    sort: 58,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Local jurisdiction (Y/N)\n\n"Local Jurisdiction" is used in the AEJ Master Confirmation to determine applicability (Y), or not (N), of local taxes (including taxes, duties, and similar charges) imposed by the taxing authority of the local jurisdiction.',
  },
  {
    name: 'RELVJRSDCTN',
    id: '233059',
    value: 'RELVJRSDCTN',
    sort: 59,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Relevant jurisdiction (Y/N)\n\n"Relevant Jurisdiction" is used in the AEJ Master Confirmation to determine applicability (Y), or not (N), of local taxes (including taxes, duties and similar charges) that would be imposed by the taxing authority of the "country of underlier" on a "hypothetical broker dealer" assuming that the applicable hedge positions are held by its office in the Relevant Jurisdiction.',
  },
  {
    name: 'IncurredRecovery',
    id: '233060',
    value: 'INCURRCVY',
    sort: 1,
    group: 'CDS General Terms',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Incurred recovery (Y/N)\n\nSpecifies whether incurred recovery is applicable (Y) or not (N). Outstanding Swap Notional Amount is defined at any time on any day, as the greater of: (a) Zero; If Incurred Recovery Amount Applicable: (b) The Original Swap Notional Amount minus the sum of all Incurred Loss Amounts and all Incurred Recovery Amounts (if any) determined under this Confirmation at or prior to such time.Incurred Recovery Amount not populated: (b) The Original Swap Notional Amount minus the sum of all Incurred Loss Amounts determined under this Confirmation at or prior to such time. 2009 CDX Tranche Terms.',
  },
  {
    name: 'AdditionalTerm',
    id: '233061',
    value: 'ADDTRM',
    sort: 2,
    group: 'CDS General Terms',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Additional term\n\nUsed for representing information contained in the Additional Terms field of the 2003 Master Credit Derivatives confirm.',
  },
  {
    name: 'ModifiedEquityDelivery',
    id: '233062',
    value: 'MODEQTYDLVY',
    sort: 3,
    group: 'CDS General Terms',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Modified equity delivery\n\nIndicates whether delivery of selected obligationshaving an amountgreater than the reference entity notional amount is allowed (Y) or (N). 2005 iTraxx tranched Transactions Standard Terms Supplement.',
  },
  {
    name: 'NoReferenceOblication',
    id: '233063',
    value: 'NOREFOBLIG',
    sort: 4,
    group: 'CDS General Terms',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'No reference obligation (Y/N)\n\nWhen specified as "Y" this indicates that there is no Reference Obligation associated with this Credit Default Swap and that there will never be one. 2003 ISDA Credit Derivatives Definitions.',
  },
  {
    name: 'UnknownReferenceObligation',
    id: '233064',
    value: 'UNKREFOBLIG',
    sort: 5,
    group: 'CDS General Terms',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Unknown reference obligation (Y/N)\n\nWhen specified as "Y" this indicates that the Reference obligation associated with the Credit Default Swap is currently not known. This is not valid for Legal Confirmation purposes, but is valid for earlier stages in the trade life cycle (e.g. Broker Confirmation). 2003 FpML-CD-4.0.',
  },
  {
    name: 'AllGuarantees',
    id: '233065',
    value: 'ALLGUARANTEES',
    sort: 6,
    group: 'CDS General Terms',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'All guarantees (Y/N)\n\nIndicates whether an obligation of the Reference Entity, guaranteed by the Reference Entity on behalf of a non-Affiliate, is to be considered an Obligation for the purpose of the transaction (Y) or (N). ISDA 2003 Term: All Guarantees.',
  },
  {
    name: 'ReferencePrice',
    id: '233066',
    value: 'REFPX',
    sort: 7,
    group: 'CDS General Terms',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Reference price (Y/N)\n\nSpecifies the reference price expressed as a percentage between 0 and 1 (e.g. 0.05 is 5%). The reference price is used to determine (a) for physically settled trades, the Physical Settlement Amount, which equals the Floating Rate Payer Calculation Amount times the Reference Price and (b) for cash settled trades, the Cash Settlement Amount, which equals the greater of (i) the difference between the Reference Price and the Final Price and (ii) zero. ISDA 2003 Term: Reference Price.',
  },
  {
    name: 'ReferencePolicy',
    id: '233067',
    value: 'REFPOLICY',
    sort: 8,
    group: 'CDS General Terms',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Reference policy (Y/N)\n\nIndicates whether the reference obligation is guaranteed (Y), or not (N), under a reference policy. If the Reference Obligation is guaranteed under a Reference Policy, and such Reference Policy by its terms excludes any component of the Expected Principal Amount for purposes of determining the liability of the relevant Insurer, or the Insurer is otherwise not required to pay any such amounts under the terms of the Reference Policy, the relevant component or amount shall also be excluded for purposes of determining the Expected Principal Amount with respect to any determination of Principal Shortfall hereunder. 2006 ISDA CDS on MBS Terms.',
  },
  {
    name: 'SecuredList',
    id: '233068',
    value: 'SECRDLIST',
    sort: 9,
    group: 'CDS General Terms',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Secured list (Y/N)\n\nSpecifies whether a list of Syndicated Secured Obligations (also known as the Relevant Secured List) exists (Y), or not (N), for the Reference Entity. With respect to any day, the list of Syndicated Secured Obligations of the Designated Priority of the Reference Entity published by Markit Group Limited or any successor thereto appointed by the Specified Dealers (the "Secured List Publisher") on or most recently before such day, which list is currently available at [http://www.markit.com]. ISDA 2003 Term: Relevant Secured List.',
  },
  {
    name: 'AverageFICOScore',
    id: '233069',
    value: 'AVFICO',
    sort: 51,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Average FICO Score',
  },
  {
    name: 'AverageLoanSize',
    id: '233070',
    value: 'AVSIZE',
    sort: 52,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Average Loan Size',
  },
  {
    name: 'MaximumLoanBalance',
    id: '233071',
    value: 'MAXBAL',
    sort: 53,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Maximum Loan Balance',
  },
  {
    name: 'PoolIdentifier',
    id: '233072',
    value: 'POOL',
    sort: 54,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Pool Identifier',
  },
  {
    name: 'TypeOfRollTrade',
    id: '233073',
    value: 'ROLLTYPE',
    sort: 55,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Type of Roll trade',
  },
  {
    name: 'ReferenceToRollingOrClosingTrade',
    id: '233074',
    value: 'REFTRADE',
    sort: 56,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    updated: 'FIX.5.0SP2',
    updatedEP: '258',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Reference to rolling or closing trade',
  },
  {
    name: 'PrincipalOfRollingOrClosingTrade',
    id: '233075',
    value: 'REFPRIN',
    sort: 57,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    updated: 'FIX.5.0SP2',
    updatedEP: '258',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Principal to rolling or closing trade',
  },
  {
    name: 'InterestOfRollingOrClosingTrade',
    id: '233076',
    value: 'REFINT',
    sort: 58,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    updated: 'FIX.5.0SP2',
    updatedEP: '258',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Interest of rolling or closing trade',
  },
  {
    name: 'AvailableOfferQuantityToBeShownToTheStreet',
    id: '233077',
    value: 'AVAILQTY',
    sort: 59,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Available offer quantity to be shown to the street',
  },
  {
    name: 'BrokerCredit',
    id: '233078',
    value: 'BROKERCREDIT',
    sort: 60,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: "Broker's sales credit",
  },
  {
    name: 'OfferPriceToBeShownToInternalBrokers',
    id: '233079',
    value: 'INTERNALPX',
    sort: 61,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Offer price to be shown to internal brokers',
  },
  {
    name: 'OfferQuantityToBeShownToInternalBrokers',
    id: '233080',
    value: 'INTERNALQTY',
    sort: 62,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Offer quantity to be shown to internal brokers',
  },
  {
    name: 'TheMinimumResidualOfferQuantity',
    id: '233081',
    value: 'LEAVEQTY',
    sort: 63,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'The minimum residual offer quantity',
  },
  {
    name: 'MaximumOrderSize',
    id: '233082',
    value: 'MAXORDQTY',
    sort: 64,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Maximum order size',
  },
  {
    name: 'OrderQuantityIncrement',
    id: '233083',
    value: 'ORDRINCR',
    sort: 65,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Order quantity increment',
  },
  {
    name: 'PrimaryOrSecondaryMarketIndicator',
    id: '233084',
    value: 'PRIMARY',
    sort: 66,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Primary or Secondary market indicator',
  },
  {
    name: 'BrokerSalesCreditOverride',
    id: '233085',
    value: 'SALESCREDITOVR',
    sort: 67,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Broker sales credit override',
  },
  {
    name: 'TraderCredit',
    id: '233086',
    value: 'TRADERCREDIT',
    sort: 68,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: "Trader's credit",
  },
  {
    name: 'DiscountRate',
    id: '233087',
    value: 'DISCOUNT',
    sort: 69,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Discount Rate (when price is denominated in percent of par)',
  },
  {
    name: 'YieldToMaturity',
    id: '233088',
    value: 'YTM',
    sort: 71,
    group: 'Other',
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description:
      'Yield to Maturity (when YieldType(235) and Yield(236) show a different yield)',
  },
  {
    name: 'InterestPayoffOfRollingOrAmendingTrade',
    id: '233089',
    value: 'PAYOFF',
    sort: 72,
    group: 'Other',
    added: 'FIX.5.0SP2',
    addedEP: '258',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Interest payoff of rolling or amending trade',
  },
  {
    name: 'AbsolutePrepaymentSpeed',
    id: '233090',
    value: 'ABS',
    sort: 1,
    group: 'Prepayment Speeds',
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Absolute Prepayment Speed',
  },
  {
    name: 'ConstantPrepaymentPenalty',
    id: '233091',
    value: 'CPP',
    sort: 2,
    group: 'Prepayment Speeds',
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Constant Prepayment Penalty',
  },
  {
    name: 'ConstantPrepaymentRate',
    id: '233092',
    value: 'CPR',
    sort: 3,
    group: 'Prepayment Speeds',
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Constant Prepayment Rate',
  },
  {
    name: 'ConstantPrepaymentYield',
    id: '233093',
    value: 'CPY',
    sort: 4,
    group: 'Prepayment Speeds',
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Constant Prepayment Yield',
  },
  {
    name: 'FinalCPROfHomeEquityPrepaymentCurve',
    id: '233094',
    value: 'HEP',
    sort: 5,
    group: 'Prepayment Speeds',
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'final CPR of Home Equity Prepayment Curve',
  },
  {
    name: 'PercentOfManufacturedHousingPrepaymentCurve',
    id: '233095',
    value: 'MHP',
    sort: 6,
    group: 'Prepayment Speeds',
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Percent of Manufactured Housing Prepayment Curve',
  },
  {
    name: 'MonthlyPrepaymentRate',
    id: '233096',
    value: 'MPR',
    sort: 7,
    group: 'Prepayment Speeds',
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Monthly Prepayment Rate',
  },
  {
    name: 'PercentOfProspectusPrepaymentCurve',
    id: '233097',
    value: 'PPC',
    sort: 8,
    group: 'Prepayment Speeds',
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Percent of Prospectus Prepayment Curve',
  },
  {
    name: 'PercentOfBMAPrepaymentCurve',
    id: '233098',
    value: 'PSA',
    sort: 9,
    group: 'Prepayment Speeds',
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Percent of BMA Prepayment Curve',
  },
  {
    name: 'SingleMonthlyMortality',
    id: '233099',
    value: 'SMM',
    sort: 10,
    group: 'Prepayment Speeds',
    added: 'FIX.4.3',
    tag: 233,
    type: 'String',
    codeSet: 'StipulationTypeCodeSet',
    description: 'Single Monthly Mortality',
  },
  {
    name: 'AfterTaxYield',
    id: '235001',
    value: 'AFTERTAX',
    sort: 1,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'After Tax Yield (Municipals)',
  },
  {
    name: 'AnnualYield',
    id: '235002',
    value: 'ANNUAL',
    sort: 2,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Annual Yield',
  },
  {
    name: 'YieldAtIssue',
    id: '235003',
    value: 'ATISSUE',
    sort: 3,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Yield At Issue (Municipals)',
  },
  {
    name: 'YieldToAverageMaturity',
    id: '235004',
    value: 'AVGMATURITY',
    sort: 4,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Yield To Avg Maturity',
  },
  {
    name: 'BookYield',
    id: '235005',
    value: 'BOOK',
    sort: 5,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Book Yield',
  },
  {
    name: 'YieldToNextCall',
    id: '235006',
    value: 'CALL',
    sort: 6,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Yield to Next Call',
  },
  {
    name: 'YieldChangeSinceClose',
    id: '235007',
    value: 'CHANGE',
    sort: 7,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Yield Change Since Close',
  },
  {
    name: 'ClosingYield',
    id: '235008',
    value: 'CLOSE',
    sort: 8,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Closing Yield',
  },
  {
    name: 'CompoundYield',
    id: '235009',
    value: 'COMPOUND',
    sort: 9,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Compound Yield',
  },
  {
    name: 'CurrentYield',
    id: '235010',
    value: 'CURRENT',
    sort: 10,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Current Yield',
  },
  {
    name: 'GvntEquivalentYield',
    id: '235011',
    value: 'GOVTEQUIV',
    sort: 11,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Gvnt Equivalent Yield',
  },
  {
    name: 'TrueGrossYield',
    id: '235012',
    value: 'GROSS',
    sort: 12,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'True Gross Yield',
  },
  {
    name: 'YieldWithInflationAssumption',
    id: '235013',
    value: 'INFLATION',
    sort: 13,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Yield with Inflation Assumption',
  },
  {
    name: 'InverseFloaterBondYield',
    id: '235014',
    value: 'INVERSEFLOATER',
    sort: 14,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Inverse Floater Bond Yield',
  },
  {
    name: 'MostRecentClosingYield',
    id: '235015',
    value: 'LASTCLOSE',
    sort: 15,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Most Recent Closing Yield',
  },
  {
    name: 'ClosingYieldMostRecentMonth',
    id: '235016',
    value: 'LASTMONTH',
    sort: 16,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Closing Yield Most Recent Month',
  },
  {
    name: 'ClosingYieldMostRecentQuarter',
    id: '235017',
    value: 'LASTQUARTER',
    sort: 17,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Closing Yield Most Recent Quarter',
  },
  {
    name: 'ClosingYieldMostRecentYear',
    id: '235018',
    value: 'LASTYEAR',
    sort: 18,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Closing Yield Most Recent Year',
  },
  {
    name: 'YieldToLongestAverageLife',
    id: '235019',
    value: 'LONGAVGLIFE',
    sort: 19,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Yield to Longest Average Life',
  },
  {
    name: 'MarkToMarketYield',
    id: '235020',
    value: 'MARK',
    sort: 20,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Mark to Market Yield',
  },
  {
    name: 'YieldToMaturity',
    id: '235021',
    value: 'MATURITY',
    sort: 21,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Yield to Maturity',
  },
  {
    name: 'YieldToNextRefund',
    id: '235022',
    value: 'NEXTREFUND',
    sort: 22,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Yield to Next Refund (Sinking Fund Bonds)',
  },
  {
    name: 'OpenAverageYield',
    id: '235023',
    value: 'OPENAVG',
    sort: 23,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Open Average Yield',
  },
  {
    name: 'PreviousCloseYield',
    id: '235024',
    value: 'PREVCLOSE',
    sort: 24,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Previous Close Yield',
  },
  {
    name: 'ProceedsYield',
    id: '235025',
    value: 'PROCEEDS',
    sort: 25,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Proceeds Yield',
  },
  {
    name: 'YieldToNextPut',
    id: '235026',
    value: 'PUT',
    sort: 26,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Yield to Next Put',
  },
  {
    name: 'SemiAnnualYield',
    id: '235027',
    value: 'SEMIANNUAL',
    sort: 27,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Semi-annual Yield',
  },
  {
    name: 'YieldToShortestAverageLife',
    id: '235028',
    value: 'SHORTAVGLIFE',
    sort: 28,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Yield to Shortest Average Life',
  },
  {
    name: 'SimpleYield',
    id: '235029',
    value: 'SIMPLE',
    sort: 29,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Simple Yield',
  },
  {
    name: 'TaxEquivalentYield',
    id: '235030',
    value: 'TAXEQUIV',
    sort: 30,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Tax Equivalent Yield',
  },
  {
    name: 'YieldToTenderDate',
    id: '235031',
    value: 'TENDER',
    sort: 31,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Yield to Tender Date',
  },
  {
    name: 'TrueYield',
    id: '235032',
    value: 'TRUE',
    sort: 32,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'True Yield',
  },
  {
    name: 'YieldValueOf32nds',
    id: '235033',
    value: 'VALUE1_32',
    sort: 33,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Yield Value Of 1/32',
  },
  {
    name: 'YieldToWorst',
    id: '235034',
    value: 'WORST',
    sort: 34,
    added: 'FIX.4.3',
    tag: 235,
    type: 'String',
    codeSet: 'YieldTypeCodeSet',
    description: 'Yield To Worst',
  },
  {
    name: 'NotTradedFlat',
    id: '258001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.3',
    tag: 258,
    type: 'Boolean',
    codeSet: 'TradedFlatSwitchCodeSet',
    description: 'Not Traded Flat',
  },
  {
    name: 'TradedFlat',
    id: '258002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.3',
    tag: 258,
    type: 'Boolean',
    codeSet: 'TradedFlatSwitchCodeSet',
    description: 'Traded Flat',
  },
  {
    name: 'Snapshot',
    id: '263001',
    value: '0',
    sort: 1,
    added: 'FIX.4.2',
    tag: 263,
    type: 'char',
    codeSet: 'SubscriptionRequestTypeCodeSet',
    description: 'Snapshot',
  },
  {
    name: 'SnapshotAndUpdates',
    id: '263002',
    value: '1',
    sort: 2,
    added: 'FIX.4.2',
    tag: 263,
    type: 'char',
    codeSet: 'SubscriptionRequestTypeCodeSet',
    description: 'Snapshot + Updates (Subscribe)',
  },
  {
    name: 'DisablePreviousSnapshot',
    id: '263003',
    value: '2',
    sort: 3,
    added: 'FIX.4.2',
    tag: 263,
    type: 'char',
    codeSet: 'SubscriptionRequestTypeCodeSet',
    description: 'Disable previous Snapshot + Update Request (Unsubscribe)',
  },
  {
    name: 'FullRefresh',
    id: '265001',
    value: '0',
    sort: 1,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 265,
    type: 'int',
    codeSet: 'MDUpdateTypeCodeSet',
    description: 'Full refresh',
  },
  {
    name: 'IncrementalRefresh',
    id: '265002',
    value: '1',
    sort: 2,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 265,
    type: 'int',
    codeSet: 'MDUpdateTypeCodeSet',
    description: 'Incremental refresh',
  },
  {
    name: 'BookEntriesToBeAggregated',
    id: '266001',
    value: 'Y',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '34',
    tag: 266,
    type: 'Boolean',
    codeSet: 'AggregatedBookCodeSet',
    description: 'book entries to be aggregated',
  },
  {
    name: 'BookEntriesShouldNotBeAggregated',
    id: '266002',
    value: 'N',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '34',
    tag: 266,
    type: 'Boolean',
    codeSet: 'AggregatedBookCodeSet',
    description: 'book entries should not be aggregated',
  },
  {
    name: 'Bid',
    id: '269001',
    value: '0',
    sort: 1,
    added: 'FIX.4.2',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Bid',
  },
  {
    name: 'Offer',
    id: '269002',
    value: '1',
    sort: 2,
    added: 'FIX.4.2',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Offer',
  },
  {
    name: 'Trade',
    id: '269003',
    value: '2',
    sort: 3,
    added: 'FIX.4.2',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Trade',
  },
  {
    name: 'IndexValue',
    id: '269004',
    value: '3',
    sort: 4,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description:
      'Index value\n\nA reference stock index (e.g. DJIA) or benchmark rate (e.g. LIBOR).',
  },
  {
    name: 'OpeningPrice',
    id: '269005',
    value: '4',
    sort: 5,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Opening price',
  },
  {
    name: 'ClosingPrice',
    id: '269006',
    value: '5',
    sort: 6,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Closing price',
  },
  {
    name: 'SettlementPrice',
    id: '269007',
    value: '6',
    sort: 7,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Settlement price',
  },
  {
    name: 'TradingSessionHighPrice',
    id: '269008',
    value: '7',
    sort: 8,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Trading session high price',
  },
  {
    name: 'TradingSessionLowPrice',
    id: '269009',
    value: '8',
    sort: 9,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Trading session low price',
  },
  {
    name: 'VWAP',
    id: '269010',
    value: '9',
    sort: 10,
    added: 'FIX.4.2',
    updated: 'FIX.Latest',
    updatedEP: '267',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Volume Weighted Average Price\n\nVWAP',
  },
  {
    name: 'Imbalance',
    id: '269011',
    value: 'A',
    sort: 11,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Imbalance',
  },
  {
    name: 'TradeVolume',
    id: '269012',
    value: 'B',
    sort: 12,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Trade volume',
  },
  {
    name: 'OpenInterest',
    id: '269013',
    value: 'C',
    sort: 13,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Open interest',
  },
  {
    name: 'CompositeUnderlyingPrice',
    id: '269014',
    value: 'D',
    sort: 14,
    added: 'FIX.4.4',
    addedEP: '4',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Composite underlying price',
  },
  {
    name: 'SimulatedSellPrice',
    id: '269015',
    value: 'E',
    sort: 15,
    added: 'FIX.4.4',
    addedEP: '7',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Simulated sell price',
  },
  {
    name: 'SimulatedBuyPrice',
    id: '269016',
    value: 'F',
    sort: 16,
    added: 'FIX.4.4',
    addedEP: '7',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Simulated buy price',
  },
  {
    name: 'MarginRate',
    id: '269017',
    value: 'G',
    sort: 17,
    added: 'FIX.4.4',
    addedEP: '7',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Margin rate',
  },
  {
    name: 'MidPrice',
    id: '269018',
    value: 'H',
    sort: 18,
    added: 'FIX.4.4',
    addedEP: '7',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Mid-price',
  },
  {
    name: 'EmptyBook',
    id: '269019',
    value: 'J',
    sort: 19,
    added: 'FIX.4.4',
    addedEP: '7',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Empty book',
  },
  {
    name: 'SettleHighPrice',
    id: '269020',
    value: 'K',
    sort: 20,
    added: 'FIX.4.4',
    addedEP: '7',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Settle high price',
  },
  {
    name: 'SettleLowPrice',
    id: '269021',
    value: 'L',
    sort: 21,
    added: 'FIX.4.4',
    addedEP: '7',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Settle low price',
  },
  {
    name: 'PriorSettlePrice',
    id: '269022',
    value: 'M',
    sort: 22,
    added: 'FIX.4.4',
    addedEP: '7',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Prior settle price',
  },
  {
    name: 'SessionHighBid',
    id: '269023',
    value: 'N',
    sort: 23,
    added: 'FIX.4.4',
    addedEP: '7',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Session high bid',
  },
  {
    name: 'SessionLowOffer',
    id: '269024',
    value: 'O',
    sort: 24,
    added: 'FIX.4.4',
    addedEP: '7',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Session low offer',
  },
  {
    name: 'EarlyPrices',
    id: '269025',
    value: 'P',
    sort: 25,
    added: 'FIX.4.4',
    addedEP: '8',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Early prices',
  },
  {
    name: 'AuctionClearingPrice',
    id: '269026',
    value: 'Q',
    sort: 26,
    added: 'FIX.4.4',
    addedEP: '26',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Auction clearing price',
  },
  {
    name: 'SwapValueFactor',
    id: '269027',
    value: 'S',
    sort: 27,
    added: 'FIX.5.0',
    addedEP: '54',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description:
      'Swap Value Factor (SVF) for swaps cleared through a central counterparty (CCP)',
  },
  {
    name: 'DailyValueAdjustmentForLongPositions',
    id: '269028',
    value: 'R',
    sort: 28,
    added: 'FIX.5.0',
    addedEP: '55',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Daily value adjustment for long positions',
  },
  {
    name: 'CumulativeValueAdjustmentForLongPositions',
    id: '269029',
    value: 'T',
    sort: 29,
    added: 'FIX.5.0',
    addedEP: '55',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Cumulative value adjustment for long positions',
  },
  {
    name: 'DailyValueAdjustmentForShortPositions',
    id: '269030',
    value: 'U',
    sort: 30,
    added: 'FIX.5.0',
    addedEP: '55',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Daily value adjustment for short positions',
  },
  {
    name: 'CumulativeValueAdjustmentForShortPositions',
    id: '269031',
    value: 'V',
    sort: 31,
    added: 'FIX.5.0',
    addedEP: '55',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Cumulative value adjustment for short positions',
  },
  {
    name: 'FixingPrice',
    id: '269032',
    value: 'W',
    sort: 32,
    added: 'FIX.5.0SP1',
    addedEP: '84',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Fixing price',
  },
  {
    name: 'CashRate',
    id: '269033',
    value: 'X',
    sort: 33,
    added: 'FIX.5.0SP1',
    addedEP: '84',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Cash rate',
  },
  {
    name: 'RecoveryRate',
    id: '269034',
    value: 'Y',
    sort: 34,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Recovery rate',
  },
  {
    name: 'RecoveryRateForLong',
    id: '269035',
    value: 'Z',
    sort: 35,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Recovery rate for long positions',
  },
  {
    name: 'RecoveryRateForShort',
    id: '269036',
    value: 'a',
    sort: 36,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Recovery rate for short positions',
  },
  {
    name: 'MarketBid',
    id: '269037',
    value: 'b',
    sort: 37,
    added: 'FIX.5.0SP2',
    addedEP: '106',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Market bid',
  },
  {
    name: 'MarketOffer',
    id: '269038',
    value: 'c',
    sort: 38,
    added: 'FIX.5.0SP2',
    addedEP: '106',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Market offer',
  },
  {
    name: 'ShortSaleMinPrice',
    id: '269039',
    value: 'd',
    sort: 39,
    added: 'FIX.5.0SP2',
    addedEP: '123',
    updated: 'FIX.5.0SP2',
    updatedEP: '174',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Short sale minimum price',
  },
  {
    name: 'PreviousClosingPrice',
    id: '269040',
    value: 'e',
    sort: 40,
    added: 'FIX.5.0SP2',
    addedEP: '190',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Previous closing price',
  },
  {
    name: 'ThresholdLimitPriceBanding',
    id: '269041',
    value: 'g',
    sort: 42,
    added: 'FIX.Latest',
    addedEP: '267',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description:
      'Threshold limits and price banding\n\nConveys incremental real time change to pre-configured or previously disseminated pricing thresholds and/or banding parameters.',
  },
  {
    name: 'DailyFinancingValue',
    id: '269042',
    value: 'h',
    sort: 43,
    added: 'FIX.Latest',
    addedEP: '267',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description:
      'Daily financing value\n\nThe financing cost of rolling an analogous total return swap from the previous business day to the current business day. In the context of Adjusted Interest Rate (AIR) futures this is a component of the cleared futures price.',
  },
  {
    name: 'AccruedFinancingValue',
    id: '269043',
    value: 'i',
    sort: 44,
    added: 'FIX.Latest',
    addedEP: '267',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description:
      "Accrued financing value\n\nThe total of the daily funding values or amounts from a contract's first day of trading to the current day. In the context of Adjusted Interest Rate (AIR) futures this is a component of the cleared futures price.",
  },
  {
    name: 'TWAP',
    id: '269044',
    value: 't',
    sort: 56,
    added: 'FIX.Latest',
    addedEP: '267',
    tag: 269,
    type: 'char',
    codeSet: 'MDEntryTypeCodeSet',
    description: 'Time Weighted Average Price\n\nTWAP',
  },
  {
    name: 'PlusTick',
    id: '274001',
    value: '0',
    sort: 1,
    added: 'FIX.4.2',
    tag: 274,
    type: 'char',
    codeSet: 'TickDirectionCodeSet',
    description: 'Plus Tick',
  },
  {
    name: 'ZeroPlusTick',
    id: '274002',
    value: '1',
    sort: 2,
    added: 'FIX.4.2',
    tag: 274,
    type: 'char',
    codeSet: 'TickDirectionCodeSet',
    description: 'Zero-Plus Tick',
  },
  {
    name: 'MinusTick',
    id: '274003',
    value: '2',
    sort: 3,
    added: 'FIX.4.2',
    tag: 274,
    type: 'char',
    codeSet: 'TickDirectionCodeSet',
    description: 'Minus Tick',
  },
  {
    name: 'ZeroMinusTick',
    id: '274004',
    value: '3',
    sort: 4,
    added: 'FIX.4.2',
    tag: 274,
    type: 'char',
    codeSet: 'TickDirectionCodeSet',
    description: 'Zero-Minus Tick',
  },
  {
    name: 'Open',
    id: '276001',
    value: 'A',
    sort: 1,
    added: 'FIX.4.2',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Open/Active',
  },
  {
    name: 'Closed',
    id: '276002',
    value: 'B',
    sort: 2,
    added: 'FIX.4.2',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Closed/Inactive',
  },
  {
    name: 'ExchangeBest',
    id: '276003',
    value: 'C',
    sort: 3,
    added: 'FIX.4.2',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Exchange Best',
  },
  {
    name: 'ConsolidatedBest',
    id: '276004',
    value: 'D',
    sort: 4,
    added: 'FIX.4.2',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Consolidated Best',
  },
  {
    name: 'Locked',
    id: '276005',
    value: 'E',
    sort: 5,
    added: 'FIX.4.2',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Locked',
  },
  {
    name: 'Crossed',
    id: '276006',
    value: 'F',
    sort: 6,
    added: 'FIX.4.2',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Crossed',
  },
  {
    name: 'Depth',
    id: '276007',
    value: 'G',
    sort: 7,
    added: 'FIX.4.2',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Depth',
  },
  {
    name: 'FastTrading',
    id: '276008',
    value: 'H',
    sort: 8,
    added: 'FIX.4.2',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Fast Trading',
  },
  {
    name: 'NonFirm',
    id: '276009',
    value: 'I',
    sort: 9,
    added: 'FIX.4.2',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Non-Firm',
  },
  {
    name: 'Manual',
    id: '276010',
    value: 'L',
    sort: 10,
    added: 'FIX.4.4',
    addedEP: '6',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Manual/Slow Quote',
  },
  {
    name: 'OutrightPrice',
    id: '276011',
    value: 'J',
    sort: 11,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Outright Price',
  },
  {
    name: 'ImpliedPrice',
    id: '276012',
    value: 'K',
    sort: 12,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Implied Price',
  },
  {
    name: 'DepthOnOffer',
    id: '276013',
    value: 'M',
    sort: 13,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Depth on Offer',
  },
  {
    name: 'DepthOnBid',
    id: '276014',
    value: 'N',
    sort: 14,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Depth on Bid',
  },
  {
    name: 'Closing',
    id: '276015',
    value: 'O',
    sort: 15,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Closing',
  },
  {
    name: 'NewsDissemination',
    id: '276016',
    value: 'P',
    sort: 16,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'News Dissemination',
  },
  {
    name: 'TradingRange',
    id: '276017',
    value: 'Q',
    sort: 17,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Trading Range',
  },
  {
    name: 'OrderInflux',
    id: '276018',
    value: 'R',
    sort: 18,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Order Influx',
  },
  {
    name: 'DueToRelated',
    id: '276019',
    value: 'S',
    sort: 19,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Due to Related',
  },
  {
    name: 'NewsPending',
    id: '276020',
    value: 'T',
    sort: 20,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'News Pending',
  },
  {
    name: 'AdditionalInfo',
    id: '276021',
    value: 'U',
    sort: 21,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Additional Info',
  },
  {
    name: 'AdditionalInfoDueToRelated',
    id: '276022',
    value: 'V',
    sort: 22,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Additional Info due to related',
  },
  {
    name: 'Resume',
    id: '276023',
    value: 'W',
    sort: 23,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Resume',
  },
  {
    name: 'ViewOfCommon',
    id: '276024',
    value: 'X',
    sort: 24,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'View of Common',
  },
  {
    name: 'VolumeAlert',
    id: '276025',
    value: 'Y',
    sort: 25,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Volume Alert',
  },
  {
    name: 'OrderImbalance',
    id: '276026',
    value: 'Z',
    sort: 26,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Order Imbalance',
  },
  {
    name: 'EquipmentChangeover',
    id: '276027',
    value: 'a',
    sort: 27,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Equipment Changeover',
  },
  {
    name: 'NoOpen',
    id: '276028',
    value: 'b',
    sort: 28,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'No Open / No Resume',
  },
  {
    name: 'RegularETH',
    id: '276029',
    value: 'c',
    sort: 29,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Regular ETH',
  },
  {
    name: 'AutomaticExecution',
    id: '276030',
    value: 'd',
    sort: 30,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Automatic Execution',
  },
  {
    name: 'AutomaticExecutionETH',
    id: '276031',
    value: 'e',
    sort: 31,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Automatic Execution ETH',
  },
  {
    name: 'FastMarketETH',
    id: '276032',
    value: 'f',
    sort: 32,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Fast Market ETH',
  },
  {
    name: 'InactiveETH',
    id: '276033',
    value: 'g',
    sort: 33,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Inactive ETH',
  },
  {
    name: 'Rotation',
    id: '276034',
    value: 'h',
    sort: 34,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Rotation',
  },
  {
    name: 'RotationETH',
    id: '276035',
    value: 'i',
    sort: 35,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Rotation ETH',
  },
  {
    name: 'Halt',
    id: '276036',
    value: 'j',
    sort: 36,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Halt',
  },
  {
    name: 'HaltETH',
    id: '276037',
    value: 'k',
    sort: 37,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Halt ETH',
  },
  {
    name: 'DueToNewsDissemination',
    id: '276038',
    value: 'l',
    sort: 38,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Due to News Dissemination',
  },
  {
    name: 'DueToNewsPending',
    id: '276039',
    value: 'm',
    sort: 39,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Due to News Pending',
  },
  {
    name: 'TradingResume',
    id: '276040',
    value: 'n',
    sort: 40,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Trading Resume',
  },
  {
    name: 'OutOfSequence',
    id: '276041',
    value: 'o',
    sort: 41,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Out of Sequence',
  },
  {
    name: 'BidSpecialist',
    id: '276042',
    value: 'p',
    sort: 42,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Bid Specialist',
  },
  {
    name: 'OfferSpecialist',
    id: '276043',
    value: 'q',
    sort: 43,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Offer Specialist',
  },
  {
    name: 'BidOfferSpecialist',
    id: '276044',
    value: 'r',
    sort: 44,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Bid Offer Specialist',
  },
  {
    name: 'EndOfDaySAM',
    id: '276045',
    value: 's',
    sort: 45,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'End of Day SAM',
  },
  {
    name: 'ForbiddenSAM',
    id: '276046',
    value: 't',
    sort: 46,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Forbidden SAM',
  },
  {
    name: 'FrozenSAM',
    id: '276047',
    value: 'u',
    sort: 47,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Frozen SAM',
  },
  {
    name: 'PreOpeningSAM',
    id: '276048',
    value: 'v',
    sort: 48,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'PreOpening SAM',
  },
  {
    name: 'OpeningSAM',
    id: '276049',
    value: 'w',
    sort: 49,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Opening SAM',
  },
  {
    name: 'OpenSAM',
    id: '276050',
    value: 'x',
    sort: 50,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Open SAM',
  },
  {
    name: 'SurveillanceSAM',
    id: '276051',
    value: 'y',
    sort: 51,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Surveillance SAM',
  },
  {
    name: 'SuspendedSAM',
    id: '276052',
    value: 'z',
    sort: 52,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Suspended SAM',
  },
  {
    name: 'ReservedSAM',
    id: '276053',
    value: '0',
    sort: 53,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Reserved SAM',
  },
  {
    name: 'NoActiveSAM',
    id: '276054',
    value: '1',
    sort: 54,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'No Active SAM',
  },
  {
    name: 'Restricted',
    id: '276055',
    value: '2',
    sort: 55,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Restricted',
  },
  {
    name: 'RestOfBookVWAP',
    id: '276056',
    value: '3',
    sort: 56,
    added: 'FIX.5.0',
    addedEP: '47',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Rest of Book VWAP',
  },
  {
    name: 'BetterPricesInConditionalOrders',
    id: '276057',
    value: '4',
    sort: 57,
    added: 'FIX.5.0',
    addedEP: '47',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Better Prices in Conditional Orders',
  },
  {
    name: 'MedianPrice',
    id: '276058',
    value: '5',
    sort: 58,
    added: 'FIX.5.0',
    addedEP: '61',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Median Price',
  },
  {
    name: 'FullCurve',
    id: '276059',
    value: '6',
    sort: 59,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Full Curve',
  },
  {
    name: 'FlatCurve',
    id: '276060',
    value: '7',
    sort: 60,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    tag: 276,
    type: 'MultipleStringValue',
    codeSet: 'QuoteConditionCodeSet',
    description: 'Flat Curve',
  },
  {
    name: 'Cash',
    id: '277001',
    value: 'A',
    sort: 0,
    added: 'FIX.4.2',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Cash (only) Market',
  },
  {
    name: 'AveragePriceTrade',
    id: '277002',
    value: 'B',
    sort: 1,
    added: 'FIX.4.2',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Average Price Trade',
  },
  {
    name: 'CashTrade',
    id: '277003',
    value: 'C',
    sort: 2,
    added: 'FIX.4.2',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Cash Trade (same day clearing)',
  },
  {
    name: 'NextDay',
    id: '277004',
    value: 'D',
    sort: 3,
    added: 'FIX.4.2',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Next Day (only)Market',
  },
  {
    name: 'Opening',
    id: '277005',
    value: 'E',
    sort: 4,
    added: 'FIX.4.2',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Opening/Reopening Trade Detail',
  },
  {
    name: 'IntradayTradeDetail',
    id: '277006',
    value: 'F',
    sort: 5,
    added: 'FIX.4.2',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Intraday Trade Detail',
  },
  {
    name: 'Rule127Trade',
    id: '277007',
    value: 'G',
    sort: 6,
    added: 'FIX.4.2',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Rule 127 Trade (NYSE)',
  },
  {
    name: 'Rule155Trade',
    id: '277008',
    value: 'H',
    sort: 7,
    added: 'FIX.4.2',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Rule 155 Trade (AMEX)',
  },
  {
    name: 'SoldLast',
    id: '277009',
    value: 'I',
    sort: 8,
    added: 'FIX.4.2',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Sold Last (late reporting)',
  },
  {
    name: 'NextDayTrade',
    id: '277010',
    value: 'J',
    sort: 9,
    added: 'FIX.4.2',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Next Day Trade (next day clearing)',
  },
  {
    name: 'Opened',
    id: '277011',
    value: 'K',
    sort: 10,
    added: 'FIX.4.2',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Opened (late report of opened trade)',
  },
  {
    name: 'Seller',
    id: '277012',
    value: 'L',
    sort: 11,
    added: 'FIX.4.2',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Seller',
  },
  {
    name: 'Sold',
    id: '277013',
    value: 'M',
    sort: 12,
    added: 'FIX.4.2',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Sold (out of sequence)',
  },
  {
    name: 'StoppedStock',
    id: '277014',
    value: 'N',
    sort: 13,
    added: 'FIX.4.2',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Stopped Stock (guarantee of price but does not execute the order)',
  },
  {
    name: 'ImbalanceMoreBuyers',
    id: '277015',
    value: 'P',
    sort: 14,
    added: 'FIX.4.3',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Imbalance More Buyers (cannot be used in combination with Q)',
  },
  {
    name: 'ImbalanceMoreSellers',
    id: '277016',
    value: 'Q',
    sort: 15,
    added: 'FIX.4.3',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Imbalance More Sellers (cannot be used in combination with P)',
  },
  {
    name: 'OpeningPrice',
    id: '277017',
    value: 'R',
    sort: 16,
    added: 'FIX.4.3',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Opening Price',
  },
  {
    name: 'BargainCondition',
    id: '277018',
    value: 'S',
    sort: 17,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Bargain Condition (LSE)',
  },
  {
    name: 'ConvertedPriceIndicator',
    id: '277019',
    value: 'T',
    sort: 18,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Converted Price Indicator',
  },
  {
    name: 'ExchangeLast',
    id: '277020',
    value: 'U',
    sort: 19,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Exchange Last',
  },
  {
    name: 'FinalPriceOfSession',
    id: '277021',
    value: 'V',
    sort: 20,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Final Price of Session',
  },
  {
    name: 'ExPit',
    id: '277022',
    value: 'W',
    sort: 21,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Ex-pit',
  },
  {
    name: 'Crossed',
    id: '277023',
    value: 'X',
    sort: 22,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Crossed',
  },
  {
    name: 'TradesResultingFromManual',
    id: '277024',
    value: 'Y',
    sort: 23,
    added: 'FIX.4.4',
    addedEP: '6',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Trades resulting from manual/slow quote',
  },
  {
    name: 'TradesResultingFromIntermarketSweep',
    id: '277025',
    value: 'Z',
    sort: 24,
    added: 'FIX.4.4',
    addedEP: '6',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Trades resulting from intermarket sweep',
  },
  {
    name: 'VolumeOnly',
    id: '277026',
    value: 'a',
    sort: 25,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Volume Only',
  },
  {
    name: 'DirectPlus',
    id: '277027',
    value: 'b',
    sort: 26,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Direct Plus',
  },
  {
    name: 'Acquisition',
    id: '277028',
    value: 'c',
    sort: 27,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Acquisition',
  },
  {
    name: 'Bunched',
    id: '277029',
    value: 'd',
    sort: 28,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Bunched',
  },
  {
    name: 'Distribution',
    id: '277030',
    value: 'e',
    sort: 29,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Distribution',
  },
  {
    name: 'BunchedSale',
    id: '277031',
    value: 'f',
    sort: 30,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Bunched Sale',
  },
  {
    name: 'SplitTrade',
    id: '277032',
    value: 'g',
    sort: 31,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Split Trade',
  },
  {
    name: 'CancelStopped',
    id: '277033',
    value: 'h',
    sort: 32,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Cancel Stopped',
  },
  {
    name: 'CancelETH',
    id: '277034',
    value: 'i',
    sort: 33,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Cancel ETH',
  },
  {
    name: 'CancelStoppedETH',
    id: '277035',
    value: 'j',
    sort: 34,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Cancel Stopped ETH',
  },
  {
    name: 'OutOfSequenceETH',
    id: '277036',
    value: 'k',
    sort: 35,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Out of Sequence ETH',
  },
  {
    name: 'CancelLastETH',
    id: '277037',
    value: 'l',
    sort: 36,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Cancel Last ETH',
  },
  {
    name: 'SoldLastSaleETH',
    id: '277038',
    value: 'm',
    sort: 37,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Sold Last Sale ETH',
  },
  {
    name: 'CancelLast',
    id: '277039',
    value: 'n',
    sort: 38,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Cancel Last',
  },
  {
    name: 'SoldLastSale',
    id: '277040',
    value: 'o',
    sort: 39,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Sold Last Sale',
  },
  {
    name: 'CancelOpen',
    id: '277041',
    value: 'p',
    sort: 40,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Cancel Open',
  },
  {
    name: 'CancelOpenETH',
    id: '277042',
    value: 'q',
    sort: 41,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Cancel Open ETH',
  },
  {
    name: 'OpenedSaleETH',
    id: '277043',
    value: 'r',
    sort: 42,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Opened Sale ETH',
  },
  {
    name: 'CancelOnly',
    id: '277044',
    value: 's',
    sort: 43,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Cancel Only',
  },
  {
    name: 'CancelOnlyETH',
    id: '277045',
    value: 't',
    sort: 44,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Cancel Only ETH',
  },
  {
    name: 'LateOpenETH',
    id: '277046',
    value: 'u',
    sort: 45,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Late Open ETH',
  },
  {
    name: 'AutoExecutionETH',
    id: '277047',
    value: 'v',
    sort: 46,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Auto Execution ETH',
  },
  {
    name: 'Reopen',
    id: '277048',
    value: 'w',
    sort: 47,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Reopen',
  },
  {
    name: 'ReopenETH',
    id: '277049',
    value: 'x',
    sort: 48,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Reopen ETH',
  },
  {
    name: 'Adjusted',
    id: '277050',
    value: 'y',
    sort: 49,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Adjusted',
  },
  {
    name: 'AdjustedETH',
    id: '277051',
    value: 'z',
    sort: 50,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Adjusted ETH',
  },
  {
    name: 'Spread',
    id: '277052',
    value: 'AA',
    sort: 51,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Spread',
  },
  {
    name: 'SpreadETH',
    id: '277053',
    value: 'AB',
    sort: 52,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Spread ETH',
  },
  {
    name: 'Straddle',
    id: '277054',
    value: 'AC',
    sort: 53,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Straddle',
  },
  {
    name: 'StraddleETH',
    id: '277055',
    value: 'AD',
    sort: 54,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Straddle ETH',
  },
  {
    name: 'Stopped',
    id: '277056',
    value: 'AE',
    sort: 55,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Stopped',
  },
  {
    name: 'StoppedETH',
    id: '277057',
    value: 'AF',
    sort: 56,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Stopped ETH',
  },
  {
    name: 'RegularETH',
    id: '277058',
    value: 'AG',
    sort: 57,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Regular ETH',
  },
  {
    name: 'Combo',
    id: '277059',
    value: 'AH',
    sort: 58,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Combo',
  },
  {
    name: 'ComboETH',
    id: '277060',
    value: 'AI',
    sort: 59,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Combo ETH',
  },
  {
    name: 'OfficialClosingPrice',
    id: '277061',
    value: 'AJ',
    sort: 60,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Official Closing Price',
  },
  {
    name: 'PriorReferencePrice',
    id: '277062',
    value: 'AK',
    sort: 61,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Prior Reference Price',
  },
  {
    name: 'StoppedSoldLast',
    id: '277063',
    value: 'AL',
    sort: 71,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Stopped Sold Last',
  },
  {
    name: 'StoppedOutOfSequence',
    id: '277064',
    value: 'AM',
    sort: 72,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Stopped Out of Sequence',
  },
  {
    name: 'OfficialClosingPriceDup',
    id: '277065',
    value: 'AN',
    sort: 73,
    added: 'FIX.4.4',
    addedEP: '7',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: "Official Closing Price (duplicate enumeration - use 'AJ' instead)",
  },
  {
    name: 'CrossedOld',
    id: '277066',
    value: 'AO',
    sort: 74,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: "Crossed (duplicate enumeration - use 'X' instead)",
  },
  {
    name: 'FastMarket',
    id: '277067',
    value: 'AP',
    sort: 75,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Fast Market',
  },
  {
    name: 'AutomaticExecution',
    id: '277068',
    value: 'AQ',
    sort: 76,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Automatic Execution',
  },
  {
    name: 'FormT',
    id: '277069',
    value: 'AR',
    sort: 77,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Form T',
  },
  {
    name: 'BasketIndex',
    id: '277070',
    value: 'AS',
    sort: 78,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Basket Index',
  },
  {
    name: 'BurstBasket',
    id: '277071',
    value: 'AT',
    sort: 79,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Burst Basket',
  },
  {
    name: 'TradeThroughExempt',
    id: '277072',
    value: 'AU',
    sort: 80,
    added: 'FIX.5.0SP2',
    addedEP: '190',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Trade through exempt\n\nTrade ignored prices on away markets.',
  },
  {
    name: 'QuoteSpread',
    id: '277073',
    value: 'AV',
    sort: 81,
    added: 'FIX.5.0',
    addedEP: '47',
    updated: 'FIX.5.0SP2',
    updatedEP: '190',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Quote spread',
  },
  {
    name: 'LastAuctionPrice',
    id: '277074',
    value: 'AW',
    sort: 82,
    added: 'FIX.5.0SP2',
    addedEP: '190',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Last auction price\n\nTrade represents outcome of last auction',
  },
  {
    name: 'HighPrice',
    id: '277075',
    value: 'AX',
    sort: 83,
    added: 'FIX.5.0SP2',
    addedEP: '190',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'High price\n\nTrade establishes new high price for the session',
  },
  {
    name: 'LowPrice',
    id: '277076',
    value: 'AY',
    sort: 84,
    added: 'FIX.5.0SP2',
    addedEP: '190',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Low price\n\nTrade establishes new low price for the session',
  },
  {
    name: 'SystematicInternaliser',
    id: '277077',
    value: 'AZ',
    sort: 85,
    added: 'FIX.5.0SP2',
    addedEP: '190',
    updated: 'FIX.5.0SP2',
    updatedEP: '228',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description:
      'Systematic Internaliser (SI)\n\nTrade conducted by Systematic Internaliser (SI).',
  },
  {
    name: 'AwayMarket',
    id: '277078',
    value: 'BA',
    sort: 86,
    added: 'FIX.5.0SP2',
    addedEP: '190',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Away market\n\nTrade conducted on away market',
  },
  {
    name: 'MidpointPrice',
    id: '277079',
    value: 'BB',
    sort: 87,
    added: 'FIX.5.0SP2',
    addedEP: '190',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Mid-point price\n\nTrade represents current midpoint price',
  },
  {
    name: 'TradedBeforeIssueDate',
    id: '277080',
    value: 'BC',
    sort: 88,
    added: 'FIX.5.0SP2',
    addedEP: '190',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description:
      'Traded before issue date\n\nTrade conducted during subscription phase of new issue',
  },
  {
    name: 'PreviousClosingPrice',
    id: '277081',
    value: 'BD',
    sort: 89,
    added: 'FIX.5.0SP2',
    addedEP: '190',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description:
      'Previous closing price\n\nTrade represents closing price of previous business day',
  },
  {
    name: 'NationalBestBidOffer',
    id: '277082',
    value: 'BE',
    sort: 90,
    added: 'FIX.5.0SP2',
    addedEP: '190',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description:
      'National Best Bid and Offer\n\nTrade price within National Best Bid and Offer (NBBO)',
  },
  {
    name: 'Cancel',
    id: '277083',
    value: '0',
    sort: 98,
    added: 'FIX.4.4',
    addedEP: '7',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Cancel',
  },
  {
    name: 'ImpliedTrade',
    id: '277084',
    value: '1',
    sort: 99,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Implied Trade',
  },
  {
    name: 'MarketplaceEnteredTrade',
    id: '277085',
    value: '2',
    sort: 100,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Marketplace entered trade',
  },
  {
    name: 'MultiAssetClassMultilegTrade',
    id: '277086',
    value: '3',
    sort: 101,
    added: 'FIX.4.4',
    addedEP: '7',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Multi-asset class multileg trade',
  },
  {
    name: 'MultilegToMultilegTrade',
    id: '277087',
    value: '4',
    sort: 102,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Multileg-to-Multileg Trade',
  },
  {
    name: 'ShortSaleMinPrice',
    id: '277088',
    value: '5',
    sort: 103,
    added: 'FIX.5.0SP2',
    addedEP: '123',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description: 'Short Sale Minimum Price',
  },
  {
    name: 'Benchmark',
    id: '277089',
    value: '6',
    sort: 104,
    added: 'FIX.5.0SP2',
    addedEP: '163',
    deprecated: 'FIX.Latest',
    deprecatedEP: '268',
    tag: 277,
    type: 'MultipleStringValue',
    codeSet: 'TradeConditionCodeSet',
    description:
      'Benchmark\n\nMarket Model Typology (MMT) terminology: The "benchmark" price depends on a benchmark which has no current price but derived from a time series such as a VWAP.',
  },
  {
    name: 'New',
    id: '279001',
    value: '0',
    sort: 1,
    added: 'FIX.4.2',
    tag: 279,
    type: 'char',
    codeSet: 'MDUpdateActionCodeSet',
    description: 'New',
  },
  {
    name: 'Change',
    id: '279002',
    value: '1',
    sort: 2,
    added: 'FIX.4.2',
    tag: 279,
    type: 'char',
    codeSet: 'MDUpdateActionCodeSet',
    description: 'Change',
  },
  {
    name: 'Delete',
    id: '279003',
    value: '2',
    sort: 3,
    added: 'FIX.4.2',
    tag: 279,
    type: 'char',
    codeSet: 'MDUpdateActionCodeSet',
    description: 'Delete',
  },
  {
    name: 'DeleteThru',
    id: '279004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 279,
    type: 'char',
    codeSet: 'MDUpdateActionCodeSet',
    description: 'Delete Thru',
  },
  {
    name: 'DeleteFrom',
    id: '279005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    addedEP: '7',
    tag: 279,
    type: 'char',
    codeSet: 'MDUpdateActionCodeSet',
    description: 'Delete From',
  },
  {
    name: 'Overlay',
    id: '279006',
    value: '5',
    sort: 10,
    added: 'FIX.5.0',
    addedEP: '42',
    tag: 279,
    type: 'char',
    codeSet: 'MDUpdateActionCodeSet',
    description: 'Overlay',
  },
  {
    name: 'UnknownSymbol',
    id: '281001',
    value: '0',
    sort: 1,
    added: 'FIX.4.2',
    tag: 281,
    type: 'char',
    codeSet: 'MDReqRejReasonCodeSet',
    description: 'Unknown symbol',
  },
  {
    name: 'DuplicateMDReqID',
    id: '281002',
    value: '1',
    sort: 2,
    added: 'FIX.4.2',
    tag: 281,
    type: 'char',
    codeSet: 'MDReqRejReasonCodeSet',
    description: 'Duplicate MDReqID',
  },
  {
    name: 'InsufficientBandwidth',
    id: '281003',
    value: '2',
    sort: 3,
    added: 'FIX.4.2',
    tag: 281,
    type: 'char',
    codeSet: 'MDReqRejReasonCodeSet',
    description: 'Insufficient Bandwidth',
  },
  {
    name: 'InsufficientPermissions',
    id: '281004',
    value: '3',
    sort: 4,
    added: 'FIX.4.2',
    tag: 281,
    type: 'char',
    codeSet: 'MDReqRejReasonCodeSet',
    description: 'Insufficient Permissions',
  },
  {
    name: 'UnsupportedSubscriptionRequestType',
    id: '281005',
    value: '4',
    sort: 5,
    added: 'FIX.4.2',
    tag: 281,
    type: 'char',
    codeSet: 'MDReqRejReasonCodeSet',
    description: 'Unsupported SubscriptionRequestType',
  },
  {
    name: 'UnsupportedMarketDepth',
    id: '281006',
    value: '5',
    sort: 6,
    added: 'FIX.4.2',
    tag: 281,
    type: 'char',
    codeSet: 'MDReqRejReasonCodeSet',
    description: 'Unsupported MarketDepth',
  },
  {
    name: 'UnsupportedMDUpdateType',
    id: '281007',
    value: '6',
    sort: 7,
    added: 'FIX.4.2',
    tag: 281,
    type: 'char',
    codeSet: 'MDReqRejReasonCodeSet',
    description: 'Unsupported MDUpdateType',
  },
  {
    name: 'UnsupportedAggregatedBook',
    id: '281008',
    value: '7',
    sort: 8,
    added: 'FIX.4.2',
    tag: 281,
    type: 'char',
    codeSet: 'MDReqRejReasonCodeSet',
    description: 'Unsupported AggregatedBook',
  },
  {
    name: 'UnsupportedMDEntryType',
    id: '281009',
    value: '8',
    sort: 9,
    added: 'FIX.4.2',
    tag: 281,
    type: 'char',
    codeSet: 'MDReqRejReasonCodeSet',
    description: 'Unsupported MDEntryType',
  },
  {
    name: 'UnsupportedTradingSessionID',
    id: '281010',
    value: '9',
    sort: 10,
    added: 'FIX.4.3',
    tag: 281,
    type: 'char',
    codeSet: 'MDReqRejReasonCodeSet',
    description: 'Unsupported TradingSessionID',
  },
  {
    name: 'UnsupportedScope',
    id: '281011',
    value: 'A',
    sort: 11,
    added: 'FIX.4.3',
    tag: 281,
    type: 'char',
    codeSet: 'MDReqRejReasonCodeSet',
    description: 'Unsupported Scope',
  },
  {
    name: 'UnsupportedOpenCloseSettleFlag',
    id: '281012',
    value: 'B',
    sort: 12,
    added: 'FIX.4.3',
    tag: 281,
    type: 'char',
    codeSet: 'MDReqRejReasonCodeSet',
    description: 'Unsupported OpenCloseSettleFlag',
  },
  {
    name: 'UnsupportedMDImplicitDelete',
    id: '281013',
    value: 'C',
    sort: 13,
    added: 'FIX.4.3',
    tag: 281,
    type: 'char',
    codeSet: 'MDReqRejReasonCodeSet',
    description: 'Unsupported MDImplicitDelete',
  },
  {
    name: 'InsufficientCredit',
    id: '281014',
    value: 'D',
    sort: 14,
    added: 'FIX.4.4',
    addedEP: '21',
    tag: 281,
    type: 'char',
    codeSet: 'MDReqRejReasonCodeSet',
    description: 'Insufficient credit',
  },
  {
    name: 'Cancellation',
    id: '285001',
    value: '0',
    sort: 1,
    added: 'FIX.4.2',
    tag: 285,
    type: 'char',
    codeSet: 'DeleteReasonCodeSet',
    description: 'Cancellation / Trade Bust',
  },
  {
    name: 'Error',
    id: '285002',
    value: '1',
    sort: 2,
    added: 'FIX.4.2',
    tag: 285,
    type: 'char',
    codeSet: 'DeleteReasonCodeSet',
    description: 'Error',
  },
  {
    name: 'DailyOpen',
    id: '286001',
    value: '0',
    sort: 1,
    added: 'FIX.4.2',
    tag: 286,
    type: 'MultipleCharValue',
    codeSet: 'OpenCloseSettlFlagCodeSet',
    description: 'Daily Open / Close / Settlement entry',
  },
  {
    name: 'SessionOpen',
    id: '286002',
    value: '1',
    sort: 2,
    added: 'FIX.4.2',
    tag: 286,
    type: 'MultipleCharValue',
    codeSet: 'OpenCloseSettlFlagCodeSet',
    description: 'Session Open / Close / Settlement entry',
  },
  {
    name: 'DeliverySettlementEntry',
    id: '286003',
    value: '2',
    sort: 3,
    added: 'FIX.4.2',
    tag: 286,
    type: 'MultipleCharValue',
    codeSet: 'OpenCloseSettlFlagCodeSet',
    description: 'Delivery Settlement entry',
  },
  {
    name: 'ExpectedEntry',
    id: '286004',
    value: '3',
    sort: 4,
    added: 'FIX.4.3',
    tag: 286,
    type: 'MultipleCharValue',
    codeSet: 'OpenCloseSettlFlagCodeSet',
    description: 'Expected entry',
  },
  {
    name: 'EntryFromPreviousBusinessDay',
    id: '286005',
    value: '4',
    sort: 5,
    added: 'FIX.4.3',
    tag: 286,
    type: 'MultipleCharValue',
    codeSet: 'OpenCloseSettlFlagCodeSet',
    description: 'Entry from previous business day',
  },
  {
    name: 'TheoreticalPriceValue',
    id: '286006',
    value: '5',
    sort: 6,
    added: 'FIX.4.4',
    tag: 286,
    type: 'MultipleCharValue',
    codeSet: 'OpenCloseSettlFlagCodeSet',
    description: 'Theoretical Price value',
  },
  {
    name: 'Bankrupt',
    id: '291001',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    tag: 291,
    type: 'MultipleCharValue',
    codeSet: 'FinancialStatusCodeSet',
    description: 'Bankrupt',
  },
  {
    name: 'PendingDelisting',
    id: '291002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 291,
    type: 'MultipleCharValue',
    codeSet: 'FinancialStatusCodeSet',
    description: 'Pending delisting',
  },
  {
    name: 'Restricted',
    id: '291003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '12',
    tag: 291,
    type: 'MultipleCharValue',
    codeSet: 'FinancialStatusCodeSet',
    description: 'Restricted',
  },
  {
    name: 'ExDividend',
    id: '292001',
    value: 'A',
    sort: 1,
    added: 'FIX.4.2',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Ex-Dividend',
  },
  {
    name: 'ExDistribution',
    id: '292002',
    value: 'B',
    sort: 2,
    added: 'FIX.4.2',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Ex-Distribution',
  },
  {
    name: 'ExRights',
    id: '292003',
    value: 'C',
    sort: 3,
    added: 'FIX.4.2',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Ex-Rights',
  },
  {
    name: 'New',
    id: '292004',
    value: 'D',
    sort: 4,
    added: 'FIX.4.2',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'New',
  },
  {
    name: 'ExInterest',
    id: '292005',
    value: 'E',
    sort: 5,
    added: 'FIX.4.2',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Ex-Interest',
  },
  {
    name: 'CashDividend',
    id: '292006',
    value: 'F',
    sort: 6,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Cash Dividend',
  },
  {
    name: 'StockDividend',
    id: '292007',
    value: 'G',
    sort: 7,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Stock Dividend',
  },
  {
    name: 'NonIntegerStockSplit',
    id: '292008',
    value: 'H',
    sort: 8,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Non-Integer Stock Split',
  },
  {
    name: 'ReverseStockSplit',
    id: '292009',
    value: 'I',
    sort: 9,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Reverse Stock Split',
  },
  {
    name: 'StandardIntegerStockSplit',
    id: '292010',
    value: 'J',
    sort: 10,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Standard-Integer Stock Split',
  },
  {
    name: 'PositionConsolidation',
    id: '292011',
    value: 'K',
    sort: 11,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Position Consolidation',
  },
  {
    name: 'LiquidationReorganization',
    id: '292012',
    value: 'L',
    sort: 12,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Liquidation Reorganization',
  },
  {
    name: 'MergerReorganization',
    id: '292013',
    value: 'M',
    sort: 13,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Merger Reorganization',
  },
  {
    name: 'RightsOffering',
    id: '292014',
    value: 'N',
    sort: 14,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Rights Offering',
  },
  {
    name: 'ShareholderMeeting',
    id: '292015',
    value: 'O',
    sort: 15,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Shareholder Meeting',
  },
  {
    name: 'Spinoff',
    id: '292016',
    value: 'P',
    sort: 16,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Spinoff',
  },
  {
    name: 'TenderOffer',
    id: '292017',
    value: 'Q',
    sort: 17,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Tender Offer',
  },
  {
    name: 'Warrant',
    id: '292018',
    value: 'R',
    sort: 18,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Warrant',
  },
  {
    name: 'SpecialAction',
    id: '292019',
    value: 'S',
    sort: 19,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Special Action',
  },
  {
    name: 'SymbolConversion',
    id: '292020',
    value: 'T',
    sort: 20,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Symbol Conversion',
  },
  {
    name: 'CUSIP',
    id: '292021',
    value: 'U',
    sort: 21,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'CUSIP / Name Change',
  },
  {
    name: 'LeapRollover',
    id: '292022',
    value: 'V',
    sort: 22,
    added: 'FIX.4.4',
    addedEP: '8',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Leap Rollover',
  },
  {
    name: 'SuccessionEvent',
    id: '292023',
    value: 'W',
    sort: 99,
    added: 'FIX.5.0',
    addedEP: '42',
    tag: 292,
    type: 'MultipleCharValue',
    codeSet: 'CorporateActionCodeSet',
    description: 'Succession Event',
  },
  {
    name: 'Accepted',
    id: '297001',
    value: '0',
    sort: 0,
    added: 'FIX.4.2',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'CancelForSymbol',
    id: '297002',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP2',
    updatedEP: '126',
    deprecated: 'FIX.5.0',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Canceled for specific securities',
  },
  {
    name: 'CanceledForSecurityType',
    id: '297003',
    value: '2',
    sort: 2,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP2',
    updatedEP: '126',
    deprecated: 'FIX.5.0',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Canceled for specific SecurityTypes(167)',
  },
  {
    name: 'CanceledForUnderlying',
    id: '297004',
    value: '3',
    sort: 3,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP2',
    updatedEP: '126',
    deprecated: 'FIX.5.0',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Canceled for underlying',
  },
  {
    name: 'CanceledAll',
    id: '297005',
    value: '4',
    sort: 4,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP2',
    updatedEP: '126',
    deprecated: 'FIX.5.0',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Canceled all',
  },
  {
    name: 'Rejected',
    id: '297006',
    value: '5',
    sort: 5,
    added: 'FIX.4.2',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'RemovedFromMarket',
    id: '297007',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '126',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Removed from market',
  },
  {
    name: 'Expired',
    id: '297008',
    value: '7',
    sort: 7,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '290',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description:
      'Expired\n\nIn the context of IA FX Reject codes, Trade Request Rejection Category A-2, this may be used to indicate price or liquidity is unavailable due to "last look latency".',
  },
  {
    name: 'Query',
    id: '297009',
    value: '8',
    sort: 8,
    added: 'FIX.4.3',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Query',
  },
  {
    name: 'QuoteNotFound',
    id: '297010',
    value: '9',
    sort: 9,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '126',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Quote not found',
  },
  {
    name: 'Pending',
    id: '297011',
    value: '10',
    sort: 10,
    added: 'FIX.4.3',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Pending',
  },
  {
    name: 'Pass',
    id: '297012',
    value: '11',
    sort: 11,
    added: 'FIX.4.4',
    updated: 'FIX.Latest',
    updatedEP: '290',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description:
      'Pass\n\nIn the context of IA FX Reject codes, Trade Request Rejection Category A-1, this is used by price maker to pass due to a "last look".',
  },
  {
    name: 'LockedMarketWarning',
    id: '297013',
    value: '12',
    sort: 12,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '126',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Locked market warning',
  },
  {
    name: 'CrossMarketWarning',
    id: '297014',
    value: '13',
    sort: 13,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '126',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Crossed market warning',
  },
  {
    name: 'CanceledDueToLockMarket',
    id: '297015',
    value: '14',
    sort: 14,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '126',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Canceled due to locked market',
  },
  {
    name: 'CanceledDueToCrossMarket',
    id: '297016',
    value: '15',
    sort: 15,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '195',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Canceled due to crossed market',
  },
  {
    name: 'Active',
    id: '297017',
    value: '16',
    sort: 16,
    added: 'FIX.5.0',
    addedEP: '45',
    updated: 'FIX.5.0SP2',
    updatedEP: '126',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Active',
  },
  {
    name: 'Canceled',
    id: '297018',
    value: '17',
    sort: 17,
    added: 'FIX.5.0',
    addedEP: '45',
    updated: 'FIX.5.0SP2',
    updatedEP: '126',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Canceled',
  },
  {
    name: 'UnsolicitedQuoteReplenishment',
    id: '297019',
    value: '18',
    sort: 18,
    added: 'FIX.5.0',
    addedEP: '45',
    updated: 'FIX.5.0SP2',
    updatedEP: '126',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Unsolicited quote replenishment',
  },
  {
    name: 'PendingEndTrade',
    id: '297020',
    value: '19',
    sort: 19,
    added: 'FIX.5.0',
    addedEP: '68',
    updated: 'FIX.5.0SP2',
    updatedEP: '126',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Pending end trade',
  },
  {
    name: 'TooLateToEnd',
    id: '297021',
    value: '20',
    sort: 20,
    added: 'FIX.5.0',
    addedEP: '68',
    updated: 'FIX.5.0SP2',
    updatedEP: '126',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Too late to end',
  },
  {
    name: 'Traded',
    id: '297022',
    value: '21',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '126',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Traded',
  },
  {
    name: 'TradedAndRemoved',
    id: '297023',
    value: '22',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '126',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description: 'Traded and removed',
  },
  {
    name: 'ContractTerminates',
    id: '297024',
    value: '23',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '258',
    tag: 297,
    type: 'int',
    codeSet: 'QuoteStatusCodeSet',
    description:
      'Contract terminated\n\nIndicates a contract has been or is being terminated.',
  },
  {
    name: 'CancelForOneOrMoreSecurities',
    id: '298001',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 298,
    type: 'int',
    codeSet: 'QuoteCancelTypeCodeSet',
    description: 'Cancel quotes for one or more securities',
  },
  {
    name: 'CancelForSecurityType',
    id: '298002',
    value: '2',
    sort: 2,
    added: 'FIX.4.2',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 298,
    type: 'int',
    codeSet: 'QuoteCancelTypeCodeSet',
    description: 'Cancel quotes for security type(s)',
  },
  {
    name: 'CancelForUnderlyingSecurity',
    id: '298003',
    value: '3',
    sort: 3,
    added: 'FIX.4.2',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 298,
    type: 'int',
    codeSet: 'QuoteCancelTypeCodeSet',
    description: 'Cancel quotes for underlying security',
  },
  {
    name: 'CancelAllQuotes',
    id: '298004',
    value: '4',
    sort: 4,
    added: 'FIX.4.2',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 298,
    type: 'int',
    codeSet: 'QuoteCancelTypeCodeSet',
    description: 'Cancel all quotes',
  },
  {
    name: 'CancelSpecifiedSingleQuote',
    id: '298005',
    value: '5',
    sort: 5,
    added: 'FIX.4.4',
    addedEP: '21',
    updated: 'FIX.5.0SP2',
    updatedEP: '126',
    tag: 298,
    type: 'int',
    codeSet: 'QuoteCancelTypeCodeSet',
    description:
      'Cancel specified single quote\n\nCancel single quote specified in QuoteID(117) or SecondaryQuoteID(1751)',
  },
  {
    name: 'CancelByTypeOfQuote',
    id: '298006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP1',
    addedEP: '78',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 298,
    type: 'int',
    codeSet: 'QuoteCancelTypeCodeSet',
    description:
      'Cancel by type of quote\n\nCancel quotes by type of quote specified in QuoteType(537)',
  },
  {
    name: 'CancelForSecurityIssuer',
    id: '298007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP1',
    addedEP: '85',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 298,
    type: 'int',
    codeSet: 'QuoteCancelTypeCodeSet',
    description: 'Cancel quotes for an issuer',
  },
  {
    name: 'CancelForIssuerOfUnderlyingSecurity',
    id: '298008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP1',
    addedEP: '85',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 298,
    type: 'int',
    codeSet: 'QuoteCancelTypeCodeSet',
    description: 'Cancel quotes for an issuer of underlying security',
  },
  {
    name: 'UnknownSymbol',
    id: '300001',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    updated: 'FIX.Latest',
    updatedEP: '290',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description:
      'Unknown symbol (security)\n\nIn the context of IA FX Reject codes, Trade Request Rejection Category F, this may be used with QuoteStatus(297)=5 (Rejected) to indicate product is not supported, e.g. by the specific venue, tenor restrictions on the market participant(s) involved.',
  },
  {
    name: 'Exchange',
    id: '300002',
    value: '2',
    sort: 2,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP2',
    updatedEP: '144',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description: 'Exchange (security) closed',
  },
  {
    name: 'QuoteRequestExceedsLimit',
    id: '300003',
    value: '3',
    sort: 3,
    added: 'FIX.4.2',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description: 'Quote Request exceeds limit',
  },
  {
    name: 'TooLateToEnter',
    id: '300004',
    value: '4',
    sort: 4,
    added: 'FIX.4.2',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description: 'Too late to enter',
  },
  {
    name: 'UnknownQuote',
    id: '300005',
    value: '5',
    sort: 5,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP2',
    updatedEP: '144',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description: 'Unknown quote',
  },
  {
    name: 'DuplicateQuote',
    id: '300006',
    value: '6',
    sort: 6,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP2',
    updatedEP: '144',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description: 'Duplicate quote',
  },
  {
    name: 'InvalidBid',
    id: '300007',
    value: '7',
    sort: 7,
    added: 'FIX.4.2',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description: 'Invalid bid/ask spread',
  },
  {
    name: 'InvalidPrice',
    id: '300008',
    value: '8',
    sort: 8,
    added: 'FIX.4.2',
    updated: 'FIX.Latest',
    updatedEP: '290',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description:
      'Invalid price\n\nIn the context of IA FX Reject codes, Trade Request Rejection Category A-2, this may be used with QuoteStatus(297)=5 (Rejected) to indicate price is not valid due to "last look latency".',
  },
  {
    name: 'NotAuthorizedToQuoteSecurity',
    id: '300009',
    value: '9',
    sort: 9,
    added: 'FIX.4.2',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description: 'Not authorized to quote security',
  },
  {
    name: 'PriceExceedsCurrentPriceBand',
    id: '300010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0',
    addedEP: '43',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description: 'Price exceeds current price band',
  },
  {
    name: 'QuoteLocked',
    id: '300011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0',
    addedEP: '45',
    updated: 'FIX.5.0SP2',
    updatedEP: '144',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description: 'Quote locked - unable to update/cancel',
  },
  {
    name: 'InvalidOrUnknownSecurityIssuer',
    id: '300012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP1',
    addedEP: '85',
    updated: 'FIX.5.0SP2',
    updatedEP: '144',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description: 'Invalid or unknown security issuer',
  },
  {
    name: 'InvalidOrUnknownIssuerOfUnderlyingSecurity',
    id: '300013',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP1',
    addedEP: '85',
    updated: 'FIX.5.0SP2',
    updatedEP: '144',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description: 'Invalid or unknown issuer of underlying security',
  },
  {
    name: 'NotionalValueExceedsThreshold',
    id: '300014',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '144',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description: 'Notional value exceeds threshold',
  },
  {
    name: 'PriceExceedsCurrentPriceBandDepr',
    id: '300015',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '144',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    deprecated: 'FIX.5.0SP2',
    deprecatedEP: '171',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description: 'Price exceeds current price band',
  },
  {
    name: 'ReferencePriceNotAvailable',
    id: '300016',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '144',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description: 'Reference price not available',
  },
  {
    name: 'InsufficientCreditLimit',
    id: '300017',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    updated: 'FIX.Latest',
    updatedEP: '290',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description:
      'Insufficient credit limit\n\nIn the context of IA FX Reject codes, Trade Request Rejection Category C, this may be used with QuoteStatus(297)=5 (Rejected) to indicate credit limit is exceeded or not in place.',
  },
  {
    name: 'ExceededClipSizeLimit',
    id: '300018',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description: 'Exceeded clip size limit',
  },
  {
    name: 'ExceededMaxNotionalOrderAmt',
    id: '300019',
    value: '19',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description: 'Exceeded maximum notional order amount',
  },
  {
    name: 'ExceededDV01PV01Limit',
    id: '300020',
    value: '20',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description: 'Exceeded DV01/PV01 limit',
  },
  {
    name: 'ExceededCS01Limit',
    id: '300021',
    value: '21',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description: 'Exceeded CS01 limit',
  },
  {
    name: 'UnavailablePriceLiquidity',
    id: '300022',
    value: '22',
    sort: 22,
    added: 'FIX.Latest',
    addedEP: '290',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description:
      'Unavailable price or liquidity\n\nIn the context of IA FX Reject codes, Trade Request Rejection Category B, this may be used with QuoteStatus(297)=5 (Rejected) to indicate the "Hit/lift" was not subjected to last look but pricing or liquidity is no longer available for execution.',
  },
  {
    name: 'InvalidMissingEntitlements',
    id: '300023',
    value: '23',
    sort: 23,
    added: 'FIX.Latest',
    addedEP: '290',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description:
      'Invalid or missing entitlements\n\nIn the context of IA FX Reject codes, Trade Request Rejection Category D, this may be used with QuoteStatus(297)=5 (Rejected) to indicate the counterparty is not authorized or has missing entitlements.',
  },
  {
    name: 'UnknownAccounts',
    id: '300024',
    value: '24',
    sort: 24,
    added: 'FIX.Latest',
    addedEP: '290',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description:
      'Unknown account(s)\n\nIn the context of IA FX Reject codes, Trade Request Rejection Category D, this may be used with QuoteStatus(297)=5 (Rejected) to indicate the account/fund is unknown or not setup.',
  },
  {
    name: 'Other',
    id: '300025',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    updated: 'FIX.Latest',
    updatedEP: '290',
    tag: 300,
    type: 'int',
    codeSet: 'QuoteRejectReasonCodeSet',
    description:
      'Other\n\nIn the context of IA FX Reject codes, Trade Request Rejection Category E, order rejected due to other exceptions. Further detail may be provided in RejectText(1328)or Text(58), with preference for RejectText(1328) if field is present in the message.',
  },
  {
    name: 'NoAcknowledgement',
    id: '301001',
    value: '0',
    sort: 1,
    added: 'FIX.4.2',
    tag: 301,
    type: 'int',
    codeSet: 'QuoteResponseLevelCodeSet',
    description: 'No Acknowledgement',
  },
  {
    name: 'AcknowledgeOnlyNegativeOrErroneousQuotes',
    id: '301002',
    value: '1',
    sort: 2,
    added: 'FIX.4.2',
    tag: 301,
    type: 'int',
    codeSet: 'QuoteResponseLevelCodeSet',
    description: 'Acknowledge only negative or erroneous quotes',
  },
  {
    name: 'AcknowledgeEachQuoteMessage',
    id: '301003',
    value: '2',
    sort: 3,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 301,
    type: 'int',
    codeSet: 'QuoteResponseLevelCodeSet',
    description: 'Acknowledge each quote message',
  },
  {
    name: 'SummaryAcknowledgement',
    id: '301004',
    value: '3',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '45',
    tag: 301,
    type: 'int',
    codeSet: 'QuoteResponseLevelCodeSet',
    description: 'Summary Acknowledgement',
  },
  {
    name: 'Manual',
    id: '303001',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    tag: 303,
    type: 'int',
    codeSet: 'QuoteRequestTypeCodeSet',
    description: 'Manual',
  },
  {
    name: 'Automatic',
    id: '303002',
    value: '2',
    sort: 2,
    added: 'FIX.4.2',
    tag: 303,
    type: 'int',
    codeSet: 'QuoteRequestTypeCodeSet',
    description: 'Automatic',
  },
  {
    name: 'ConfirmQuote',
    id: '303003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '126',
    tag: 303,
    type: 'int',
    codeSet: 'QuoteRequestTypeCodeSet',
    description: 'Confirm quote',
  },
  {
    name: 'RequestSecurityIdentityAndSpecifications',
    id: '321001',
    value: '0',
    sort: 1,
    added: 'FIX.4.2',
    tag: 321,
    type: 'int',
    codeSet: 'SecurityRequestTypeCodeSet',
    description: 'Request Security identity and specifications',
  },
  {
    name: 'RequestSecurityIdentityForSpecifications',
    id: '321002',
    value: '1',
    sort: 2,
    added: 'FIX.4.2',
    tag: 321,
    type: 'int',
    codeSet: 'SecurityRequestTypeCodeSet',
    description:
      'Request Security identity for the specifications provided (name of the security is not supplied)',
  },
  {
    name: 'RequestListSecurityTypes',
    id: '321003',
    value: '2',
    sort: 3,
    added: 'FIX.4.2',
    deprecated: 'FIX.5.0SP1',
    tag: 321,
    type: 'int',
    codeSet: 'SecurityRequestTypeCodeSet',
    description: 'Request List Security Types',
  },
  {
    name: 'RequestListSecurities',
    id: '321004',
    value: '3',
    sort: 4,
    added: 'FIX.4.2',
    deprecated: 'FIX.5.0SP1',
    tag: 321,
    type: 'int',
    codeSet: 'SecurityRequestTypeCodeSet',
    description:
      'Request List Securities (can be qualified with Symbol, SecurityType, TradingSessionID, SecurityExchange. If provided then only list Securities for the specific type.)',
  },
  {
    name: 'Symbol',
    id: '321005',
    value: '4',
    sort: 5,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 321,
    type: 'int',
    codeSet: 'SecurityRequestTypeCodeSet',
    description: 'Symbol',
  },
  {
    name: 'SecurityTypeAndOrCFICode',
    id: '321006',
    value: '5',
    sort: 6,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 321,
    type: 'int',
    codeSet: 'SecurityRequestTypeCodeSet',
    description: 'SecurityType and or CFICode',
  },
  {
    name: 'Product',
    id: '321007',
    value: '6',
    sort: 7,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 321,
    type: 'int',
    codeSet: 'SecurityRequestTypeCodeSet',
    description: 'Product',
  },
  {
    name: 'TradingSessionID',
    id: '321008',
    value: '7',
    sort: 8,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 321,
    type: 'int',
    codeSet: 'SecurityRequestTypeCodeSet',
    description: 'TradingSessionID',
  },
  {
    name: 'AllSecurities',
    id: '321009',
    value: '8',
    sort: 9,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 321,
    type: 'int',
    codeSet: 'SecurityRequestTypeCodeSet',
    description: 'All Securities',
  },
  {
    name: 'MarketIDOrMarketID',
    id: '321010',
    value: '9',
    sort: 10,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 321,
    type: 'int',
    codeSet: 'SecurityRequestTypeCodeSet',
    description: 'MarketID or MarketID + MarketSegmentID',
  },
  {
    name: 'AcceptAsIs',
    id: '323001',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    tag: 323,
    type: 'int',
    codeSet: 'SecurityResponseTypeCodeSet',
    description: 'Accept security proposal as-is',
  },
  {
    name: 'AcceptWithRevisions',
    id: '323002',
    value: '2',
    sort: 2,
    added: 'FIX.4.2',
    tag: 323,
    type: 'int',
    codeSet: 'SecurityResponseTypeCodeSet',
    description: 'Accept security proposal with revisions as indicated in the message',
  },
  {
    name: 'ListOfSecurityTypesReturnedPerRequest',
    id: '323003',
    value: '3',
    sort: 3,
    added: 'FIX.4.2',
    deprecated: 'FIX.5.0SP1',
    tag: 323,
    type: 'int',
    codeSet: 'SecurityResponseTypeCodeSet',
    description: 'List of security types returned per request',
  },
  {
    name: 'ListOfSecuritiesReturnedPerRequest',
    id: '323004',
    value: '4',
    sort: 4,
    added: 'FIX.4.2',
    tag: 323,
    type: 'int',
    codeSet: 'SecurityResponseTypeCodeSet',
    description: 'List of securities returned per request',
  },
  {
    name: 'RejectSecurityProposal',
    id: '323005',
    value: '5',
    sort: 5,
    added: 'FIX.4.2',
    tag: 323,
    type: 'int',
    codeSet: 'SecurityResponseTypeCodeSet',
    description: 'Reject security proposal',
  },
  {
    name: 'CannotMatchSelectionCriteria',
    id: '323006',
    value: '6',
    sort: 6,
    added: 'FIX.4.2',
    tag: 323,
    type: 'int',
    codeSet: 'SecurityResponseTypeCodeSet',
    description: 'Cannot match selection criteria',
  },
  {
    name: 'MessageIsBeingSentAsAResultOfAPriorRequest',
    id: '325001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.2',
    tag: 325,
    type: 'Boolean',
    codeSet: 'UnsolicitedIndicatorCodeSet',
    description: 'Message is being sent as a result of a prior request',
  },
  {
    name: 'MessageIsBeingSentUnsolicited',
    id: '325002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 325,
    type: 'Boolean',
    codeSet: 'UnsolicitedIndicatorCodeSet',
    description: 'Message is being sent unsolicited',
  },
  {
    name: 'OpeningDelay',
    id: '326001',
    value: '1',
    sort: 0,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'Opening delay',
  },
  {
    name: 'TradingHalt',
    id: '326002',
    value: '2',
    sort: 1,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'Trading halt',
  },
  {
    name: 'Resume',
    id: '326003',
    value: '3',
    sort: 2,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'Resume',
  },
  {
    name: 'NoOpen',
    id: '326004',
    value: '4',
    sort: 3,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'No Open / No Resume',
  },
  {
    name: 'PriceIndication',
    id: '326005',
    value: '5',
    sort: 4,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'Price indication',
  },
  {
    name: 'TradingRangeIndication',
    id: '326006',
    value: '6',
    sort: 5,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'Trading Range Indication',
  },
  {
    name: 'MarketImbalanceBuy',
    id: '326007',
    value: '7',
    sort: 6,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'Market Imbalance Buy',
  },
  {
    name: 'MarketImbalanceSell',
    id: '326008',
    value: '8',
    sort: 7,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'Market Imbalance Sell',
  },
  {
    name: 'MarketOnCloseImbalanceBuy',
    id: '326009',
    value: '9',
    sort: 8,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'Market on Close Imbalance Buy',
  },
  {
    name: 'MarketOnCloseImbalanceSell',
    id: '326010',
    value: '10',
    sort: 9,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'Market on Close Imbalance Sell',
  },
  {
    name: 'NoMarketImbalance',
    id: '326011',
    value: '12',
    sort: 11,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'No Market Imbalance',
  },
  {
    name: 'NoMarketOnCloseImbalance',
    id: '326012',
    value: '13',
    sort: 12,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'No Market on Close Imbalance',
  },
  {
    name: 'ITSPreOpening',
    id: '326013',
    value: '14',
    sort: 13,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'ITS Pre-opening',
  },
  {
    name: 'NewPriceIndication',
    id: '326014',
    value: '15',
    sort: 14,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'New Price Indication',
  },
  {
    name: 'TradeDisseminationTime',
    id: '326015',
    value: '16',
    sort: 15,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'Trade Dissemination Time',
  },
  {
    name: 'ReadyToTrade',
    id: '326016',
    value: '17',
    sort: 16,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'Ready to trade (start of session)',
  },
  {
    name: 'NotAvailableForTrading',
    id: '326017',
    value: '18',
    sort: 17,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'Not available for trading (end of session)',
  },
  {
    name: 'NotTradedOnThisMarket',
    id: '326018',
    value: '19',
    sort: 18,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'Not traded on this market',
  },
  {
    name: 'UnknownOrInvalid',
    id: '326019',
    value: '20',
    sort: 19,
    added: 'FIX.4.2',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'Unknown or Invalid',
  },
  {
    name: 'PreOpen',
    id: '326020',
    value: '21',
    sort: 20,
    added: 'FIX.4.3',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'Pre-open',
  },
  {
    name: 'OpeningRotation',
    id: '326021',
    value: '22',
    sort: 21,
    added: 'FIX.4.3',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'Opening Rotation',
  },
  {
    name: 'FastMarket',
    id: '326022',
    value: '23',
    sort: 22,
    added: 'FIX.4.3',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'Fast Market',
  },
  {
    name: 'PreCross',
    id: '326023',
    value: '24',
    sort: 98,
    added: 'FIX.5.0',
    addedEP: '42',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description:
      'Pre-Cross - system is in a pre-cross state allowing market to respond to either side of cross',
  },
  {
    name: 'Cross',
    id: '326024',
    value: '25',
    sort: 99,
    added: 'FIX.5.0',
    addedEP: '42',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description:
      'Cross - system has crossed a percentage of the orders and allows market to respond prior to crossing remaining portion',
  },
  {
    name: 'PostClose',
    id: '326025',
    value: '26',
    sort: 100,
    added: 'FIX.5.0SP1',
    addedEP: '84',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'Post-close',
  },
  {
    name: 'NoCancel',
    id: '326026',
    value: '27',
    sort: 101,
    added: 'FIX.5.0SP2',
    addedEP: '114',
    tag: 326,
    type: 'int',
    codeSet: 'SecurityTradingStatusCodeSet',
    description: 'No-cancel',
  },
  {
    name: 'NewsDissemination',
    id: '327001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP1',
    addedEP: '86',
    tag: 327,
    type: 'int',
    codeSet: 'HaltReasonCodeSet',
    description: 'News Dissemination',
  },
  {
    name: 'OrderInflux',
    id: '327002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '86',
    tag: 327,
    type: 'int',
    codeSet: 'HaltReasonCodeSet',
    description: 'Order Influx',
  },
  {
    name: 'OrderImbalance',
    id: '327003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '86',
    tag: 327,
    type: 'int',
    codeSet: 'HaltReasonCodeSet',
    description: 'Order Imbalance',
  },
  {
    name: 'AdditionalInformation',
    id: '327004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP1',
    addedEP: '86',
    tag: 327,
    type: 'int',
    codeSet: 'HaltReasonCodeSet',
    description: 'Additional Information',
  },
  {
    name: 'NewsPending',
    id: '327005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP1',
    addedEP: '86',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 327,
    type: 'int',
    codeSet: 'HaltReasonCodeSet',
    description: 'News Pending',
  },
  {
    name: 'EquipmentChangeover',
    id: '327006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP1',
    addedEP: '86',
    tag: 327,
    type: 'int',
    codeSet: 'HaltReasonCodeSet',
    description: 'Equipment Changeover',
  },
  {
    name: 'HaltWasNotRelatedToAHaltOfTheCommonStock',
    id: '328001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.2',
    tag: 328,
    type: 'Boolean',
    codeSet: 'InViewOfCommonCodeSet',
    description: 'Halt was not related to a halt of the common stock',
  },
  {
    name: 'HaltWasDueToCommonStockBeingHalted',
    id: '328002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 328,
    type: 'Boolean',
    codeSet: 'InViewOfCommonCodeSet',
    description: 'Halt was due to common stock being halted',
  },
  {
    name: 'NotRelatedToSecurityHalt',
    id: '329001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.2',
    tag: 329,
    type: 'Boolean',
    codeSet: 'DueToRelatedCodeSet',
    description: 'Halt was not related to a halt of the related security',
  },
  {
    name: 'RelatedToSecurityHalt',
    id: '329002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.2',
    tag: 329,
    type: 'Boolean',
    codeSet: 'DueToRelatedCodeSet',
    description: 'Halt was due to related security being halted',
  },
  {
    name: 'Cancel',
    id: '334001',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    tag: 334,
    type: 'int',
    codeSet: 'AdjustmentCodeSet',
    description: 'Cancel',
  },
  {
    name: 'Error',
    id: '334002',
    value: '2',
    sort: 2,
    added: 'FIX.4.2',
    tag: 334,
    type: 'int',
    codeSet: 'AdjustmentCodeSet',
    description: 'Error',
  },
  {
    name: 'Correction',
    id: '334003',
    value: '3',
    sort: 3,
    added: 'FIX.4.2',
    tag: 334,
    type: 'int',
    codeSet: 'AdjustmentCodeSet',
    description: 'Correction',
  },
  {
    name: 'Day',
    id: '336001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 336,
    type: 'String',
    codeSet: 'TradingSessionIDCodeSet',
    description: 'Day',
  },
  {
    name: 'HalfDay',
    id: '336002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 336,
    type: 'String',
    codeSet: 'TradingSessionIDCodeSet',
    description: 'HalfDay',
  },
  {
    name: 'Morning',
    id: '336003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 336,
    type: 'String',
    codeSet: 'TradingSessionIDCodeSet',
    description: 'Morning',
  },
  {
    name: 'Afternoon',
    id: '336004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 336,
    type: 'String',
    codeSet: 'TradingSessionIDCodeSet',
    description: 'Afternoon',
  },
  {
    name: 'Evening',
    id: '336005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 336,
    type: 'String',
    codeSet: 'TradingSessionIDCodeSet',
    description: 'Evening',
  },
  {
    name: 'AfterHours',
    id: '336006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 336,
    type: 'String',
    codeSet: 'TradingSessionIDCodeSet',
    description: 'After-hours',
  },
  {
    name: 'Holiday',
    id: '336007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '190',
    tag: 336,
    type: 'String',
    codeSet: 'TradingSessionIDCodeSet',
    description: 'Holiday',
  },
  {
    name: 'Electronic',
    id: '338001',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    tag: 338,
    type: 'int',
    codeSet: 'TradSesMethodCodeSet',
    description: 'Electronic',
  },
  {
    name: 'OpenOutcry',
    id: '338002',
    value: '2',
    sort: 2,
    added: 'FIX.4.2',
    tag: 338,
    type: 'int',
    codeSet: 'TradSesMethodCodeSet',
    description: 'Open Outcry',
  },
  {
    name: 'TwoParty',
    id: '338003',
    value: '3',
    sort: 3,
    added: 'FIX.4.2',
    tag: 338,
    type: 'int',
    codeSet: 'TradSesMethodCodeSet',
    description: 'Two Party',
  },
  {
    name: 'Voice',
    id: '338004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 338,
    type: 'int',
    codeSet: 'TradSesMethodCodeSet',
    description: 'Voice',
  },
  {
    name: 'Testing',
    id: '339001',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    tag: 339,
    type: 'int',
    codeSet: 'TradSesModeCodeSet',
    description: 'Testing',
  },
  {
    name: 'Simulated',
    id: '339002',
    value: '2',
    sort: 2,
    added: 'FIX.4.2',
    tag: 339,
    type: 'int',
    codeSet: 'TradSesModeCodeSet',
    description: 'Simulated',
  },
  {
    name: 'Production',
    id: '339003',
    value: '3',
    sort: 3,
    added: 'FIX.4.2',
    tag: 339,
    type: 'int',
    codeSet: 'TradSesModeCodeSet',
    description: 'Production',
  },
  {
    name: 'Unknown',
    id: '340001',
    value: '0',
    sort: 1,
    added: 'FIX.4.3',
    tag: 340,
    type: 'int',
    codeSet: 'TradSesStatusCodeSet',
    description: 'Unknown',
  },
  {
    name: 'Halted',
    id: '340002',
    value: '1',
    sort: 2,
    added: 'FIX.4.2',
    tag: 340,
    type: 'int',
    codeSet: 'TradSesStatusCodeSet',
    description: 'Halted',
  },
  {
    name: 'Open',
    id: '340003',
    value: '2',
    sort: 3,
    added: 'FIX.4.2',
    tag: 340,
    type: 'int',
    codeSet: 'TradSesStatusCodeSet',
    description: 'Open',
  },
  {
    name: 'Closed',
    id: '340004',
    value: '3',
    sort: 4,
    added: 'FIX.4.2',
    tag: 340,
    type: 'int',
    codeSet: 'TradSesStatusCodeSet',
    description: 'Closed',
  },
  {
    name: 'PreOpen',
    id: '340005',
    value: '4',
    sort: 5,
    added: 'FIX.4.2',
    tag: 340,
    type: 'int',
    codeSet: 'TradSesStatusCodeSet',
    description: 'Pre-Open',
  },
  {
    name: 'PreClose',
    id: '340006',
    value: '5',
    sort: 6,
    added: 'FIX.4.2',
    tag: 340,
    type: 'int',
    codeSet: 'TradSesStatusCodeSet',
    description: 'Pre-Close',
  },
  {
    name: 'RequestRejected',
    id: '340007',
    value: '6',
    sort: 7,
    added: 'FIX.4.3',
    tag: 340,
    type: 'int',
    codeSet: 'TradSesStatusCodeSet',
    description: 'Request Rejected',
  },
  {
    name: 'InvalidTagNumber',
    id: '373001',
    value: '0',
    sort: 0,
    added: 'FIX.4.2',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'Invalid Tag Number',
  },
  {
    name: 'RequiredTagMissing',
    id: '373002',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'Required Tag Missing',
  },
  {
    name: 'TagNotDefinedForThisMessageType',
    id: '373003',
    value: '2',
    sort: 2,
    added: 'FIX.4.2',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'Tag not defined for this message type',
  },
  {
    name: 'UndefinedTag',
    id: '373004',
    value: '3',
    sort: 3,
    added: 'FIX.4.2',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'Undefined tag',
  },
  {
    name: 'TagSpecifiedWithoutAValue',
    id: '373005',
    value: '4',
    sort: 4,
    added: 'FIX.4.2',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'Tag specified without a value',
  },
  {
    name: 'ValueIsIncorrect',
    id: '373006',
    value: '5',
    sort: 5,
    added: 'FIX.4.2',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'Value is incorrect (out of range) for this tag',
  },
  {
    name: 'IncorrectDataFormatForValue',
    id: '373007',
    value: '6',
    sort: 6,
    added: 'FIX.4.2',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'Incorrect data format for value',
  },
  {
    name: 'DecryptionProblem',
    id: '373008',
    value: '7',
    sort: 7,
    added: 'FIX.4.2',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'Decryption problem',
  },
  {
    name: 'SignatureProblem',
    id: '373009',
    value: '8',
    sort: 8,
    added: 'FIX.4.2',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'Signature problem',
  },
  {
    name: 'CompIDProblem',
    id: '373010',
    value: '9',
    sort: 9,
    added: 'FIX.4.2',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'CompID problem',
  },
  {
    name: 'SendingTimeAccuracyProblem',
    id: '373011',
    value: '10',
    sort: 10,
    added: 'FIX.4.2',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'SendingTime Accuracy Problem',
  },
  {
    name: 'InvalidMsgType',
    id: '373012',
    value: '11',
    sort: 11,
    added: 'FIX.4.2',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'Invalid MsgType',
  },
  {
    name: 'XMLValidationError',
    id: '373013',
    value: '12',
    sort: 12,
    added: 'FIX.4.3',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'XML Validation Error',
  },
  {
    name: 'TagAppearsMoreThanOnce',
    id: '373014',
    value: '13',
    sort: 13,
    added: 'FIX.4.3',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'Tag appears more than once',
  },
  {
    name: 'TagSpecifiedOutOfRequiredOrder',
    id: '373015',
    value: '14',
    sort: 14,
    added: 'FIX.4.3',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'Tag specified out of required order',
  },
  {
    name: 'RepeatingGroupFieldsOutOfOrder',
    id: '373016',
    value: '15',
    sort: 15,
    added: 'FIX.4.3',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'Repeating group fields out of order',
  },
  {
    name: 'IncorrectNumInGroupCountForRepeatingGroup',
    id: '373017',
    value: '16',
    sort: 16,
    added: 'FIX.4.3',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'Incorrect NumInGroup count for repeating group',
  },
  {
    name: 'NonDataValueIncludesFieldDelimiter',
    id: '373018',
    value: '17',
    sort: 17,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'Non "Data" value includes field delimiter (<SOH> character)',
  },
  {
    name: 'InvalidUnsupportedApplVer',
    id: '373019',
    value: '18',
    sort: 19,
    added: 'FIX.5.0',
    addedEP: '56',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'Invalid/Unsupported Application Version',
  },
  {
    name: 'Other',
    id: '373020',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    tag: 373,
    type: 'int',
    codeSet: 'SessionRejectReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'Cancel',
    id: '374001',
    value: 'C',
    sort: 1,
    added: 'FIX.4.2',
    tag: 374,
    type: 'char',
    codeSet: 'BidRequestTransTypeCodeSet',
    description: 'Cancel',
  },
  {
    name: 'New',
    id: '374002',
    value: 'N',
    sort: 2,
    added: 'FIX.4.2',
    tag: 374,
    type: 'char',
    codeSet: 'BidRequestTransTypeCodeSet',
    description: 'New',
  },
  {
    name: 'WasNotSolicited',
    id: '377001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.2',
    tag: 377,
    type: 'Boolean',
    codeSet: 'SolicitedFlagCodeSet',
    description: 'Was not solicited',
  },
  {
    name: 'WasSolicited',
    id: '377002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.2',
    tag: 377,
    type: 'Boolean',
    codeSet: 'SolicitedFlagCodeSet',
    description: 'Was solicited',
  },
  {
    name: 'GTCorporateAction',
    id: '378001',
    value: '0',
    sort: 0,
    added: 'FIX.4.2',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description: 'GT corporate action',
  },
  {
    name: 'GTRenewal',
    id: '378002',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description: 'GT renewal / restatement (no corporate action)',
  },
  {
    name: 'VerbalChange',
    id: '378003',
    value: '2',
    sort: 2,
    added: 'FIX.4.2',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description: 'Verbal change',
  },
  {
    name: 'RepricingOfOrder',
    id: '378004',
    value: '3',
    sort: 3,
    added: 'FIX.4.2',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description: 'Repricing of order',
  },
  {
    name: 'BrokerOption',
    id: '378005',
    value: '4',
    sort: 4,
    added: 'FIX.4.2',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description: 'Broker option',
  },
  {
    name: 'PartialDeclineOfOrderQty',
    id: '378006',
    value: '5',
    sort: 5,
    added: 'FIX.4.2',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description: 'Partial decline of OrderQty (e.g. exchange initiated partial cancel)',
  },
  {
    name: 'CancelOnTradingHalt',
    id: '378007',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description: 'Cancel on Trading Halt',
  },
  {
    name: 'CancelOnSystemFailure',
    id: '378008',
    value: '7',
    sort: 7,
    added: 'FIX.4.3',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description: 'Cancel on System Failure',
  },
  {
    name: 'Market',
    id: '378009',
    value: '8',
    sort: 8,
    added: 'FIX.4.3',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description: 'Market (Exchange) option',
  },
  {
    name: 'Canceled',
    id: '378010',
    value: '9',
    sort: 9,
    added: 'FIX.4.4',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description: 'Canceled, not best',
  },
  {
    name: 'WarehouseRecap',
    id: '378011',
    value: '10',
    sort: 10,
    added: 'FIX.4.4',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description: 'Warehouse Recap',
  },
  {
    name: 'PegRefresh',
    id: '378012',
    value: '11',
    sort: 11,
    added: 'FIX.4.4',
    addedEP: '22',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description: 'Peg Refresh',
  },
  {
    name: 'CancelOnConnectionLoss',
    id: '378013',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description: 'Cancel On Connection Loss',
  },
  {
    name: 'CancelOnLogout',
    id: '378014',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description: 'Cancel On Logout',
  },
  {
    name: 'AssignTimePriority',
    id: '378015',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '101',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description: 'Assign Time Priority',
  },
  {
    name: 'CancelledForTradePriceViolation',
    id: '378016',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '104',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description: 'Cancelled, Trade Price Violation',
  },
  {
    name: 'CancelledForCrossImbalance',
    id: '378017',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '104',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description: 'Cancelled, Cross Imbalance',
  },
  {
    name: 'CxldSMP',
    id: '378018',
    value: '17',
    sort: 17,
    added: 'FIX.Latest',
    addedEP: '280',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description:
      'Cancelled, self-match prevention\n\nCancelled order based on standing rules for self-match prevention (i.e. SelfMatchPreventionInstruction(2964) not specified or used).',
  },
  {
    name: 'CxldSMPAggressive',
    id: '378019',
    value: '18',
    sort: 18,
    added: 'FIX.Latest',
    addedEP: '280',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description:
      'Cancelled, self-match prevention aggressive order\n\nCancelled due to incoming order with the same SelfMatchPreventionID(2362) and SelfMatchPreventionInstruction(2964)=1 (Cancel aggressive).',
  },
  {
    name: 'CxldSMPPassive',
    id: '378020',
    value: '19',
    sort: 19,
    added: 'FIX.Latest',
    addedEP: '280',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description:
      'Cancelled, self-match prevention passive order\n\nCancelled due to incoming order with the same SelfMatchPreventionID(2362) and SelfMatchPreventionInstruction(2964)=2 (Cancel passive).',
  },
  {
    name: 'CxldSMPAggressivePassive',
    id: '378021',
    value: '20',
    sort: 20,
    added: 'FIX.Latest',
    addedEP: '280',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description:
      'Cancelled, self-match prevention aggressive and passive order\n\nCancelled due to incoming order with the same SelfMatchPreventionID(2362) and SelfMatchPreventionInstruction(2964)=3 (Cancel aggressive and passive).',
  },
  {
    name: 'Other',
    id: '378022',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    tag: 378,
    type: 'int',
    codeSet: 'ExecRestatementReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'Other',
    id: '380001',
    value: '0',
    sort: 1,
    added: 'FIX.4.2',
    tag: 380,
    type: 'int',
    codeSet: 'BusinessRejectReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'UnknownID',
    id: '380002',
    value: '1',
    sort: 2,
    added: 'FIX.4.2',
    tag: 380,
    type: 'int',
    codeSet: 'BusinessRejectReasonCodeSet',
    description: 'Unknown ID',
  },
  {
    name: 'UnknownSecurity',
    id: '380003',
    value: '2',
    sort: 3,
    added: 'FIX.4.2',
    tag: 380,
    type: 'int',
    codeSet: 'BusinessRejectReasonCodeSet',
    description: 'Unknown Security',
  },
  {
    name: 'UnsupportedMessageType',
    id: '380004',
    value: '3',
    sort: 4,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 380,
    type: 'int',
    codeSet: 'BusinessRejectReasonCodeSet',
    description: 'Unsupported Message Type',
  },
  {
    name: 'ApplicationNotAvailable',
    id: '380005',
    value: '4',
    sort: 5,
    added: 'FIX.4.2',
    tag: 380,
    type: 'int',
    codeSet: 'BusinessRejectReasonCodeSet',
    description: 'Application not available',
  },
  {
    name: 'ConditionallyRequiredFieldMissing',
    id: '380006',
    value: '5',
    sort: 6,
    added: 'FIX.4.2',
    tag: 380,
    type: 'int',
    codeSet: 'BusinessRejectReasonCodeSet',
    description: 'Conditionally required field missing',
  },
  {
    name: 'NotAuthorized',
    id: '380007',
    value: '6',
    sort: 7,
    added: 'FIX.4.3',
    tag: 380,
    type: 'int',
    codeSet: 'BusinessRejectReasonCodeSet',
    description: 'Not Authorized',
  },
  {
    name: 'DeliverToFirmNotAvailableAtThisTime',
    id: '380008',
    value: '7',
    sort: 8,
    added: 'FIX.4.3',
    tag: 380,
    type: 'int',
    codeSet: 'BusinessRejectReasonCodeSet',
    description: 'DeliverTo firm not available at this time',
  },
  {
    name: 'ThrottleLimitExceeded',
    id: '380009',
    value: '8',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '116',
    tag: 380,
    type: 'int',
    codeSet: 'BusinessRejectReasonCodeSet',
    description: 'Throttle limit exceeded',
  },
  {
    name: 'ThrottleLimitExceededSessionDisconnected',
    id: '380010',
    value: '9',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '116',
    tag: 380,
    type: 'int',
    codeSet: 'BusinessRejectReasonCodeSet',
    description: 'Throttle limit exceeded, session will be disconnected',
  },
  {
    name: 'ThrottledMessagesRejectedOnRequest',
    id: '380011',
    value: '10',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '116',
    tag: 380,
    type: 'int',
    codeSet: 'BusinessRejectReasonCodeSet',
    description: 'Throttled messages rejected on request',
  },
  {
    name: 'InvalidPriceIncrement',
    id: '380012',
    value: '18',
    sort: 19,
    added: 'FIX.4.4',
    addedEP: '6',
    updated: 'FIX.5.0SP2',
    updatedEP: '116',
    tag: 380,
    type: 'int',
    codeSet: 'BusinessRejectReasonCodeSet',
    description: 'Invalid price increment',
  },
  {
    name: 'Receive',
    id: '385001',
    value: 'R',
    sort: 1,
    added: 'FIX.4.2',
    tag: 385,
    type: 'char',
    codeSet: 'MsgDirectionCodeSet',
    description: 'Receive',
  },
  {
    name: 'Send',
    id: '385002',
    value: 'S',
    sort: 2,
    added: 'FIX.4.2',
    tag: 385,
    type: 'char',
    codeSet: 'MsgDirectionCodeSet',
    description: 'Send',
  },
  {
    name: 'RelatedToDisplayedPrice',
    id: '388001',
    value: '0',
    sort: 1,
    added: 'FIX.4.2',
    tag: 388,
    type: 'char',
    codeSet: 'DiscretionInstCodeSet',
    description: 'Related to displayed price',
  },
  {
    name: 'RelatedToMarketPrice',
    id: '388002',
    value: '1',
    sort: 2,
    added: 'FIX.4.2',
    tag: 388,
    type: 'char',
    codeSet: 'DiscretionInstCodeSet',
    description: 'Related to market price',
  },
  {
    name: 'RelatedToPrimaryPrice',
    id: '388003',
    value: '2',
    sort: 3,
    added: 'FIX.4.2',
    tag: 388,
    type: 'char',
    codeSet: 'DiscretionInstCodeSet',
    description: 'Related to primary price',
  },
  {
    name: 'RelatedToLocalPrimaryPrice',
    id: '388004',
    value: '3',
    sort: 4,
    added: 'FIX.4.2',
    tag: 388,
    type: 'char',
    codeSet: 'DiscretionInstCodeSet',
    description: 'Related to local primary price',
  },
  {
    name: 'RelatedToMidpointPrice',
    id: '388005',
    value: '4',
    sort: 5,
    added: 'FIX.4.2',
    tag: 388,
    type: 'char',
    codeSet: 'DiscretionInstCodeSet',
    description: 'Related to midpoint price',
  },
  {
    name: 'RelatedToLastTradePrice',
    id: '388006',
    value: '5',
    sort: 6,
    added: 'FIX.4.2',
    tag: 388,
    type: 'char',
    codeSet: 'DiscretionInstCodeSet',
    description: 'Related to last trade price',
  },
  {
    name: 'RelatedToVWAP',
    id: '388007',
    value: '6',
    sort: 7,
    added: 'FIX.4.4',
    tag: 388,
    type: 'char',
    codeSet: 'DiscretionInstCodeSet',
    description: 'Related to VWAP',
  },
  {
    name: 'AveragePriceGuarantee',
    id: '388008',
    value: '7',
    sort: 8,
    added: 'FIX.4.4',
    addedEP: '22',
    tag: 388,
    type: 'char',
    codeSet: 'DiscretionInstCodeSet',
    description: 'Average Price Guarantee',
  },
  {
    name: 'NonDisclosed',
    id: '394001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 394,
    type: 'int',
    codeSet: 'BidTypeCodeSet',
    description: '"Non Disclosed" style (e.g. US/European)',
  },
  {
    name: 'Disclosed',
    id: '394002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 394,
    type: 'int',
    codeSet: 'BidTypeCodeSet',
    description: '"Disclosed" style (e.g. Japanese)',
  },
  {
    name: 'NoBiddingProcess',
    id: '394003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 394,
    type: 'int',
    codeSet: 'BidTypeCodeSet',
    description: 'No bidding process',
  },
  {
    name: 'Sector',
    id: '399001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 399,
    type: 'int',
    codeSet: 'BidDescriptorTypeCodeSet',
    description: 'Sector',
  },
  {
    name: 'Country',
    id: '399002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 399,
    type: 'int',
    codeSet: 'BidDescriptorTypeCodeSet',
    description: 'Country',
  },
  {
    name: 'Index',
    id: '399003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 399,
    type: 'int',
    codeSet: 'BidDescriptorTypeCodeSet',
    description: 'Index',
  },
  {
    name: 'SideValue1',
    id: '401001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 401,
    type: 'int',
    codeSet: 'SideValueIndCodeSet',
    description: 'Side Value 1',
  },
  {
    name: 'SideValue2',
    id: '401002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 401,
    type: 'int',
    codeSet: 'SideValueIndCodeSet',
    description: 'Side Value 2',
  },
  {
    name: 'FiveDayMovingAverage',
    id: '409001',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    tag: 409,
    type: 'int',
    codeSet: 'LiquidityIndTypeCodeSet',
    description: '5-day moving average',
  },
  {
    name: 'TwentyDayMovingAverage',
    id: '409002',
    value: '2',
    sort: 2,
    added: 'FIX.4.2',
    tag: 409,
    type: 'int',
    codeSet: 'LiquidityIndTypeCodeSet',
    description: '20-day moving average',
  },
  {
    name: 'NormalMarketSize',
    id: '409003',
    value: '3',
    sort: 3,
    added: 'FIX.4.2',
    tag: 409,
    type: 'int',
    codeSet: 'LiquidityIndTypeCodeSet',
    description: 'Normal market size',
  },
  {
    name: 'Other',
    id: '409004',
    value: '4',
    sort: 4,
    added: 'FIX.4.2',
    tag: 409,
    type: 'int',
    codeSet: 'LiquidityIndTypeCodeSet',
    description: 'Other',
  },
  {
    name: 'False',
    id: '411001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.2',
    tag: 411,
    type: 'Boolean',
    codeSet: 'ExchangeForPhysicalCodeSet',
    description: 'False',
  },
  {
    name: 'True',
    id: '411002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.2',
    tag: 411,
    type: 'Boolean',
    codeSet: 'ExchangeForPhysicalCodeSet',
    description: 'True',
  },
  {
    name: 'BuySideRequests',
    id: '414001',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    tag: 414,
    type: 'int',
    codeSet: 'ProgRptReqsCodeSet',
    description:
      'Buy-side explicitly requests status using Statue Request (default), the sell-side firm can, however, send a DONE status List STatus Response in an unsolicited fashion',
  },
  {
    name: 'SellSideSends',
    id: '414002',
    value: '2',
    sort: 2,
    added: 'FIX.4.2',
    tag: 414,
    type: 'int',
    codeSet: 'ProgRptReqsCodeSet',
    description:
      'Sell-side periodically sends status using List Status. Period optionally specified in ProgressPeriod.',
  },
  {
    name: 'RealTimeExecutionReports',
    id: '414003',
    value: '3',
    sort: 3,
    added: 'FIX.4.2',
    tag: 414,
    type: 'int',
    codeSet: 'ProgRptReqsCodeSet',
    description: 'Real-time execution reports (to be discourage)',
  },
  {
    name: 'Net',
    id: '416001',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    tag: 416,
    type: 'int',
    codeSet: 'IncTaxIndCodeSet',
    description: 'Net',
  },
  {
    name: 'Gross',
    id: '416002',
    value: '2',
    sort: 2,
    added: 'FIX.4.2',
    tag: 416,
    type: 'int',
    codeSet: 'IncTaxIndCodeSet',
    description: 'Gross',
  },
  {
    name: 'Agency',
    id: '418001',
    value: 'A',
    sort: 1,
    added: 'FIX.4.2',
    tag: 418,
    type: 'char',
    codeSet: 'BidTradeTypeCodeSet',
    description: 'Agency',
  },
  {
    name: 'VWAPGuarantee',
    id: '418002',
    value: 'G',
    sort: 2,
    added: 'FIX.4.2',
    tag: 418,
    type: 'char',
    codeSet: 'BidTradeTypeCodeSet',
    description: 'VWAP Guarantee',
  },
  {
    name: 'GuaranteedClose',
    id: '418003',
    value: 'J',
    sort: 3,
    added: 'FIX.4.2',
    tag: 418,
    type: 'char',
    codeSet: 'BidTradeTypeCodeSet',
    description: 'Guaranteed Close',
  },
  {
    name: 'RiskTrade',
    id: '418004',
    value: 'R',
    sort: 4,
    added: 'FIX.4.2',
    tag: 418,
    type: 'char',
    codeSet: 'BidTradeTypeCodeSet',
    description: 'Risk Trade',
  },
  {
    name: 'ClosingPriceAtMorningSession',
    id: '419001',
    value: '2',
    sort: 1,
    added: 'FIX.4.2',
    tag: 419,
    type: 'char',
    codeSet: 'BasisPxTypeCodeSet',
    description: 'Closing price at morning session',
  },
  {
    name: 'ClosingPrice',
    id: '419002',
    value: '3',
    sort: 2,
    added: 'FIX.4.2',
    tag: 419,
    type: 'char',
    codeSet: 'BasisPxTypeCodeSet',
    description: 'Closing price',
  },
  {
    name: 'CurrentPrice',
    id: '419003',
    value: '4',
    sort: 3,
    added: 'FIX.4.2',
    tag: 419,
    type: 'char',
    codeSet: 'BasisPxTypeCodeSet',
    description: 'Current price',
  },
  {
    name: 'SQ',
    id: '419004',
    value: '5',
    sort: 4,
    added: 'FIX.4.2',
    tag: 419,
    type: 'char',
    codeSet: 'BasisPxTypeCodeSet',
    description: 'SQ',
  },
  {
    name: 'VWAPThroughADay',
    id: '419005',
    value: '6',
    sort: 5,
    added: 'FIX.4.2',
    tag: 419,
    type: 'char',
    codeSet: 'BasisPxTypeCodeSet',
    description: 'VWAP through a day',
  },
  {
    name: 'VWAPThroughAMorningSession',
    id: '419006',
    value: '7',
    sort: 6,
    added: 'FIX.4.2',
    tag: 419,
    type: 'char',
    codeSet: 'BasisPxTypeCodeSet',
    description: 'VWAP through a morning session',
  },
  {
    name: 'VWAPThroughAnAfternoonSession',
    id: '419007',
    value: '8',
    sort: 7,
    added: 'FIX.4.2',
    tag: 419,
    type: 'char',
    codeSet: 'BasisPxTypeCodeSet',
    description: 'VWAP through an afternoon session',
  },
  {
    name: 'VWAPThroughADayExcept',
    id: '419008',
    value: '9',
    sort: 8,
    added: 'FIX.4.2',
    tag: 419,
    type: 'char',
    codeSet: 'BasisPxTypeCodeSet',
    description: 'VWAP through a day except "YORI" (an opening auction)',
  },
  {
    name: 'VWAPThroughAMorningSessionExcept',
    id: '419009',
    value: 'A',
    sort: 9,
    added: 'FIX.4.2',
    tag: 419,
    type: 'char',
    codeSet: 'BasisPxTypeCodeSet',
    description: 'VWAP through a morning session except "YORI" (an opening auction)',
  },
  {
    name: 'VWAPThroughAnAfternoonSessionExcept',
    id: '419010',
    value: 'B',
    sort: 10,
    added: 'FIX.4.2',
    tag: 419,
    type: 'char',
    codeSet: 'BasisPxTypeCodeSet',
    description: 'VWAP through an afternoon session except "YORI" (an opening auction)',
  },
  {
    name: 'Strike',
    id: '419011',
    value: 'C',
    sort: 11,
    added: 'FIX.4.2',
    tag: 419,
    type: 'char',
    codeSet: 'BasisPxTypeCodeSet',
    description: 'Strike',
  },
  {
    name: 'Open',
    id: '419012',
    value: 'D',
    sort: 12,
    added: 'FIX.4.2',
    tag: 419,
    type: 'char',
    codeSet: 'BasisPxTypeCodeSet',
    description: 'Open',
  },
  {
    name: 'Others',
    id: '419013',
    value: 'Z',
    sort: 30,
    added: 'FIX.4.2',
    tag: 419,
    type: 'char',
    codeSet: 'BasisPxTypeCodeSet',
    description: 'Others',
  },
  {
    name: 'Percentage',
    id: '423001',
    value: '1',
    sort: 0,
    added: 'FIX.4.2',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description:
      'Percentage (i.e. percent of par) (often called "dollar price" for fixed income)',
  },
  {
    name: 'PerUnit',
    id: '423002',
    value: '2',
    sort: 1,
    added: 'FIX.4.2',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'Per unit (i.e. per share or contract)',
  },
  {
    name: 'FixedAmount',
    id: '423003',
    value: '3',
    sort: 2,
    added: 'FIX.4.2',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'Fixed amount (absolute value)',
  },
  {
    name: 'Discount',
    id: '423004',
    value: '4',
    sort: 3,
    added: 'FIX.4.3',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'Discount - percentage points below par',
  },
  {
    name: 'Premium',
    id: '423005',
    value: '5',
    sort: 4,
    added: 'FIX.4.3',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'Premium - percentage points over par',
  },
  {
    name: 'Spread',
    id: '423006',
    value: '6',
    sort: 5,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '207',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description:
      'Spread (basis points spread)\n\nUsually the difference in yield between two switched bonds or a corporate bond traded spread-to-benchmark.',
  },
  {
    name: 'TEDPrice',
    id: '423007',
    value: '7',
    sort: 6,
    added: 'FIX.4.3',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'TED Price',
  },
  {
    name: 'TEDYield',
    id: '423008',
    value: '8',
    sort: 7,
    added: 'FIX.4.3',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'TED Yield',
  },
  {
    name: 'Yield',
    id: '423009',
    value: '9',
    sort: 8,
    added: 'FIX.4.4',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'Yield',
  },
  {
    name: 'FixedCabinetTradePrice',
    id: '423010',
    value: '10',
    sort: 9,
    added: 'FIX.4.4',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'Fixed cabinet trade price (primarily for listed futures and options)',
  },
  {
    name: 'VariableCabinetTradePrice',
    id: '423011',
    value: '11',
    sort: 10,
    added: 'FIX.4.4',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description:
      'Variable cabinet trade price (primarily for listed futures and options)',
  },
  {
    name: 'PriceSpread',
    id: '423012',
    value: '12',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '207',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description:
      'Price spread\n\nPrice spread is expressed based on market convention for the asset being priced or traded. For example, the difference between the prices of a multileg switch or strategy expressed in basis points for a CDS or TBA roll; a price value to be added to a reference price, such as a "pay up" for specified pools',
  },
  {
    name: 'ProductTicksInHalves',
    id: '423013',
    value: '13',
    sort: 12,
    added: 'FIX.4.4',
    addedEP: '19',
    updated: 'FIX.5.0SP2',
    updatedEP: '207',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'Product ticks in halves',
  },
  {
    name: 'ProductTicksInFourths',
    id: '423014',
    value: '14',
    sort: 13,
    added: 'FIX.4.4',
    addedEP: '19',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'Product ticks in fourths',
  },
  {
    name: 'ProductTicksInEighths',
    id: '423015',
    value: '15',
    sort: 14,
    added: 'FIX.4.4',
    addedEP: '19',
    updated: 'FIX.5.0SP2',
    updatedEP: '207',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'Product ticks in eighths',
  },
  {
    name: 'ProductTicksInSixteenths',
    id: '423016',
    value: '16',
    sort: 15,
    added: 'FIX.4.4',
    addedEP: '19',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'Product ticks in sixteenths',
  },
  {
    name: 'ProductTicksInThirtySeconds',
    id: '423017',
    value: '17',
    sort: 16,
    added: 'FIX.4.4',
    addedEP: '19',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'Product ticks in thirty-seconds',
  },
  {
    name: 'ProductTicksInSixtyFourths',
    id: '423018',
    value: '18',
    sort: 17,
    added: 'FIX.4.4',
    addedEP: '19',
    updated: 'FIX.5.0SP2',
    updatedEP: '207',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'Product ticks in sixty-fourths',
  },
  {
    name: 'ProductTicksInOneTwentyEighths',
    id: '423019',
    value: '19',
    sort: 18,
    added: 'FIX.4.4',
    addedEP: '19',
    updated: 'FIX.5.0SP2',
    updatedEP: '207',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'Product ticks in one-twenty-eighths',
  },
  {
    name: 'NormalRateRepresentation',
    id: '423020',
    value: '20',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'Normal rate representation (e.g. FX rate)',
  },
  {
    name: 'InverseRateRepresentation',
    id: '423021',
    value: '21',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'Inverse rate representation (e.g. FX rate)',
  },
  {
    name: 'BasisPoints',
    id: '423022',
    value: '22',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'Basis points\n\nWhen the price is not spread based.',
  },
  {
    name: 'UpfrontPoints',
    id: '423023',
    value: '23',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'Up front points\n\nUsed specifically for CDS pricing.',
  },
  {
    name: 'InterestRate',
    id: '423024',
    value: '24',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '174',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description:
      'Interest rate\n\nWhen the price is an interest rate. For example, used with benchmark reference rate.',
  },
  {
    name: 'PercentageNotional',
    id: '423025',
    value: '25',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 423,
    type: 'int',
    codeSet: 'PriceTypeCodeSet',
    description: 'Percentage of notional',
  },
  {
    name: 'BookOutAllTradesOnDayOfExecution',
    id: '427001',
    value: '0',
    sort: 1,
    added: 'FIX.4.2',
    tag: 427,
    type: 'int',
    codeSet: 'GTBookingInstCodeSet',
    description: 'Book out all trades on day of execution',
  },
  {
    name: 'AccumulateUntilFilledOrExpired',
    id: '427002',
    value: '1',
    sort: 2,
    added: 'FIX.4.2',
    tag: 427,
    type: 'int',
    codeSet: 'GTBookingInstCodeSet',
    description: 'Accumulate executions until order is filled or expires',
  },
  {
    name: 'AccumulateUntilVerballyNotifiedOtherwise',
    id: '427003',
    value: '2',
    sort: 3,
    added: 'FIX.4.2',
    tag: 427,
    type: 'int',
    codeSet: 'GTBookingInstCodeSet',
    description: 'Accumulate until verbally notified otherwise',
  },
  {
    name: 'Ack',
    id: '429001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 429,
    type: 'int',
    codeSet: 'ListStatusTypeCodeSet',
    description: 'Ack',
  },
  {
    name: 'Response',
    id: '429002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 429,
    type: 'int',
    codeSet: 'ListStatusTypeCodeSet',
    description: 'Response',
  },
  {
    name: 'Timed',
    id: '429003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 429,
    type: 'int',
    codeSet: 'ListStatusTypeCodeSet',
    description: 'Timed',
  },
  {
    name: 'ExecStarted',
    id: '429004',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    tag: 429,
    type: 'int',
    codeSet: 'ListStatusTypeCodeSet',
    description: 'Exec Started',
  },
  {
    name: 'AllDone',
    id: '429005',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    tag: 429,
    type: 'int',
    codeSet: 'ListStatusTypeCodeSet',
    description: 'All Done',
  },
  {
    name: 'Alert',
    id: '429006',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    tag: 429,
    type: 'int',
    codeSet: 'ListStatusTypeCodeSet',
    description: 'Alert',
  },
  {
    name: 'Net',
    id: '430001',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    tag: 430,
    type: 'int',
    codeSet: 'NetGrossIndCodeSet',
    description: 'Net',
  },
  {
    name: 'Gross',
    id: '430002',
    value: '2',
    sort: 2,
    added: 'FIX.4.2',
    tag: 430,
    type: 'int',
    codeSet: 'NetGrossIndCodeSet',
    description: 'Gross',
  },
  {
    name: 'InBiddingProcess',
    id: '431001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 431,
    type: 'int',
    codeSet: 'ListOrderStatusCodeSet',
    description: 'In bidding process',
  },
  {
    name: 'ReceivedForExecution',
    id: '431002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 431,
    type: 'int',
    codeSet: 'ListOrderStatusCodeSet',
    description: 'Received for execution',
  },
  {
    name: 'Executing',
    id: '431003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 431,
    type: 'int',
    codeSet: 'ListOrderStatusCodeSet',
    description: 'Executing',
  },
  {
    name: 'Cancelling',
    id: '431004',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    tag: 431,
    type: 'int',
    codeSet: 'ListOrderStatusCodeSet',
    description: 'Cancelling',
  },
  {
    name: 'Alert',
    id: '431005',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    tag: 431,
    type: 'int',
    codeSet: 'ListOrderStatusCodeSet',
    description: 'Alert',
  },
  {
    name: 'AllDone',
    id: '431006',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    tag: 431,
    type: 'int',
    codeSet: 'ListOrderStatusCodeSet',
    description: 'All Done',
  },
  {
    name: 'Reject',
    id: '431007',
    value: '7',
    sort: 7,
    added: 'FIX.4.3',
    tag: 431,
    type: 'int',
    codeSet: 'ListOrderStatusCodeSet',
    description: 'Reject',
  },
  {
    name: 'Immediate',
    id: '433001',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    tag: 433,
    type: 'char',
    codeSet: 'ListExecInstTypeCodeSet',
    description: 'Immediate',
  },
  {
    name: 'WaitForInstruction',
    id: '433002',
    value: '2',
    sort: 2,
    added: 'FIX.4.2',
    tag: 433,
    type: 'char',
    codeSet: 'ListExecInstTypeCodeSet',
    description:
      'Wait for Execut Instruction (i.e. a List Execut message or phone call before proceeding with execution of the list)',
  },
  {
    name: 'SellDriven',
    id: '433003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 433,
    type: 'char',
    codeSet: 'ListExecInstTypeCodeSet',
    description: 'Exchange/switch CIV order - Sell driven',
  },
  {
    name: 'BuyDrivenCashTopUp',
    id: '433004',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    tag: 433,
    type: 'char',
    codeSet: 'ListExecInstTypeCodeSet',
    description:
      'Exchange/switch CIV order - Buy driven, cash top-up (i.e. additional cash will be provided to fulfill the order)',
  },
  {
    name: 'BuyDrivenCashWithdraw',
    id: '433005',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    tag: 433,
    type: 'char',
    codeSet: 'ListExecInstTypeCodeSet',
    description:
      'Exchange/switch CIV order - Buy driven, cash withdraw (i.e. additional cash will not be provided to fulfill the order)',
  },
  {
    name: 'OrderCancelRequest',
    id: '434001',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    tag: 434,
    type: 'char',
    codeSet: 'CxlRejResponseToCodeSet',
    description: 'Order cancel request',
  },
  {
    name: 'OrderCancelReplaceRequest',
    id: '434002',
    value: '2',
    sort: 2,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 434,
    type: 'char',
    codeSet: 'CxlRejResponseToCodeSet',
    description: 'Order cancel/replace request',
  },
  {
    name: 'SingleSecurity',
    id: '442001',
    value: '1',
    sort: 1,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 442,
    type: 'char',
    codeSet: 'MultiLegReportingTypeCodeSet',
    description: 'Single security (default if not specified)',
  },
  {
    name: 'IndividualLegOfAMultiLegSecurity',
    id: '442002',
    value: '2',
    sort: 2,
    added: 'FIX.4.2',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 442,
    type: 'char',
    codeSet: 'MultiLegReportingTypeCodeSet',
    description: 'Individual leg of a multi-leg security',
  },
  {
    name: 'MultiLegSecurity',
    id: '442003',
    value: '3',
    sort: 3,
    added: 'FIX.4.2',
    tag: 442,
    type: 'char',
    codeSet: 'MultiLegReportingTypeCodeSet',
    description: 'Multi-leg security',
  },
  {
    name: 'UKNationalInsuranceOrPensionNumber',
    id: '447001',
    value: '6',
    sort: 1,
    group: 'For PartyRole = "InvestorID" and for CIV',
    added: 'FIX.4.3',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description: 'UK National Insurance or Pension Number',
  },
  {
    name: 'USSocialSecurityNumber',
    id: '447002',
    value: '7',
    sort: 2,
    group: 'For PartyRole = "InvestorID" and for CIV',
    added: 'FIX.4.3',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description: 'US Social Security Number',
  },
  {
    name: 'USEmployerOrTaxIDNumber',
    id: '447003',
    value: '8',
    sort: 3,
    group: 'For PartyRole = "InvestorID" and for CIV',
    added: 'FIX.4.3',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description: 'US Employer or Tax ID Number',
  },
  {
    name: 'AustralianBusinessNumber',
    id: '447004',
    value: '9',
    sort: 4,
    group: 'For PartyRole = "InvestorID" and for CIV',
    added: 'FIX.4.3',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description: 'Australian Business Number',
  },
  {
    name: 'AustralianTaxFileNumber',
    id: '447005',
    value: 'A',
    sort: 5,
    group: 'For PartyRole = "InvestorID" and for CIV',
    added: 'FIX.4.3',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description: 'Australian Tax File Number',
  },
  {
    name: 'TaxID',
    id: '447006',
    value: 'J',
    sort: 6,
    group: 'For PartyRole = "InvestorID" and for CIV',
    added: 'FIX.5.0SP2',
    addedEP: '103',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description: 'Tax ID',
  },
  {
    name: 'KoreanInvestorID',
    id: '447007',
    value: '1',
    sort: 1,
    group: 'For PartyRole = "InvestorID" and for Equities',
    added: 'FIX.4.3',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description: 'Korean Investor ID',
  },
  {
    name: 'TaiwaneseForeignInvestorID',
    id: '447008',
    value: '2',
    sort: 2,
    group: 'For PartyRole = "InvestorID" and for Equities',
    added: 'FIX.4.3',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description: 'Taiwanese Qualified Foreign Investor ID QFII/FID',
  },
  {
    name: 'TaiwaneseTradingAcct',
    id: '447009',
    value: '3',
    sort: 3,
    group: 'For PartyRole = "InvestorID" and for Equities',
    added: 'FIX.4.3',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description: 'Taiwanese Trading Acct',
  },
  {
    name: 'MalaysianCentralDepository',
    id: '447010',
    value: '4',
    sort: 4,
    group: 'For PartyRole = "InvestorID" and for Equities',
    added: 'FIX.4.3',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description: 'Malaysian Central Depository (MCD) number',
  },
  {
    name: 'ChineseInvestorID',
    id: '447011',
    value: '5',
    sort: 5,
    group: 'For PartyRole = "InvestorID" and for Equities',
    added: 'FIX.4.3',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description: 'Chinese Investor ID',
  },
  {
    name: 'ISITCAcronym',
    id: '447012',
    value: 'I',
    sort: 1,
    group: 'For PartyRole="Broker of Credit"',
    added: 'FIX.4.4',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description:
      'Directed broker three character acronym as defined in ISITC "ETC Best Practice" guidelines document',
  },
  {
    name: 'BIC',
    id: '447013',
    value: 'B',
    sort: 1,
    group: 'For all PartyRoles',
    added: 'FIX.4.3',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description:
      'BIC (Bank Identification Code - SWIFT managed) code (ISO9362 - See "Appendix 6-B")',
  },
  {
    name: 'GeneralIdentifier',
    id: '447014',
    value: 'C',
    sort: 2,
    group: 'For all PartyRoles',
    added: 'FIX.4.3',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description: 'Generally accepted market participant identifier (e.g. NASD mnemonic)',
  },
  {
    name: 'Proprietary',
    id: '447015',
    value: 'D',
    sort: 3,
    group: 'For all PartyRoles',
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '192',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description:
      'Proprietary / Custom code\n\nCustom ID schema used between counterparties, trading platforms and repositories.',
  },
  {
    name: 'ISOCountryCode',
    id: '447016',
    value: 'E',
    sort: 4,
    group: 'For all PartyRoles',
    added: 'FIX.4.3',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description: 'ISO Country Code',
  },
  {
    name: 'SettlementEntityLocation',
    id: '447017',
    value: 'F',
    sort: 5,
    group: 'For all PartyRoles',
    added: 'FIX.4.3',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description:
      'Settlement Entity Location (note if Local Market Settlement use "E=ISO Country Code") (see "Appendix 6-G" for valid values)',
  },
  {
    name: 'MIC',
    id: '447018',
    value: 'G',
    sort: 6,
    group: 'For all PartyRoles',
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '236',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description: 'Market Identifier Code (ISO 10383) MIC',
  },
  {
    name: 'CSDParticipant',
    id: '447019',
    value: 'H',
    sort: 7,
    group: 'For all PartyRoles',
    added: 'FIX.4.4',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description:
      'CSD participant/member code (e.g. Euroclear, DTC, CREST or Kassenverein number',
  },
  {
    name: 'AustralianCompanyNumber',
    id: '447020',
    value: 'K',
    sort: 8,
    group: 'For all PartyRoles',
    added: 'FIX.5.0SP2',
    addedEP: '108',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description: 'Australian Company Number',
  },
  {
    name: 'AustralianRegisteredBodyNumber',
    id: '447021',
    value: 'L',
    sort: 9,
    group: 'For all PartyRoles',
    added: 'FIX.5.0SP2',
    addedEP: '108',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description: 'Australian Registered Body Number',
  },
  {
    name: 'CFTCReportingFirmIdentifier',
    id: '447022',
    value: 'M',
    sort: 10,
    group: 'For all PartyRoles',
    added: 'FIX.5.0SP2',
    addedEP: '140',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description: 'CFTC reporting firm identifier',
  },
  {
    name: 'LegalEntityIdentifier',
    id: '447023',
    value: 'N',
    sort: 11,
    group: 'For all PartyRoles',
    added: 'FIX.5.0SP2',
    addedEP: '156',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description: 'Legal Entity Identifier (ISO 17442) LEI',
  },
  {
    name: 'InterimIdentifier',
    id: '447024',
    value: 'O',
    sort: 12,
    group: 'For all PartyRoles',
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description:
      'Interim identifier\n\nAn interim entity identifier assigned by a regulatory agency prior to an LEI (ISO 17442) being assigned.',
  },
  {
    name: 'ShortCodeIdentifier',
    id: '447025',
    value: 'P',
    sort: 13,
    group: 'For all PartyRoles',
    added: 'FIX.5.0SP2',
    addedEP: '222',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description:
      'Short code identifier\n\nA generic means for trading venues, brokers, investment managers to convey a bilaterally agreed upon "short hand" code for an identifier that is a reference to a mapping between the parties.',
  },
  {
    name: 'NationalIDNaturalPerson',
    id: '447026',
    value: 'Q',
    sort: 14,
    group: 'For all PartyRoles',
    added: 'FIX.5.0SP2',
    addedEP: '222',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description:
      'National ID of natural person\n\nAn identification number generally assigned by a government authority or agency to a natural person which is unique to the person it is assigned to. Examples include, but not limited to, "social security number", "pension number".',
  },
  {
    name: 'IndiaPermanentAccountNumber',
    id: '447027',
    value: 'R',
    sort: 15,
    group: 'For all PartyRoles',
    added: 'FIX.5.0SP2',
    addedEP: '244',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description:
      'India Permanent Account Number\n\nAlso referred to as PAN ID. An identifier issued by the Income Tax Department of India.',
  },
  {
    name: 'FDID',
    id: '447028',
    value: 'S',
    sort: 16,
    group: 'For all PartyRoles',
    added: 'FIX.5.0SP2',
    addedEP: '248',
    updated: 'FIX.Latest',
    updatedEP: '262',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description:
      'Firm designated identifier\n\nAlso referred to as FDID. A unique identifier required by the SEC for each trading account designated by Industry Members for purposes of reporting to CAT (Consolidated Audit Trail).',
  },
  {
    name: 'SPSAID',
    id: '447029',
    value: 'T',
    sort: 17,
    group: 'For all PartyRoles',
    added: 'FIX.Latest',
    addedEP: '262',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description:
      'Special Segregated Account ID\n\nAlso referred to as SPSA ID. The Special Segregated Account identifier issued by Hong Kong Exchanges and Clearing.',
  },
  {
    name: 'MasterSPSAID',
    id: '447030',
    value: 'U',
    sort: 18,
    group: 'For all PartyRoles',
    added: 'FIX.Latest',
    addedEP: '262',
    tag: 447,
    type: 'char',
    codeSet: 'PartyIDSourceCodeSet',
    description:
      'Master Special Segregated Account ID\n\nAlso referred to as Master SPSA ID. The master identifier issued by Hong Kong Exchanges and Clearing for the aggregation of SPSA IDs.',
  },
  {
    name: 'ExecutingFirm',
    id: '452001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Executing Firm (formerly FIX 4.2 ExecBroker)',
  },
  {
    name: 'BrokerOfCredit',
    id: '452002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Broker of Credit (formerly FIX 4.2 BrokerOfCredit)',
  },
  {
    name: 'ClientID',
    id: '452003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Client ID (formerly FIX 4.2 ClientID)',
  },
  {
    name: 'ClearingFirm',
    id: '452004',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Clearing Firm (formerly FIX 4.2 ClearingFirm)',
  },
  {
    name: 'InvestorID',
    id: '452005',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Investor ID',
  },
  {
    name: 'IntroducingFirm',
    id: '452006',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Introducing Firm',
  },
  {
    name: 'EnteringFirm',
    id: '452007',
    value: '7',
    sort: 7,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Entering Firm',
  },
  {
    name: 'Locate',
    id: '452008',
    value: '8',
    sort: 8,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Locate / Lending Firm (for short-sales)',
  },
  {
    name: 'FundManagerClientID',
    id: '452009',
    value: '9',
    sort: 9,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Fund Manager Client ID (for CIV)',
  },
  {
    name: 'SettlementLocation',
    id: '452010',
    value: '10',
    sort: 10,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Settlement Location (formerly FIX 4.2 SettlLocation)',
  },
  {
    name: 'OrderOriginationTrader',
    id: '452011',
    value: '11',
    sort: 11,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Order Origination Trader (associated with Order Origination Firm - i.e. trader who initiates/submits the order)',
  },
  {
    name: 'ExecutingTrader',
    id: '452012',
    value: '12',
    sort: 12,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Executing Trader (associated with Executing Firm - actually executes)',
  },
  {
    name: 'OrderOriginationFirm',
    id: '452013',
    value: '13',
    sort: 13,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Order Origination Firm (e.g. buy-side firm)',
  },
  {
    name: 'GiveupClearingFirmDepr',
    id: '452014',
    value: '14',
    sort: 14,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    deprecated: 'FIX.5.0SP2',
    deprecatedEP: '118',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Giveup Clearing Firm (firm to which trade is given up)',
  },
  {
    name: 'CorrespondantClearingFirm',
    id: '452015',
    value: '15',
    sort: 15,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Correspondant Clearing Firm',
  },
  {
    name: 'ExecutingSystem',
    id: '452016',
    value: '16',
    sort: 16,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Executing System',
  },
  {
    name: 'ContraFirm',
    id: '452017',
    value: '17',
    sort: 17,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Contra Firm',
  },
  {
    name: 'ContraClearingFirm',
    id: '452018',
    value: '18',
    sort: 18,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Contra Clearing Firm',
  },
  {
    name: 'SponsoringFirm',
    id: '452019',
    value: '19',
    sort: 19,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Sponsoring Firm',
  },
  {
    name: 'UnderlyingContraFirm',
    id: '452020',
    value: '20',
    sort: 20,
    added: 'FIX.4.3',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Underlying Contra Firm',
  },
  {
    name: 'ClearingOrganization',
    id: '452021',
    value: '21',
    sort: 21,
    added: 'FIX.4.4',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Clearing Organization',
  },
  {
    name: 'Exchange',
    id: '452022',
    value: '22',
    sort: 22,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '139',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Exchange\n\nIdentify using PartyIDSource(tag 447) = G (Market Identifier Code) if the MIC exists.',
  },
  {
    name: 'CustomerAccount',
    id: '452023',
    value: '24',
    sort: 24,
    added: 'FIX.4.4',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Customer Account',
  },
  {
    name: 'CorrespondentClearingOrganization',
    id: '452024',
    value: '25',
    sort: 25,
    added: 'FIX.4.4',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Correspondent Clearing Organization',
  },
  {
    name: 'CorrespondentBroker',
    id: '452025',
    value: '26',
    sort: 26,
    added: 'FIX.4.4',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Correspondent Broker',
  },
  {
    name: 'Buyer',
    id: '452026',
    value: '27',
    sort: 27,
    added: 'FIX.4.4',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Buyer/Seller (Receiver/Deliverer)',
  },
  {
    name: 'Custodian',
    id: '452027',
    value: '28',
    sort: 28,
    added: 'FIX.4.4',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Custodian',
  },
  {
    name: 'Intermediary',
    id: '452028',
    value: '29',
    sort: 29,
    added: 'FIX.4.4',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Intermediary',
  },
  {
    name: 'Agent',
    id: '452029',
    value: '30',
    sort: 30,
    added: 'FIX.4.4',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Agent',
  },
  {
    name: 'SubCustodian',
    id: '452030',
    value: '31',
    sort: 31,
    added: 'FIX.4.4',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Sub-custodian',
  },
  {
    name: 'Beneficiary',
    id: '452031',
    value: '32',
    sort: 32,
    added: 'FIX.4.4',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Beneficiary',
  },
  {
    name: 'InterestedParty',
    id: '452032',
    value: '33',
    sort: 33,
    added: 'FIX.4.4',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Interested party',
  },
  {
    name: 'RegulatoryBody',
    id: '452033',
    value: '34',
    sort: 34,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Regulatory body\n\nIn the context of regulatory reporting, this identifies the regulator the trade is being reported to.',
  },
  {
    name: 'LiquidityProvider',
    id: '452034',
    value: '35',
    sort: 35,
    added: 'FIX.4.4',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Liquidity provider',
  },
  {
    name: 'EnteringTrader',
    id: '452035',
    value: '36',
    sort: 36,
    added: 'FIX.4.4',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Entering trader',
  },
  {
    name: 'ContraTrader',
    id: '452036',
    value: '37',
    sort: 37,
    added: 'FIX.4.4',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Contra trader',
  },
  {
    name: 'PositionAccount',
    id: '452037',
    value: '38',
    sort: 38,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '155',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Position account\n\nThe account which positions are maintained. Typically represents the aggregation of one or more customer accounts.',
  },
  {
    name: 'ContraInvestorID',
    id: '452038',
    value: '39',
    sort: 39,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Contra Investor ID',
  },
  {
    name: 'TransferToFirm',
    id: '452039',
    value: '40',
    sort: 40,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Transfer to Firm',
  },
  {
    name: 'ContraPositionAccount',
    id: '452040',
    value: '41',
    sort: 41,
    added: 'FIX.4.4',
    addedEP: '5',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Contra Position Account',
  },
  {
    name: 'ContraExchange',
    id: '452041',
    value: '42',
    sort: 42,
    added: 'FIX.4.4',
    addedEP: '5',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Contra Exchange',
  },
  {
    name: 'InternalCarryAccount',
    id: '452042',
    value: '43',
    sort: 43,
    added: 'FIX.4.4',
    addedEP: '5',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Internal Carry Account',
  },
  {
    name: 'OrderEntryOperatorID',
    id: '452043',
    value: '44',
    sort: 44,
    added: 'FIX.4.4',
    addedEP: '5',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Order Entry Operator ID',
  },
  {
    name: 'SecondaryAccountNumber',
    id: '452044',
    value: '45',
    sort: 45,
    added: 'FIX.4.4',
    addedEP: '5',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Secondary Account Number',
  },
  {
    name: 'ForeignFirm',
    id: '452045',
    value: '46',
    sort: 46,
    added: 'FIX.4.4',
    addedEP: '8',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Foreign Firm',
  },
  {
    name: 'ThirdPartyAllocationFirm',
    id: '452046',
    value: '47',
    sort: 47,
    added: 'FIX.4.4',
    addedEP: '8',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Third Party Allocation Firm',
  },
  {
    name: 'ClaimingAccount',
    id: '452047',
    value: '48',
    sort: 48,
    added: 'FIX.4.4',
    addedEP: '8',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Claiming Account',
  },
  {
    name: 'AssetManager',
    id: '452048',
    value: '49',
    sort: 49,
    added: 'FIX.4.4',
    addedEP: '8',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Asset Manager',
  },
  {
    name: 'PledgorAccount',
    id: '452049',
    value: '50',
    sort: 50,
    added: 'FIX.4.4',
    addedEP: '8',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Pledgor Account',
  },
  {
    name: 'PledgeeAccount',
    id: '452050',
    value: '51',
    sort: 51,
    added: 'FIX.4.4',
    addedEP: '8',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Pledgee Account',
  },
  {
    name: 'LargeTraderReportableAccount',
    id: '452051',
    value: '52',
    sort: 52,
    added: 'FIX.4.4',
    addedEP: '8',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Large Trader Reportable Account',
  },
  {
    name: 'TraderMnemonic',
    id: '452052',
    value: '53',
    sort: 53,
    added: 'FIX.4.4',
    addedEP: '8',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Trader mnemonic',
  },
  {
    name: 'SenderLocation',
    id: '452053',
    value: '54',
    sort: 54,
    added: 'FIX.4.4',
    addedEP: '8',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Sender Location',
  },
  {
    name: 'SessionID',
    id: '452054',
    value: '55',
    sort: 55,
    added: 'FIX.4.4',
    addedEP: '8',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Session ID',
  },
  {
    name: 'AcceptableCounterparty',
    id: '452055',
    value: '56',
    sort: 56,
    added: 'FIX.4.4',
    addedEP: '22',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Acceptable Counterparty',
  },
  {
    name: 'UnacceptableCounterparty',
    id: '452056',
    value: '57',
    sort: 57,
    added: 'FIX.4.4',
    addedEP: '22',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Unacceptable Counterparty',
  },
  {
    name: 'EnteringUnit',
    id: '452057',
    value: '58',
    sort: 58,
    added: 'FIX.4.4',
    addedEP: '22',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Entering Unit',
  },
  {
    name: 'ExecutingUnit',
    id: '452058',
    value: '59',
    sort: 59,
    added: 'FIX.4.4',
    addedEP: '22',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Executing Unit',
  },
  {
    name: 'IntroducingBroker',
    id: '452059',
    value: '60',
    sort: 60,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Introducing Broker',
  },
  {
    name: 'QuoteOriginator',
    id: '452060',
    value: '61',
    sort: 61,
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Quote originator',
  },
  {
    name: 'ReportOriginator',
    id: '452061',
    value: '62',
    sort: 62,
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Report originator',
  },
  {
    name: 'SystematicInternaliser',
    id: '452062',
    value: '63',
    sort: 63,
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Systematic internaliser (SI)',
  },
  {
    name: 'MultilateralTradingFacility',
    id: '452063',
    value: '64',
    sort: 64,
    added: 'FIX.4.4',
    addedEP: '26',
    updated: 'FIX.5.0SP2',
    updatedEP: '139',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Multilateral Trading Facility (MTF)\n\nIdentify using PartyIDSource(tag 447) = G (Market Identifier Code) if the MIC exists.',
  },
  {
    name: 'RegulatedMarket',
    id: '452064',
    value: '65',
    sort: 65,
    added: 'FIX.4.4',
    addedEP: '26',
    updated: 'FIX.5.0SP2',
    updatedEP: '139',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Regulated Market (RM)\n\nIdentify using PartyIDSource(tag 447) = G (Market Identifier Code) if the MIC exists.',
  },
  {
    name: 'MarketMaker',
    id: '452065',
    value: '66',
    sort: 66,
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Market Maker',
  },
  {
    name: 'InvestmentFirm',
    id: '452066',
    value: '67',
    sort: 67,
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Investment Firm',
  },
  {
    name: 'HostCompetentAuthority',
    id: '452067',
    value: '68',
    sort: 68,
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Host Competent Authority (Host CA)',
  },
  {
    name: 'HomeCompetentAuthority',
    id: '452068',
    value: '69',
    sort: 69,
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Home Competent Authority (Home CA)',
  },
  {
    name: 'CompetentAuthorityLiquidity',
    id: '452069',
    value: '70',
    sort: 70,
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Competent Authority of the most relevant market in terms of liquidity (CAL)',
  },
  {
    name: 'CompetentAuthorityTransactionVenue',
    id: '452070',
    value: '71',
    sort: 71,
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Competent Authority of the Transaction (Execution) Venue (CATV)',
  },
  {
    name: 'ReportingIntermediary',
    id: '452071',
    value: '72',
    sort: 72,
    added: 'FIX.4.4',
    addedEP: '26',
    updated: 'FIX.5.0SP2',
    updatedEP: '229',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Reporting intermediary\n\nThe medium or vendor used to report to a regulator, non-regulatory agency or data repository.',
  },
  {
    name: 'ExecutionVenue',
    id: '452072',
    value: '73',
    sort: 73,
    added: 'FIX.4.4',
    addedEP: '26',
    updated: 'FIX.5.0SP2',
    updatedEP: '139',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Execution Venue\n\nIdentify using PartyIDSource(tag 447) = G (Market Identifier Code) if the MIC exists.',
  },
  {
    name: 'MarketDataEntryOriginator',
    id: '452073',
    value: '74',
    sort: 74,
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Market data entry originator',
  },
  {
    name: 'LocationID',
    id: '452074',
    value: '75',
    sort: 75,
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Location ID',
  },
  {
    name: 'DeskID',
    id: '452075',
    value: '76',
    sort: 76,
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Desk ID',
  },
  {
    name: 'MarketDataMarket',
    id: '452076',
    value: '77',
    sort: 77,
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Market data market',
  },
  {
    name: 'AllocationEntity',
    id: '452077',
    value: '78',
    sort: 78,
    added: 'FIX.4.4',
    addedEP: '35',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Allocation Entity',
  },
  {
    name: 'PrimeBroker',
    id: '452078',
    value: '79',
    sort: 79,
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Prime Broker providing General Trade Services',
  },
  {
    name: 'StepOutFirm',
    id: '452079',
    value: '80',
    sort: 80,
    added: 'FIX.5.0',
    addedEP: '68',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Step-Out Firm (Prime Broker)',
  },
  {
    name: 'BrokerClearingID',
    id: '452080',
    value: '81',
    sort: 81,
    added: 'FIX.5.0',
    addedEP: '68',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Broker clearing identifier',
  },
  {
    name: 'CentralRegistrationDepository',
    id: '452081',
    value: '82',
    sort: 82,
    added: 'FIX.5.0SP1',
    addedEP: '79',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Central Registration Depository (CRD)',
  },
  {
    name: 'ClearingAccount',
    id: '452082',
    value: '83',
    sort: 83,
    added: 'FIX.5.0SP1',
    addedEP: '96',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Clearing Account',
  },
  {
    name: 'AcceptableSettlingCounterparty',
    id: '452083',
    value: '84',
    sort: 84,
    added: 'FIX.5.0SP1',
    addedEP: '96',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Acceptable Settling Counterparty',
  },
  {
    name: 'UnacceptableSettlingCounterparty',
    id: '452084',
    value: '85',
    sort: 85,
    added: 'FIX.5.0SP1',
    addedEP: '96',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Unacceptable Settling Counterparty',
  },
  {
    name: 'CLSMemberBank',
    id: '452085',
    value: '86',
    sort: 86,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'CLS Member Bank',
  },
  {
    name: 'InConcertGroup',
    id: '452086',
    value: '87',
    sort: 87,
    added: 'FIX.5.0SP2',
    addedEP: '103',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'In Concert Group',
  },
  {
    name: 'InConcertControllingEntity',
    id: '452087',
    value: '88',
    sort: 88,
    added: 'FIX.5.0SP2',
    addedEP: '103',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'In Concert Controlling Entity',
  },
  {
    name: 'LargePositionsReportingAccount',
    id: '452088',
    value: '89',
    sort: 89,
    added: 'FIX.5.0SP2',
    addedEP: '103',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Large Positions Reporting Account',
  },
  {
    name: 'SettlementFirm',
    id: '452089',
    value: '90',
    sort: 90,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Settlement Firm',
  },
  {
    name: 'SettlementAccount',
    id: '452090',
    value: '91',
    sort: 91,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    updated: 'FIX.5.0SP2',
    updatedEP: '155',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Settlement account\n\nThe account to which individual payment obligations are aggregated for netting and funds movement. Typically represents the aggregation of many margin (performance bond) accounts.',
  },
  {
    name: 'ReportingMarketCenter',
    id: '452091',
    value: '92',
    sort: 92,
    added: 'FIX.5.0SP2',
    addedEP: '112',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Reporting Market Center',
  },
  {
    name: 'RelatedReportingMarketCenter',
    id: '452092',
    value: '93',
    sort: 93,
    added: 'FIX.5.0SP2',
    addedEP: '112',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Related Reporting Market Center',
  },
  {
    name: 'AwayMarket',
    id: '452093',
    value: '94',
    sort: 94,
    added: 'FIX.5.0SP2',
    addedEP: '112',
    updated: 'FIX.5.0SP2',
    updatedEP: '139',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Away Market\n\nIdentify using PartyIDSource(tag 447) = G (Market Identifier Code) if the MIC exists.',
  },
  {
    name: 'GiveupTradingFirm',
    id: '452094',
    value: '95',
    sort: 95,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Give-up (trading) firm',
  },
  {
    name: 'TakeupTradingFirm',
    id: '452095',
    value: '96',
    sort: 96,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Take-up (trading) firm',
  },
  {
    name: 'GiveupClearingFirm',
    id: '452096',
    value: '97',
    sort: 97,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Give-up clearing firm',
  },
  {
    name: 'TakeupClearingFirm',
    id: '452097',
    value: '98',
    sort: 98,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Take-up clearing firm',
  },
  {
    name: 'OriginatingMarket',
    id: '452098',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '139',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Originating Market\n\nIdentifies the Market using PartyIDSource(tag 447) = G (Market Identifier Code) where an order originated in the event that the order is sent to an alternative market for execution. Serves as an inverse of an away market.',
  },
  {
    name: 'MarginAccount',
    id: '452099',
    value: '100',
    sort: 100,
    added: 'FIX.5.0SP2',
    addedEP: '155',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Margin account\n\nAlso referred to as "performance bond account". The margin account is the calculated margin requirements. Typically represents the aggregation of one or more position accounts.',
  },
  {
    name: 'CollateralAssetAccount',
    id: '452100',
    value: '101',
    sort: 101,
    added: 'FIX.5.0SP2',
    addedEP: '155',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Collateral asset account\n\nThe account at which individual collateral assets are maintained. Typically, although not always, one-for-one with the settlement account.',
  },
  {
    name: 'DataRepository',
    id: '452101',
    value: '102',
    sort: 102,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Data repository\n\nMultiple instances of this PartyRole may appear for reporting purposes.',
  },
  {
    name: 'CalculationAgent',
    id: '452102',
    value: '103',
    sort: 103,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Calculation agent',
  },
  {
    name: 'ExerciseNoticeSender',
    id: '452103',
    value: '104',
    sort: 104,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Sender of exercise notice',
  },
  {
    name: 'ExerciseNoticeReceiver',
    id: '452104',
    value: '105',
    sort: 105,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Receiver of exercise notice',
  },
  {
    name: 'RateReferenceBank',
    id: '452105',
    value: '106',
    sort: 106,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Rate reference bank\n\nThe bank providing the reference rate. Multiple instance of this PartyRole may appear.',
  },
  {
    name: 'Correspondent',
    id: '452106',
    value: '107',
    sort: 107,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Correspondent',
  },
  {
    name: 'BeneficiaryBank',
    id: '452107',
    value: '109',
    sort: 109,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      "Beneficiary's bank or depository institution\n\nThe institution in which the beneficiary, a person or an entity, has their account with. The institution may be a bank or non-bank institution.",
  },
  {
    name: 'Borrower',
    id: '452108',
    value: '110',
    sort: 110,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Borrower',
  },
  {
    name: 'PrimaryObligator',
    id: '452109',
    value: '111',
    sort: 111,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Primary obligator',
  },
  {
    name: 'Guarantor',
    id: '452110',
    value: '112',
    sort: 112,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Guarantor',
  },
  {
    name: 'ExcludedReferenceEntity',
    id: '452111',
    value: '113',
    sort: 113,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Excluded reference entity',
  },
  {
    name: 'DeterminingParty',
    id: '452112',
    value: '114',
    sort: 114,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Determining party',
  },
  {
    name: 'HedgingParty',
    id: '452113',
    value: '115',
    sort: 115,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Hedging party',
  },
  {
    name: 'ReportingEntity',
    id: '452114',
    value: '116',
    sort: 116,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Reporting entity\n\nThe entity that is reporting the information.',
  },
  {
    name: 'SalesPerson',
    id: '452115',
    value: '117',
    sort: 117,
    added: 'FIX.5.0SP2',
    addedEP: '173',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Sales person\n\nThe person who is involved in the sales activities for their firm.',
  },
  {
    name: 'Operator',
    id: '452116',
    value: '118',
    sort: 118,
    added: 'FIX.5.0SP2',
    addedEP: '173',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Operator\n\nThe person who has the capabilities and authorization to take certain actions; for example, setting entitlements, etc.',
  },
  {
    name: 'CSD',
    id: '452117',
    value: '119',
    sort: 119,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Central Securities Depository (CSD)',
  },
  {
    name: 'ICSD',
    id: '452118',
    value: '120',
    sort: 120,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'International Central Securities Depository (ICSD)',
  },
  {
    name: 'TradingSubAccount',
    id: '452119',
    value: '121',
    sort: 121,
    added: 'FIX.5.0SP2',
    addedEP: '217',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Trading sub-account\n\nExample of sub-accounts include a clearing account that has multiple trading sub-accounts, a trading account that has multiple trading sub-accounts belonging to different trading firms.',
  },
  {
    name: 'InvestmentDecisionMaker',
    id: '452120',
    value: '122',
    sort: 122,
    added: 'FIX.5.0SP2',
    addedEP: '222',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Investment decision maker\n\nIn the context of ESMA RTS reporting, this is used to specify party responsible for the investment decision. See RTS 24, Annex, Table 2, Field 4.',
  },
  {
    name: 'PublishingIntermediary',
    id: '452121',
    value: '123',
    sort: 123,
    added: 'FIX.5.0SP2',
    addedEP: '229',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Publishing intermediary\n\nThe medium or vendor used to publish to the market.',
  },
  {
    name: 'CSDParticipant',
    id: '452122',
    value: '124',
    sort: 124,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Central Securities Depository (CSD) Participant\n\nIn the context of EU SFTR reporting the identifier of the CSD participant or indirect participant of the reporting counterparty. Where both the CSD participant and indirect participant are involved in the transaction this should identify the indirect participant.',
  },
  {
    name: 'Issuer',
    id: '452123',
    value: '125',
    sort: 125,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description: 'Issuer\n\nThe issuer of the security.',
  },
  {
    name: 'ContraCustomerAccount',
    id: '452124',
    value: '126',
    sort: 126,
    added: 'FIX.5.0SP2',
    addedEP: '256',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Contra Customer Account\n\nSame as PartyRole(452) = 24 (Customer Account) but for the counterparty. Can be used whenever the parties component is not nested in a repeating group representing both sides.',
  },
  {
    name: 'ContraInvestmentDecisionMaker',
    id: '452125',
    value: '127',
    sort: 127,
    added: 'FIX.5.0SP2',
    addedEP: '256',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Contra Investment Decision Maker\n\nSame as PartyRole(452) = 122 (Investment Decision Maker) but for the counterparty. Can be used whenever the parties component is not nested in a repeating group representing both sides.',
  },
  {
    name: 'AuthorizingPerson',
    id: '452126',
    value: '128',
    sort: 128,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 452,
    type: 'int',
    codeSet: 'PartyRoleCodeSet',
    description:
      'Authorizing person\n\nIn the context of MiFIR, this value is used to identify the person authorizing algorithms within a trading firm.',
  },
  {
    name: 'AGENCY',
    id: '460001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 460,
    type: 'int',
    codeSet: 'ProductCodeSet',
    description: 'AGENCY',
  },
  {
    name: 'COMMODITY',
    id: '460002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 460,
    type: 'int',
    codeSet: 'ProductCodeSet',
    description: 'COMMODITY',
  },
  {
    name: 'CORPORATE',
    id: '460003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 460,
    type: 'int',
    codeSet: 'ProductCodeSet',
    description: 'CORPORATE',
  },
  {
    name: 'CURRENCY',
    id: '460004',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    tag: 460,
    type: 'int',
    codeSet: 'ProductCodeSet',
    description: 'CURRENCY',
  },
  {
    name: 'EQUITY',
    id: '460005',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    tag: 460,
    type: 'int',
    codeSet: 'ProductCodeSet',
    description: 'EQUITY',
  },
  {
    name: 'GOVERNMENT',
    id: '460006',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    tag: 460,
    type: 'int',
    codeSet: 'ProductCodeSet',
    description: 'GOVERNMENT',
  },
  {
    name: 'INDEX',
    id: '460007',
    value: '7',
    sort: 7,
    added: 'FIX.4.3',
    tag: 460,
    type: 'int',
    codeSet: 'ProductCodeSet',
    description: 'INDEX',
  },
  {
    name: 'LOAN',
    id: '460008',
    value: '8',
    sort: 8,
    added: 'FIX.4.3',
    tag: 460,
    type: 'int',
    codeSet: 'ProductCodeSet',
    description: 'LOAN',
  },
  {
    name: 'MONEYMARKET',
    id: '460009',
    value: '9',
    sort: 9,
    added: 'FIX.4.3',
    tag: 460,
    type: 'int',
    codeSet: 'ProductCodeSet',
    description: 'MONEYMARKET',
  },
  {
    name: 'MORTGAGE',
    id: '460010',
    value: '10',
    sort: 10,
    added: 'FIX.4.3',
    tag: 460,
    type: 'int',
    codeSet: 'ProductCodeSet',
    description: 'MORTGAGE',
  },
  {
    name: 'MUNICIPAL',
    id: '460011',
    value: '11',
    sort: 11,
    added: 'FIX.4.3',
    tag: 460,
    type: 'int',
    codeSet: 'ProductCodeSet',
    description: 'MUNICIPAL',
  },
  {
    name: 'OTHER',
    id: '460012',
    value: '12',
    sort: 12,
    added: 'FIX.4.3',
    tag: 460,
    type: 'int',
    codeSet: 'ProductCodeSet',
    description: 'OTHER',
  },
  {
    name: 'FINANCING',
    id: '460013',
    value: '13',
    sort: 13,
    added: 'FIX.4.4',
    tag: 460,
    type: 'int',
    codeSet: 'ProductCodeSet',
    description: 'FINANCING',
  },
  {
    name: 'False',
    id: '464001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 464,
    type: 'Boolean',
    codeSet: 'TestMessageIndicatorCodeSet',
    description: 'False (production)',
  },
  {
    name: 'True',
    id: '464002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 464,
    type: 'Boolean',
    codeSet: 'TestMessageIndicatorCodeSet',
    description: 'True (test)',
  },
  {
    name: 'RoundToNearest',
    id: '468001',
    value: '0',
    sort: 1,
    added: 'FIX.4.3',
    tag: 468,
    type: 'char',
    codeSet: 'RoundingDirectionCodeSet',
    description: 'Round to nearest',
  },
  {
    name: 'RoundDown',
    id: '468002',
    value: '1',
    sort: 2,
    added: 'FIX.4.3',
    tag: 468,
    type: 'char',
    codeSet: 'RoundingDirectionCodeSet',
    description: 'Round down',
  },
  {
    name: 'RoundUp',
    id: '468003',
    value: '2',
    sort: 3,
    added: 'FIX.4.3',
    tag: 468,
    type: 'char',
    codeSet: 'RoundingDirectionCodeSet',
    description: 'Round up',
  },
  {
    name: 'CREST',
    id: '477001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 477,
    type: 'int',
    codeSet: 'DistribPaymentMethodCodeSet',
    description: 'CREST',
  },
  {
    name: 'NSCC',
    id: '477002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 477,
    type: 'int',
    codeSet: 'DistribPaymentMethodCodeSet',
    description: 'NSCC',
  },
  {
    name: 'Euroclear',
    id: '477003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    tag: 477,
    type: 'int',
    codeSet: 'DistribPaymentMethodCodeSet',
    description: 'Euroclear',
  },
  {
    name: 'Clearstream',
    id: '477004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    tag: 477,
    type: 'int',
    codeSet: 'DistribPaymentMethodCodeSet',
    description: 'Clearstream',
  },
  {
    name: 'Cheque',
    id: '477005',
    value: '5',
    sort: 5,
    added: 'FIX.4.4',
    tag: 477,
    type: 'int',
    codeSet: 'DistribPaymentMethodCodeSet',
    description: 'Cheque',
  },
  {
    name: 'TelegraphicTransfer',
    id: '477006',
    value: '6',
    sort: 6,
    added: 'FIX.4.4',
    tag: 477,
    type: 'int',
    codeSet: 'DistribPaymentMethodCodeSet',
    description: 'Telegraphic Transfer',
  },
  {
    name: 'FedWire',
    id: '477007',
    value: '7',
    sort: 7,
    added: 'FIX.4.4',
    tag: 477,
    type: 'int',
    codeSet: 'DistribPaymentMethodCodeSet',
    description: 'Fed Wire',
  },
  {
    name: 'DirectCredit',
    id: '477008',
    value: '8',
    sort: 8,
    added: 'FIX.4.4',
    tag: 477,
    type: 'int',
    codeSet: 'DistribPaymentMethodCodeSet',
    description: 'Direct Credit (BECS, BACS)',
  },
  {
    name: 'ACHCredit',
    id: '477009',
    value: '9',
    sort: 9,
    added: 'FIX.4.4',
    tag: 477,
    type: 'int',
    codeSet: 'DistribPaymentMethodCodeSet',
    description: 'ACH Credit',
  },
  {
    name: 'BPAY',
    id: '477010',
    value: '10',
    sort: 10,
    added: 'FIX.4.4',
    tag: 477,
    type: 'int',
    codeSet: 'DistribPaymentMethodCodeSet',
    description: 'BPAY',
  },
  {
    name: 'HighValueClearingSystemHVACS',
    id: '477011',
    value: '11',
    sort: 11,
    added: 'FIX.4.4',
    tag: 477,
    type: 'int',
    codeSet: 'DistribPaymentMethodCodeSet',
    description: 'High Value Clearing System HVACS',
  },
  {
    name: 'ReinvestInFund',
    id: '477012',
    value: '12',
    sort: 12,
    added: 'FIX.4.4',
    tag: 477,
    type: 'int',
    codeSet: 'DistribPaymentMethodCodeSet',
    description: 'Reinvest In Fund',
  },
  {
    name: 'Other',
    id: '477013',
    value: '999',
    sort: 999,
    added: 'FIX.Latest',
    addedEP: '271',
    tag: 477,
    type: 'int',
    codeSet: 'DistribPaymentMethodCodeSet',
    description: 'Other',
  },
  {
    name: 'Yes',
    id: '480001',
    value: 'Y',
    sort: 1,
    added: 'FIX.4.3',
    tag: 480,
    type: 'char',
    codeSet: 'CancellationRightsCodeSet',
    description: 'Yes',
  },
  {
    name: 'NoExecutionOnly',
    id: '480002',
    value: 'N',
    sort: 2,
    added: 'FIX.4.3',
    tag: 480,
    type: 'char',
    codeSet: 'CancellationRightsCodeSet',
    description: 'No - Execution Only',
  },
  {
    name: 'NoWaiverAgreement',
    id: '480003',
    value: 'M',
    sort: 3,
    added: 'FIX.4.3',
    tag: 480,
    type: 'char',
    codeSet: 'CancellationRightsCodeSet',
    description: 'No - Waiver agreement',
  },
  {
    name: 'NoInstitutional',
    id: '480004',
    value: 'O',
    sort: 4,
    added: 'FIX.4.3',
    tag: 480,
    type: 'char',
    codeSet: 'CancellationRightsCodeSet',
    description: 'No - Institutional',
  },
  {
    name: 'Passed',
    id: '481001',
    value: 'Y',
    sort: 1,
    added: 'FIX.4.3',
    tag: 481,
    type: 'char',
    codeSet: 'MoneyLaunderingStatusCodeSet',
    description: 'Passed',
  },
  {
    name: 'NotChecked',
    id: '481002',
    value: 'N',
    sort: 2,
    added: 'FIX.4.3',
    tag: 481,
    type: 'char',
    codeSet: 'MoneyLaunderingStatusCodeSet',
    description: 'Not Checked',
  },
  {
    name: 'ExemptBelowLimit',
    id: '481003',
    value: '1',
    sort: 3,
    added: 'FIX.4.3',
    tag: 481,
    type: 'char',
    codeSet: 'MoneyLaunderingStatusCodeSet',
    description: 'Exempt - Below the Limit',
  },
  {
    name: 'ExemptMoneyType',
    id: '481004',
    value: '2',
    sort: 4,
    added: 'FIX.4.3',
    tag: 481,
    type: 'char',
    codeSet: 'MoneyLaunderingStatusCodeSet',
    description: 'Exempt - Client Money Type exemption',
  },
  {
    name: 'ExemptAuthorised',
    id: '481005',
    value: '3',
    sort: 5,
    added: 'FIX.4.3',
    tag: 481,
    type: 'char',
    codeSet: 'MoneyLaunderingStatusCodeSet',
    description: 'Exempt - Authorised Credit or financial institution',
  },
  {
    name: 'BidPrice',
    id: '484001',
    value: 'B',
    sort: 1,
    added: 'FIX.4.3',
    tag: 484,
    type: 'char',
    codeSet: 'ExecPriceTypeCodeSet',
    description: 'Bid price',
  },
  {
    name: 'CreationPrice',
    id: '484002',
    value: 'C',
    sort: 2,
    added: 'FIX.4.3',
    tag: 484,
    type: 'char',
    codeSet: 'ExecPriceTypeCodeSet',
    description: 'Creation price',
  },
  {
    name: 'CreationPricePlusAdjustmentPercent',
    id: '484003',
    value: 'D',
    sort: 3,
    added: 'FIX.4.3',
    tag: 484,
    type: 'char',
    codeSet: 'ExecPriceTypeCodeSet',
    description: 'Creation price plus adjustment percent',
  },
  {
    name: 'CreationPricePlusAdjustmentAmount',
    id: '484004',
    value: 'E',
    sort: 4,
    added: 'FIX.4.3',
    tag: 484,
    type: 'char',
    codeSet: 'ExecPriceTypeCodeSet',
    description: 'Creation price plus adjustment amount',
  },
  {
    name: 'OfferPrice',
    id: '484005',
    value: 'O',
    sort: 5,
    added: 'FIX.4.3',
    tag: 484,
    type: 'char',
    codeSet: 'ExecPriceTypeCodeSet',
    description: 'Offer price',
  },
  {
    name: 'OfferPriceMinusAdjustmentPercent',
    id: '484006',
    value: 'P',
    sort: 6,
    added: 'FIX.4.3',
    tag: 484,
    type: 'char',
    codeSet: 'ExecPriceTypeCodeSet',
    description: 'Offer price minus adjustment percent',
  },
  {
    name: 'OfferPriceMinusAdjustmentAmount',
    id: '484007',
    value: 'Q',
    sort: 7,
    added: 'FIX.4.3',
    tag: 484,
    type: 'char',
    codeSet: 'ExecPriceTypeCodeSet',
    description: 'Offer price minus adjustment amount',
  },
  {
    name: 'SinglePrice',
    id: '484008',
    value: 'S',
    sort: 8,
    added: 'FIX.4.3',
    tag: 484,
    type: 'char',
    codeSet: 'ExecPriceTypeCodeSet',
    description: 'Single price',
  },
  {
    name: 'New',
    id: '487001',
    value: '0',
    sort: 1,
    added: 'FIX.4.3',
    updated: 'FIX.4.4',
    tag: 487,
    type: 'int',
    codeSet: 'TradeReportTransTypeCodeSet',
    description: 'New',
  },
  {
    name: 'Cancel',
    id: '487002',
    value: '1',
    sort: 2,
    added: 'FIX.4.3',
    updated: 'FIX.4.4',
    tag: 487,
    type: 'int',
    codeSet: 'TradeReportTransTypeCodeSet',
    description: 'Cancel',
  },
  {
    name: 'Replace',
    id: '487003',
    value: '2',
    sort: 3,
    added: 'FIX.4.3',
    updated: 'FIX.4.4',
    tag: 487,
    type: 'int',
    codeSet: 'TradeReportTransTypeCodeSet',
    description: 'Replace',
  },
  {
    name: 'Release',
    id: '487004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 487,
    type: 'int',
    codeSet: 'TradeReportTransTypeCodeSet',
    description: 'Release',
  },
  {
    name: 'Reverse',
    id: '487005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    tag: 487,
    type: 'int',
    codeSet: 'TradeReportTransTypeCodeSet',
    description: 'Reverse',
  },
  {
    name: 'CancelDueToBackOutOfTrade',
    id: '487006',
    value: '5',
    sort: 6,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 487,
    type: 'int',
    codeSet: 'TradeReportTransTypeCodeSet',
    description: 'Cancel Due To Back Out of Trade',
  },
  {
    name: 'CREST',
    id: '492001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'CREST',
  },
  {
    name: 'NSCC',
    id: '492002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'NSCC',
  },
  {
    name: 'Euroclear',
    id: '492003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'Euroclear',
  },
  {
    name: 'Clearstream',
    id: '492004',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'Clearstream',
  },
  {
    name: 'Cheque',
    id: '492005',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'Cheque',
  },
  {
    name: 'TelegraphicTransfer',
    id: '492006',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'Telegraphic Transfer',
  },
  {
    name: 'FedWire',
    id: '492007',
    value: '7',
    sort: 7,
    added: 'FIX.4.3',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'Fed Wire',
  },
  {
    name: 'DebitCard',
    id: '492008',
    value: '8',
    sort: 8,
    added: 'FIX.4.3',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'Debit Card',
  },
  {
    name: 'DirectDebit',
    id: '492009',
    value: '9',
    sort: 9,
    added: 'FIX.4.3',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'Direct Debit (BECS)',
  },
  {
    name: 'DirectCredit',
    id: '492010',
    value: '10',
    sort: 10,
    added: 'FIX.4.3',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'Direct Credit (BECS)',
  },
  {
    name: 'CreditCard',
    id: '492011',
    value: '11',
    sort: 11,
    added: 'FIX.4.3',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'Credit Card',
  },
  {
    name: 'ACHDebit',
    id: '492012',
    value: '12',
    sort: 12,
    added: 'FIX.4.3',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'ACH Debit',
  },
  {
    name: 'ACHCredit',
    id: '492013',
    value: '13',
    sort: 13,
    added: 'FIX.4.3',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'ACH Credit',
  },
  {
    name: 'BPAY',
    id: '492014',
    value: '14',
    sort: 14,
    added: 'FIX.4.3',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'BPAY',
  },
  {
    name: 'HighValueClearingSystem',
    id: '492015',
    value: '15',
    sort: 15,
    added: 'FIX.4.3',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'High Value Clearing System (HVACS)',
  },
  {
    name: 'CHIPS',
    id: '492016',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'CHIPS',
  },
  {
    name: 'SWIFT',
    id: '492017',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'S.W.I.F.T.',
  },
  {
    name: 'CHAPS',
    id: '492018',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'CHAPS',
  },
  {
    name: 'SIC',
    id: '492019',
    value: '19',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'SIC',
  },
  {
    name: 'EuroSIC',
    id: '492020',
    value: '20',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '259',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'euroSIC\n\n',
  },
  {
    name: 'Other',
    id: '492021',
    value: '999',
    sort: 999,
    added: 'FIX.Latest',
    addedEP: '271',
    tag: 492,
    type: 'int',
    codeSet: 'PaymentMethodCodeSet',
    description: 'Other',
  },
  {
    name: 'None',
    id: '495001',
    value: '0',
    sort: 0,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'None/Not Applicable (default)',
  },
  {
    name: 'MaxiISA',
    id: '495002',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Maxi ISA (UK)',
  },
  {
    name: 'TESSA',
    id: '495003',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'TESSA (UK)',
  },
  {
    name: 'MiniCashISA',
    id: '495004',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Mini Cash ISA (UK)',
  },
  {
    name: 'MiniStocksAndSharesISA',
    id: '495005',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Mini Stocks And Shares ISA (UK)',
  },
  {
    name: 'MiniInsuranceISA',
    id: '495006',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Mini Insurance ISA (UK)',
  },
  {
    name: 'CurrentYearPayment',
    id: '495007',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Current Year Payment (US)',
  },
  {
    name: 'PriorYearPayment',
    id: '495008',
    value: '7',
    sort: 7,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Prior Year Payment (US)',
  },
  {
    name: 'AssetTransfer',
    id: '495009',
    value: '8',
    sort: 8,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Asset Transfer (US)',
  },
  {
    name: 'EmployeePriorYear',
    id: '495010',
    value: '9',
    sort: 9,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Employee - prior year (US)',
  },
  {
    name: 'EmployeeCurrentYear',
    id: '495011',
    value: '10',
    sort: 10,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Employee - current year (US)',
  },
  {
    name: 'EmployerPriorYear',
    id: '495012',
    value: '11',
    sort: 11,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Employer - prior year (US)',
  },
  {
    name: 'EmployerCurrentYear',
    id: '495013',
    value: '12',
    sort: 12,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Employer - current year (US)',
  },
  {
    name: 'NonFundPrototypeIRA',
    id: '495014',
    value: '13',
    sort: 13,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Non-fund prototype IRA (US)',
  },
  {
    name: 'NonFundQualifiedPlan',
    id: '495015',
    value: '14',
    sort: 14,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Non-fund qualified plan (US)',
  },
  {
    name: 'DefinedContributionPlan',
    id: '495016',
    value: '15',
    sort: 15,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Defined contribution plan (US)',
  },
  {
    name: 'IRA',
    id: '495017',
    value: '16',
    sort: 16,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Individual Retirement Account (US)',
  },
  {
    name: 'IRARollover',
    id: '495018',
    value: '17',
    sort: 17,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Individual Retirement Account - Rollover (US)',
  },
  {
    name: 'KEOGH',
    id: '495019',
    value: '18',
    sort: 18,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'KEOGH (US)',
  },
  {
    name: 'ProfitSharingPlan',
    id: '495020',
    value: '19',
    sort: 19,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Profit Sharing Plan (US)',
  },
  {
    name: 'US401K',
    id: '495021',
    value: '20',
    sort: 20,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: '401(k) (US)',
  },
  {
    name: 'SelfDirectedIRA',
    id: '495022',
    value: '21',
    sort: 21,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Self-directed IRA (US)',
  },
  {
    name: 'US403b',
    id: '495023',
    value: '22',
    sort: 22,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: '403(b) (US)',
  },
  {
    name: 'US457',
    id: '495024',
    value: '23',
    sort: 23,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: '457 (US)',
  },
  {
    name: 'RothIRAPrototype',
    id: '495025',
    value: '24',
    sort: 24,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Roth IRA (Fund Prototype) (US)',
  },
  {
    name: 'RothIRANonPrototype',
    id: '495026',
    value: '25',
    sort: 25,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Roth IRA (Non-prototype) (US)',
  },
  {
    name: 'RothConversionIRAPrototype',
    id: '495027',
    value: '26',
    sort: 26,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Roth Conversion IRA (Fund Prototype) (US)',
  },
  {
    name: 'RothConversionIRANonPrototype',
    id: '495028',
    value: '27',
    sort: 27,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Roth Conversion IRA (Non-prototype) (US)',
  },
  {
    name: 'EducationIRAPrototype',
    id: '495029',
    value: '28',
    sort: 28,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Education IRA (Fund Prototype) (US)',
  },
  {
    name: 'EducationIRANonPrototype',
    id: '495030',
    value: '29',
    sort: 29,
    added: 'FIX.4.3',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Education IRA (Non-prototype) (US)',
  },
  {
    name: 'Other',
    id: '495031',
    value: '999',
    sort: 99,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 495,
    type: 'int',
    codeSet: 'TaxAdvantageTypeCodeSet',
    description: 'Other',
  },
  {
    name: 'No',
    id: '497001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.3',
    tag: 497,
    type: 'char',
    codeSet: 'FundRenewWaivCodeSet',
    description: 'No',
  },
  {
    name: 'Yes',
    id: '497002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.3',
    tag: 497,
    type: 'char',
    codeSet: 'FundRenewWaivCodeSet',
    description: 'Yes',
  },
  {
    name: 'Accepted',
    id: '506001',
    value: 'A',
    sort: 1,
    added: 'FIX.4.3',
    tag: 506,
    type: 'char',
    codeSet: 'RegistStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Rejected',
    id: '506002',
    value: 'R',
    sort: 2,
    added: 'FIX.4.3',
    tag: 506,
    type: 'char',
    codeSet: 'RegistStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'Held',
    id: '506003',
    value: 'H',
    sort: 3,
    added: 'FIX.4.3',
    tag: 506,
    type: 'char',
    codeSet: 'RegistStatusCodeSet',
    description: 'Held',
  },
  {
    name: 'Reminder',
    id: '506004',
    value: 'N',
    sort: 4,
    added: 'FIX.4.3',
    tag: 506,
    type: 'char',
    codeSet: 'RegistStatusCodeSet',
    description: 'Reminder - i.e. Registration Instructions are still outstanding',
  },
  {
    name: 'InvalidAccountType',
    id: '507001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Invalid/unacceptable Account Type',
  },
  {
    name: 'InvalidTaxExemptType',
    id: '507002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Invalid/unacceptable Tax Exempt Type',
  },
  {
    name: 'InvalidOwnershipType',
    id: '507003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Invalid/unacceptable Ownership Type',
  },
  {
    name: 'NoRegDetails',
    id: '507004',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Invalid/unacceptable No Reg Details',
  },
  {
    name: 'InvalidRegSeqNo',
    id: '507005',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Invalid/unacceptable Reg Seq No',
  },
  {
    name: 'InvalidRegDetails',
    id: '507006',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Invalid/unacceptable Reg Details',
  },
  {
    name: 'InvalidMailingDetails',
    id: '507007',
    value: '7',
    sort: 7,
    added: 'FIX.4.3',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Invalid/unacceptable Mailing Details',
  },
  {
    name: 'InvalidMailingInstructions',
    id: '507008',
    value: '8',
    sort: 8,
    added: 'FIX.4.3',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Invalid/unacceptable Mailing Instructions',
  },
  {
    name: 'InvalidInvestorID',
    id: '507009',
    value: '9',
    sort: 9,
    added: 'FIX.4.3',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Invalid/unacceptable Investor ID',
  },
  {
    name: 'InvalidInvestorIDSource',
    id: '507010',
    value: '10',
    sort: 10,
    added: 'FIX.4.3',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Invalid/unaceeptable Investor ID Source',
  },
  {
    name: 'InvalidDateOfBirth',
    id: '507011',
    value: '11',
    sort: 11,
    added: 'FIX.4.3',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Invalid/unacceptable Date Of Birth',
  },
  {
    name: 'InvalidCountry',
    id: '507012',
    value: '12',
    sort: 12,
    added: 'FIX.4.3',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Invalid/unacceptable Investor Country Of Residence',
  },
  {
    name: 'InvalidDistribInstns',
    id: '507013',
    value: '13',
    sort: 13,
    added: 'FIX.4.3',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Invalid/unacceptable No Distrib Instns',
  },
  {
    name: 'InvalidPercentage',
    id: '507014',
    value: '14',
    sort: 14,
    added: 'FIX.4.3',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Invalid/unacceptable Distrib Percentage',
  },
  {
    name: 'InvalidPaymentMethod',
    id: '507015',
    value: '15',
    sort: 15,
    added: 'FIX.4.3',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Invalid/unacceptable Distrib Payment Method',
  },
  {
    name: 'InvalidAccountName',
    id: '507016',
    value: '16',
    sort: 16,
    added: 'FIX.4.3',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Invalid/unacceptable Cash Distrib Agent Acct Name',
  },
  {
    name: 'InvalidAgentCode',
    id: '507017',
    value: '17',
    sort: 17,
    added: 'FIX.4.3',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Invalid/unacceptable Cash Distrib Agent Code',
  },
  {
    name: 'InvalidAccountNum',
    id: '507018',
    value: '18',
    sort: 18,
    added: 'FIX.4.3',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Invalid/unacceptable Cash Distrib Agent Acct Num',
  },
  {
    name: 'Other',
    id: '507019',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    tag: 507,
    type: 'int',
    codeSet: 'RegistRejReasonCodeCodeSet',
    description: 'Other',
  },
  {
    name: 'New',
    id: '514001',
    value: '0',
    sort: 1,
    added: 'FIX.4.3',
    tag: 514,
    type: 'char',
    codeSet: 'RegistTransTypeCodeSet',
    description: 'New',
  },
  {
    name: 'Cancel',
    id: '514002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 514,
    type: 'char',
    codeSet: 'RegistTransTypeCodeSet',
    description: 'Cancel',
  },
  {
    name: 'Replace',
    id: '514003',
    value: '1',
    sort: 3,
    added: 'FIX.4.3',
    tag: 514,
    type: 'char',
    codeSet: 'RegistTransTypeCodeSet',
    description: 'Replace',
  },
  {
    name: 'JointInvestors',
    id: '517001',
    value: 'J',
    sort: 1,
    added: 'FIX.4.4',
    tag: 517,
    type: 'char',
    codeSet: 'OwnershipTypeCodeSet',
    description: 'Joint Investors',
  },
  {
    name: 'TenantsInCommon',
    id: '517002',
    value: 'T',
    sort: 2,
    added: 'FIX.4.4',
    tag: 517,
    type: 'char',
    codeSet: 'OwnershipTypeCodeSet',
    description: 'Tenants in Common',
  },
  {
    name: 'JointTrustees',
    id: '517003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 517,
    type: 'char',
    codeSet: 'OwnershipTypeCodeSet',
    description: 'Joint Trustees',
  },
  {
    name: 'CommissionAmount',
    id: '519001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 519,
    type: 'int',
    codeSet: 'ContAmtTypeCodeSet',
    description: 'Commission amount (actual)',
  },
  {
    name: 'CommissionPercent',
    id: '519002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 519,
    type: 'int',
    codeSet: 'ContAmtTypeCodeSet',
    description: 'Commission percent (actual)',
  },
  {
    name: 'InitialChargeAmount',
    id: '519003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 519,
    type: 'int',
    codeSet: 'ContAmtTypeCodeSet',
    description: 'Initial Charge Amount',
  },
  {
    name: 'InitialChargePercent',
    id: '519004',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    tag: 519,
    type: 'int',
    codeSet: 'ContAmtTypeCodeSet',
    description: 'Initial Charge Percent',
  },
  {
    name: 'DiscountAmount',
    id: '519005',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    tag: 519,
    type: 'int',
    codeSet: 'ContAmtTypeCodeSet',
    description: 'Discount Amount',
  },
  {
    name: 'DiscountPercent',
    id: '519006',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    tag: 519,
    type: 'int',
    codeSet: 'ContAmtTypeCodeSet',
    description: 'Discount Percent',
  },
  {
    name: 'DilutionLevyAmount',
    id: '519007',
    value: '7',
    sort: 7,
    added: 'FIX.4.3',
    tag: 519,
    type: 'int',
    codeSet: 'ContAmtTypeCodeSet',
    description: 'Dilution Levy Amount',
  },
  {
    name: 'DilutionLevyPercent',
    id: '519008',
    value: '8',
    sort: 8,
    added: 'FIX.4.3',
    tag: 519,
    type: 'int',
    codeSet: 'ContAmtTypeCodeSet',
    description: 'Dilution Levy Percent',
  },
  {
    name: 'ExitChargeAmount',
    id: '519009',
    value: '9',
    sort: 9,
    added: 'FIX.4.3',
    tag: 519,
    type: 'int',
    codeSet: 'ContAmtTypeCodeSet',
    description: 'Exit Charge Amount',
  },
  {
    name: 'ExitChargePercent',
    id: '519010',
    value: '10',
    sort: 10,
    added: 'FIX.4.3',
    tag: 519,
    type: 'int',
    codeSet: 'ContAmtTypeCodeSet',
    description: 'Exit Charge Percent',
  },
  {
    name: 'FundBasedRenewalCommissionPercent',
    id: '519011',
    value: '11',
    sort: 11,
    added: 'FIX.4.3',
    tag: 519,
    type: 'int',
    codeSet: 'ContAmtTypeCodeSet',
    description: 'Fund-Based Renewal Commission Percent (a.k.a. Trail commission)',
  },
  {
    name: 'ProjectedFundValue',
    id: '519012',
    value: '12',
    sort: 12,
    added: 'FIX.4.3',
    tag: 519,
    type: 'int',
    codeSet: 'ContAmtTypeCodeSet',
    description:
      'Projected Fund Value (i.e. for investments intended to realise or exceed a specific future value)',
  },
  {
    name: 'FundBasedRenewalCommissionOnOrder',
    id: '519013',
    value: '13',
    sort: 13,
    added: 'FIX.4.3',
    tag: 519,
    type: 'int',
    codeSet: 'ContAmtTypeCodeSet',
    description: 'Fund-Based Renewal Commission Amount (based on Order value)',
  },
  {
    name: 'FundBasedRenewalCommissionOnFund',
    id: '519014',
    value: '14',
    sort: 14,
    added: 'FIX.4.3',
    tag: 519,
    type: 'int',
    codeSet: 'ContAmtTypeCodeSet',
    description: 'Fund-Based Renewal Commission Amount (based on Projected Fund value)',
  },
  {
    name: 'NetSettlementAmount',
    id: '519015',
    value: '15',
    sort: 15,
    added: 'FIX.4.3',
    tag: 519,
    type: 'int',
    codeSet: 'ContAmtTypeCodeSet',
    description: 'Net Settlement Amount',
  },
  {
    name: 'IndividualInvestor',
    id: '522001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Individual investor',
  },
  {
    name: 'PublicCompany',
    id: '522002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Public company',
  },
  {
    name: 'PrivateCompany',
    id: '522003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Private company',
  },
  {
    name: 'IndividualTrustee',
    id: '522004',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Individual trustee',
  },
  {
    name: 'CompanyTrustee',
    id: '522005',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Company trustee',
  },
  {
    name: 'PensionPlan',
    id: '522006',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Pension plan',
  },
  {
    name: 'CustodianUnderGiftsToMinorsAct',
    id: '522007',
    value: '7',
    sort: 7,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Custodian under Gifts to Minors Act',
  },
  {
    name: 'Trusts',
    id: '522008',
    value: '8',
    sort: 8,
    added: 'FIX.4.3',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Trusts',
  },
  {
    name: 'Fiduciaries',
    id: '522009',
    value: '9',
    sort: 9,
    added: 'FIX.4.3',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Fiduciaries',
  },
  {
    name: 'NetworkingSubAccount',
    id: '522010',
    value: '10',
    sort: 10,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Networking sub-account',
  },
  {
    name: 'NonProfitOrganization',
    id: '522011',
    value: '11',
    sort: 11,
    added: 'FIX.4.3',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Non-profit organization',
  },
  {
    name: 'CorporateBody',
    id: '522012',
    value: '12',
    sort: 12,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Corporate body',
  },
  {
    name: 'Nominee',
    id: '522013',
    value: '13',
    sort: 13,
    added: 'FIX.4.3',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Nominee',
  },
  {
    name: 'InstitutionalCustomer',
    id: '522014',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Institutional customer',
  },
  {
    name: 'Combined',
    id: '522015',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description:
      'Combined\n\nRepresenting more than one type of beneficial owner account.',
  },
  {
    name: 'MemberFirmEmployee',
    id: '522016',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Member firm employee or associated person',
  },
  {
    name: 'MarketMakingAccount',
    id: '522017',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Market making account',
  },
  {
    name: 'ProprietaryAccount',
    id: '522018',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Proprietary account',
  },
  {
    name: 'NonbrokerDealer',
    id: '522019',
    value: '19',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Non-broker-dealer',
  },
  {
    name: 'UnknownBeneficialOwnerType',
    id: '522020',
    value: '20',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '135',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description:
      'Unknown beneficial owner type\n\nIn the context of US CAT this is a non-broker-dealer foreign affiliate or non-reporting foreign broker-dealer.',
  },
  {
    name: 'FirmsErrorAccount',
    id: '522021',
    value: '21',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Error account of firm',
  },
  {
    name: 'FirmAgencyAveragePriceAccount',
    id: '522022',
    value: '22',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 522,
    type: 'int',
    codeSet: 'OwnerTypeCodeSet',
    description: 'Firm agency average price account',
  },
  {
    name: 'Agency',
    id: '528001',
    value: 'A',
    sort: 1,
    added: 'FIX.4.3',
    tag: 528,
    type: 'char',
    codeSet: 'OrderCapacityCodeSet',
    description: 'Agency',
  },
  {
    name: 'Proprietary',
    id: '528002',
    value: 'G',
    sort: 2,
    added: 'FIX.4.3',
    tag: 528,
    type: 'char',
    codeSet: 'OrderCapacityCodeSet',
    description: 'Proprietary',
  },
  {
    name: 'Individual',
    id: '528003',
    value: 'I',
    sort: 3,
    added: 'FIX.4.3',
    tag: 528,
    type: 'char',
    codeSet: 'OrderCapacityCodeSet',
    description: 'Individual',
  },
  {
    name: 'Principal',
    id: '528004',
    value: 'P',
    sort: 4,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 528,
    type: 'char',
    codeSet: 'OrderCapacityCodeSet',
    description: 'Principal\n\nFor some markets Principal may include Proprietary.',
  },
  {
    name: 'RisklessPrincipal',
    id: '528005',
    value: 'R',
    sort: 5,
    added: 'FIX.4.3',
    tag: 528,
    type: 'char',
    codeSet: 'OrderCapacityCodeSet',
    description: 'Riskless Principal',
  },
  {
    name: 'AgentForOtherMember',
    id: '528006',
    value: 'W',
    sort: 6,
    added: 'FIX.4.3',
    tag: 528,
    type: 'char',
    codeSet: 'OrderCapacityCodeSet',
    description: 'Agent for Other Member',
  },
  {
    name: 'MixedCapacity',
    id: '528007',
    value: 'M',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    tag: 528,
    type: 'char',
    codeSet: 'OrderCapacityCodeSet',
    description: 'Mixed capacity',
  },
  {
    name: 'ProgramTrade',
    id: '529001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 529,
    type: 'MultipleCharValue',
    codeSet: 'OrderRestrictionsCodeSet',
    description: 'Program Trade',
  },
  {
    name: 'IndexArbitrage',
    id: '529002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 529,
    type: 'MultipleCharValue',
    codeSet: 'OrderRestrictionsCodeSet',
    description: 'Index Arbitrage',
  },
  {
    name: 'NonIndexArbitrage',
    id: '529003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 529,
    type: 'MultipleCharValue',
    codeSet: 'OrderRestrictionsCodeSet',
    description: 'Non-Index Arbitrage',
  },
  {
    name: 'CompetingMarketMaker',
    id: '529004',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    tag: 529,
    type: 'MultipleCharValue',
    codeSet: 'OrderRestrictionsCodeSet',
    description: 'Competing Market Maker',
  },
  {
    name: 'ActingAsMarketMakerOrSpecialistInSecurity',
    id: '529005',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    tag: 529,
    type: 'MultipleCharValue',
    codeSet: 'OrderRestrictionsCodeSet',
    description: 'Acting as Market Maker or Specialist in the security',
  },
  {
    name: 'ActingAsMarketMakerOrSpecialistInUnderlying',
    id: '529006',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 529,
    type: 'MultipleCharValue',
    codeSet: 'OrderRestrictionsCodeSet',
    description:
      'Acting as Market Maker or Specialist in the underlying security of a derivative security',
  },
  {
    name: 'ForeignEntity',
    id: '529007',
    value: '7',
    sort: 7,
    added: 'FIX.4.3',
    tag: 529,
    type: 'MultipleCharValue',
    codeSet: 'OrderRestrictionsCodeSet',
    description: 'Foreign Entity (of foreign government or regulatory jurisdiction)',
  },
  {
    name: 'ExternalMarketParticipant',
    id: '529008',
    value: '8',
    sort: 8,
    added: 'FIX.4.3',
    tag: 529,
    type: 'MultipleCharValue',
    codeSet: 'OrderRestrictionsCodeSet',
    description: 'External Market Participant',
  },
  {
    name: 'ExternalInterConnectedMarketLinkage',
    id: '529009',
    value: '9',
    sort: 9,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 529,
    type: 'MultipleCharValue',
    codeSet: 'OrderRestrictionsCodeSet',
    description: 'External Inter-connected Market Linkage',
  },
  {
    name: 'RisklessArbitrage',
    id: '529010',
    value: 'A',
    sort: 10,
    added: 'FIX.4.3',
    tag: 529,
    type: 'MultipleCharValue',
    codeSet: 'OrderRestrictionsCodeSet',
    description: 'Riskless Arbitrage',
  },
  {
    name: 'IssuerHolding',
    id: '529011',
    value: 'B',
    sort: 11,
    added: 'FIX.5.0',
    addedEP: '61',
    tag: 529,
    type: 'MultipleCharValue',
    codeSet: 'OrderRestrictionsCodeSet',
    description: 'Issuer Holding',
  },
  {
    name: 'IssuePriceStabilization',
    id: '529012',
    value: 'C',
    sort: 12,
    added: 'FIX.5.0',
    addedEP: '61',
    tag: 529,
    type: 'MultipleCharValue',
    codeSet: 'OrderRestrictionsCodeSet',
    description: 'Issue Price Stabilization',
  },
  {
    name: 'NonAlgorithmic',
    id: '529013',
    value: 'D',
    sort: 13,
    added: 'FIX.5.0',
    addedEP: '-1',
    tag: 529,
    type: 'MultipleCharValue',
    codeSet: 'OrderRestrictionsCodeSet',
    description: 'Non-algorithmic',
  },
  {
    name: 'Algorithmic',
    id: '529014',
    value: 'E',
    sort: 14,
    added: 'FIX.5.0',
    addedEP: '-1',
    tag: 529,
    type: 'MultipleCharValue',
    codeSet: 'OrderRestrictionsCodeSet',
    description: 'Algorithmic',
  },
  {
    name: 'Cross',
    id: '529015',
    value: 'F',
    sort: 15,
    added: 'FIX.5.0SP1',
    addedEP: '78',
    tag: 529,
    type: 'MultipleCharValue',
    codeSet: 'OrderRestrictionsCodeSet',
    description: 'Cross',
  },
  {
    name: 'InsiderAccount',
    id: '529016',
    value: 'G',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '101',
    tag: 529,
    type: 'MultipleCharValue',
    codeSet: 'OrderRestrictionsCodeSet',
    description: 'Insider Account',
  },
  {
    name: 'SignificantShareholder',
    id: '529017',
    value: 'H',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '101',
    tag: 529,
    type: 'MultipleCharValue',
    codeSet: 'OrderRestrictionsCodeSet',
    description: 'Significant Shareholder',
  },
  {
    name: 'NormalCourseIssuerBid',
    id: '529018',
    value: 'I',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '101',
    tag: 529,
    type: 'MultipleCharValue',
    codeSet: 'OrderRestrictionsCodeSet',
    description: 'Normal Course Issuer Bid (NCIB)',
  },
  {
    name: 'CancelOrdersForASecurity',
    id: '530001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 530,
    type: 'char',
    codeSet: 'MassCancelRequestTypeCodeSet',
    description: 'Cancel orders for a security',
  },
  {
    name: 'CancelOrdersForAnUnderlyingSecurity',
    id: '530002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 530,
    type: 'char',
    codeSet: 'MassCancelRequestTypeCodeSet',
    description: 'Cancel orders for an underlying security',
  },
  {
    name: 'CancelOrdersForAProduct',
    id: '530003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 530,
    type: 'char',
    codeSet: 'MassCancelRequestTypeCodeSet',
    description: 'Cancel orders for a product',
  },
  {
    name: 'CancelOrdersForACFICode',
    id: '530004',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    tag: 530,
    type: 'char',
    codeSet: 'MassCancelRequestTypeCodeSet',
    description: 'Cancel orders for a CFICode',
  },
  {
    name: 'CancelOrdersForASecurityType',
    id: '530005',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 530,
    type: 'char',
    codeSet: 'MassCancelRequestTypeCodeSet',
    description: 'Cancel orders for a security type',
  },
  {
    name: 'CancelOrdersForATradingSession',
    id: '530006',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    tag: 530,
    type: 'char',
    codeSet: 'MassCancelRequestTypeCodeSet',
    description: 'Cancel orders for a trading session',
  },
  {
    name: 'CancelAllOrders',
    id: '530007',
    value: '7',
    sort: 7,
    added: 'FIX.4.3',
    tag: 530,
    type: 'char',
    codeSet: 'MassCancelRequestTypeCodeSet',
    description: 'Cancel all orders',
  },
  {
    name: 'CancelOrdersForAMarket',
    id: '530008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 530,
    type: 'char',
    codeSet: 'MassCancelRequestTypeCodeSet',
    description: 'Cancel orders for a market',
  },
  {
    name: 'CancelOrdersForAMarketSegment',
    id: '530009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 530,
    type: 'char',
    codeSet: 'MassCancelRequestTypeCodeSet',
    description: 'Cancel orders for a market segment',
  },
  {
    name: 'CancelOrdersForASecurityGroup',
    id: '530010',
    value: 'A',
    sort: 10,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 530,
    type: 'char',
    codeSet: 'MassCancelRequestTypeCodeSet',
    description: 'Cancel orders for a security group',
  },
  {
    name: 'CancelOrdersForSecurityIssuer',
    id: '530011',
    value: 'B',
    sort: 11,
    added: 'FIX.5.0SP1',
    addedEP: '85',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 530,
    type: 'char',
    codeSet: 'MassCancelRequestTypeCodeSet',
    description: 'Cancel orders for an issuer',
  },
  {
    name: 'CancelForIssuerOfUnderlyingSecurity',
    id: '530012',
    value: 'C',
    sort: 12,
    added: 'FIX.5.0SP1',
    addedEP: '85',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 530,
    type: 'char',
    codeSet: 'MassCancelRequestTypeCodeSet',
    description: 'Cancel orders for an issuer of underlying security',
  },
  {
    name: 'CancelRequestRejected',
    id: '531001',
    value: '0',
    sort: 0,
    added: 'FIX.4.3',
    tag: 531,
    type: 'char',
    codeSet: 'MassCancelResponseCodeSet',
    description: 'Cancel Request Rejected - See MassCancelRejectReason (532)',
  },
  {
    name: 'CancelOrdersForASecurity',
    id: '531002',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 531,
    type: 'char',
    codeSet: 'MassCancelResponseCodeSet',
    description: 'Cancel orders for a security',
  },
  {
    name: 'CancelOrdersForAnUnderlyingSecurity',
    id: '531003',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 531,
    type: 'char',
    codeSet: 'MassCancelResponseCodeSet',
    description: 'Cancel orders for an underlying security',
  },
  {
    name: 'CancelOrdersForAProduct',
    id: '531004',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 531,
    type: 'char',
    codeSet: 'MassCancelResponseCodeSet',
    description: 'Cancel orders for a product',
  },
  {
    name: 'CancelOrdersForACFICode',
    id: '531005',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 531,
    type: 'char',
    codeSet: 'MassCancelResponseCodeSet',
    description: 'Cancel orders for a CFI Code',
  },
  {
    name: 'CancelOrdersForASecurityType',
    id: '531006',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 531,
    type: 'char',
    codeSet: 'MassCancelResponseCodeSet',
    description: 'Cancel orders for a security type',
  },
  {
    name: 'CancelOrdersForATradingSession',
    id: '531007',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    tag: 531,
    type: 'char',
    codeSet: 'MassCancelResponseCodeSet',
    description: 'Cancel orders for a trading session',
  },
  {
    name: 'CancelAllOrders',
    id: '531008',
    value: '7',
    sort: 7,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 531,
    type: 'char',
    codeSet: 'MassCancelResponseCodeSet',
    description: 'Cancel all orders',
  },
  {
    name: 'CancelOrdersForAMarket',
    id: '531009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 531,
    type: 'char',
    codeSet: 'MassCancelResponseCodeSet',
    description: 'Cancel orders for a market',
  },
  {
    name: 'CancelOrdersForAMarketSegment',
    id: '531010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 531,
    type: 'char',
    codeSet: 'MassCancelResponseCodeSet',
    description: 'Cancel orders for a market segment',
  },
  {
    name: 'CancelOrdersForASecurityGroup',
    id: '531011',
    value: 'A',
    sort: 10,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 531,
    type: 'char',
    codeSet: 'MassCancelResponseCodeSet',
    description: 'Cancel orders for a security group',
  },
  {
    name: 'CancelOrdersForASecuritiesIssuer',
    id: '531012',
    value: 'B',
    sort: 11,
    added: 'FIX.5.0SP1',
    addedEP: '85',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 531,
    type: 'char',
    codeSet: 'MassCancelResponseCodeSet',
    description: 'Cancel orders for an issuer',
  },
  {
    name: 'CancelOrdersForIssuerOfUnderlyingSecurity',
    id: '531013',
    value: 'C',
    sort: 12,
    added: 'FIX.5.0SP1',
    addedEP: '85',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 531,
    type: 'char',
    codeSet: 'MassCancelResponseCodeSet',
    description: 'Cancel orders for an issuer of underlying security',
  },
  {
    name: 'MassCancelNotSupported',
    id: '532001',
    value: '0',
    sort: 0,
    added: 'FIX.4.3',
    tag: 532,
    type: 'int',
    codeSet: 'MassCancelRejectReasonCodeSet',
    description: 'Mass Cancel Not Supported',
  },
  {
    name: 'InvalidOrUnknownSecurity',
    id: '532002',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 532,
    type: 'int',
    codeSet: 'MassCancelRejectReasonCodeSet',
    description: 'Invalid or unknown security',
  },
  {
    name: 'InvalidOrUnknownUnderlyingSecurity',
    id: '532003',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 532,
    type: 'int',
    codeSet: 'MassCancelRejectReasonCodeSet',
    description: 'Invalid or unknown underlying security',
  },
  {
    name: 'InvalidOrUnknownProduct',
    id: '532004',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 532,
    type: 'int',
    codeSet: 'MassCancelRejectReasonCodeSet',
    description: 'Invalid or unknown product',
  },
  {
    name: 'InvalidOrUnknownCFICode',
    id: '532005',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 532,
    type: 'int',
    codeSet: 'MassCancelRejectReasonCodeSet',
    description: 'Invalid or unknown CFI Code',
  },
  {
    name: 'InvalidOrUnknownSecurityType',
    id: '532006',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 532,
    type: 'int',
    codeSet: 'MassCancelRejectReasonCodeSet',
    description: 'Invalid or unknown security type',
  },
  {
    name: 'InvalidOrUnknownTradingSession',
    id: '532007',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 532,
    type: 'int',
    codeSet: 'MassCancelRejectReasonCodeSet',
    description: 'Invalid or unknown trading session',
  },
  {
    name: 'InvalidOrUnknownMarket',
    id: '532008',
    value: '7',
    sort: 8,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 532,
    type: 'int',
    codeSet: 'MassCancelRejectReasonCodeSet',
    description: 'Invalid or unknown market',
  },
  {
    name: 'InvalidOrUnkownMarketSegment',
    id: '532009',
    value: '8',
    sort: 9,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 532,
    type: 'int',
    codeSet: 'MassCancelRejectReasonCodeSet',
    description: 'Invalid or unknown market segment',
  },
  {
    name: 'InvalidOrUnknownSecurityGroup',
    id: '532010',
    value: '9',
    sort: 10,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 532,
    type: 'int',
    codeSet: 'MassCancelRejectReasonCodeSet',
    description: 'Invalid or unknown security group',
  },
  {
    name: 'InvalidOrUnknownSecurityIssuer',
    id: '532011',
    value: '10',
    sort: 11,
    added: 'FIX.5.0SP1',
    addedEP: '85',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 532,
    type: 'int',
    codeSet: 'MassCancelRejectReasonCodeSet',
    description: 'Invalid or unknown security issuer',
  },
  {
    name: 'InvalidOrUnknownIssuerOfUnderlyingSecurity',
    id: '532012',
    value: '11',
    sort: 12,
    added: 'FIX.5.0SP1',
    addedEP: '85',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 532,
    type: 'int',
    codeSet: 'MassCancelRejectReasonCodeSet',
    description: 'Invalid or unknown issuer of underlying security',
  },
  {
    name: 'Other',
    id: '532013',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    tag: 532,
    type: 'int',
    codeSet: 'MassCancelRejectReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'Indicative',
    id: '537001',
    value: '0',
    sort: 1,
    added: 'FIX.4.3',
    tag: 537,
    type: 'int',
    codeSet: 'QuoteTypeCodeSet',
    description: 'Indicative',
  },
  {
    name: 'Tradeable',
    id: '537002',
    value: '1',
    sort: 2,
    added: 'FIX.4.3',
    tag: 537,
    type: 'int',
    codeSet: 'QuoteTypeCodeSet',
    description: 'Tradeable',
  },
  {
    name: 'RestrictedTradeable',
    id: '537003',
    value: '2',
    sort: 3,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '126',
    tag: 537,
    type: 'int',
    codeSet: 'QuoteTypeCodeSet',
    description: 'Restricted tradeable',
  },
  {
    name: 'Counter',
    id: '537004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 537,
    type: 'int',
    codeSet: 'QuoteTypeCodeSet',
    description: 'Counter (tradeable)',
  },
  {
    name: 'InitiallyTradeable',
    id: '537005',
    value: '4',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '126',
    tag: 537,
    type: 'int',
    codeSet: 'QuoteTypeCodeSet',
    description: 'Initially tradeable',
  },
  {
    name: 'Cash',
    id: '544001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 544,
    type: 'char',
    codeSet: 'CashMarginCodeSet',
    description: 'Cash',
  },
  {
    name: 'MarginOpen',
    id: '544002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 544,
    type: 'char',
    codeSet: 'CashMarginCodeSet',
    description: 'Margin Open',
  },
  {
    name: 'MarginClose',
    id: '544003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 544,
    type: 'char',
    codeSet: 'CashMarginCodeSet',
    description: 'Margin Close',
  },
  {
    name: 'LocalMarket',
    id: '546001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 546,
    type: 'MultipleCharValue',
    codeSet: 'ScopeCodeSet',
    description: 'Local Market (Exchange, ECN, ATS)',
  },
  {
    name: 'National',
    id: '546002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 546,
    type: 'MultipleCharValue',
    codeSet: 'ScopeCodeSet',
    description: 'National',
  },
  {
    name: 'Global',
    id: '546003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 546,
    type: 'MultipleCharValue',
    codeSet: 'ScopeCodeSet',
    description: 'Global',
  },
  {
    name: 'No',
    id: '547001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.3',
    tag: 547,
    type: 'Boolean',
    codeSet: 'MDImplicitDeleteCodeSet',
    description:
      'Server must send an explicit delete for bids or offers falling outside the requested MarketDepth of the request',
  },
  {
    name: 'Yes',
    id: '547002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.3',
    tag: 547,
    type: 'Boolean',
    codeSet: 'MDImplicitDeleteCodeSet',
    description:
      'Client has responsibility for implicitly deleting bids or offers falling outside the MarketDepth of the request',
  },
  {
    name: 'CrossAON',
    id: '549001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '131',
    tag: 549,
    type: 'int',
    codeSet: 'CrossTypeCodeSet',
    description:
      'All-or-none cross\n\nA cross order which is executed completely or not at all. Both sides of the cross are treated in the same manner.',
  },
  {
    name: 'CrossIOC',
    id: '549002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '131',
    tag: 549,
    type: 'int',
    codeSet: 'CrossTypeCodeSet',
    description:
      'Immediate-or-cancel cross\n\nA cross order which is immediately executed with any unfilled quantity cancelled. CrossPrioritization(550) may be used to indicate whether one side should have execution priority and any remaining quantity of the partially executed side be cancelled. Using CrossPrioritiation(550)="Y" and CrossType(549)=2(Immediate-or-cancel cross) is equivalent to non-prioritized leg having a TimeInForce(59)=3(IOC) Immediate-or-cancel.',
  },
  {
    name: 'CrossOneSide',
    id: '549003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '131',
    tag: 549,
    type: 'int',
    codeSet: 'CrossTypeCodeSet',
    description:
      'One sided cross\n\nA cross order which is executed on one side with any unfilled quantity remaining active. CrossPrioritization(550) may be used to indicate which side should have execution priority.',
  },
  {
    name: 'CrossSamePrice',
    id: '549004',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '131',
    tag: 549,
    type: 'int',
    codeSet: 'CrossTypeCodeSet',
    description:
      'Cross executed against book\n\nA cross order which is executed against existing orders in the order book. The quantity on one side of the cross is executed against existing orders and quotes with the same price, and any remaining quantity of the cross is executed against the other side of the cross. The two sides of the cross may have different quantities.',
  },
  {
    name: 'BasisCross',
    id: '549005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '101',
    updated: 'FIX.5.0SP2',
    updatedEP: '131',
    tag: 549,
    type: 'int',
    codeSet: 'CrossTypeCodeSet',
    description:
      'Basis cross\n\nA cross order where a basket of securities or an index participation unit is transacted at prices achieved through the execution of related exchange-traded derivative instruments in an amount that will correspond to an equivalent market exposure.',
  },
  {
    name: 'ContingentCross',
    id: '549006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '101',
    updated: 'FIX.5.0SP2',
    updatedEP: '131',
    tag: 549,
    type: 'int',
    codeSet: 'CrossTypeCodeSet',
    description:
      'Contingent cross\n\nA cross order resulting from a paired order placed by a participant to execute an order on a security that is contingent on the execution of a second order for an offsetting volume of a related security.',
  },
  {
    name: 'VWAPCross',
    id: '549007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '101',
    updated: 'FIX.5.0SP2',
    updatedEP: '131',
    tag: 549,
    type: 'int',
    codeSet: 'CrossTypeCodeSet',
    description:
      'Volume-weighted-average-price (VWAP) cross\n\nA cross order for the purpose of executing a trade at a volume-weighted-average-price (VWAP) of a security traded for a continuous period on or during a trading day.',
  },
  {
    name: 'STSCross',
    id: '549008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '101',
    updated: 'FIX.5.0SP2',
    updatedEP: '131',
    tag: 549,
    type: 'int',
    codeSet: 'CrossTypeCodeSet',
    description:
      'Special trading session cross\n\nA closing price cross resulting from an order placed by a participant for execution in a special trading session at the last sale price.',
  },
  {
    name: 'CustomerToCustomer',
    id: '549009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 549,
    type: 'int',
    codeSet: 'CrossTypeCodeSet',
    description:
      'Customer to customer cross\n\nCross order where both sides of the cross represent agency orders.',
  },
  {
    name: 'None',
    id: '550001',
    value: '0',
    sort: 1,
    added: 'FIX.4.3',
    tag: 550,
    type: 'int',
    codeSet: 'CrossPrioritizationCodeSet',
    description: 'None',
  },
  {
    name: 'BuySideIsPrioritized',
    id: '550002',
    value: '1',
    sort: 2,
    added: 'FIX.4.3',
    tag: 550,
    type: 'int',
    codeSet: 'CrossPrioritizationCodeSet',
    description: 'Buy side is prioritized',
  },
  {
    name: 'SellSideIsPrioritized',
    id: '550003',
    value: '2',
    sort: 3,
    added: 'FIX.4.3',
    tag: 550,
    type: 'int',
    codeSet: 'CrossPrioritizationCodeSet',
    description: 'Sell side is prioritized',
  },
  {
    name: 'OneSide',
    id: '552001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 552,
    type: 'NumInGroup',
    codeSet: 'NoSidesCodeSet',
    description: 'One Side',
  },
  {
    name: 'BothSides',
    id: '552002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 552,
    type: 'NumInGroup',
    codeSet: 'NoSidesCodeSet',
    description: 'Both Sides',
  },
  {
    name: 'Symbol',
    id: '559001',
    value: '0',
    sort: 0,
    added: 'FIX.4.3',
    tag: 559,
    type: 'int',
    codeSet: 'SecurityListRequestTypeCodeSet',
    description: 'Symbol',
  },
  {
    name: 'SecurityTypeAnd',
    id: '559002',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 559,
    type: 'int',
    codeSet: 'SecurityListRequestTypeCodeSet',
    description: 'SecurityType and/or CFICode',
  },
  {
    name: 'Product',
    id: '559003',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 559,
    type: 'int',
    codeSet: 'SecurityListRequestTypeCodeSet',
    description: 'Product',
  },
  {
    name: 'TradingSessionID',
    id: '559004',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 559,
    type: 'int',
    codeSet: 'SecurityListRequestTypeCodeSet',
    description: 'TradingSessionID',
  },
  {
    name: 'AllSecurities',
    id: '559005',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    tag: 559,
    type: 'int',
    codeSet: 'SecurityListRequestTypeCodeSet',
    description: 'All Securities',
  },
  {
    name: 'MarketIDOrMarketID',
    id: '559006',
    value: '5',
    sort: 6,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 559,
    type: 'int',
    codeSet: 'SecurityListRequestTypeCodeSet',
    description: 'MarketID or MarketID + MarketSegmentID',
  },
  {
    name: 'ValidRequest',
    id: '560001',
    value: '0',
    sort: 0,
    added: 'FIX.4.3',
    tag: 560,
    type: 'int',
    codeSet: 'SecurityRequestResultCodeSet',
    description: 'Valid request',
  },
  {
    name: 'InvalidOrUnsupportedRequest',
    id: '560002',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 560,
    type: 'int',
    codeSet: 'SecurityRequestResultCodeSet',
    description: 'Invalid or unsupported request',
  },
  {
    name: 'NoInstrumentsFound',
    id: '560003',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 560,
    type: 'int',
    codeSet: 'SecurityRequestResultCodeSet',
    description: 'No instruments found that match selection criteria',
  },
  {
    name: 'NotAuthorizedToRetrieveInstrumentData',
    id: '560004',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 560,
    type: 'int',
    codeSet: 'SecurityRequestResultCodeSet',
    description: 'Not authorized to retrieve instrument data',
  },
  {
    name: 'InstrumentDataTemporarilyUnavailable',
    id: '560005',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    tag: 560,
    type: 'int',
    codeSet: 'SecurityRequestResultCodeSet',
    description: 'Instrument data temporarily unavailable',
  },
  {
    name: 'RequestForInstrumentDataNotSupported',
    id: '560006',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    tag: 560,
    type: 'int',
    codeSet: 'SecurityRequestResultCodeSet',
    description: 'Request for instrument data not supported',
  },
  {
    name: 'ReportByMulitlegSecurityOnly',
    id: '563001',
    value: '0',
    sort: 0,
    added: 'FIX.4.4',
    tag: 563,
    type: 'int',
    codeSet: 'MultiLegRptTypeReqCodeSet',
    description: 'Report by mulitleg security only (do not report legs)',
  },
  {
    name: 'ReportByMultilegSecurityAndInstrumentLegs',
    id: '563002',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 563,
    type: 'int',
    codeSet: 'MultiLegRptTypeReqCodeSet',
    description:
      'Report by multileg security and by instrument legs belonging to the multileg security',
  },
  {
    name: 'ReportByInstrumentLegsOnly',
    id: '563003',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 563,
    type: 'int',
    codeSet: 'MultiLegRptTypeReqCodeSet',
    description:
      'Report by instrument legs belonging to the multileg security only (do not report status of multileg security)',
  },
  {
    name: 'UnknownOrInvalidTradingSessionID',
    id: '567001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 567,
    type: 'int',
    codeSet: 'TradSesStatusRejReasonCodeSet',
    description: 'Unknown or invalid TradingSessionID',
  },
  {
    name: 'Other',
    id: '567002',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    tag: 567,
    type: 'int',
    codeSet: 'TradSesStatusRejReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'AllTrades',
    id: '569001',
    value: '0',
    sort: 0,
    added: 'FIX.4.3',
    tag: 569,
    type: 'int',
    codeSet: 'TradeRequestTypeCodeSet',
    description: 'All Trades',
  },
  {
    name: 'MatchedTradesMatchingCriteria',
    id: '569002',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 569,
    type: 'int',
    codeSet: 'TradeRequestTypeCodeSet',
    description:
      'Matched trades matching criteria provided on request (Parties, ExecID, TradeID, OrderID, Instrument, InputSource, etc.)',
  },
  {
    name: 'UnmatchedTradesThatMatchCriteria',
    id: '569003',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 569,
    type: 'int',
    codeSet: 'TradeRequestTypeCodeSet',
    description: 'Unmatched trades that match criteria',
  },
  {
    name: 'UnreportedTradesThatMatchCriteria',
    id: '569004',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 569,
    type: 'int',
    codeSet: 'TradeRequestTypeCodeSet',
    description: 'Unreported trades that match criteria',
  },
  {
    name: 'AdvisoriesThatMatchCriteria',
    id: '569005',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    tag: 569,
    type: 'int',
    codeSet: 'TradeRequestTypeCodeSet',
    description: 'Advisories that match criteria',
  },
  {
    name: 'NotReportedToCounterparty',
    id: '570001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '229',
    tag: 570,
    type: 'Boolean',
    codeSet: 'PreviouslyReportedCodeSet',
    description:
      'Not reported to counterparty or market\n\nIn the context of RTS 13 Article 16 when a trade is reported to more than one "approved publication arrangement" (APA) the original report can be flagged as "original". This is the ESMA "ORGN" flag.',
  },
  {
    name: 'PreviouslyReportedToCounterparty',
    id: '570002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '229',
    tag: 570,
    type: 'Boolean',
    codeSet: 'PreviouslyReportedCodeSet',
    description:
      'Previously reported to counterparty or market\n\nIn the context of RTS 13 Article 16 when a trade is reported to more than one "approved publication arrangement" (APA) the additional reports need to be flagged as "duplicative" and this flag needs to be present on any occurrence (even when publishing to the market). This is also used for reporting directly to ESMA when the trade has been previously reported. This is the ESMA "DUPL" flag.',
  },
  {
    name: 'Compared',
    id: '573001',
    value: '0',
    sort: 0,
    added: 'FIX.4.3',
    tag: 573,
    type: 'char',
    codeSet: 'MatchStatusCodeSet',
    description: 'Compared, matched or affirmed',
  },
  {
    name: 'Uncompared',
    id: '573002',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 573,
    type: 'char',
    codeSet: 'MatchStatusCodeSet',
    description: 'Uncompared, unmatched, or unaffirmed',
  },
  {
    name: 'AdvisoryOrAlert',
    id: '573003',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 573,
    type: 'char',
    codeSet: 'MatchStatusCodeSet',
    description: 'Advisory or alert',
  },
  {
    name: 'Mismatched',
    id: '573004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 573,
    type: 'char',
    codeSet: 'MatchStatusCodeSet',
    description:
      'Mismatched\n\nIndicates that data points from the AllocationInstruction(35=J) and Confirmation(35=AK) are matched but there are variances. MatchExceptionGrp component may be used to detail on the mis-matched data fields.',
  },
  {
    name: 'OnePartyTradeReport',
    id: '574001',
    value: '1',
    sort: 70,
    group: 'General Purpose',
    added: 'FIX.4.4',
    addedEP: '22',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description: 'One-Party Trade Report (privately negotiated trade)',
  },
  {
    name: 'TwoPartyTradeReport',
    id: '574002',
    value: '2',
    sort: 71,
    group: 'General Purpose',
    added: 'FIX.4.4',
    addedEP: '22',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description: 'Two-Party Trade Report (privately negotiated trade)',
  },
  {
    name: 'ConfirmedTradeReport',
    id: '574003',
    value: '3',
    sort: 72,
    group: 'General Purpose',
    added: 'FIX.4.4',
    addedEP: '22',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description: 'Confirmed Trade Report (reporting from recognized markets)',
  },
  {
    name: 'AutoMatch',
    id: '574004',
    value: '4',
    sort: 73,
    group: 'General Purpose',
    added: 'FIX.4.4',
    addedEP: '22',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description: 'Auto-match',
  },
  {
    name: 'CrossAuction',
    id: '574005',
    value: '5',
    sort: 74,
    group: 'General Purpose',
    added: 'FIX.4.4',
    addedEP: '22',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description: 'Cross Auction',
  },
  {
    name: 'CounterOrderSelection',
    id: '574006',
    value: '6',
    sort: 75,
    group: 'General Purpose',
    added: 'FIX.4.4',
    addedEP: '22',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description: 'Counter-Order Selection',
  },
  {
    name: 'CallAuction',
    id: '574007',
    value: '7',
    sort: 76,
    group: 'General Purpose',
    added: 'FIX.4.4',
    addedEP: '22',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description: 'Call Auction',
  },
  {
    name: 'Issuing',
    id: '574008',
    value: '8',
    sort: 77,
    group: 'General Purpose',
    added: 'FIX.5.0',
    addedEP: '47',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description: 'Issuing/Buy Back Auction',
  },
  {
    name: 'SystematicInternaliser',
    id: '574009',
    value: '9',
    sort: 78,
    group: 'General Purpose',
    added: 'FIX.5.0SP2',
    addedEP: '163',
    updated: 'FIX.5.0SP2',
    updatedEP: '228',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description: 'Systematic Internaliser (SI)',
  },
  {
    name: 'AutoMatchLastLook',
    id: '574010',
    value: '10',
    sort: 79,
    group: 'General Purpose',
    added: 'FIX.5.0SP2',
    addedEP: '198',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description:
      'Auto-match with last look\n\nExecution that arises from a match against orders or quotes which require a confirmation during continuous trading.',
  },
  {
    name: 'CrossAuctionLastLook',
    id: '574011',
    value: '11',
    sort: 80,
    group: 'General Purpose',
    added: 'FIX.5.0SP2',
    addedEP: '198',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description:
      'Cross auction with last look\n\nExecution that arises from a match against orders or quotes which require a confirmation during an auction.',
  },
  {
    name: 'ACTAcceptedTrade',
    id: '574012',
    value: 'M3',
    sort: 2,
    group: 'NASDAQ',
    added: 'FIX.4.3',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description: 'ACT Accepted Trade',
  },
  {
    name: 'ACTDefaultTrade',
    id: '574013',
    value: 'M4',
    sort: 3,
    group: 'NASDAQ',
    added: 'FIX.4.3',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description: 'ACT Default Trade',
  },
  {
    name: 'ACTDefaultAfterM2',
    id: '574014',
    value: 'M5',
    sort: 4,
    group: 'NASDAQ',
    added: 'FIX.4.3',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description: 'ACT Default After M2',
  },
  {
    name: 'ACTM6Match',
    id: '574015',
    value: 'M6',
    sort: 5,
    group: 'NASDAQ',
    added: 'FIX.4.3',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description: 'ACT M6 Match',
  },
  {
    name: 'ExactMatchPlus4BadgesExecTime',
    id: '574016',
    value: 'A1',
    sort: 0,
    group: 'NYSE and AMEX',
    added: 'FIX.4.3',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description:
      'Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator plus four badges and execution time (within two-minute window)',
  },
  {
    name: 'ExactMatchPlus4Badges',
    id: '574017',
    value: 'A2',
    sort: 1,
    group: 'NYSE and AMEX',
    added: 'FIX.4.3',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description:
      'Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator, plus four badges',
  },
  {
    name: 'ExactMatchPlus2BadgesExecTime',
    id: '574018',
    value: 'A3',
    sort: 2,
    group: 'NYSE and AMEX',
    added: 'FIX.4.3',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description:
      'Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator, plus two badges and execution time (within two-minute window)',
  },
  {
    name: 'ExactMatchPlus2Badges',
    id: '574019',
    value: 'A4',
    sort: 3,
    group: 'NYSE and AMEX',
    added: 'FIX.4.3',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description:
      'Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator, plus two badges',
  },
  {
    name: 'ExactMatchPlusExecTime',
    id: '574020',
    value: 'A5',
    sort: 4,
    group: 'NYSE and AMEX',
    added: 'FIX.4.3',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description:
      'Exact match on Trade Date, Stock Symbol, Quantity, Price, TradeType, and Special Trade Indicator plus execution time (within two-minute window)',
  },
  {
    name: 'StampedAdvisoriesOrSpecialistAccepts',
    id: '574021',
    value: 'AQ',
    sort: 5,
    group: 'NYSE and AMEX',
    added: 'FIX.4.3',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description:
      'Compared records resulting from stamped advisories or specialist accepts/pair-offs',
  },
  {
    name: 'A1ExactMatchSummarizedQuantity',
    id: '574022',
    value: 'S1',
    sort: 6,
    group: 'NYSE and AMEX',
    added: 'FIX.4.3',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description:
      'Summarized match using A1 exact match criteria except quantity is summaried',
  },
  {
    name: 'A2ExactMatchSummarizedQuantity',
    id: '574023',
    value: 'S2',
    sort: 7,
    group: 'NYSE and AMEX',
    added: 'FIX.4.3',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description:
      'Summarized match using A2 exact match criteria except quantity is summarized',
  },
  {
    name: 'A3ExactMatchSummarizedQuantity',
    id: '574024',
    value: 'S3',
    sort: 8,
    group: 'NYSE and AMEX',
    added: 'FIX.4.3',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description:
      'Summarized match using A3 exact match criteria except quantity is summarized',
  },
  {
    name: 'A4ExactMatchSummarizedQuantity',
    id: '574025',
    value: 'S4',
    sort: 9,
    group: 'NYSE and AMEX',
    added: 'FIX.4.3',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description:
      'Summarized match using A4 exact match criteria except quantity is summarized',
  },
  {
    name: 'A5ExactMatchSummarizedQuantity',
    id: '574026',
    value: 'S5',
    sort: 10,
    group: 'NYSE and AMEX',
    added: 'FIX.4.3',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description:
      'Summarized match using A5 exact match criteria except quantity is summarized',
  },
  {
    name: 'ExactMatchMinusBadgesTimes',
    id: '574027',
    value: 'M1',
    sort: 11,
    group: 'NYSE, AMEX and NASDAQ',
    added: 'FIX.4.3',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description:
      'Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator minus badges And times: ACT M1 match',
  },
  {
    name: 'SummarizedMatchMinusBadgesTimes',
    id: '574028',
    value: 'M2',
    sort: 12,
    group: 'NYSE, AMEX and NASDAQ',
    added: 'FIX.4.3',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description: 'Summarized match minus badges and times: ACT M2 Match',
  },
  {
    name: 'OCSLockedIn',
    id: '574029',
    value: 'MT',
    sort: 13,
    group: 'NYSE, AMEX and NASDAQ',
    added: 'FIX.4.3',
    tag: 574,
    type: 'String',
    codeSet: 'MatchTypeCodeSet',
    description: 'OCS Locked In: Non-ACT',
  },
  {
    name: 'TreatAsRoundLot',
    id: '575001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.4',
    tag: 575,
    type: 'Boolean',
    codeSet: 'OddLotCodeSet',
    description: 'Treat as round lot (default)',
  },
  {
    name: 'TreatAsOddLot',
    id: '575002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.4',
    tag: 575,
    type: 'Boolean',
    codeSet: 'OddLotCodeSet',
    description: 'Treat as odd lot',
  },
  {
    name: 'ProcessNormally',
    id: '577001',
    value: '0',
    sort: 0,
    added: 'FIX.4.3',
    tag: 577,
    type: 'int',
    codeSet: 'ClearingInstructionCodeSet',
    description: 'Process normally',
  },
  {
    name: 'ExcludeFromAllNetting',
    id: '577002',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 577,
    type: 'int',
    codeSet: 'ClearingInstructionCodeSet',
    description: 'Exclude from all netting',
  },
  {
    name: 'BilateralNettingOnly',
    id: '577003',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 577,
    type: 'int',
    codeSet: 'ClearingInstructionCodeSet',
    description: 'Bilateral netting only',
  },
  {
    name: 'ExClearing',
    id: '577004',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 577,
    type: 'int',
    codeSet: 'ClearingInstructionCodeSet',
    description: 'Ex clearing',
  },
  {
    name: 'SpecialTrade',
    id: '577005',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    tag: 577,
    type: 'int',
    codeSet: 'ClearingInstructionCodeSet',
    description: 'Special trade',
  },
  {
    name: 'MultilateralNetting',
    id: '577006',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    tag: 577,
    type: 'int',
    codeSet: 'ClearingInstructionCodeSet',
    description: 'Multilateral netting',
  },
  {
    name: 'ClearAgainstCentralCounterparty',
    id: '577007',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    tag: 577,
    type: 'int',
    codeSet: 'ClearingInstructionCodeSet',
    description: 'Clear against central counterparty',
  },
  {
    name: 'ExcludeFromCentralCounterparty',
    id: '577008',
    value: '7',
    sort: 7,
    added: 'FIX.4.3',
    tag: 577,
    type: 'int',
    codeSet: 'ClearingInstructionCodeSet',
    description: 'Exclude from central counterparty',
  },
  {
    name: 'ManualMode',
    id: '577009',
    value: '8',
    sort: 8,
    added: 'FIX.4.3',
    tag: 577,
    type: 'int',
    codeSet: 'ClearingInstructionCodeSet',
    description: 'Manual mode (pre-posting and/or pre-giveup)',
  },
  {
    name: 'AutomaticPostingMode',
    id: '577010',
    value: '9',
    sort: 9,
    added: 'FIX.4.3',
    tag: 577,
    type: 'int',
    codeSet: 'ClearingInstructionCodeSet',
    description:
      'Automatic posting mode (trade posting to the position account number specified)',
  },
  {
    name: 'AutomaticGiveUpMode',
    id: '577011',
    value: '10',
    sort: 10,
    added: 'FIX.4.3',
    tag: 577,
    type: 'int',
    codeSet: 'ClearingInstructionCodeSet',
    description:
      'Automatic give-up mode (trade give-up to the give-up destination number specified)',
  },
  {
    name: 'QualifiedServiceRepresentativeQSR',
    id: '577012',
    value: '11',
    sort: 11,
    added: 'FIX.4.4',
    tag: 577,
    type: 'int',
    codeSet: 'ClearingInstructionCodeSet',
    description: 'Qualified Service Representative QSR',
  },
  {
    name: 'CustomerTrade',
    id: '577013',
    value: '12',
    sort: 12,
    added: 'FIX.4.4',
    tag: 577,
    type: 'int',
    codeSet: 'ClearingInstructionCodeSet',
    description: 'Customer trade',
  },
  {
    name: 'SelfClearing',
    id: '577014',
    value: '13',
    sort: 13,
    added: 'FIX.4.4',
    tag: 577,
    type: 'int',
    codeSet: 'ClearingInstructionCodeSet',
    description: 'Self clearing',
  },
  {
    name: 'BuyIn',
    id: '577015',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '136',
    tag: 577,
    type: 'int',
    codeSet: 'ClearingInstructionCodeSet',
    description: 'Buy-in',
  },
  {
    name: 'CarriedCustomerSide',
    id: '581001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 581,
    type: 'int',
    codeSet: 'AccountTypeCodeSet',
    description: 'Account is carried on customer side of the books',
  },
  {
    name: 'CarriedNonCustomerSide',
    id: '581002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 581,
    type: 'int',
    codeSet: 'AccountTypeCodeSet',
    description: 'Account is carried on non-customer side of books',
  },
  {
    name: 'HouseTrader',
    id: '581003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 581,
    type: 'int',
    codeSet: 'AccountTypeCodeSet',
    description: 'House Trader',
  },
  {
    name: 'FloorTrader',
    id: '581004',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    tag: 581,
    type: 'int',
    codeSet: 'AccountTypeCodeSet',
    description: 'Floor Trader',
  },
  {
    name: 'CarriedNonCustomerSideCrossMargined',
    id: '581005',
    value: '6',
    sort: 5,
    added: 'FIX.4.3',
    tag: 581,
    type: 'int',
    codeSet: 'AccountTypeCodeSet',
    description: 'Account is carried on non-customer side of books and is cross margined',
  },
  {
    name: 'HouseTraderCrossMargined',
    id: '581006',
    value: '7',
    sort: 6,
    added: 'FIX.4.3',
    tag: 581,
    type: 'int',
    codeSet: 'AccountTypeCodeSet',
    description: 'Account is house trader and is cross margined',
  },
  {
    name: 'JointBackOfficeAccount',
    id: '581007',
    value: '8',
    sort: 7,
    added: 'FIX.4.3',
    tag: 581,
    type: 'int',
    codeSet: 'AccountTypeCodeSet',
    description: 'Joint back office account (JBO)',
  },
  {
    name: 'EquitiesSpecialist',
    id: '581008',
    value: '9',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '101',
    tag: 581,
    type: 'int',
    codeSet: 'AccountTypeCodeSet',
    description: 'Equities specialist',
  },
  {
    name: 'OptionsMarketMaker',
    id: '581009',
    value: '10',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '101',
    tag: 581,
    type: 'int',
    codeSet: 'AccountTypeCodeSet',
    description: 'Options market maker',
  },
  {
    name: 'OptionsFirmAccount',
    id: '581010',
    value: '11',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '101',
    tag: 581,
    type: 'int',
    codeSet: 'AccountTypeCodeSet',
    description: 'Options firm account',
  },
  {
    name: 'AccountCustomerNonCustomerOrders',
    id: '581011',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '256',
    tag: 581,
    type: 'int',
    codeSet: 'AccountTypeCodeSet',
    description:
      'Account for customer and non-customer orders\n\nAccount aggregates orders from customers and non-customers.\n\nIn the context of IIROC UMIR this account type can be used for bundled orders (BU), i.e. orders including client, non-client and principal orders.',
  },
  {
    name: 'AccountOrdersMultipleCustomers',
    id: '581012',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '256',
    tag: 581,
    type: 'int',
    codeSet: 'AccountTypeCodeSet',
    description:
      'Account for orders from multiple customers\n\nAccount aggregates orders from multiple customers.\n\nIn the context of IIROC UMIR this account type can be used for multiple client orders (MC), i.e. orders including orders from more than one client but no principal or non-client orders.',
  },
  {
    name: 'MemberTradingForTheirOwnAccount',
    id: '582001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 582,
    type: 'int',
    codeSet: 'CustOrderCapacityCodeSet',
    description: 'Member trading for their own account',
  },
  {
    name: 'ClearingFirmTradingForItsProprietaryAccount',
    id: '582002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '205',
    tag: 582,
    type: 'int',
    codeSet: 'CustOrderCapacityCodeSet',
    description: 'Clearing firm trading for its proprietary account',
  },
  {
    name: 'MemberTradingForAnotherMember',
    id: '582003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    tag: 582,
    type: 'int',
    codeSet: 'CustOrderCapacityCodeSet',
    description: 'Member trading for another member',
  },
  {
    name: 'AllOther',
    id: '582004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    tag: 582,
    type: 'int',
    codeSet: 'CustOrderCapacityCodeSet',
    description: 'All other',
  },
  {
    name: 'RetailCustomer',
    id: '582005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '205',
    tag: 582,
    type: 'int',
    codeSet: 'CustOrderCapacityCodeSet',
    description:
      'Retail customer\n\nAn order that originated from a retail customer (a natural person). In the context of the US Securities and Exchange Commission, this also means an order originated from a natural person where, prior to submission, no change was made to the terms of the order with respect to price or side of market and the order does not originate from an algorithm or other computerized trading method.',
  },
  {
    name: 'StatusForOrdersForASecurity',
    id: '585001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 585,
    type: 'int',
    codeSet: 'MassStatusReqTypeCodeSet',
    description: 'Status for orders for a security',
  },
  {
    name: 'StatusForOrdersForAnUnderlyingSecurity',
    id: '585002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 585,
    type: 'int',
    codeSet: 'MassStatusReqTypeCodeSet',
    description: 'Status for orders for an underlying security',
  },
  {
    name: 'StatusForOrdersForAProduct',
    id: '585003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 585,
    type: 'int',
    codeSet: 'MassStatusReqTypeCodeSet',
    description: 'Status for orders for a product',
  },
  {
    name: 'StatusForOrdersForACFICode',
    id: '585004',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 585,
    type: 'int',
    codeSet: 'MassStatusReqTypeCodeSet',
    description: 'Status for orders for a CFI Code',
  },
  {
    name: 'StatusForOrdersForASecurityType',
    id: '585005',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 585,
    type: 'int',
    codeSet: 'MassStatusReqTypeCodeSet',
    description: 'Status for orders for a security type',
  },
  {
    name: 'StatusForOrdersForATradingSession',
    id: '585006',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    tag: 585,
    type: 'int',
    codeSet: 'MassStatusReqTypeCodeSet',
    description: 'Status for orders for a trading session',
  },
  {
    name: 'StatusForAllOrders',
    id: '585007',
    value: '7',
    sort: 7,
    added: 'FIX.4.3',
    tag: 585,
    type: 'int',
    codeSet: 'MassStatusReqTypeCodeSet',
    description: 'Status for all orders',
  },
  {
    name: 'StatusForOrdersForAPartyID',
    id: '585008',
    value: '8',
    sort: 8,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 585,
    type: 'int',
    codeSet: 'MassStatusReqTypeCodeSet',
    description: 'Status for orders for a party identifier',
  },
  {
    name: 'StatusForSecurityIssuer',
    id: '585009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP1',
    addedEP: '85',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 585,
    type: 'int',
    codeSet: 'MassStatusReqTypeCodeSet',
    description: 'Status for orders for an issuer',
  },
  {
    name: 'StatusForIssuerOfUnderlyingSecurity',
    id: '585010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP1',
    addedEP: '85',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 585,
    type: 'int',
    codeSet: 'MassStatusReqTypeCodeSet',
    description: 'Status for orders for an issuer of underlying security',
  },
  {
    name: 'Auto',
    id: '589001',
    value: '0',
    sort: 1,
    added: 'FIX.4.3',
    tag: 589,
    type: 'char',
    codeSet: 'DayBookingInstCodeSet',
    description: 'Can trigger booking without reference to the order initiator ("auto")',
  },
  {
    name: 'SpeakWithOrderInitiatorBeforeBooking',
    id: '589002',
    value: '1',
    sort: 2,
    added: 'FIX.4.3',
    tag: 589,
    type: 'char',
    codeSet: 'DayBookingInstCodeSet',
    description: 'Speak with order initiator before booking ("speak first")',
  },
  {
    name: 'Accumulate',
    id: '589003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 589,
    type: 'char',
    codeSet: 'DayBookingInstCodeSet',
    description: 'Accumulate',
  },
  {
    name: 'EachPartialExecutionIsABookableUnit',
    id: '590001',
    value: '0',
    sort: 1,
    added: 'FIX.4.3',
    tag: 590,
    type: 'char',
    codeSet: 'BookingUnitCodeSet',
    description: 'Each partial execution is a bookable unit',
  },
  {
    name: 'AggregatePartialExecutionsOnThisOrder',
    id: '590002',
    value: '1',
    sort: 2,
    added: 'FIX.4.3',
    tag: 590,
    type: 'char',
    codeSet: 'BookingUnitCodeSet',
    description:
      'Aggregate partial executions on this order, and book one trade per order',
  },
  {
    name: 'AggregateExecutionsForThisSymbol',
    id: '590003',
    value: '2',
    sort: 3,
    added: 'FIX.4.3',
    tag: 590,
    type: 'char',
    codeSet: 'BookingUnitCodeSet',
    description: 'Aggregate executions for this symbol, side, and settlement date',
  },
  {
    name: 'ProRata',
    id: '591001',
    value: '0',
    sort: 1,
    added: 'FIX.4.3',
    tag: 591,
    type: 'char',
    codeSet: 'PreallocMethodCodeSet',
    description: 'Pro rata',
  },
  {
    name: 'DoNotProRata',
    id: '591002',
    value: '1',
    sort: 2,
    added: 'FIX.4.3',
    tag: 591,
    type: 'char',
    codeSet: 'PreallocMethodCodeSet',
    description: 'Do not pro-rata - discuss first',
  },
  {
    name: 'PreTrading',
    id: '625001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 625,
    type: 'String',
    codeSet: 'TradingSessionSubIDCodeSet',
    description: 'Pre-Trading',
  },
  {
    name: 'OpeningOrOpeningAuction',
    id: '625002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 625,
    type: 'String',
    codeSet: 'TradingSessionSubIDCodeSet',
    description: 'Opening or opening auction',
  },
  {
    name: 'Continuous',
    id: '625003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 625,
    type: 'String',
    codeSet: 'TradingSessionSubIDCodeSet',
    description: '(Continuous) Trading',
  },
  {
    name: 'ClosingOrClosingAuction',
    id: '625004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 625,
    type: 'String',
    codeSet: 'TradingSessionSubIDCodeSet',
    description: 'Closing or closing auction',
  },
  {
    name: 'PostTrading',
    id: '625005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 625,
    type: 'String',
    codeSet: 'TradingSessionSubIDCodeSet',
    description: 'Post-Trading',
  },
  {
    name: 'ScheduledIntradayAuction',
    id: '625006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.5.0SP2',
    updatedEP: '163',
    tag: 625,
    type: 'String',
    codeSet: 'TradingSessionSubIDCodeSet',
    description: 'Scheduled intraday auction',
  },
  {
    name: 'Quiescent',
    id: '625007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 625,
    type: 'String',
    codeSet: 'TradingSessionSubIDCodeSet',
    description: 'Quiescent',
  },
  {
    name: 'AnyAuction',
    id: '625008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 625,
    type: 'String',
    codeSet: 'TradingSessionSubIDCodeSet',
    description: 'Any auction',
  },
  {
    name: 'UnscheduledIntradayAuction',
    id: '625009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '163',
    tag: 625,
    type: 'String',
    codeSet: 'TradingSessionSubIDCodeSet',
    description:
      'Unscheduled intraday auction\n\nAn unscheduled intraday auction might be triggered by a circuit breaker.',
  },
  {
    name: 'OutOfMainSessionTrading',
    id: '625010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '163',
    tag: 625,
    type: 'String',
    codeSet: 'TradingSessionSubIDCodeSet',
    description:
      'Out of main session trading\n\nIn the context of Market Model Typology "Out of main session trading" refers to both before and after session, neither auction nor continuous trading.',
  },
  {
    name: 'PrivateAuction',
    id: '625011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '168',
    tag: 625,
    type: 'String',
    codeSet: 'TradingSessionSubIDCodeSet',
    description:
      'Private auction\n\nAn auction phase where only two parties participate.',
  },
  {
    name: 'PublicAuction',
    id: '625012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '168',
    tag: 625,
    type: 'String',
    codeSet: 'TradingSessionSubIDCodeSet',
    description:
      'Public auction\n\nAn auction phase where all trading parties participate.',
  },
  {
    name: 'GroupAuction',
    id: '625013',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '168',
    tag: 625,
    type: 'String',
    codeSet: 'TradingSessionSubIDCodeSet',
    description:
      'Group auction\n\nAn auction phase limited to specific parties (e.g. parties that have resting orders in the order book).',
  },
  {
    name: 'OrderInitiatedAuction',
    id: '625014',
    value: '14',
    sort: 14,
    added: 'FIX.Latest',
    addedEP: '286',
    tag: 625,
    type: 'String',
    codeSet: 'TradingSessionSubIDCodeSet',
    description:
      'Order initiated auction\n\nAuction automatically triggered by an order, e.g. an incoming order or a resting order that can be matched based on an incoming order. Use 9="Unscheduled intraday auction" for any other auctions that are not scheduled. In the context of Market Model Topology, this can be used for an on demand auction (a.k.a. frequent batched auction).',
  },
  {
    name: 'Calculated',
    id: '626001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Calculated (includes MiscFees and NetMoney)',
  },
  {
    name: 'Preliminary',
    id: '626002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Preliminary (without MiscFees and NetMoney)',
  },
  {
    name: 'SellsideCalculatedUsingPreliminary',
    id: '626003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    deprecated: 'FIX.4.2',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description:
      'Sellside calculated using preliminary (includes MiscFees and NetMoney) (Replaced)',
  },
  {
    name: 'SellsideCalculatedWithoutPreliminary',
    id: '626004',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    deprecated: 'FIX.4.2',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description:
      'Sellside calculatedd without preliminary (sent unsolicited by sellside, includes MiscFees and NetMoney) (Replaced)',
  },
  {
    name: 'ReadyToBook',
    id: '626005',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Ready-To-Book single order',
  },
  {
    name: 'BuysideReadyToBook',
    id: '626006',
    value: '6',
    sort: 6,
    added: 'FIX.4.3',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    deprecated: 'FIX.4.2',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Buyside Ready-To-Book - combined set of orders (replaced)',
  },
  {
    name: 'WarehouseInstruction',
    id: '626007',
    value: '7',
    sort: 7,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Warehouse instruction',
  },
  {
    name: 'RequestToIntermediary',
    id: '626008',
    value: '8',
    sort: 8,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Request to intermediary',
  },
  {
    name: 'Accept',
    id: '626009',
    value: '9',
    sort: 9,
    added: 'FIX.4.4',
    addedEP: '5',
    deprecated: 'FIX.5.0SP2',
    deprecatedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Accept',
  },
  {
    name: 'Reject',
    id: '626010',
    value: '10',
    sort: 10,
    added: 'FIX.4.4',
    addedEP: '5',
    deprecated: 'FIX.5.0SP2',
    deprecatedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Reject',
  },
  {
    name: 'AcceptPending',
    id: '626011',
    value: '11',
    sort: 11,
    added: 'FIX.4.4',
    addedEP: '5',
    deprecated: 'FIX.5.0SP2',
    deprecatedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Accept Pending',
  },
  {
    name: 'IncompleteGroup',
    id: '626012',
    value: '12',
    sort: 12,
    added: 'FIX.4.4',
    addedEP: '5',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Incomplete group',
  },
  {
    name: 'CompleteGroup',
    id: '626013',
    value: '13',
    sort: 13,
    added: 'FIX.4.4',
    addedEP: '5',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Complete group',
  },
  {
    name: 'ReversalPending',
    id: '626014',
    value: '14',
    sort: 14,
    added: 'FIX.4.4',
    addedEP: '5',
    deprecated: 'FIX.5.0SP2',
    deprecatedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Reversal Pending',
  },
  {
    name: 'ReopenGroup',
    id: '626015',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Reopen group',
  },
  {
    name: 'CancelGroup',
    id: '626016',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Cancel group',
  },
  {
    name: 'Giveup',
    id: '626017',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Give-up',
  },
  {
    name: 'Takeup',
    id: '626018',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Take-up',
  },
  {
    name: 'RefuseTakeup',
    id: '626019',
    value: '19',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Refuse take-up',
  },
  {
    name: 'InitiateReversal',
    id: '626020',
    value: '20',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Initiate reversal',
  },
  {
    name: 'Reverse',
    id: '626021',
    value: '21',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Reverse',
  },
  {
    name: 'RefuseReversal',
    id: '626022',
    value: '22',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Refuse reversal',
  },
  {
    name: 'SubAllocationGiveup',
    id: '626023',
    value: '23',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Sub-allocation give-up',
  },
  {
    name: 'ApproveGiveup',
    id: '626024',
    value: '24',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Approve give-up',
  },
  {
    name: 'ApproveTakeup',
    id: '626025',
    value: '25',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description: 'Approve take-up',
  },
  {
    name: 'NotionalValueAveragePxGroupAlloc',
    id: '626026',
    value: '26',
    sort: 26,
    added: 'FIX.5.0SP2',
    addedEP: '239',
    tag: 626,
    type: 'int',
    codeSet: 'AllocTypeCodeSet',
    description:
      'Notional value average price group allocation\n\nUsed when conducting notional value average price (NVAP) group allocation with a clearinghouse.',
  },
  {
    name: 'FirstYearDelegate',
    id: '635001',
    value: '1',
    sort: 1,
    added: 'FIX.4.3',
    tag: 635,
    type: 'String',
    codeSet: 'ClearingFeeIndicatorCodeSet',
    description: '1st year delegate trading for own account',
  },
  {
    name: 'SecondYearDelegate',
    id: '635002',
    value: '2',
    sort: 2,
    added: 'FIX.4.3',
    tag: 635,
    type: 'String',
    codeSet: 'ClearingFeeIndicatorCodeSet',
    description: '2nd year delegate trading for own account',
  },
  {
    name: 'ThirdYearDelegate',
    id: '635003',
    value: '3',
    sort: 3,
    added: 'FIX.4.3',
    tag: 635,
    type: 'String',
    codeSet: 'ClearingFeeIndicatorCodeSet',
    description: '3rd year delegate trading for own account',
  },
  {
    name: 'FourthYearDelegate',
    id: '635004',
    value: '4',
    sort: 4,
    added: 'FIX.4.3',
    tag: 635,
    type: 'String',
    codeSet: 'ClearingFeeIndicatorCodeSet',
    description: '4th year delegate trading for own account',
  },
  {
    name: 'FifthYearDelegate',
    id: '635005',
    value: '5',
    sort: 5,
    added: 'FIX.4.3',
    tag: 635,
    type: 'String',
    codeSet: 'ClearingFeeIndicatorCodeSet',
    description: '5th year delegate trading for own account',
  },
  {
    name: 'SixthYearDelegate',
    id: '635006',
    value: '9',
    sort: 6,
    added: 'FIX.4.3',
    tag: 635,
    type: 'String',
    codeSet: 'ClearingFeeIndicatorCodeSet',
    description: '6th year delegate trading for own account',
  },
  {
    name: 'CBOEMember',
    id: '635007',
    value: 'B',
    sort: 7,
    added: 'FIX.4.3',
    tag: 635,
    type: 'String',
    codeSet: 'ClearingFeeIndicatorCodeSet',
    description: 'CBOE Member',
  },
  {
    name: 'NonMemberAndCustomer',
    id: '635008',
    value: 'C',
    sort: 8,
    added: 'FIX.4.3',
    tag: 635,
    type: 'String',
    codeSet: 'ClearingFeeIndicatorCodeSet',
    description: 'Non-member and Customer',
  },
  {
    name: 'EquityMemberAndClearingMember',
    id: '635009',
    value: 'E',
    sort: 9,
    added: 'FIX.4.3',
    tag: 635,
    type: 'String',
    codeSet: 'ClearingFeeIndicatorCodeSet',
    description: 'Equity Member and Clearing Member',
  },
  {
    name: 'FullAndAssociateMember',
    id: '635010',
    value: 'F',
    sort: 10,
    added: 'FIX.4.3',
    tag: 635,
    type: 'String',
    codeSet: 'ClearingFeeIndicatorCodeSet',
    description: 'Full and Associate Member trading for own account and as floor brokers',
  },
  {
    name: 'Firms106HAnd106J',
    id: '635011',
    value: 'H',
    sort: 11,
    added: 'FIX.4.3',
    tag: 635,
    type: 'String',
    codeSet: 'ClearingFeeIndicatorCodeSet',
    description: '106.H and 106.J firms',
  },
  {
    name: 'GIM',
    id: '635012',
    value: 'I',
    sort: 12,
    added: 'FIX.4.3',
    tag: 635,
    type: 'String',
    codeSet: 'ClearingFeeIndicatorCodeSet',
    description: 'GIM, IDEM and COM Membership Interest Holders',
  },
  {
    name: 'Lessee106FEmployees',
    id: '635013',
    value: 'L',
    sort: 13,
    added: 'FIX.4.3',
    tag: 635,
    type: 'String',
    codeSet: 'ClearingFeeIndicatorCodeSet',
    description: 'Lessee 106.F Employees',
  },
  {
    name: 'AllOtherOwnershipTypes',
    id: '635014',
    value: 'M',
    sort: 14,
    added: 'FIX.4.3',
    tag: 635,
    type: 'String',
    codeSet: 'ClearingFeeIndicatorCodeSet',
    description: 'All other ownership types',
  },
  {
    name: 'NotWorking',
    id: '636001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.3',
    tag: 636,
    type: 'Boolean',
    codeSet: 'WorkingIndicatorCodeSet',
    description: 'Order has been accepted but not yet in a working state',
  },
  {
    name: 'Working',
    id: '636002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.3',
    tag: 636,
    type: 'Boolean',
    codeSet: 'WorkingIndicatorCodeSet',
    description: 'Order is currently being worked',
  },
  {
    name: 'PriorityUnchanged',
    id: '638001',
    value: '0',
    sort: 1,
    added: 'FIX.4.3',
    tag: 638,
    type: 'int',
    codeSet: 'PriorityIndicatorCodeSet',
    description: 'Priority unchanged',
  },
  {
    name: 'LostPriorityAsResultOfOrderChange',
    id: '638002',
    value: '1',
    sort: 2,
    added: 'FIX.4.3',
    tag: 638,
    type: 'int',
    codeSet: 'PriorityIndicatorCodeSet',
    description: 'Lost Priority as result of order change',
  },
  {
    name: 'DoesNotConsituteALegalConfirm',
    id: '650001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.3',
    tag: 650,
    type: 'Boolean',
    codeSet: 'LegalConfirmCodeSet',
    description: 'Does not consitute a Legal Confirm',
  },
  {
    name: 'LegalConfirm',
    id: '650002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.3',
    tag: 650,
    type: 'Boolean',
    codeSet: 'LegalConfirmCodeSet',
    description: 'Legal Confirm',
  },
  {
    name: 'UnknownSymbol',
    id: '658001',
    value: '1',
    sort: 0,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '290',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description:
      'Unknown Symbol (Security)\n\nIn the context of IA FX Reject codes, Quote Rejection Category F, the RFQ is rejected due to unknown or unsupported product, e.g. by the specific venue, tenor restrictions on the market participant(s) involved.',
  },
  {
    name: 'Exchange',
    id: '658002',
    value: '2',
    sort: 1,
    added: 'FIX.4.3',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description: 'Exchange (Security) Closed',
  },
  {
    name: 'QuoteRequestExceedsLimit',
    id: '658003',
    value: '3',
    sort: 2,
    added: 'FIX.4.3',
    updated: 'FIX.Latest',
    updatedEP: '290',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description:
      'Quote Request Exceeds Limit\n\nIn the context of IA FX Reject codes, Quote Rejection Category D, the RFQ is rejected due to risk limit exceeded or not in place.',
  },
  {
    name: 'TooLateToEnter',
    id: '658004',
    value: '4',
    sort: 3,
    added: 'FIX.4.3',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description: 'Too Late to enter',
  },
  {
    name: 'InvalidPrice',
    id: '658005',
    value: '5',
    sort: 4,
    added: 'FIX.4.3',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description: 'Invalid Price',
  },
  {
    name: 'NotAuthorizedToRequestQuote',
    id: '658006',
    value: '6',
    sort: 5,
    added: 'FIX.4.3',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description: 'Not Authorized To Request Quote',
  },
  {
    name: 'NoMatchForInquiry',
    id: '658007',
    value: '7',
    sort: 6,
    added: 'FIX.4.4',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description: 'No Match For Inquiry',
  },
  {
    name: 'NoMarketForInstrument',
    id: '658008',
    value: '8',
    sort: 7,
    added: 'FIX.4.4',
    updated: 'FIX.Latest',
    updatedEP: '290',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description:
      'No Market For Instrument\n\nIn the context of IA FX Reject codes, Quote Rejection Category F, the RFQ is rejected due to unknown or unsupported product.',
  },
  {
    name: 'NoInventory',
    id: '658009',
    value: '9',
    sort: 8,
    added: 'FIX.4.4',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description: 'No Inventory',
  },
  {
    name: 'Pass',
    id: '658010',
    value: '10',
    sort: 9,
    added: 'FIX.4.4',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description: 'Pass',
  },
  {
    name: 'InsufficientCredit',
    id: '658011',
    value: '11',
    sort: 10,
    added: 'FIX.4.4',
    addedEP: '21',
    updated: 'FIX.Latest',
    updatedEP: '290',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description:
      'Insufficient credit\n\nIn the context of IA FX Reject codes, Quote Rejection Category A, the RFQ is rejected due to credit limit exceeded or not in place.',
  },
  {
    name: 'ExceededClipSizeLimit',
    id: '658012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description: 'Exceeded clip size limit',
  },
  {
    name: 'ExceededMaxNotionalOrderAmt',
    id: '658013',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description: 'Exceeded maximum notional order amount',
  },
  {
    name: 'ExceededDV01PV01Limit',
    id: '658014',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description: 'Exceeded DV01/PV01 limit',
  },
  {
    name: 'ExceededCS01Limit',
    id: '658015',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description: 'Exceeded CS01 limit',
  },
  {
    name: 'UnavailablePriceLiquidity',
    id: '658016',
    value: '16',
    sort: 16,
    added: 'FIX.Latest',
    addedEP: '290',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description:
      'Unavailable price or liquidity\n\nIn the context of IA FX Reject codes, Quote Rejection Category A, the RFQ is rejected due to unavailable price information.',
  },
  {
    name: 'UnmetRegulatoryRequirement',
    id: '658017',
    value: '17',
    sort: 17,
    added: 'FIX.Latest',
    addedEP: '290',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description:
      'Unmet regulatory requirement\n\nIn the context of IA FX Reject codes, Quote Rejection Category B, the RFQ is rejected due to regulatory requirements not being met. For example, a RFQ is submitted into a SEF by a non-SEF participant, or an NDF was submitted into the trading platform.',
  },
  {
    name: 'UnknownAccounts',
    id: '658018',
    value: '18',
    sort: 18,
    added: 'FIX.Latest',
    addedEP: '290',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description:
      'Unknown account(s)\n\nIn the context of IA FX Reject codes, Quote Rejection Category F, the RFQ is rejected due to the account/fund is not setup or unknown.',
  },
  {
    name: 'InvalidMissingEntitlements',
    id: '658019',
    value: '19',
    sort: 19,
    added: 'FIX.Latest',
    addedEP: '290',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description:
      'Invalid or missing entitlements\n\nIn the context of IA FX Reject codes, Quote Rejection Category F, the RFQ is rejected due to static data when the counterparty is not authorized or has missing entitlements.',
  },
  {
    name: 'Other',
    id: '658020',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    updated: 'FIX.Latest',
    updatedEP: '290',
    tag: 658,
    type: 'int',
    codeSet: 'QuoteRequestRejectReasonCodeSet',
    description:
      'Other\n\nIn the context of IA FX Reject codes, Quote Rejection Category E, the RFQ is rejected due to other exceptions. Further detail may be provided in RejectText(1328) or Text(58), with preference for RejectText(1328) if field is present in the message.',
  },
  {
    name: 'BIC',
    id: '660001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 660,
    type: 'int',
    codeSet: 'AcctIDSourceCodeSet',
    description: 'BIC',
  },
  {
    name: 'SIDCode',
    id: '660002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 660,
    type: 'int',
    codeSet: 'AcctIDSourceCodeSet',
    description: 'SID Code',
  },
  {
    name: 'TFM',
    id: '660003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    tag: 660,
    type: 'int',
    codeSet: 'AcctIDSourceCodeSet',
    description: 'TFM (GSPTA)',
  },
  {
    name: 'OMGEO',
    id: '660004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    tag: 660,
    type: 'int',
    codeSet: 'AcctIDSourceCodeSet',
    description: 'OMGEO (Alert ID)',
  },
  {
    name: 'DTCCCode',
    id: '660005',
    value: '5',
    sort: 5,
    added: 'FIX.4.4',
    tag: 660,
    type: 'int',
    codeSet: 'AcctIDSourceCodeSet',
    description: 'DTCC Code',
  },
  {
    name: 'SPSAID',
    id: '660006',
    value: '6',
    sort: 6,
    added: 'FIX.Latest',
    addedEP: '262',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 660,
    type: 'int',
    codeSet: 'AcctIDSourceCodeSet',
    description:
      'Special Segregated Account ID\n\nAlso referred to as SPSA ID. The Special Segregated Account identifier issued by Hong Kong Exchanges and Clearing.',
  },
  {
    name: 'Other',
    id: '660007',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    tag: 660,
    type: 'int',
    codeSet: 'AcctIDSourceCodeSet',
    description: 'Other (custom or proprietary)',
  },
  {
    name: 'Received',
    id: '665001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 665,
    type: 'int',
    codeSet: 'ConfirmStatusCodeSet',
    description: 'Received',
  },
  {
    name: 'MismatchedAccount',
    id: '665002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 665,
    type: 'int',
    codeSet: 'ConfirmStatusCodeSet',
    description: 'Mismatched Account',
  },
  {
    name: 'MissingSettlementInstructions',
    id: '665003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    tag: 665,
    type: 'int',
    codeSet: 'ConfirmStatusCodeSet',
    description: 'Missing Settlement Instructions',
  },
  {
    name: 'Confirmed',
    id: '665004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    tag: 665,
    type: 'int',
    codeSet: 'ConfirmStatusCodeSet',
    description: 'Confirmed',
  },
  {
    name: 'RequestRejected',
    id: '665005',
    value: '5',
    sort: 5,
    added: 'FIX.4.4',
    tag: 665,
    type: 'int',
    codeSet: 'ConfirmStatusCodeSet',
    description: 'Request Rejected',
  },
  {
    name: 'New',
    id: '666001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 666,
    type: 'int',
    codeSet: 'ConfirmTransTypeCodeSet',
    description: 'New',
  },
  {
    name: 'Replace',
    id: '666002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 666,
    type: 'int',
    codeSet: 'ConfirmTransTypeCodeSet',
    description: 'Replace',
  },
  {
    name: 'Cancel',
    id: '666003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 666,
    type: 'int',
    codeSet: 'ConfirmTransTypeCodeSet',
    description: 'Cancel',
  },
  {
    name: 'BookEntry',
    id: '668001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 668,
    type: 'int',
    codeSet: 'DeliveryFormCodeSet',
    description: 'Book Entry (default)',
  },
  {
    name: 'Bearer',
    id: '668002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 668,
    type: 'int',
    codeSet: 'DeliveryFormCodeSet',
    description: 'Bearer',
  },
  {
    name: 'ParForPar',
    id: '690001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 690,
    type: 'int',
    codeSet: 'LegSwapTypeCodeSet',
    description: 'Par For Par',
  },
  {
    name: 'ModifiedDuration',
    id: '690002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 690,
    type: 'int',
    codeSet: 'LegSwapTypeCodeSet',
    description: 'Modified Duration',
  },
  {
    name: 'Risk',
    id: '690003',
    value: '4',
    sort: 3,
    added: 'FIX.4.4',
    tag: 690,
    type: 'int',
    codeSet: 'LegSwapTypeCodeSet',
    description: 'Risk',
  },
  {
    name: 'Proceeds',
    id: '690004',
    value: '5',
    sort: 4,
    added: 'FIX.4.4',
    tag: 690,
    type: 'int',
    codeSet: 'LegSwapTypeCodeSet',
    description: 'Proceeds',
  },
  {
    name: 'Percent',
    id: '692001',
    value: '1',
    sort: 0,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '207',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description:
      'Percentage (i.e. percent of par) (often called "dollar price" for fixed income)',
  },
  {
    name: 'PerShare',
    id: '692002',
    value: '2',
    sort: 1,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '207',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'Per unit (i.e. per share or contract)',
  },
  {
    name: 'FixedAmount',
    id: '692003',
    value: '3',
    sort: 2,
    added: 'FIX.4.4',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'Fixed Amount (absolute value)',
  },
  {
    name: 'Discount',
    id: '692004',
    value: '4',
    sort: 3,
    added: 'FIX.4.4',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'Discount - percentage points below par',
  },
  {
    name: 'Premium',
    id: '692005',
    value: '5',
    sort: 4,
    added: 'FIX.4.4',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'Premium - percentage points over par',
  },
  {
    name: 'Spread',
    id: '692006',
    value: '6',
    sort: 5,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '207',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description:
      'Spread (basis points relative to benchmark)\n\nUsually the difference in yield between two switched bonds or a corporate bond traded spread-to-benchmark.',
  },
  {
    name: 'TEDPrice',
    id: '692007',
    value: '7',
    sort: 6,
    added: 'FIX.4.4',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'TED Price',
  },
  {
    name: 'TEDYield',
    id: '692008',
    value: '8',
    sort: 7,
    added: 'FIX.4.4',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'TED Yield',
  },
  {
    name: 'YieldSpread',
    id: '692009',
    value: '9',
    sort: 8,
    added: 'FIX.4.4',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'Yield Spread (swaps)',
  },
  {
    name: 'Yield',
    id: '692010',
    value: '10',
    sort: 9,
    added: 'FIX.4.4',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'Yield',
  },
  {
    name: 'PriceSpread',
    id: '692011',
    value: '12',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '207',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description:
      'Price spread\n\nPrice spread is expressed based on market convention for the asset being priced or traded. For example: the difference between the prices of a multileg switch or strategy expressed in basis points for a CDS or TBA roll; a price value to be added to a reference price, such as a "pay up" for specified pools.',
  },
  {
    name: 'ProductTicksInHalves',
    id: '692012',
    value: '13',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '207',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'Product ticks in halves',
  },
  {
    name: 'ProductTicksInFourths',
    id: '692013',
    value: '14',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '207',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'Product ticks in fourths',
  },
  {
    name: 'ProductTicksInEighths',
    id: '692014',
    value: '15',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '207',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'Product ticks in eighths',
  },
  {
    name: 'ProductTicksInSixteenths',
    id: '692015',
    value: '16',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '207',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'Product ticks in sixteenths',
  },
  {
    name: 'ProductTicksInThirtySeconds',
    id: '692016',
    value: '17',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '207',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'Product ticks in thirty-seconds',
  },
  {
    name: 'ProductTicksInSixtyFourths',
    id: '692017',
    value: '18',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '207',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'Product ticks in sixty-fourths',
  },
  {
    name: 'ProductTicksInOneTwentyEighths',
    id: '692018',
    value: '19',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '207',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'Product ticks in one-twenty-eighths',
  },
  {
    name: 'NormalRateRepresentation',
    id: '692019',
    value: '20',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '207',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'Normal rate representation (e.g. FX rate)',
  },
  {
    name: 'InverseRateRepresentation',
    id: '692020',
    value: '21',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '207',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'Inverse rate representation (e.g. FX rate)',
  },
  {
    name: 'BasisPoints',
    id: '692021',
    value: '22',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '207',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'Basis points\n\nWhen the price is not spread based',
  },
  {
    name: 'UpFrontPoints',
    id: '692022',
    value: '23',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '207',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'Up front points\n\nUsed specifically for CDS pricing.',
  },
  {
    name: 'InterestRate',
    id: '692023',
    value: '24',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '207',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description:
      'Interest rate\n\nWhen the price is an interest rate. For example, used with benchmark reference rate.',
  },
  {
    name: 'PercentageOfNotional',
    id: '692024',
    value: '25',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '207',
    tag: 692,
    type: 'int',
    codeSet: 'QuotePriceTypeCodeSet',
    description: 'Percentage of notional',
  },
  {
    name: 'Hit',
    id: '694001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 694,
    type: 'int',
    codeSet: 'QuoteRespTypeCodeSet',
    description: 'Hit/Lift',
  },
  {
    name: 'Counter',
    id: '694002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 694,
    type: 'int',
    codeSet: 'QuoteRespTypeCodeSet',
    description: 'Counter',
  },
  {
    name: 'Expired',
    id: '694003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    tag: 694,
    type: 'int',
    codeSet: 'QuoteRespTypeCodeSet',
    description: 'Expired',
  },
  {
    name: 'Cover',
    id: '694004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '159',
    tag: 694,
    type: 'int',
    codeSet: 'QuoteRespTypeCodeSet',
    description:
      "Cover\n\nTrade was done with another quote provider. Quote provider's original quoted price was the best price not traded (i.e. the cover price).",
  },
  {
    name: 'DoneAway',
    id: '694005',
    value: '5',
    sort: 5,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '159',
    tag: 694,
    type: 'int',
    codeSet: 'QuoteRespTypeCodeSet',
    description: 'Done away\n\nTrade was done with another quote provider.',
  },
  {
    name: 'Pass',
    id: '694006',
    value: '6',
    sort: 6,
    added: 'FIX.4.4',
    tag: 694,
    type: 'int',
    codeSet: 'QuoteRespTypeCodeSet',
    description: 'Pass',
  },
  {
    name: 'EndTrade',
    id: '694007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0',
    addedEP: '68',
    updated: 'FIX.5.0SP2',
    updatedEP: '258',
    tag: 694,
    type: 'int',
    codeSet: 'QuoteRespTypeCodeSet',
    description: 'End trade\n\nIndicates an end to the trade negotiation.',
  },
  {
    name: 'TimedOut',
    id: '694008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0',
    addedEP: '68',
    updated: 'FIX.5.0SP2',
    updatedEP: '159',
    tag: 694,
    type: 'int',
    codeSet: 'QuoteRespTypeCodeSet',
    description: 'Timed out',
  },
  {
    name: 'Tied',
    id: '694009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '159',
    tag: 694,
    type: 'int',
    codeSet: 'QuoteRespTypeCodeSet',
    description:
      "Tied\n\nTrade was done with another quote provider. Quote provider's original quoted price was the same as the traded price.",
  },
  {
    name: 'TiedCover',
    id: '694010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '159',
    tag: 694,
    type: 'int',
    codeSet: 'QuoteRespTypeCodeSet',
    description:
      "Tied cover\n\nTrade was done with another quote provider. Quote provider's original quoted price was the best price not traded. There were other quote provider(s) at the same price.",
  },
  {
    name: 'Accept',
    id: '694011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '258',
    tag: 694,
    type: 'int',
    codeSet: 'QuoteRespTypeCodeSet',
    description:
      'Accept\n\nUsed in a response to acknowledge an action communicated by the counterparty.',
  },
  {
    name: 'TerminateContract',
    id: '694012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '258',
    tag: 694,
    type: 'int',
    codeSet: 'QuoteRespTypeCodeSet',
    description:
      'Terminate contract\n\nUsed to communicate the termination of an existing contract.',
  },
  {
    name: 'AllocationTradeQty',
    id: '703001',
    value: 'ALC',
    sort: 1,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Allocation Trade Qty',
  },
  {
    name: 'OptionAssignment',
    id: '703002',
    value: 'AS',
    sort: 2,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Option Assignment',
  },
  {
    name: 'AsOfTradeQty',
    id: '703003',
    value: 'ASF',
    sort: 3,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'As-of Trade Qty',
  },
  {
    name: 'DeliveryQty',
    id: '703004',
    value: 'DLV',
    sort: 4,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Delivery Qty',
  },
  {
    name: 'ElectronicTradeQty',
    id: '703005',
    value: 'ETR',
    sort: 5,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Electronic Trade Qty',
  },
  {
    name: 'OptionExerciseQty',
    id: '703006',
    value: 'EX',
    sort: 6,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Option Exercise Qty',
  },
  {
    name: 'EndOfDayQty',
    id: '703007',
    value: 'FIN',
    sort: 7,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'End-of-Day Qty',
  },
  {
    name: 'IntraSpreadQty',
    id: '703008',
    value: 'IAS',
    sort: 8,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Intra-spread Qty',
  },
  {
    name: 'InterSpreadQty',
    id: '703009',
    value: 'IES',
    sort: 9,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Inter-spread Qty',
  },
  {
    name: 'AdjustmentQty',
    id: '703010',
    value: 'PA',
    sort: 10,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Adjustment Qty',
  },
  {
    name: 'PitTradeQty',
    id: '703011',
    value: 'PIT',
    sort: 11,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Pit Trade Qty',
  },
  {
    name: 'StartOfDayQty',
    id: '703012',
    value: 'SOD',
    sort: 12,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Start-of-Day Qty',
  },
  {
    name: 'IntegralSplit',
    id: '703013',
    value: 'SPL',
    sort: 13,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Integral Split',
  },
  {
    name: 'TransactionFromAssignment',
    id: '703014',
    value: 'TA',
    sort: 14,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Transaction from Assignment',
  },
  {
    name: 'TotalTransactionQty',
    id: '703015',
    value: 'TOT',
    sort: 15,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Total Transaction Qty',
  },
  {
    name: 'TransactionQuantity',
    id: '703016',
    value: 'TQ',
    sort: 16,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Transaction Quantity',
  },
  {
    name: 'TransferTradeQty',
    id: '703017',
    value: 'TRF',
    sort: 17,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Transfer Trade Qty',
  },
  {
    name: 'TransactionFromExercise',
    id: '703018',
    value: 'TX',
    sort: 18,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Transaction from Exercise',
  },
  {
    name: 'CrossMarginQty',
    id: '703019',
    value: 'XM',
    sort: 19,
    added: 'FIX.4.4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Cross Margin Qty',
  },
  {
    name: 'ReceiveQuantity',
    id: '703020',
    value: 'RCV',
    sort: 20,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Receive Quantity',
  },
  {
    name: 'CorporateActionAdjustment',
    id: '703021',
    value: 'CAA',
    sort: 21,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Corporate Action Adjustment',
  },
  {
    name: 'DeliveryNoticeQty',
    id: '703022',
    value: 'DN',
    sort: 22,
    added: 'FIX.4.4',
    addedEP: '13',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Delivery Notice Qty',
  },
  {
    name: 'ExchangeForPhysicalQty',
    id: '703023',
    value: 'EP',
    sort: 23,
    added: 'FIX.4.4',
    addedEP: '13',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Exchange for Physical Qty',
  },
  {
    name: 'PrivatelyNegotiatedTradeQty',
    id: '703024',
    value: 'PNTN',
    sort: 24,
    added: 'FIX.5.0',
    addedEP: '55',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Privately negotiated Trade Qty (Non-regulated)',
  },
  {
    name: 'NetDeltaQty',
    id: '703025',
    value: 'DLT',
    sort: 25,
    added: 'FIX.5.0SP1',
    addedEP: '79',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Net Delta Qty',
  },
  {
    name: 'CreditEventAdjustment',
    id: '703026',
    value: 'CEA',
    sort: 25,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Credit Event Adjustment',
  },
  {
    name: 'SuccessionEventAdjustment',
    id: '703027',
    value: 'SEA',
    sort: 26,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Succession Event Adjustment',
  },
  {
    name: 'NetQty',
    id: '703028',
    value: 'NET',
    sort: 27,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Net Qty',
  },
  {
    name: 'GrossQty',
    id: '703029',
    value: 'GRS',
    sort: 28,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Gross Qty',
  },
  {
    name: 'IntradayQty',
    id: '703030',
    value: 'ITD',
    sort: 29,
    added: 'FIX.5.0SP2',
    addedEP: '103',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Intraday Qty',
  },
  {
    name: 'GrossLongNonDeltaAdjustedSwaptionPosition',
    id: '703031',
    value: 'NDAS',
    sort: 30,
    added: 'FIX.5.0SP2',
    addedEP: '140',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Gross non-delta-adjusted swaption position',
  },
  {
    name: 'LongDeltaAdjustedPairedSwaptionPosition',
    id: '703032',
    value: 'DAS',
    sort: 31,
    added: 'FIX.5.0SP2',
    addedEP: '140',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Delta-adjusted paired swaption position',
  },
  {
    name: 'ExpiringQuantity',
    id: '703033',
    value: 'EXP',
    sort: 32,
    added: 'FIX.5.0SP2',
    addedEP: '151',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description:
      'Expiring quantity\n\nThe position quantity on expiration day after the application of trade and post trade activity, but prior to the application of exercises and assignments.',
  },
  {
    name: 'QuantityNotExercised',
    id: '703034',
    value: 'UNEX',
    sort: 33,
    added: 'FIX.5.0SP2',
    addedEP: '151',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description:
      'Quantity not exercised\n\nThe exercise quantity requested that was not allowed, e.g., the exercise quantity requested that exceeded the final long position.',
  },
  {
    name: 'RequestedExerciseQuantity',
    id: '703035',
    value: 'REQ',
    sort: 34,
    added: 'FIX.5.0SP2',
    addedEP: '151',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description:
      'Requested exercise quantity\n\nThe exercise quantity requested. It may differ from the exercise quantity if it exceeds the final long position.',
  },
  {
    name: 'CashFuturesEquivalentQuantity',
    id: '703036',
    value: 'CFE',
    sort: 35,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description: 'Cash futures equivalent quantity',
  },
  {
    name: 'LoanOrBorrowedQuantity',
    id: '703037',
    value: 'SECLN',
    sort: 36,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 703,
    type: 'String',
    codeSet: 'PosTypeCodeSet',
    description:
      'Loan or borrowed quantity\n\nThe number of shares, par value of bonds or commodity contracts on loan or borrowed.',
  },
  {
    name: 'Submitted',
    id: '706001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 706,
    type: 'int',
    codeSet: 'PosQtyStatusCodeSet',
    description: 'Submitted',
  },
  {
    name: 'Accepted',
    id: '706002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 706,
    type: 'int',
    codeSet: 'PosQtyStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Rejected',
    id: '706003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 706,
    type: 'int',
    codeSet: 'PosQtyStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'CashAmount',
    id: '707001',
    value: 'CASH',
    sort: 0,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Cash amount (corporate event)',
  },
  {
    name: 'CashResidualAmount',
    id: '707002',
    value: 'CRES',
    sort: 1,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Cash residual amount',
  },
  {
    name: 'FinalMarkToMarketAmount',
    id: '707003',
    value: 'FMTM',
    sort: 2,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Final mark-to-market amount',
  },
  {
    name: 'IncrementalMarkToMarketAmount',
    id: '707004',
    value: 'IMTM',
    sort: 3,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Incremental mark-to-market',
  },
  {
    name: 'PremiumAmount',
    id: '707005',
    value: 'PREM',
    sort: 4,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Premium amount',
  },
  {
    name: 'StartOfDayMarkToMarketAmount',
    id: '707006',
    value: 'SMTM',
    sort: 5,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Start of day mark-to-market',
  },
  {
    name: 'TradeVariationAmount',
    id: '707007',
    value: 'TVAR',
    sort: 6,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Trade variation amount',
  },
  {
    name: 'ValueAdjustedAmount',
    id: '707008',
    value: 'VADJ',
    sort: 7,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Value adjusted amount',
  },
  {
    name: 'SettlementValue',
    id: '707009',
    value: 'SETL',
    sort: 8,
    added: 'FIX.4.4',
    addedEP: '4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Settlement value',
  },
  {
    name: 'InitialTradeCouponAmount',
    id: '707010',
    value: 'ICPN',
    sort: 9,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Initial trade coupon amount',
  },
  {
    name: 'AccruedCouponAmount',
    id: '707011',
    value: 'ACPN',
    sort: 10,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Accrued coupon amount',
  },
  {
    name: 'CouponAmount',
    id: '707012',
    value: 'CPN',
    sort: 11,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Coupon amount',
  },
  {
    name: 'IncrementalAccruedCoupon',
    id: '707013',
    value: 'IACPN',
    sort: 12,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Incremental accrued coupon',
  },
  {
    name: 'CollateralizedMarkToMarket',
    id: '707014',
    value: 'CMTM',
    sort: 13,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Collateralized mark-to-market',
  },
  {
    name: 'IncrementalCollateralizedMarkToMarket',
    id: '707015',
    value: 'ICMTM',
    sort: 14,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Incremental collateralized mark-to-market',
  },
  {
    name: 'CompensationAmount',
    id: '707016',
    value: 'DLV',
    sort: 15,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Compensation amount',
  },
  {
    name: 'TotalBankedAmount',
    id: '707017',
    value: 'BANK',
    sort: 16,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Total banked amount',
  },
  {
    name: 'TotalCollateralizedAmount',
    id: '707018',
    value: 'COLAT',
    sort: 17,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Total collateralized amount',
  },
  {
    name: 'LongPairedSwapNotionalValue',
    id: '707019',
    value: 'LSNV',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '140',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Long paired swap or swaption notional value',
  },
  {
    name: 'ShortPairedSwapNotionalValue',
    id: '707020',
    value: 'SSNV',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '140',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Short paired swap or swaption notional value',
  },
  {
    name: 'StartOfDayAccruedCoupon',
    id: '707021',
    value: 'SACPN',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Start-of-day accrued coupon',
  },
  {
    name: 'NetPresentValue',
    id: '707022',
    value: 'NPV',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Net present value',
  },
  {
    name: 'StartOfDayNetPresentValue',
    id: '707023',
    value: 'SNPV',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Start-of-day net present value',
  },
  {
    name: 'NetCashFlow',
    id: '707024',
    value: 'NCF',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Net cash flow',
  },
  {
    name: 'PresentValueOfFees',
    id: '707025',
    value: 'PVFEES',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Present value of all fees',
  },
  {
    name: 'PresentValueOneBasisPoints',
    id: '707026',
    value: 'PV01',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description:
      'Present value of one basis points\n\nChange in value if yield curve shifts 0.01%.',
  },
  {
    name: 'FiveYearEquivalentNotional',
    id: '707027',
    value: '5YREN',
    sort: 26,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'The five year equivalent notional amount',
  },
  {
    name: 'UndiscountedMarkToMarket',
    id: '707028',
    value: 'UMTM',
    sort: 27,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Undiscounted mark-to-market',
  },
  {
    name: 'MarkToModel',
    id: '707029',
    value: 'MTD',
    sort: 28,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Mark-to-model',
  },
  {
    name: 'MarkToMarketVariance',
    id: '707030',
    value: 'VMTM',
    sort: 29,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Mark-to-market variance',
  },
  {
    name: 'MarkToModelVariance',
    id: '707031',
    value: 'VMTD',
    sort: 30,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Mark-to-model variance',
  },
  {
    name: 'UpfrontPayment',
    id: '707032',
    value: 'UPFRNT',
    sort: 31,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Upfront payment',
  },
  {
    name: 'EndVale',
    id: '707033',
    value: 'ENDV',
    sort: 32,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description:
      'End value\n\nPrincipal amount of a securities financing transaction on matuity date.',
  },
  {
    name: 'OutstandingMarginLoan',
    id: '707034',
    value: 'MGNLN',
    sort: 33,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description:
      'Outstanding margin loan\n\nThe amount of the outstanding margin loan. In the event that the loan has a short market value, PosAmt(708) would be a negative value.',
  },
  {
    name: 'LoanValue',
    id: '707035',
    value: 'LNVL',
    sort: 34,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 707,
    type: 'String',
    codeSet: 'PosAmtTypeCodeSet',
    description: 'Loan value\n\nThe amount of the loan.',
  },
  {
    name: 'Exercise',
    id: '709001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 709,
    type: 'int',
    codeSet: 'PosTransTypeCodeSet',
    description: 'Exercise',
  },
  {
    name: 'DoNotExercise',
    id: '709002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '199',
    tag: 709,
    type: 'int',
    codeSet: 'PosTransTypeCodeSet',
    description: 'Do not exercise',
  },
  {
    name: 'PositionAdjustment',
    id: '709003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '199',
    tag: 709,
    type: 'int',
    codeSet: 'PosTransTypeCodeSet',
    description: 'Position adjustment',
  },
  {
    name: 'PositionChangeSubmission',
    id: '709004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '199',
    tag: 709,
    type: 'int',
    codeSet: 'PosTransTypeCodeSet',
    description: 'Position change submission / margin disposition',
  },
  {
    name: 'Pledge',
    id: '709005',
    value: '5',
    sort: 5,
    added: 'FIX.4.4',
    tag: 709,
    type: 'int',
    codeSet: 'PosTransTypeCodeSet',
    description: 'Pledge',
  },
  {
    name: 'LargeTraderSubmission',
    id: '709006',
    value: '6',
    sort: 6,
    added: 'FIX.4.4',
    addedEP: '13',
    updated: 'FIX.5.0SP2',
    updatedEP: '199',
    tag: 709,
    type: 'int',
    codeSet: 'PosTransTypeCodeSet',
    description: 'Large trader submission',
  },
  {
    name: 'LargePositionsReportingSubmission',
    id: '709007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '103',
    updated: 'FIX.5.0SP2',
    updatedEP: '199',
    tag: 709,
    type: 'int',
    codeSet: 'PosTransTypeCodeSet',
    description: 'Large positions reporting submission',
  },
  {
    name: 'LongHoldings',
    id: '709008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '110',
    updated: 'FIX.5.0SP2',
    updatedEP: '199',
    tag: 709,
    type: 'int',
    codeSet: 'PosTransTypeCodeSet',
    description: 'Long holdings',
  },
  {
    name: 'InternalTransfer',
    id: '709009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '199',
    tag: 709,
    type: 'int',
    codeSet: 'PosTransTypeCodeSet',
    description:
      'Internal transfer\n\nChanges due to transfer of positions within a firm.',
  },
  {
    name: 'TransferOfFirm',
    id: '709010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '199',
    tag: 709,
    type: 'int',
    codeSet: 'PosTransTypeCodeSet',
    description:
      'Transfer of firm\n\nChanges due to transfer of all positions of a firm.',
  },
  {
    name: 'ExternalTransfer',
    id: '709011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '199',
    tag: 709,
    type: 'int',
    codeSet: 'PosTransTypeCodeSet',
    description:
      'External transfer\n\nChanges due to transfer of positions between firms.',
  },
  {
    name: 'CorporateAction',
    id: '709012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '199',
    tag: 709,
    type: 'int',
    codeSet: 'PosTransTypeCodeSet',
    description: 'Corporate action',
  },
  {
    name: 'Notification',
    id: '709013',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '199',
    tag: 709,
    type: 'int',
    codeSet: 'PosTransTypeCodeSet',
    description:
      'Notification\n\nInformation about a position that has been chosen for assignment.',
  },
  {
    name: 'PositionCreation',
    id: '709014',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '199',
    tag: 709,
    type: 'int',
    codeSet: 'PosTransTypeCodeSet',
    description:
      'Position creation\n\nChanges due to an option exercise causing a new futures position to be created.',
  },
  {
    name: 'Closeout',
    id: '709015',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '199',
    tag: 709,
    type: 'int',
    codeSet: 'PosTransTypeCodeSet',
    description: 'Close out\n\nInformation about a position that has been closed out.',
  },
  {
    name: 'Reopen',
    id: '709016',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '199',
    tag: 709,
    type: 'int',
    codeSet: 'PosTransTypeCodeSet',
    description:
      'Reopen\n\nInformation about a position that has been reopened, i.e. reversal of a close out.',
  },
  {
    name: 'New',
    id: '712001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 712,
    type: 'int',
    codeSet: 'PosMaintActionCodeSet',
    description: 'New\n\nUsed to increment the overall transaction quantity.',
  },
  {
    name: 'Replace',
    id: '712002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 712,
    type: 'int',
    codeSet: 'PosMaintActionCodeSet',
    description:
      'Replace\n\nUsed to override the overall transaction quantity or specific add messages based on the reference ID.',
  },
  {
    name: 'Cancel',
    id: '712003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 712,
    type: 'int',
    codeSet: 'PosMaintActionCodeSet',
    description:
      'Cancel\n\nUsed to remove the overall transaction quantity or specific add messages based on the reference ID.',
  },
  {
    name: 'Reverse',
    id: '712004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '4',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 712,
    type: 'int',
    codeSet: 'PosMaintActionCodeSet',
    description:
      'Reverse\n\nUsed to completelly back-out the transaction such that the transaction never existed.',
  },
  {
    name: 'Intraday',
    id: '716001',
    value: 'ITD',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '1',
    tag: 716,
    type: 'String',
    codeSet: 'SettlSessIDCodeSet',
    description: 'Intraday',
  },
  {
    name: 'RegularTradingHours',
    id: '716002',
    value: 'RTH',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '1',
    tag: 716,
    type: 'String',
    codeSet: 'SettlSessIDCodeSet',
    description: 'Regular Trading Hours',
  },
  {
    name: 'ElectronicTradingHours',
    id: '716003',
    value: 'ETH',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '1',
    tag: 716,
    type: 'String',
    codeSet: 'SettlSessIDCodeSet',
    description: 'Electronic Trading Hours',
  },
  {
    name: 'EndOfDay',
    id: '716004',
    value: 'EOD',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 716,
    type: 'String',
    codeSet: 'SettlSessIDCodeSet',
    description: 'End Of Day',
  },
  {
    name: 'ProcessRequestAsMarginDisposition',
    id: '718001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '155',
    tag: 718,
    type: 'int',
    codeSet: 'AdjustmentTypeCodeSet',
    description: 'Process request as margin disposition',
  },
  {
    name: 'DeltaPlus',
    id: '718002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '155',
    tag: 718,
    type: 'int',
    codeSet: 'AdjustmentTypeCodeSet',
    description: 'Delta plus',
  },
  {
    name: 'DeltaMinus',
    id: '718003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '155',
    tag: 718,
    type: 'int',
    codeSet: 'AdjustmentTypeCodeSet',
    description: 'Delta minus',
  },
  {
    name: 'Final',
    id: '718004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 718,
    type: 'int',
    codeSet: 'AdjustmentTypeCodeSet',
    description: 'Final',
  },
  {
    name: 'CustomerSpecificPosition',
    id: '718005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '155',
    tag: 718,
    type: 'int',
    codeSet: 'AdjustmentTypeCodeSet',
    description: 'Customer specific position',
  },
  {
    name: 'Accepted',
    id: '722001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 722,
    type: 'int',
    codeSet: 'PosMaintStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'AcceptedWithWarnings',
    id: '722002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 722,
    type: 'int',
    codeSet: 'PosMaintStatusCodeSet',
    description: 'Accepted With Warnings',
  },
  {
    name: 'Rejected',
    id: '722003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 722,
    type: 'int',
    codeSet: 'PosMaintStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'Completed',
    id: '722004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 722,
    type: 'int',
    codeSet: 'PosMaintStatusCodeSet',
    description: 'Completed',
  },
  {
    name: 'CompletedWithWarnings',
    id: '722005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    tag: 722,
    type: 'int',
    codeSet: 'PosMaintStatusCodeSet',
    description: 'Completed With Warnings',
  },
  {
    name: 'SuccessfulCompletion',
    id: '723001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 723,
    type: 'int',
    codeSet: 'PosMaintResultCodeSet',
    description: 'Successful Completion - no warnings or errors',
  },
  {
    name: 'Rejected',
    id: '723002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 723,
    type: 'int',
    codeSet: 'PosMaintResultCodeSet',
    description: 'Rejected',
  },
  {
    name: 'Other',
    id: '723003',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    tag: 723,
    type: 'int',
    codeSet: 'PosMaintResultCodeSet',
    description: 'Other',
  },
  {
    name: 'Positions',
    id: '724001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 724,
    type: 'int',
    codeSet: 'PosReqTypeCodeSet',
    description: 'Positions',
  },
  {
    name: 'Trades',
    id: '724002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 724,
    type: 'int',
    codeSet: 'PosReqTypeCodeSet',
    description: 'Trades',
  },
  {
    name: 'Exercises',
    id: '724003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 724,
    type: 'int',
    codeSet: 'PosReqTypeCodeSet',
    description: 'Exercises',
  },
  {
    name: 'Assignments',
    id: '724004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 724,
    type: 'int',
    codeSet: 'PosReqTypeCodeSet',
    description: 'Assignments',
  },
  {
    name: 'SettlementActivity',
    id: '724005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 724,
    type: 'int',
    codeSet: 'PosReqTypeCodeSet',
    description: 'Settlement Activity',
  },
  {
    name: 'BackoutMessage',
    id: '724006',
    value: '5',
    sort: 6,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 724,
    type: 'int',
    codeSet: 'PosReqTypeCodeSet',
    description: 'Backout Message',
  },
  {
    name: 'DeltaPositions',
    id: '724007',
    value: '6',
    sort: 7,
    added: 'FIX.5.0SP1',
    addedEP: '79',
    tag: 724,
    type: 'int',
    codeSet: 'PosReqTypeCodeSet',
    description: 'Delta Positions',
  },
  {
    name: 'NetPosition',
    id: '724008',
    value: '7',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 724,
    type: 'int',
    codeSet: 'PosReqTypeCodeSet',
    description: 'Net Position',
  },
  {
    name: 'LargePositionsReporting',
    id: '724009',
    value: '8',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '103',
    tag: 724,
    type: 'int',
    codeSet: 'PosReqTypeCodeSet',
    description: 'Large Positions Reporting',
  },
  {
    name: 'ExercisePositionReportingSubmission',
    id: '724010',
    value: '9',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '103',
    tag: 724,
    type: 'int',
    codeSet: 'PosReqTypeCodeSet',
    description: 'Exercise Position Reporting Submission',
  },
  {
    name: 'PositionLimitReportingSubmissing',
    id: '724011',
    value: '10',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '103',
    tag: 724,
    type: 'int',
    codeSet: 'PosReqTypeCodeSet',
    description: 'Position Limit Reporting Submission',
  },
  {
    name: 'Inband',
    id: '725001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 725,
    type: 'int',
    codeSet: 'ResponseTransportTypeCodeSet',
    description: 'In-band (default)\n\nTransport of the request was sent over in-band.',
  },
  {
    name: 'OutOfBand',
    id: '725002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 725,
    type: 'int',
    codeSet: 'ResponseTransportTypeCodeSet',
    description:
      'Out of band\n\nPre-arranged out-of-band delivery mechanism (e.g. FTP, HTTP, NDM, etc.) between counterparties. Details specified via ResponseDestination(726).',
  },
  {
    name: 'ValidRequest',
    id: '728001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 728,
    type: 'int',
    codeSet: 'PosReqResultCodeSet',
    description: 'Valid request',
  },
  {
    name: 'InvalidOrUnsupportedRequest',
    id: '728002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 728,
    type: 'int',
    codeSet: 'PosReqResultCodeSet',
    description: 'Invalid or unsupported request',
  },
  {
    name: 'NoPositionsFoundThatMatchCriteria',
    id: '728003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 728,
    type: 'int',
    codeSet: 'PosReqResultCodeSet',
    description: 'No positions found that match criteria',
  },
  {
    name: 'NotAuthorizedToRequestPositions',
    id: '728004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 728,
    type: 'int',
    codeSet: 'PosReqResultCodeSet',
    description: 'Not authorized to request positions',
  },
  {
    name: 'RequestForPositionNotSupported',
    id: '728005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    tag: 728,
    type: 'int',
    codeSet: 'PosReqResultCodeSet',
    description: 'Request for position not supported',
  },
  {
    name: 'Other',
    id: '728006',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 728,
    type: 'int',
    codeSet: 'PosReqResultCodeSet',
    description: 'Other\n\nUse Text(58) for further explanation.',
  },
  {
    name: 'Completed',
    id: '729001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 729,
    type: 'int',
    codeSet: 'PosReqStatusCodeSet',
    description: 'Completed',
  },
  {
    name: 'CompletedWithWarnings',
    id: '729002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 729,
    type: 'int',
    codeSet: 'PosReqStatusCodeSet',
    description: 'Completed With Warnings',
  },
  {
    name: 'Rejected',
    id: '729003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 729,
    type: 'int',
    codeSet: 'PosReqStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'Final',
    id: '731001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 731,
    type: 'int',
    codeSet: 'SettlPriceTypeCodeSet',
    description: 'Final',
  },
  {
    name: 'Theoretical',
    id: '731002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 731,
    type: 'int',
    codeSet: 'SettlPriceTypeCodeSet',
    description: 'Theoretical',
  },
  {
    name: 'ProRata',
    id: '744001',
    value: 'P',
    sort: 1,
    added: 'FIX.4.4',
    tag: 744,
    type: 'char',
    codeSet: 'AssignmentMethodCodeSet',
    description: 'Pro rata',
  },
  {
    name: 'Random',
    id: '744002',
    value: 'R',
    sort: 2,
    added: 'FIX.4.4',
    tag: 744,
    type: 'char',
    codeSet: 'AssignmentMethodCodeSet',
    description: 'Random',
  },
  {
    name: 'Automatic',
    id: '747001',
    value: 'A',
    sort: 1,
    added: 'FIX.4.4',
    tag: 747,
    type: 'char',
    codeSet: 'ExerciseMethodCodeSet',
    description: 'Automatic',
  },
  {
    name: 'Manual',
    id: '747002',
    value: 'M',
    sort: 2,
    added: 'FIX.4.4',
    tag: 747,
    type: 'char',
    codeSet: 'ExerciseMethodCodeSet',
    description: 'Manual',
  },
  {
    name: 'Successful',
    id: '749001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 749,
    type: 'int',
    codeSet: 'TradeRequestResultCodeSet',
    description: 'Successful (default)',
  },
  {
    name: 'InvalidOrUnknownInstrument',
    id: '749002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 749,
    type: 'int',
    codeSet: 'TradeRequestResultCodeSet',
    description: 'Invalid or unknown instrument',
  },
  {
    name: 'InvalidTypeOfTradeRequested',
    id: '749003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 749,
    type: 'int',
    codeSet: 'TradeRequestResultCodeSet',
    description: 'Invalid type of trade requested',
  },
  {
    name: 'InvalidParties',
    id: '749004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 749,
    type: 'int',
    codeSet: 'TradeRequestResultCodeSet',
    description: 'Invalid parties',
  },
  {
    name: 'InvalidTransportTypeRequested',
    id: '749005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    tag: 749,
    type: 'int',
    codeSet: 'TradeRequestResultCodeSet',
    description: 'Invalid transport type requested',
  },
  {
    name: 'InvalidDestinationRequested',
    id: '749006',
    value: '5',
    sort: 6,
    added: 'FIX.4.4',
    tag: 749,
    type: 'int',
    codeSet: 'TradeRequestResultCodeSet',
    description: 'Invalid destination requested',
  },
  {
    name: 'TradeRequestTypeNotSupported',
    id: '749007',
    value: '8',
    sort: 7,
    added: 'FIX.4.4',
    tag: 749,
    type: 'int',
    codeSet: 'TradeRequestResultCodeSet',
    description: 'TradeRequestType not supported',
  },
  {
    name: 'NotAuthorized',
    id: '749008',
    value: '9',
    sort: 8,
    added: 'FIX.4.4',
    tag: 749,
    type: 'int',
    codeSet: 'TradeRequestResultCodeSet',
    description: 'Not authorized',
  },
  {
    name: 'Other',
    id: '749009',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    tag: 749,
    type: 'int',
    codeSet: 'TradeRequestResultCodeSet',
    description: 'Other',
  },
  {
    name: 'Accepted',
    id: '750001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 750,
    type: 'int',
    codeSet: 'TradeRequestStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Completed',
    id: '750002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 750,
    type: 'int',
    codeSet: 'TradeRequestStatusCodeSet',
    description: 'Completed',
  },
  {
    name: 'Rejected',
    id: '750003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 750,
    type: 'int',
    codeSet: 'TradeRequestStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'Successful',
    id: '751001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 751,
    type: 'int',
    codeSet: 'TradeReportRejectReasonCodeSet',
    description: 'Successful (default)',
  },
  {
    name: 'InvalidPartyInformation',
    id: '751002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '208',
    tag: 751,
    type: 'int',
    codeSet: 'TradeReportRejectReasonCodeSet',
    description: 'Invalid party information',
  },
  {
    name: 'UnknownInstrument',
    id: '751003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 751,
    type: 'int',
    codeSet: 'TradeReportRejectReasonCodeSet',
    description: 'Unknown instrument',
  },
  {
    name: 'UnauthorizedToReportTrades',
    id: '751004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 751,
    type: 'int',
    codeSet: 'TradeReportRejectReasonCodeSet',
    description: 'Unauthorized to report trades',
  },
  {
    name: 'InvalidTradeType',
    id: '751005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    tag: 751,
    type: 'int',
    codeSet: 'TradeReportRejectReasonCodeSet',
    description: 'Invalid trade type',
  },
  {
    name: 'PriceExceedsCurrentPriceBand',
    id: '751006',
    value: '5',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '136',
    tag: 751,
    type: 'int',
    codeSet: 'TradeReportRejectReasonCodeSet',
    description: 'Price exceeds current price band',
  },
  {
    name: 'ReferencePriceNotAvailable',
    id: '751007',
    value: '6',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '136',
    tag: 751,
    type: 'int',
    codeSet: 'TradeReportRejectReasonCodeSet',
    description: 'Reference price not available',
  },
  {
    name: 'NotionalValueExceedsThreshold',
    id: '751008',
    value: '7',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '136',
    tag: 751,
    type: 'int',
    codeSet: 'TradeReportRejectReasonCodeSet',
    description: 'Notional value exceeds threshold',
  },
  {
    name: 'Other',
    id: '751009',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    tag: 751,
    type: 'int',
    codeSet: 'TradeReportRejectReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'SingleSecurity',
    id: '752001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 752,
    type: 'int',
    codeSet: 'SideMultiLegReportingTypeCodeSet',
    description: 'Single Security (default if not specified)',
  },
  {
    name: 'IndividualLegOfAMultilegSecurity',
    id: '752002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 752,
    type: 'int',
    codeSet: 'SideMultiLegReportingTypeCodeSet',
    description: 'Individual leg of a multileg security',
  },
  {
    name: 'MultilegSecurity',
    id: '752003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    tag: 752,
    type: 'int',
    codeSet: 'SideMultiLegReportingTypeCodeSet',
    description: 'Multileg Security',
  },
  {
    name: 'ExecutionTime',
    id: '770001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      'Execution time\n\nTimestamp for the order execution. In the context of US futures markets (CFTC regulated) this is the non-qualified reporting time of order execution.',
  },
  {
    name: 'TimeIn',
    id: '770002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      'Time in\n\nTimestamp for receiving an order, quote or trade. In the context of US futures markets (CFTC) this is the timestamp of when the order was received on the trading floor (booth).',
  },
  {
    name: 'TimeOut',
    id: '770003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      'Time out\n\nTimestamp for sending an order, quote or trade. In the context of US futures markets (CFTC) this is the timestamp when the trade was received from the pit.',
  },
  {
    name: 'BrokerReceipt',
    id: '770004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      'Broker receipt\n\nTimestamp for a broker receiving an order, quote or trade. In the context of US futures markets (CFTC) this is the time at which the broker received the order.',
  },
  {
    name: 'BrokerExecution',
    id: '770005',
    value: '5',
    sort: 5,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      'Broker execution\n\nTimestamp for the broker executing an order. In the context of US futures markets (CFTC regulated) this is the time at which a broker executed the order for another broker.',
  },
  {
    name: 'DeskReceipt',
    id: '770006',
    value: '6',
    sort: 6,
    added: 'FIX.4.4',
    addedEP: '9',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      'Desk receipt\n\nTimestamp for the transmission of an order to an internal desk or department on the same day the firm received the order.',
  },
  {
    name: 'SubmissionToClearing',
    id: '770007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      'Submission to clearing\n\nThe timestamp when the trade was officially acknowledged by the Clearing House.',
  },
  {
    name: 'TimePriority',
    id: '770008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '101',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      'Time priority\n\nA timestamp (manually or electronically) assigned by a market to specify time priority for an order or quote.',
  },
  {
    name: 'OrderbookEntryTime',
    id: '770009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      'Orderbook entry time\n\nTimestamp for an order representing the time it was entered in the orderbook of the execution venue. The orderbook entry time cannot change during the lifetime of the order.',
  },
  {
    name: 'OrderSubmissionTime',
    id: '770010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description: 'Order submission time\n\nTime the order was sent by the submitter.',
  },
  {
    name: 'PubliclyReported',
    id: '770011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '229',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      'Publicly reported\n\nIn the context of MiFID II, this is used to identify the time at which the transaction was first published to the market.',
  },
  {
    name: 'PublicReportUpdated',
    id: '770012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '229',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      "Public report updated\n\nIn the context of MiFID II, this is used to identify the time at which the transaction's publication to the market was last updated",
  },
  {
    name: 'NonPubliclyReported',
    id: '770013',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description: 'Non-publicly reported',
  },
  {
    name: 'NonPublicReportUpdated',
    id: '770014',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description: 'Non-public report updated',
  },
  {
    name: 'SubmittedForConfirmation',
    id: '770015',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description: 'Submitted for confirmation',
  },
  {
    name: 'UpdatedForConfirmation',
    id: '770016',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description: 'Updated for confirmation',
  },
  {
    name: 'Confirmed',
    id: '770017',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description: 'Confirmed',
  },
  {
    name: 'UpdatedForClearing',
    id: '770018',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description: 'Updated for clearing',
  },
  {
    name: 'Cleared',
    id: '770019',
    value: '19',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description: 'Cleared',
  },
  {
    name: 'AllocationsSubmitted',
    id: '770020',
    value: '20',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description: 'Allocations submitted',
  },
  {
    name: 'AllocationsUpdated',
    id: '770021',
    value: '21',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description: 'Allocations updated',
  },
  {
    name: 'AllocationsCompleted',
    id: '770022',
    value: '22',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '236',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description: 'Allocations completed',
  },
  {
    name: 'SubmittedToRepository',
    id: '770023',
    value: '23',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description: 'Submitted to repository',
  },
  {
    name: 'PostTrdContntnEvnt',
    id: '770024',
    value: '24',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description: 'Post-trade continuation event',
  },
  {
    name: 'PostTradeValuation',
    id: '770025',
    value: '25',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description: 'Post-trade valuation',
  },
  {
    name: 'PreviousTimePriority',
    id: '770026',
    value: '26',
    sort: 26,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      'Previous time priority\n\nCan be used in conjunction with TrdRegTimestampType(770) = 8 (Time priority) to provide the current and last priority timestamp in a single message.',
  },
  {
    name: 'IdentifierAssigned',
    id: '770027',
    value: '27',
    sort: 27,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      'Identifier assigned\n\nTimestamp for the assignment of a (unique) identifier to an entity (e.g. order, quote, trade).',
  },
  {
    name: 'PreviousIdentifierAssigned',
    id: '770028',
    value: '28',
    sort: 28,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      'Previous identifier assigned\n\nTimestamp of previous assignment of a (unique) identifier to an entity (e.g. order, quote, trade).',
  },
  {
    name: 'OrderCancellationTime',
    id: '770029',
    value: '29',
    sort: 29,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      'Order cancellation time\n\nTimestamp for the cancellation of an order or quote.',
  },
  {
    name: 'OrderModificationTime',
    id: '770030',
    value: '30',
    sort: 30,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      'Order modification time\n\nTimestamp for the modification of an order or quote.',
  },
  {
    name: 'OrderRoutingTime',
    id: '770031',
    value: '31',
    sort: 31,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      'Order routing time\n\nTimestamp for the routing of an order to another broker or electronic execution venue.',
  },
  {
    name: 'TradeCancellationTime',
    id: '770032',
    value: '32',
    sort: 32,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      'Trade cancellation time\n\nTimestamp for the cancellation of an execution (ExecType(150) = H (Trade Cancel)) or trade (TradeReportType(856) = 6 (Trade Report Cancel)).',
  },
  {
    name: 'TradeModificationTime',
    id: '770033',
    value: '33',
    sort: 33,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description:
      'Trade modification time\n\nTimestamp for the modification of an execution (ExecType(150) = G (Trade Correct)) or trade (TradeReportType(856) = 5 (No/Was)).',
  },
  {
    name: 'ReferenceTimeForNBBO',
    id: '770034',
    value: '34',
    sort: 34,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description: 'Reference time for NBBO\n\nTimestamp for an NBBO reference price.',
  },
  {
    name: 'Affirmed',
    id: '770035',
    value: '35',
    sort: 35,
    added: 'FIX.Latest',
    addedEP: '291',
    tag: 770,
    type: 'int',
    codeSet: 'TrdRegTimestampTypeCodeSet',
    description: 'Affirmed',
  },
  {
    name: 'Status',
    id: '773001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 773,
    type: 'int',
    codeSet: 'ConfirmTypeCodeSet',
    description: 'Status',
  },
  {
    name: 'Confirmation',
    id: '773002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 773,
    type: 'int',
    codeSet: 'ConfirmTypeCodeSet',
    description: 'Confirmation',
  },
  {
    name: 'ConfirmationRequestRejected',
    id: '773003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    tag: 773,
    type: 'int',
    codeSet: 'ConfirmTypeCodeSet',
    description:
      'Confirmation Request Rejected (reason can be stated in Text (58) field)',
  },
  {
    name: 'MismatchedAccount',
    id: '774001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Incorrect or missing account',
  },
  {
    name: 'MissingSettlementInstructions',
    id: '774002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Incorrect or missing settlement instructions',
  },
  {
    name: 'UnknownOrMissingIndividualAllocId',
    id: '774003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Unknown or missing IndividualAllocId(467)',
  },
  {
    name: 'TransactionNotRecognized',
    id: '774004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Transaction not recognized',
  },
  {
    name: 'DuplicateTransaction',
    id: '774005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Duplicate transaction',
  },
  {
    name: 'IncorrectOrMissingInstrument',
    id: '774006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Incorrect or missing instrument',
  },
  {
    name: 'IncorrectOrMissingPrice',
    id: '774007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Incorrect or missing price',
  },
  {
    name: 'IncorrectOrMissingCommission',
    id: '774008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Incorrect or missing commission',
  },
  {
    name: 'IncorrectOrMissingSettlDate',
    id: '774009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Incorrect or missing settlement date',
  },
  {
    name: 'IncorrectOrMissingFundIDOrFundName',
    id: '774010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Incorrect or missing fund ID or fund name',
  },
  {
    name: 'IncorrectOrMissingQuantity',
    id: '774011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Incorrect or missing quantity',
  },
  {
    name: 'IncorrectOrMissingFees',
    id: '774012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Incorrect or missing fees',
  },
  {
    name: 'IncorrectOrMissingTax',
    id: '774013',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Incorrect or missing tax',
  },
  {
    name: 'IncorrectOrMissingParty',
    id: '774014',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Incorrect or missing party',
  },
  {
    name: 'IncorrectOrMissingSide',
    id: '774015',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Incorrect or missing side',
  },
  {
    name: 'IncorrectOrMissingNetMoney',
    id: '774016',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Incorrect or missing net-money',
  },
  {
    name: 'IncorrectOrMissingTradeDate',
    id: '774017',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Incorrect or missing trade date',
  },
  {
    name: 'IncorrectOrMissingSettlCcyInstructions',
    id: '774018',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Incorrect or missing settlement currency instructions',
  },
  {
    name: 'IncorrectOrMissingCapacity',
    id: '774019',
    value: '19',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Incorrect or missing capacity',
  },
  {
    name: 'Other',
    id: '774020',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '170',
    tag: 774,
    type: 'int',
    codeSet: 'ConfirmRejReasonCodeSet',
    description: 'Other\n\nUse Text(58) for further reject reasons.',
  },
  {
    name: 'RegularBooking',
    id: '775001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 775,
    type: 'int',
    codeSet: 'BookingTypeCodeSet',
    description: 'Regular booking',
  },
  {
    name: 'CFD',
    id: '775002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 775,
    type: 'int',
    codeSet: 'BookingTypeCodeSet',
    description: 'CFD (Contract for difference)',
  },
  {
    name: 'TotalReturnSwap',
    id: '775003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 775,
    type: 'int',
    codeSet: 'BookingTypeCodeSet',
    description: 'Total Return Swap',
  },
  {
    name: 'UseDefaultInstructions',
    id: '780001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 780,
    type: 'int',
    codeSet: 'AllocSettlInstTypeCodeSet',
    description: 'Use default instructions',
  },
  {
    name: 'DeriveFromParametersProvided',
    id: '780002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 780,
    type: 'int',
    codeSet: 'AllocSettlInstTypeCodeSet',
    description: 'Derive from parameters provided',
  },
  {
    name: 'FullDetailsProvided',
    id: '780003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 780,
    type: 'int',
    codeSet: 'AllocSettlInstTypeCodeSet',
    description: 'Full details provided',
  },
  {
    name: 'SSIDBIDsProvided',
    id: '780004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 780,
    type: 'int',
    codeSet: 'AllocSettlInstTypeCodeSet',
    description: 'SSI DB IDs provided',
  },
  {
    name: 'PhoneForInstructions',
    id: '780005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    tag: 780,
    type: 'int',
    codeSet: 'AllocSettlInstTypeCodeSet',
    description: 'Phone for instructions',
  },
  {
    name: 'Cash',
    id: '787001',
    value: 'C',
    sort: 1,
    added: 'FIX.4.4',
    tag: 787,
    type: 'char',
    codeSet: 'DlvyInstTypeCodeSet',
    description: 'Cash',
  },
  {
    name: 'Securities',
    id: '787002',
    value: 'S',
    sort: 2,
    added: 'FIX.4.4',
    tag: 787,
    type: 'char',
    codeSet: 'DlvyInstTypeCodeSet',
    description: 'Securities',
  },
  {
    name: 'Overnight',
    id: '788001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 788,
    type: 'int',
    codeSet: 'TerminationTypeCodeSet',
    description: 'Overnight',
  },
  {
    name: 'Term',
    id: '788002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 788,
    type: 'int',
    codeSet: 'TerminationTypeCodeSet',
    description: 'Term',
  },
  {
    name: 'Flexible',
    id: '788003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    tag: 788,
    type: 'int',
    codeSet: 'TerminationTypeCodeSet',
    description: 'Flexible',
  },
  {
    name: 'Open',
    id: '788004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    tag: 788,
    type: 'int',
    codeSet: 'TerminationTypeCodeSet',
    description: 'Open',
  },
  {
    name: 'UnableToProcessRequest',
    id: '792001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 792,
    type: 'int',
    codeSet: 'SettlInstReqRejCodeCodeSet',
    description: 'Unable to process request',
  },
  {
    name: 'UnknownAccount',
    id: '792002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 792,
    type: 'int',
    codeSet: 'SettlInstReqRejCodeCodeSet',
    description: 'Unknown account',
  },
  {
    name: 'NoMatchingSettlementInstructionsFound',
    id: '792003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 792,
    type: 'int',
    codeSet: 'SettlInstReqRejCodeCodeSet',
    description: 'No matching settlement instructions found',
  },
  {
    name: 'Other',
    id: '792004',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    tag: 792,
    type: 'int',
    codeSet: 'SettlInstReqRejCodeCodeSet',
    description: 'Other',
  },
  {
    name: 'PreliminaryRequestToIntermediary',
    id: '794001',
    value: '2',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '5',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 794,
    type: 'int',
    codeSet: 'AllocReportTypeCodeSet',
    description: 'Preliminary request to intermediary',
  },
  {
    name: 'SellsideCalculatedUsingPreliminary',
    id: '794002',
    value: '3',
    sort: 2,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 794,
    type: 'int',
    codeSet: 'AllocReportTypeCodeSet',
    description: 'Sellside calculated using preliminary (includes MiscFees and NetMoney)',
  },
  {
    name: 'SellsideCalculatedWithoutPreliminary',
    id: '794003',
    value: '4',
    sort: 3,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 794,
    type: 'int',
    codeSet: 'AllocReportTypeCodeSet',
    description:
      'Sellside calculated without preliminary (sent unsolicited by sellside, includes MiscFees and NetMoney)',
  },
  {
    name: 'WarehouseRecap',
    id: '794004',
    value: '5',
    sort: 4,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 794,
    type: 'int',
    codeSet: 'AllocReportTypeCodeSet',
    description: 'Warehouse recap',
  },
  {
    name: 'RequestToIntermediary',
    id: '794005',
    value: '8',
    sort: 5,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 794,
    type: 'int',
    codeSet: 'AllocReportTypeCodeSet',
    description: 'Request to intermediary',
  },
  {
    name: 'Accept',
    id: '794006',
    value: '9',
    sort: 6,
    added: 'FIX.4.4',
    addedEP: '5',
    deprecated: 'FIX.5.0SP2',
    deprecatedEP: '118',
    tag: 794,
    type: 'int',
    codeSet: 'AllocReportTypeCodeSet',
    description: 'Accept',
  },
  {
    name: 'Reject',
    id: '794007',
    value: '10',
    sort: 7,
    added: 'FIX.4.4',
    addedEP: '5',
    deprecated: 'FIX.5.0SP2',
    deprecatedEP: '118',
    tag: 794,
    type: 'int',
    codeSet: 'AllocReportTypeCodeSet',
    description: 'Reject',
  },
  {
    name: 'AcceptPending',
    id: '794008',
    value: '11',
    sort: 8,
    added: 'FIX.4.4',
    addedEP: '5',
    deprecated: 'FIX.5.0SP2',
    deprecatedEP: '118',
    tag: 794,
    type: 'int',
    codeSet: 'AllocReportTypeCodeSet',
    description: 'Accept Pending',
  },
  {
    name: 'Complete',
    id: '794009',
    value: '12',
    sort: 9,
    added: 'FIX.4.4',
    addedEP: '5',
    deprecated: 'FIX.5.0SP2',
    deprecatedEP: '118',
    tag: 794,
    type: 'int',
    codeSet: 'AllocReportTypeCodeSet',
    description: 'Complete',
  },
  {
    name: 'ReversePending',
    id: '794010',
    value: '14',
    sort: 10,
    added: 'FIX.4.4',
    addedEP: '5',
    deprecated: 'FIX.5.0SP2',
    deprecatedEP: '118',
    tag: 794,
    type: 'int',
    codeSet: 'AllocReportTypeCodeSet',
    description: 'Reverse Pending',
  },
  {
    name: 'Giveup',
    id: '794011',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 794,
    type: 'int',
    codeSet: 'AllocReportTypeCodeSet',
    description: 'Give-up',
  },
  {
    name: 'Takeup',
    id: '794012',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 794,
    type: 'int',
    codeSet: 'AllocReportTypeCodeSet',
    description: 'Take-up',
  },
  {
    name: 'Reversal',
    id: '794013',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 794,
    type: 'int',
    codeSet: 'AllocReportTypeCodeSet',
    description: 'Reversal',
  },
  {
    name: 'Alleged',
    id: '794014',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 794,
    type: 'int',
    codeSet: 'AllocReportTypeCodeSet',
    description: 'Alleged reversal',
  },
  {
    name: 'SubAllocationGiveup',
    id: '794015',
    value: '19',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 794,
    type: 'int',
    codeSet: 'AllocReportTypeCodeSet',
    description: 'Sub-allocation give-up',
  },
  {
    name: 'OriginalDetailsIncomplete',
    id: '796001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 796,
    type: 'int',
    codeSet: 'AllocCancReplaceReasonCodeSet',
    description: 'Original details incomplete/incorrect',
  },
  {
    name: 'ChangeInUnderlyingOrderDetails',
    id: '796002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 796,
    type: 'int',
    codeSet: 'AllocCancReplaceReasonCodeSet',
    description: 'Change in underlying order details',
  },
  {
    name: 'CancelledByGiveupFirm',
    id: '796003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 796,
    type: 'int',
    codeSet: 'AllocCancReplaceReasonCodeSet',
    description: 'Cancelled by give-up firm',
  },
  {
    name: 'Other',
    id: '796004',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    tag: 796,
    type: 'int',
    codeSet: 'AllocCancReplaceReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'CarriedCustomerSide',
    id: '798001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 798,
    type: 'int',
    codeSet: 'AllocAccountTypeCodeSet',
    description: 'Account is carried pn customer side of books',
  },
  {
    name: 'CarriedNonCustomerSide',
    id: '798002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 798,
    type: 'int',
    codeSet: 'AllocAccountTypeCodeSet',
    description: 'Account is carried on non-customer side of books',
  },
  {
    name: 'HouseTrader',
    id: '798003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    tag: 798,
    type: 'int',
    codeSet: 'AllocAccountTypeCodeSet',
    description: 'House trader',
  },
  {
    name: 'FloorTrader',
    id: '798004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    tag: 798,
    type: 'int',
    codeSet: 'AllocAccountTypeCodeSet',
    description: 'Floor trader',
  },
  {
    name: 'CarriedNonCustomerSideCrossMargined',
    id: '798005',
    value: '6',
    sort: 5,
    added: 'FIX.4.4',
    tag: 798,
    type: 'int',
    codeSet: 'AllocAccountTypeCodeSet',
    description: 'Account is carried on non-customer side of books and is cross margined',
  },
  {
    name: 'HouseTraderCrossMargined',
    id: '798006',
    value: '7',
    sort: 6,
    added: 'FIX.4.4',
    tag: 798,
    type: 'int',
    codeSet: 'AllocAccountTypeCodeSet',
    description: 'Account is house trader and is cross margined',
  },
  {
    name: 'JointBackOfficeAccount',
    id: '798007',
    value: '8',
    sort: 7,
    added: 'FIX.4.4',
    tag: 798,
    type: 'int',
    codeSet: 'AllocAccountTypeCodeSet',
    description: 'Joint back office account (JBO)',
  },
  {
    name: 'Firm',
    id: '803001',
    value: '1',
    sort: 0,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Firm',
  },
  {
    name: 'Person',
    id: '803002',
    value: '2',
    sort: 1,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Person',
  },
  {
    name: 'System',
    id: '803003',
    value: '3',
    sort: 2,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'System',
  },
  {
    name: 'Application',
    id: '803004',
    value: '4',
    sort: 3,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Application',
  },
  {
    name: 'FullLegalNameOfFirm',
    id: '803005',
    value: '5',
    sort: 4,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Full legal name of firm',
  },
  {
    name: 'PostalAddress',
    id: '803006',
    value: '6',
    sort: 5,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Postal address',
  },
  {
    name: 'PhoneNumber',
    id: '803007',
    value: '7',
    sort: 6,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Phone number',
  },
  {
    name: 'EmailAddress',
    id: '803008',
    value: '8',
    sort: 7,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Email address',
  },
  {
    name: 'ContactName',
    id: '803009',
    value: '9',
    sort: 8,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Contact name',
  },
  {
    name: 'SecuritiesAccountNumber',
    id: '803010',
    value: '10',
    sort: 9,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Securities account number (for settlement instructions)',
  },
  {
    name: 'RegistrationNumber',
    id: '803011',
    value: '11',
    sort: 10,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Registration number (for settlement instructions and confirmations)',
  },
  {
    name: 'RegisteredAddressForConfirmation',
    id: '803012',
    value: '12',
    sort: 11,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Registered address (for confirmation purposes)',
  },
  {
    name: 'RegulatoryStatus',
    id: '803013',
    value: '13',
    sort: 12,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Regulatory status (for confirmation purposes)',
  },
  {
    name: 'RegistrationName',
    id: '803014',
    value: '14',
    sort: 13,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Registration name (for settlement instructions)',
  },
  {
    name: 'CashAccountNumber',
    id: '803015',
    value: '15',
    sort: 14,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Cash account number (for settlement instructions)',
  },
  {
    name: 'BIC',
    id: '803016',
    value: '16',
    sort: 15,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'BIC',
  },
  {
    name: 'CSDParticipantMemberCode',
    id: '803017',
    value: '17',
    sort: 16,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'CSD participant member code',
  },
  {
    name: 'RegisteredAddress',
    id: '803018',
    value: '18',
    sort: 17,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Registered address',
  },
  {
    name: 'FundAccountName',
    id: '803019',
    value: '19',
    sort: 18,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Fund account name',
  },
  {
    name: 'TelexNumber',
    id: '803020',
    value: '20',
    sort: 19,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Telex number',
  },
  {
    name: 'FaxNumber',
    id: '803021',
    value: '21',
    sort: 20,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Fax number',
  },
  {
    name: 'SecuritiesAccountName',
    id: '803022',
    value: '22',
    sort: 21,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Securities account name',
  },
  {
    name: 'CashAccountName',
    id: '803023',
    value: '23',
    sort: 22,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Cash account name',
  },
  {
    name: 'Department',
    id: '803024',
    value: '24',
    sort: 23,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Department',
  },
  {
    name: 'LocationDesk',
    id: '803025',
    value: '25',
    sort: 24,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Location desk',
  },
  {
    name: 'PositionAccountType',
    id: '803026',
    value: '26',
    sort: 25,
    added: 'FIX.4.4',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Position account type',
  },
  {
    name: 'SecurityLocateID',
    id: '803027',
    value: '27',
    sort: 26,
    added: 'FIX.4.4',
    addedEP: '1',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Security locate ID',
  },
  {
    name: 'MarketMaker',
    id: '803028',
    value: '28',
    sort: 27,
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Market maker',
  },
  {
    name: 'EligibleCounterparty',
    id: '803029',
    value: '29',
    sort: 28,
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Eligible counterparty',
  },
  {
    name: 'ProfessionalClient',
    id: '803030',
    value: '30',
    sort: 29,
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Professional client',
  },
  {
    name: 'Location',
    id: '803031',
    value: '31',
    sort: 30,
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Location',
  },
  {
    name: 'ExecutionVenue',
    id: '803032',
    value: '32',
    sort: 31,
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Execution venue',
  },
  {
    name: 'CurrencyDeliveryIdentifier',
    id: '803033',
    value: '33',
    sort: 32,
    added: 'FIX.5.0',
    addedEP: '44',
    updated: 'FIX.5.0SP2',
    updatedEP: '103',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Currency delivery identifier',
  },
  {
    name: 'AddressCity',
    id: '803034',
    value: '34',
    sort: 33,
    added: 'FIX.5.0SP2',
    addedEP: '103',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Address City',
  },
  {
    name: 'AddressStateOrProvince',
    id: '803035',
    value: '35',
    sort: 34,
    added: 'FIX.5.0SP2',
    addedEP: '103',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Address State/Province',
  },
  {
    name: 'AddressPostalCode',
    id: '803036',
    value: '36',
    sort: 35,
    added: 'FIX.5.0SP2',
    addedEP: '103',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Address Postal Code',
  },
  {
    name: 'AddressStreet',
    id: '803037',
    value: '37',
    sort: 36,
    added: 'FIX.5.0SP2',
    addedEP: '103',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Address Street',
  },
  {
    name: 'AddressISOCountryCode',
    id: '803038',
    value: '38',
    sort: 37,
    added: 'FIX.5.0SP2',
    addedEP: '103',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Address Country (ISO country code)',
  },
  {
    name: 'ISOCountryCode',
    id: '803039',
    value: '39',
    sort: 38,
    added: 'FIX.5.0SP2',
    addedEP: '103',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'ISO country code',
  },
  {
    name: 'MarketSegment',
    id: '803040',
    value: '40',
    sort: 39,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    updated: 'FIX.5.0SP2',
    updatedEP: '187',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Market segment',
  },
  {
    name: 'CustomerAccountType',
    id: '803041',
    value: '41',
    sort: 41,
    added: 'FIX.5.0SP2',
    addedEP: '155',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Customer account type',
  },
  {
    name: 'OmnibusAccount',
    id: '803042',
    value: '42',
    sort: 42,
    added: 'FIX.5.0SP2',
    addedEP: '155',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Omnibus account',
  },
  {
    name: 'FundsSegregationType',
    id: '803043',
    value: '43',
    sort: 43,
    added: 'FIX.5.0SP2',
    addedEP: '155',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Funds segregation type',
  },
  {
    name: 'GuaranteeFund',
    id: '803044',
    value: '44',
    sort: 44,
    added: 'FIX.5.0SP2',
    addedEP: '157',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Guarantee fund\n\nIdentifies a guarantee fund related to an account. Used when one account has multiple funds of collateral, each guaranteeing different positions. Can be used for PartyRole(452) = Customer Account(24).',
  },
  {
    name: 'SwapDealer',
    id: '803045',
    value: '45',
    sort: 45,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '192',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Swap dealer\n\nThe US regulator\'s defined term for identifying the trade counterparty as "any person who holds itself out as a dealer in swaps, makes a market in swaps, regularly enters into swaps with counterparties as an ordinary course of business for its own account, or engages in activity causing itself to be commonly known in the trade as a dealer or market maker in swaps".',
  },
  {
    name: 'MajorParticipant',
    id: '803046',
    value: '46',
    sort: 46,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '187',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Major participant\n\nWhen PartySubID(523)=Y the counterparty is not the swap dealer but is a major swap participant as defined in the regulations.',
  },
  {
    name: 'FinancialEntity',
    id: '803047',
    value: '47',
    sort: 47,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '208',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Financial entity\n\nWhen PartySubID(523)=Y the counterparty is neither a swap dealer nor a major swap participant but is a financial entity as defined in the regulations.',
  },
  {
    name: 'USPerson',
    id: '803048',
    value: '48',
    sort: 48,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'U.S. person\n\nA legal term referring to any U.S. person or legal entity anywhere in the world that should be taxed under U.S. law.',
  },
  {
    name: 'ReportingEntityIndicator',
    id: '803049',
    value: '49',
    sort: 49,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '229',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Reporting entity indicator\n\nIndicates the entity obligated or delegated to report to their regulator, a non-regulatory agency or data repository. Set PartySubID(523)=Y if true.',
  },
  {
    name: 'ElectedClearingRequirementException',
    id: '803050',
    value: '50',
    sort: 50,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Elected clearing requirement exception',
  },
  {
    name: 'BusinessCenter',
    id: '803051',
    value: '51',
    sort: 51,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Business center\n\n',
  },
  {
    name: 'ReferenceText',
    id: '803052',
    value: '52',
    sort: 52,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Reference text',
  },
  {
    name: 'ShortMarkingExemptAccount',
    id: '803053',
    value: '53',
    sort: 53,
    added: 'FIX.5.0SP2',
    addedEP: '164',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Short-marking exempt account',
  },
  {
    name: 'ParentFirmIdentifier',
    id: '803054',
    value: '54',
    sort: 54,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      "Parent firm identifier\n\nImplementation-specific identifier of this party's parent entity.",
  },
  {
    name: 'ParentFirmName',
    id: '803055',
    value: '55',
    sort: 55,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: "Parent firm name\n\nFull name of this party's parent entity.",
  },
  {
    name: 'DealIdentifier',
    id: '803056',
    value: '56',
    sort: 56,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Deal identifier\n\nThe internal identifier assigned to the trade by this party, particularly by a Clearing Organization.',
  },
  {
    name: 'SystemTradeID',
    id: '803057',
    value: '57',
    sort: 57,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'System trade identifier',
  },
  {
    name: 'SystemTradeSubID',
    id: '803058',
    value: '58',
    sort: 58,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'System trade sub-identifier',
  },
  {
    name: 'FCMCode',
    id: '803059',
    value: '59',
    sort: 59,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      "Futures Commission Merchant (FCM) code\n\nThe FCM's code or identifier in relation to the PartyRole(452). For example, if PartyRole(452) is the exchange or clearinghouse, the FCM code/ID specified in PartySubID(523) is the FCM's identifier at the exchange or clearinghouse.",
  },
  {
    name: 'DlvryTrmlCode',
    id: '803060',
    value: '60',
    sort: 60,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Delivery terminal customer account/code\n\nUsually used for gas delivery to identify whose account the gas is allocated to at the delivery terminal. Often referred to as "HUB" code.',
  },
  {
    name: 'VolntyRptEntity',
    id: '803061',
    value: '61',
    sort: 61,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Voluntary reporting entity\n\nThe entity voluntarily reporting the trade to the regulator. Set PartySubID(523)=Y if true.',
  },
  {
    name: 'RptObligJursdctn',
    id: '803062',
    value: '62',
    sort: 62,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Reporting obligation jurisdiction\n\nFor a trade that falls under multiple jurisdictions this may be used to identify, through PartySubID(523), the reporting jurisdiction to which the party is obligated to report.',
  },
  {
    name: 'VolntyRptJursdctn',
    id: '803063',
    value: '63',
    sort: 63,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Voluntary reporting jurisdiction\n\nFor a trade that falls under multiple jurisdictions this may be used to identify, through PartySubID(523), the regulatory jurisdiction to which the party is submitting a voluntary report.',
  },
  {
    name: 'CompanyActivities',
    id: '803064',
    value: '64',
    sort: 64,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Company activities\n\nFor regulatory reporting. ID values include: A = Assurance undertaking authorized in accordance with Directive 2002/83/EC C=Credit institution authorized in accordance with Directive 2006/48/EC F=Investment firm in accordance with Directive 2004/39/EC I=Insurance undertaking authorized in accordance with Directive 73/239/EC L=Alternative investment fund managed by AIFMs authorized or registered in accordance with Directive 2011/61/EC O=Institution for occupational retirement provision within the meaning of Article 6(a0 of Directive 2003/41/EC R=Reinsurance undertaking authorized in accordance with Directive 2005/68/EC U=UCITS and its management company, authorized in accordance with Directive 2009/65/EC or blank in case of coverage by LEI or in case of non-financial counterparties.\n\nIn the context of EU SFTR reporting use the appropriate 4- or 1-character code noted in the regulations. See SFTR ITS "Commission Implementing Regulation (EU) 2019/363" Annexes 1 and 2 for values.',
  },
  {
    name: 'EEAreaDomiciled',
    id: '803065',
    value: '65',
    sort: 65,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'European Economic Area domiciled\n\nID values: Y or N',
  },
  {
    name: 'ContractLinked',
    id: '803066',
    value: '66',
    sort: 66,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Contract linked to commercial or treasury financing for this counterparty\n\nID values: Y or N',
  },
  {
    name: 'ContractAbove',
    id: '803067',
    value: '67',
    sort: 67,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Contract above clearing threshold for this counterparty\n\nID values: Y or N',
  },
  {
    name: 'VolntyRptPty',
    id: '803068',
    value: '68',
    sort: 68,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Voluntary reporting party\n\nWhen PartySubID(523)=Y, identifies that the trading party is reporting voluntarily when VoluntaryRegulatoryReport(1935)=Y.',
  },
  {
    name: 'EndUser',
    id: '803069',
    value: '69',
    sort: 69,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'End user\n\nWhen PartySubID(523)=Y, the counterparty is neither the swap dealer, major swap participant nor financial entity as defined in the regulations.',
  },
  {
    name: 'LocationOrJurisdiction',
    id: '803070',
    value: '70',
    sort: 70,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    updated: 'FIX.5.0SP2',
    updatedEP: '193',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Location or jurisdiction\n\nOne or more instances may be used in combination with PartySubIDType(803) = 49 (Reporting entity indicator) or 102 (Data repository) to identify the jurisdiction, countries, regions or provinces for which the party is a reporting entity or data repository when that characteristic is ambiguous or where there are multiple locations. The party sub-ID value is either a jurisdiction acronym, a 2-character ISO 3166 country code, or a hyphenated combination of the country code and the standard post-office abbreviation for province, state or region if necessary. E.g. "US" for United States or "CA-QC" for Quebec Canada.',
  },
  {
    name: 'DerivativesDealer',
    id: '803071',
    value: '71',
    sort: 71,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Derivatives dealer\n\nIndicates whether the party is a derivatives dealer or not (Y/N). The Canadian regulator\'s defined term for identifying the trade counterparty as "a person or company engaging in or holding himself, herself or itself out as engaging in the business of trading in derivatives in Ontario as principal or agent".',
  },
  {
    name: 'Domicile',
    id: '803072',
    value: '72',
    sort: 72,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Domicile\n\nCountry and optionally province, state or region of domicile. The party sub-ID value is either a 2-character ISO 3166 country code or a hyphenated combination of the country code and the standard post-office abbreviation of province, state or region if necessary. E.g. "US" for United States or "CA-QC" for Quebec Canada.',
  },
  {
    name: 'ExemptFromRecognition',
    id: '803073',
    value: '73',
    sort: 73,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Exempt from recognition\n\nUsed with party role 21 "Clearing Organization" to indicate exemption (Y/N). Identifies a clearing agency as exempt from oversight in Ontario, i.e. one that 1) only provides limited services and does not present significant risks or 2) is foreign-based, indends to operate in Ontario but is subject to regulatory oversight in another jurisdiction.',
  },
  {
    name: 'Payer',
    id: '803074',
    value: '74',
    sort: 74,
    added: 'FIX.5.0SP2',
    addedEP: '203',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      "Payer\n\nIdentifies the party as the payer of a particular payment stream or bullet payment by quoting the stream's StreamDesc(40051) (or LegStreamDesc(40243) or UnderlyingStreamDesc(40542)) or payment's PaymentDesc(43087) in the associated party sub-identifier field.",
  },
  {
    name: 'Receiver',
    id: '803075',
    value: '75',
    sort: 75,
    added: 'FIX.5.0SP2',
    addedEP: '203',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      "Receiver\n\nIdentifies the party as the receiver of a particular payment stream or bullet payment by quoting the stream's StreamDesc(40051) (or LegStreamDesc(40243) or UnderlyingStreamDesc(40542)) or payment's PaymentDesc(43087) in the associated party sub-identifier field.",
  },
  {
    name: 'SystematicInternaliser',
    id: '803076',
    value: '76',
    sort: 76,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Systematic Internaliser (SI)\n\nIn the context of ESMA reporting, this is used to indicate whether the specified party is a Systematic Internaliser or not for the security defined in the Instrument component (Y/N).',
  },
  {
    name: 'PublishingEntityIndicator',
    id: '803077',
    value: '77',
    sort: 77,
    added: 'FIX.5.0SP2',
    addedEP: '229',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Publishing entity indicator\n\nIndicates the entity obligated or delegated to publish to the market. Set PartySubID(523)=Y if true.',
  },
  {
    name: 'FirstName',
    id: '803078',
    value: '78',
    sort: 78,
    added: 'FIX.5.0SP2',
    addedEP: '232',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'First name\n\nThe first name(s) of a natural person. If multiple names, separate entries by a comma.',
  },
  {
    name: 'Surname',
    id: '803079',
    value: '79',
    sort: 79,
    added: 'FIX.5.0SP2',
    addedEP: '232',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Surname\n\nThe surname(s) or lastname(s) of a natural person. If multiple names, separate entries by a comma.',
  },
  {
    name: 'DateOfBirth',
    id: '803080',
    value: '80',
    sort: 80,
    added: 'FIX.5.0SP2',
    addedEP: '232',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Date of birth\n\nThe date of birth of a natural person in the format YYYYMMDD.',
  },
  {
    name: 'OrderTransmittingFirm',
    id: '803081',
    value: '81',
    sort: 81,
    added: 'FIX.5.0SP2',
    addedEP: '232',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Order transmitting firm\n\nIdentifies whether the party specified in PartyID(448) is the firm that transmitted the order. In the context of RTS 22 Article 4, when "true" the PartySubID(523)=Y shall be set "by the transmitting firm within the transmitting firm\'s report where conditions for transmission specified in Article 4 were not satisfied."',
  },
  {
    name: 'OrderTransmittingFirmBuyer',
    id: '803082',
    value: '82',
    sort: 82,
    added: 'FIX.5.0SP2',
    addedEP: '232',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Order transmitting firm for buyer\n\nIdentifies the firm that transmitted the order for the buyer. In the context of ESMA RTS 22, PartySubID(523)=Y is used to indicate the firm identified in PartyID(448) is the firm that transmitted the order for the buyer. "This shall be populated by the receiving firm within the receiving firm\'s report with the identification code provided by the transmitting firm."',
  },
  {
    name: 'OrderTransmitterSeller',
    id: '803083',
    value: '83',
    sort: 83,
    added: 'FIX.5.0SP2',
    addedEP: '232',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Order transmitter for seller\n\nIdentifies the order transmitting firm for the seller. In the context of ESMA RTS 22, PartySubID(523)=Y is used to indicate the firm identified in PartyID(448) is the firm that transmitted the order for the seller. "This shall be populated by the receiving firm within the receiving firm\'s report with the identification code provided by the transmitting firm."',
  },
  {
    name: 'LegalEntityIdentifier',
    id: '803084',
    value: '84',
    sort: 84,
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description: 'Legal Entity Identifier (ISO 17442) LEI',
  },
  {
    name: 'SubSectorClassification',
    id: '803085',
    value: '85',
    sort: 85,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Sub-sector classification\n\nSupplemental to party sub-ID type "64" (Company activities) for regulatory reporting. For EU SFTR reporting use the appropriate 4-character code noted in the regulations applying the conditional association rules. See SFTR ITS "Commission Implementing Regulation (EU) 2019/363" Annexes 1 and 2 for values.',
  },
  {
    name: 'PartySide',
    id: '803086',
    value: '86',
    sort: 86,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Party side\n\nMay be used, when appropriate, to explicitly indicate the transaction side of the party, e.g. Buyer, Seller, Lender, Borrower, Maker, Taker, etc. in the ID. In the context of EU SFTR reporting, use values as required by SFTR, "GIVE" and "TAKE" in the ID, to identify collateral giver and taker.',
  },
  {
    name: 'LegalRegistrationCountry',
    id: '803087',
    value: '87',
    sort: 87,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 803,
    type: 'int',
    codeSet: 'PartySubIDTypeCodeSet',
    description:
      'Legal registration country\n\nISO Country Code where the registered office of the party is located as specified in the LEI reference data.',
  },
  {
    name: 'PendingAccept',
    id: '808001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 808,
    type: 'int',
    codeSet: 'AllocIntermedReqTypeCodeSet',
    description: 'Pending Accept',
  },
  {
    name: 'PendingRelease',
    id: '808002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 808,
    type: 'int',
    codeSet: 'AllocIntermedReqTypeCodeSet',
    description: 'Pending Release',
  },
  {
    name: 'PendingReversal',
    id: '808003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    tag: 808,
    type: 'int',
    codeSet: 'AllocIntermedReqTypeCodeSet',
    description: 'Pending Reversal',
  },
  {
    name: 'Accept',
    id: '808004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    tag: 808,
    type: 'int',
    codeSet: 'AllocIntermedReqTypeCodeSet',
    description: 'Accept',
  },
  {
    name: 'BlockLevelReject',
    id: '808005',
    value: '5',
    sort: 5,
    added: 'FIX.4.4',
    tag: 808,
    type: 'int',
    codeSet: 'AllocIntermedReqTypeCodeSet',
    description: 'Block Level Reject',
  },
  {
    name: 'AccountLevelReject',
    id: '808006',
    value: '6',
    sort: 6,
    added: 'FIX.4.4',
    tag: 808,
    type: 'int',
    codeSet: 'AllocIntermedReqTypeCodeSet',
    description: 'Account Level Reject',
  },
  {
    name: 'NoActionTaken',
    id: '814001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 814,
    type: 'int',
    codeSet: 'ApplQueueResolutionCodeSet',
    description: 'No Action Taken',
  },
  {
    name: 'QueueFlushed',
    id: '814002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 814,
    type: 'int',
    codeSet: 'ApplQueueResolutionCodeSet',
    description: 'Queue Flushed',
  },
  {
    name: 'OverlayLast',
    id: '814003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 814,
    type: 'int',
    codeSet: 'ApplQueueResolutionCodeSet',
    description: 'Overlay Last',
  },
  {
    name: 'EndSession',
    id: '814004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 814,
    type: 'int',
    codeSet: 'ApplQueueResolutionCodeSet',
    description: 'End Session',
  },
  {
    name: 'NoActionTaken',
    id: '815001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 815,
    type: 'int',
    codeSet: 'ApplQueueActionCodeSet',
    description: 'No Action Taken',
  },
  {
    name: 'QueueFlushed',
    id: '815002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 815,
    type: 'int',
    codeSet: 'ApplQueueActionCodeSet',
    description: 'Queue Flushed',
  },
  {
    name: 'OverlayLast',
    id: '815003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 815,
    type: 'int',
    codeSet: 'ApplQueueActionCodeSet',
    description: 'Overlay Last',
  },
  {
    name: 'EndSession',
    id: '815004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 815,
    type: 'int',
    codeSet: 'ApplQueueActionCodeSet',
    description: 'End Session',
  },
  {
    name: 'NoAveragePricing',
    id: '819001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 819,
    type: 'int',
    codeSet: 'AvgPxIndicatorCodeSet',
    description: 'No average pricing',
  },
  {
    name: 'Trade',
    id: '819002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 819,
    type: 'int',
    codeSet: 'AvgPxIndicatorCodeSet',
    description:
      'Trade is part of an average price group identified by the AvgPxGroupID(1731)',
  },
  {
    name: 'LastTrade',
    id: '819003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '234',
    tag: 819,
    type: 'int',
    codeSet: 'AvgPxIndicatorCodeSet',
    description:
      'Last trade of the average price group identified by the AvgPxGroupID(1731)',
  },
  {
    name: 'NotionalValueAveragePxGroupTrade',
    id: '819004',
    value: '3',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '239',
    tag: 819,
    type: 'int',
    codeSet: 'AvgPxIndicatorCodeSet',
    description:
      'Trade is part of a notional value average price group\n\nA notional value average price (NVAP) group is effectively closed and available for allocation as long as the NVAP of the group is non-zero.',
  },
  {
    name: 'AveragePricedTrade',
    id: '819005',
    value: '4',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '240',
    tag: 819,
    type: 'int',
    codeSet: 'AvgPxIndicatorCodeSet',
    description: 'Trade is average priced',
  },
  {
    name: 'AllocationNotRequired',
    id: '826001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 826,
    type: 'int',
    codeSet: 'TradeAllocIndicatorCodeSet',
    description: 'Allocation not required',
  },
  {
    name: 'AllocationRequired',
    id: '826002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 826,
    type: 'int',
    codeSet: 'TradeAllocIndicatorCodeSet',
    description:
      'Allocation required (give-up trade) allocation information not provided (incomplete)',
  },
  {
    name: 'UseAllocationProvidedWithTheTrade',
    id: '826003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 826,
    type: 'int',
    codeSet: 'TradeAllocIndicatorCodeSet',
    description: 'Use allocation provided with the trade',
  },
  {
    name: 'AllocationGiveUpExecutor',
    id: '826004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 826,
    type: 'int',
    codeSet: 'TradeAllocIndicatorCodeSet',
    description: 'Allocation give-up executor',
  },
  {
    name: 'AllocationFromExecutor',
    id: '826005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 826,
    type: 'int',
    codeSet: 'TradeAllocIndicatorCodeSet',
    description: 'Allocation from executor',
  },
  {
    name: 'AllocationToClaimAccount',
    id: '826006',
    value: '5',
    sort: 6,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 826,
    type: 'int',
    codeSet: 'TradeAllocIndicatorCodeSet',
    description: 'Allocation to claim account',
  },
  {
    name: 'TradeSplit',
    id: '826007',
    value: '6',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 826,
    type: 'int',
    codeSet: 'TradeAllocIndicatorCodeSet',
    description: 'Trade split',
  },
  {
    name: 'ExpireOnTradingSessionClose',
    id: '827001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 827,
    type: 'int',
    codeSet: 'ExpirationCycleCodeSet',
    description: 'Expire on trading session close (default)',
  },
  {
    name: 'ExpireOnTradingSessionOpen',
    id: '827002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 827,
    type: 'int',
    codeSet: 'ExpirationCycleCodeSet',
    description: 'Expire on trading session open',
  },
  {
    name: 'SpecifiedExpiration',
    id: '827003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '42',
    tag: 827,
    type: 'int',
    codeSet: 'ExpirationCycleCodeSet',
    description:
      'Trading eligibility expiration specified in the date and time fields [EventDate(866) and EventTime(1145)] associated with EventType(865)=7(Last Eligible Trade Date)',
  },
  {
    name: 'RegularTrade',
    id: '828001',
    value: '0',
    sort: 0,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Regular trade',
  },
  {
    name: 'BlockTrade',
    id: '828002',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Block trade',
  },
  {
    name: 'EFP',
    id: '828003',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Exchange for physical (EFP)',
  },
  {
    name: 'Transfer',
    id: '828004',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Transfer',
  },
  {
    name: 'LateTrade',
    id: '828005',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Late trade',
  },
  {
    name: 'TTrade',
    id: '828006',
    value: '5',
    sort: 5,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'T trade',
  },
  {
    name: 'WeightedAveragePriceTrade',
    id: '828007',
    value: '6',
    sort: 6,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Weighted average price trade',
  },
  {
    name: 'BunchedTrade',
    id: '828008',
    value: '7',
    sort: 7,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Bunched trade',
  },
  {
    name: 'LateBunchedTrade',
    id: '828009',
    value: '8',
    sort: 8,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Late bunched trade',
  },
  {
    name: 'PriorReferencePriceTrade',
    id: '828010',
    value: '9',
    sort: 9,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Prior reference price trade',
  },
  {
    name: 'AfterHoursTrade',
    id: '828011',
    value: '10',
    sort: 10,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'After hours trade',
  },
  {
    name: 'ExchangeForRisk',
    id: '828012',
    value: '11',
    sort: 11,
    added: 'FIX.4.4',
    addedEP: '5',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Exchange for risk (EFR)',
  },
  {
    name: 'ExchangeForSwap',
    id: '828013',
    value: '12',
    sort: 12,
    added: 'FIX.4.4',
    addedEP: '5',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Exchange for swap (EFS)',
  },
  {
    name: 'ExchangeOfFuturesFor',
    id: '828014',
    value: '13',
    sort: 13,
    added: 'FIX.4.4',
    addedEP: '5',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description:
      'Exchange of futures for in market futures (EFM)\n\nFor example full sized for mini.',
  },
  {
    name: 'ExchangeOfOptionsForOptions',
    id: '828015',
    value: '14',
    sort: 14,
    added: 'FIX.4.4',
    addedEP: '5',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Exchange of options for options (EOO)',
  },
  {
    name: 'TradingAtSettlement',
    id: '828016',
    value: '15',
    sort: 15,
    added: 'FIX.4.4',
    addedEP: '5',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Trading at settlement',
  },
  {
    name: 'AllOrNone',
    id: '828017',
    value: '16',
    sort: 16,
    added: 'FIX.4.4',
    addedEP: '5',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'All or none',
  },
  {
    name: 'FuturesLargeOrderExecution',
    id: '828018',
    value: '17',
    sort: 17,
    added: 'FIX.4.4',
    addedEP: '5',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Futures large order execution',
  },
  {
    name: 'ExchangeOfFuturesForFutures',
    id: '828019',
    value: '18',
    sort: 18,
    added: 'FIX.4.4',
    addedEP: '5',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Exchange of futures for external market futures (EFF)',
  },
  {
    name: 'OptionInterimTrade',
    id: '828020',
    value: '19',
    sort: 19,
    added: 'FIX.4.4',
    addedEP: '5',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Option interim trade',
  },
  {
    name: 'OptionCabinetTrade',
    id: '828021',
    value: '20',
    sort: 20,
    added: 'FIX.4.4',
    addedEP: '5',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Option cabinet trade',
  },
  {
    name: 'PrivatelyNegotiatedTrades',
    id: '828022',
    value: '22',
    sort: 21,
    added: 'FIX.4.4',
    addedEP: '19',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Privately negotiated trade',
  },
  {
    name: 'SubstitutionOfFuturesForForwards',
    id: '828023',
    value: '23',
    sort: 22,
    added: 'FIX.4.4',
    addedEP: '19',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Substitution of futures for forwards',
  },
  {
    name: 'NonStandardSettlement',
    id: '828024',
    value: '48',
    sort: 48,
    added: 'FIX.5.0',
    addedEP: '47',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Non-standard settlement',
  },
  {
    name: 'DerivativeRelatedTransaction',
    id: '828025',
    value: '49',
    sort: 49,
    added: 'FIX.5.0',
    addedEP: '47',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Derivative related transaction',
  },
  {
    name: 'PortfolioTrade',
    id: '828026',
    value: '50',
    sort: 50,
    added: 'FIX.5.0',
    addedEP: '47',
    updated: 'FIX.Latest',
    updatedEP: '268',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description:
      'Portfolio trade\n\nIdentifies a collection/basket of trades. In the context of bonds (e.g. corporate bonds) these are transacted as a single trade at an aggregate price for the entire portfolio and may be traded all-or-none or most-or-none depending on bilateral agreement.\n\nIn the context of ESMA RTS 1 Article 2(b), may be used to refer to portfolio trades to distinguish between addressable and non-addressable volume.\n\nIn the context of Market Model Typology (MMT), use of this value applies to SecondaryTrdType(855) or TertiaryTrdType(2896), and when used for MMT market data publication requires MDEntryType(269) = 2 (Trade).',
  },
  {
    name: 'VolumeWeightedAverageTrade',
    id: '828027',
    value: '51',
    sort: 51,
    added: 'FIX.5.0',
    addedEP: '47',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Volume weighted average trade',
  },
  {
    name: 'ExchangeGrantedTrade',
    id: '828028',
    value: '52',
    sort: 52,
    added: 'FIX.5.0',
    addedEP: '47',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Exchange granted trade',
  },
  {
    name: 'RepurchaseAgreement',
    id: '828029',
    value: '53',
    sort: 53,
    added: 'FIX.5.0',
    addedEP: '47',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Repurchase agreement',
  },
  {
    name: 'OTC',
    id: '828030',
    value: '54',
    sort: 54,
    added: 'FIX.5.0',
    addedEP: '47',
    updated: 'FIX.5.0SP2',
    updatedEP: '177',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description:
      'OTC\n\nTrade executed off-market. In the context of CFTC regulatory reporting for swaps, it is a large notional off-facility swap. In the context of MiFID transparency reporting rules this is used to report, into an exchange, deals made outside exchange rules.',
  },
  {
    name: 'ExchangeBasisFacility',
    id: '828031',
    value: '55',
    sort: 55,
    added: 'FIX.5.0',
    addedEP: '55',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Exchange basis facility (EBF)',
  },
  {
    name: 'OpeningTrade',
    id: '828032',
    value: '56',
    sort: 56,
    added: 'FIX.5.0SP2',
    addedEP: '104',
    updated: 'FIX.Latest',
    updatedEP: '283',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description:
      'Opening trade\n\nIdentifies a trade that resulted from the opening of a market. In the context of IIROC, this indicates a trade that occurred at the opening or the first trade of the day for a security.',
  },
  {
    name: 'NettedTrade',
    id: '828033',
    value: '57',
    sort: 57,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Netted trade',
  },
  {
    name: 'BlockSwapTrade',
    id: '828034',
    value: '58',
    sort: 58,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '177',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description:
      'Block swap trade\n\nBlock trade executed off-market or on a registered market. In the context of CFTC regulatory reporting for swaps, it is a swap executed according to SEF or DCM rules.',
  },
  {
    name: 'CreditEventTrade',
    id: '828035',
    value: '59',
    sort: 59,
    added: 'FIX.5.0SP2',
    addedEP: '165',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Credit event trade',
  },
  {
    name: 'SuccessionEventTrade',
    id: '828036',
    value: '60',
    sort: 60,
    added: 'FIX.5.0SP2',
    addedEP: '165',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Succession event trade',
  },
  {
    name: 'GiveUpGiveInTrade',
    id: '828037',
    value: '61',
    sort: 61,
    added: 'FIX.5.0SP2',
    addedEP: '163',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Give-up Give-in trade',
  },
  {
    name: 'DarkTrade',
    id: '828038',
    value: '62',
    sort: 62,
    added: 'FIX.5.0SP2',
    addedEP: '163',
    updated: 'FIX.Latest',
    updatedEP: '268',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description:
      'Dark trade\n\nIn the context of Market Model Typology (MMT), a dark trade might also come from a lit/hybrid book (e.g. when an aggressive lit order hits a resting dark order). The use of this value applies to TrdType(828), and when used for MMT market data publication requires MDEntryType(269) = 2 (Trade).',
  },
  {
    name: 'TechnicalTrade',
    id: '828039',
    value: '63',
    sort: 63,
    added: 'FIX.5.0SP2',
    addedEP: '163',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Technical trade',
  },
  {
    name: 'Benchmark',
    id: '828040',
    value: '64',
    sort: 64,
    added: 'FIX.5.0SP2',
    addedEP: '163',
    updated: 'FIX.Latest',
    updatedEP: '268',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description:
      'Benchmark\n\nIn the context of ESMA RTS 1 Article 2(a), may be used to refer to benchmark trades.\n\nIn the context of Market Model Typology (MMT), the "benchmark" price depends on a benchmark which has no current price but was derived from a time series such as a VWAP. The use of this value applies to SecondaryTrdType(855) or TertiaryTrdType(2896), and when used for MMT market data publication requires MDEntryType(269) = 2 (Trade).',
  },
  {
    name: 'PackageTrade',
    id: '828041',
    value: '65',
    sort: 65,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    updated: 'FIX.Latest',
    updatedEP: '277',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description:
      'Package trade\n\nMay be used to identify the pseudo-trade of a stream or collection of trades to be transacted, cleared and be reported as an atomic unit.\n\nIn the context of MiFIR RTS 1, this is the "CONT" flag.\n\nIn the context of MiFIR RTS 2 Article 1(1)(b), may be used to refer to package transactions (excluding exchange for physicals).\n\nIn the context of Market Model Typology (MMT), use of this value applies to SecondaryTrdType(855) or TertiaryTrdType(2896), and when used for MMT market data publication requires MDEntryType(269) = 2 (Trade).',
  },
  {
    name: 'RollTrade',
    id: '828042',
    value: '66',
    sort: 66,
    added: 'FIX.5.0SP2',
    addedEP: '258',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description:
      'Roll trade\n\nTrade is a roll from one contract that is about to expire to a new contract.',
  },
  {
    name: 'ClosingPriceTrade',
    id: '828043',
    value: '67',
    sort: 67,
    added: 'FIX.Latest',
    addedEP: '283',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description:
      'Closing price trade\n\nIdentifies a trade that uses the closing price of a market without resulting from the closing of this market. In the context of FCA policy statement PS23/4, this indicates a benchmark transaction executed using the market closing price and is the "CLSE" flag.',
  },
  {
    name: 'InterFundTransferTrade',
    id: '828044',
    value: '68',
    sort: 68,
    added: 'FIX.Latest',
    addedEP: '289',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description:
      'Inter-fund transfer trade\n\nAdministrative trade (non price-forming) related to the transfer of ownership between funds.',
  },
  {
    name: 'NetAssetValueCalculatedTrade',
    id: '828045',
    value: '69',
    sort: 69,
    added: 'FIX.Latest',
    addedEP: '289',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description:
      'Net asset value calculated trade\n\nTrade of a fund priced at the net asset value of its constituents. In the context of MiFIR RTS 1, this may be used for ETFs when the NAV price becomes available.',
  },
  {
    name: 'ErrorTrade',
    id: '828046',
    value: '24',
    sort: 24,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Error trade',
  },
  {
    name: 'SpecialCumDividend',
    id: '828047',
    value: '25',
    sort: 25,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Special cum dividend (CD)',
  },
  {
    name: 'SpecialExDividend',
    id: '828048',
    value: '26',
    sort: 26,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Special ex dividend (XD)',
  },
  {
    name: 'SpecialCumCoupon',
    id: '828049',
    value: '27',
    sort: 27,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Special cum coupon (CC)',
  },
  {
    name: 'SpecialExCoupon',
    id: '828050',
    value: '28',
    sort: 28,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Special ex coupon (XC)',
  },
  {
    name: 'CashSettlement',
    id: '828051',
    value: '29',
    sort: 29,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Cash settlement (CS)',
  },
  {
    name: 'SpecialPrice',
    id: '828052',
    value: '30',
    sort: 30,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Special price (SP)\n\nUsually net or all-in price.',
  },
  {
    name: 'GuaranteedDelivery',
    id: '828053',
    value: '31',
    sort: 31,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Guaranteed delivery (GD)',
  },
  {
    name: 'SpecialCumRights',
    id: '828054',
    value: '32',
    sort: 32,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Special cum rights (CR)',
  },
  {
    name: 'SpecialExRights',
    id: '828055',
    value: '33',
    sort: 33,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Special ex rights (XR)',
  },
  {
    name: 'SpecialCumCapitalRepayments',
    id: '828056',
    value: '34',
    sort: 34,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Special cum capital repayments (CP)',
  },
  {
    name: 'SpecialExCapitalRepayments',
    id: '828057',
    value: '35',
    sort: 35,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Special ex capital repayments (XP)',
  },
  {
    name: 'SpecialCumBonus',
    id: '828058',
    value: '36',
    sort: 36,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Special cum bonus (CB)',
  },
  {
    name: 'SpecialExBonus',
    id: '828059',
    value: '37',
    sort: 37,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Special ex bonus (XB)',
  },
  {
    name: 'LargeTrade',
    id: '828060',
    value: '38',
    sort: 38,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Block trade\n\nThe same as large trade.',
  },
  {
    name: 'WorkedPrincipalTrade',
    id: '828061',
    value: '39',
    sort: 39,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Worked principal trade',
  },
  {
    name: 'BlockTrades',
    id: '828062',
    value: '40',
    sort: 40,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Block trades',
  },
  {
    name: 'NameChange',
    id: '828063',
    value: '41',
    sort: 41,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Name change',
  },
  {
    name: 'PortfolioTransfer',
    id: '828064',
    value: '42',
    sort: 42,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Portfolio transfer',
  },
  {
    name: 'ProrogationBuy',
    id: '828065',
    value: '43',
    sort: 43,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description:
      'Prorogation buy\n\nUsed by Euronext Paris only. Is used to defer settlement under French SRD (deferred settlement system). Trades must be reported as crosses at zero price.',
  },
  {
    name: 'ProrogationSell',
    id: '828066',
    value: '44',
    sort: 44,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Prorogation sell\n\nSee prorogation buy.',
  },
  {
    name: 'OptionExercise',
    id: '828067',
    value: '45',
    sort: 45,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Option exercise',
  },
  {
    name: 'DeltaNeutralTransaction',
    id: '828068',
    value: '46',
    sort: 46,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Delta neutral transaction',
  },
  {
    name: 'FinancingTransaction',
    id: '828069',
    value: '47',
    sort: 47,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 828,
    type: 'int',
    codeSet: 'TrdTypeCodeSet',
    description: 'Financing transaction',
  },
  {
    name: 'CMTA',
    id: '829001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'CMTA',
  },
  {
    name: 'InternalTransferOrAdjustment',
    id: '829002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Internal transfer or adjustment',
  },
  {
    name: 'ExternalTransferOrTransferOfAccount',
    id: '829003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'External transfer or transfer of account',
  },
  {
    name: 'RejectForSubmittingSide',
    id: '829004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Reject for submitting side',
  },
  {
    name: 'AdvisoryForContraSide',
    id: '829005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Advisory for contra side',
  },
  {
    name: 'OffsetDueToAnAllocation',
    id: '829006',
    value: '5',
    sort: 6,
    added: 'FIX.4.4',
    addedEP: '5',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Offset due to an allocation',
  },
  {
    name: 'OnsetDueToAnAllocation',
    id: '829007',
    value: '6',
    sort: 7,
    added: 'FIX.4.4',
    addedEP: '5',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Onset due to an allocation',
  },
  {
    name: 'DifferentialSpread',
    id: '829008',
    value: '7',
    sort: 8,
    added: 'FIX.4.4',
    addedEP: '5',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Differential spread',
  },
  {
    name: 'ImpliedSpreadLegExecutedAgainstAnOutright',
    id: '829009',
    value: '8',
    sort: 9,
    added: 'FIX.4.4',
    addedEP: '5',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Implied spread leg executed against an outright',
  },
  {
    name: 'TransactionFromExercise',
    id: '829010',
    value: '9',
    sort: 10,
    added: 'FIX.4.4',
    addedEP: '5',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Transaction from exercise',
  },
  {
    name: 'TransactionFromAssignment',
    id: '829011',
    value: '10',
    sort: 11,
    added: 'FIX.4.4',
    addedEP: '5',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Transaction from assignment',
  },
  {
    name: 'ACATS',
    id: '829012',
    value: '11',
    sort: 12,
    added: 'FIX.4.4',
    addedEP: '8',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'ACATS',
  },
  {
    name: 'OffHoursTrade',
    id: '829013',
    value: '33',
    sort: 32,
    added: 'FIX.5.0',
    addedEP: '61',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Off Hours Trade',
  },
  {
    name: 'OnHoursTrade',
    id: '829014',
    value: '34',
    sort: 33,
    added: 'FIX.5.0',
    addedEP: '61',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'On Hours Trade',
  },
  {
    name: 'OTCQuote',
    id: '829015',
    value: '35',
    sort: 34,
    added: 'FIX.5.0',
    addedEP: '61',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'OTC Quote',
  },
  {
    name: 'ConvertedSWAP',
    id: '829016',
    value: '36',
    sort: 36,
    added: 'FIX.5.0',
    addedEP: '-1',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Converted SWAP',
  },
  {
    name: 'WashTrade',
    id: '829017',
    value: '40',
    sort: 40,
    added: 'FIX.5.0SP2',
    addedEP: '101',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Wash Trade',
  },
  {
    name: 'TradeAtSettlement',
    id: '829018',
    value: '41',
    sort: 41,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    updated: 'FIX.5.0SP2',
    updatedEP: '227',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'Trade at Settlement (TAS)\n\nIdentifies a trade that will be priced using the settlement price.',
  },
  {
    name: 'AuctionTrade',
    id: '829019',
    value: '42',
    sort: 42,
    added: 'FIX.5.0SP2',
    addedEP: '114',
    updated: 'FIX.5.0SP2',
    updatedEP: '227',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'Auction Trade\n\nMutually exclusive with TrdSubType(829) = 50 (Balancing).',
  },
  {
    name: 'TradeAtMarker',
    id: '829020',
    value: '43',
    sort: 43,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    updated: 'FIX.5.0SP2',
    updatedEP: '227',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'Trade at Marker (TAM)\n\nPosted at a specific time each day and used to price the consummated trade for the product/month/strip executed (+/- and differentials). Closely related to TAS trades in function and trade practice.',
  },
  {
    name: 'CreditDefault',
    id: '829021',
    value: '44',
    sort: 44,
    added: 'FIX.5.0SP2',
    addedEP: '165',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Default (Credit Event)',
  },
  {
    name: 'CreditRestructuring',
    id: '829022',
    value: '45',
    sort: 45,
    added: 'FIX.5.0SP2',
    addedEP: '165',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Restructuring (credit event)',
  },
  {
    name: 'Merger',
    id: '829023',
    value: '46',
    sort: 46,
    added: 'FIX.5.0SP2',
    addedEP: '165',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Merger (succession event)',
  },
  {
    name: 'SpinOff',
    id: '829024',
    value: '47',
    sort: 47,
    added: 'FIX.5.0SP2',
    addedEP: '165',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Spin-off (succession event)',
  },
  {
    name: 'MultilateralCompression',
    id: '829025',
    value: '48',
    sort: 48,
    added: 'FIX.5.0SP2',
    addedEP: '201',
    updated: 'FIX.Latest',
    updatedEP: '269',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'Multilateral compression\n\nUsed to identify a special case of compression between multiple parties, e.g. for netted or portfolio trades.',
  },
  {
    name: 'Balancing',
    id: '829026',
    value: '50',
    sort: 50,
    added: 'FIX.5.0SP2',
    addedEP: '227',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'Balancing\n\nIdentifies an additional trade distributed to auction participants meant to resolve an imbalance between bids and offers.\n\nMutually exclusive with TrdSubType(829) = 42 =(Auction).',
  },
  {
    name: 'BasisTradeIndexClose',
    id: '829027',
    value: '51',
    sort: 51,
    added: 'FIX.5.0SP2',
    addedEP: '227',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'Basis Trade index Close (BTIC)\n\nThe marketplace name given to Trade at Marker (TAM) transactions in equity index futures.',
  },
  {
    name: 'TradeAtCashOpen',
    id: '829028',
    value: '52',
    sort: 52,
    added: 'FIX.5.0SP2',
    addedEP: '243',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'Trade At Cash Open (TACO)\n\nThe marketplace name given to trading futures based on an opening quote of the underlying cash market.',
  },
  {
    name: 'TrdSubmitVenueClrSettl',
    id: '829029',
    value: '53',
    sort: 53,
    added: 'FIX.Latest',
    addedEP: '268',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'Trade submitted to venue for clearing and settlement\n\nIdentifies trades brought on a trading venue purely for clearing and settlement purposes.',
  },
  {
    name: 'BilateralCompression',
    id: '829030',
    value: '54',
    sort: 54,
    added: 'FIX.Latest',
    addedEP: '269',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'Bilateral compression\n\nUsed to identify a special case of compression between two parties, e.g. for netted or portfolio trades.',
  },
  {
    name: 'AI',
    id: '829031',
    value: '14',
    sort: 13,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'AI (Automated input facility disabled in response to an exchange request.)',
  },
  {
    name: 'B',
    id: '829032',
    value: '15',
    sort: 14,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'B (Transaction between two member firms where neither member firm is registered as a market maker in the security in question and neither is a designated fund manager. Also used by broker dealers when dealing with another broker which is not a member firm. Non-order book securities only.)',
  },
  {
    name: 'K',
    id: '829033',
    value: '16',
    sort: 15,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'K (Transaction using block trade facility.)',
  },
  {
    name: 'LC',
    id: '829034',
    value: '17',
    sort: 16,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'LC (Correction submitted more than three days after publication of the original trade report.)',
  },
  {
    name: 'M',
    id: '829035',
    value: '18',
    sort: 17,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'M (Transaction, other than a transaction resulting from a stock swap or stock switch, between two market makers registered in that security including IDB or a public display system trades. Non-order book securities only.)',
  },
  {
    name: 'N',
    id: '829036',
    value: '19',
    sort: 18,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'N (Non-protected portfolio transaction or a fully disclosed portfolio transaction)',
  },
  {
    name: 'NM',
    id: '829037',
    value: '20',
    sort: 19,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'NM ( i) transaction where Exchange has granted permission for non-publication\n\nii)IDB is reporting as seller\n\niii) submitting a transaction report to the Exchange, where the transaction report is not also a trade report.)',
  },
  {
    name: 'NR',
    id: '829038',
    value: '21',
    sort: 20,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'NR (Non-risk transaction in a SEATS security other than an AIM security)',
  },
  {
    name: 'P',
    id: '829039',
    value: '22',
    sort: 21,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'P (Protected portfolio transaction or a worked principal agreement to effect a portfolio transaction which includes order book securities)',
  },
  {
    name: 'PA',
    id: '829040',
    value: '23',
    sort: 22,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'PA (Protected transaction notification)',
  },
  {
    name: 'PC',
    id: '829041',
    value: '24',
    sort: 23,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'PC (Contra trade for transaction which took place on a previous day and which was automatically executed on the Exchange trading system)',
  },
  {
    name: 'PN',
    id: '829042',
    value: '25',
    sort: 24,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'PN (Worked principal notification for a portfolio transaction which includes order book securities)',
  },
  {
    name: 'R',
    id: '829043',
    value: '26',
    sort: 25,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'R ( (i) riskless principal transaction between non-members where the buying and selling transactions are executed at different prices or on different terms (requires a trade report with trade type indicator R for each transaction)\n\n(ii) market maker is reporting all the legs of a riskless principal transaction where the buying and selling transactions are executed at different prices (requires a trade report with trade type indicator R for each transaction)or\n\n(iii) market maker is reporting the onward leg of a riskless principal transaction where the legs are executed at different prices, and another market maker has submitted a trade report using trade type indicator M for the first leg (this requires a single trade report with trade type indicator R).)',
  },
  {
    name: 'RO',
    id: '829044',
    value: '27',
    sort: 26,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'RO (Transaction which resulted from the exercise of a traditional option or a stock-settled covered warrant)',
  },
  {
    name: 'RT',
    id: '829045',
    value: '28',
    sort: 27,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'RT (Risk transaction in a SEATS security, (excluding AIM security) reported by a market maker registered in that security)',
  },
  {
    name: 'SW',
    id: '829046',
    value: '29',
    sort: 28,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description:
      'SW (Transactions resulting from stock swap or a stock switch (one report is required for each line of stock))',
  },
  {
    name: 'T',
    id: '829047',
    value: '30',
    sort: 29,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'T (If reporting a single protected transaction)',
  },
  {
    name: 'WN',
    id: '829048',
    value: '31',
    sort: 30,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'WN (Worked principal notification for a single order book security)',
  },
  {
    name: 'WT',
    id: '829049',
    value: '32',
    sort: 31,
    group: 'MiFID Values',
    added: 'FIX.4.4',
    addedEP: '26',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'WT (Worked principal transaction (other than a portfolio transaction))',
  },
  {
    name: 'CrossedTrade',
    id: '829050',
    value: '37',
    sort: 37,
    group: 'MiFID Values',
    added: 'FIX.5.0',
    addedEP: '-1',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Crossed Trade (X)',
  },
  {
    name: 'InterimProtectedTrade',
    id: '829051',
    value: '38',
    sort: 38,
    group: 'MiFID Values',
    added: 'FIX.5.0',
    addedEP: '-1',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Interim Protected Trade (I)',
  },
  {
    name: 'LargeInScale',
    id: '829052',
    value: '39',
    sort: 39,
    group: 'MiFID Values',
    added: 'FIX.5.0',
    addedEP: '-1',
    tag: 829,
    type: 'int',
    codeSet: 'TrdSubTypeCodeSet',
    description: 'Large in Scale (L)',
  },
  {
    name: 'Floating',
    id: '835001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 835,
    type: 'int',
    codeSet: 'PegMoveTypeCodeSet',
    description: 'Floating (default)',
  },
  {
    name: 'Fixed',
    id: '835002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 835,
    type: 'int',
    codeSet: 'PegMoveTypeCodeSet',
    description: 'Fixed',
  },
  {
    name: 'Price',
    id: '836001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 836,
    type: 'int',
    codeSet: 'PegOffsetTypeCodeSet',
    description: 'Price (default)',
  },
  {
    name: 'BasisPoints',
    id: '836002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 836,
    type: 'int',
    codeSet: 'PegOffsetTypeCodeSet',
    description: 'Basis Points',
  },
  {
    name: 'Ticks',
    id: '836003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 836,
    type: 'int',
    codeSet: 'PegOffsetTypeCodeSet',
    description: 'Ticks',
  },
  {
    name: 'PriceTier',
    id: '836004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 836,
    type: 'int',
    codeSet: 'PegOffsetTypeCodeSet',
    description: 'Price Tier / Level',
  },
  {
    name: 'Percentage',
    id: '836005',
    value: '4',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 836,
    type: 'int',
    codeSet: 'PegOffsetTypeCodeSet',
    description: 'Percentage',
  },
  {
    name: 'OrBetter',
    id: '837001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 837,
    type: 'int',
    codeSet: 'PegLimitTypeCodeSet',
    description: 'Or better (default) - price improvement allowed',
  },
  {
    name: 'Strict',
    id: '837002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 837,
    type: 'int',
    codeSet: 'PegLimitTypeCodeSet',
    description: 'Strict - limit is a strict limit',
  },
  {
    name: 'OrWorse',
    id: '837003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 837,
    type: 'int',
    codeSet: 'PegLimitTypeCodeSet',
    description:
      'Or worse - for a buy the peg limit is a minimum and for a sell the peg limit is a maximum (for use for orders which have a price range)',
  },
  {
    name: 'MoreAggressive',
    id: '838001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 838,
    type: 'int',
    codeSet: 'PegRoundDirectionCodeSet',
    description:
      'More aggressive - on a buy order round the price up to the nearest tick; on a sell order round down to the nearest tick',
  },
  {
    name: 'MorePassive',
    id: '838002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 838,
    type: 'int',
    codeSet: 'PegRoundDirectionCodeSet',
    description:
      'More passive - on a buy order round down to the nearest tick; on a sell order round up to the nearest tick',
  },
  {
    name: 'Local',
    id: '840001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 840,
    type: 'int',
    codeSet: 'PegScopeCodeSet',
    description: 'Local (Exchange, ECN, ATS)',
  },
  {
    name: 'National',
    id: '840002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 840,
    type: 'int',
    codeSet: 'PegScopeCodeSet',
    description: 'National',
  },
  {
    name: 'Global',
    id: '840003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    tag: 840,
    type: 'int',
    codeSet: 'PegScopeCodeSet',
    description: 'Global',
  },
  {
    name: 'NationalExcludingLocal',
    id: '840004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    tag: 840,
    type: 'int',
    codeSet: 'PegScopeCodeSet',
    description: 'National excluding local',
  },
  {
    name: 'Floating',
    id: '841001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 841,
    type: 'int',
    codeSet: 'DiscretionMoveTypeCodeSet',
    description: 'Floating (default)',
  },
  {
    name: 'Fixed',
    id: '841002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 841,
    type: 'int',
    codeSet: 'DiscretionMoveTypeCodeSet',
    description: 'Fixed',
  },
  {
    name: 'Price',
    id: '842001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 842,
    type: 'int',
    codeSet: 'DiscretionOffsetTypeCodeSet',
    description: 'Price (default)',
  },
  {
    name: 'BasisPoints',
    id: '842002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 842,
    type: 'int',
    codeSet: 'DiscretionOffsetTypeCodeSet',
    description: 'Basis Points',
  },
  {
    name: 'Ticks',
    id: '842003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 842,
    type: 'int',
    codeSet: 'DiscretionOffsetTypeCodeSet',
    description: 'Ticks',
  },
  {
    name: 'PriceTier',
    id: '842004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 842,
    type: 'int',
    codeSet: 'DiscretionOffsetTypeCodeSet',
    description: 'Price Tier / Level',
  },
  {
    name: 'OrBetter',
    id: '843001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 843,
    type: 'int',
    codeSet: 'DiscretionLimitTypeCodeSet',
    description: 'Or better (default) - price improvement allowed',
  },
  {
    name: 'Strict',
    id: '843002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 843,
    type: 'int',
    codeSet: 'DiscretionLimitTypeCodeSet',
    description: 'Strict - limit is a strict limit',
  },
  {
    name: 'OrWorse',
    id: '843003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 843,
    type: 'int',
    codeSet: 'DiscretionLimitTypeCodeSet',
    description:
      'Or worse - for a buy the discretion price is a minimum and for a sell the discretion price is a maximum (for use for orders which have a price range)',
  },
  {
    name: 'MoreAggressive',
    id: '844001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 844,
    type: 'int',
    codeSet: 'DiscretionRoundDirectionCodeSet',
    description:
      'More aggressive - on a buy order round the price up to the nearest tick; on a sell round down to the nearest tick',
  },
  {
    name: 'MorePassive',
    id: '844002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 844,
    type: 'int',
    codeSet: 'DiscretionRoundDirectionCodeSet',
    description:
      'More passive - on a buy order round down to the nearest tick; on a sell order round up to the nearest tick',
  },
  {
    name: 'Local',
    id: '846001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 846,
    type: 'int',
    codeSet: 'DiscretionScopeCodeSet',
    description: 'Local (Exchange, ECN, ATS)',
  },
  {
    name: 'National',
    id: '846002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 846,
    type: 'int',
    codeSet: 'DiscretionScopeCodeSet',
    description: 'National',
  },
  {
    name: 'Global',
    id: '846003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    tag: 846,
    type: 'int',
    codeSet: 'DiscretionScopeCodeSet',
    description: 'Global',
  },
  {
    name: 'NationalExcludingLocal',
    id: '846004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    tag: 846,
    type: 'int',
    codeSet: 'DiscretionScopeCodeSet',
    description: 'National excluding local',
  },
  {
    name: 'VWAP',
    id: '847001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 847,
    type: 'int',
    codeSet: 'TargetStrategyCodeSet',
    description: 'VWAP',
  },
  {
    name: 'Participate',
    id: '847002',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 847,
    type: 'int',
    codeSet: 'TargetStrategyCodeSet',
    description: 'Participate (i.e. aim to be x percent of the market volume)',
  },
  {
    name: 'MininizeMarketImpact',
    id: '847003',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 847,
    type: 'int',
    codeSet: 'TargetStrategyCodeSet',
    description: 'Mininize market impact',
  },
  {
    name: 'NeitherAddedNorRemovedLiquidity',
    id: '851001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '252',
    updated: 'FIX.Latest',
    updatedEP: '278',
    tag: 851,
    type: 'int',
    codeSet: 'LastLiquidityIndCodeSet',
    description:
      'Neither added nor removed liquidity\n\nMay be used by venues where market rules do not define "add" or "remove" liquidity.\n\nIn the context of the SEC amendment of Regulation NMS Rule 606(b), may be used to identify executions that are only reported as part of total shares executed and not as part of shares providing or removing liquidity (see https://www.sec.gov/rules/final/2018/34-84528.pdf for details).',
  },
  {
    name: 'AddedLiquidity',
    id: '851002',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 851,
    type: 'int',
    codeSet: 'LastLiquidityIndCodeSet',
    description: 'Added Liquidity',
  },
  {
    name: 'RemovedLiquidity',
    id: '851003',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 851,
    type: 'int',
    codeSet: 'LastLiquidityIndCodeSet',
    description: 'Removed Liquidity',
  },
  {
    name: 'LiquidityRoutedOut',
    id: '851004',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    tag: 851,
    type: 'int',
    codeSet: 'LastLiquidityIndCodeSet',
    description: 'Liquidity Routed Out',
  },
  {
    name: 'Auction',
    id: '851005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '57',
    updated: 'FIX.5.0SP2',
    updatedEP: '252',
    tag: 851,
    type: 'int',
    codeSet: 'LastLiquidityIndCodeSet',
    description: 'Auction execution',
  },
  {
    name: 'TriggeredStopOrder',
    id: '851006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 851,
    type: 'int',
    codeSet: 'LastLiquidityIndCodeSet',
    description:
      'Triggered stop order\n\nFill was the result of a stop order being triggered and immediately executed.',
  },
  {
    name: 'TriggeredContingencyOrder',
    id: '851007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 851,
    type: 'int',
    codeSet: 'LastLiquidityIndCodeSet',
    description:
      'Triggered contingency order\n\nFill was the result of a contingency order (OCO, OTO, OUO) becoming active (after cancelling or updating another order) and being immediately executed.',
  },
  {
    name: 'TriggeredMarketOrder',
    id: '851008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 851,
    type: 'int',
    codeSet: 'LastLiquidityIndCodeSet',
    description:
      'Triggered market order\n\nFill was the result of a market order being triggered due to an executable orderbook situation.',
  },
  {
    name: 'RemovedLiquidityAfterFirmOrderCommitment',
    id: '851009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '252',
    tag: 851,
    type: 'int',
    codeSet: 'LastLiquidityIndCodeSet',
    description:
      'Removed liquidity after firm order commitment\n\nAn order that was submitted for continuous trading that required a firm order commit prior to execution. "Conditional order" is an alternate term used for such orders.',
  },
  {
    name: 'AuctionExecutionAfterFirmOrderCommitment',
    id: '851010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '252',
    tag: 851,
    type: 'int',
    codeSet: 'LastLiquidityIndCodeSet',
    description:
      'Auction execution after firm order commitment\n\nAn order that was submitted for auction trading that required a firm order commit prior to execution. "Conditional order" is an alternate term used for such orders.',
  },
  {
    name: 'Unknown',
    id: '851011',
    value: '10',
    sort: 10,
    added: 'FIX.Latest',
    addedEP: '278',
    tag: 851,
    type: 'int',
    codeSet: 'LastLiquidityIndCodeSet',
    description:
      'Unknown\n\nThe liquidity indicator of the execution cannot be determined or was not provided upon execution.',
  },
  {
    name: 'Other',
    id: '851012',
    value: '11',
    sort: 11,
    added: 'FIX.Latest',
    addedEP: '278',
    tag: 851,
    type: 'int',
    codeSet: 'LastLiquidityIndCodeSet',
    description:
      "Other\n\nNone of the existing liquidity indicators are applicable for the execution (e.g. due to a venue's new order type that does not fit existing values).",
  },
  {
    name: 'DoNotReportTrade',
    id: '852001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.4',
    tag: 852,
    type: 'Boolean',
    codeSet: 'PublishTrdIndicatorCodeSet',
    description: 'Do Not Report Trade',
  },
  {
    name: 'ReportTrade',
    id: '852002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.4',
    tag: 852,
    type: 'Boolean',
    codeSet: 'PublishTrdIndicatorCodeSet',
    description: 'Report Trade',
  },
  {
    name: 'DealerSoldShort',
    id: '853001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 853,
    type: 'int',
    codeSet: 'ShortSaleReasonCodeSet',
    description: 'Dealer Sold Short',
  },
  {
    name: 'DealerSoldShortExempt',
    id: '853002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 853,
    type: 'int',
    codeSet: 'ShortSaleReasonCodeSet',
    description: 'Dealer Sold Short Exempt',
  },
  {
    name: 'SellingCustomerSoldShort',
    id: '853003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 853,
    type: 'int',
    codeSet: 'ShortSaleReasonCodeSet',
    description: 'Selling Customer Sold Short',
  },
  {
    name: 'SellingCustomerSoldShortExempt',
    id: '853004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 853,
    type: 'int',
    codeSet: 'ShortSaleReasonCodeSet',
    description: 'Selling Customer Sold Short Exempt',
  },
  {
    name: 'QualifiedServiceRepresentative',
    id: '853005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    tag: 853,
    type: 'int',
    codeSet: 'ShortSaleReasonCodeSet',
    description:
      'Qualified Service Representative (QSR) or Automatic Give-up (AGU) Contra Side Sold Short',
  },
  {
    name: 'QSROrAGUContraSideSoldShortExempt',
    id: '853006',
    value: '5',
    sort: 6,
    added: 'FIX.4.4',
    tag: 853,
    type: 'int',
    codeSet: 'ShortSaleReasonCodeSet',
    description: 'QSR or AGU Contra Side Sold Short Exempt',
  },
  {
    name: 'Units',
    id: '854001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 854,
    type: 'int',
    codeSet: 'QtyTypeCodeSet',
    description: 'Units (shares, par, currency)',
  },
  {
    name: 'Contracts',
    id: '854002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '107',
    tag: 854,
    type: 'int',
    codeSet: 'QtyTypeCodeSet',
    description: 'Contracts',
  },
  {
    name: 'UnitsOfMeasurePerTimeUnit',
    id: '854003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '5',
    updated: 'FIX.5.0SP2',
    updatedEP: '107',
    tag: 854,
    type: 'int',
    codeSet: 'QtyTypeCodeSet',
    description: 'Unit of Measure per Time Unit',
  },
  {
    name: 'Submit',
    id: '856001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description: 'Submit',
  },
  {
    name: 'Alleged',
    id: '856002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description: 'Alleged',
  },
  {
    name: 'Accept',
    id: '856003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description: 'Accept',
  },
  {
    name: 'Decline',
    id: '856004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description: 'Decline',
  },
  {
    name: 'Addendum',
    id: '856005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '241',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description:
      'Addendum\n\nUsed to provide material supplemental data to a previously submitted trade.',
  },
  {
    name: 'No',
    id: '856006',
    value: '5',
    sort: 6,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '241',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description:
      'No/Was\n\nUsed to report a full replacement of a previously submitted trade.',
  },
  {
    name: 'TradeReportCancel',
    id: '856007',
    value: '6',
    sort: 7,
    added: 'FIX.4.4',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description: 'Trade Report Cancel',
  },
  {
    name: 'LockedIn',
    id: '856008',
    value: '7',
    sort: 8,
    added: 'FIX.4.4',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description: '(Locked-In) Trade Break',
  },
  {
    name: 'Defaulted',
    id: '856009',
    value: '8',
    sort: 9,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description: 'Defaulted',
  },
  {
    name: 'InvalidCMTA',
    id: '856010',
    value: '9',
    sort: 10,
    added: 'FIX.4.4',
    addedEP: '8',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description: 'Invalid CMTA',
  },
  {
    name: 'Pended',
    id: '856011',
    value: '10',
    sort: 11,
    added: 'FIX.4.4',
    addedEP: '23',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description: 'Pended',
  },
  {
    name: 'AllegedNew',
    id: '856012',
    value: '11',
    sort: 12,
    added: 'FIX.4.4',
    addedEP: '23',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description: 'Alleged New',
  },
  {
    name: 'AllegedAddendum',
    id: '856013',
    value: '12',
    sort: 13,
    added: 'FIX.4.4',
    addedEP: '23',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description: 'Alleged Addendum',
  },
  {
    name: 'AllegedNo',
    id: '856014',
    value: '13',
    sort: 14,
    added: 'FIX.4.4',
    addedEP: '23',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description: 'Alleged No/Was',
  },
  {
    name: 'AllegedTradeReportCancel',
    id: '856015',
    value: '14',
    sort: 15,
    added: 'FIX.4.4',
    addedEP: '23',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description: 'Alleged Trade Report Cancel',
  },
  {
    name: 'AllegedTradeBreak',
    id: '856016',
    value: '15',
    sort: 16,
    added: 'FIX.4.4',
    addedEP: '23',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description: 'Alleged (Locked-In) Trade Break',
  },
  {
    name: 'Verify',
    id: '856017',
    value: '16',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description:
      'Verify\n\nUsed in reports from a trading party to the SDR to confirm trade details. Omit RegulatoryReportType(1934).',
  },
  {
    name: 'Dispute',
    id: '856018',
    value: '17',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description:
      'Dispute\n\nUsed in reports from a trading party to the SDR to dispute trade details. Omit RegulatoryReportType(1934).',
  },
  {
    name: 'NonMaterialUpdate',
    id: '856019',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '241',
    tag: 856,
    type: 'int',
    codeSet: 'TradeReportTypeCodeSet',
    description:
      'Non-material Update\n\nUsed to provide non-material supplemental data to a previously submitted trade.',
  },
  {
    name: 'NotSpecified',
    id: '857001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 857,
    type: 'int',
    codeSet: 'AllocNoOrdersTypeCodeSet',
    description: 'Not specified',
  },
  {
    name: 'ExplicitListProvided',
    id: '857002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '118',
    tag: 857,
    type: 'int',
    codeSet: 'AllocNoOrdersTypeCodeSet',
    description: 'Explicit list provided',
  },
  {
    name: 'Put',
    id: '865001',
    value: '1',
    sort: 0,
    added: 'FIX.4.4',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Put',
  },
  {
    name: 'Call',
    id: '865002',
    value: '2',
    sort: 1,
    added: 'FIX.4.4',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Call',
  },
  {
    name: 'Tender',
    id: '865003',
    value: '3',
    sort: 2,
    added: 'FIX.4.4',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Tender',
  },
  {
    name: 'SinkingFundCall',
    id: '865004',
    value: '4',
    sort: 3,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Sinking fund call',
  },
  {
    name: 'Activation',
    id: '865005',
    value: '5',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '8',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Activation',
  },
  {
    name: 'Inactiviation',
    id: '865006',
    value: '6',
    sort: 5,
    added: 'FIX.4.4',
    addedEP: '8',
    updated: 'FIX.5.0SP2',
    updatedEP: '137',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Inactivation',
  },
  {
    name: 'LastEligibleTradeDate',
    id: '865007',
    value: '7',
    sort: 6,
    added: 'FIX.5.0',
    addedEP: '42',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Last eligible trade date',
  },
  {
    name: 'SwapStartDate',
    id: '865008',
    value: '8',
    sort: 7,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Swap start date',
  },
  {
    name: 'SwapEndDate',
    id: '865009',
    value: '9',
    sort: 8,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Swap end date',
  },
  {
    name: 'SwapRollDate',
    id: '865010',
    value: '10',
    sort: 9,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Swap roll date',
  },
  {
    name: 'SwapNextStartDate',
    id: '865011',
    value: '11',
    sort: 10,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Swap next start date',
  },
  {
    name: 'SwapNextRollDate',
    id: '865012',
    value: '12',
    sort: 11,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Swap next roll date',
  },
  {
    name: 'FirstDeliveryDate',
    id: '865013',
    value: '13',
    sort: 12,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'First delivery date',
  },
  {
    name: 'LastDeliveryDate',
    id: '865014',
    value: '14',
    sort: 13,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Last delivery date',
  },
  {
    name: 'InitialInventoryDueDate',
    id: '865015',
    value: '15',
    sort: 14,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Initial inventory due date',
  },
  {
    name: 'FinalInventoryDueDate',
    id: '865016',
    value: '16',
    sort: 15,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Final inventory due date',
  },
  {
    name: 'FirstIntentDate',
    id: '865017',
    value: '17',
    sort: 16,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'First intent date',
  },
  {
    name: 'LastIntentDate',
    id: '865018',
    value: '18',
    sort: 17,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Last intent date',
  },
  {
    name: 'PositionRemovalDate',
    id: '865019',
    value: '19',
    sort: 18,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Position removal date',
  },
  {
    name: 'MinimumNotice',
    id: '865020',
    value: '20',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '132',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Minimum notice',
  },
  {
    name: 'DeliveryStartTime',
    id: '865021',
    value: '21',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '137',
    updated: 'FIX.5.0SP2',
    updatedEP: '228',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Delivery start time',
  },
  {
    name: 'DeliveryEndTime',
    id: '865022',
    value: '22',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '137',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Delivery end time',
  },
  {
    name: 'FirstNoticeDate',
    id: '865023',
    value: '23',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '138',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description:
      "First notice date\n\nThe first day that a notice of intent to deliver a commodity can be made by a clearing house to a buyer in fulfillment of a given month's futures contract.",
  },
  {
    name: 'LastNoticeDate',
    id: '865024',
    value: '24',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '138',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description:
      'Last notice date\n\nThe last day on which a clearing house may inform an investor that a seller intends to make delivery of a commodity that the investor previously bought in a futures contract. The date is governed by the rules of different exchanges and clearing houses, but may also be stated in the futures contract itself.',
  },
  {
    name: 'FirstExerciseDate',
    id: '865025',
    value: '25',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'First exercise date',
  },
  {
    name: 'RedemptionDate',
    id: '865026',
    value: '26',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Redemption date',
  },
  {
    name: 'TrdCntntnEfctvDt',
    id: '865027',
    value: '27',
    sort: 27,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Trade continuation effective date',
  },
  {
    name: 'Other',
    id: '865028',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    tag: 865,
    type: 'int',
    codeSet: 'EventTypeCodeSet',
    description: 'Other',
  },
  {
    name: 'Flat',
    id: '871001',
    value: '1',
    sort: 0,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description:
      'Flat (securities pay interest on a current basis but are traded without interest)',
  },
  {
    name: 'ZeroCoupon',
    id: '871002',
    value: '2',
    sort: 1,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Zero coupon',
  },
  {
    name: 'InterestBearing',
    id: '871003',
    value: '3',
    sort: 2,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description:
      'Interest bearing (for Euro commercial paper when not issued at discount)',
  },
  {
    name: 'NoPeriodicPayments',
    id: '871004',
    value: '4',
    sort: 3,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'No periodic payments',
  },
  {
    name: 'VariableRate',
    id: '871005',
    value: '5',
    sort: 4,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Variable rate',
  },
  {
    name: 'LessFeeForPut',
    id: '871006',
    value: '6',
    sort: 5,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Less fee for put',
  },
  {
    name: 'SteppedCoupon',
    id: '871007',
    value: '7',
    sort: 6,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Stepped coupon',
  },
  {
    name: 'CouponPeriod',
    id: '871008',
    value: '8',
    sort: 7,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description:
      'Coupon period (if not semi-annual)\n\nSupply redemption date in the InstrAttribValue(872) field.',
  },
  {
    name: 'When',
    id: '871009',
    value: '9',
    sort: 8,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'When [and if] issued',
  },
  {
    name: 'OriginalIssueDiscount',
    id: '871010',
    value: '10',
    sort: 9,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Original issue discount',
  },
  {
    name: 'Callable',
    id: '871011',
    value: '11',
    sort: 10,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Callable, puttable',
  },
  {
    name: 'EscrowedToMaturity',
    id: '871012',
    value: '12',
    sort: 11,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Escrowed to Maturity',
  },
  {
    name: 'EscrowedToRedemptionDate',
    id: '871013',
    value: '13',
    sort: 12,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description:
      'Escrowed to redemption date - callable\n\nSupply redemption date in the InstrAttribValue(872) field.',
  },
  {
    name: 'PreRefunded',
    id: '871014',
    value: '14',
    sort: 13,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Pre-refunded',
  },
  {
    name: 'InDefault',
    id: '871015',
    value: '15',
    sort: 14,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'In default',
  },
  {
    name: 'Unrated',
    id: '871016',
    value: '16',
    sort: 15,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Unrated',
  },
  {
    name: 'Taxable',
    id: '871017',
    value: '17',
    sort: 16,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Taxable',
  },
  {
    name: 'Indexed',
    id: '871018',
    value: '18',
    sort: 17,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Indexed',
  },
  {
    name: 'SubjectToAlternativeMinimumTax',
    id: '871019',
    value: '19',
    sort: 18,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Subject To Alternative Minimum Tax',
  },
  {
    name: 'OriginalIssueDiscountPrice',
    id: '871020',
    value: '20',
    sort: 19,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description:
      'Original issue discount price\n\nSupply price in the InstrAttribValue(872) field.',
  },
  {
    name: 'CallableBelowMaturityValue',
    id: '871021',
    value: '21',
    sort: 20,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Callable below maturity value',
  },
  {
    name: 'CallableWithoutNotice',
    id: '871022',
    value: '22',
    sort: 21,
    added: 'FIX.4.4',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Callable without notice by mail to holder unless registered',
  },
  {
    name: 'PriceTickRulesForSecurity',
    id: '871023',
    value: '23',
    sort: 22,
    added: 'FIX.5.0',
    addedEP: '42',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Price tick rules for security',
  },
  {
    name: 'TradeTypeEligibilityDetailsForSecurity',
    id: '871024',
    value: '24',
    sort: 23,
    added: 'FIX.5.0',
    addedEP: '42',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Trade type eligibility details for security',
  },
  {
    name: 'InstrumentDenominator',
    id: '871025',
    value: '25',
    sort: 26,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Instrument denominator',
  },
  {
    name: 'InstrumentNumerator',
    id: '871026',
    value: '26',
    sort: 27,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Instrument numerator',
  },
  {
    name: 'InstrumentPricePrecision',
    id: '871027',
    value: '27',
    sort: 28,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Instrument price precision',
  },
  {
    name: 'InstrumentStrikePrice',
    id: '871028',
    value: '28',
    sort: 29,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Instrument strike price',
  },
  {
    name: 'TradeableIndicator',
    id: '871029',
    value: '29',
    sort: 30,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Tradeable indicator',
  },
  {
    name: 'InstrumentEligibleAnonOrders',
    id: '871030',
    value: '30',
    sort: 31,
    added: 'FIX.5.0SP2',
    addedEP: '101',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Instrument is eligible to accept anonymous orders',
  },
  {
    name: 'MinGuaranteedFillVolume',
    id: '871031',
    value: '31',
    sort: 32,
    added: 'FIX.5.0SP2',
    addedEP: '101',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Minimum guaranteed fill volume',
  },
  {
    name: 'MinGuaranteedFillStatus',
    id: '871032',
    value: '32',
    sort: 33,
    added: 'FIX.5.0SP2',
    addedEP: '104',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Minimum guaranteed fill status',
  },
  {
    name: 'TradeAtSettlementEligibility',
    id: '871033',
    value: '33',
    sort: 34,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Trade at settlement (TAS) eligibility',
  },
  {
    name: 'TestInstrument',
    id: '871034',
    value: '34',
    sort: 35,
    added: 'FIX.5.0SP2',
    addedEP: '130',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description:
      'Test instrument\n\nInstrument that is tradable but has no effect on the positions, exchange turnover etc.',
  },
  {
    name: 'DummyInstrument',
    id: '871035',
    value: '35',
    sort: 36,
    added: 'FIX.5.0SP2',
    addedEP: '130',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description:
      'Dummy instrument\n\nInstrument that is normally halted and is only activated for trading under very special conditions (e.g. temporarily assigned for newly listed instrument). Use of a dummy instrument generally applies to systems that are unable to add reference data for new instruments intraday.',
  },
  {
    name: 'NegativeSettlementPriceEligibility',
    id: '871036',
    value: '36',
    sort: 37,
    added: 'FIX.5.0SP2',
    addedEP: '138',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Negative settlement price eligibility',
  },
  {
    name: 'NegativeStrikePriceEligibility',
    id: '871037',
    value: '37',
    sort: 38,
    added: 'FIX.5.0SP2',
    addedEP: '138',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Negative strike price eligibility',
  },
  {
    name: 'USStdContractInd',
    id: '871038',
    value: '38',
    sort: 39,
    added: 'FIX.5.0SP2',
    addedEP: '193',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description:
      'US standard contract indicator\n\nIndicates through InstrAttribValue(872) - values Y or N - whether the underlying asset in the trade references or is economically related to a contract listed in Appendix B of CFTC Part 43 regulation. See http://www.ecfr.gov/cgi-bin/text-idx?SID=4b2d1078ad68f6564a89d7ff6c52ec43&node=17:2.0.1.1.3.0.1.8.2&rgn=div or refer to Appendix B to Part 43 in the final rule at http://www.cftc.gov/ucm/groups/public/@lrfederalregister/documents/file/2013-12133a.pdf',
  },
  {
    name: 'AdmittedToTradingOnTradingVenue',
    id: '871039',
    value: '39',
    sort: 40,
    added: 'FIX.5.0SP2',
    addedEP: '236',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Admitted to trading on a trading venue',
  },
  {
    name: 'AverageDailyNotionalAmount',
    id: '871040',
    value: '40',
    sort: 41,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Average daily notional amount',
  },
  {
    name: 'AverageDailyNumberTrades',
    id: '871041',
    value: '41',
    sort: 42,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Average daily number of trades',
  },
  {
    name: 'Text',
    id: '871042',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 871,
    type: 'int',
    codeSet: 'InstrAttribTypeCodeSet',
    description: 'Text\n\nSupply the text value in InstrAttribValue(872).',
  },
  {
    name: 'Program3a3',
    id: '875001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '201',
    tag: 875,
    type: 'int',
    codeSet: 'CPProgramCodeSet',
    description:
      '3(a)(3)\n\nArising out of a current transaction with a maturity less than 9 months.',
  },
  {
    name: 'Program42',
    id: '875002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '201',
    tag: 875,
    type: 'int',
    codeSet: 'CPProgramCodeSet',
    description: '4(2)\n\nIssued not involving any public offering.',
  },
  {
    name: 'Program3a2',
    id: '875003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '201',
    tag: 875,
    type: 'int',
    codeSet: 'CPProgramCodeSet',
    description:
      '3(a)(2)\n\nIssued or guaranteed by the US, state or territorial government.',
  },
  {
    name: 'Program3a3And3c7',
    id: '875004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '201',
    tag: 875,
    type: 'int',
    codeSet: 'CPProgramCodeSet',
    description: '3(a)(3) & 3(c)(7)\n\nCombination of 3(a)(3) and 3(c)(7).',
  },
  {
    name: 'Program3a4',
    id: '875005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '201',
    tag: 875,
    type: 'int',
    codeSet: 'CPProgramCodeSet',
    description:
      '3(a)(4)\n\nReligious, education, benevolent, fraternal, charitable or reformatory purposes.',
  },
  {
    name: 'Program3a5',
    id: '875006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '201',
    tag: 875,
    type: 'int',
    codeSet: 'CPProgramCodeSet',
    description:
      "3(a)(5)\n\nIssued by an institution supervised by state or federal authority or by an exempt farmer's cooperative.",
  },
  {
    name: 'Program3a7',
    id: '875007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '201',
    tag: 875,
    type: 'int',
    codeSet: 'CPProgramCodeSet',
    description: '3(a)(7)\n\nIssued by a receiver or trustee in bankruptcy.',
  },
  {
    name: 'Program3c7',
    id: '875008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '201',
    tag: 875,
    type: 'int',
    codeSet: 'CPProgramCodeSet',
    description:
      '3(c)(7)\n\nQualified hedge-fund under the Investment Company Act of 1940.',
  },
  {
    name: 'Other',
    id: '875009',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    tag: 875,
    type: 'int',
    codeSet: 'CPProgramCodeSet',
    description: 'Other',
  },
  {
    name: 'Absolute',
    id: '891001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '240',
    tag: 891,
    type: 'int',
    codeSet: 'MiscFeeBasisCodeSet',
    description:
      'Absolute\n\nThe fee or markup is a total fixed amount expressed in the currency of the trade.',
  },
  {
    name: 'PerUnit',
    id: '891002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '240',
    tag: 891,
    type: 'int',
    codeSet: 'MiscFeeBasisCodeSet',
    description:
      'Per Unit\n\nThe fee or markup is an amount per quantity unit, i.e. per share or contract, expressed in the currency of the trade.',
  },
  {
    name: 'Percentage',
    id: '891003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '240',
    tag: 891,
    type: 'int',
    codeSet: 'MiscFeeBasisCodeSet',
    description:
      'Percentage\n\nThe percentage is expressed in standard FIX "Percentage" datatype format, i.e. "0.01" for 1 percent and ranges between 0 and 1. It is the number which when multiplied by the trade price and quantity produces the total amount of the fee or markup.',
  },
  {
    name: 'NotLastMessage',
    id: '893001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.4',
    tag: 893,
    type: 'Boolean',
    codeSet: 'LastFragmentCodeSet',
    description: 'Not Last Message',
  },
  {
    name: 'LastMessage',
    id: '893002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.4',
    tag: 893,
    type: 'Boolean',
    codeSet: 'LastFragmentCodeSet',
    description: 'Last Message',
  },
  {
    name: 'Initial',
    id: '895001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 895,
    type: 'int',
    codeSet: 'CollAsgnReasonCodeSet',
    description: 'Initial',
  },
  {
    name: 'Scheduled',
    id: '895002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 895,
    type: 'int',
    codeSet: 'CollAsgnReasonCodeSet',
    description: 'Scheduled',
  },
  {
    name: 'TimeWarning',
    id: '895003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 895,
    type: 'int',
    codeSet: 'CollAsgnReasonCodeSet',
    description: 'Time Warning',
  },
  {
    name: 'MarginDeficiency',
    id: '895004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '192',
    tag: 895,
    type: 'int',
    codeSet: 'CollAsgnReasonCodeSet',
    description:
      'Margin Deficiency\n\nIn a CollateralRequest(35=AX), this indicates there is a margin deficiency. In a CollateralAssignment(35=AY), this indicates that the assignment is a deposit to meet margin deficiency.',
  },
  {
    name: 'MarginExcess',
    id: '895005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    updated: 'FIX.5.0SP2',
    updatedEP: '192',
    tag: 895,
    type: 'int',
    codeSet: 'CollAsgnReasonCodeSet',
    description:
      'Margin Excess\n\nIn a CollateralRequest(35=AX), this indicates there is excess margin. In a CollateralAssignment(35=AY), this indicates that the assignment is a withdrawal of the margin excess.',
  },
  {
    name: 'ForwardCollateralDemand',
    id: '895006',
    value: '5',
    sort: 6,
    added: 'FIX.4.4',
    tag: 895,
    type: 'int',
    codeSet: 'CollAsgnReasonCodeSet',
    description: 'Forward Collateral Demand',
  },
  {
    name: 'EventOfDefault',
    id: '895007',
    value: '6',
    sort: 7,
    added: 'FIX.4.4',
    tag: 895,
    type: 'int',
    codeSet: 'CollAsgnReasonCodeSet',
    description: 'Event of default',
  },
  {
    name: 'AdverseTaxEvent',
    id: '895008',
    value: '7',
    sort: 8,
    added: 'FIX.4.4',
    tag: 895,
    type: 'int',
    codeSet: 'CollAsgnReasonCodeSet',
    description: 'Adverse tax event',
  },
  {
    name: 'TransferDeposit',
    id: '895009',
    value: '8',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '193',
    tag: 895,
    type: 'int',
    codeSet: 'CollAsgnReasonCodeSet',
    description:
      'Transfer deposit\n\nCollateral deposit in which the asset is to be transferred from an undesignated holding into collateral. I.e. there is no intermediate conversion to cash.',
  },
  {
    name: 'TransferWithdrawal',
    id: '895010',
    value: '9',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '193',
    tag: 895,
    type: 'int',
    codeSet: 'CollAsgnReasonCodeSet',
    description:
      'Transfer withdrawal\n\nCollateral withdrawal in which the asset is to be transferred from collateral into an undesignated holding. I.e. there is no intermediate conversion to cash.',
  },
  {
    name: 'Pledge',
    id: '895011',
    value: '10',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '197',
    tag: 895,
    type: 'int',
    codeSet: 'CollAsgnReasonCodeSet',
    description:
      'Pledge\n\nThe purpose of the collateral assignment is to pledge or "lock up" a value of a basket of securities, individual security or fund as collateral.',
  },
  {
    name: 'TradeDate',
    id: '896001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 896,
    type: 'int',
    codeSet: 'CollInquiryQualifierCodeSet',
    description: 'Trade Date',
  },
  {
    name: 'GCInstrument',
    id: '896002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 896,
    type: 'int',
    codeSet: 'CollInquiryQualifierCodeSet',
    description: 'GC Instrument',
  },
  {
    name: 'CollateralInstrument',
    id: '896003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 896,
    type: 'int',
    codeSet: 'CollInquiryQualifierCodeSet',
    description: 'Collateral Instrument',
  },
  {
    name: 'SubstitutionEligible',
    id: '896004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 896,
    type: 'int',
    codeSet: 'CollInquiryQualifierCodeSet',
    description: 'Substitution Eligible',
  },
  {
    name: 'NotAssigned',
    id: '896005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    tag: 896,
    type: 'int',
    codeSet: 'CollInquiryQualifierCodeSet',
    description: 'Not Assigned',
  },
  {
    name: 'PartiallyAssigned',
    id: '896006',
    value: '5',
    sort: 6,
    added: 'FIX.4.4',
    tag: 896,
    type: 'int',
    codeSet: 'CollInquiryQualifierCodeSet',
    description: 'Partially Assigned',
  },
  {
    name: 'FullyAssigned',
    id: '896007',
    value: '6',
    sort: 7,
    added: 'FIX.4.4',
    tag: 896,
    type: 'int',
    codeSet: 'CollInquiryQualifierCodeSet',
    description: 'Fully Assigned',
  },
  {
    name: 'OutstandingTrades',
    id: '896008',
    value: '7',
    sort: 8,
    added: 'FIX.4.4',
    tag: 896,
    type: 'int',
    codeSet: 'CollInquiryQualifierCodeSet',
    description: 'Outstanding Trades (Today < end date)',
  },
  {
    name: 'New',
    id: '903001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 903,
    type: 'int',
    codeSet: 'CollAsgnTransTypeCodeSet',
    description: 'New',
  },
  {
    name: 'Replace',
    id: '903002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 903,
    type: 'int',
    codeSet: 'CollAsgnTransTypeCodeSet',
    description: 'Replace',
  },
  {
    name: 'Cancel',
    id: '903003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 903,
    type: 'int',
    codeSet: 'CollAsgnTransTypeCodeSet',
    description: 'Cancel',
  },
  {
    name: 'Release',
    id: '903004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 903,
    type: 'int',
    codeSet: 'CollAsgnTransTypeCodeSet',
    description: 'Release',
  },
  {
    name: 'Reverse',
    id: '903005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    tag: 903,
    type: 'int',
    codeSet: 'CollAsgnTransTypeCodeSet',
    description: 'Reverse',
  },
  {
    name: 'Received',
    id: '905001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 905,
    type: 'int',
    codeSet: 'CollAsgnRespTypeCodeSet',
    description: 'Received',
  },
  {
    name: 'Accepted',
    id: '905002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 905,
    type: 'int',
    codeSet: 'CollAsgnRespTypeCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Declined',
    id: '905003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 905,
    type: 'int',
    codeSet: 'CollAsgnRespTypeCodeSet',
    description: 'Declined',
  },
  {
    name: 'Rejected',
    id: '905004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 905,
    type: 'int',
    codeSet: 'CollAsgnRespTypeCodeSet',
    description: 'Rejected',
  },
  {
    name: 'TransactionPending',
    id: '905005',
    value: '4',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 905,
    type: 'int',
    codeSet: 'CollAsgnRespTypeCodeSet',
    description:
      'Transaction pending\n\nThe collateral assignment transaction is pending at the recipient.',
  },
  {
    name: 'TransactionCompletedWithWarning',
    id: '905006',
    value: '5',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 905,
    type: 'int',
    codeSet: 'CollAsgnRespTypeCodeSet',
    description:
      'Transaction completed with warning - see Text(58) for further information.\n\nThe collateral assignment transaction was accepted and completed but with warnings.',
  },
  {
    name: 'UnknownDeal',
    id: '906001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 906,
    type: 'int',
    codeSet: 'CollAsgnRejectReasonCodeSet',
    description: 'Unknown deal (order / trade)',
  },
  {
    name: 'UnknownOrInvalidInstrument',
    id: '906002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 906,
    type: 'int',
    codeSet: 'CollAsgnRejectReasonCodeSet',
    description: 'Unknown or invalid instrument',
  },
  {
    name: 'UnauthorizedTransaction',
    id: '906003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 906,
    type: 'int',
    codeSet: 'CollAsgnRejectReasonCodeSet',
    description: 'Unauthorized transaction',
  },
  {
    name: 'InsufficientCollateral',
    id: '906004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 906,
    type: 'int',
    codeSet: 'CollAsgnRejectReasonCodeSet',
    description: 'Insufficient collateral',
  },
  {
    name: 'InvalidTypeOfCollateral',
    id: '906005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    tag: 906,
    type: 'int',
    codeSet: 'CollAsgnRejectReasonCodeSet',
    description: 'Invalid type of collateral',
  },
  {
    name: 'ExcessiveSubstitution',
    id: '906006',
    value: '5',
    sort: 6,
    added: 'FIX.4.4',
    tag: 906,
    type: 'int',
    codeSet: 'CollAsgnRejectReasonCodeSet',
    description: 'Excessive substitution',
  },
  {
    name: 'Other',
    id: '906007',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    tag: 906,
    type: 'int',
    codeSet: 'CollAsgnRejectReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'Unassigned',
    id: '910001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 910,
    type: 'int',
    codeSet: 'CollStatusCodeSet',
    description: 'Unassigned',
  },
  {
    name: 'PartiallyAssigned',
    id: '910002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 910,
    type: 'int',
    codeSet: 'CollStatusCodeSet',
    description: 'Partially Assigned',
  },
  {
    name: 'AssignmentProposed',
    id: '910003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 910,
    type: 'int',
    codeSet: 'CollStatusCodeSet',
    description: 'Assignment Proposed',
  },
  {
    name: 'Assigned',
    id: '910004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 910,
    type: 'int',
    codeSet: 'CollStatusCodeSet',
    description: 'Assigned (Accepted)',
  },
  {
    name: 'Challenged',
    id: '910005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    tag: 910,
    type: 'int',
    codeSet: 'CollStatusCodeSet',
    description: 'Challenged',
  },
  {
    name: 'Reused',
    id: '910006',
    value: '5',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 910,
    type: 'int',
    codeSet: 'CollStatusCodeSet',
    description:
      'Reused\n\nA modification of the details of the collateral re-use. In the context of EU SFTR reporting, to be used with RegulatoryReportType(1934)=31 (Collateral update).',
  },
  {
    name: 'NotLastMessage',
    id: '912001',
    value: 'N',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 912,
    type: 'Boolean',
    codeSet: 'LastRptRequestedCodeSet',
    description: 'Not last message',
  },
  {
    name: 'LastMessage',
    id: '912002',
    value: 'Y',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 912,
    type: 'Boolean',
    codeSet: 'LastRptRequestedCodeSet',
    description: 'Last message',
  },
  {
    name: 'VersusPayment',
    id: '919001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 919,
    type: 'int',
    codeSet: 'DeliveryTypeCodeSet',
    description:
      '"Versus Payment": Deliver (if sell) or Receive (if buy) vs. (against) Payment',
  },
  {
    name: 'Free',
    id: '919002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 919,
    type: 'int',
    codeSet: 'DeliveryTypeCodeSet',
    description: '"Free": Deliver (if sell) or Receive (if buy) Free',
  },
  {
    name: 'TriParty',
    id: '919003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 919,
    type: 'int',
    codeSet: 'DeliveryTypeCodeSet',
    description: 'Tri-Party',
  },
  {
    name: 'HoldInCustody',
    id: '919004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 919,
    type: 'int',
    codeSet: 'DeliveryTypeCodeSet',
    description: 'Hold In Custody',
  },
  {
    name: 'DeliverByValue',
    id: '919005',
    value: '4',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 919,
    type: 'int',
    codeSet: 'DeliveryTypeCodeSet',
    description:
      'Deliver-by-Value\n\nIn the context of EU SFTR reporting, indicates that the transaction is to be or was settled using the DBV mechanism.',
  },
  {
    name: 'LogOnUser',
    id: '924001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 924,
    type: 'int',
    codeSet: 'UserRequestTypeCodeSet',
    description: 'Log On User',
  },
  {
    name: 'LogOffUser',
    id: '924002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 924,
    type: 'int',
    codeSet: 'UserRequestTypeCodeSet',
    description: 'Log Off User',
  },
  {
    name: 'ChangePasswordForUser',
    id: '924003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    tag: 924,
    type: 'int',
    codeSet: 'UserRequestTypeCodeSet',
    description: 'Change Password For User',
  },
  {
    name: 'RequestIndividualUserStatus',
    id: '924004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    tag: 924,
    type: 'int',
    codeSet: 'UserRequestTypeCodeSet',
    description: 'Request Individual User Status',
  },
  {
    name: 'RequestThrottleLimit',
    id: '924005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '116',
    tag: 924,
    type: 'int',
    codeSet: 'UserRequestTypeCodeSet',
    description: 'Request Throttle Limit',
  },
  {
    name: 'LoggedIn',
    id: '926001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 926,
    type: 'int',
    codeSet: 'UserStatusCodeSet',
    description: 'Logged In',
  },
  {
    name: 'NotLoggedIn',
    id: '926002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 926,
    type: 'int',
    codeSet: 'UserStatusCodeSet',
    description: 'Not Logged In',
  },
  {
    name: 'UserNotRecognised',
    id: '926003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    tag: 926,
    type: 'int',
    codeSet: 'UserStatusCodeSet',
    description: 'User Not Recognised',
  },
  {
    name: 'PasswordIncorrect',
    id: '926004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    tag: 926,
    type: 'int',
    codeSet: 'UserStatusCodeSet',
    description: 'Password Incorrect',
  },
  {
    name: 'PasswordChanged',
    id: '926005',
    value: '5',
    sort: 5,
    added: 'FIX.4.4',
    tag: 926,
    type: 'int',
    codeSet: 'UserStatusCodeSet',
    description: 'Password Changed',
  },
  {
    name: 'Other',
    id: '926006',
    value: '6',
    sort: 6,
    added: 'FIX.4.4',
    tag: 926,
    type: 'int',
    codeSet: 'UserStatusCodeSet',
    description: 'Other',
  },
];

const batch2: ISpecEnums[] = [
  {
    name: 'ForcedUserLogoutByExchange',
    id: '926007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0',
    addedEP: '56',
    tag: 926,
    type: 'int',
    codeSet: 'UserStatusCodeSet',
    description: 'Forced user logout by Exchange',
  },
  {
    name: 'SessionShutdownWarning',
    id: '926008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0',
    addedEP: '56',
    tag: 926,
    type: 'int',
    codeSet: 'UserStatusCodeSet',
    description: 'Session shutdown warning',
  },
  {
    name: 'ThrottleParametersChanged',
    id: '926009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '116',
    tag: 926,
    type: 'int',
    codeSet: 'UserStatusCodeSet',
    description: 'Throttle parameters changed',
  },
  {
    name: 'Connected',
    id: '928001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 928,
    type: 'int',
    codeSet: 'StatusValueCodeSet',
    description: 'Connected',
  },
  {
    name: 'NotConnectedUnexpected',
    id: '928002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 928,
    type: 'int',
    codeSet: 'StatusValueCodeSet',
    description: 'Not Connected - down expected up',
  },
  {
    name: 'NotConnectedExpected',
    id: '928003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    tag: 928,
    type: 'int',
    codeSet: 'StatusValueCodeSet',
    description: 'Not Connected - down expected down',
  },
  {
    name: 'InProcess',
    id: '928004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    tag: 928,
    type: 'int',
    codeSet: 'StatusValueCodeSet',
    description: 'In Process',
  },
  {
    name: 'Snapshot',
    id: '935001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 935,
    type: 'int',
    codeSet: 'NetworkRequestTypeCodeSet',
    description: 'Snapshot',
  },
  {
    name: 'Subscribe',
    id: '935002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 935,
    type: 'int',
    codeSet: 'NetworkRequestTypeCodeSet',
    description: 'Subscribe',
  },
  {
    name: 'StopSubscribing',
    id: '935003',
    value: '4',
    sort: 3,
    added: 'FIX.4.4',
    tag: 935,
    type: 'int',
    codeSet: 'NetworkRequestTypeCodeSet',
    description: 'Stop Subscribing',
  },
  {
    name: 'LevelOfDetail',
    id: '935004',
    value: '8',
    sort: 4,
    added: 'FIX.4.4',
    tag: 935,
    type: 'int',
    codeSet: 'NetworkRequestTypeCodeSet',
    description: "Level of Detail, then NoCompID's becomes required",
  },
  {
    name: 'Full',
    id: '937001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 937,
    type: 'int',
    codeSet: 'NetworkStatusResponseTypeCodeSet',
    description: 'Full',
  },
  {
    name: 'IncrementalUpdate',
    id: '937002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 937,
    type: 'int',
    codeSet: 'NetworkStatusResponseTypeCodeSet',
    description: 'Incremental Update',
  },
  {
    name: 'Accepted',
    id: '939001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 939,
    type: 'int',
    codeSet: 'TrdRptStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Rejected',
    id: '939002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 939,
    type: 'int',
    codeSet: 'TrdRptStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'Cancelled',
    id: '939003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 939,
    type: 'int',
    codeSet: 'TrdRptStatusCodeSet',
    description: 'Cancelled',
  },
  {
    name: 'AcceptedWithErrors',
    id: '939004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '13',
    updated: 'FIX.5.0SP2',
    updatedEP: '107',
    tag: 939,
    type: 'int',
    codeSet: 'TrdRptStatusCodeSet',
    description: 'Accepted with errors',
  },
  {
    name: 'PendingNew',
    id: '939005',
    value: '4',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 939,
    type: 'int',
    codeSet: 'TrdRptStatusCodeSet',
    description: 'Pending New',
  },
  {
    name: 'PendingCancel',
    id: '939006',
    value: '5',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 939,
    type: 'int',
    codeSet: 'TrdRptStatusCodeSet',
    description: 'Pending Cancel',
  },
  {
    name: 'PendingReplace',
    id: '939007',
    value: '6',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 939,
    type: 'int',
    codeSet: 'TrdRptStatusCodeSet',
    description: 'Pending Replace',
  },
  {
    name: 'Terminated',
    id: '939008',
    value: '7',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '165',
    tag: 939,
    type: 'int',
    codeSet: 'TrdRptStatusCodeSet',
    description: 'Terminated',
  },
  {
    name: 'PendingVerification',
    id: '939009',
    value: '8',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 939,
    type: 'int',
    codeSet: 'TrdRptStatusCodeSet',
    description:
      'Pending verification\n\nUsed in reports from the SDR to the regulator and to trading parties to indicate that the trade details have not been verified by one or both parties.',
  },
  {
    name: 'DeemedVerified',
    id: '939010',
    value: '9',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 939,
    type: 'int',
    codeSet: 'TrdRptStatusCodeSet',
    description:
      'Deemed verified\n\nUsed in reports from the SDR to the regulator and to trading parties to indicate that the trade details are deemed verified by the SDR but have not been confirmed by the trading parties.',
  },
  {
    name: 'Verified',
    id: '939011',
    value: '10',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 939,
    type: 'int',
    codeSet: 'TrdRptStatusCodeSet',
    description:
      'Verified\n\nUsed in reports from the SDR to the regulator and to trading parties to indicate that the trade details have been confirmed by the trading parties.',
  },
  {
    name: 'Disputed',
    id: '939012',
    value: '11',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 939,
    type: 'int',
    codeSet: 'TrdRptStatusCodeSet',
    description:
      'Disputed\n\nUsed in reports from the SDR to the regulator and to trading parties to indicate that the trade details have been disputed by a trading party.',
  },
  {
    name: 'Received',
    id: '940001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    tag: 940,
    type: 'int',
    codeSet: 'AffirmStatusCodeSet',
    description: 'Received',
  },
  {
    name: 'ConfirmRejected',
    id: '940002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    tag: 940,
    type: 'int',
    codeSet: 'AffirmStatusCodeSet',
    description: 'Confirm rejected, i.e. not affirmed',
  },
  {
    name: 'Affirmed',
    id: '940003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    tag: 940,
    type: 'int',
    codeSet: 'AffirmStatusCodeSet',
    description: 'Affirmed',
  },
  {
    name: 'Retain',
    id: '944001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 944,
    type: 'int',
    codeSet: 'CollActionCodeSet',
    description: 'Retain',
  },
  {
    name: 'Add',
    id: '944002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 944,
    type: 'int',
    codeSet: 'CollActionCodeSet',
    description: 'Add',
  },
  {
    name: 'Remove',
    id: '944003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 944,
    type: 'int',
    codeSet: 'CollActionCodeSet',
    description: 'Remove',
  },
  {
    name: 'Accepted',
    id: '945001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 945,
    type: 'int',
    codeSet: 'CollInquiryStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'AcceptedWithWarnings',
    id: '945002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 945,
    type: 'int',
    codeSet: 'CollInquiryStatusCodeSet',
    description: 'Accepted With Warnings',
  },
  {
    name: 'Completed',
    id: '945003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 945,
    type: 'int',
    codeSet: 'CollInquiryStatusCodeSet',
    description: 'Completed',
  },
  {
    name: 'CompletedWithWarnings',
    id: '945004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 945,
    type: 'int',
    codeSet: 'CollInquiryStatusCodeSet',
    description: 'Completed With Warnings',
  },
  {
    name: 'Rejected',
    id: '945005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    tag: 945,
    type: 'int',
    codeSet: 'CollInquiryStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'Successful',
    id: '946001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    tag: 946,
    type: 'int',
    codeSet: 'CollInquiryResultCodeSet',
    description: 'Successful (default)',
  },
  {
    name: 'InvalidOrUnknownInstrument',
    id: '946002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    tag: 946,
    type: 'int',
    codeSet: 'CollInquiryResultCodeSet',
    description: 'Invalid or unknown instrument',
  },
  {
    name: 'InvalidOrUnknownCollateralType',
    id: '946003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    tag: 946,
    type: 'int',
    codeSet: 'CollInquiryResultCodeSet',
    description: 'Invalid or unknown collateral type',
  },
  {
    name: 'InvalidParties',
    id: '946004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    tag: 946,
    type: 'int',
    codeSet: 'CollInquiryResultCodeSet',
    description: 'Invalid Parties',
  },
  {
    name: 'InvalidTransportTypeRequested',
    id: '946005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    tag: 946,
    type: 'int',
    codeSet: 'CollInquiryResultCodeSet',
    description: 'Invalid Transport Type requested',
  },
  {
    name: 'InvalidDestinationRequested',
    id: '946006',
    value: '5',
    sort: 6,
    added: 'FIX.4.4',
    tag: 946,
    type: 'int',
    codeSet: 'CollInquiryResultCodeSet',
    description: 'Invalid Destination requested',
  },
  {
    name: 'NoCollateralFoundForTheTradeSpecified',
    id: '946007',
    value: '6',
    sort: 7,
    added: 'FIX.4.4',
    tag: 946,
    type: 'int',
    codeSet: 'CollInquiryResultCodeSet',
    description: 'No collateral found for the trade specified',
  },
  {
    name: 'NoCollateralFoundForTheOrderSpecified',
    id: '946008',
    value: '7',
    sort: 8,
    added: 'FIX.4.4',
    tag: 946,
    type: 'int',
    codeSet: 'CollInquiryResultCodeSet',
    description: 'No collateral found for the order specified',
  },
  {
    name: 'CollateralInquiryTypeNotSupported',
    id: '946009',
    value: '8',
    sort: 9,
    added: 'FIX.4.4',
    tag: 946,
    type: 'int',
    codeSet: 'CollInquiryResultCodeSet',
    description: 'Collateral inquiry type not supported',
  },
  {
    name: 'UnauthorizedForCollateralInquiry',
    id: '946010',
    value: '9',
    sort: 10,
    added: 'FIX.4.4',
    tag: 946,
    type: 'int',
    codeSet: 'CollInquiryResultCodeSet',
    description: 'Unauthorized for collateral inquiry',
  },
  {
    name: 'Other',
    id: '946011',
    value: '99',
    sort: 99,
    added: 'FIX.4.4',
    tag: 946,
    type: 'int',
    codeSet: 'CollInquiryResultCodeSet',
    description: 'Other (further information in Text (58) field)',
  },
  {
    name: 'Int',
    id: '959001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'Int',
  },
  {
    name: 'Length',
    id: '959002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'Length',
  },
  {
    name: 'NumInGroup',
    id: '959003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'NumInGroup',
  },
  {
    name: 'SeqNum',
    id: '959004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'SeqNum',
  },
  {
    name: 'TagNum',
    id: '959005',
    value: '5',
    sort: 5,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'TagNum',
  },
  {
    name: 'Float',
    id: '959006',
    value: '6',
    sort: 6,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'float',
  },
  {
    name: 'Qty',
    id: '959007',
    value: '7',
    sort: 7,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'Qty',
  },
  {
    name: 'Price',
    id: '959008',
    value: '8',
    sort: 8,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'Price',
  },
  {
    name: 'PriceOffset',
    id: '959009',
    value: '9',
    sort: 9,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'PriceOffset',
  },
  {
    name: 'Amt',
    id: '959010',
    value: '10',
    sort: 10,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'Amt',
  },
  {
    name: 'Percentage',
    id: '959011',
    value: '11',
    sort: 11,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'Percentage',
  },
  {
    name: 'Char',
    id: '959012',
    value: '12',
    sort: 12,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'Char',
  },
  {
    name: 'Boolean',
    id: '959013',
    value: '13',
    sort: 13,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'Boolean',
  },
  {
    name: 'String',
    id: '959014',
    value: '14',
    sort: 14,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'String',
  },
  {
    name: 'MultipleCharValue',
    id: '959015',
    value: '15',
    sort: 15,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'MultipleCharValue',
  },
  {
    name: 'Currency',
    id: '959016',
    value: '16',
    sort: 16,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'Currency',
  },
  {
    name: 'Exchange',
    id: '959017',
    value: '17',
    sort: 17,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'Exchange',
  },
  {
    name: 'MonthYear',
    id: '959018',
    value: '18',
    sort: 18,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'MonthYear',
  },
  {
    name: 'UTCTimestamp',
    id: '959019',
    value: '19',
    sort: 19,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'UTCTimestamp',
  },
  {
    name: 'UTCTimeOnly',
    id: '959020',
    value: '20',
    sort: 20,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'UTCTimeOnly',
  },
  {
    name: 'LocalMktDate',
    id: '959021',
    value: '21',
    sort: 21,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'LocalMktDate',
  },
  {
    name: 'UTCDateOnly',
    id: '959022',
    value: '22',
    sort: 22,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'UTCDateOnly',
  },
  {
    name: 'Data',
    id: '959023',
    value: '23',
    sort: 23,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'data',
  },
  {
    name: 'MultipleStringValue',
    id: '959024',
    value: '24',
    sort: 24,
    added: 'FIX.4.4',
    addedEP: '34',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'MultipleStringValue',
  },
  {
    name: 'Country',
    id: '959025',
    value: '25',
    sort: 25,
    added: 'FIX.5.0SP1',
    addedEP: '95',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'Country',
  },
  {
    name: 'Language',
    id: '959026',
    value: '26',
    sort: 26,
    added: 'FIX.5.0SP1',
    addedEP: '95',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'Language',
  },
  {
    name: 'TZTimeOnly',
    id: '959027',
    value: '27',
    sort: 27,
    added: 'FIX.5.0SP1',
    addedEP: '95',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'TZTimeOnly',
  },
  {
    name: 'TZTimestamp',
    id: '959028',
    value: '28',
    sort: 28,
    added: 'FIX.5.0SP1',
    addedEP: '95',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'TZTimestamp',
  },
  {
    name: 'Tenor',
    id: '959029',
    value: '29',
    sort: 29,
    added: 'FIX.5.0SP1',
    addedEP: '95',
    tag: 959,
    type: 'int',
    codeSet: 'StrategyParameterTypeCodeSet',
    description: 'Tenor',
  },
  {
    name: 'Active',
    id: '965001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '195',
    tag: 965,
    type: 'String',
    codeSet: 'SecurityStatusCodeSet',
    description: 'Active\n\nInstrument is active, i.e. trading is possible.',
  },
  {
    name: 'Inactive',
    id: '965002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '195',
    tag: 965,
    type: 'String',
    codeSet: 'SecurityStatusCodeSet',
    description:
      'Inactive\n\nInstrument has previously been active and is now no longer traded but has not expired yet. The instrument may become active again.',
  },
  {
    name: 'ActiveClosingOrdersOnly',
    id: '965003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 965,
    type: 'String',
    codeSet: 'SecurityStatusCodeSet',
    description:
      'Active, closing orders only\n\nInstrument is active but only orders closing positions (reducing risk) are allowed.',
  },
  {
    name: 'Expired',
    id: '965004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 965,
    type: 'String',
    codeSet: 'SecurityStatusCodeSet',
    description:
      'Expired\n\nInstrument has expired. E.g. An instrument may expire due to reaching maturity or expired based on contract definitions or exchange rules.',
  },
  {
    name: 'Delisted',
    id: '965005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 965,
    type: 'String',
    codeSet: 'SecurityStatusCodeSet',
    description:
      'Delisted\n\nInstrument has been removed from securities reference data. Delisting rules varies from exchange to exchange, which may include non-compliance of capitalization, revenue, consecutive minimum closing price. The instrument may become listed again once the instrument is back in compliance. A delisted instrument would not trade on the exchange but it may still be traded over-the-counter (e.g. OTCBB) or on Pink Sheets, or other similar trading service.',
  },
  {
    name: 'KnockedOut',
    id: '965006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 965,
    type: 'String',
    codeSet: 'SecurityStatusCodeSet',
    description: 'Knocked-out\n\nInstrument has breached a pre-defined price threshold.',
  },
  {
    name: 'KnockOutRevoked',
    id: '965007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 965,
    type: 'String',
    codeSet: 'SecurityStatusCodeSet',
    description:
      'Knock-out revoked\n\nInstrument reinstated, i.e. threshold has not been breached.',
  },
  {
    name: 'PendingExpiry',
    id: '965008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 965,
    type: 'String',
    codeSet: 'SecurityStatusCodeSet',
    description:
      "Pending Expiry\n\nInstrument is currently still active but will expire after the current business day. For example, a contract that expires intra-day (e.g. at noon time) and is no longer tradeable but will still show up in the current day's order book with related statistics.",
  },
  {
    name: 'Suspended',
    id: '965009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 965,
    type: 'String',
    codeSet: 'SecurityStatusCodeSet',
    description:
      'Suspended\n\nInstrument has been temporarily disabled for trading (i.e. halted).',
  },
  {
    name: 'Published',
    id: '965010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 965,
    type: 'String',
    codeSet: 'SecurityStatusCodeSet',
    description:
      'Published\n\nInstrument information is provided prior to its first activation.',
  },
  {
    name: 'PendingDeletion',
    id: '965011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 965,
    type: 'String',
    codeSet: 'SecurityStatusCodeSet',
    description:
      'Pending Deletion\n\nInstrument is awaiting deletion from security reference data.',
  },
  {
    name: 'FIXED',
    id: '974001',
    value: 'FIXED',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 974,
    type: 'String',
    codeSet: 'UnderlyingCashTypeCodeSet',
    description: 'FIXED',
  },
  {
    name: 'DIFF',
    id: '974002',
    value: 'DIFF',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 974,
    type: 'String',
    codeSet: 'UnderlyingCashTypeCodeSet',
    description: 'DIFF',
  },
  {
    name: 'TPlus1',
    id: '975001',
    value: '2',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 975,
    type: 'int',
    codeSet: 'UnderlyingSettlementTypeCodeSet',
    description: 'T+1',
  },
  {
    name: 'TPlus3',
    id: '975002',
    value: '4',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 975,
    type: 'int',
    codeSet: 'UnderlyingSettlementTypeCodeSet',
    description: 'T+3',
  },
  {
    name: 'TPlus4',
    id: '975003',
    value: '5',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 975,
    type: 'int',
    codeSet: 'UnderlyingSettlementTypeCodeSet',
    description: 'T+4',
  },
  {
    name: 'Add',
    id: '980001',
    value: 'A',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '8',
    tag: 980,
    type: 'char',
    codeSet: 'SecurityUpdateActionCodeSet',
    description: 'Add',
  },
  {
    name: 'Delete',
    id: '980002',
    value: 'D',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '8',
    tag: 980,
    type: 'char',
    codeSet: 'SecurityUpdateActionCodeSet',
    description: 'Delete',
  },
  {
    name: 'Modify',
    id: '980003',
    value: 'M',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '8',
    tag: 980,
    type: 'char',
    codeSet: 'SecurityUpdateActionCodeSet',
    description: 'Modify',
  },
  {
    name: 'AutoExercise',
    id: '982001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 982,
    type: 'int',
    codeSet: 'ExpirationQtyTypeCodeSet',
    description: 'Auto Exercise',
  },
  {
    name: 'NonAutoExercise',
    id: '982002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 982,
    type: 'int',
    codeSet: 'ExpirationQtyTypeCodeSet',
    description: 'Non Auto Exercise',
  },
  {
    name: 'FinalWillBeExercised',
    id: '982003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 982,
    type: 'int',
    codeSet: 'ExpirationQtyTypeCodeSet',
    description: 'Final Will Be Exercised',
  },
  {
    name: 'ContraryIntention',
    id: '982004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 982,
    type: 'int',
    codeSet: 'ExpirationQtyTypeCodeSet',
    description: 'Contrary Intention',
  },
  {
    name: 'Difference',
    id: '982005',
    value: '5',
    sort: 5,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 982,
    type: 'int',
    codeSet: 'ExpirationQtyTypeCodeSet',
    description: 'Difference',
  },
  {
    name: 'SubAllocate',
    id: '992001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 992,
    type: 'int',
    codeSet: 'IndividualAllocTypeCodeSet',
    description: 'Sub Allocate',
  },
  {
    name: 'ThirdPartyAllocation',
    id: '992002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 992,
    type: 'int',
    codeSet: 'IndividualAllocTypeCodeSet',
    description: 'Third Party Allocation',
  },
  {
    name: 'BillionCubicFeet',
    id: '996001',
    value: 'Bcf',
    sort: 1,
    group: 'Fixed Magnitude UOM',
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Billion cubic feet',
  },
  {
    name: 'CubicMeters',
    id: '996002',
    value: 'CBM',
    sort: 2,
    group: 'Fixed Magnitude UOM',
    added: 'FIX.5.0SP2',
    addedEP: '107',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Cubic Meters',
  },
  {
    name: 'Gigajoules',
    id: '996003',
    value: 'GJ',
    sort: 3,
    group: 'Fixed Magnitude UOM',
    added: 'FIX.5.0SP2',
    addedEP: '152',
    updated: 'FIX.5.0SP2',
    updatedEP: '259',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'gigajoules',
  },
  {
    name: 'HeatRate',
    id: '996004',
    value: 'kHR',
    sort: 4,
    group: 'Fixed Magnitude UOM',
    added: 'FIX.5.0SP2',
    addedEP: '243',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description:
      'Heat rate\n\nThe number of BTUs required to produce one kilowatt hour of electricity, typically 3,412.14 BTUs per 1 kWh.',
  },
  {
    name: 'KilowattHours',
    id: '996005',
    value: 'kWh',
    sort: 5,
    group: 'Fixed Magnitude UOM',
    added: 'FIX.5.0SP2',
    addedEP: '137',
    updated: 'FIX.5.0SP2',
    updatedEP: '243',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Kilowatt hours',
  },
  {
    name: 'MegaHeatRate',
    id: '996006',
    value: 'MHR',
    sort: 6,
    group: 'Fixed Magnitude UOM',
    added: 'FIX.5.0SP2',
    addedEP: '243',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description:
      'Mega heat rate\n\nThe number of million BTUs required to produce one megawatt hour of electricity, typically 3.41214 million BTUs per 1 MWh.',
  },
  {
    name: 'OneMillionBTU',
    id: '996007',
    value: 'MMBtu',
    sort: 7,
    group: 'Fixed Magnitude UOM',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '243',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'One Million BTU',
  },
  {
    name: 'MegawattHours',
    id: '996008',
    value: 'MWh',
    sort: 8,
    group: 'Fixed Magnitude UOM',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '243',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Megawatt hours',
  },
  {
    name: 'Therms',
    id: '996009',
    value: 'thm',
    sort: 9,
    group: 'Fixed Magnitude UOM',
    added: 'FIX.5.0SP2',
    addedEP: '152',
    updated: 'FIX.5.0SP2',
    updatedEP: '259',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'therms\n\nEqual to 100,000 BTU',
  },
  {
    name: 'TonsOfCarbonDioxide',
    id: '996010',
    value: 'tnCO2',
    sort: 10,
    group: 'Fixed Magnitude UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Tons of carbon dioxide',
  },
  {
    name: 'MillionBarrels',
    id: '996011',
    value: 'MMbbl',
    sort: 99,
    group: 'Fixed Magnitude UOM',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    deprecated: 'FIX.5.0SP1',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Million Barrels',
  },
  {
    name: 'Allowances',
    id: '996012',
    value: 'Alw',
    sort: 1,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP1',
    addedEP: '89',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Allowances',
  },
  {
    name: 'Barrels',
    id: '996013',
    value: 'Bbl',
    sort: 2,
    group: 'Variable Quantity UOM',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Barrels\n\nEqual to 42 US gallons',
  },
  {
    name: 'BoardFeet',
    id: '996014',
    value: 'BDFT',
    sort: 3,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '122',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Board feet\n\nEqual to 144 cubic inches',
  },
  {
    name: 'Bushels',
    id: '996015',
    value: 'Bu',
    sort: 4,
    group: 'Variable Quantity UOM',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Bushels',
  },
  {
    name: 'Currency',
    id: '996016',
    value: 'Ccy',
    sort: 5,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '122',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Amount of currency',
  },
  {
    name: 'CoolingDegreeDay',
    id: '996017',
    value: 'CDD',
    sort: 6,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Cooling degree day',
  },
  {
    name: 'CertifiedEmissionsReduction',
    id: '996018',
    value: 'CER',
    sort: 7,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '107',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Certified emissions reduction',
  },
  {
    name: 'CriticalPrecipDay',
    id: '996019',
    value: 'CPD',
    sort: 8,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Critical precipitation day',
  },
  {
    name: 'ClimateReserveTonnes',
    id: '996020',
    value: 'CRT',
    sort: 9,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '114',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Climate reserve tonnes',
  },
  {
    name: 'Hundredweight',
    id: '996021',
    value: 'cwt',
    sort: 10,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '122',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Hundredweight(US)\n\nEqual to 100 lbs',
  },
  {
    name: 'Day',
    id: '996022',
    value: 'day',
    sort: 11,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '122',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Days',
  },
  {
    name: 'DryMetricTons',
    id: '996023',
    value: 'dt',
    sort: 12,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '122',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Dry metric tons',
  },
  {
    name: 'EnvAllwncCert',
    id: '996024',
    value: 'EnvAllwnc',
    sort: 13,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Environmental allowance certificates',
  },
  {
    name: 'EnvironmentalCredit',
    id: '996025',
    value: 'EnvCrd',
    sort: 14,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '137',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Environmental credit',
  },
  {
    name: 'EnvironmentalOffset',
    id: '996026',
    value: 'EnvOfst',
    sort: 15,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '137',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Environmental Offset',
  },
  {
    name: 'Grams',
    id: '996027',
    value: 'g',
    sort: 16,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '122',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Grams',
  },
  {
    name: 'Gallons',
    id: '996028',
    value: 'Gal',
    sort: 17,
    group: 'Variable Quantity UOM',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Gallons',
  },
  {
    name: 'GrossTons',
    id: '996029',
    value: 'GT',
    sort: 18,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '154',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description:
      'Gross tons\n\nAlso known as long tons or imperial tons, equal to 2240 lbs',
  },
  {
    name: 'HeatingDegreeDay',
    id: '996030',
    value: 'HDD',
    sort: 19,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Heating degree day',
  },
  {
    name: 'IndexPoint',
    id: '996031',
    value: 'IPNT',
    sort: 20,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '122',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Index point',
  },
  {
    name: 'Kilograms',
    id: '996032',
    value: 'kg',
    sort: 21,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '154',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Kilograms',
  },
  {
    name: 'Kiloliters',
    id: '996033',
    value: 'kL',
    sort: 22,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '152',
    updated: 'FIX.5.0SP2',
    updatedEP: '259',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'kiloliters',
  },
  {
    name: 'KilowattYear',
    id: '996034',
    value: 'kW-a',
    sort: 23,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '137',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Kilowatt year (electrical capacity)',
  },
  {
    name: 'KilowattDay',
    id: '996035',
    value: 'kW-d',
    sort: 24,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '137',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Kilowatt day (electrical capacity)',
  },
  {
    name: 'KilowattHour',
    id: '996036',
    value: 'kW-h',
    sort: 25,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '137',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Kilowatt hour (electrical capacity)',
  },
  {
    name: 'KilowattMonth',
    id: '996037',
    value: 'kW-M',
    sort: 26,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '137',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Kilowatt month (electrical capacity)',
  },
  {
    name: 'KilowattMinute',
    id: '996038',
    value: 'kW-min',
    sort: 27,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '137',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Kilowatt-Minute (electrical capacity)',
  },
  {
    name: 'Liters',
    id: '996039',
    value: 'L',
    sort: 28,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '152',
    updated: 'FIX.5.0SP2',
    updatedEP: '259',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'liters',
  },
  {
    name: 'Pounds',
    id: '996040',
    value: 'lbs',
    sort: 29,
    group: 'Variable Quantity UOM',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'pounds',
  },
  {
    name: 'MegawattYear',
    id: '996041',
    value: 'MW-a',
    sort: 30,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '137',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Megawatt year (electrical capacity)',
  },
  {
    name: 'MegawattDay',
    id: '996042',
    value: 'MW-d',
    sort: 31,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '137',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Megawatt day (electrical capacity)',
  },
  {
    name: 'MegawattHour',
    id: '996043',
    value: 'MW-h',
    sort: 32,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '137',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Megawatt hour (electrical capacity)',
  },
  {
    name: 'MegawattMonth',
    id: '996044',
    value: 'MW-M',
    sort: 33,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '137',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Megawatt month (electrical capacity)',
  },
  {
    name: 'MegawattMinute',
    id: '996045',
    value: 'MW-min',
    sort: 34,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '137',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Megawatt minute (electrical capacity)',
  },
  {
    name: 'TroyOunces',
    id: '996046',
    value: 'oz_tr',
    sort: 35,
    group: 'Variable Quantity UOM',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Troy ounces',
  },
  {
    name: 'PrincipalWithRelationToDebtInstrument',
    id: '996047',
    value: 'PRINC',
    sort: 36,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '107',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Principal with relation to debt instrument',
  },
  {
    name: 'MetricTons',
    id: '996048',
    value: 't',
    sort: 37,
    group: 'Variable Quantity UOM',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Metric tons\n\nAlso known as Tonnes, equal to 1000 kg',
  },
  {
    name: 'Tons',
    id: '996049',
    value: 'tn',
    sort: 38,
    group: 'Variable Quantity UOM',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Tons (US)\n\nEqual to 2000 lbs',
  },
  {
    name: 'Are',
    id: '996050',
    value: 'a',
    sort: 39,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Are',
  },
  {
    name: 'Acre',
    id: '996051',
    value: 'ac',
    sort: 40,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Acre',
  },
  {
    name: 'Centiliter',
    id: '996052',
    value: 'cL',
    sort: 41,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Centiliter',
  },
  {
    name: 'Centimeter',
    id: '996053',
    value: 'cM',
    sort: 42,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Centimeter',
  },
  {
    name: 'DieselGallonEquivalent',
    id: '996054',
    value: 'DGE',
    sort: 43,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Diesel gallon equivalent',
  },
  {
    name: 'Foot',
    id: '996055',
    value: 'ft',
    sort: 44,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Foot',
  },
  {
    name: 'GBGallon',
    id: '996056',
    value: 'Gal_gb',
    sort: 45,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'GB Gallon',
  },
  {
    name: 'GasolineGallonEquivalent',
    id: '996057',
    value: 'GGE',
    sort: 46,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Gasonline gallon equivalent',
  },
  {
    name: 'Hectare',
    id: '996058',
    value: 'ha',
    sort: 47,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Hectare',
  },
  {
    name: 'Inch',
    id: '996059',
    value: 'in',
    sort: 48,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Inch',
  },
  {
    name: 'Kilometer',
    id: '996060',
    value: 'kM',
    sort: 49,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Kilometer',
  },
  {
    name: 'Meter',
    id: '996061',
    value: 'M',
    sort: 50,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Meter',
  },
  {
    name: 'Mile',
    id: '996062',
    value: 'mi',
    sort: 51,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Mile',
  },
  {
    name: 'Milliliter',
    id: '996063',
    value: 'mL',
    sort: 52,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Milliliter',
  },
  {
    name: 'Millimeter',
    id: '996064',
    value: 'mM',
    sort: 53,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Millimeter',
  },
  {
    name: 'USOunce',
    id: '996065',
    value: 'oz',
    sort: 54,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'US ounce',
  },
  {
    name: 'Piece',
    id: '996066',
    value: 'pc',
    sort: 55,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Piece',
  },
  {
    name: 'USPint',
    id: '996067',
    value: 'pt',
    sort: 56,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'US Pint',
  },
  {
    name: 'GBPint',
    id: '996068',
    value: 'pt_gb',
    sort: 57,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'GB pint',
  },
  {
    name: 'USQuart',
    id: '996069',
    value: 'qt',
    sort: 58,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'US Quart',
  },
  {
    name: 'GBQuart',
    id: '996070',
    value: 'qt_gb',
    sort: 59,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'GB Quart',
  },
  {
    name: 'SquareCentimeter',
    id: '996071',
    value: 'SqcM',
    sort: 60,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Square centimeter',
  },
  {
    name: 'SquareFoot',
    id: '996072',
    value: 'Sqft',
    sort: 61,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Square foot',
  },
  {
    name: 'SquareInch',
    id: '996073',
    value: 'Sqin',
    sort: 62,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Square inch',
  },
  {
    name: 'SquareKilometer',
    id: '996074',
    value: 'SqkM',
    sort: 63,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Square kilometer',
  },
  {
    name: 'SquareMeter',
    id: '996075',
    value: 'SqM',
    sort: 64,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Square meter',
  },
  {
    name: 'SquareMile',
    id: '996076',
    value: 'Sqmi',
    sort: 65,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Square mile',
  },
  {
    name: 'SquareMillimeter',
    id: '996077',
    value: 'SqmM',
    sort: 66,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Square millimeter',
  },
  {
    name: 'SquareYard',
    id: '996078',
    value: 'Sqyd',
    sort: 67,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Square yard',
  },
  {
    name: 'Yard',
    id: '996079',
    value: 'yd',
    sort: 68,
    group: 'Variable Quantity UOM',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'Yard',
  },
  {
    name: 'USDollars',
    id: '996080',
    value: 'USD',
    sort: 99,
    group: 'Variable Quantity UOM',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    deprecated: 'FIX.5.0SP2',
    deprecatedEP: '122',
    tag: 996,
    type: 'String',
    codeSet: 'UnitOfMeasureCodeSet',
    description: 'US Dollars',
  },
  {
    name: 'Hour',
    id: '997001',
    value: 'H',
    sort: 0,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 997,
    type: 'String',
    codeSet: 'TimeUnitCodeSet',
    description: 'Hour',
  },
  {
    name: 'Minute',
    id: '997002',
    value: 'Min',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 997,
    type: 'String',
    codeSet: 'TimeUnitCodeSet',
    description: 'Minute',
  },
  {
    name: 'Second',
    id: '997003',
    value: 'S',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 997,
    type: 'String',
    codeSet: 'TimeUnitCodeSet',
    description: 'Second',
  },
  {
    name: 'Day',
    id: '997004',
    value: 'D',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 997,
    type: 'String',
    codeSet: 'TimeUnitCodeSet',
    description: 'Day',
  },
  {
    name: 'Week',
    id: '997005',
    value: 'Wk',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 997,
    type: 'String',
    codeSet: 'TimeUnitCodeSet',
    description: 'Week',
  },
  {
    name: 'Month',
    id: '997006',
    value: 'Mo',
    sort: 5,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 997,
    type: 'String',
    codeSet: 'TimeUnitCodeSet',
    description: 'Month',
  },
  {
    name: 'Year',
    id: '997007',
    value: 'Yr',
    sort: 6,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 997,
    type: 'String',
    codeSet: 'TimeUnitCodeSet',
    description: 'Year',
  },
  {
    name: 'Quarter',
    id: '997008',
    value: 'Q',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 997,
    type: 'String',
    codeSet: 'TimeUnitCodeSet',
    description: 'Quarter',
  },
  {
    name: 'EndOfMonth',
    id: '997009',
    value: 'EOM',
    sort: 8,
    added: 'FIX.Latest',
    addedEP: '287',
    tag: 997,
    type: 'String',
    codeSet: 'TimeUnitCodeSet',
    description:
      'End of Month\n\nEnd of Month identifies a relative time unit, e.g. until the third Friday of each month.',
  },
  {
    name: 'Flexible',
    id: '997010',
    value: 'F',
    sort: 9,
    added: 'FIX.Latest',
    addedEP: '287',
    tag: 997,
    type: 'String',
    codeSet: 'TimeUnitCodeSet',
    description:
      'Flexible\n\nA flexible time unit indicates that a specific time unit for the contract is currently undetermined.',
  },
  {
    name: 'Automatic',
    id: '1002001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1002,
    type: 'int',
    codeSet: 'AllocMethodCodeSet',
    description: 'Automatic',
  },
  {
    name: 'Guarantor',
    id: '1002002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1002,
    type: 'int',
    codeSet: 'AllocMethodCodeSet',
    description: 'Guarantor',
  },
  {
    name: 'Manual',
    id: '1002003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1002,
    type: 'int',
    codeSet: 'AllocMethodCodeSet',
    description: 'Manual',
  },
  {
    name: 'BrokerAssigned',
    id: '1002004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 1002,
    type: 'int',
    codeSet: 'AllocMethodCodeSet',
    description: 'Broker assigned',
  },
  {
    name: 'False',
    id: '1015001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1015,
    type: 'char',
    codeSet: 'AsOfIndicatorCodeSet',
    description: 'false - trade is not an AsOf trade',
  },
  {
    name: 'True',
    id: '1015002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1015,
    type: 'char',
    codeSet: 'AsOfIndicatorCodeSet',
    description: 'true - trade is an AsOf trade',
  },
  {
    name: 'TopOfBook',
    id: '1021001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1021,
    type: 'int',
    codeSet: 'MDBookTypeCodeSet',
    description: 'Top of Book',
  },
  {
    name: 'PriceDepth',
    id: '1021002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1021,
    type: 'int',
    codeSet: 'MDBookTypeCodeSet',
    description: 'Price Depth',
  },
  {
    name: 'OrderDepth',
    id: '1021003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1021,
    type: 'int',
    codeSet: 'MDBookTypeCodeSet',
    description: 'Order Depth',
  },
  {
    name: 'Book',
    id: '1024001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1024,
    type: 'int',
    codeSet: 'MDOriginTypeCodeSet',
    description: 'Book',
  },
  {
    name: 'OffBook',
    id: '1024002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1024,
    type: 'int',
    codeSet: 'MDOriginTypeCodeSet',
    description: 'Off-Book',
  },
  {
    name: 'Cross',
    id: '1024003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1024,
    type: 'int',
    codeSet: 'MDOriginTypeCodeSet',
    description: 'Cross',
  },
  {
    name: 'QuoteDrivenMarket',
    id: '1024004',
    value: '3',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '163',
    tag: 1024,
    type: 'int',
    codeSet: 'MDOriginTypeCodeSet',
    description:
      'Quote driven market\n\nExamples for quote driven markets are market maker or specialist market models.',
  },
  {
    name: 'DarkOrderBook',
    id: '1024005',
    value: '4',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '163',
    tag: 1024,
    type: 'int',
    codeSet: 'MDOriginTypeCodeSet',
    description: 'Dark order book',
  },
  {
    name: 'AuctionDrivenMarket',
    id: '1024006',
    value: '5',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 1024,
    type: 'int',
    codeSet: 'MDOriginTypeCodeSet',
    description:
      'Auction driven market\n\nMarkets where matching occurs only in scheduled auctions.',
  },
  {
    name: 'QuoteNegotiation',
    id: '1024007',
    value: '6',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 1024,
    type: 'int',
    codeSet: 'MDOriginTypeCodeSet',
    description:
      'Quote negotiation\n\nDiscretionary quoting on request or "request for quote" market.',
  },
  {
    name: 'VoiceNegotiation',
    id: '1024008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    tag: 1024,
    type: 'int',
    codeSet: 'MDOriginTypeCodeSet',
    description:
      'Voice negotiation\n\nA trading system where transactions between members are arranged through voice negotiation.',
  },
  {
    name: 'HybridMarket',
    id: '1024009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    updated: 'FIX.Latest',
    updatedEP: '286',
    tag: 1024,
    type: 'int',
    codeSet: 'MDOriginTypeCodeSet',
    description:
      'Hybrid market\n\nA hybrid system falling into two or more types of trading systems. In the context of ESMA reporting, this is for "Hybrid system." In the context of FCA reporting, this is for "Any other, including hybrid."',
  },
  {
    name: 'OtherMarket',
    id: '1024010',
    value: '9',
    sort: 9,
    added: 'FIX.Latest',
    addedEP: '286',
    tag: 1024,
    type: 'int',
    codeSet: 'MDOriginTypeCodeSet',
    description:
      'Other market\n\nA market that does not fall under any of the market types defined for MDOriginType(1024). In the context of ESMA reporting, this is for "Any other, excluding hybrid."',
  },
  {
    name: 'PhoneSimple',
    id: '1031001',
    value: 'A',
    sort: 0,
    group: 'FIA Execution Source Code',
    added: 'FIX.5.0SP2',
    addedEP: '133',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Phone simple',
  },
  {
    name: 'PhoneComplex',
    id: '1031002',
    value: 'B',
    sort: 1,
    group: 'FIA Execution Source Code',
    added: 'FIX.5.0SP2',
    addedEP: '133',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Phone complex',
  },
  {
    name: 'FCMProvidedScreen',
    id: '1031003',
    value: 'C',
    sort: 2,
    group: 'FIA Execution Source Code',
    added: 'FIX.5.0SP2',
    addedEP: '133',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'FCM provided screen',
  },
  {
    name: 'OtherProvidedScreen',
    id: '1031004',
    value: 'D',
    sort: 3,
    group: 'FIA Execution Source Code',
    added: 'FIX.5.0SP2',
    addedEP: '133',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Other provided screen',
  },
  {
    name: 'ClientProvidedPlatformControlledByFCM',
    id: '1031005',
    value: 'E',
    sort: 4,
    group: 'FIA Execution Source Code',
    added: 'FIX.5.0SP2',
    addedEP: '133',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Client provided platform controlled by FCM',
  },
  {
    name: 'ClientProvidedPlatformDirectToExchange',
    id: '1031006',
    value: 'F',
    sort: 5,
    group: 'FIA Execution Source Code',
    added: 'FIX.5.0SP2',
    addedEP: '133',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Client provided platform direct to exchange',
  },
  {
    name: 'AlgoEngine',
    id: '1031007',
    value: 'H',
    sort: 7,
    group: 'FIA Execution Source Code',
    added: 'FIX.5.0SP2',
    addedEP: '133',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Algo engine',
  },
  {
    name: 'PriceAtExecution',
    id: '1031008',
    value: 'J',
    sort: 8,
    group: 'FIA Execution Source Code',
    added: 'FIX.5.0SP2',
    addedEP: '133',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description:
      'Price at execution (price added at initial order entry, trading, middle office or time of give-up)',
  },
  {
    name: 'DeskElectronic',
    id: '1031009',
    value: 'W',
    sort: 9,
    group: 'FIA Execution Source Code',
    added: 'FIX.5.0SP2',
    addedEP: '133',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Desk - electronic',
  },
  {
    name: 'DeskPit',
    id: '1031010',
    value: 'X',
    sort: 10,
    group: 'FIA Execution Source Code',
    added: 'FIX.5.0SP2',
    addedEP: '133',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Desk - pit',
  },
  {
    name: 'ClientElectronic',
    id: '1031011',
    value: 'Y',
    sort: 11,
    group: 'FIA Execution Source Code',
    added: 'FIX.5.0SP2',
    addedEP: '133',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Client - electronic',
  },
  {
    name: 'ClientPit',
    id: '1031012',
    value: 'Z',
    sort: 12,
    group: 'FIA Execution Source Code',
    added: 'FIX.5.0SP2',
    addedEP: '133',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Client - pit',
  },
  {
    name: 'AddOnOrder',
    id: '1031013',
    value: 'ADD',
    sort: 1,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Add-on order',
  },
  {
    name: 'AllOrNone',
    id: '1031014',
    value: 'AON',
    sort: 2,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'All or none',
  },
  {
    name: 'ConditionalOrder',
    id: '1031015',
    value: 'CND',
    sort: 3,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Conditional order',
  },
  {
    name: 'CashNotHeld',
    id: '1031016',
    value: 'CNH',
    sort: 4,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Cash not held',
  },
  {
    name: 'DeliveryInstructionsCash',
    id: '1031017',
    value: 'CSH',
    sort: 5,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Delivery instructions - cash',
  },
  {
    name: 'DirectedOrder',
    id: '1031018',
    value: 'DIR',
    sort: 6,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Directed order',
  },
  {
    name: 'DiscretionaryLimitOrder',
    id: '1031019',
    value: 'DLO',
    sort: 7,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Discretionary limit order',
  },
  {
    name: 'ExchangeForPhysicalTransaction',
    id: '1031020',
    value: 'E.W',
    sort: 8,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Exchange for physical transaction',
  },
  {
    name: 'FillOrKill',
    id: '1031021',
    value: 'FOK',
    sort: 9,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Fill or kill',
  },
  {
    name: 'IntraDayCross',
    id: '1031022',
    value: 'IDX',
    sort: 11,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Intraday cross',
  },
  {
    name: 'ImbalanceOnly',
    id: '1031023',
    value: 'IO',
    sort: 12,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Imbalance only',
  },
  {
    name: 'ImmediateOrCancel',
    id: '1031024',
    value: 'IOC',
    sort: 13,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Immediate or cancel',
  },
  {
    name: 'IntermarketSweepOrder',
    id: '1031025',
    value: 'ISO',
    sort: 14,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Intermarket sweep order',
  },
  {
    name: 'LimitOnOpen',
    id: '1031026',
    value: 'LOO',
    sort: 15,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Limit on open',
  },
  {
    name: 'LimitOnClose',
    id: '1031027',
    value: 'LOC',
    sort: 16,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Limit on Close',
  },
  {
    name: 'MarketAtOpen',
    id: '1031028',
    value: 'MAO',
    sort: 17,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Market at Open',
  },
  {
    name: 'MarketAtClose',
    id: '1031029',
    value: 'MAC',
    sort: 18,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Market at close',
  },
  {
    name: 'MarketOnOpen',
    id: '1031030',
    value: 'MOO',
    sort: 19,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Market on open',
  },
  {
    name: 'MarketOnClose',
    id: '1031031',
    value: 'MOC',
    sort: 20,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Market on close',
  },
  {
    name: 'MergerRelatedTransferPosition',
    id: '1031032',
    value: 'MPT',
    sort: 21,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Merger related transfer position',
  },
  {
    name: 'MinimumQuantity',
    id: '1031033',
    value: 'MQT',
    sort: 22,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Minimum quantity',
  },
  {
    name: 'MarketToLimit',
    id: '1031034',
    value: 'MTL',
    sort: 23,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Market to limit',
  },
  {
    name: 'DeliveryInstructionsNextDay',
    id: '1031035',
    value: 'ND',
    sort: 24,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Delivery instructions - next day',
  },
  {
    name: 'NotHeld',
    id: '1031036',
    value: 'NH',
    sort: 25,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Not held',
  },
  {
    name: 'OptionsRelatedTransaction',
    id: '1031037',
    value: 'OPT',
    sort: 26,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Options related transaction',
  },
  {
    name: 'OverTheDay',
    id: '1031038',
    value: 'OVD',
    sort: 27,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Over the day',
  },
  {
    name: 'Pegged',
    id: '1031039',
    value: 'PEG',
    sort: 28,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Pegged',
  },
  {
    name: 'ReserveSizeOrder',
    id: '1031040',
    value: 'RSV',
    sort: 29,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Reserve size order',
  },
  {
    name: 'StopStockTransaction',
    id: '1031041',
    value: 'S.W',
    sort: 30,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Stop stock transaction',
  },
  {
    name: 'Scale',
    id: '1031042',
    value: 'SCL',
    sort: 31,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Scale',
  },
  {
    name: 'DeliveryInstructionsSellersOption',
    id: '1031043',
    value: 'SLR',
    sort: 32,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Delivery instructions - sellers option',
  },
  {
    name: 'TimeOrder',
    id: '1031044',
    value: 'TMO',
    sort: 33,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Time order',
  },
  {
    name: 'TrailingStop',
    id: '1031045',
    value: 'TS',
    sort: 34,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Trailing stop',
  },
  {
    name: 'Work',
    id: '1031046',
    value: 'WRK',
    sort: 35,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Work',
  },
  {
    name: 'StayOnOfferside',
    id: '1031047',
    value: 'F0',
    sort: 36,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Stay on offerside',
  },
  {
    name: 'GoAlong',
    id: '1031048',
    value: 'F3',
    sort: 37,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Go along',
  },
  {
    name: 'ParticipateDoNotInitiate',
    id: '1031049',
    value: 'F6',
    sort: 38,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Participate do not initiate',
  },
  {
    name: 'StrictScale',
    id: '1031050',
    value: 'F7',
    sort: 39,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Strict scale',
  },
  {
    name: 'TryToScale',
    id: '1031051',
    value: 'F8',
    sort: 40,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Try to scale',
  },
  {
    name: 'StayOnBidside',
    id: '1031052',
    value: 'F9',
    sort: 41,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Stay on bidside',
  },
  {
    name: 'NoCross',
    id: '1031053',
    value: 'FA',
    sort: 42,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'No cross',
  },
  {
    name: 'OKToCross',
    id: '1031054',
    value: 'FB',
    sort: 43,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'OK to cross',
  },
  {
    name: 'CallFirst',
    id: '1031055',
    value: 'FC',
    sort: 44,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Call first',
  },
  {
    name: 'PercentOfVolume',
    id: '1031056',
    value: 'FD',
    sort: 45,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Percent of volume',
  },
  {
    name: 'ReinstateOnSystemFailure',
    id: '1031057',
    value: 'FH',
    sort: 46,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Reinstate on system failure',
  },
  {
    name: 'InstitutionOnly',
    id: '1031058',
    value: 'FI',
    sort: 47,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Institution only',
  },
  {
    name: 'ReinstateOnTradingHalt',
    id: '1031059',
    value: 'FJ',
    sort: 48,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Reinstate on trading halt',
  },
  {
    name: 'CancelOnTradingHalf',
    id: '1031060',
    value: 'FK',
    sort: 49,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Cancel on trading half',
  },
  {
    name: 'LastPeg',
    id: '1031061',
    value: 'FL',
    sort: 50,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Last peg',
  },
  {
    name: 'MidPricePeg',
    id: '1031062',
    value: 'FM',
    sort: 51,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Mid-price peg',
  },
  {
    name: 'NonNegotiable',
    id: '1031063',
    value: 'FN',
    sort: 52,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Non-negotiable',
  },
  {
    name: 'OpeningPeg',
    id: '1031064',
    value: 'FO',
    sort: 53,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Opening peg',
  },
  {
    name: 'MarketPeg',
    id: '1031065',
    value: 'FP',
    sort: 54,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Market peg',
  },
  {
    name: 'CancelOnSystemFailure',
    id: '1031066',
    value: 'FQ',
    sort: 55,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Cancel on system failure',
  },
  {
    name: 'PrimaryPeg',
    id: '1031067',
    value: 'FR',
    sort: 56,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Primary peg',
  },
  {
    name: 'Suspend',
    id: '1031068',
    value: 'FS',
    sort: 57,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Suspend',
  },
  {
    name: 'FixedPegToLocalBBO',
    id: '1031069',
    value: 'FT',
    sort: 58,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Fixed peg to local best bid or offer at time of order',
  },
  {
    name: 'PegToVWAP',
    id: '1031070',
    value: 'FW',
    sort: 59,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Peg to VWAP',
  },
  {
    name: 'TradeAlong',
    id: '1031071',
    value: 'FX',
    sort: 60,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Trade along',
  },
  {
    name: 'TryToStop',
    id: '1031072',
    value: 'FY',
    sort: 61,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Try to stop',
  },
  {
    name: 'CancelIfNotBest',
    id: '1031073',
    value: 'FZ',
    sort: 62,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Cancel if not best',
  },
  {
    name: 'StrictLimit',
    id: '1031074',
    value: 'Fb',
    sort: 63,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Strict limit',
  },
  {
    name: 'IgnorePriceValidityChecks',
    id: '1031075',
    value: 'Fc',
    sort: 64,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Ignore price validity checks',
  },
  {
    name: 'PegToLimitPrice',
    id: '1031076',
    value: 'Fd',
    sort: 65,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Peg to Limit Price',
  },
  {
    name: 'WorkToTargetStrategy',
    id: '1031077',
    value: 'Fe',
    sort: 66,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'Work to target strategy',
  },
  {
    name: 'GOrderAndFCMAPIorFIX',
    id: '1031078',
    value: 'G',
    sort: 0,
    group: 'SHARED',
    added: 'FIX.5.0SP2',
    addedEP: '133',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1031,
    type: 'MultipleStringValue',
    codeSet: 'CustOrderHandlingInstCodeSet',
    description: 'G Order(FINRA OATS), FCM API or FIX(FIA Execution Source)',
  },
  {
    name: 'FINRAOATS',
    id: '1032001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1032,
    type: 'int',
    codeSet: 'OrderHandlingInstSourceCodeSet',
    description: 'FINRA OATS',
  },
  {
    name: 'FIAExecutionSourceCode',
    id: '1032002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '133',
    tag: 1032,
    type: 'int',
    codeSet: 'OrderHandlingInstSourceCodeSet',
    description: 'FIA Execution Source Code',
  },
  {
    name: 'Agency',
    id: '1033001',
    value: 'A',
    sort: 1,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1033,
    type: 'String',
    codeSet: 'DeskTypeCodeSet',
    description: 'Agency',
  },
  {
    name: 'Arbitrage',
    id: '1033002',
    value: 'AR',
    sort: 2,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1033,
    type: 'String',
    codeSet: 'DeskTypeCodeSet',
    description: 'Arbitrage',
  },
  {
    name: 'BlockTrading',
    id: '1033003',
    value: 'B',
    sort: 3,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1033,
    type: 'String',
    codeSet: 'DeskTypeCodeSet',
    description: 'Block trading',
  },
  {
    name: 'ConvertibleDesk',
    id: '1033004',
    value: 'C',
    sort: 4,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1033,
    type: 'String',
    codeSet: 'DeskTypeCodeSet',
    description: 'Convertible desk',
  },
  {
    name: 'CentralRiskBooks',
    id: '1033005',
    value: 'CR',
    sort: 5,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1033,
    type: 'String',
    codeSet: 'DeskTypeCodeSet',
    description: 'Central risk books',
  },
  {
    name: 'Derivatives',
    id: '1033006',
    value: 'D',
    sort: 6,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1033,
    type: 'String',
    codeSet: 'DeskTypeCodeSet',
    description: 'Derivatives',
  },
  {
    name: 'EquityCapitalMarkets',
    id: '1033007',
    value: 'EC',
    sort: 7,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1033,
    type: 'String',
    codeSet: 'DeskTypeCodeSet',
    description: 'Equity capital markets',
  },
  {
    name: 'International',
    id: '1033008',
    value: 'IN',
    sort: 8,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1033,
    type: 'String',
    codeSet: 'DeskTypeCodeSet',
    description: 'International',
  },
  {
    name: 'Institutional',
    id: '1033009',
    value: 'IS',
    sort: 9,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1033,
    type: 'String',
    codeSet: 'DeskTypeCodeSet',
    description: 'Institutional',
  },
  {
    name: 'Other',
    id: '1033010',
    value: 'O',
    sort: 10,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1033,
    type: 'String',
    codeSet: 'DeskTypeCodeSet',
    description: 'Other',
  },
  {
    name: 'PreferredTrading',
    id: '1033011',
    value: 'PF',
    sort: 11,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1033,
    type: 'String',
    codeSet: 'DeskTypeCodeSet',
    description: 'Preferred trading',
  },
  {
    name: 'Proprietary',
    id: '1033012',
    value: 'PR',
    sort: 12,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1033,
    type: 'String',
    codeSet: 'DeskTypeCodeSet',
    description: 'Proprietary',
  },
  {
    name: 'ProgramTrading',
    id: '1033013',
    value: 'PT',
    sort: 13,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1033,
    type: 'String',
    codeSet: 'DeskTypeCodeSet',
    description: 'Program trading',
  },
  {
    name: 'Sales',
    id: '1033014',
    value: 'S',
    sort: 14,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1033,
    type: 'String',
    codeSet: 'DeskTypeCodeSet',
    description: 'Sales',
  },
  {
    name: 'Swaps',
    id: '1033015',
    value: 'SW',
    sort: 15,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1033,
    type: 'String',
    codeSet: 'DeskTypeCodeSet',
    description: 'Swaps',
  },
  {
    name: 'TradingDeskSystem',
    id: '1033016',
    value: 'T',
    sort: 16,
    group: 'FINRA OATS',
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1033,
    type: 'String',
    codeSet: 'DeskTypeCodeSet',
    description: 'Trading desk or system non-market maker',
  },
  {
    name: 'Treasury',
    id: '1033017',
    value: 'TR',
    sort: 17,
    group: 'FINRA OATS',
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1033,
    type: 'String',
    codeSet: 'DeskTypeCodeSet',
    description: 'Treasury',
  },
  {
    name: 'FloorBroker',
    id: '1033018',
    value: 'FB',
    sort: 18,
    group: 'FINRA OATS',
    added: 'FIX.Latest',
    addedEP: '264',
    tag: 1033,
    type: 'String',
    codeSet: 'DeskTypeCodeSet',
    description: 'Floor Broker',
  },
  {
    name: 'FINRAOATS',
    id: '1034001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '135',
    tag: 1034,
    type: 'int',
    codeSet: 'DeskTypeSourceCodeSet',
    description: 'FINRA OATS',
  },
  {
    name: 'Received',
    id: '1036001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1036,
    type: 'char',
    codeSet: 'ExecAckStatusCodeSet',
    description: 'Received, not yet processed',
  },
  {
    name: 'Accepted',
    id: '1036002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1036,
    type: 'char',
    codeSet: 'ExecAckStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'DontKnow',
    id: '1036003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 1036,
    type: 'char',
    codeSet: 'ExecAckStatusCodeSet',
    description: "Don't know / Rejected",
  },
  {
    name: 'SpecificDeposit',
    id: '1043001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1043,
    type: 'int',
    codeSet: 'CollApplTypeCodeSet',
    description: 'Specific Deposit',
  },
  {
    name: 'General',
    id: '1043002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1043,
    type: 'int',
    codeSet: 'CollApplTypeCodeSet',
    description: 'General',
  },
  {
    name: 'Divide',
    id: '1046001',
    value: 'D',
    sort: 0,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1046,
    type: 'char',
    codeSet: 'UnderlyingFXRateCalcCodeSet',
    description: 'Divide',
  },
  {
    name: 'Multiply',
    id: '1046002',
    value: 'M',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1046,
    type: 'char',
    codeSet: 'UnderlyingFXRateCalcCodeSet',
    description: 'Multiply',
  },
  {
    name: 'Open',
    id: '1047001',
    value: 'O',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1047,
    type: 'char',
    codeSet: 'AllocPositionEffectCodeSet',
    description: 'Open',
  },
  {
    name: 'Close',
    id: '1047002',
    value: 'C',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1047,
    type: 'char',
    codeSet: 'AllocPositionEffectCodeSet',
    description: 'Close',
  },
  {
    name: 'Rolled',
    id: '1047003',
    value: 'R',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1047,
    type: 'char',
    codeSet: 'AllocPositionEffectCodeSet',
    description: 'Rolled',
  },
  {
    name: 'FIFO',
    id: '1047004',
    value: 'F',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1047,
    type: 'char',
    codeSet: 'AllocPositionEffectCodeSet',
    description: 'FIFO',
  },
  {
    name: 'Agent',
    id: '1048001',
    value: 'A',
    sort: 0,
    added: 'FIX.5.0SP1',
    addedEP: '95',
    tag: 1048,
    type: 'char',
    codeSet: 'DealingCapacityCodeSet',
    description: 'Agent',
  },
  {
    name: 'Principal',
    id: '1048002',
    value: 'P',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '95',
    tag: 1048,
    type: 'char',
    codeSet: 'DealingCapacityCodeSet',
    description: 'Principal',
  },
  {
    name: 'RisklessPrincipal',
    id: '1048003',
    value: 'R',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '95',
    tag: 1048,
    type: 'char',
    codeSet: 'DealingCapacityCodeSet',
    description: 'Riskless Principal',
  },
  {
    name: 'ProRata',
    id: '1049001',
    value: 'P',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 1049,
    type: 'char',
    codeSet: 'InstrmtAssignmentMethodCodeSet',
    description: 'Pro rata',
  },
  {
    name: 'Random',
    id: '1049002',
    value: 'R',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '4',
    tag: 1049,
    type: 'char',
    codeSet: 'InstrmtAssignmentMethodCodeSet',
    description: 'Random',
  },
  {
    name: 'OrderInitiatorIsAggressor',
    id: '1057001',
    value: 'Y',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1057,
    type: 'Boolean',
    codeSet: 'AggressorIndicatorCodeSet',
    description: 'Order initiator is aggressor',
  },
  {
    name: 'OrderInitiatorIsPassive',
    id: '1057002',
    value: 'N',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1057,
    type: 'Boolean',
    codeSet: 'AggressorIndicatorCodeSet',
    description: 'Order initiator is passive',
  },
  {
    name: 'Indicative',
    id: '1070001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '32',
    tag: 1070,
    type: 'int',
    codeSet: 'MDQuoteTypeCodeSet',
    description: 'Indicative',
  },
  {
    name: 'Tradeable',
    id: '1070002',
    value: '1',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '32',
    tag: 1070,
    type: 'int',
    codeSet: 'MDQuoteTypeCodeSet',
    description: 'Tradeable',
  },
  {
    name: 'RestrictedTradeable',
    id: '1070003',
    value: '2',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '32',
    tag: 1070,
    type: 'int',
    codeSet: 'MDQuoteTypeCodeSet',
    description: 'Restricted Tradeable',
  },
  {
    name: 'Counter',
    id: '1070004',
    value: '3',
    sort: 5,
    added: 'FIX.4.4',
    addedEP: '32',
    tag: 1070,
    type: 'int',
    codeSet: 'MDQuoteTypeCodeSet',
    description: 'Counter',
  },
  {
    name: 'IndicativeAndTradeable',
    id: '1070005',
    value: '4',
    sort: 6,
    added: 'FIX.4.4',
    addedEP: '32',
    tag: 1070,
    type: 'int',
    codeSet: 'MDQuoteTypeCodeSet',
    description: 'Indicative and Tradeable',
  },
  {
    name: 'SecondaryOrderID',
    id: '1081001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '259',
    tag: 1081,
    type: 'char',
    codeSet: 'RefOrderIDSourceCodeSet',
    description:
      'Secondary order ID\n\nCan be used to refer to an additional order identifier assigned by the party accepting an order, e.g. SecondaryOrderID(198).',
  },
  {
    name: 'OrderID',
    id: '1081002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '259',
    tag: 1081,
    type: 'char',
    codeSet: 'RefOrderIDSourceCodeSet',
    description:
      'Order ID\n\nCan be used to refer to an order identifier assigned by the party accepting an order, e.g. OrderID(37).',
  },
  {
    name: 'MDEntryID',
    id: '1081003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '259',
    tag: 1081,
    type: 'char',
    codeSet: 'RefOrderIDSourceCodeSet',
    description:
      'Market data entry ID\n\nCan be used to refer to a market data entry identifier provided with market data, e.g. MDEntryID(278).',
  },
  {
    name: 'QuoteEntryID',
    id: '1081004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '259',
    tag: 1081,
    type: 'char',
    codeSet: 'RefOrderIDSourceCodeSet',
    description:
      'Quote entry ID\n\nCan be used to refer to a quote identifier provided with market data or quote, e.g. QuoteEntryID(299).',
  },
  {
    name: 'OriginalOrderID',
    id: '1081005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    updated: 'FIX.5.0SP2',
    updatedEP: '259',
    tag: 1081,
    type: 'char',
    codeSet: 'RefOrderIDSourceCodeSet',
    description:
      'Original order ID\n\nCan be used to refer to an initial order identifier assigned by the party accepting an order, e.g. OrderID(37) that changed.',
  },
  {
    name: 'QuoteID',
    id: '1081006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    updated: 'FIX.5.0SP2',
    updatedEP: '259',
    tag: 1081,
    type: 'char',
    codeSet: 'RefOrderIDSourceCodeSet',
    description:
      'Quote ID\n\nCan be used to refer to a quote identifier assigned by the party issuing the quote, e.g. QuoteID(117).',
  },
  {
    name: 'QuoteReqID',
    id: '1081007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    updated: 'FIX.5.0SP2',
    updatedEP: '259',
    tag: 1081,
    type: 'char',
    codeSet: 'RefOrderIDSourceCodeSet',
    description:
      'Quote request ID\n\nCan be used to refer to a quote identifier or quote request identifier assigned by the party issuing the request, e.g. QuoteReqID(131).',
  },
  {
    name: 'PreviousOrderIdentifier',
    id: '1081008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 1081,
    type: 'char',
    codeSet: 'RefOrderIDSourceCodeSet',
    description:
      'Previous order identifier\n\nCan be used when previously assigned (unique) system order identifier has changed.',
  },
  {
    name: 'PreviousQuoteIdentifier',
    id: '1081009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 1081,
    type: 'char',
    codeSet: 'RefOrderIDSourceCodeSet',
    description:
      'Previous quote identifier\n\nCan be used when previously assigned (unique) quote identifier has changed.',
  },
  {
    name: 'ParentOrderIdentifier',
    id: '1081010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 1081,
    type: 'char',
    codeSet: 'RefOrderIDSourceCodeSet',
    description:
      'Parent order identifier\n\nCan be used where orders are split into child orders and need to refer back to their parent order.',
  },
  {
    name: 'ManualOrderIdentifier',
    id: '1081011',
    value: 'A',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 1081,
    type: 'char',
    codeSet: 'RefOrderIDSourceCodeSet',
    description:
      'Manual order identifier\n\nCan be used to refer to a manually received order that is being replaced by an electronically received order.',
  },
  {
    name: 'Immediate',
    id: '1083001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1083,
    type: 'char',
    codeSet: 'DisplayWhenCodeSet',
    description: 'Immediate (after each fill)',
  },
  {
    name: 'Exhaust',
    id: '1083002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1083,
    type: 'char',
    codeSet: 'DisplayWhenCodeSet',
    description: 'Exhaust (when DisplayQty = 0)',
  },
  {
    name: 'Initial',
    id: '1084001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1084,
    type: 'char',
    codeSet: 'DisplayMethodCodeSet',
    description: 'Initial (use original DisplayQty)',
  },
  {
    name: 'New',
    id: '1084002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1084,
    type: 'char',
    codeSet: 'DisplayMethodCodeSet',
    description: 'New (use RefreshQty)',
  },
  {
    name: 'Random',
    id: '1084003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1084,
    type: 'char',
    codeSet: 'DisplayMethodCodeSet',
    description: 'Random (randomize value)',
  },
  {
    name: 'Undisclosed',
    id: '1084004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP1',
    addedEP: '78',
    tag: 1084,
    type: 'char',
    codeSet: 'DisplayMethodCodeSet',
    description: 'Undisclosed (invisible order)',
  },
  {
    name: 'None',
    id: '1092001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1092,
    type: 'char',
    codeSet: 'PriceProtectionScopeCodeSet',
    description: 'None',
  },
  {
    name: 'Local',
    id: '1092002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1092,
    type: 'char',
    codeSet: 'PriceProtectionScopeCodeSet',
    description: 'Local (Exchange, ECN, ATS)',
  },
  {
    name: 'National',
    id: '1092003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1092,
    type: 'char',
    codeSet: 'PriceProtectionScopeCodeSet',
    description: 'National (Across all national markets)',
  },
  {
    name: 'Global',
    id: '1092004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1092,
    type: 'char',
    codeSet: 'PriceProtectionScopeCodeSet',
    description: 'Global (Across all markets)',
  },
  {
    name: 'OddLot',
    id: '1093001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1093,
    type: 'char',
    codeSet: 'LotTypeCodeSet',
    description: 'Odd Lot',
  },
  {
    name: 'RoundLot',
    id: '1093002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1093,
    type: 'char',
    codeSet: 'LotTypeCodeSet',
    description: 'Round Lot',
  },
  {
    name: 'BlockLot',
    id: '1093003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1093,
    type: 'char',
    codeSet: 'LotTypeCodeSet',
    description: 'Block Lot',
  },
  {
    name: 'RoundLotBasedUpon',
    id: '1093004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP1',
    addedEP: '80',
    tag: 1093,
    type: 'char',
    codeSet: 'LotTypeCodeSet',
    description: 'Round lot based upon UnitOfMeasure(996)',
  },
  {
    name: 'LastPeg',
    id: '1094001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1094,
    type: 'int',
    codeSet: 'PegPriceTypeCodeSet',
    description: 'Last peg (last sale)',
  },
  {
    name: 'MidPricePeg',
    id: '1094002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1094,
    type: 'int',
    codeSet: 'PegPriceTypeCodeSet',
    description: 'Mid-price peg (midprice of inside quote)',
  },
  {
    name: 'OpeningPeg',
    id: '1094003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1094,
    type: 'int',
    codeSet: 'PegPriceTypeCodeSet',
    description: 'Opening peg',
  },
  {
    name: 'MarketPeg',
    id: '1094004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1094,
    type: 'int',
    codeSet: 'PegPriceTypeCodeSet',
    description: 'Market peg',
  },
  {
    name: 'PrimaryPeg',
    id: '1094005',
    value: '5',
    sort: 5,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1094,
    type: 'int',
    codeSet: 'PegPriceTypeCodeSet',
    description: 'Primary peg (primary market - buy at bid or sell at offer)',
  },
  {
    name: 'PegToVWAP',
    id: '1094006',
    value: '7',
    sort: 7,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1094,
    type: 'int',
    codeSet: 'PegPriceTypeCodeSet',
    description: 'Peg to VWAP',
  },
  {
    name: 'TrailingStopPeg',
    id: '1094007',
    value: '8',
    sort: 8,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1094,
    type: 'int',
    codeSet: 'PegPriceTypeCodeSet',
    description: 'Trailing Stop Peg',
  },
  {
    name: 'PegToLimitPrice',
    id: '1094008',
    value: '9',
    sort: 9,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1094,
    type: 'int',
    codeSet: 'PegPriceTypeCodeSet',
    description: 'Peg to Limit Price',
  },
  {
    name: 'ShortSaleMinPricePeg',
    id: '1094009',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '123',
    tag: 1094,
    type: 'int',
    codeSet: 'PegPriceTypeCodeSet',
    description:
      'Short sale minimum price Peg\n\nShort sale minimum price Peg (published price that a short sell order must meet in order to comply with regulatory requirements, e.g. SEC uptick rules).',
  },
  {
    name: 'PartialExecution',
    id: '1100001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1100,
    type: 'char',
    codeSet: 'TriggerTypeCodeSet',
    description: 'Partial Execution',
  },
  {
    name: 'SpecifiedTradingSession',
    id: '1100002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1100,
    type: 'char',
    codeSet: 'TriggerTypeCodeSet',
    description: 'Specified Trading Session',
  },
  {
    name: 'NextAuction',
    id: '1100003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1100,
    type: 'char',
    codeSet: 'TriggerTypeCodeSet',
    description: 'Next Auction',
  },
  {
    name: 'PriceMovement',
    id: '1100004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1100,
    type: 'char',
    codeSet: 'TriggerTypeCodeSet',
    description: 'Price Movement',
  },
  {
    name: 'OnOrderEntryOrModification',
    id: '1100005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 1100,
    type: 'char',
    codeSet: 'TriggerTypeCodeSet',
    description: 'On Order Entry or order modification entry',
  },
  {
    name: 'Activate',
    id: '1101001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1101,
    type: 'char',
    codeSet: 'TriggerActionCodeSet',
    description: 'Activate',
  },
  {
    name: 'Modify',
    id: '1101002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1101,
    type: 'char',
    codeSet: 'TriggerActionCodeSet',
    description: 'Modify',
  },
  {
    name: 'Cancel',
    id: '1101003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1101,
    type: 'char',
    codeSet: 'TriggerActionCodeSet',
    description: 'Cancel',
  },
  {
    name: 'BestOffer',
    id: '1107001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1107,
    type: 'char',
    codeSet: 'TriggerPriceTypeCodeSet',
    description: 'Best Offer',
  },
  {
    name: 'LastTrade',
    id: '1107002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1107,
    type: 'char',
    codeSet: 'TriggerPriceTypeCodeSet',
    description: 'Last Trade',
  },
  {
    name: 'BestBid',
    id: '1107003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1107,
    type: 'char',
    codeSet: 'TriggerPriceTypeCodeSet',
    description: 'Best Bid',
  },
  {
    name: 'BestBidOrLastTrade',
    id: '1107004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1107,
    type: 'char',
    codeSet: 'TriggerPriceTypeCodeSet',
    description: 'Best Bid or Last Trade',
  },
  {
    name: 'BestOfferOrLastTrade',
    id: '1107005',
    value: '5',
    sort: 5,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1107,
    type: 'char',
    codeSet: 'TriggerPriceTypeCodeSet',
    description: 'Best Offer or Last Trade',
  },
  {
    name: 'BestMid',
    id: '1107006',
    value: '6',
    sort: 6,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1107,
    type: 'char',
    codeSet: 'TriggerPriceTypeCodeSet',
    description: 'Best Mid',
  },
  {
    name: 'None',
    id: '1108001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1108,
    type: 'char',
    codeSet: 'TriggerPriceTypeScopeCodeSet',
    description: 'None',
  },
  {
    name: 'Local',
    id: '1108002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1108,
    type: 'char',
    codeSet: 'TriggerPriceTypeScopeCodeSet',
    description: 'Local (Exchange, ECN, ATS)',
  },
  {
    name: 'National',
    id: '1108003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1108,
    type: 'char',
    codeSet: 'TriggerPriceTypeScopeCodeSet',
    description: 'National (Across all national markets)',
  },
  {
    name: 'Global',
    id: '1108004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1108,
    type: 'char',
    codeSet: 'TriggerPriceTypeScopeCodeSet',
    description: 'Global (Across all markets)',
  },
  {
    name: 'Up',
    id: '1109001',
    value: 'U',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1109,
    type: 'char',
    codeSet: 'TriggerPriceDirectionCodeSet',
    description:
      'Trigger if the price of the specified type goes UP to or through the specified Trigger Price.',
  },
  {
    name: 'Down',
    id: '1109002',
    value: 'D',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1109,
    type: 'char',
    codeSet: 'TriggerPriceDirectionCodeSet',
    description:
      'Trigger if the price of the specified type goes DOWN to or through the specified Trigger Price.',
  },
  {
    name: 'Market',
    id: '1111001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '35',
    tag: 1111,
    type: 'char',
    codeSet: 'TriggerOrderTypeCodeSet',
    description: 'Market',
  },
  {
    name: 'Limit',
    id: '1111002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '35',
    tag: 1111,
    type: 'char',
    codeSet: 'TriggerOrderTypeCodeSet',
    description: 'Limit',
  },
  {
    name: 'Order',
    id: '1115001',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1115,
    type: 'char',
    codeSet: 'OrderCategoryCodeSet',
    description: 'Order',
  },
  {
    name: 'Quote',
    id: '1115002',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1115,
    type: 'char',
    codeSet: 'OrderCategoryCodeSet',
    description: 'Quote',
  },
  {
    name: 'PrivatelyNegotiatedTrade',
    id: '1115003',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1115,
    type: 'char',
    codeSet: 'OrderCategoryCodeSet',
    description: 'Privately Negotiated Trade',
  },
  {
    name: 'MultilegOrder',
    id: '1115004',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1115,
    type: 'char',
    codeSet: 'OrderCategoryCodeSet',
    description: 'Multileg order',
  },
  {
    name: 'LinkedOrder',
    id: '1115005',
    value: '5',
    sort: 5,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1115,
    type: 'char',
    codeSet: 'OrderCategoryCodeSet',
    description: 'Linked order',
  },
  {
    name: 'QuoteRequest',
    id: '1115006',
    value: '6',
    sort: 6,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1115,
    type: 'char',
    codeSet: 'OrderCategoryCodeSet',
    description: 'Quote Request',
  },
  {
    name: 'ImpliedOrder',
    id: '1115007',
    value: '7',
    sort: 7,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1115,
    type: 'char',
    codeSet: 'OrderCategoryCodeSet',
    description: 'Implied Order',
  },
  {
    name: 'CrossOrder',
    id: '1115008',
    value: '8',
    sort: 8,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1115,
    type: 'char',
    codeSet: 'OrderCategoryCodeSet',
    description: 'Cross Order',
  },
  {
    name: 'StreamingPrice',
    id: '1115009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0',
    addedEP: '-1',
    tag: 1115,
    type: 'char',
    codeSet: 'OrderCategoryCodeSet',
    description: 'Streaming price (quote)',
  },
  {
    name: 'InternalCrossOrder',
    id: '1115010',
    value: 'A',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '101',
    tag: 1115,
    type: 'char',
    codeSet: 'OrderCategoryCodeSet',
    description: 'Internal Cross Order',
  },
  {
    name: 'TradeConfirmation',
    id: '1123001',
    value: '0',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '136',
    tag: 1123,
    type: 'char',
    codeSet: 'TradeHandlingInstrCodeSet',
    description: 'Trade confirmation',
  },
  {
    name: 'TwoPartyReport',
    id: '1123002',
    value: '1',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '136',
    tag: 1123,
    type: 'char',
    codeSet: 'TradeHandlingInstrCodeSet',
    description: 'Two-party report',
  },
  {
    name: 'OnePartyReportForMatching',
    id: '1123003',
    value: '2',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '136',
    tag: 1123,
    type: 'char',
    codeSet: 'TradeHandlingInstrCodeSet',
    description: 'One-party report for matching',
  },
  {
    name: 'OnePartyReportForPassThrough',
    id: '1123004',
    value: '3',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '212',
    tag: 1123,
    type: 'char',
    codeSet: 'TradeHandlingInstrCodeSet',
    description:
      'One-party report for pass through\n\nCan be used when one of the parties to the trade submits a report which then has to be approved or confirmed by the other (counter)party.',
  },
  {
    name: 'AutomatedFloorOrderRouting',
    id: '1123005',
    value: '4',
    sort: 5,
    added: 'FIX.4.4',
    addedEP: '-1',
    updated: 'FIX.5.0SP2',
    updatedEP: '136',
    tag: 1123,
    type: 'char',
    codeSet: 'TradeHandlingInstrCodeSet',
    description: 'Automated floor order routing',
  },
  {
    name: 'TwoPartyReportForClaim',
    id: '1123006',
    value: '5',
    sort: 6,
    added: 'FIX.5.0',
    addedEP: '55',
    updated: 'FIX.5.0SP2',
    updatedEP: '136',
    tag: 1123,
    type: 'char',
    codeSet: 'TradeHandlingInstrCodeSet',
    description: 'Two-party report for claim',
  },
  {
    name: 'OnePartyReport',
    id: '1123007',
    value: '6',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '136',
    tag: 1123,
    type: 'char',
    codeSet: 'TradeHandlingInstrCodeSet',
    description: 'One-party report',
  },
  {
    name: 'ThirdPtyRptForPassThrough',
    id: '1123008',
    value: '7',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '212',
    tag: 1123,
    type: 'char',
    codeSet: 'TradeHandlingInstrCodeSet',
    description:
      'Third-party report for pass through\n\nCan be used when RootParties component contains a service provider role who submits the trade report and is not necessarily also on one side of the trade.',
  },
  {
    name: 'OnePartyReportAutoMatch',
    id: '1123009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '227',
    tag: 1123,
    type: 'char',
    codeSet: 'TradeHandlingInstrCodeSet',
    description:
      'One-party report for auto-match\n\nIndicates that the submission is a transfer trade to a firm or account that is part of the same corporate entity and that once validated the transfer should be automatically accepted without confirmation.',
  },
  {
    name: 'FIX27',
    id: '1128001',
    value: '0',
    sort: 0,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1128,
    type: 'String',
    codeSet: 'ApplVerIDCodeSet',
    description: 'FIX27',
  },
  {
    name: 'FIX30',
    id: '1128002',
    value: '1',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1128,
    type: 'String',
    codeSet: 'ApplVerIDCodeSet',
    description: 'FIX30',
  },
  {
    name: 'FIX40',
    id: '1128003',
    value: '2',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1128,
    type: 'String',
    codeSet: 'ApplVerIDCodeSet',
    description: 'FIX40',
  },
  {
    name: 'FIX41',
    id: '1128004',
    value: '3',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1128,
    type: 'String',
    codeSet: 'ApplVerIDCodeSet',
    description: 'FIX41',
  },
  {
    name: 'FIX42',
    id: '1128005',
    value: '4',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1128,
    type: 'String',
    codeSet: 'ApplVerIDCodeSet',
    description: 'FIX42',
  },
  {
    name: 'FIX43',
    id: '1128006',
    value: '5',
    sort: 5,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1128,
    type: 'String',
    codeSet: 'ApplVerIDCodeSet',
    description: 'FIX43',
  },
  {
    name: 'FIX44',
    id: '1128007',
    value: '6',
    sort: 6,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1128,
    type: 'String',
    codeSet: 'ApplVerIDCodeSet',
    description: 'FIX44',
  },
  {
    name: 'FIX50',
    id: '1128008',
    value: '7',
    sort: 7,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1128,
    type: 'String',
    codeSet: 'ApplVerIDCodeSet',
    description: 'FIX50',
  },
  {
    name: 'FIX50SP1',
    id: '1128009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0',
    addedEP: '-1',
    tag: 1128,
    type: 'String',
    codeSet: 'ApplVerIDCodeSet',
    description: 'FIX50SP1',
  },
  {
    name: 'FIX50SP2',
    id: '1128010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP1',
    addedEP: '97',
    tag: 1128,
    type: 'String',
    codeSet: 'ApplVerIDCodeSet',
    description: 'FIX50SP2',
  },
  {
    name: 'FIXLatest',
    id: '1128011',
    value: '10',
    sort: 10,
    added: 'FIX.Latest',
    addedEP: '260',
    tag: 1128,
    type: 'String',
    codeSet: 'ApplVerIDCodeSet',
    description: 'FIXLatest',
  },
  {
    name: 'BIC',
    id: '1133001',
    value: 'B',
    sort: 1,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1133,
    type: 'char',
    codeSet: 'ExDestinationIDSourceCodeSet',
    description: 'BIC (Bank Identification Code) (ISO 9362)',
  },
  {
    name: 'GeneralIdentifier',
    id: '1133002',
    value: 'C',
    sort: 2,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1133,
    type: 'char',
    codeSet: 'ExDestinationIDSourceCodeSet',
    description: 'Generally accepted market participant identifier (e.g. NASD mnemonic)',
  },
  {
    name: 'Proprietary',
    id: '1133003',
    value: 'D',
    sort: 3,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1133,
    type: 'char',
    codeSet: 'ExDestinationIDSourceCodeSet',
    description: 'Proprietary / Custom code',
  },
  {
    name: 'ISOCountryCode',
    id: '1133004',
    value: 'E',
    sort: 4,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1133,
    type: 'char',
    codeSet: 'ExDestinationIDSourceCodeSet',
    description: 'ISO Country Code',
  },
  {
    name: 'MIC',
    id: '1133005',
    value: 'G',
    sort: 5,
    added: 'FIX.4.4',
    addedEP: '-1',
    tag: 1133,
    type: 'char',
    codeSet: 'ExDestinationIDSourceCodeSet',
    description: 'MIC (ISO 10383 - Market Identifier Code)',
  },
  {
    name: 'NotImplied',
    id: '1144001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '42',
    tag: 1144,
    type: 'int',
    codeSet: 'ImpliedMarketIndicatorCodeSet',
    description: 'Not implied',
  },
  {
    name: 'ImpliedIn',
    id: '1144002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '42',
    tag: 1144,
    type: 'int',
    codeSet: 'ImpliedMarketIndicatorCodeSet',
    description:
      'Implied-in - The existence of a multi-leg instrument is implied by the legs of that instrument',
  },
  {
    name: 'ImpliedOut',
    id: '1144003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '42',
    tag: 1144,
    type: 'int',
    codeSet: 'ImpliedMarketIndicatorCodeSet',
    description:
      'Implied-out - The existence of the underlying legs are implied by the multi-leg instrument',
  },
  {
    name: 'BothImpliedInAndImpliedOut',
    id: '1144004',
    value: '3',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '42',
    tag: 1144,
    type: 'int',
    codeSet: 'ImpliedMarketIndicatorCodeSet',
    description: 'Both Implied-in and Implied-out',
  },
  {
    name: 'Preliminary',
    id: '1159001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '44',
    tag: 1159,
    type: 'int',
    codeSet: 'SettlObligModeCodeSet',
    description: 'Preliminary',
  },
  {
    name: 'Final',
    id: '1159002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '44',
    tag: 1159,
    type: 'int',
    codeSet: 'SettlObligModeCodeSet',
    description: 'Final',
  },
  {
    name: 'Cancel',
    id: '1162001',
    value: 'C',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '44',
    tag: 1162,
    type: 'char',
    codeSet: 'SettlObligTransTypeCodeSet',
    description: 'Cancel',
  },
  {
    name: 'New',
    id: '1162002',
    value: 'N',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '44',
    tag: 1162,
    type: 'char',
    codeSet: 'SettlObligTransTypeCodeSet',
    description: 'New',
  },
  {
    name: 'Replace',
    id: '1162003',
    value: 'R',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '44',
    tag: 1162,
    type: 'char',
    codeSet: 'SettlObligTransTypeCodeSet',
    description: 'Replace',
  },
  {
    name: 'Restate',
    id: '1162004',
    value: 'T',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '44',
    tag: 1162,
    type: 'char',
    codeSet: 'SettlObligTransTypeCodeSet',
    description: 'Restate',
  },
  {
    name: 'InstructionsOfBroker',
    id: '1164001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '44',
    tag: 1164,
    type: 'char',
    codeSet: 'SettlObligSourceCodeSet',
    description: 'Instructions of Broker',
  },
  {
    name: 'InstructionsForInstitution',
    id: '1164002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '44',
    tag: 1164,
    type: 'char',
    codeSet: 'SettlObligSourceCodeSet',
    description: 'Instructions for Institution',
  },
  {
    name: 'Investor',
    id: '1164003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '44',
    tag: 1164,
    type: 'char',
    codeSet: 'SettlObligSourceCodeSet',
    description: 'Investor',
  },
  {
    name: 'BuyersSettlementInstructions',
    id: '1164004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 1164,
    type: 'char',
    codeSet: 'SettlObligSourceCodeSet',
    description: "Buyer's settlement instructions",
  },
  {
    name: 'SellersSettlementInstructions',
    id: '1164005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 1164,
    type: 'char',
    codeSet: 'SettlObligSourceCodeSet',
    description: "Seller's settlement instructions",
  },
  {
    name: 'Accepted',
    id: '1167001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '45',
    tag: 1167,
    type: 'int',
    codeSet: 'QuoteEntryStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Rejected',
    id: '1167002',
    value: '5',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '45',
    tag: 1167,
    type: 'int',
    codeSet: 'QuoteEntryStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'RemovedFromMarket',
    id: '1167003',
    value: '6',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '45',
    tag: 1167,
    type: 'int',
    codeSet: 'QuoteEntryStatusCodeSet',
    description: 'Removed from Market',
  },
  {
    name: 'Expired',
    id: '1167004',
    value: '7',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '45',
    tag: 1167,
    type: 'int',
    codeSet: 'QuoteEntryStatusCodeSet',
    description: 'Expired',
  },
  {
    name: 'LockedMarketWarning',
    id: '1167005',
    value: '12',
    sort: 5,
    added: 'FIX.5.0',
    addedEP: '45',
    tag: 1167,
    type: 'int',
    codeSet: 'QuoteEntryStatusCodeSet',
    description: 'Locked Market Warning',
  },
  {
    name: 'CrossMarketWarning',
    id: '1167006',
    value: '13',
    sort: 6,
    added: 'FIX.5.0',
    addedEP: '45',
    tag: 1167,
    type: 'int',
    codeSet: 'QuoteEntryStatusCodeSet',
    description: 'Cross Market Warning',
  },
  {
    name: 'CanceledDueToLockMarket',
    id: '1167007',
    value: '14',
    sort: 7,
    added: 'FIX.5.0',
    addedEP: '45',
    tag: 1167,
    type: 'int',
    codeSet: 'QuoteEntryStatusCodeSet',
    description: 'Canceled due to Lock Market',
  },
  {
    name: 'CanceledDueToCrossMarket',
    id: '1167008',
    value: '15',
    sort: 8,
    added: 'FIX.5.0',
    addedEP: '45',
    tag: 1167,
    type: 'int',
    codeSet: 'QuoteEntryStatusCodeSet',
    description: 'Canceled due to Cross Market',
  },
  {
    name: 'Active',
    id: '1167009',
    value: '16',
    sort: 9,
    added: 'FIX.5.0',
    addedEP: '45',
    tag: 1167,
    type: 'int',
    codeSet: 'QuoteEntryStatusCodeSet',
    description: 'Active',
  },
  {
    name: 'PrivateQuote',
    id: '1171001',
    value: 'Y',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '46',
    tag: 1171,
    type: 'Boolean',
    codeSet: 'PrivateQuoteCodeSet',
    description: 'Private Quote',
  },
  {
    name: 'PublicQuote',
    id: '1171002',
    value: 'N',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '46',
    tag: 1171,
    type: 'Boolean',
    codeSet: 'PrivateQuoteCodeSet',
    description: 'Public Quote',
  },
  {
    name: 'AllMarketParticipants',
    id: '1172001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '46',
    tag: 1172,
    type: 'int',
    codeSet: 'RespondentTypeCodeSet',
    description: 'All market participants',
  },
  {
    name: 'SpecifiedMarketParticipants',
    id: '1172002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '46',
    tag: 1172,
    type: 'int',
    codeSet: 'RespondentTypeCodeSet',
    description: 'Specified market participants',
  },
  {
    name: 'AllMarketMakers',
    id: '1172003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '46',
    tag: 1172,
    type: 'int',
    codeSet: 'RespondentTypeCodeSet',
    description: 'All Market Makers',
  },
  {
    name: 'PrimaryMarketMaker',
    id: '1172004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '46',
    tag: 1172,
    type: 'int',
    codeSet: 'RespondentTypeCodeSet',
    description: 'Primary Market Maker(s)',
  },
  {
    name: 'OrderImbalance',
    id: '1174001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '47',
    tag: 1174,
    type: 'int',
    codeSet: 'SecurityTradingEventCodeSet',
    description: 'Order imbalance, auction is extended',
  },
  {
    name: 'TradingResumes',
    id: '1174002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '47',
    tag: 1174,
    type: 'int',
    codeSet: 'SecurityTradingEventCodeSet',
    description: 'Trading resumes (after Halt)',
  },
  {
    name: 'PriceVolatilityInterruption',
    id: '1174003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '47',
    tag: 1174,
    type: 'int',
    codeSet: 'SecurityTradingEventCodeSet',
    description: 'Price Volatility Interruption',
  },
  {
    name: 'ChangeOfTradingSession',
    id: '1174004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '47',
    tag: 1174,
    type: 'int',
    codeSet: 'SecurityTradingEventCodeSet',
    description: 'Change of Trading Session',
  },
  {
    name: 'ChangeOfTradingSubsession',
    id: '1174005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0',
    addedEP: '47',
    tag: 1174,
    type: 'int',
    codeSet: 'SecurityTradingEventCodeSet',
    description: 'Change of Trading Subsession',
  },
  {
    name: 'ChangeOfSecurityTradingStatus',
    id: '1174006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0',
    addedEP: '47',
    updated: 'FIX.5.0SP1',
    updatedEP: '95',
    tag: 1174,
    type: 'int',
    codeSet: 'SecurityTradingEventCodeSet',
    description: 'Change of Security Trading Status',
  },
  {
    name: 'ChangeOfBookType',
    id: '1174007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0',
    addedEP: '47',
    tag: 1174,
    type: 'int',
    codeSet: 'SecurityTradingEventCodeSet',
    description: 'Change of Book Type',
  },
  {
    name: 'ChangeOfMarketDepth',
    id: '1174008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0',
    addedEP: '47',
    tag: 1174,
    type: 'int',
    codeSet: 'SecurityTradingEventCodeSet',
    description: 'Change of Market Depth',
  },
  {
    name: 'CorporateAction',
    id: '1174009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '190',
    tag: 1174,
    type: 'int',
    codeSet: 'SecurityTradingEventCodeSet',
    description: 'Corporate action',
  },
  {
    name: 'ExchangeLast',
    id: '1176001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '47',
    tag: 1176,
    type: 'int',
    codeSet: 'StatsTypeCodeSet',
    description: 'Exchange Last',
  },
  {
    name: 'High',
    id: '1176002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '47',
    tag: 1176,
    type: 'int',
    codeSet: 'StatsTypeCodeSet',
    description: 'High / Low Price',
  },
  {
    name: 'AveragePrice',
    id: '1176003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '47',
    tag: 1176,
    type: 'int',
    codeSet: 'StatsTypeCodeSet',
    description: 'Average Price (VWAP, TWAP ... )',
  },
  {
    name: 'Turnover',
    id: '1176004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '47',
    tag: 1176,
    type: 'int',
    codeSet: 'StatsTypeCodeSet',
    description: 'Turnover (Price * Qty)',
  },
  {
    name: 'Customer',
    id: '1178001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '47',
    updated: 'FIX.5.0SP2',
    updatedEP: '190',
    tag: 1178,
    type: 'int',
    codeSet: 'MDSecSizeTypeCodeSet',
    description: 'Customer\n\nQuantity of retail investors.',
  },
  {
    name: 'CustomerProfessional',
    id: '1178002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '190',
    tag: 1178,
    type: 'int',
    codeSet: 'MDSecSizeTypeCodeSet',
    description:
      'Customer professional\n\nQuantity of high-volume investors acting similar to broker-dealers.',
  },
  {
    name: 'DoNotTradeThrough',
    id: '1178003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '190',
    tag: 1178,
    type: 'int',
    codeSet: 'MDSecSizeTypeCodeSet',
    description:
      'Do not trade through\n\nQuantity that cannot trade through the away markets.',
  },
  {
    name: 'CashSettlementRequired',
    id: '1193001',
    value: 'C',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1193,
    type: 'String',
    codeSet: 'SettlMethodCodeSet',
    description: 'Cash settlement required',
  },
  {
    name: 'PhysicalSettlementRequired',
    id: '1193002',
    value: 'P',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1193,
    type: 'String',
    codeSet: 'SettlMethodCodeSet',
    description: 'Physical settlement required',
  },
  {
    name: 'Election',
    id: '1193003',
    value: 'E',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 1193,
    type: 'String',
    codeSet: 'SettlMethodCodeSet',
    description:
      'Election at exercise\n\nThe settlement method will be elected at the time of contract exercise.',
  },
  {
    name: 'European',
    id: '1194001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1194,
    type: 'int',
    codeSet: 'ExerciseStyleCodeSet',
    description: 'European',
  },
  {
    name: 'American',
    id: '1194002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1194,
    type: 'int',
    codeSet: 'ExerciseStyleCodeSet',
    description: 'American',
  },
  {
    name: 'Bermuda',
    id: '1194003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1194,
    type: 'int',
    codeSet: 'ExerciseStyleCodeSet',
    description: 'Bermuda',
  },
  {
    name: 'Other',
    id: '1194004',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1194,
    type: 'int',
    codeSet: 'ExerciseStyleCodeSet',
    description: 'Other',
  },
  {
    name: 'Standard',
    id: '1196001',
    value: 'STD',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1196,
    type: 'String',
    codeSet: 'PriceQuoteMethodCodeSet',
    description: 'Standard, money per unit of a physical',
  },
  {
    name: 'Index',
    id: '1196002',
    value: 'INX',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1196,
    type: 'String',
    codeSet: 'PriceQuoteMethodCodeSet',
    description: 'Index',
  },
  {
    name: 'InterestRateIndex',
    id: '1196003',
    value: 'INT',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1196,
    type: 'String',
    codeSet: 'PriceQuoteMethodCodeSet',
    description: 'Interest rate Index',
  },
  {
    name: 'PercentOfPar',
    id: '1196004',
    value: 'PCTPAR',
    sort: 4,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    tag: 1196,
    type: 'String',
    codeSet: 'PriceQuoteMethodCodeSet',
    description: 'Percent of Par',
  },
  {
    name: 'PremiumStyle',
    id: '1197001',
    value: 'EQTY',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1197,
    type: 'String',
    codeSet: 'ValuationMethodCodeSet',
    description: 'premium style',
  },
  {
    name: 'FuturesStyleMarkToMarket',
    id: '1197002',
    value: 'FUT',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1197,
    type: 'String',
    codeSet: 'ValuationMethodCodeSet',
    description: 'futures style mark-to-market',
  },
  {
    name: 'FuturesStyleWithAnAttachedCashAdjustment',
    id: '1197003',
    value: 'FUTDA',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1197,
    type: 'String',
    codeSet: 'ValuationMethodCodeSet',
    description: 'futures style with an attached cash adjustment',
  },
  {
    name: 'CDSStyleCollateralization',
    id: '1197004',
    value: 'CDS',
    sort: 4,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    tag: 1197,
    type: 'String',
    codeSet: 'ValuationMethodCodeSet',
    description: 'CDS style collateralization of market to market and coupon',
  },
  {
    name: 'CDSInDeliveryUseRecoveryRateToCalculate',
    id: '1197005',
    value: 'CDSD',
    sort: 5,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    tag: 1197,
    type: 'String',
    codeSet: 'ValuationMethodCodeSet',
    description: 'CDS in delivery - use recovery rate to calculate obligation',
  },
  {
    name: 'PreListedOnly',
    id: '1198001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1198,
    type: 'int',
    codeSet: 'ListMethodCodeSet',
    description: 'pre-listed only',
  },
  {
    name: 'UserRequested',
    id: '1198002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1198,
    type: 'int',
    codeSet: 'ListMethodCodeSet',
    description: 'user requested',
  },
  {
    name: 'RegularTrading',
    id: '1209001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 1209,
    type: 'int',
    codeSet: 'TickRuleTypeCodeSet',
    description: 'Regular trading',
  },
  {
    name: 'VariableCabinet',
    id: '1209002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 1209,
    type: 'int',
    codeSet: 'TickRuleTypeCodeSet',
    description: 'Variable cabinet',
  },
  {
    name: 'FixedCabinet',
    id: '1209003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '138',
    tag: 1209,
    type: 'int',
    codeSet: 'TickRuleTypeCodeSet',
    description: 'Fixed cabinet',
  },
  {
    name: 'TradedAsASpreadLeg',
    id: '1209004',
    value: '3',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1209,
    type: 'int',
    codeSet: 'TickRuleTypeCodeSet',
    description: 'Traded as a spread leg',
  },
  {
    name: 'SettledAsASpreadLeg',
    id: '1209005',
    value: '4',
    sort: 5,
    added: 'FIX.5.0',
    addedEP: '52',
    deprecated: 'FIX.5.0SP2',
    deprecatedEP: '138',
    tag: 1209,
    type: 'int',
    codeSet: 'TickRuleTypeCodeSet',
    description: 'Settled as a spread leg',
  },
  {
    name: 'TradedAsSpread',
    id: '1209006',
    value: '5',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '138',
    tag: 1209,
    type: 'int',
    codeSet: 'TickRuleTypeCodeSet',
    description: 'Traded as spread\n\nBasis points spread',
  },
  {
    name: 'Months',
    id: '1302001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1302,
    type: 'int',
    codeSet: 'MaturityMonthYearIncrementUnitsCodeSet',
    description: 'Months',
  },
  {
    name: 'Days',
    id: '1302002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1302,
    type: 'int',
    codeSet: 'MaturityMonthYearIncrementUnitsCodeSet',
    description: 'Days',
  },
  {
    name: 'Weeks',
    id: '1302003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1302,
    type: 'int',
    codeSet: 'MaturityMonthYearIncrementUnitsCodeSet',
    description: 'Weeks',
  },
  {
    name: 'Years',
    id: '1302004',
    value: '3',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1302,
    type: 'int',
    codeSet: 'MaturityMonthYearIncrementUnitsCodeSet',
    description: 'Years',
  },
  {
    name: 'YearMonthOnly',
    id: '1303001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1303,
    type: 'int',
    codeSet: 'MaturityMonthYearFormatCodeSet',
    description: 'YearMonth Only (default)',
  },
  {
    name: 'YearMonthDay',
    id: '1303002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1303,
    type: 'int',
    codeSet: 'MaturityMonthYearFormatCodeSet',
    description: 'YearMonthDay',
  },
  {
    name: 'YearMonthWeek',
    id: '1303003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1303,
    type: 'int',
    codeSet: 'MaturityMonthYearFormatCodeSet',
    description: 'YearMonthWeek',
  },
  {
    name: 'Price',
    id: '1306001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '52',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 1306,
    type: 'int',
    codeSet: 'PriceLimitTypeCodeSet',
    description: 'Price (default)',
  },
  {
    name: 'Ticks',
    id: '1306002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1306,
    type: 'int',
    codeSet: 'PriceLimitTypeCodeSet',
    description: 'Ticks',
  },
  {
    name: 'Percentage',
    id: '1306003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '52',
    tag: 1306,
    type: 'int',
    codeSet: 'PriceLimitTypeCodeSet',
    description: 'Percentage',
  },
  {
    name: 'Add',
    id: '1324001',
    value: 'A',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1324,
    type: 'char',
    codeSet: 'ListUpdateActionCodeSet',
    description: 'Add',
  },
  {
    name: 'Delete',
    id: '1324002',
    value: 'D',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1324,
    type: 'char',
    codeSet: 'ListUpdateActionCodeSet',
    description: 'Delete',
  },
  {
    name: 'Modify',
    id: '1324003',
    value: 'M',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1324,
    type: 'char',
    codeSet: 'ListUpdateActionCodeSet',
    description: 'Modify',
  },
  {
    name: 'Snapshot',
    id: '1324004',
    value: 'S',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1324,
    type: 'char',
    codeSet: 'ListUpdateActionCodeSet',
    description: 'Snapshot',
  },
  {
    name: 'SessionActive',
    id: '1409001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '56',
    tag: 1409,
    type: 'int',
    codeSet: 'SessionStatusCodeSet',
    description: 'Session active',
  },
  {
    name: 'SessionPasswordChanged',
    id: '1409002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '56',
    tag: 1409,
    type: 'int',
    codeSet: 'SessionStatusCodeSet',
    description: 'Session password changed',
  },
  {
    name: 'SessionPasswordDueToExpire',
    id: '1409003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '56',
    tag: 1409,
    type: 'int',
    codeSet: 'SessionStatusCodeSet',
    description: 'Session password due to expire',
  },
  {
    name: 'NewSessionPasswordDoesNotComplyWithPolicy',
    id: '1409004',
    value: '3',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '56',
    tag: 1409,
    type: 'int',
    codeSet: 'SessionStatusCodeSet',
    description: 'New session password does not comply with policy',
  },
  {
    name: 'SessionLogoutComplete',
    id: '1409005',
    value: '4',
    sort: 5,
    added: 'FIX.5.0',
    addedEP: '56',
    tag: 1409,
    type: 'int',
    codeSet: 'SessionStatusCodeSet',
    description: 'Session logout complete',
  },
  {
    name: 'InvalidUsernameOrPassword',
    id: '1409006',
    value: '5',
    sort: 6,
    added: 'FIX.5.0',
    addedEP: '56',
    tag: 1409,
    type: 'int',
    codeSet: 'SessionStatusCodeSet',
    description: 'Invalid username or password',
  },
  {
    name: 'AccountLocked',
    id: '1409007',
    value: '6',
    sort: 7,
    added: 'FIX.5.0',
    addedEP: '56',
    tag: 1409,
    type: 'int',
    codeSet: 'SessionStatusCodeSet',
    description: 'Account locked',
  },
  {
    name: 'LogonsAreNotAllowedAtThisTime',
    id: '1409008',
    value: '7',
    sort: 8,
    added: 'FIX.5.0',
    addedEP: '56',
    tag: 1409,
    type: 'int',
    codeSet: 'SessionStatusCodeSet',
    description: 'Logons are not allowed at this time',
  },
  {
    name: 'PasswordExpired',
    id: '1409009',
    value: '8',
    sort: 9,
    added: 'FIX.5.0',
    addedEP: '56',
    tag: 1409,
    type: 'int',
    codeSet: 'SessionStatusCodeSet',
    description: 'Password expired',
  },
  {
    name: 'ReceivedMsgSeqNumTooLow',
    id: '1409010',
    value: '9',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '124',
    tag: 1409,
    type: 'int',
    codeSet: 'SessionStatusCodeSet',
    description: 'Received MsgSeqNum(34) is too low.',
  },
  {
    name: 'ReceivedNextExpectedMsgSeqNumTooHigh',
    id: '1409011',
    value: '10',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '124',
    tag: 1409,
    type: 'int',
    codeSet: 'SessionStatusCodeSet',
    description: 'Received NextExpectedMsgSeqNum(789) is too high.',
  },
  {
    name: 'TradingResumes',
    id: '1368001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 1368,
    type: 'int',
    codeSet: 'TradSesEventCodeSet',
    description: 'Trading resumes (after Halt)',
  },
  {
    name: 'ChangeOfTradingSession',
    id: '1368002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 1368,
    type: 'int',
    codeSet: 'TradSesEventCodeSet',
    description: 'Change of Trading Session',
  },
  {
    name: 'ChangeOfTradingSubsession',
    id: '1368003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 1368,
    type: 'int',
    codeSet: 'TradSesEventCodeSet',
    description: 'Change of Trading Subsession',
  },
  {
    name: 'ChangeOfTradingStatus',
    id: '1368004',
    value: '3',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 1368,
    type: 'int',
    codeSet: 'TradSesEventCodeSet',
    description: 'Change of Trading Status',
  },
  {
    name: 'SuspendOrders',
    id: '1373001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 1373,
    type: 'int',
    codeSet: 'MassActionTypeCodeSet',
    description: 'Suspend orders',
  },
  {
    name: 'ReleaseOrdersFromSuspension',
    id: '1373002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 1373,
    type: 'int',
    codeSet: 'MassActionTypeCodeSet',
    description: 'Release orders from suspension',
  },
  {
    name: 'CancelOrders',
    id: '1373003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 1373,
    type: 'int',
    codeSet: 'MassActionTypeCodeSet',
    description: 'Cancel orders',
  },
  {
    name: 'AllOrdersForASecurity',
    id: '1374001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 1374,
    type: 'int',
    codeSet: 'MassActionScopeCodeSet',
    description: 'All orders for a security',
  },
  {
    name: 'AllOrdersForAnUnderlyingSecurity',
    id: '1374002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 1374,
    type: 'int',
    codeSet: 'MassActionScopeCodeSet',
    description: 'All orders for an underlying security',
  },
  {
    name: 'AllOrdersForAProduct',
    id: '1374003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 1374,
    type: 'int',
    codeSet: 'MassActionScopeCodeSet',
    description: 'All orders for a product',
  },
  {
    name: 'AllOrdersForACFICode',
    id: '1374004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 1374,
    type: 'int',
    codeSet: 'MassActionScopeCodeSet',
    description: 'All orders for a CFI Code',
  },
  {
    name: 'AllOrdersForASecurityType',
    id: '1374005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 1374,
    type: 'int',
    codeSet: 'MassActionScopeCodeSet',
    description: 'All orders for a security type',
  },
  {
    name: 'AllOrdersForATradingSession',
    id: '1374006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 1374,
    type: 'int',
    codeSet: 'MassActionScopeCodeSet',
    description: 'All orders for a trading session',
  },
  {
    name: 'AllOrders',
    id: '1374007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 1374,
    type: 'int',
    codeSet: 'MassActionScopeCodeSet',
    description: 'All orders',
  },
  {
    name: 'AllOrdersForAMarket',
    id: '1374008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 1374,
    type: 'int',
    codeSet: 'MassActionScopeCodeSet',
    description: 'All orders for a market',
  },
  {
    name: 'AllOrdersForAMarketSegment',
    id: '1374009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.5.0SP2',
    updatedEP: '204',
    tag: 1374,
    type: 'int',
    codeSet: 'MassActionScopeCodeSet',
    description: 'All orders for a market segment (or multiple segments)',
  },
  {
    name: 'AllOrdersForASecurityGroup',
    id: '1374010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 1374,
    type: 'int',
    codeSet: 'MassActionScopeCodeSet',
    description: 'All orders for a security group',
  },
  {
    name: 'CancelForSecurityIssuer',
    id: '1374011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP1',
    addedEP: '85',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 1374,
    type: 'int',
    codeSet: 'MassActionScopeCodeSet',
    description: 'All orders for an issuer',
  },
  {
    name: 'CancelForIssuerOfUnderlyingSecurity',
    id: '1374012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP1',
    addedEP: '85',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 1374,
    type: 'int',
    codeSet: 'MassActionScopeCodeSet',
    description: 'All orders for an issuer of underlying security',
  },
  {
    name: 'Rejected',
    id: '1375001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 1375,
    type: 'int',
    codeSet: 'MassActionResponseCodeSet',
    description: 'Rejected - See MassActionRejectReason(1376)',
  },
  {
    name: 'Accepted',
    id: '1375002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 1375,
    type: 'int',
    codeSet: 'MassActionResponseCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Completed',
    id: '1375003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1375,
    type: 'int',
    codeSet: 'MassActionResponseCodeSet',
    description: 'Completed',
  },
  {
    name: 'MassActionNotSupported',
    id: '1376001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 1376,
    type: 'int',
    codeSet: 'MassActionRejectReasonCodeSet',
    description: 'Mass action not supported',
  },
  {
    name: 'InvalidOrUnknownSecurity',
    id: '1376002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 1376,
    type: 'int',
    codeSet: 'MassActionRejectReasonCodeSet',
    description: 'Invalid or unknown security',
  },
  {
    name: 'InvalidOrUnknownUnderlyingSecurity',
    id: '1376003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 1376,
    type: 'int',
    codeSet: 'MassActionRejectReasonCodeSet',
    description: 'Invalid or unknown underlying security',
  },
  {
    name: 'InvalidOrUnknownProduct',
    id: '1376004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 1376,
    type: 'int',
    codeSet: 'MassActionRejectReasonCodeSet',
    description: 'Invalid or unknown product',
  },
  {
    name: 'InvalidOrUnknownCFICode',
    id: '1376005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 1376,
    type: 'int',
    codeSet: 'MassActionRejectReasonCodeSet',
    description: 'Invalid or unknown CFI Code',
  },
  {
    name: 'InvalidOrUnknownSecurityType',
    id: '1376006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 1376,
    type: 'int',
    codeSet: 'MassActionRejectReasonCodeSet',
    description: 'Invalid or unknown security type',
  },
  {
    name: 'InvalidOrUnknownTradingSession',
    id: '1376007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 1376,
    type: 'int',
    codeSet: 'MassActionRejectReasonCodeSet',
    description: 'Invalid or unknown trading session',
  },
  {
    name: 'InvalidOrUnknownMarket',
    id: '1376008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 1376,
    type: 'int',
    codeSet: 'MassActionRejectReasonCodeSet',
    description: 'Invalid or unknown market',
  },
  {
    name: 'InvalidOrUnknownMarketSegment',
    id: '1376009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 1376,
    type: 'int',
    codeSet: 'MassActionRejectReasonCodeSet',
    description: 'Invalid or unknown market segment',
  },
  {
    name: 'InvalidOrUnknownSecurityGroup',
    id: '1376010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0',
    addedEP: '58',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 1376,
    type: 'int',
    codeSet: 'MassActionRejectReasonCodeSet',
    description: 'Invalid or unknown security group',
  },
  {
    name: 'InvalidOrUnknownSecurityIssuer',
    id: '1376011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP1',
    addedEP: '85',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 1376,
    type: 'int',
    codeSet: 'MassActionRejectReasonCodeSet',
    description: 'Invalid or unknown issuer',
  },
  {
    name: 'InvalidOrUnknownIssuerOfUnderlyingSecurity',
    id: '1376012',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP1',
    addedEP: '85',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 1376,
    type: 'int',
    codeSet: 'MassActionRejectReasonCodeSet',
    description: 'Invalid or unknown issuer of underlying security',
  },
  {
    name: 'Other',
    id: '1376013',
    value: '99',
    sort: 99,
    added: 'FIX.5.0',
    addedEP: '58',
    tag: 1376,
    type: 'int',
    codeSet: 'MassActionRejectReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'PredefinedMultilegSecurity',
    id: '1377001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '59',
    tag: 1377,
    type: 'int',
    codeSet: 'MultilegModelCodeSet',
    description: 'Predefined Multileg Security',
  },
  {
    name: 'UserDefinedMultilegSecurity',
    id: '1377002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '59',
    updated: 'FIX.5.0SP2',
    updatedEP: '195',
    tag: 1377,
    type: 'int',
    codeSet: 'MultilegModelCodeSet',
    description: 'User-defined Multileg Security',
  },
  {
    name: 'UserDefined',
    id: '1377003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '59',
    tag: 1377,
    type: 'int',
    codeSet: 'MultilegModelCodeSet',
    description: 'User-defined, Non-Securitized, Multileg',
  },
  {
    name: 'NetPrice',
    id: '1378001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '59',
    tag: 1378,
    type: 'int',
    codeSet: 'MultilegPriceMethodCodeSet',
    description: 'Net Price',
  },
  {
    name: 'ReversedNetPrice',
    id: '1378002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '59',
    tag: 1378,
    type: 'int',
    codeSet: 'MultilegPriceMethodCodeSet',
    description: 'Reversed Net Price',
  },
  {
    name: 'YieldDifference',
    id: '1378003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '59',
    tag: 1378,
    type: 'int',
    codeSet: 'MultilegPriceMethodCodeSet',
    description: 'Yield Difference',
  },
  {
    name: 'Individual',
    id: '1378004',
    value: '3',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '59',
    tag: 1378,
    type: 'int',
    codeSet: 'MultilegPriceMethodCodeSet',
    description: 'Individual',
  },
  {
    name: 'ContractWeightedAveragePrice',
    id: '1378005',
    value: '4',
    sort: 5,
    added: 'FIX.5.0',
    addedEP: '59',
    tag: 1378,
    type: 'int',
    codeSet: 'MultilegPriceMethodCodeSet',
    description: 'Contract Weighted Average Price',
  },
  {
    name: 'MultipliedPrice',
    id: '1378006',
    value: '5',
    sort: 6,
    added: 'FIX.5.0',
    addedEP: '59',
    tag: 1378,
    type: 'int',
    codeSet: 'MultilegPriceMethodCodeSet',
    description: 'Multiplied Price',
  },
  {
    name: 'OneCancelsTheOther',
    id: '1385001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '60',
    tag: 1385,
    type: 'int',
    codeSet: 'ContingencyTypeCodeSet',
    description: 'One Cancels the Other (OCO)',
  },
  {
    name: 'OneTriggersTheOther',
    id: '1385002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '60',
    tag: 1385,
    type: 'int',
    codeSet: 'ContingencyTypeCodeSet',
    description: 'One Triggers the Other (OTO)',
  },
  {
    name: 'OneUpdatesTheOtherAbsolute',
    id: '1385003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '60',
    tag: 1385,
    type: 'int',
    codeSet: 'ContingencyTypeCodeSet',
    description: 'One Updates the Other (OUO) - Absolute Quantity Reduction',
  },
  {
    name: 'OneUpdatesTheOtherProportional',
    id: '1385004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '60',
    tag: 1385,
    type: 'int',
    codeSet: 'ContingencyTypeCodeSet',
    description: 'One Updates the Other (OUO) - Proportional Quantity Reduction',
  },
  {
    name: 'BidAndOffer',
    id: '1385005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 1385,
    type: 'int',
    codeSet: 'ContingencyTypeCodeSet',
    description: 'Bid and Offer',
  },
  {
    name: 'BidAndOfferOCO',
    id: '1385006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 1385,
    type: 'int',
    codeSet: 'ContingencyTypeCodeSet',
    description: 'Bid and Offer OCO',
  },
  {
    name: 'BrokerCredit',
    id: '1386001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '60',
    tag: 1386,
    type: 'int',
    codeSet: 'ListRejectReasonCodeSet',
    description: 'Broker / Exchange option',
  },
  {
    name: 'ExchangeClosed',
    id: '1386002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '60',
    tag: 1386,
    type: 'int',
    codeSet: 'ListRejectReasonCodeSet',
    description: 'Exchange closed',
  },
  {
    name: 'TooLateToEnter',
    id: '1386003',
    value: '4',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '60',
    tag: 1386,
    type: 'int',
    codeSet: 'ListRejectReasonCodeSet',
    description: 'Too late to enter',
  },
  {
    name: 'UnknownOrder',
    id: '1386004',
    value: '5',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '60',
    tag: 1386,
    type: 'int',
    codeSet: 'ListRejectReasonCodeSet',
    description: 'Unknown order',
  },
  {
    name: 'DuplicateOrder',
    id: '1386005',
    value: '6',
    sort: 5,
    added: 'FIX.5.0',
    addedEP: '60',
    tag: 1386,
    type: 'int',
    codeSet: 'ListRejectReasonCodeSet',
    description: 'Duplicate Order (e.g. dupe ClOrdID)',
  },
  {
    name: 'UnsupportedOrderCharacteristic',
    id: '1386006',
    value: '11',
    sort: 6,
    added: 'FIX.5.0',
    addedEP: '60',
    tag: 1386,
    type: 'int',
    codeSet: 'ListRejectReasonCodeSet',
    description: 'Unsupported order characteristic',
  },
  {
    name: 'Other',
    id: '1386007',
    value: '99',
    sort: 7,
    added: 'FIX.5.0',
    addedEP: '60',
    tag: 1386,
    type: 'int',
    codeSet: 'ListRejectReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'DoNotPublishTrade',
    id: '1390001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '61',
    tag: 1390,
    type: 'int',
    codeSet: 'TradePublishIndicatorCodeSet',
    description: 'Do Not Publish Trade',
  },
  {
    name: 'PublishTrade',
    id: '1390002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '61',
    tag: 1390,
    type: 'int',
    codeSet: 'TradePublishIndicatorCodeSet',
    description: 'Publish Trade',
  },
  {
    name: 'DeferredPublication',
    id: '1390003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '61',
    tag: 1390,
    type: 'int',
    codeSet: 'TradePublishIndicatorCodeSet',
    description: 'Deferred Publication',
  },
  {
    name: 'Published',
    id: '1390004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '229',
    tag: 1390,
    type: 'int',
    codeSet: 'TradePublishIndicatorCodeSet',
    description:
      'Published\n\nIndicates that the transaction has been published to the market.',
  },
  {
    name: 'Retransmission',
    id: '1347001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '63',
    tag: 1347,
    type: 'int',
    codeSet: 'ApplReqTypeCodeSet',
    description: 'Retransmission of application messages for the specified Applications',
  },
  {
    name: 'Subscription',
    id: '1347002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '63',
    tag: 1347,
    type: 'int',
    codeSet: 'ApplReqTypeCodeSet',
    description: 'Subscription to the specified Applications',
  },
  {
    name: 'RequestLastSeqNum',
    id: '1347003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '63',
    tag: 1347,
    type: 'int',
    codeSet: 'ApplReqTypeCodeSet',
    description:
      'Request for the last ApplLastSeqNum published for the specified Applications',
  },
  {
    name: 'RequestApplications',
    id: '1347004',
    value: '3',
    sort: 4,
    added: 'FIX.5.0',
    addedEP: '63',
    tag: 1347,
    type: 'int',
    codeSet: 'ApplReqTypeCodeSet',
    description: 'Request valid set of Applications',
  },
  {
    name: 'Unsubscribe',
    id: '1347005',
    value: '4',
    sort: 5,
    added: 'FIX.5.0',
    addedEP: '63',
    tag: 1347,
    type: 'int',
    codeSet: 'ApplReqTypeCodeSet',
    description: 'Unsubscribe to the specified Applications',
  },
  {
    name: 'CancelRetransmission',
    id: '1347006',
    value: '5',
    sort: 6,
    added: 'FIX.5.0SP1',
    addedEP: '78',
    tag: 1347,
    type: 'int',
    codeSet: 'ApplReqTypeCodeSet',
    description: 'Cancel retransmission',
  },
  {
    name: 'CancelRetransmissionUnsubscribe',
    id: '1347007',
    value: '6',
    sort: 7,
    added: 'FIX.5.0SP1',
    addedEP: '78',
    tag: 1347,
    type: 'int',
    codeSet: 'ApplReqTypeCodeSet',
    description: 'Cancel retransmission and unsubscribe to the specified applications',
  },
  {
    name: 'RequestSuccessfullyProcessed',
    id: '1348001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '63',
    tag: 1348,
    type: 'int',
    codeSet: 'ApplResponseTypeCodeSet',
    description: 'Request successfully processed',
  },
  {
    name: 'ApplicationDoesNotExist',
    id: '1348002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '63',
    tag: 1348,
    type: 'int',
    codeSet: 'ApplResponseTypeCodeSet',
    description: 'Application does not exist',
  },
  {
    name: 'MessagesNotAvailable',
    id: '1348003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '63',
    tag: 1348,
    type: 'int',
    codeSet: 'ApplResponseTypeCodeSet',
    description: 'Messages not available',
  },
  {
    name: 'ApplicationDoesNotExist',
    id: '1354001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '63',
    tag: 1354,
    type: 'int',
    codeSet: 'ApplResponseErrorCodeSet',
    description: 'Application does not exist',
  },
  {
    name: 'MessagesRequestedAreNotAvailable',
    id: '1354002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '63',
    tag: 1354,
    type: 'int',
    codeSet: 'ApplResponseErrorCodeSet',
    description: 'Messages requested are not available',
  },
  {
    name: 'UserNotAuthorizedForApplication',
    id: '1354003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0',
    addedEP: '63',
    tag: 1354,
    type: 'int',
    codeSet: 'ApplResponseErrorCodeSet',
    description: 'User not authorized for application',
  },
  {
    name: 'ApplSeqNumReset',
    id: '1426001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0',
    addedEP: '-1',
    tag: 1426,
    type: 'int',
    codeSet: 'ApplReportTypeCodeSet',
    description: 'Reset ApplSeqNum to new value specified in ApplNewSeqNum(1399)',
  },
  {
    name: 'LastMessageSent',
    id: '1426002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0',
    addedEP: '-1',
    tag: 1426,
    type: 'int',
    codeSet: 'ApplReportTypeCodeSet',
    description:
      'Reports that the last message has been sent for the ApplIDs Refer to RefApplLastSeqNum(1357) for the application sequence number of the last message.',
  },
  {
    name: 'ApplicationAlive',
    id: '1426003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0',
    addedEP: '-1',
    tag: 1426,
    type: 'int',
    codeSet: 'ApplReportTypeCodeSet',
    description:
      'Heartbeat message indicating that Application identified by RefApplID(1355) is still alive. Refer to RefApplLastSeqNum(1357) for the application sequence number of the previous message.',
  },
  {
    name: 'ResendComplete',
    id: '1426004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP1',
    addedEP: '91',
    tag: 1426,
    type: 'int',
    codeSet: 'ApplReportTypeCodeSet',
    description: 'Application message re-send completed.',
  },
  {
    name: 'Seconds',
    id: '1429001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1429,
    type: 'int',
    codeSet: 'OrderDelayUnitCodeSet',
    description: 'Seconds (default if not specified)',
  },
  {
    name: 'TenthsOfASecond',
    id: '1429002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1429,
    type: 'int',
    codeSet: 'OrderDelayUnitCodeSet',
    description: 'Tenths of a second',
  },
  {
    name: 'HundredthsOfASecond',
    id: '1429003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1429,
    type: 'int',
    codeSet: 'OrderDelayUnitCodeSet',
    description: 'Hundredths of a second',
  },
  {
    name: 'Milliseconds',
    id: '1429004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1429,
    type: 'int',
    codeSet: 'OrderDelayUnitCodeSet',
    description: 'milliseconds',
  },
  {
    name: 'Microseconds',
    id: '1429005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1429,
    type: 'int',
    codeSet: 'OrderDelayUnitCodeSet',
    description: 'microseconds',
  },
  {
    name: 'Nanoseconds',
    id: '1429006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1429,
    type: 'int',
    codeSet: 'OrderDelayUnitCodeSet',
    description: 'nanoseconds',
  },
  {
    name: 'Minutes',
    id: '1429007',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1429,
    type: 'int',
    codeSet: 'OrderDelayUnitCodeSet',
    description: 'minutes',
  },
  {
    name: 'Hours',
    id: '1429008',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1429,
    type: 'int',
    codeSet: 'OrderDelayUnitCodeSet',
    description: 'hours',
  },
  {
    name: 'Days',
    id: '1429009',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1429,
    type: 'int',
    codeSet: 'OrderDelayUnitCodeSet',
    description: 'days',
  },
  {
    name: 'Weeks',
    id: '1429010',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1429,
    type: 'int',
    codeSet: 'OrderDelayUnitCodeSet',
    description: 'weeks',
  },
  {
    name: 'Months',
    id: '1429011',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1429,
    type: 'int',
    codeSet: 'OrderDelayUnitCodeSet',
    description: 'months',
  },
  {
    name: 'Years',
    id: '1429012',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1429,
    type: 'int',
    codeSet: 'OrderDelayUnitCodeSet',
    description: 'years',
  },
  {
    name: 'Electronic',
    id: '1430001',
    value: 'E',
    sort: 0,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 1430,
    type: 'char',
    codeSet: 'VenueTypeCodeSet',
    description: 'Electronic exchange',
  },
  {
    name: 'Pit',
    id: '1430002',
    value: 'P',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1430,
    type: 'char',
    codeSet: 'VenueTypeCodeSet',
    description: 'Pit',
  },
  {
    name: 'ExPit',
    id: '1430003',
    value: 'X',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 1430,
    type: 'char',
    codeSet: 'VenueTypeCodeSet',
    description: 'Ex-pit',
  },
  {
    name: 'ClearingHouse',
    id: '1430004',
    value: 'C',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1430,
    type: 'char',
    codeSet: 'VenueTypeCodeSet',
    description: 'Clearinghouse',
  },
  {
    name: 'RegisteredMarket',
    id: '1430005',
    value: 'R',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1430,
    type: 'char',
    codeSet: 'VenueTypeCodeSet',
    description:
      'Registered market\n\nMarkets registered with regulators such as exchange, multilateral trading facility (MTF), swap execution facility (SEF). In the context of regulatory reporting (e.g. CFTC reporting), this is used for regulated markets, e.g. swap markets.',
  },
  {
    name: 'OffMarket',
    id: '1430006',
    value: 'O',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1430,
    type: 'char',
    codeSet: 'VenueTypeCodeSet',
    description:
      'Off-market\n\nOff-book, off-facility. In the context of regulatory reporting (e.g. CFTC reporting) this identifies trades conducted away from a regulated market.',
  },
  {
    name: 'CentralLimitOrderBook',
    id: '1430007',
    value: 'B',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '163',
    tag: 1430,
    type: 'char',
    codeSet: 'VenueTypeCodeSet',
    description: 'Central limit order book',
  },
  {
    name: 'QuoteDrivenMarket',
    id: '1430008',
    value: 'Q',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '163',
    tag: 1430,
    type: 'char',
    codeSet: 'VenueTypeCodeSet',
    description: 'Quote driven market',
  },
  {
    name: 'DarkOrderBook',
    id: '1430009',
    value: 'D',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '163',
    tag: 1430,
    type: 'char',
    codeSet: 'VenueTypeCodeSet',
    description: 'Dark order book',
  },
  {
    name: 'AuctionDrivenMarket',
    id: '1430010',
    value: 'A',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 1430,
    type: 'char',
    codeSet: 'VenueTypeCodeSet',
    description:
      'Auction driven market\n\nMarkets where matching occurs only in scheduled auctions.',
  },
  {
    name: 'QuoteNegotiation',
    id: '1430011',
    value: 'N',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 1430,
    type: 'char',
    codeSet: 'VenueTypeCodeSet',
    description:
      'Quote negotiation\n\nDiscretionary quoting on request or "request for quote" market.',
  },
  {
    name: 'VoiceNegotiation',
    id: '1430012',
    value: 'V',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 1430,
    type: 'char',
    codeSet: 'VenueTypeCodeSet',
    description:
      'Voice negotiation\n\nA trading system where transactions between members are arranged through voice negotiation.',
  },
  {
    name: 'HybridMarket',
    id: '1430013',
    value: 'H',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    updated: 'FIX.Latest',
    updatedEP: '286',
    tag: 1430,
    type: 'char',
    codeSet: 'VenueTypeCodeSet',
    description:
      'Hybrid market\n\nA hybrid system falling into two or more types of trading systems. In the context of ESMA reporting, this is for "Hybrid system." In the context of FCA reporting, this is for "Any other, including hybrid."',
  },
  {
    name: 'OtherMarket',
    id: '1430014',
    value: 'z',
    sort: 13,
    added: 'FIX.Latest',
    addedEP: '277',
    updated: 'FIX.Latest',
    updatedEP: '286',
    tag: 1430,
    type: 'char',
    codeSet: 'VenueTypeCodeSet',
    description:
      'Other market (lowercase "z")\n\nA market that does not fall under any of the market types defined for VenueType(1430). In the context of ESMA reporting, this is for "Any other, excluding hybrid."',
  },
  {
    name: 'GTCFromPreviousDay',
    id: '1431001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1431,
    type: 'int',
    codeSet: 'RefOrdIDReasonCodeSet',
    description: 'GTC from previous day',
  },
  {
    name: 'PartialFillRemaining',
    id: '1431002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1431,
    type: 'int',
    codeSet: 'RefOrdIDReasonCodeSet',
    description: 'Partial Fill Remaining',
  },
  {
    name: 'OrderChanged',
    id: '1431003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1431,
    type: 'int',
    codeSet: 'RefOrdIDReasonCodeSet',
    description: 'Order Changed',
  },
  {
    name: 'MemberTradingForTheirOwnAccount',
    id: '1432001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1432,
    type: 'int',
    codeSet: 'OrigCustOrderCapacityCodeSet',
    description: 'Member trading for their own account',
  },
  {
    name: 'ClearingFirmTradingForItsProprietaryAccount',
    id: '1432002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1432,
    type: 'int',
    codeSet: 'OrigCustOrderCapacityCodeSet',
    description: 'Clearing Firm trading for its proprietary account',
  },
  {
    name: 'MemberTradingForAnotherMember',
    id: '1432003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1432,
    type: 'int',
    codeSet: 'OrigCustOrderCapacityCodeSet',
    description: 'Member trading for another member',
  },
  {
    name: 'AllOther',
    id: '1432004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP1',
    addedEP: '77',
    tag: 1432,
    type: 'int',
    codeSet: 'OrigCustOrderCapacityCodeSet',
    description: 'All other',
  },
  {
    name: 'UtilityProvidedStandardModel',
    id: '1434001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP1',
    addedEP: '79',
    tag: 1434,
    type: 'int',
    codeSet: 'ModelTypeCodeSet',
    description: 'Utility provided standard model',
  },
  {
    name: 'ProprietaryModel',
    id: '1434002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '79',
    tag: 1434,
    type: 'int',
    codeSet: 'ModelTypeCodeSet',
    description: 'Proprietary (user supplied) model',
  },
  {
    name: 'Shares',
    id: '1435001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP1',
    addedEP: '80',
    tag: 1435,
    type: 'int',
    codeSet: 'ContractMultiplierUnitCodeSet',
    description: 'Shares',
  },
  {
    name: 'Hours',
    id: '1435002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '80',
    tag: 1435,
    type: 'int',
    codeSet: 'ContractMultiplierUnitCodeSet',
    description: 'Hours',
  },
  {
    name: 'Days',
    id: '1435003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '80',
    tag: 1435,
    type: 'int',
    codeSet: 'ContractMultiplierUnitCodeSet',
    description: 'Days',
  },
  {
    name: 'NERCEasternOffPeak',
    id: '1439001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP1',
    addedEP: '80',
    tag: 1439,
    type: 'int',
    codeSet: 'FlowScheduleTypeCodeSet',
    description: 'NERC Eastern Off-Peak',
  },
  {
    name: 'NERCWesternOffPeak',
    id: '1439002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '80',
    tag: 1439,
    type: 'int',
    codeSet: 'FlowScheduleTypeCodeSet',
    description: 'NERC Western Off-Peak',
  },
  {
    name: 'NERCCalendarAllDaysInMonth',
    id: '1439003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '80',
    tag: 1439,
    type: 'int',
    codeSet: 'FlowScheduleTypeCodeSet',
    description: 'NERC Calendar-All Days in month',
  },
  {
    name: 'NERCEasternPeak',
    id: '1439004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP1',
    addedEP: '80',
    tag: 1439,
    type: 'int',
    codeSet: 'FlowScheduleTypeCodeSet',
    description: 'NERC Eastern Peak',
  },
  {
    name: 'NERCWesternPeak',
    id: '1439005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP1',
    addedEP: '80',
    tag: 1439,
    type: 'int',
    codeSet: 'FlowScheduleTypeCodeSet',
    description: 'NERC Western Peak',
  },
  {
    name: 'AllTimes',
    id: '1439006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 1439,
    type: 'int',
    codeSet: 'FlowScheduleTypeCodeSet',
    description: 'All times',
  },
  {
    name: 'OnPeak',
    id: '1439007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 1439,
    type: 'int',
    codeSet: 'FlowScheduleTypeCodeSet',
    description: 'On peak',
  },
  {
    name: 'OffPeak',
    id: '1439008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 1439,
    type: 'int',
    codeSet: 'FlowScheduleTypeCodeSet',
    description: 'Off peak',
  },
  {
    name: 'Base',
    id: '1439009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 1439,
    type: 'int',
    codeSet: 'FlowScheduleTypeCodeSet',
    description: 'Base',
  },
  {
    name: 'Block',
    id: '1439010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 1439,
    type: 'int',
    codeSet: 'FlowScheduleTypeCodeSet',
    description: 'Block',
  },
  {
    name: 'Other',
    id: '1439011',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 1439,
    type: 'int',
    codeSet: 'FlowScheduleTypeCodeSet',
    description: 'Other',
  },
  {
    name: 'Bloomberg',
    id: '1446001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP1',
    addedEP: '82',
    tag: 1446,
    type: 'int',
    codeSet: 'RateSourceCodeSet',
    description: 'Bloomberg',
  },
  {
    name: 'Reuters',
    id: '1446002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '82',
    tag: 1446,
    type: 'int',
    codeSet: 'RateSourceCodeSet',
    description: 'Reuters',
  },
  {
    name: 'Telerate',
    id: '1446003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '82',
    tag: 1446,
    type: 'int',
    codeSet: 'RateSourceCodeSet',
    description: 'Telerate',
  },
  {
    name: 'ISDARateOption',
    id: '1446004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1446,
    type: 'int',
    codeSet: 'RateSourceCodeSet',
    description:
      'ISDA Settlement Rate Option\n\nThe source of the currency conversion as specified by the ISDA terms in Annex A to the 1998 FX and Currency Option Definitions. See http://www.fpml.org/coding-scheme/settlement-rate-option',
  },
  {
    name: 'Other',
    id: '1446005',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP1',
    addedEP: '82',
    tag: 1446,
    type: 'int',
    codeSet: 'RateSourceCodeSet',
    description: 'Other',
  },
  {
    name: 'Primary',
    id: '1447001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP1',
    addedEP: '82',
    tag: 1447,
    type: 'int',
    codeSet: 'RateSourceTypeCodeSet',
    description: 'Primary',
  },
  {
    name: 'Secondary',
    id: '1447002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '82',
    tag: 1447,
    type: 'int',
    codeSet: 'RateSourceTypeCodeSet',
    description: 'Secondary',
  },
  {
    name: 'FullRestructuring',
    id: '1449001',
    value: 'FR',
    sort: 0,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    tag: 1449,
    type: 'String',
    codeSet: 'RestructuringTypeCodeSet',
    description: 'Full Restructuring',
  },
  {
    name: 'ModifiedRestructuring',
    id: '1449002',
    value: 'MR',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    tag: 1449,
    type: 'String',
    codeSet: 'RestructuringTypeCodeSet',
    description: 'Modified Restructuring',
  },
  {
    name: 'ModifiedModRestructuring',
    id: '1449003',
    value: 'MM',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    tag: 1449,
    type: 'String',
    codeSet: 'RestructuringTypeCodeSet',
    description: 'Modified Mod Restructuring',
  },
  {
    name: 'NoRestructuringSpecified',
    id: '1449004',
    value: 'XR',
    sort: 3,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    tag: 1449,
    type: 'String',
    codeSet: 'RestructuringTypeCodeSet',
    description: 'No Restructuring specified',
  },
  {
    name: 'SeniorSecured',
    id: '1450001',
    value: 'SD',
    sort: 0,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    tag: 1450,
    type: 'String',
    codeSet: 'SeniorityCodeSet',
    description: 'Senior Secured',
  },
  {
    name: 'Senior',
    id: '1450002',
    value: 'SR',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    tag: 1450,
    type: 'String',
    codeSet: 'SeniorityCodeSet',
    description: 'Senior',
  },
  {
    name: 'Subordinated',
    id: '1450003',
    value: 'SB',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '83',
    tag: 1450,
    type: 'String',
    codeSet: 'SeniorityCodeSet',
    description: 'Subordinated',
  },
  {
    name: 'Junior',
    id: '1450004',
    value: 'JR',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 1450,
    type: 'String',
    codeSet: 'SeniorityCodeSet',
    description:
      'Junior\n\nIn the context of MiFID II this value is used as identified in RTS 23 Annex I Table 3 Field 23 "Seniority of the bond".',
  },
  {
    name: 'Mezzanine',
    id: '1450005',
    value: 'MZ',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 1450,
    type: 'String',
    codeSet: 'SeniorityCodeSet',
    description:
      'Mezzanine\n\nIn the context of MiFID II this value is used as identified in RTS 23 Annex I Table 3 Field 23 "Seniority of the bond".',
  },
  {
    name: 'SeniorNonPreferred',
    id: '1450006',
    value: 'SN',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 1450,
    type: 'String',
    codeSet: 'SeniorityCodeSet',
    description:
      "Senior Non-Preferred\n\nFor CDS reference obligations of non-preferred senior debt issued by European Financials that constitute a layer of debt ranking between the bank's normal senior debt but above the bank's normal tier 2 subordinated debt (reference: ISDA Credit Market Infrastructure Group).",
  },
  {
    name: 'IndustryClassification',
    id: '1470001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '87',
    tag: 1470,
    type: 'int',
    codeSet: 'SecurityListTypeCodeSet',
    description: 'Industry Classification',
  },
  {
    name: 'TradingList',
    id: '1470002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '87',
    tag: 1470,
    type: 'int',
    codeSet: 'SecurityListTypeCodeSet',
    description: 'Trading List',
  },
  {
    name: 'Market',
    id: '1470003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP1',
    addedEP: '87',
    tag: 1470,
    type: 'int',
    codeSet: 'SecurityListTypeCodeSet',
    description: 'Market / Market Segment List',
  },
  {
    name: 'NewspaperList',
    id: '1470004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP1',
    addedEP: '87',
    tag: 1470,
    type: 'int',
    codeSet: 'SecurityListTypeCodeSet',
    description: 'Newspaper List',
  },
  {
    name: 'ICB',
    id: '1471001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '87',
    tag: 1471,
    type: 'int',
    codeSet: 'SecurityListTypeSourceCodeSet',
    description:
      'ICB (Industry Classification Benchmark) published by Dow Jones and FTSE - www.icbenchmark.com',
  },
  {
    name: 'NAICS',
    id: '1471002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '87',
    tag: 1471,
    type: 'int',
    codeSet: 'SecurityListTypeSourceCodeSet',
    description:
      'NAICS (North American Industry Classification System). Replaced SIC (Standard Industry Classification) www.census.gov/naics or www.naics.com.',
  },
  {
    name: 'GICS',
    id: '1471003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP1',
    addedEP: '87',
    tag: 1471,
    type: 'int',
    codeSet: 'SecurityListTypeSourceCodeSet',
    description:
      'GICS (Global Industry Classification Standard) published by Standards & Poor',
  },
  {
    name: 'CompanyNews',
    id: '1473001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP1',
    addedEP: '90',
    tag: 1473,
    type: 'int',
    codeSet: 'NewsCategoryCodeSet',
    description: 'Company News',
  },
  {
    name: 'MarketplaceNews',
    id: '1473002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '90',
    tag: 1473,
    type: 'int',
    codeSet: 'NewsCategoryCodeSet',
    description: 'Marketplace News',
  },
  {
    name: 'FinancialMarketNews',
    id: '1473003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '90',
    tag: 1473,
    type: 'int',
    codeSet: 'NewsCategoryCodeSet',
    description: 'Financial Market News',
  },
  {
    name: 'TechnicalNews',
    id: '1473004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP1',
    addedEP: '90',
    tag: 1473,
    type: 'int',
    codeSet: 'NewsCategoryCodeSet',
    description: 'Technical News',
  },
  {
    name: 'OtherNews',
    id: '1473005',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP1',
    addedEP: '90',
    tag: 1473,
    type: 'int',
    codeSet: 'NewsCategoryCodeSet',
    description: 'Other News',
  },
  {
    name: 'Replacement',
    id: '1477001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP1',
    addedEP: '90',
    tag: 1477,
    type: 'int',
    codeSet: 'NewsRefTypeCodeSet',
    description: 'Replacement',
  },
  {
    name: 'OtherLanguage',
    id: '1477002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '90',
    updated: 'FIX.5.0SP2',
    updatedEP: '190',
    tag: 1477,
    type: 'int',
    codeSet: 'NewsRefTypeCodeSet',
    description: 'Other language',
  },
  {
    name: 'Complimentary',
    id: '1477003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '90',
    tag: 1477,
    type: 'int',
    codeSet: 'NewsRefTypeCodeSet',
    description: 'Complimentary',
  },
  {
    name: 'Withdrawal',
    id: '1477004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '190',
    tag: 1477,
    type: 'int',
    codeSet: 'NewsRefTypeCodeSet',
    description:
      'Withdrawal\n\nWithdrawal of the referenced news item, e.g. to correct an error.',
  },
  {
    name: 'FixedStrike',
    id: '1478001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 1478,
    type: 'int',
    codeSet: 'StrikePriceDeterminationMethodCodeSet',
    description: 'Fixed strike (default if not specified)',
  },
  {
    name: 'StrikeSetAtExpiration',
    id: '1478002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1478,
    type: 'int',
    codeSet: 'StrikePriceDeterminationMethodCodeSet',
    description:
      'Strike set at expiration to underlying or other value (lookback floating)',
  },
  {
    name: 'StrikeSetToAverageAcrossLife',
    id: '1478003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1478,
    type: 'int',
    codeSet: 'StrikePriceDeterminationMethodCodeSet',
    description:
      'Strike set to average of underlying settlement price across the life of the option',
  },
  {
    name: 'StrikeSetToOptimalValue',
    id: '1478004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1478,
    type: 'int',
    codeSet: 'StrikePriceDeterminationMethodCodeSet',
    description: 'Strike set to optimal value',
  },
  {
    name: 'LessThan',
    id: '1479001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1479,
    type: 'int',
    codeSet: 'StrikePriceBoundaryMethodCodeSet',
    description: 'Less than underlying price is in-the-money (ITM)',
  },
  {
    name: 'LessThanOrEqual',
    id: '1479002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1479,
    type: 'int',
    codeSet: 'StrikePriceBoundaryMethodCodeSet',
    description: 'Less than or equal to the underlying price is in-the-money(ITM)',
  },
  {
    name: 'Equal',
    id: '1479003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1479,
    type: 'int',
    codeSet: 'StrikePriceBoundaryMethodCodeSet',
    description: 'Equal to the underlying price is in-the-money(ITM)',
  },
  {
    name: 'GreaterThanOrEqual',
    id: '1479004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1479,
    type: 'int',
    codeSet: 'StrikePriceBoundaryMethodCodeSet',
    description: 'Greater than or equal to underlying price is in-the-money(ITM)',
  },
  {
    name: 'GreaterThan',
    id: '1479005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1479,
    type: 'int',
    codeSet: 'StrikePriceBoundaryMethodCodeSet',
    description: 'Greater than underlying is in-the-money(ITM)',
  },
  {
    name: 'Regular',
    id: '1481001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1481,
    type: 'int',
    codeSet: 'UnderlyingPriceDeterminationMethodCodeSet',
    description: 'Regular',
  },
  {
    name: 'SpecialReference',
    id: '1481002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1481,
    type: 'int',
    codeSet: 'UnderlyingPriceDeterminationMethodCodeSet',
    description: 'Special reference',
  },
  {
    name: 'OptimalValue',
    id: '1481003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1481,
    type: 'int',
    codeSet: 'UnderlyingPriceDeterminationMethodCodeSet',
    description: 'Optimal value (Lookback)',
  },
  {
    name: 'AverageValue',
    id: '1481004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1481,
    type: 'int',
    codeSet: 'UnderlyingPriceDeterminationMethodCodeSet',
    description: 'Average value (Asian option)',
  },
  {
    name: 'Vanilla',
    id: '1482001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1482,
    type: 'int',
    codeSet: 'OptPayoutTypeCodeSet',
    description: 'Vanilla',
  },
  {
    name: 'Capped',
    id: '1482002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1482,
    type: 'int',
    codeSet: 'OptPayoutTypeCodeSet',
    description: 'Capped',
  },
  {
    name: 'Binary',
    id: '1482003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    updated: 'FIX.5.0SP2',
    updatedEP: '238',
    tag: 1482,
    type: 'int',
    codeSet: 'OptPayoutTypeCodeSet',
    description: 'Digital (Binary)',
  },
  {
    name: 'Asian',
    id: '1482004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 1482,
    type: 'int',
    codeSet: 'OptPayoutTypeCodeSet',
    description: 'Asian',
  },
  {
    name: 'Barrier',
    id: '1482005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 1482,
    type: 'int',
    codeSet: 'OptPayoutTypeCodeSet',
    description: 'Barrier',
  },
  {
    name: 'DigitalBarrier',
    id: '1482006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 1482,
    type: 'int',
    codeSet: 'OptPayoutTypeCodeSet',
    description: 'Digital Barrier',
  },
  {
    name: 'Lookback',
    id: '1482007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 1482,
    type: 'int',
    codeSet: 'OptPayoutTypeCodeSet',
    description: 'Lookback',
  },
  {
    name: 'OtherPathDependent',
    id: '1482008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 1482,
    type: 'int',
    codeSet: 'OptPayoutTypeCodeSet',
    description: 'Other path dependent',
  },
  {
    name: 'Other',
    id: '1482009',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 1482,
    type: 'int',
    codeSet: 'OptPayoutTypeCodeSet',
    description: 'Other',
  },
  {
    name: 'Capped',
    id: '1484001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Capped',
  },
  {
    name: 'Trigger',
    id: '1484002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Trigger',
  },
  {
    name: 'KnockInUp',
    id: '1484003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Knock-in up',
  },
  {
    name: 'KnockInDown',
    id: '1484004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Knock-in down',
  },
  {
    name: 'KnockOutUp',
    id: '1484005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Knock-out up',
  },
  {
    name: 'KnockOutDown',
    id: '1484006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Knock-out down',
  },
  {
    name: 'Underlying',
    id: '1484007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Underlying',
  },
  {
    name: 'ResetBarrier',
    id: '1484008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Reset Barrier',
  },
  {
    name: 'RollingBarrier',
    id: '1484009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Rolling Barrier',
  },
  {
    name: 'OneTouch',
    id: '1484010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'One-touch',
  },
  {
    name: 'NoTouch',
    id: '1484011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'No-touch',
  },
  {
    name: 'DblOneTouch',
    id: '1484012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Double one-touch',
  },
  {
    name: 'DblNoTouch',
    id: '1484013',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Double no-touch',
  },
  {
    name: 'FXComposite',
    id: '1484014',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Foreign exchange composite',
  },
  {
    name: 'FXQuanto',
    id: '1484015',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Foreign exchange Quanto',
  },
  {
    name: 'FXCrssCcy',
    id: '1484016',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Foreign exchange cross currency',
  },
  {
    name: 'StrkSpread',
    id: '1484017',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Strike spread',
  },
  {
    name: 'ClndrSpread',
    id: '1484018',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Calendar spread',
  },
  {
    name: 'PxObsvtn',
    id: '1484019',
    value: '19',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Price observation (Asian or Lookback)',
  },
  {
    name: 'PassThrough',
    id: '1484020',
    value: '20',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Pass-through',
  },
  {
    name: 'StrkSched',
    id: '1484021',
    value: '21',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Strike schedule',
  },
  {
    name: 'EquityValuation',
    id: '1484022',
    value: '22',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Equity valuation',
  },
  {
    name: 'DividendValuation',
    id: '1484023',
    value: '23',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 1484,
    type: 'int',
    codeSet: 'ComplexEventTypeCodeSet',
    description: 'Dividend valuation',
  },
  {
    name: 'LessThanComplexEventPrice',
    id: '1487001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1487,
    type: 'int',
    codeSet: 'ComplexEventPriceBoundaryMethodCodeSet',
    description: 'Less than ComplexEventPrice(1486)',
  },
  {
    name: 'LessThanOrEqualToComplexEventPrice',
    id: '1487002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1487,
    type: 'int',
    codeSet: 'ComplexEventPriceBoundaryMethodCodeSet',
    description: 'Less than or equal to ComplexEventPrice(1486)',
  },
  {
    name: 'EqualToComplexEventPrice',
    id: '1487003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1487,
    type: 'int',
    codeSet: 'ComplexEventPriceBoundaryMethodCodeSet',
    description: 'Equal to ComplexEventPrice(1486)',
  },
  {
    name: 'GreaterThanOrEqualToComplexEventPrice',
    id: '1487004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1487,
    type: 'int',
    codeSet: 'ComplexEventPriceBoundaryMethodCodeSet',
    description: 'Greater than or equal to ComplexEventPrice(1486)',
  },
  {
    name: 'GreaterThanComplexEventPrice',
    id: '1487005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1487,
    type: 'int',
    codeSet: 'ComplexEventPriceBoundaryMethodCodeSet',
    description: 'Greater than ComplexEventPrice(1486)',
  },
  {
    name: 'Expiration',
    id: '1489001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1489,
    type: 'int',
    codeSet: 'ComplexEventPriceTimeTypeCodeSet',
    description: 'Expiration',
  },
  {
    name: 'Immediate',
    id: '1489002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1489,
    type: 'int',
    codeSet: 'ComplexEventPriceTimeTypeCodeSet',
    description: 'Immediate (At Any Time)',
  },
  {
    name: 'SpecifiedDate',
    id: '1489003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1489,
    type: 'int',
    codeSet: 'ComplexEventPriceTimeTypeCodeSet',
    description: 'Specified Date/Time',
  },
  {
    name: 'Close',
    id: '1489004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 1489,
    type: 'int',
    codeSet: 'ComplexEventPriceTimeTypeCodeSet',
    description: 'Close\n\nOfficial closing time of the exchange on valuation date.',
  },
  {
    name: 'Open',
    id: '1489005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 1489,
    type: 'int',
    codeSet: 'ComplexEventPriceTimeTypeCodeSet',
    description: 'Open\n\nOfficial opening time of the exchange on valuation date.',
  },
  {
    name: 'OfficialSettlPrice',
    id: '1489006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 1489,
    type: 'int',
    codeSet: 'ComplexEventPriceTimeTypeCodeSet',
    description:
      'Official settlement price\n\nOfficial settlement price determination time.',
  },
  {
    name: 'DerivativesClose',
    id: '1489007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 1489,
    type: 'int',
    codeSet: 'ComplexEventPriceTimeTypeCodeSet',
    description:
      'Derivatives close\n\nOfficial closing time of the derivatives exchange.',
  },
  {
    name: 'AsSpecifiedMasterConfirmation',
    id: '1489008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 1489,
    type: 'int',
    codeSet: 'ComplexEventPriceTimeTypeCodeSet',
    description: 'As specified in Master Confirmation',
  },
  {
    name: 'And',
    id: '1490001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1490,
    type: 'int',
    codeSet: 'ComplexEventConditionCodeSet',
    description: 'And',
  },
  {
    name: 'Or',
    id: '1490002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '92',
    tag: 1490,
    type: 'int',
    codeSet: 'ComplexEventConditionCodeSet',
    description: 'Or',
  },
  {
    name: 'StreamAssignmentForNewCustomer',
    id: '1498001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '93',
    tag: 1498,
    type: 'int',
    codeSet: 'StreamAsgnReqTypeCodeSet',
    description: 'Stream assignment for new customer(s)',
  },
  {
    name: 'StreamAssignmentForExistingCustomer',
    id: '1498002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '93',
    tag: 1498,
    type: 'int',
    codeSet: 'StreamAsgnReqTypeCodeSet',
    description: 'Stream assignment for existing customer(s)',
  },
  {
    name: 'UnknownClient',
    id: '1502001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP1',
    addedEP: '93',
    tag: 1502,
    type: 'int',
    codeSet: 'StreamAsgnRejReasonCodeSet',
    description: 'Unknown client',
  },
  {
    name: 'ExceedsMaximumSize',
    id: '1502002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '93',
    tag: 1502,
    type: 'int',
    codeSet: 'StreamAsgnRejReasonCodeSet',
    description: 'Exceeds maximum size',
  },
  {
    name: 'UnknownOrInvalidCurrencyPair',
    id: '1502003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '93',
    tag: 1502,
    type: 'int',
    codeSet: 'StreamAsgnRejReasonCodeSet',
    description: 'Unknown or Invalid currency pair',
  },
  {
    name: 'NoAvailableStream',
    id: '1502004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP1',
    addedEP: '93',
    tag: 1502,
    type: 'int',
    codeSet: 'StreamAsgnRejReasonCodeSet',
    description: 'No available stream',
  },
  {
    name: 'Other',
    id: '1502005',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP1',
    addedEP: '93',
    tag: 1502,
    type: 'int',
    codeSet: 'StreamAsgnRejReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'AssignmentAccepted',
    id: '1503001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP1',
    addedEP: '93',
    tag: 1503,
    type: 'int',
    codeSet: 'StreamAsgnAckTypeCodeSet',
    description: 'Assignment Accepted',
  },
  {
    name: 'AssignmentRejected',
    id: '1503002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '93',
    tag: 1503,
    type: 'int',
    codeSet: 'StreamAsgnAckTypeCodeSet',
    description: 'Assignment Rejected',
  },
  {
    name: 'Assignment',
    id: '1617001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP1',
    addedEP: '93',
    tag: 1617,
    type: 'int',
    codeSet: 'StreamAsgnTypeCodeSet',
    description: 'Assignment',
  },
  {
    name: 'Rejected',
    id: '1617002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP1',
    addedEP: '93',
    tag: 1617,
    type: 'int',
    codeSet: 'StreamAsgnTypeCodeSet',
    description: 'Rejected',
  },
  {
    name: 'Terminate',
    id: '1617003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP1',
    addedEP: '93',
    tag: 1617,
    type: 'int',
    codeSet: 'StreamAsgnTypeCodeSet',
    description: 'Terminate/Unassign',
  },
  {
    name: 'Match',
    id: '1625001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '99',
    tag: 1625,
    type: 'int',
    codeSet: 'MatchInstCodeSet',
    description: 'Match',
  },
  {
    name: 'DoNotMatch',
    id: '1625002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '99',
    tag: 1625,
    type: 'int',
    codeSet: 'MatchInstCodeSet',
    description: 'Do Not Match',
  },
  {
    name: 'ThisOrder',
    id: '1628001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 1628,
    type: 'int',
    codeSet: 'TriggerScopeCodeSet',
    description: 'This order (default)',
  },
  {
    name: 'OtherOrder',
    id: '1628002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 1628,
    type: 'int',
    codeSet: 'TriggerScopeCodeSet',
    description: 'Other order (use RefID)',
  },
  {
    name: 'AllOtherOrdersForGivenSecurity',
    id: '1628003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 1628,
    type: 'int',
    codeSet: 'TriggerScopeCodeSet',
    description: 'All other orders for the given security',
  },
  {
    name: 'AllOtherOrdersForGivenSecurityAndPrice',
    id: '1628004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 1628,
    type: 'int',
    codeSet: 'TriggerScopeCodeSet',
    description: 'All other orders for the given security and price',
  },
  {
    name: 'AllOtherOrdersForGivenSecurityAndSide',
    id: '1628005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 1628,
    type: 'int',
    codeSet: 'TriggerScopeCodeSet',
    description: 'All other orders for the given security and side',
  },
  {
    name: 'AllOtherOrdersForGivenSecurityPriceAndSide',
    id: '1628006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 1628,
    type: 'int',
    codeSet: 'TriggerScopeCodeSet',
    description: 'All other orders for the given security, price and side',
  },
  {
    name: 'CreditLimit',
    id: '1631001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 1631,
    type: 'int',
    codeSet: 'LimitAmtTypeCodeSet',
    description: 'Credit limit',
  },
  {
    name: 'GrossPositionLimit',
    id: '1631002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 1631,
    type: 'int',
    codeSet: 'LimitAmtTypeCodeSet',
    description: 'Gross position limit',
  },
  {
    name: 'NetPositionLimit',
    id: '1631003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 1631,
    type: 'int',
    codeSet: 'LimitAmtTypeCodeSet',
    description: 'Net position limit',
  },
  {
    name: 'RiskExposureLimit',
    id: '1631004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 1631,
    type: 'int',
    codeSet: 'LimitAmtTypeCodeSet',
    description: 'Risk exposure limit',
  },
  {
    name: 'LongPositionLimit',
    id: '1631005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 1631,
    type: 'int',
    codeSet: 'LimitAmtTypeCodeSet',
    description: 'Long position limit',
  },
  {
    name: 'ShortPositionLimit',
    id: '1631006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '100',
    tag: 1631,
    type: 'int',
    codeSet: 'LimitAmtTypeCodeSet',
    description: 'Short position limit',
  },
  {
    name: 'Summary',
    id: '1637001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1637,
    type: 'int',
    codeSet: 'MarginReqmtInqQualifierCodeSet',
    description: 'Summary',
  },
  {
    name: 'Detail',
    id: '1637002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1637,
    type: 'int',
    codeSet: 'MarginReqmtInqQualifierCodeSet',
    description: 'Detail',
  },
  {
    name: 'ExcessDeficit',
    id: '1637003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1637,
    type: 'int',
    codeSet: 'MarginReqmtInqQualifierCodeSet',
    description: 'Excess/Deficit',
  },
  {
    name: 'NetPosition',
    id: '1637004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1637,
    type: 'int',
    codeSet: 'MarginReqmtInqQualifierCodeSet',
    description: 'Net Position',
  },
  {
    name: 'Summary',
    id: '1638001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1638,
    type: 'int',
    codeSet: 'MarginReqmtRptTypeCodeSet',
    description: 'Summary',
  },
  {
    name: 'Detail',
    id: '1638002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1638,
    type: 'int',
    codeSet: 'MarginReqmtRptTypeCodeSet',
    description: 'Detail',
  },
  {
    name: 'ExcessDeficit',
    id: '1638003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1638,
    type: 'int',
    codeSet: 'MarginReqmtRptTypeCodeSet',
    description: 'Excess/Deficit',
  },
  {
    name: 'Successful',
    id: '1641001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1641,
    type: 'int',
    codeSet: 'MarginReqmtInqResultCodeSet',
    description: 'Successful (default)',
  },
  {
    name: 'InvalidOrUnknownInstrument',
    id: '1641002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1641,
    type: 'int',
    codeSet: 'MarginReqmtInqResultCodeSet',
    description: 'Invalid or unknown instrument',
  },
  {
    name: 'InvalidOrUnknownMarginClass',
    id: '1641003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1641,
    type: 'int',
    codeSet: 'MarginReqmtInqResultCodeSet',
    description: 'Invalid or unknown margin class',
  },
  {
    name: 'InvalidParties',
    id: '1641004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1641,
    type: 'int',
    codeSet: 'MarginReqmtInqResultCodeSet',
    description: 'Invalid Parties',
  },
  {
    name: 'InvalidTransportTypeReq',
    id: '1641005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1641,
    type: 'int',
    codeSet: 'MarginReqmtInqResultCodeSet',
    description: 'Invalid Transport Type requested',
  },
  {
    name: 'InvalidDestinationReq',
    id: '1641006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1641,
    type: 'int',
    codeSet: 'MarginReqmtInqResultCodeSet',
    description: 'Invalid Destination requested',
  },
  {
    name: 'NoMarginReqFound',
    id: '1641007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1641,
    type: 'int',
    codeSet: 'MarginReqmtInqResultCodeSet',
    description: 'No margin requirement found',
  },
  {
    name: 'MarginReqInquiryQualifierNotSupported',
    id: '1641008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1641,
    type: 'int',
    codeSet: 'MarginReqmtInqResultCodeSet',
    description: 'Margin requirement inquiry qualifier not supported',
  },
  {
    name: 'UnauthorizedForMarginReqInquiry',
    id: '1641009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1641,
    type: 'int',
    codeSet: 'MarginReqmtInqResultCodeSet',
    description: 'Unauthorized for margin requirement inquiry',
  },
  {
    name: 'Other',
    id: '1641010',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1641,
    type: 'int',
    codeSet: 'MarginReqmtInqResultCodeSet',
    description: 'Other (further information in Text (58) field)',
  },
  {
    name: 'AdditionalMargin',
    id: '1644001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Additional Margin\n\nComponent of the total margin calculation which allows the CCP to include amounts generated outside of the Margin Deficit. Additional risk charges collected when a firm is placed on higher than normal surveillance.\n\nAdditional margin serves to cover the additional liquidation costs that potentially could be incurred. Such possible close-out costs could arise if, based on the current market value of a portfolio, the worst case loss were to occur within a 24-hour period. It is used for options (also options on futures) and non-spread futures positions, bonds and equity trades. For bonds and equity trades, the additional margin is calculated for security positions but not for the corresponding cash positions.',
  },
  {
    name: 'AdjustedMargin',
    id: '1644002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Adjusted Margin\n\nUnadjusted Margin can be modified to become an Adjusted Margin by assigning a specific collateral to it or by applying an exchange rate.',
  },
  {
    name: 'UnadjustedMargin',
    id: '1644003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Unadjusted Margin\n\nCalculated by adding up the options Premium Margin, the current Liquidating Margin, the Futures Spread Margin and the Additional Margin on account and currency level.',
  },
  {
    name: 'BinaryAddOnAmount',
    id: '1644004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Binary Add-On Amount\n\nRequirement generated from positions in Binary Options which are considered fully margined. Margin for an individual contract in this category represents the total amount that would be paid upon delivery of a contract should it expire in-the-money. This amount is included as a component of Additional Margin in the Total Margin calculation.',
  },
  {
    name: 'CashBalanceAmount',
    id: '1644005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Cash Balance Amount\n\nInformation about cash balance posted to the clearing house to cover the current margin requirement.',
  },
  {
    name: 'ConcentrationMargin',
    id: '1644006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Concentration Margin\n\nReflects a riskier portfolio concentration when a set of closely related products is held.',
  },
  {
    name: 'CoreMargin',
    id: '1644007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Core Margin\n\nSpecific basic requirement of a position. Core margin is equal to Initial Margin plus a percentage of the Variation Margin.',
  },
  {
    name: 'DeliveryMargin',
    id: '1644008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Delivery Margin\n\nMargin amount calculated between the Last Trade Date or Options Exercise Date and the Delivery or Settlement Date. Can also represent a commodities or energy delivery.',
  },
  {
    name: 'DiscretionaryMargin',
    id: '1644009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Discretionary Margin\n\nUnspecific margin amount added by the risk manager, also called Increase Coverage Amount.',
  },
  {
    name: 'FuturesSpreadMargin',
    id: '1644010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Futures Spread Margin\n\nLong and short positions of futures with different expiration dates can be offset against each other and are called “spreads”. The remaining risk stems from the difference in expiration dates which does not provide a perfect price correlation. The purpose of Futures Spread Margin is to cover this risk until the next trading day.\n\nThis kind of margin is levied in order to cover those risks associated with a futures spread which could arise between today and tomorrow.',
  },
  {
    name: 'InitialMargin',
    id: '1644011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description: 'Initial Margin\n\nThe initial amount required to cover the position.',
  },
  {
    name: 'LiquidatingMargin',
    id: '1644012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Liquidating Margin\n\nCalculated for cash, bond and equity positions and is equal to the profits and losses in such positions at the time of calculation. This margin protects the CCP if it is required to close out the position at the current/EOD price.\n\nThe liquidating margin (also called Current Liquidating Margin or Net Liquidating Margin) is paid by the buyer or the seller of the bonds. This margin covers losses that would occur if a position were to be liquidated today. The liquidating margin is adjusted daily similar to premium margin.',
  },
  {
    name: 'MarginCallAmount',
    id: '1644013',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Margin Call Amount\n\nIf the collateral that has been deposited is no longer sufficient, meaning a lack of coverage exists, then the market participant will be called upon to provide additional cash as collateral.',
  },
  {
    name: 'MarginDeficitAmount',
    id: '1644014',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Margin Deficit Amount (Shortfall)\n\nBase margin risk charge. This amount represents anticipated losses should the value of a portfolio (all positions in the account) fall below predefined level of Historical Value-at-Risk confidence. Also called Expected Shortfall Amount.',
  },
  {
    name: 'MarginExcessAmount',
    id: '1644015',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      "Margin Excess Amount (Surplus)\n\nExcess long premium value which is generated when long premium value exceeds the sum of any short premium debit requirement and the account's risk charges. Also called Expected Surplus Amount or Margin Credit Amount.",
  },
  {
    name: 'OptionPremiumAmount',
    id: '1644016',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Option Premium Amount\n\nPremium registered on the given trading date.\n\nThe amount of money that the options buyer must pay the options seller.',
  },
  {
    name: 'PremiumMargin',
    id: '1644017',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Premium Margin\n\nPremium margin must be deposited by the seller of a traditional options position. It remains effective until the exercise or expiration of the option, and covers the potential costs of a close-out (liquidation) of the position of the seller at the settlement price.',
  },
  {
    name: 'ReserveMargin',
    id: '1644018',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Reserve Margin\n\nReserve margin provides a way to reflect the inflated risk of a position. Reserve margin is equal to a percentage of the variation margin.',
  },
  {
    name: 'SecurityCollateralAmount',
    id: '1644019',
    value: '19',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Security Collateral Amount\n\nInformation about the security collateral posted to the clearing house to cover the current margin requirement.',
  },
  {
    name: 'StressTestAddOnAmount',
    id: '1644020',
    value: '20',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Stress Test Add-On Amount\n\nAmount in addition to Margin Deficit in the Risk component of the margin calculation. This charge is based on tests which incorporate changes to distributional and confidence level assumptions to evaluate exposure to security concentration and changes in dependence structure; a predetermined percentage of the calculated exposure is collateralized as this charge.',
  },
  {
    name: 'SuperMargin',
    id: '1644021',
    value: '21',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      "Super Margin\n\nAdditional risk charge applied to predetermined Cross-Margin accounts. The charge is based on the account's level of Margin Deficit. This amount is included as a component of Additional Margin in the Total Margin calculation.",
  },
  {
    name: 'TotalMargin',
    id: '1644022',
    value: '22',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description: 'Total Margin\n\nSum of all margin amounts at value date.',
  },
  {
    name: 'VariationMargin',
    id: '1644023',
    value: '23',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      "Variation Margin\n\nVariation margin (also called Contingent Variation Margin or Maintenance Margin) is the daily Profit and Loss (P&L) on Open Positions for the given trading date. The current price is compared to the previous day's price.\n\nVariation margin (a daily offsetting of profits and losses) occurs as a result of the mark-to-market procedure used for futures and options on futures.",
  },
  {
    name: 'SecondaryVariationMargin',
    id: '1644024',
    value: '24',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '102',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Secondary Variation Margin\n\nVariation margin on Option Positions that is calculated based on the market movement. This will be used by CCPs wanting to report the variation for Options and Futures separately.',
  },
  {
    name: 'RolledUpMarginDeficit',
    id: '1644025',
    value: '25',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '117',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description: 'Rolled up margin deficit',
  },
  {
    name: 'SpreadResponseMargin',
    id: '1644026',
    value: '26',
    sort: 26,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Spread response margin\n\nRisk factor component associated with spread moves, curve shape changes and recovery rates.',
  },
  {
    name: 'SystemicRiskMargin',
    id: '1644027',
    value: '27',
    sort: 27,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Systemic risk margin\n\nRisk factor component to capture parallel shift of credit spreads.',
  },
  {
    name: 'CurveRiskMargin',
    id: '1644028',
    value: '28',
    sort: 28,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Curve risk margin\n\nRisk factor captures curve shifts based on portfolio.',
  },
  {
    name: 'IndexSpreadRiskMargin',
    id: '1644029',
    value: '29',
    sort: 29,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Index spread risk margin\n\nRisk factor component associated with risks due to widening/tightening spreads of CDS indices relative to each other.',
  },
  {
    name: 'SectorRiskMargin',
    id: '1644030',
    value: '30',
    sort: 30,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description: 'Sector risk margin\n\nRisk factor component to capture sector risk.',
  },
  {
    name: 'JumpToDefaultRiskMargin',
    id: '1644031',
    value: '31',
    sort: 31,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Jump-to-default risk margin\n\nRisk factor component to capture extreme widening of credit spreads of a reference entity. Also known as Idiosyncratic Risk.',
  },
  {
    name: 'BasisRiskMargin',
    id: '1644032',
    value: '32',
    sort: 32,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Basis risk margin\n\nRisk factor component to capture basis risk between index and index constituent reference entities.',
  },
  {
    name: 'InterestRateRiskMargin',
    id: '1644033',
    value: '33',
    sort: 33,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Interest rate risk margin\n\nRisk factor component associated with parallel shift movements in interest rates.',
  },
  {
    name: 'JumpToHealthRiskMargin',
    id: '1644034',
    value: '34',
    sort: 34,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Jump-to-health risk margin\n\nRisk factor component to capture extreme narrowing of credit spreads of a reference entity. Also known as Idiosyncratic Risk.',
  },
  {
    name: 'OtherRiskMargin',
    id: '1644035',
    value: '35',
    sort: 35,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 1644,
    type: 'int',
    codeSet: 'MarginAmtTypeCodeSet',
    description:
      'Other risk margin\n\nAny other risk factors include in the Margin Model.',
  },
  {
    name: 'HedgesForInstrument',
    id: '1648001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '103',
    tag: 1648,
    type: 'int',
    codeSet: 'RelatedInstrumentTypeCodeSet',
    description: '"hedges for" instrument',
  },
  {
    name: 'Underlier',
    id: '1648002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 1648,
    type: 'int',
    codeSet: 'RelatedInstrumentTypeCodeSet',
    description: 'Underlier',
  },
  {
    name: 'EquityEquivalent',
    id: '1648003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 1648,
    type: 'int',
    codeSet: 'RelatedInstrumentTypeCodeSet',
    description: 'Equity equivalent',
  },
  {
    name: 'NearestExchangeTradedContract',
    id: '1648004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 1648,
    type: 'int',
    codeSet: 'RelatedInstrumentTypeCodeSet',
    description: 'Nearest exchange traded contract',
  },
  {
    name: 'RetailEquivalent',
    id: '1648005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 1648,
    type: 'int',
    codeSet: 'RelatedInstrumentTypeCodeSet',
    description: 'Retail equivalent of wholesale instrument\n\n',
  },
  {
    name: 'Leg',
    id: '1648006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '201',
    tag: 1648,
    type: 'int',
    codeSet: 'RelatedInstrumentTypeCodeSet',
    description:
      'Leg\n\nUsed to associate or link InstrumentLeg to Instrument in messages where there can be multiple instruments, such as in Email(35=C) and News(35=B) messages.',
  },
  {
    name: 'NoParticipation',
    id: '1655001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '104',
    tag: 1655,
    type: 'int',
    codeSet: 'MarketMakerActivityCodeSet',
    description: 'No participation',
  },
  {
    name: 'BuyParticipation',
    id: '1655002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '104',
    tag: 1655,
    type: 'int',
    codeSet: 'MarketMakerActivityCodeSet',
    description: 'Buy participation',
  },
  {
    name: 'SellParticipation',
    id: '1655003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '104',
    tag: 1655,
    type: 'int',
    codeSet: 'MarketMakerActivityCodeSet',
    description: 'Sell participation',
  },
  {
    name: 'BothBuyAndSellParticipation',
    id: '1655004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '104',
    tag: 1655,
    type: 'int',
    codeSet: 'MarketMakerActivityCodeSet',
    description: 'Both buy and sell participation',
  },
  {
    name: 'ValidRequest',
    id: '1511001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1511,
    type: 'int',
    codeSet: 'RequestResultCodeSet',
    description: 'Valid request',
  },
  {
    name: 'InvalidOrUnsupportedRequest',
    id: '1511002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1511,
    type: 'int',
    codeSet: 'RequestResultCodeSet',
    description: 'Invalid or unsupported request',
  },
  {
    name: 'NoDataFound',
    id: '1511003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1511,
    type: 'int',
    codeSet: 'RequestResultCodeSet',
    description: 'No data found that match selection criteria',
  },
  {
    name: 'NotAuthorized',
    id: '1511004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1511,
    type: 'int',
    codeSet: 'RequestResultCodeSet',
    description: 'Not authorized to retrieve data',
  },
  {
    name: 'DataTemporarilyUnavailable',
    id: '1511005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1511,
    type: 'int',
    codeSet: 'RequestResultCodeSet',
    description: 'Data temporarily unavailable',
  },
  {
    name: 'RequestForDataNotSupported',
    id: '1511006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1511,
    type: 'int',
    codeSet: 'RequestResultCodeSet',
    description: 'Request for data not supported',
  },
  {
    name: 'Other',
    id: '1511007',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1511,
    type: 'int',
    codeSet: 'RequestResultCodeSet',
    description: 'Other (further information in RejectText (1328) field)',
  },
  {
    name: 'IsAlso',
    id: '1515001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Is also',
  },
  {
    name: 'ClearsFor',
    id: '1515002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Clears for',
  },
  {
    name: 'ClearsThrough',
    id: '1515003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Clears through',
  },
  {
    name: 'TradesFor',
    id: '1515004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Trades for',
  },
  {
    name: 'TradesThrough',
    id: '1515005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Trades through',
  },
  {
    name: 'Sponsors',
    id: '1515006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Sponsors',
  },
  {
    name: 'SponsoredThrough',
    id: '1515007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Sponsored through',
  },
  {
    name: 'ProvidesGuaranteeFor',
    id: '1515008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Provides guarantee for',
  },
  {
    name: 'IsGuaranteedBy',
    id: '1515009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Is guaranteed by',
  },
  {
    name: 'MemberOf',
    id: '1515010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Member of',
  },
  {
    name: 'HasMembers',
    id: '1515011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Has members',
  },
  {
    name: 'ProvidesMarketplaceFor',
    id: '1515012',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Provides marketplace for',
  },
  {
    name: 'ParticipantOfMarketplace',
    id: '1515013',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Participant of marketplace',
  },
  {
    name: 'CarriesPositionsFor',
    id: '1515014',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Carries positions for',
  },
  {
    name: 'PostsTradesTo',
    id: '1515015',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Posts trades to',
  },
  {
    name: 'EntersTradesFor',
    id: '1515016',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Enters trades for',
  },
  {
    name: 'EntersTradesThrough',
    id: '1515017',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Enters trades through',
  },
  {
    name: 'ProvidesQuotesTo',
    id: '1515018',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Provides quotes to',
  },
  {
    name: 'RequestsQuotesFrom',
    id: '1515019',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Requests quotes from',
  },
  {
    name: 'InvestsFor',
    id: '1515020',
    value: '19',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Invests for',
  },
  {
    name: 'InvestsThrough',
    id: '1515021',
    value: '20',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Invests through',
  },
  {
    name: 'BrokersTradesFor',
    id: '1515022',
    value: '21',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Brokers trades for',
  },
  {
    name: 'BrokersTradesThrough',
    id: '1515023',
    value: '22',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Brokers trades through',
  },
  {
    name: 'ProvidesTradingServicesFor',
    id: '1515024',
    value: '23',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Provides trading services for',
  },
  {
    name: 'UsesTradingServicesOf',
    id: '1515025',
    value: '24',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Uses trading services of',
  },
  {
    name: 'ApprovesOf',
    id: '1515026',
    value: '25',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Approves of',
  },
  {
    name: 'ApprovedBy',
    id: '1515027',
    value: '26',
    sort: 26,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Approved by',
  },
  {
    name: 'ParentFirmFor',
    id: '1515028',
    value: '27',
    sort: 27,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Parent firm for',
  },
  {
    name: 'SubsidiaryOf',
    id: '1515029',
    value: '28',
    sort: 28,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Subsidiary of',
  },
  {
    name: 'RegulatoryOwnerOf',
    id: '1515030',
    value: '29',
    sort: 29,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Regulatory owner of',
  },
  {
    name: 'OwnedByRegulatory',
    id: '1515031',
    value: '30',
    sort: 30,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Owned by (regulatory)',
  },
  {
    name: 'Controls',
    id: '1515032',
    value: '31',
    sort: 31,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Controls',
  },
  {
    name: 'IsControlledBy',
    id: '1515033',
    value: '32',
    sort: 32,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Is controlled by',
  },
  {
    name: 'LegalOwnerOf',
    id: '1515034',
    value: '33',
    sort: 33,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Legal / titled owner of',
  },
  {
    name: 'OwnedByLegal',
    id: '1515035',
    value: '34',
    sort: 34,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Owned by (legal / title)',
  },
  {
    name: 'BeneficialOwnerOf',
    id: '1515036',
    value: '35',
    sort: 35,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Beneficial owner of',
  },
  {
    name: 'OwnedByBeneficial',
    id: '1515037',
    value: '36',
    sort: 36,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Owned by (beneficial)',
  },
  {
    name: 'SettlesFor',
    id: '1515038',
    value: '37',
    sort: 37,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Settles for',
  },
  {
    name: 'SettlesThrough',
    id: '1515039',
    value: '38',
    sort: 38,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1515,
    type: 'int',
    codeSet: 'PartyRelationshipCodeSet',
    description: 'Settles through',
  },
  {
    name: 'CreditLimit',
    id: '1530001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 1530,
    type: 'int',
    codeSet: 'RiskLimitTypeCodeSet',
    description:
      'Credit limit\n\nThe credit limit provided by one party to another for trading.',
  },
  {
    name: 'GrossLimit',
    id: '1530002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    updated: 'FIX.5.0SP2',
    updatedEP: '128',
    tag: 1530,
    type: 'int',
    codeSet: 'RiskLimitTypeCodeSet',
    description: 'Gross limit',
  },
  {
    name: 'NetLimit',
    id: '1530003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    updated: 'FIX.5.0SP2',
    updatedEP: '128',
    tag: 1530,
    type: 'int',
    codeSet: 'RiskLimitTypeCodeSet',
    description: 'Net limit',
  },
  {
    name: 'Exposure',
    id: '1530004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1530,
    type: 'int',
    codeSet: 'RiskLimitTypeCodeSet',
    description: 'Exposure',
  },
  {
    name: 'LongLimit',
    id: '1530005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    updated: 'FIX.5.0SP2',
    updatedEP: '128',
    tag: 1530,
    type: 'int',
    codeSet: 'RiskLimitTypeCodeSet',
    description: 'Long limit',
  },
  {
    name: 'ShortLimit',
    id: '1530006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    updated: 'FIX.5.0SP2',
    updatedEP: '128',
    tag: 1530,
    type: 'int',
    codeSet: 'RiskLimitTypeCodeSet',
    description: 'Short limit',
  },
  {
    name: 'CashMargin',
    id: '1530007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1530,
    type: 'int',
    codeSet: 'RiskLimitTypeCodeSet',
    description: 'Cash margin',
  },
  {
    name: 'AdditionalMargin',
    id: '1530008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1530,
    type: 'int',
    codeSet: 'RiskLimitTypeCodeSet',
    description: 'Additional margin',
  },
  {
    name: 'TotalMargin',
    id: '1530009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1530,
    type: 'int',
    codeSet: 'RiskLimitTypeCodeSet',
    description: 'Total margin',
  },
  {
    name: 'LimitConsumed',
    id: '1530010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 1530,
    type: 'int',
    codeSet: 'RiskLimitTypeCodeSet',
    description: 'Limit consumed\n\nThe limit used in the recent transaction.',
  },
  {
    name: 'ClipSize',
    id: '1530011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    updated: 'FIX.5.0SP2',
    updatedEP: '214',
    tag: 1530,
    type: 'int',
    codeSet: 'RiskLimitTypeCodeSet',
    description:
      'Clip size/notional limit per time period\n\nThe total notional amount limit allowed to be executed within a defined period of time or velocity. The defined period of time may be specified by the RiskLimitVelocityPeriod(2336) and RiskLimitVelocityUnit(2337).',
  },
  {
    name: 'MaxNotionalOrderSize',
    id: '1530012',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 1530,
    type: 'int',
    codeSet: 'RiskLimitTypeCodeSet',
    description: 'Maximum notional order size',
  },
  {
    name: 'DV01PV01Limit',
    id: '1530013',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 1530,
    type: 'int',
    codeSet: 'RiskLimitTypeCodeSet',
    description:
      'DV01/PV01 limit\n\nThe maximum dollar value change resulting from a move of 1 basis point in the yield curve. This limits the interest rate risk exposure. Also known as "basis point value" or BPV.',
  },
  {
    name: 'CS01Limit',
    id: '1530014',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 1530,
    type: 'int',
    codeSet: 'RiskLimitTypeCodeSet',
    description:
      'CS01 limit\n\nCredit spread sensitivity. Represents the change in market value of a CDS for a one basis point change in the credit spread. This limits the credit risk exposure of a CDS. Also known as "risky-DV01".',
  },
  {
    name: 'VolumeLimitPerTimePeriod',
    id: '1530015',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '214',
    tag: 1530,
    type: 'int',
    codeSet: 'RiskLimitTypeCodeSet',
    description:
      'Volume limit per time period\n\nThe total number of shares, bonds or contracts allowed to be executed within a defined period of time or velocity. The defined period of time may be specified by the RiskLimitVelocityPeriod(2336) and RiskLimitVelocityUnit(2337).',
  },
  {
    name: 'VolFilledPctOrdVolTmPeriod',
    id: '1530016',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '214',
    tag: 1530,
    type: 'int',
    codeSet: 'RiskLimitTypeCodeSet',
    description:
      'Volume filled as percent of ordered volume per time period\n\nThe total number of shares, bonds or contracts executed as a percentage of the total ordered shares, contracts or notional amount for a specified security, instrument, symbol, or underlying, over a defined period of time or velocity. The defined period of time may be specified by the RiskLimitVelocityPeriod(2336) and RiskLimitVelocityUnit(2337).',
  },
  {
    name: 'NotlFilledPctNotlTmPeriod',
    id: '1530017',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '214',
    tag: 1530,
    type: 'int',
    codeSet: 'RiskLimitTypeCodeSet',
    description:
      'Notional filled as percent of notional per time period\n\nThe total notional amount executed as a percentage of the total ordered shares, contracts or notional amount for a specified security, instrument, symbol, or underlying, over a defined period of time or velocity. The defined period of time may be specified by the RiskLimitVelocityPeriod(2336) and RiskLimitVelocityUnit(2337).',
  },
  {
    name: 'TransactionExecutionLimitPerTimePeriod',
    id: '1530018',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '214',
    tag: 1530,
    type: 'int',
    codeSet: 'RiskLimitTypeCodeSet',
    description:
      'Transaction/execution limit per time period\n\nThe total number of transactions or execution fills allowed within a defined period of time or velocity. The defined period of time may be specified by the RiskLimitVelocityPeriod(2336) and RiskLimitVelocityUnit(2337).',
  },
  {
    name: 'Include',
    id: '1535001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1535,
    type: 'int',
    codeSet: 'InstrumentScopeOperatorCodeSet',
    description: 'Include',
  },
  {
    name: 'Exclude',
    id: '1535002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1535,
    type: 'int',
    codeSet: 'InstrumentScopeOperatorCodeSet',
    description: 'Exclude',
  },
  {
    name: 'Active',
    id: '1672001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1672,
    type: 'int',
    codeSet: 'PartyDetailStatusCodeSet',
    description: 'Active (default if not specified)',
  },
  {
    name: 'Suspended',
    id: '1672002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '105',
    tag: 1672,
    type: 'int',
    codeSet: 'PartyDetailStatusCodeSet',
    description: 'Suspended',
  },
  {
    name: 'Halted',
    id: '1672003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 1672,
    type: 'int',
    codeSet: 'PartyDetailStatusCodeSet',
    description: 'Halted',
  },
  {
    name: 'FirmOrLegalEntity',
    id: '1674001',
    value: '23',
    sort: 23,
    group: 'For all firm / broker type party roles',
    added: 'FIX.5.0SP2',
    addedEP: '222',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description: 'Firm or legal entity',
  },
  {
    name: 'Current',
    id: '1674002',
    value: '18',
    sort: 18,
    group: 'For all party roles',
    added: 'FIX.5.0SP2',
    addedEP: '213',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description:
      'Current\n\nCan be used to convey an existing party identifier for the same party role in a single message.',
  },
  {
    name: 'New',
    id: '1674003',
    value: '19',
    sort: 19,
    group: 'For all party roles',
    added: 'FIX.5.0SP2',
    addedEP: '213',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description:
      'New\n\nCan be used to convey a future party identifier for the same party role in a single message.',
  },
  {
    name: 'NaturalPerson',
    id: '1674004',
    value: '24',
    sort: 24,
    group: 'For all trader / customer type party roles',
    added: 'FIX.5.0SP2',
    addedEP: '222',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description: 'Natural person',
  },
  {
    name: 'Agency',
    id: '1674005',
    value: '0',
    sort: 0,
    group: 'For party role 1 (Executing Firm)',
    added: 'FIX.5.0SP2',
    addedEP: '105',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description: 'Agency',
  },
  {
    name: 'Principal',
    id: '1674006',
    value: '1',
    sort: 1,
    group: 'For party role 1 (Executing Firm)',
    added: 'FIX.5.0SP2',
    addedEP: '105',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description: 'Principal',
  },
  {
    name: 'RisklessPrincipal',
    id: '1674007',
    value: '2',
    sort: 2,
    group: 'For party role 1 (Executing Firm)',
    added: 'FIX.5.0SP2',
    addedEP: '105',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description: 'Riskless principal',
  },
  {
    name: 'ExchangeOrderSubmitter',
    id: '1674008',
    value: '30',
    sort: 3,
    group: 'For party role 1 (Executing Firm)',
    added: 'FIX.Latest',
    addedEP: '279',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description:
      'Exchange order submitter\n\nUsed to identify original or initial exchange order submitting broker when party role "1" (Executing Firm) appears more than once.',
  },
  {
    name: 'PrimaryTrdRepository',
    id: '1674009',
    value: '9',
    sort: 9,
    group: 'For party role 102 (Data repository)',
    added: 'FIX.5.0SP2',
    addedEP: '193',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description:
      'Primary trade repository\n\nUsed to differentiate the principal trade repository from the Original or Additional trade repositories when there are multiple trade repositories being reported.',
  },
  {
    name: 'OrigTrdRepository',
    id: '1674010',
    value: '10',
    sort: 10,
    group: 'For party role 102 (Data repository)',
    added: 'FIX.5.0SP2',
    addedEP: '193',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description:
      'Original trade repository\n\nUsed to identify the trade repository to which the trade was originally reported if different from the current repository to which the trade is being reported.',
  },
  {
    name: 'AddtnlIntlTrdRepository',
    id: '1674011',
    value: '11',
    sort: 11,
    group: 'For party role 102 (Data repository)',
    added: 'FIX.5.0SP2',
    addedEP: '193',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description:
      'Additional international trade repository\n\nUsed with InternationalSwapIndicator(2526) to identify the trade repository that is in addition to the local swaps data repository as required by U.S. law.',
  },
  {
    name: 'AddtnlDomesticTrdRepository',
    id: '1674012',
    value: '12',
    sort: 12,
    group: 'For party role 102 (Data repository)',
    added: 'FIX.5.0SP2',
    addedEP: '193',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description:
      'Additional domestic trade repository\n\nUsed with MixedSwapIndicator(1929) to identify the trade repository that is in addition to the current trade repository when the assets in the swap are subject to two different domestic regulators.',
  },
  {
    name: 'RegularTrader',
    id: '1674013',
    value: '25',
    sort: 25,
    group:
      'For party role 11 (Order Origination Trader), 12 (Executing Trader), 36 (Entering Trader), 37 (Contra Trader)',
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description: 'Regular trader\n\nStandard trader profile.',
  },
  {
    name: 'HeadTrader',
    id: '1674014',
    value: '26',
    sort: 26,
    group:
      'For party role 11 (Order Origination Trader), 12 (Executing Trader), 36 (Entering Trader), 37 (Contra Trader)',
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description: 'Head trader\n\nSenior trader leading a group of regular traders.',
  },
  {
    name: 'Supervisor',
    id: '1674015',
    value: '27',
    sort: 27,
    group:
      'For party role 11 (Order Origination Trader), 12 (Executing Trader), 36 (Entering Trader), 37 (Contra Trader)',
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description:
      'Supervisor\n\nAdministrative user that has only limited rights for normal trading but possibly special rights for emergency actions.',
  },
  {
    name: 'Algorithm',
    id: '1674016',
    value: '22',
    sort: 22,
    group: 'For party role 12 (Executing trader) or 122 (Investment decision maker)',
    added: 'FIX.5.0SP2',
    addedEP: '222',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description: 'Algorithm',
  },
  {
    name: 'RelatedExchange',
    id: '1674017',
    value: '13',
    sort: 13,
    group: 'For party role 22 (Exchange)',
    added: 'FIX.5.0SP2',
    addedEP: '208',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description: 'Related exchange',
  },
  {
    name: 'OptionsExchange',
    id: '1674018',
    value: '14',
    sort: 14,
    group: 'For party role 22 (Exchange)',
    added: 'FIX.5.0SP2',
    addedEP: '208',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description: 'Options exchange',
  },
  {
    name: 'SpecifiedExchange',
    id: '1674019',
    value: '15',
    sort: 15,
    group: 'For party role 22 (Exchange)',
    added: 'FIX.5.0SP2',
    addedEP: '208',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description: 'Specified exchange',
  },
  {
    name: 'ConstituentExchange',
    id: '1674020',
    value: '16',
    sort: 16,
    group: 'For party role 22 (Exchange)',
    added: 'FIX.5.0SP2',
    addedEP: '208',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description: 'Constituent exchange\n\n',
  },
  {
    name: 'Bank',
    id: '1674021',
    value: '7',
    sort: 7,
    group: 'For party role 29 (Intermediary), 32 (Beneficiary) and 107 (Correspondent)',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description: 'Bank',
  },
  {
    name: 'Hub',
    id: '1674022',
    value: '8',
    sort: 8,
    group: 'For party role 29 (Intermediary), 32 (Beneficiary) and 107 (Correspondent)',
    added: 'FIX.5.0SP2',
    addedEP: '171',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description:
      'Hub\n\nIndicates that the Intermediary party is a hub system or service provider.',
  },
  {
    name: 'TriParty',
    id: '1674023',
    value: '28',
    sort: 28,
    group: 'For party role 30 (Agent)',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description:
      'Tri-party\n\nIn the context of EU SFTR reporting, identifies the third party, not necessarily the custodian, to which the reporting counterparty has outsourced the post-trade processing of an SFT (if applicable).',
  },
  {
    name: 'Lender',
    id: '1674024',
    value: '29',
    sort: 29,
    group: 'For party role 30 (Agent)',
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description:
      'Lender\n\nIn the context of EU SFTR reporting, identifies the agent lender involved in the securities lending transaction.',
  },
  {
    name: 'GeneralClearingMember',
    id: '1674025',
    value: '3',
    sort: 3,
    group: 'For party role 4 (Clearing Firm)',
    added: 'FIX.5.0SP2',
    addedEP: '105',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description: 'General clearing member',
  },
  {
    name: 'IndividualClearingMember',
    id: '1674026',
    value: '4',
    sort: 4,
    group: 'For party role 4 (Clearing Firm)',
    added: 'FIX.5.0SP2',
    addedEP: '105',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description: 'Individual clearing member',
  },
  {
    name: 'PreferredMarketMaker',
    id: '1674027',
    value: '5',
    sort: 5,
    group: 'For party role 66 (Market Maker)',
    added: 'FIX.5.0SP2',
    addedEP: '131',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description:
      'Preferred market maker\n\nMarket maker getting a part of the matched quantity before primary or default market maker.',
  },
  {
    name: 'DirectedMarketMaker',
    id: '1674028',
    value: '6',
    sort: 6,
    group: 'For party role 66 (Market Maker)',
    added: 'FIX.5.0SP2',
    addedEP: '131',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description:
      'Directed market maker\n\nSingle market maker to handle the order provided.',
  },
  {
    name: 'DesignatedSponsor',
    id: '1674029',
    value: '20',
    sort: 20,
    group: 'For party role 66 (Market Maker)',
    added: 'FIX.5.0SP2',
    addedEP: '219',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description:
      'Designated sponsor\n\nMarket maker jointly providing liquidity for the same security with other market makers.',
  },
  {
    name: 'Specialist',
    id: '1674030',
    value: '21',
    sort: 21,
    group: 'For party role 66 (Market Maker)',
    added: 'FIX.5.0SP2',
    addedEP: '219',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description:
      'Specialist\n\nMarket maker being the only one providing liquidity for a security.',
  },
  {
    name: 'ExemptFromTradeReporting',
    id: '1674031',
    value: '17',
    sort: 17,
    group: 'For party role 73 (Execution Venue)',
    added: 'FIX.5.0SP2',
    addedEP: '209',
    updated: 'FIX.5.0SP2',
    updatedEP: '223',
    tag: 1674,
    type: 'int',
    codeSet: 'PartyDetailRoleQualifierCodeSet',
    description:
      'Exempt from trade reporting\n\nIn the context of FINRA TRACE reporting requirements, this is used to indicate the ATS has been granted a regulatory exemption from reporting.',
  },
  {
    name: 'Accepted',
    id: '1523001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 1523,
    type: 'int',
    codeSet: 'TrdAckStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Rejected',
    id: '1523002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 1523,
    type: 'int',
    codeSet: 'TrdAckStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'Received',
    id: '1523003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 1523,
    type: 'int',
    codeSet: 'TrdAckStatusCodeSet',
    description: 'Received',
  },
  {
    name: 'Fee',
    id: '1583001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 1583,
    type: 'int',
    codeSet: 'SecurityClassificationReasonCodeSet',
    description: 'Fee',
  },
  {
    name: 'CreditControls',
    id: '1583002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 1583,
    type: 'int',
    codeSet: 'SecurityClassificationReasonCodeSet',
    description: 'Credit Controls',
  },
  {
    name: 'Margin',
    id: '1583003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 1583,
    type: 'int',
    codeSet: 'SecurityClassificationReasonCodeSet',
    description: 'Margin',
  },
  {
    name: 'EntitlementOrEligibility',
    id: '1583004',
    value: '3',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 1583,
    type: 'int',
    codeSet: 'SecurityClassificationReasonCodeSet',
    description: 'Entitlement / Eligibility',
  },
  {
    name: 'MarketData',
    id: '1583005',
    value: '4',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 1583,
    type: 'int',
    codeSet: 'SecurityClassificationReasonCodeSet',
    description: 'Market Data',
  },
  {
    name: 'AccountSelection',
    id: '1583006',
    value: '5',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 1583,
    type: 'int',
    codeSet: 'SecurityClassificationReasonCodeSet',
    description: 'Account Selection',
  },
  {
    name: 'DeliveryProcess',
    id: '1583007',
    value: '6',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 1583,
    type: 'int',
    codeSet: 'SecurityClassificationReasonCodeSet',
    description: 'Delivery Process',
  },
  {
    name: 'Sector',
    id: '1583008',
    value: '7',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 1583,
    type: 'int',
    codeSet: 'SecurityClassificationReasonCodeSet',
    description: 'Sector',
  },
  {
    name: 'OptionsSettlement',
    id: '1585001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 1585,
    type: 'int',
    codeSet: 'PosAmtReasonCodeSet',
    description: 'Options settlement',
  },
  {
    name: 'PendingErosionAdjustment',
    id: '1585002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 1585,
    type: 'int',
    codeSet: 'PosAmtReasonCodeSet',
    description: 'Pending erosion adjustment',
  },
  {
    name: 'FinalErosionAdjustment',
    id: '1585003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 1585,
    type: 'int',
    codeSet: 'PosAmtReasonCodeSet',
    description: 'Final erosion adjustment',
  },
  {
    name: 'TearUpCouponAmount',
    id: '1585004',
    value: '3',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 1585,
    type: 'int',
    codeSet: 'PosAmtReasonCodeSet',
    description: 'Tear-up coupon amount',
  },
  {
    name: 'PriceAlignmentInterest',
    id: '1585005',
    value: '4',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    updated: 'FIX.5.0SP2',
    updatedEP: '141',
    tag: 1585,
    type: 'int',
    codeSet: 'PosAmtReasonCodeSet',
    description:
      'Price alignment interest\n\nTo minimize the impact of daily cash variation margin payments on the pricing of interest rate swaps, the Clearing House will charge interest on cumulative variation margin received and pay interest on cumulative variation margin paid in respect of these instruments. This interest element is known as price alignment interest.',
  },
  {
    name: 'DeliveryInvoiceCharges',
    id: '1585006',
    value: '5',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 1585,
    type: 'int',
    codeSet: 'PosAmtReasonCodeSet',
    description: 'Delivery invoice charges',
  },
  {
    name: 'DeliveryStorageCharges',
    id: '1585007',
    value: '6',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '107',
    tag: 1585,
    type: 'int',
    codeSet: 'PosAmtReasonCodeSet',
    description: 'Delivery storage charges',
  },
  {
    name: 'TradeClearingAtExecutionPrice',
    id: '1598001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '111',
    tag: 1598,
    type: 'int',
    codeSet: 'SideClearingTradePriceTypeCodeSet',
    description: 'Trade Clearing at Execution Price',
  },
  {
    name: 'TradeClearingAtAlternateClearingPrice',
    id: '1598002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '111',
    tag: 1598,
    type: 'int',
    codeSet: 'SideClearingTradePriceTypeCodeSet',
    description: 'Trade Clearing at Alternate Clearing Price',
  },
  {
    name: 'InvalidInstrumentRequested',
    id: '1607001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '114',
    tag: 1607,
    type: 'int',
    codeSet: 'SecurityRejectReasonCodeSet',
    description: 'Invalid instrument requested',
  },
  {
    name: 'InstrumentAlreadyExists',
    id: '1607002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '114',
    tag: 1607,
    type: 'int',
    codeSet: 'SecurityRejectReasonCodeSet',
    description: 'Instrument already exists',
  },
  {
    name: 'RequestTypeNotSupported',
    id: '1607003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '114',
    tag: 1607,
    type: 'int',
    codeSet: 'SecurityRejectReasonCodeSet',
    description: 'Request type not supported',
  },
  {
    name: 'SystemUnavailableForInstrumentCreation',
    id: '1607004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '114',
    tag: 1607,
    type: 'int',
    codeSet: 'SecurityRejectReasonCodeSet',
    description: 'System unavailable for instrument creation',
  },
  {
    name: 'IneligibleInstrumentGroup',
    id: '1607005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '114',
    tag: 1607,
    type: 'int',
    codeSet: 'SecurityRejectReasonCodeSet',
    description: 'Ineligible instrument group',
  },
  {
    name: 'InstrumentIDUnavailable',
    id: '1607006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '114',
    tag: 1607,
    type: 'int',
    codeSet: 'SecurityRejectReasonCodeSet',
    description: 'Instrument ID unavailable',
  },
  {
    name: 'InvalidOrMissingDataOnOptionLeg',
    id: '1607007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '114',
    tag: 1607,
    type: 'int',
    codeSet: 'SecurityRejectReasonCodeSet',
    description: 'Invalid or missing data on option leg',
  },
  {
    name: 'InvalidOrMissingDataOnFutureLeg',
    id: '1607008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '114',
    tag: 1607,
    type: 'int',
    codeSet: 'SecurityRejectReasonCodeSet',
    description: 'Invalid or missing data on future leg',
  },
  {
    name: 'InvalidOrMissingDataOnFXLeg',
    id: '1607009',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '114',
    tag: 1607,
    type: 'int',
    codeSet: 'SecurityRejectReasonCodeSet',
    description: 'Invalid or missing data on FX leg',
  },
  {
    name: 'InvalidLegPriceSpecified',
    id: '1607010',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '114',
    tag: 1607,
    type: 'int',
    codeSet: 'SecurityRejectReasonCodeSet',
    description: 'Invalid leg price specified',
  },
  {
    name: 'InvalidInstrumentStructureSpecified',
    id: '1607011',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '114',
    tag: 1607,
    type: 'int',
    codeSet: 'SecurityRejectReasonCodeSet',
    description: 'Invalid instrument structure specified',
  },
  {
    name: 'ThrottleLimitNotExceededNotQueued',
    id: '1609001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '116',
    tag: 1609,
    type: 'int',
    codeSet: 'ThrottleStatusCodeSet',
    description: 'Throttle limit not exceeded, not queued',
  },
  {
    name: 'QueuedDueToThrottleLimitExceeded',
    id: '1609002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '116',
    tag: 1609,
    type: 'int',
    codeSet: 'ThrottleStatusCodeSet',
    description: 'Queued due to throttle limit exceeded',
  },
  {
    name: 'QueueInbound',
    id: '1611001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '116',
    updated: 'FIX.5.0SP2',
    updatedEP: '128',
    tag: 1611,
    type: 'int',
    codeSet: 'ThrottleActionCodeSet',
    description: 'Queue inbound',
  },
  {
    name: 'QueueOutbound',
    id: '1611002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '116',
    updated: 'FIX.5.0SP2',
    updatedEP: '128',
    tag: 1611,
    type: 'int',
    codeSet: 'ThrottleActionCodeSet',
    description: 'Queue outbound',
  },
  {
    name: 'Reject',
    id: '1611003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '116',
    tag: 1611,
    type: 'int',
    codeSet: 'ThrottleActionCodeSet',
    description: 'Reject',
  },
  {
    name: 'Disconnect',
    id: '1611004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '116',
    tag: 1611,
    type: 'int',
    codeSet: 'ThrottleActionCodeSet',
    description: 'Disconnect',
  },
  {
    name: 'Warning',
    id: '1611005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '116',
    tag: 1611,
    type: 'int',
    codeSet: 'ThrottleActionCodeSet',
    description: 'Warning',
  },
  {
    name: 'InboundRate',
    id: '1612001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '116',
    tag: 1612,
    type: 'int',
    codeSet: 'ThrottleTypeCodeSet',
    description: 'Inbound Rate',
  },
  {
    name: 'OutstandingRequests',
    id: '1612002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '116',
    tag: 1612,
    type: 'int',
    codeSet: 'ThrottleTypeCodeSet',
    description: 'Outstanding Requests',
  },
  {
    name: 'RejectIfThrottleLimitExceeded',
    id: '1685001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '116',
    tag: 1685,
    type: 'int',
    codeSet: 'ThrottleInstCodeSet',
    description: 'Reject if throttle limit exceeded',
  },
  {
    name: 'QueueIfThrottleLimitExceeded',
    id: '1685002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '116',
    tag: 1685,
    type: 'int',
    codeSet: 'ThrottleInstCodeSet',
    description: 'Queue if throttle limit exceeded',
  },
  {
    name: 'OutstandingRequestsUnchanged',
    id: '1686001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '116',
    tag: 1686,
    type: 'int',
    codeSet: 'ThrottleCountIndicatorCodeSet',
    description: 'Outstanding requests unchanged',
  },
  {
    name: 'OutstandingRequestsDecreased',
    id: '1686002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '116',
    tag: 1686,
    type: 'int',
    codeSet: 'ThrottleCountIndicatorCodeSet',
    description: 'Outstanding requests decreased',
  },
  {
    name: 'Rollup',
    id: '1735001',
    value: '0',
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 1735,
    type: 'int',
    codeSet: 'AllocationRollupInstructionCodeSet',
    description: 'Roll up',
  },
  {
    name: 'DoNotRollUp',
    id: '1735002',
    value: '1',
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 1735,
    type: 'int',
    codeSet: 'AllocationRollupInstructionCodeSet',
    description: 'Do not roll up',
  },
  {
    name: 'Completed',
    id: '1738001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 1738,
    type: 'int',
    codeSet: 'AllocReversalStatusCodeSet',
    description: 'Completed',
  },
  {
    name: 'Refused',
    id: '1738002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 1738,
    type: 'int',
    codeSet: 'AllocReversalStatusCodeSet',
    description: 'Refused',
  },
  {
    name: 'Cancelled',
    id: '1738003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '118',
    tag: 1738,
    type: 'int',
    codeSet: 'AllocReversalStatusCodeSet',
    description: 'Cancelled',
  },
  {
    name: 'Bond',
    id: '1739001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '119',
    tag: 1739,
    type: 'String',
    codeSet: 'ObligationTypeCodeSet',
    description: 'Bond',
  },
  {
    name: 'ConvertBond',
    id: '1739002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '119',
    tag: 1739,
    type: 'String',
    codeSet: 'ObligationTypeCodeSet',
    description: 'Convertible bond',
  },
  {
    name: 'Mortgage',
    id: '1739003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '119',
    tag: 1739,
    type: 'String',
    codeSet: 'ObligationTypeCodeSet',
    description: 'Mortgage',
  },
  {
    name: 'Loan',
    id: '1739004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '119',
    tag: 1739,
    type: 'String',
    codeSet: 'ObligationTypeCodeSet',
    description: 'Loan',
  },
  {
    name: 'PercentPar',
    id: '1740001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '119',
    tag: 1740,
    type: 'int',
    codeSet: 'TradePriceNegotiationMethodCodeSet',
    description: 'Percent of par',
  },
  {
    name: 'DealSpread',
    id: '1740002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '119',
    tag: 1740,
    type: 'int',
    codeSet: 'TradePriceNegotiationMethodCodeSet',
    description: 'Deal spread',
  },
  {
    name: 'UpfrontPnts',
    id: '1740003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '119',
    tag: 1740,
    type: 'int',
    codeSet: 'TradePriceNegotiationMethodCodeSet',
    description: 'Upfront points',
  },
  {
    name: 'UpfrontAmt',
    id: '1740004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '119',
    tag: 1740,
    type: 'int',
    codeSet: 'TradePriceNegotiationMethodCodeSet',
    description: 'Upfront amount',
  },
  {
    name: 'ParUpfrontAmt',
    id: '1740005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '119',
    tag: 1740,
    type: 'int',
    codeSet: 'TradePriceNegotiationMethodCodeSet',
    description: 'Percent of par and upfront amount',
  },
  {
    name: 'SpreadUpfrontAmt',
    id: '1740006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '119',
    tag: 1740,
    type: 'int',
    codeSet: 'TradePriceNegotiationMethodCodeSet',
    description: 'Deal spread and upfront amount',
  },
  {
    name: 'UpfrontPntsAmt',
    id: '1740007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '119',
    tag: 1740,
    type: 'int',
    codeSet: 'TradePriceNegotiationMethodCodeSet',
    description: 'Upfront points and upfront amount',
  },
  {
    name: 'Percentage',
    id: '1741001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '119',
    tag: 1741,
    type: 'int',
    codeSet: 'UpfrontPriceTypeCodeSet',
    description:
      'Percentage (i.e. percent of par) (often called "dollar price" for fixed income)',
  },
  {
    name: 'FixedAmount',
    id: '1741002',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '119',
    tag: 1741,
    type: 'int',
    codeSet: 'UpfrontPriceTypeCodeSet',
    description: 'Fixed amount (absolute value)',
  },
  {
    name: 'NoRestrictions',
    id: '1687001',
    value: '0',
    added: 'FIX.5.0SP2',
    addedEP: '120',
    tag: 1687,
    type: 'int',
    codeSet: 'ShortSaleRestrictionCodeSet',
    description: 'No restrictions',
  },
  {
    name: 'SecurityNotShortable',
    id: '1687002',
    value: '1',
    added: 'FIX.5.0SP2',
    addedEP: '120',
    tag: 1687,
    type: 'int',
    codeSet: 'ShortSaleRestrictionCodeSet',
    description: 'Security is not shortable',
  },
  {
    name: 'SecurityNotShortableAtOrBelowBestBid',
    id: '1687003',
    value: '2',
    added: 'FIX.5.0SP2',
    addedEP: '120',
    tag: 1687,
    type: 'int',
    codeSet: 'ShortSaleRestrictionCodeSet',
    description: 'Security not shortable at or below the best bid',
  },
  {
    name: 'SecurityNotShortableWithoutPreBorrow',
    id: '1687004',
    value: '3',
    added: 'FIX.5.0SP2',
    addedEP: '164',
    tag: 1687,
    type: 'int',
    codeSet: 'ShortSaleRestrictionCodeSet',
    description: 'Security is not shortable without pre-borrow',
  },
  {
    name: 'ExemptionReasonUnknown',
    id: '1688001',
    value: '0',
    added: 'FIX.5.0SP2',
    addedEP: '121',
    tag: 1688,
    type: 'int',
    codeSet: 'ShortSaleExemptionReasonCodeSet',
    description:
      'Exemption reason unknown\n\nAn exemption reason not provided or received.',
  },
  {
    name: 'IncomingSSE',
    id: '1688002',
    value: '1',
    added: 'FIX.5.0SP2',
    addedEP: '121',
    tag: 1688,
    type: 'int',
    codeSet: 'ShortSaleExemptionReasonCodeSet',
    description:
      "Income sell short exempt\n\nAgency broker has the customer's exemption reason, which is not explicitly provided to executing broker.",
  },
  {
    name: 'AboveNationalBestBid',
    id: '1688003',
    value: '2',
    added: 'FIX.5.0SP2',
    addedEP: '121',
    tag: 1688,
    type: 'int',
    codeSet: 'ShortSaleExemptionReasonCodeSet',
    description:
      'Above national best bid (broker/dealer provision)\n\nBroker / dealer responsible for enforcing exemption rule has determined that the order is priced one or more ticks above the nation best bid of the security to be traded.',
  },
  {
    name: 'DelayedDelivery',
    id: '1688004',
    value: '3',
    added: 'FIX.5.0SP2',
    addedEP: '121',
    tag: 1688,
    type: 'int',
    codeSet: 'ShortSaleExemptionReasonCodeSet',
    description:
      'Delayed delivery\n\nThe broker-dealer has a reasonable basis to believe the seller owns the covered security (pursuant to Rule 200 in the U.S.), but is subject to restrictions on delivery, provided that the seller intends to deliver the security as soon as all restrictions on delivery have been removed.',
  },
  {
    name: 'OddLot',
    id: '1688005',
    value: '4',
    added: 'FIX.5.0SP2',
    addedEP: '121',
    tag: 1688,
    type: 'int',
    codeSet: 'ShortSaleExemptionReasonCodeSet',
    description:
      'Odd lot\n\nThe broker-dealer has a reasonable basis to believe the sale is by a market maker to offset customer odd-lot orders or to liquidate an odd-lot position that changes such broker’s or dealer’s position by no more than a unit of trading.',
  },
  {
    name: 'DomesticArbitrage',
    id: '1688006',
    value: '5',
    added: 'FIX.5.0SP2',
    addedEP: '121',
    tag: 1688,
    type: 'int',
    codeSet: 'ShortSaleExemptionReasonCodeSet',
    description:
      'Domestic arbitrage\n\nThe sale is connected to a bona-fide domestic arbitrage transaction.',
  },
  {
    name: 'InternationalArbitrage',
    id: '1688007',
    value: '6',
    added: 'FIX.5.0SP2',
    addedEP: '121',
    tag: 1688,
    type: 'int',
    codeSet: 'ShortSaleExemptionReasonCodeSet',
    description:
      'International arbitrage\n\nThe sale is connected to an international arbitrage transaction.',
  },
  {
    name: 'UnderwriterOrSyndicateDistribution',
    id: '1688008',
    value: '7',
    added: 'FIX.5.0SP2',
    addedEP: '121',
    tag: 1688,
    type: 'int',
    codeSet: 'ShortSaleExemptionReasonCodeSet',
    description:
      'Underwriter or syndicate distribution\n\nThe short sale is (i) by an underwriter or member of a syndicate or group participating in the distribution of a security in connection with an over-allotment of securities; or (ii) is for purposes of a lay-off sale by an underwriter or member of a syndicate or group in connection with a distribution of securities through a rights or standby underwriting commitment.',
  },
  {
    name: 'RisklessPrincipal',
    id: '1688009',
    value: '8',
    added: 'FIX.5.0SP2',
    addedEP: '121',
    tag: 1688,
    type: 'int',
    codeSet: 'ShortSaleExemptionReasonCodeSet',
    description:
      'Riskless principal\n\nThe short sale is by a broker or dealer effecting the execution of a customer purchase or the execution of a customer “long” sale on a riskless principal basis.',
  },
  {
    name: 'VWAP',
    id: '1688010',
    value: '9',
    added: 'FIX.5.0SP2',
    addedEP: '121',
    tag: 1688,
    type: 'int',
    codeSet: 'ShortSaleExemptionReasonCodeSet',
    description:
      'VWAP\n\nThe short sale order is for the sale of a covered security at the volume weighted average price (VWAP) meeting certain criteria.',
  },
  {
    name: 'NoApplRecoveryNeeded',
    id: '1744001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '124',
    tag: 1744,
    type: 'int',
    codeSet: 'ApplLevelRecoveryIndicatorCodeSet',
    description: 'Application level recovery is not needed (default)',
  },
  {
    name: 'ApplRecoveryNeeded',
    id: '1744002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '124',
    tag: 1744,
    type: 'int',
    codeSet: 'ApplLevelRecoveryIndicatorCodeSet',
    description: 'Application level recovery is needed',
  },
  {
    name: 'Definitions',
    id: '1760001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1760,
    type: 'int',
    codeSet: 'RiskLimitRequestTypeCodeSet',
    description: 'Definitions(Default)',
  },
  {
    name: 'Utilization',
    id: '1760002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1760,
    type: 'int',
    codeSet: 'RiskLimitRequestTypeCodeSet',
    description: 'Utilization',
  },
  {
    name: 'DefinitionsAndUtilizations',
    id: '1760003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1760,
    type: 'int',
    codeSet: 'RiskLimitRequestTypeCodeSet',
    description: 'Definitions and utilization',
  },
  {
    name: 'Successful',
    id: '1761001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1761,
    type: 'int',
    codeSet: 'RiskLimitRequestResultCodeSet',
    description: 'Successful (default)',
  },
  {
    name: 'InvalidParty',
    id: '1761002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1761,
    type: 'int',
    codeSet: 'RiskLimitRequestResultCodeSet',
    description: 'Invalid party(-ies)',
  },
  {
    name: 'InvalidRelatedParty',
    id: '1761003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1761,
    type: 'int',
    codeSet: 'RiskLimitRequestResultCodeSet',
    description: 'Invalid related party(-ies)',
  },
  {
    name: 'InvalidRiskLimitType',
    id: '1761004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1761,
    type: 'int',
    codeSet: 'RiskLimitRequestResultCodeSet',
    description: 'Invalid risk limit type(s)',
  },
  {
    name: 'InvalidRiskLimitID',
    id: '1761005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1761,
    type: 'int',
    codeSet: 'RiskLimitRequestResultCodeSet',
    description: 'Invalid risk limit ID(s)',
  },
  {
    name: 'InvalidRiskLimitAmount',
    id: '1761006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1761,
    type: 'int',
    codeSet: 'RiskLimitRequestResultCodeSet',
    description: 'Invalid risk limit amount(s)',
  },
  {
    name: 'InvalidRiskWarningLevelAction',
    id: '1761007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1761,
    type: 'int',
    codeSet: 'RiskLimitRequestResultCodeSet',
    description: 'Invalid risk/warning level action(s)',
  },
  {
    name: 'InvalidRiskInstrumentScope',
    id: '1761008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1761,
    type: 'int',
    codeSet: 'RiskLimitRequestResultCodeSet',
    description: 'Invalid risk instrument scope(s)',
  },
  {
    name: 'RiskLimitActionsNotSupported',
    id: '1761009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1761,
    type: 'int',
    codeSet: 'RiskLimitRequestResultCodeSet',
    description: 'Risk limit actions not supported',
  },
  {
    name: 'WarningLevelsNotSupported',
    id: '1761010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1761,
    type: 'int',
    codeSet: 'RiskLimitRequestResultCodeSet',
    description: 'Warning levels not supported',
  },
  {
    name: 'WarningLevelActionsNotSupported',
    id: '1761011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1761,
    type: 'int',
    codeSet: 'RiskLimitRequestResultCodeSet',
    description: 'Warning level actions not supported',
  },
  {
    name: 'RiskInstrumentScopeNotSupported',
    id: '1761012',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1761,
    type: 'int',
    codeSet: 'RiskLimitRequestResultCodeSet',
    description: 'Risk instrument scope not supported',
  },
  {
    name: 'RiskLimitNotApprovedForParty',
    id: '1761013',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1761,
    type: 'int',
    codeSet: 'RiskLimitRequestResultCodeSet',
    description: 'Risk limit not approved for party(-ies)',
  },
  {
    name: 'RiskLimitAlreadyDefinedForParty',
    id: '1761014',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1761,
    type: 'int',
    codeSet: 'RiskLimitRequestResultCodeSet',
    description: 'Risk limit already defined for party(-ies)',
  },
  {
    name: 'InstrumentNotApprovedForParty',
    id: '1761015',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1761,
    type: 'int',
    codeSet: 'RiskLimitRequestResultCodeSet',
    description: 'Instrument not approved for party(-ies)',
  },
  {
    name: 'NotAuthorized',
    id: '1761016',
    value: '98',
    sort: 98,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1761,
    type: 'int',
    codeSet: 'RiskLimitRequestResultCodeSet',
    description: 'Not authorized',
  },
  {
    name: 'Other',
    id: '1761017',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '128',
    tag: 1761,
    type: 'int',
    codeSet: 'RiskLimitRequestResultCodeSet',
    description: 'Other',
  },
  {
    name: 'QueueInbound',
    id: '1767001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 1767,
    type: 'int',
    codeSet: 'RiskLimitActionCodeSet',
    description: 'Queue inbound',
  },
  {
    name: 'QueueOutbound',
    id: '1767002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 1767,
    type: 'int',
    codeSet: 'RiskLimitActionCodeSet',
    description: 'Queue outbound',
  },
  {
    name: 'Reject',
    id: '1767003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 1767,
    type: 'int',
    codeSet: 'RiskLimitActionCodeSet',
    description: 'Reject',
  },
  {
    name: 'Disconnect',
    id: '1767004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 1767,
    type: 'int',
    codeSet: 'RiskLimitActionCodeSet',
    description: 'Disconnect',
  },
  {
    name: 'Warning',
    id: '1767005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 1767,
    type: 'int',
    codeSet: 'RiskLimitActionCodeSet',
    description: 'Warning',
  },
  {
    name: 'PingCreditCheckWithRevalidation',
    id: '1767006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 1767,
    type: 'int',
    codeSet: 'RiskLimitActionCodeSet',
    description:
      'Ping credit check model with revalidation\n\nEach subsequent order, quote request or quote submission by the Credit\n\nUser must obtain pre-approval. Any open orders, quote requests or quotes are to be cancelled.',
  },
  {
    name: 'PingCreditCheckNoRevalidation',
    id: '1767007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 1767,
    type: 'int',
    codeSet: 'RiskLimitActionCodeSet',
    description:
      'Ping credit check model without revalidation\n\nEach subsequent order, quote request or quote submission by the Credit\n\nUser must obtain pre-approval. Any open orders, quote requests or quotes will remain active.',
  },
  {
    name: 'PushCreditCheckWithRevalidation',
    id: '1767008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 1767,
    type: 'int',
    codeSet: 'RiskLimitActionCodeSet',
    description:
      'Push credit check model with revalidation\n\nEach subsequent order, quote request or quote subnmission by the Credit\n\nUser must be checked against the limit amounts pushed to the trading platform. Any open orders, quote requests or quotes are\n\nto be cancelled.',
  },
  {
    name: 'PushCreditCheckNoRevalidation',
    id: '1767009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 1767,
    type: 'int',
    codeSet: 'RiskLimitActionCodeSet',
    description:
      'Push credit check model without revalidation\n\nEach subsequent order, quote request or quote subnmission by the Credit\n\nUser must be checked against the limit amounts pushed to the trading platform. Any open orders, quote requests or quotes will\n\nremain active.',
  },
  {
    name: 'Suspend',
    id: '1767010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 1767,
    type: 'int',
    codeSet: 'RiskLimitActionCodeSet',
    description:
      'Suspend\n\nSuspend the Credit User from trading once limit(s) is breached. This is\n\nconsidered a "soft" stop.',
  },
  {
    name: 'HaltTrading',
    id: '1767011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 1767,
    type: 'int',
    codeSet: 'RiskLimitActionCodeSet',
    description:
      'Halt trading\n\nHalt or stop the Credit User from trading once limit(s) is breached.\n\nThis is considered a "hard" stop and may require more involved actions to reinstate the Credit User\'s ability\n\nto trade.',
  },
  {
    name: 'Trade',
    id: '1775001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '129',
    updated: 'FIX.5.0SP2',
    updatedEP: '173',
    tag: 1775,
    type: 'int',
    codeSet: 'EntitlementTypeCodeSet',
    description: 'Trade',
  },
  {
    name: 'MakeMarkets',
    id: '1775002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '129',
    updated: 'FIX.5.0SP2',
    updatedEP: '173',
    tag: 1775,
    type: 'int',
    codeSet: 'EntitlementTypeCodeSet',
    description: 'Make markets',
  },
  {
    name: 'HoldPositions',
    id: '1775003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '129',
    updated: 'FIX.5.0SP2',
    updatedEP: '173',
    tag: 1775,
    type: 'int',
    codeSet: 'EntitlementTypeCodeSet',
    description: 'Hold positions',
  },
  {
    name: 'PerformGiveUps',
    id: '1775004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '129',
    updated: 'FIX.5.0SP2',
    updatedEP: '173',
    tag: 1775,
    type: 'int',
    codeSet: 'EntitlementTypeCodeSet',
    description: 'Perform give-ups',
  },
  {
    name: 'SubmitIOIs',
    id: '1775005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '129',
    updated: 'FIX.5.0SP2',
    updatedEP: '173',
    tag: 1775,
    type: 'int',
    codeSet: 'EntitlementTypeCodeSet',
    description: 'Submit Indications of Interest (IOIs)',
  },
  {
    name: 'SubscribeMarketData',
    id: '1775006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '129',
    updated: 'FIX.5.0SP2',
    updatedEP: '173',
    tag: 1775,
    type: 'int',
    codeSet: 'EntitlementTypeCodeSet',
    description: 'Subscribe to market data',
  },
  {
    name: 'ShortWithPreBorrow',
    id: '1775007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '164',
    updated: 'FIX.5.0SP2',
    updatedEP: '173',
    tag: 1775,
    type: 'int',
    codeSet: 'EntitlementTypeCodeSet',
    description:
      'Short with pre-borrow\n\nShort sell order is allowed with pre-borrowing.',
  },
  {
    name: 'SubmitQuoteRequests',
    id: '1775008',
    value: '7',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '173',
    tag: 1775,
    type: 'int',
    codeSet: 'EntitlementTypeCodeSet',
    description:
      'Submit quote requests\n\nEntitled to submit quote requests into the market in order to receive quotes from the market.',
  },
  {
    name: 'RespondToQuoteRequests',
    id: '1775009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '173',
    tag: 1775,
    type: 'int',
    codeSet: 'EntitlementTypeCodeSet',
    description:
      'Respond to quote requests\n\nEntitled to respond to quote requests from the market.',
  },
  {
    name: 'Tenor',
    id: '1779001',
    value: '29',
    sort: 29,
    group: 'Pattern',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'Tenor',
  },
  {
    name: 'Pattern',
    id: '1779002',
    value: '32',
    sort: 32,
    group: 'Pattern',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'Pattern',
  },
  {
    name: 'Reserved100Plus',
    id: '1779003',
    value: '33',
    sort: 33,
    group: 'Pattern',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'Reserved100Plus',
  },
  {
    name: 'Reserved1000Plus',
    id: '1779004',
    value: '34',
    sort: 34,
    group: 'Pattern',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'Reserved1000Plus',
  },
  {
    name: 'Reserved4000Plus',
    id: '1779005',
    value: '35',
    sort: 35,
    group: 'Pattern',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'Reserved4000Plus',
  },
  {
    name: 'String',
    id: '1779006',
    value: '14',
    sort: 14,
    group: 'String',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'String',
  },
  {
    name: 'MultipleCharValue',
    id: '1779007',
    value: '15',
    sort: 15,
    group: 'String',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'MultipleCharValue',
  },
  {
    name: 'Currency',
    id: '1779008',
    value: '16',
    sort: 16,
    group: 'String',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'Currency',
  },
  {
    name: 'Exchange',
    id: '1779009',
    value: '17',
    sort: 17,
    group: 'String',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'Exchange',
  },
  {
    name: 'MonthYear',
    id: '1779010',
    value: '18',
    sort: 18,
    group: 'String',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'MonthYear',
  },
  {
    name: 'UTCTimestamp',
    id: '1779011',
    value: '19',
    sort: 19,
    group: 'String',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'UTCTimestamp',
  },
  {
    name: 'UTCTimeOnly',
    id: '1779012',
    value: '20',
    sort: 20,
    group: 'String',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'UTCTimeOnly',
  },
  {
    name: 'LocalMktDate',
    id: '1779013',
    value: '21',
    sort: 21,
    group: 'String',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'LocalMktDate',
  },
  {
    name: 'UTCDateOnly',
    id: '1779014',
    value: '22',
    sort: 22,
    group: 'String',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'UTCDateOnly',
  },
  {
    name: 'Data',
    id: '1779015',
    value: '23',
    sort: 23,
    group: 'String',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    updated: 'FIX.Latest',
    updatedEP: '264',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'data',
  },
  {
    name: 'MultipleStringValue',
    id: '1779016',
    value: '24',
    sort: 24,
    group: 'String',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'MultipleStringValue',
  },
  {
    name: 'Country',
    id: '1779017',
    value: '25',
    sort: 25,
    group: 'String',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'Country',
  },
  {
    name: 'Language',
    id: '1779018',
    value: '26',
    sort: 26,
    group: 'String',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'Language',
  },
  {
    name: 'TZTimeOnly',
    id: '1779019',
    value: '27',
    sort: 27,
    group: 'String',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'TZTimeOnly',
  },
  {
    name: 'TZTimestamp',
    id: '1779020',
    value: '28',
    sort: 28,
    group: 'String',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'TZTimestamp',
  },
  {
    name: 'XMLData',
    id: '1779021',
    value: '31',
    sort: 31,
    group: 'String',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'XMLData',
  },
  {
    name: 'Char',
    id: '1779022',
    value: '12',
    sort: 12,
    group: 'char',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    updated: 'FIX.Latest',
    updatedEP: '264',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'char',
  },
  {
    name: 'Boolean',
    id: '1779023',
    value: '13',
    sort: 13,
    group: 'char',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'Boolean',
  },
  {
    name: 'Float',
    id: '1779024',
    value: '6',
    sort: 6,
    group: 'float',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    updated: 'FIX.Latest',
    updatedEP: '264',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'float',
  },
  {
    name: 'Qty',
    id: '1779025',
    value: '7',
    sort: 7,
    group: 'float',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'Qty',
  },
  {
    name: 'Price',
    id: '1779026',
    value: '8',
    sort: 8,
    group: 'float',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'Price',
  },
  {
    name: 'PriceOffset',
    id: '1779027',
    value: '9',
    sort: 9,
    group: 'float',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'PriceOffset',
  },
  {
    name: 'Amt',
    id: '1779028',
    value: '10',
    sort: 10,
    group: 'float',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'Amt',
  },
  {
    name: 'Percentage',
    id: '1779029',
    value: '11',
    sort: 11,
    group: 'float',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'Percentage',
  },
  {
    name: 'Int',
    id: '1779030',
    value: '1',
    sort: 1,
    group: 'int',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    updated: 'FIX.Latest',
    updatedEP: '264',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'int',
  },
  {
    name: 'Length',
    id: '1779031',
    value: '2',
    sort: 2,
    group: 'int',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'Length',
  },
  {
    name: 'NumInGroup',
    id: '1779032',
    value: '3',
    sort: 3,
    group: 'int',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'NumInGroup',
  },
  {
    name: 'SeqNum',
    id: '1779033',
    value: '4',
    sort: 4,
    group: 'int',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'SeqNum',
  },
  {
    name: 'TagNum',
    id: '1779034',
    value: '5',
    sort: 5,
    group: 'int',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'TagNum',
  },
  {
    name: 'DayOfMonth',
    id: '1779035',
    value: '30',
    sort: 30,
    group: 'int',
    added: 'FIX.5.0SP2',
    addedEP: '129',
    tag: 1779,
    type: 'int',
    codeSet: 'EntitlementAttribDatatypeCodeSet',
    description: 'DayOfMonth',
  },
  {
    name: 'Automatic',
    id: '1785001',
    value: '0',
    added: 'FIX.5.0SP2',
    addedEP: '130',
    tag: 1785,
    type: 'int',
    codeSet: 'TradSesControlCodeSet',
    description: 'Automatic (Default)',
  },
  {
    name: 'Manual',
    id: '1785002',
    value: '1',
    added: 'FIX.5.0SP2',
    addedEP: '130',
    tag: 1785,
    type: 'int',
    codeSet: 'TradSesControlCodeSet',
    description: 'Manual',
  },
  {
    name: 'NumberOfUnits',
    id: '1786001',
    value: '0',
    added: 'FIX.5.0SP2',
    addedEP: '130',
    tag: 1786,
    type: 'int',
    codeSet: 'TradeVolTypeCodeSet',
    description: 'Number of units (e.g. share, par, currency, contracts) (default)',
  },
  {
    name: 'NumberOfRoundLots',
    id: '1786002',
    value: '1',
    added: 'FIX.5.0SP2',
    addedEP: '130',
    tag: 1786,
    type: 'int',
    codeSet: 'TradeVolTypeCodeSet',
    description: 'Number of round lots',
  },
  {
    name: 'Added',
    id: '1796001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1796,
    type: 'int',
    codeSet: 'OrderEventTypeCodeSet',
    description: 'Added (0=New)',
  },
  {
    name: 'Modified',
    id: '1796002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1796,
    type: 'int',
    codeSet: 'OrderEventTypeCodeSet',
    description: 'Modified (5=Replaced)',
  },
  {
    name: 'Deleted',
    id: '1796003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1796,
    type: 'int',
    codeSet: 'OrderEventTypeCodeSet',
    description: 'Deleted (4=Canceled)',
  },
  {
    name: 'PartiallyFilled',
    id: '1796004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1796,
    type: 'int',
    codeSet: 'OrderEventTypeCodeSet',
    description: 'Partially Filled (F=Trade)',
  },
  {
    name: 'Filled',
    id: '1796005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1796,
    type: 'int',
    codeSet: 'OrderEventTypeCodeSet',
    description: 'Filled (F=Trade)',
  },
  {
    name: 'Suspended',
    id: '1796006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1796,
    type: 'int',
    codeSet: 'OrderEventTypeCodeSet',
    description: 'Suspended (9=Suspended)',
  },
  {
    name: 'Released',
    id: '1796007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1796,
    type: 'int',
    codeSet: 'OrderEventTypeCodeSet',
    description: 'Released (N=Released)',
  },
  {
    name: 'Restated',
    id: '1796008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1796,
    type: 'int',
    codeSet: 'OrderEventTypeCodeSet',
    description: 'Restated (D=Restated)',
  },
  {
    name: 'Locked',
    id: '1796009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1796,
    type: 'int',
    codeSet: 'OrderEventTypeCodeSet',
    description: 'Locked (M=Locked)',
  },
  {
    name: 'Triggered',
    id: '1796010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    updated: 'FIX.5.0SP2',
    updatedEP: '188',
    tag: 1796,
    type: 'int',
    codeSet: 'OrderEventTypeCodeSet',
    description: 'Triggered (L=Triggered or Activated by System)',
  },
  {
    name: 'Activated',
    id: '1796011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 1796,
    type: 'int',
    codeSet: 'OrderEventTypeCodeSet',
    description: 'Activated (L=Triggered or Activated by System)',
  },
  {
    name: 'AddOrderRequest',
    id: '1798001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1798,
    type: 'int',
    codeSet: 'OrderEventReasonCodeSet',
    description: 'Add order request',
  },
  {
    name: 'ModifyOrderRequest',
    id: '1798002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1798,
    type: 'int',
    codeSet: 'OrderEventReasonCodeSet',
    description: 'Modify order request',
  },
  {
    name: 'DeleteOrderRequest',
    id: '1798003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1798,
    type: 'int',
    codeSet: 'OrderEventReasonCodeSet',
    description: 'Delete order request',
  },
  {
    name: 'OrderEnteredOOB',
    id: '1798004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1798,
    type: 'int',
    codeSet: 'OrderEventReasonCodeSet',
    description: 'Order entered out-of-band',
  },
  {
    name: 'OrderModifiedOOB',
    id: '1798005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1798,
    type: 'int',
    codeSet: 'OrderEventReasonCodeSet',
    description: 'Order modified out-of-band',
  },
  {
    name: 'OrderDeletedOOB',
    id: '1798006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1798,
    type: 'int',
    codeSet: 'OrderEventReasonCodeSet',
    description: 'Order deleted out-of-band',
  },
  {
    name: 'OrderActivatedOrTriggered',
    id: '1798007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1798,
    type: 'int',
    codeSet: 'OrderEventReasonCodeSet',
    description: 'Order activated or triggered',
  },
  {
    name: 'OrderExpired',
    id: '1798008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1798,
    type: 'int',
    codeSet: 'OrderEventReasonCodeSet',
    description: 'Order expired',
  },
  {
    name: 'ReserveOrderRefreshed',
    id: '1798009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1798,
    type: 'int',
    codeSet: 'OrderEventReasonCodeSet',
    description: 'Reserve order refreshed',
  },
  {
    name: 'AwayMarketBetter',
    id: '1798010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1798,
    type: 'int',
    codeSet: 'OrderEventReasonCodeSet',
    description: 'Away market better',
  },
  {
    name: 'CorporateAction',
    id: '1798011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1798,
    type: 'int',
    codeSet: 'OrderEventReasonCodeSet',
    description: 'Corporate action',
  },
  {
    name: 'StartOfDay',
    id: '1798012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1798,
    type: 'int',
    codeSet: 'OrderEventReasonCodeSet',
    description: 'Start of day',
  },
  {
    name: 'EndOfDay',
    id: '1798013',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1798,
    type: 'int',
    codeSet: 'OrderEventReasonCodeSet',
    description: 'End of day',
  },
  {
    name: 'None',
    id: '1803001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 1803,
    type: 'int',
    codeSet: 'AuctionTypeCodeSet',
    description: 'None',
  },
  {
    name: 'BlockOrderAuction',
    id: '1803002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1803,
    type: 'int',
    codeSet: 'AuctionTypeCodeSet',
    description: 'Block order auction',
  },
  {
    name: 'DirectedOrderAuction',
    id: '1803003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1803,
    type: 'int',
    codeSet: 'AuctionTypeCodeSet',
    description: 'Directed order auction',
  },
  {
    name: 'ExposureOrderAuction',
    id: '1803004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1803,
    type: 'int',
    codeSet: 'AuctionTypeCodeSet',
    description: 'Exposure order auction',
  },
  {
    name: 'FlashOrderAuction',
    id: '1803005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1803,
    type: 'int',
    codeSet: 'AuctionTypeCodeSet',
    description: 'Flash order auction',
  },
  {
    name: 'FacilitationOrderAuction',
    id: '1803006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1803,
    type: 'int',
    codeSet: 'AuctionTypeCodeSet',
    description: 'Facilitation order auction',
  },
  {
    name: 'SolicitationOrderAuction',
    id: '1803007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1803,
    type: 'int',
    codeSet: 'AuctionTypeCodeSet',
    description: 'Solicitation order auction',
  },
  {
    name: 'PriceImprovementMechanism',
    id: '1803008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1803,
    type: 'int',
    codeSet: 'AuctionTypeCodeSet',
    description: 'Price improvement mechanism (PIM)',
  },
  {
    name: 'DirectedOrderPriceImprovementMechanism',
    id: '1803009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1803,
    type: 'int',
    codeSet: 'AuctionTypeCodeSet',
    description: 'Directed Order price improvement mechanism (PIM)',
  },
  {
    name: 'AutomatedAuctionPermitted',
    id: '1805001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    updated: 'FIX.5.0SP2',
    updatedEP: '208',
    tag: 1805,
    type: 'int',
    codeSet: 'AuctionInstructionCodeSet',
    description: 'Automatic auction permitted (default)',
  },
  {
    name: 'AutomatedAuctionNotPermitted',
    id: '1805002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1805,
    type: 'int',
    codeSet: 'AuctionInstructionCodeSet',
    description: 'Automatic auction not permitted',
  },
  {
    name: 'NotLocked',
    id: '1807001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1807,
    type: 'int',
    codeSet: 'LockTypeCodeSet',
    description: 'Not locked',
  },
  {
    name: 'AwayMarketNetter',
    id: '1807002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1807,
    type: 'int',
    codeSet: 'LockTypeCodeSet',
    description: 'Away market better',
  },
  {
    name: 'ThreeTickLocked',
    id: '1807003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1807,
    type: 'int',
    codeSet: 'LockTypeCodeSet',
    description: 'Three tick locked',
  },
  {
    name: 'LockedByMarketMaker',
    id: '1807004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1807,
    type: 'int',
    codeSet: 'LockTypeCodeSet',
    description: 'Locked by market maker',
  },
  {
    name: 'DirectedOrderLock',
    id: '1807005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1807,
    type: 'int',
    codeSet: 'LockTypeCodeSet',
    description: 'Directed order lock',
  },
  {
    name: 'MultilegLock',
    id: '1807006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1807,
    type: 'int',
    codeSet: 'LockTypeCodeSet',
    description:
      'Multileg lock\n\nLock in the context of multileg orders where legs are executed independently and the entire order is locked until matching information is available for all legs. A multileg order or quote must be matched in its entirety or not at all. For example, one of the legs may be a stock leg sent to a different execution venue that may or may not be able to fill it.',
  },
  {
    name: 'MarketOrderLock',
    id: '1807007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1807,
    type: 'int',
    codeSet: 'LockTypeCodeSet',
    description: 'Market order lock',
  },
  {
    name: 'PreAssignmentLock',
    id: '1807008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1807,
    type: 'int',
    codeSet: 'LockTypeCodeSet',
    description: 'Pre-assignment lock',
  },
  {
    name: 'ISO',
    id: '1810001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1810,
    type: 'int',
    codeSet: 'ReleaseInstructionCodeSet',
    description: 'Intermarket Sweep Order (ISO)',
  },
  {
    name: 'NoAwayMarketBetterCheck',
    id: '1810002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1810,
    type: 'int',
    codeSet: 'ReleaseInstructionCodeSet',
    description: 'No Away Market Better check',
  },
  {
    name: 'Volume',
    id: '1813001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1813,
    type: 'int',
    codeSet: 'DisclosureTypeCodeSet',
    description: 'Volume',
  },
  {
    name: 'Price',
    id: '1813002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1813,
    type: 'int',
    codeSet: 'DisclosureTypeCodeSet',
    description: 'Price',
  },
  {
    name: 'Side',
    id: '1813003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1813,
    type: 'int',
    codeSet: 'DisclosureTypeCodeSet',
    description: 'Side',
  },
  {
    name: 'AON',
    id: '1813004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1813,
    type: 'int',
    codeSet: 'DisclosureTypeCodeSet',
    description: 'AON',
  },
  {
    name: 'General',
    id: '1813005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1813,
    type: 'int',
    codeSet: 'DisclosureTypeCodeSet',
    description:
      'General\n\nGeneral is used for bilateral agreed disclosure information type(s).',
  },
  {
    name: 'ClearingAccount',
    id: '1813006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1813,
    type: 'int',
    codeSet: 'DisclosureTypeCodeSet',
    description: 'Clearing account',
  },
  {
    name: 'CMTAAccount',
    id: '1813007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1813,
    type: 'int',
    codeSet: 'DisclosureTypeCodeSet',
    description: 'CMTA account',
  },
  {
    name: 'No',
    id: '1814001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1814,
    type: 'int',
    codeSet: 'DisclosureInstructionCodeSet',
    description: 'No',
  },
  {
    name: 'Yes',
    id: '1814002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1814,
    type: 'int',
    codeSet: 'DisclosureInstructionCodeSet',
    description: 'Yes',
  },
  {
    name: 'UseDefaultSetting',
    id: '1814003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1814,
    type: 'int',
    codeSet: 'DisclosureInstructionCodeSet',
    description: 'Use default setting',
  },
  {
    name: 'Customer',
    id: '1815001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1815,
    type: 'int',
    codeSet: 'TradingCapacityCodeSet',
    description: 'Customer',
  },
  {
    name: 'CustomerProfessional',
    id: '1815002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1815,
    type: 'int',
    codeSet: 'TradingCapacityCodeSet',
    description: 'Customer professional',
  },
  {
    name: 'BrokerDealer',
    id: '1815003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1815,
    type: 'int',
    codeSet: 'TradingCapacityCodeSet',
    description: 'Broker-dealer',
  },
  {
    name: 'CustomerBrokerDealer',
    id: '1815004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1815,
    type: 'int',
    codeSet: 'TradingCapacityCodeSet',
    description: 'Customer broker-dealer',
  },
  {
    name: 'Principal',
    id: '1815005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1815,
    type: 'int',
    codeSet: 'TradingCapacityCodeSet',
    description: 'Principal',
  },
  {
    name: 'MarketMaker',
    id: '1815006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1815,
    type: 'int',
    codeSet: 'TradingCapacityCodeSet',
    description: 'Market maker',
  },
  {
    name: 'AwayMarketMaker',
    id: '1815007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1815,
    type: 'int',
    codeSet: 'TradingCapacityCodeSet',
    description: 'Away market maker',
  },
  {
    name: 'SystematicInternaliser',
    id: '1815008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 1815,
    type: 'int',
    codeSet: 'TradingCapacityCodeSet',
    description: 'Systematic internaliser',
  },
  {
    name: 'Customer',
    id: '1816001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1816,
    type: 'int',
    codeSet: 'ClearingAccountTypeCodeSet',
    description: 'Customer',
  },
  {
    name: 'Firm',
    id: '1816002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1816,
    type: 'int',
    codeSet: 'ClearingAccountTypeCodeSet',
    description: 'Firm',
  },
  {
    name: 'MarketMaker',
    id: '1816003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1816,
    type: 'int',
    codeSet: 'ClearingAccountTypeCodeSet',
    description: 'Market maker',
  },
  {
    name: 'NBBid',
    id: '1821001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1821,
    type: 'int',
    codeSet: 'RelatedPriceSourceCodeSet',
    description: 'NBB (National Best Bid)',
  },
  {
    name: 'NBOffer',
    id: '1821002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1821,
    type: 'int',
    codeSet: 'RelatedPriceSourceCodeSet',
    description: 'NBO (National Best Offer)',
  },
  {
    name: 'Once',
    id: '1822001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1822,
    type: 'int',
    codeSet: 'MinQtyMethodCodeSet',
    description: 'Once (applies only to first execution)',
  },
  {
    name: 'Multiple',
    id: '1822002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1822,
    type: 'int',
    codeSet: 'MinQtyMethodCodeSet',
    description: 'Multiple (applies to every execution)',
  },
  {
    name: 'NotTriggered',
    id: '1823001',
    value: '0',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1823,
    type: 'int',
    codeSet: 'TriggeredCodeSet',
    description: 'Not triggered (default)',
  },
  {
    name: 'Triggered',
    id: '1823002',
    value: '1',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '131',
    tag: 1823,
    type: 'int',
    codeSet: 'TriggeredCodeSet',
    description: 'Triggered',
  },
  {
    name: 'StopOrderTriggered',
    id: '1823003',
    value: '2',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 1823,
    type: 'int',
    codeSet: 'TriggeredCodeSet',
    description: 'Stop order triggered',
  },
  {
    name: 'OCOOrderTriggered',
    id: '1823004',
    value: '3',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 1823,
    type: 'int',
    codeSet: 'TriggeredCodeSet',
    description: 'One Cancels the Other (OCO) order triggered',
  },
  {
    name: 'OTOOrderTriggered',
    id: '1823005',
    value: '4',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 1823,
    type: 'int',
    codeSet: 'TriggeredCodeSet',
    description: 'One Triggers the Other (OTO) order triggered',
  },
  {
    name: 'OUOOrderTriggered',
    id: '1823006',
    value: '5',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 1823,
    type: 'int',
    codeSet: 'TriggeredCodeSet',
    description: 'One Updates the Other (OUO) order triggered',
  },
  {
    name: 'Hour',
    id: '1827001',
    value: 'H',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '132',
    tag: 1827,
    type: 'String',
    codeSet: 'EventTimeUnitCodeSet',
    description: 'Hour',
  },
  {
    name: 'Minute',
    id: '1827002',
    value: 'Min',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '132',
    tag: 1827,
    type: 'String',
    codeSet: 'EventTimeUnitCodeSet',
    description: 'Minute',
  },
  {
    name: 'Second',
    id: '1827003',
    value: 'S',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '132',
    tag: 1827,
    type: 'String',
    codeSet: 'EventTimeUnitCodeSet',
    description: 'Second',
  },
  {
    name: 'Day',
    id: '1827004',
    value: 'D',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '132',
    tag: 1827,
    type: 'String',
    codeSet: 'EventTimeUnitCodeSet',
    description: 'Day',
  },
  {
    name: 'Week',
    id: '1827005',
    value: 'Wk',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '132',
    tag: 1827,
    type: 'String',
    codeSet: 'EventTimeUnitCodeSet',
    description: 'Week',
  },
  {
    name: 'Month',
    id: '1827006',
    value: 'Mo',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '132',
    tag: 1827,
    type: 'String',
    codeSet: 'EventTimeUnitCodeSet',
    description: 'Month',
  },
  {
    name: 'Year',
    id: '1827007',
    value: 'Yr',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '132',
    tag: 1827,
    type: 'String',
    codeSet: 'EventTimeUnitCodeSet',
    description: 'Year',
  },
  {
    name: 'OrderReceivedFromCustomer',
    id: '1724001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1724,
    type: 'int',
    codeSet: 'OrderOriginationCodeSet',
    description: 'Order received from a customer',
  },
  {
    name: 'OrderReceivedFromWithinFirm',
    id: '1724002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1724,
    type: 'int',
    codeSet: 'OrderOriginationCodeSet',
    description: 'Order received from within the firm',
  },
  {
    name: 'OrderReceivedFromAnotherBrokerDealer',
    id: '1724003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '135',
    tag: 1724,
    type: 'int',
    codeSet: 'OrderOriginationCodeSet',
    description: 'Order received from another broker-dealer',
  },
  {
    name: 'OrderReceivedFromCustomerOrWithFirm',
    id: '1724004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '135',
    updated: 'FIX.5.0SP2',
    updatedEP: '256',
    tag: 1724,
    type: 'int',
    codeSet: 'OrderOriginationCodeSet',
    description: 'Order received from a customer or originated from within the firm',
  },
  {
    name: 'OrderReceivedFromDirectAccessCustomer',
    id: '1724005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '222',
    tag: 1724,
    type: 'int',
    codeSet: 'OrderOriginationCodeSet',
    description: 'Order received from a direct access or sponsored access customer',
  },
  {
    name: 'OrderReceivedFromForeignDealerEquivalent',
    id: '1724006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '256',
    tag: 1724,
    type: 'int',
    codeSet: 'OrderOriginationCodeSet',
    description:
      'Order received from a foreign dealer equivalent\n\nA foreign dealer equivalent is a person in the business of trading securities in a foreign jurisdiction in a manner analogous to an investment dealer and that is subject to the regulatory jurisdiction of a signatory to the International Organization of Securities Commissions’ (IOSCO) Multilateral Memorandum of Understanding\n\nin that foreign jurisdiction.',
  },
  {
    name: 'OrderReceivedFromExecutionOnlyService',
    id: '1724007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '256',
    tag: 1724,
    type: 'int',
    codeSet: 'OrderOriginationCodeSet',
    description:
      'Order received from an execution-only service\n\nThe acceptance and execution of orders from customers for trades that the broker-dealer has not recommended and for which the broker-dealer takes no responsibility as to the appropriateness or suitability of orders accepted or account positions held.',
  },
  {
    name: 'NotCleared',
    id: '1832001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '140',
    updated: 'FIX.5.0SP2',
    updatedEP: '196',
    tag: 1832,
    type: 'int',
    codeSet: 'ClearedIndicatorCodeSet',
    description:
      'Not cleared\n\nTrade or position has not yet been submitted for clearing.',
  },
  {
    name: 'Cleared',
    id: '1832002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '140',
    updated: 'FIX.5.0SP2',
    updatedEP: '196',
    tag: 1832,
    type: 'int',
    codeSet: 'ClearedIndicatorCodeSet',
    description: 'Cleared\n\nTrade or position has been successfully cleared.',
  },
  {
    name: 'Submitted',
    id: '1832003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '196',
    tag: 1832,
    type: 'int',
    codeSet: 'ClearedIndicatorCodeSet',
    description: 'Submitted\n\nTrade or position has been submitted for clearing.',
  },
  {
    name: 'Rejected',
    id: '1832004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '196',
    tag: 1832,
    type: 'int',
    codeSet: 'ClearedIndicatorCodeSet',
    description: 'Rejected\n\nTrade or position was rejected by clearing.',
  },
  {
    name: 'TwoComponentIntercommoditySpread',
    id: '1833001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '140',
    tag: 1833,
    type: 'int',
    codeSet: 'ContractRefPosTypeCodeSet',
    description: 'Two component intercommodity spread',
  },
  {
    name: 'IndexOrBasket',
    id: '1833002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '140',
    tag: 1833,
    type: 'int',
    codeSet: 'ContractRefPosTypeCodeSet',
    description: 'Index or basket',
  },
  {
    name: 'TwoComponentLocationBasis',
    id: '1833003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '140',
    tag: 1833,
    type: 'int',
    codeSet: 'ContractRefPosTypeCodeSet',
    description: 'Two component locational basis',
  },
  {
    name: 'Other',
    id: '1833004',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '140',
    tag: 1833,
    type: 'int',
    codeSet: 'ContractRefPosTypeCodeSet',
    description: 'Other',
  },
  {
    name: 'Principal',
    id: '1834001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '140',
    tag: 1834,
    type: 'int',
    codeSet: 'PositionCapacityCodeSet',
    description: 'Principal',
  },
  {
    name: 'Agent',
    id: '1834002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '140',
    tag: 1834,
    type: 'int',
    codeSet: 'PositionCapacityCodeSet',
    description: 'Agent',
  },
  {
    name: 'Customer',
    id: '1834003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '140',
    tag: 1834,
    type: 'int',
    codeSet: 'PositionCapacityCodeSet',
    description: 'Customer',
  },
  {
    name: 'Counterparty',
    id: '1834004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '140',
    tag: 1834,
    type: 'int',
    codeSet: 'PositionCapacityCodeSet',
    description: 'Counterparty',
  },
  {
    name: 'SpecialCumDividend',
    id: '1839001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description: 'Special cum dividend (CD)',
  },
  {
    name: 'SpecialCumRights',
    id: '1839002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description: 'Special cum rights (CR)',
  },
  {
    name: 'SpecialExDividend',
    id: '1839003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description: 'Special ex dividend (XD)',
  },
  {
    name: 'SpecialExRights',
    id: '1839004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description: 'Special ex rights (XR)',
  },
  {
    name: 'SpecialCumCoupon',
    id: '1839005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description: 'Special cum coupon (CC)',
  },
  {
    name: 'SpecialCumCapitalRepayments',
    id: '1839006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description: 'Special cum capital repayments (CP)',
  },
  {
    name: 'SpecialExCoupon',
    id: '1839007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description: 'Special ex coupon (XC)',
  },
  {
    name: 'SpecialExCapitalRepayments',
    id: '1839008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description: 'Special ex capital repayments (XP)',
  },
  {
    name: 'CashSettlement',
    id: '1839009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description: 'Cash settlement (CS)',
  },
  {
    name: 'SpecialCumBonus',
    id: '1839010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description: 'Special cum bonus (CB)',
  },
  {
    name: 'SpecialPrice',
    id: '1839011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description: 'Special price (SP)\n\nUsually net or all-in price.',
  },
  {
    name: 'SpecialExBonus',
    id: '1839012',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description: 'Special ex bonus (XB)',
  },
  {
    name: 'GuaranteedDelivery',
    id: '1839013',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description: 'Guaranteed delivery (GD)',
  },
  {
    name: 'SpecialDividend',
    id: '1839014',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description:
      'Special dividend\n\nDeviation from regular ex/cum treatment (without further specification) leading to price modification. To be used only if it is not clear whether it is a special cum or special ex dividend. For ESMA RTS 1, this is the "SDIV" flag.',
  },
  {
    name: 'PriceImprovement',
    id: '1839015',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description:
      'Price improvement\n\nThe price is better than a reference price. For example, this may be due to an offer by a systematic internaliser to always quote better prices than a public reference price. For ESMA RTS 1, this is the "RPRI" flag.',
  },
  {
    name: 'NonPriceFormingTrade',
    id: '1839016',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description:
      'Non-price forming trade\n\nIn the context of MiFID II, these are transactions which are exempted from the trading obligation (i.e. permitted to be transacted as an OTC transaction) and are deemed not to be contributing to the price discovery process. However, these transactions are not exempted from post trade transparency reporting and are required to be published by MiFID venues and "approved publication arrangement" (APAs) for market transparency purposes. The price from exempted transactions should be disregarded for the purposes of price discovery. For ESMA RTS 1 and RTS 2, this is the "NPFT" flag.',
  },
  {
    name: 'TradeExemptedFromTradingObligation',
    id: '1839017',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    updated: 'FIX.Latest',
    updatedEP: '277',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description:
      'Trade exempted from trading obligation\n\nPer MiFIR Article 23, these types of trades are not exempted from post-trade transparency if reported to a trading venue under MiFID II and deemed on exchange, however, they are ignored for price formation despite published by venue. For the UK implementation of MiFIR RTS 1, this is the "TNCP" flag.',
  },
  {
    name: 'PricePending',
    id: '1839018',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    updated: 'FIX.Latest',
    updatedEP: '277',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description:
      'Price or strike price is pending\n\nIn the context of MiFIR RTS 1, RTS 2, and RTS 22, this is the "PNDG" flag.',
  },
  {
    name: 'PriceNotApplicable',
    id: '1839019',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    updated: 'FIX.Latest',
    updatedEP: '277',
    tag: 1839,
    type: 'int',
    codeSet: 'TradePriceConditionCodeSet',
    description:
      'Price is not applicable\n\nIn the context of MiFIR RTS 1, RTS 2, and RTS 22, this is the "NOAP" flag.',
  },
  {
    name: 'PendingClear',
    id: '1840001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1840,
    type: 'int',
    codeSet: 'TradeAllocStatusCodeSet',
    description: 'Pending clear',
  },
  {
    name: 'Claimed',
    id: '1840002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1840,
    type: 'int',
    codeSet: 'TradeAllocStatusCodeSet',
    description: 'Claimed',
  },
  {
    name: 'Cleared',
    id: '1840003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1840,
    type: 'int',
    codeSet: 'TradeAllocStatusCodeSet',
    description: 'Cleared',
  },
  {
    name: 'Rejected',
    id: '1840004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1840,
    type: 'int',
    codeSet: 'TradeAllocStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'ClearedQuantity',
    id: '1842001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1842,
    type: 'int',
    codeSet: 'TradeQtyTypeCodeSet',
    description: 'Cleared quantity',
  },
  {
    name: 'LongSideClaimedQuantity',
    id: '1842002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1842,
    type: 'int',
    codeSet: 'TradeQtyTypeCodeSet',
    description: 'Long side claimed quantity',
  },
  {
    name: 'ShortSideClaimedQuantity',
    id: '1842003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1842,
    type: 'int',
    codeSet: 'TradeQtyTypeCodeSet',
    description: 'Short side claimed quantity',
  },
  {
    name: 'LongSideRejectedQuantity',
    id: '1842004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1842,
    type: 'int',
    codeSet: 'TradeQtyTypeCodeSet',
    description: 'Long side rejected quantity',
  },
  {
    name: 'ShortSideRejectedQuantity',
    id: '1842005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1842,
    type: 'int',
    codeSet: 'TradeQtyTypeCodeSet',
    description: 'Short side rejected quantity',
  },
  {
    name: 'PendingQuantity',
    id: '1842006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1842,
    type: 'int',
    codeSet: 'TradeQtyTypeCodeSet',
    description: 'Pending quantity',
  },
  {
    name: 'TransactionQuantity',
    id: '1842007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1842,
    type: 'int',
    codeSet: 'TradeQtyTypeCodeSet',
    description: 'Transaction quantity',
  },
  {
    name: 'RemainingQuantity',
    id: '1842008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1842,
    type: 'int',
    codeSet: 'TradeQtyTypeCodeSet',
    description:
      'Remaining trade quantity\n\nUsed to indicate the remaining quantity of a trade after a give-up or posting action.',
  },
  {
    name: 'PreviousRemainingQuantity',
    id: '1842009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1842,
    type: 'int',
    codeSet: 'TradeQtyTypeCodeSet',
    description:
      'Previous remaining trade quantity\n\nUsed to indicate the remaining quantity of a trade prior to a give-up or posting action.',
  },
  {
    name: 'Add',
    id: '1848001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1848,
    type: 'int',
    codeSet: 'TradeAllocGroupInstructionCodeSet',
    description: 'Add to an existing allocation group if one exists.',
  },
  {
    name: 'DoNotAdd',
    id: '1848002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1848,
    type: 'int',
    codeSet: 'TradeAllocGroupInstructionCodeSet',
    description: 'Do not add the trade to an allocation group.',
  },
  {
    name: 'Offset',
    id: '1849001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1849,
    type: 'int',
    codeSet: 'OffsetInstructionCodeSet',
    description:
      "Offset\n\nA type of transaction where an executing firm gives up a trade as a result of an allocation. Or, in the case of a reversal of an allocation, the take-up (claiming) firm's transaction.",
  },
  {
    name: 'Onset',
    id: '1849002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '141',
    tag: 1849,
    type: 'int',
    codeSet: 'OffsetInstructionCodeSet',
    description:
      "Onset\n\nA type of transaction where a take-up (claiming) firm takes up a trade as a result of an allocation. Or, in the case of a reversal of an allocation, the executing firm's transaction.",
  },
  {
    name: 'NonFIXSource',
    id: '1857001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '142',
    tag: 1857,
    type: 'int',
    codeSet: 'RelatedTradeIDSourceCodeSet',
    description: 'Non-FIX source',
  },
  {
    name: 'TradeID',
    id: '1857002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '142',
    updated: 'FIX.5.0SP2',
    updatedEP: '165',
    tag: 1857,
    type: 'int',
    codeSet: 'RelatedTradeIDSourceCodeSet',
    description: 'Trade ID',
  },
  {
    name: 'SecondaryTradeID',
    id: '1857003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '142',
    updated: 'FIX.5.0SP2',
    updatedEP: '165',
    tag: 1857,
    type: 'int',
    codeSet: 'RelatedTradeIDSourceCodeSet',
    description: 'Secondary trade ID',
  },
  {
    name: 'TradeReportID',
    id: '1857004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '142',
    updated: 'FIX.5.0SP2',
    updatedEP: '165',
    tag: 1857,
    type: 'int',
    codeSet: 'RelatedTradeIDSourceCodeSet',
    description: 'Trade report ID',
  },
  {
    name: 'FirmTradeID',
    id: '1857005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '142',
    updated: 'FIX.5.0SP2',
    updatedEP: '165',
    tag: 1857,
    type: 'int',
    codeSet: 'RelatedTradeIDSourceCodeSet',
    description: 'Firm trade ID',
  },
  {
    name: 'SecondaryFirmTradeID',
    id: '1857006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '142',
    updated: 'FIX.5.0SP2',
    updatedEP: '165',
    tag: 1857,
    type: 'int',
    codeSet: 'RelatedTradeIDSourceCodeSet',
    description: 'Secondary firm Trade ID',
  },
  {
    name: 'RegulatoryTradeID',
    id: '1857007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '165',
    tag: 1857,
    type: 'int',
    codeSet: 'RelatedTradeIDSourceCodeSet',
    description: 'Regulatory trade ID',
  },
  {
    name: 'PosMaintRptID',
    id: '1863001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '142',
    tag: 1863,
    type: 'int',
    codeSet: 'RelatedPositionIDSourceCodeSet',
    description: 'Position maintenance report ID - PosMaintRptID(721)',
  },
  {
    name: 'TransferID',
    id: '1863002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    updated: 'FIX.5.0SP2',
    updatedEP: '199',
    tag: 1863,
    type: 'int',
    codeSet: 'RelatedPositionIDSourceCodeSet',
    description: 'Position transfer ID - TransferID(2437)',
  },
  {
    name: 'PositionEntityID',
    id: '1863003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '199',
    tag: 1863,
    type: 'int',
    codeSet: 'RelatedPositionIDSourceCodeSet',
    description: 'Position entity ID - PositionID(2618)',
  },
  {
    name: 'ReceivedNotYetProcessed',
    id: '1865001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '143',
    tag: 1865,
    type: 'int',
    codeSet: 'QuoteAckStatusCodeSet',
    description: 'Received, not yet processed',
  },
  {
    name: 'Accepted',
    id: '1865002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '143',
    tag: 1865,
    type: 'int',
    codeSet: 'QuoteAckStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Rejected',
    id: '1865003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '143',
    tag: 1865,
    type: 'int',
    codeSet: 'QuoteAckStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'PriceCheck',
    id: '1869001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '144',
    updated: 'FIX.5.0SP2',
    updatedEP: '229',
    tag: 1869,
    type: 'int',
    codeSet: 'ValueCheckTypeCodeSet',
    description:
      'Price check\n\nIn the context of ESMA RTS 6 Article 15(1)(a) investment firms are required to perform pre-trade controls using "price collars, which automatically block or cancel orders that do not meet set price parameters, differentiating between different financial instruments, both on an order-by-order basis and over a specified period of time".',
  },
  {
    name: 'NotionalValueCheck',
    id: '1869002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '144',
    updated: 'FIX.5.0SP2',
    updatedEP: '229',
    tag: 1869,
    type: 'int',
    codeSet: 'ValueCheckTypeCodeSet',
    description:
      'Notional value check\n\nIn the context of ESMA RTS 6 Article 15(1)(b) investment firms are required to perform pre-trade controls using "maximum order values, which prevent orders with an uncommonly large order value from entering the order book".',
  },
  {
    name: 'QuantityCheck',
    id: '1869003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '229',
    tag: 1869,
    type: 'int',
    codeSet: 'ValueCheckTypeCodeSet',
    description:
      'Quantity check\n\nIn the context of ESMA RTS 6 Article 15(1)(c) investment firms are required to perform pre-trade controls using "maximum order volumes, which prevent orders with an uncommonly large order quantity from entering the order book".',
  },
  {
    name: 'DoNotCheck',
    id: '1870001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '144',
    tag: 1870,
    type: 'int',
    codeSet: 'ValueCheckActionCodeSet',
    description:
      'Do not check\n\nChecks will not be done for the specified ValueCheckType(1869).',
  },
  {
    name: 'Check',
    id: '1870002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '144',
    tag: 1870,
    type: 'int',
    codeSet: 'ValueCheckActionCodeSet',
    description: 'Check\n\nChecks will be done for the specificed ValueCheckType(1869)',
  },
  {
    name: 'BestEffort',
    id: '1870003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '144',
    tag: 1870,
    type: 'int',
    codeSet: 'ValueCheckActionCodeSet',
    description:
      'Best effort\n\nThe market may or may not check the specified ValueCheckType(1869) depending on availability of reference data.',
  },
  {
    name: 'Successful',
    id: '1877001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1877,
    type: 'int',
    codeSet: 'PartyDetailRequestResultCodeSet',
    description: 'Successful (default)',
  },
  {
    name: 'InvalidParty',
    id: '1877002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1877,
    type: 'int',
    codeSet: 'PartyDetailRequestResultCodeSet',
    description: 'Invalid party(-ies)',
  },
  {
    name: 'InvalidRelatedParty',
    id: '1877003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1877,
    type: 'int',
    codeSet: 'PartyDetailRequestResultCodeSet',
    description: 'Invalid related party(-ies)',
  },
  {
    name: 'InvalidPartyStatus',
    id: '1877004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1877,
    type: 'int',
    codeSet: 'PartyDetailRequestResultCodeSet',
    description: 'Invalid party status(es)',
  },
  {
    name: 'NotAuthorized',
    id: '1877005',
    value: '98',
    sort: 98,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1877,
    type: 'int',
    codeSet: 'PartyDetailRequestResultCodeSet',
    description: 'Not authorized',
  },
  {
    name: 'Other',
    id: '1877006',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1877,
    type: 'int',
    codeSet: 'PartyDetailRequestResultCodeSet',
    description: 'Other',
  },
  {
    name: 'Accepted',
    id: '1878001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1878,
    type: 'int',
    codeSet: 'PartyDetailRequestStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'AcceptedWithChanges',
    id: '1878002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1878,
    type: 'int',
    codeSet: 'PartyDetailRequestStatusCodeSet',
    description: 'Accepted with changes',
  },
  {
    name: 'Rejected',
    id: '1878003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1878,
    type: 'int',
    codeSet: 'PartyDetailRequestStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'AcceptancePending',
    id: '1878004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1878,
    type: 'int',
    codeSet: 'PartyDetailRequestStatusCodeSet',
    description: 'Acceptance pending',
  },
  {
    name: 'Accepted',
    id: '1879001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1879,
    type: 'int',
    codeSet: 'PartyDetailDefinitionStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'AcceptedWithChanges',
    id: '1879002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1879,
    type: 'int',
    codeSet: 'PartyDetailDefinitionStatusCodeSet',
    description: 'Accepted with changes',
  },
  {
    name: 'Rejected',
    id: '1879003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1879,
    type: 'int',
    codeSet: 'PartyDetailDefinitionStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'Successful',
    id: '1881001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1881,
    type: 'int',
    codeSet: 'EntitlementRequestResultCodeSet',
    description: 'Successful (default)',
  },
  {
    name: 'InvalidParty',
    id: '1881002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1881,
    type: 'int',
    codeSet: 'EntitlementRequestResultCodeSet',
    description: 'Invalid party(-ies)',
  },
  {
    name: 'InvalidRelatedParty',
    id: '1881003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1881,
    type: 'int',
    codeSet: 'EntitlementRequestResultCodeSet',
    description: 'Invalid related party(-ies)',
  },
  {
    name: 'InvalidEntitlementType',
    id: '1881004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1881,
    type: 'int',
    codeSet: 'EntitlementRequestResultCodeSet',
    description: 'Invalid entitlement type(s)',
  },
  {
    name: 'InvalidEntitlementID',
    id: '1881005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1881,
    type: 'int',
    codeSet: 'EntitlementRequestResultCodeSet',
    description: 'Invalid entitlement ID(s) / ref ID(s)',
  },
  {
    name: 'InvalidEntitlementAttribute',
    id: '1881006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1881,
    type: 'int',
    codeSet: 'EntitlementRequestResultCodeSet',
    description: 'Invalid entitlement attribute(s)',
  },
  {
    name: 'InvalidInstrumentScope',
    id: '1881007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1881,
    type: 'int',
    codeSet: 'EntitlementRequestResultCodeSet',
    description: 'Invalid instrument scope(s)',
  },
  {
    name: 'InvalidMarketSegmentScope',
    id: '1881008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1881,
    type: 'int',
    codeSet: 'EntitlementRequestResultCodeSet',
    description: 'Invalid market segment scope(s)',
  },
  {
    name: 'InvalidStartDate',
    id: '1881009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1881,
    type: 'int',
    codeSet: 'EntitlementRequestResultCodeSet',
    description: 'Invalid start date',
  },
  {
    name: 'InvalidEndDate',
    id: '1881010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1881,
    type: 'int',
    codeSet: 'EntitlementRequestResultCodeSet',
    description: 'Invalid end date',
  },
  {
    name: 'InstrumentScopeNotSupported',
    id: '1881011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1881,
    type: 'int',
    codeSet: 'EntitlementRequestResultCodeSet',
    description: 'Instrument scope not supported',
  },
  {
    name: 'MarketSegmentScopeNotSupported',
    id: '1881012',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1881,
    type: 'int',
    codeSet: 'EntitlementRequestResultCodeSet',
    description: 'Market segment scope not supported',
  },
  {
    name: 'EntitlementNotApprovedForParty',
    id: '1881013',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1881,
    type: 'int',
    codeSet: 'EntitlementRequestResultCodeSet',
    description: 'Entitlement not approved for party(-ies)',
  },
  {
    name: 'EntitlementAlreadyDefinedForParty',
    id: '1881014',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1881,
    type: 'int',
    codeSet: 'EntitlementRequestResultCodeSet',
    description: 'Entitlement already defined for party(-ies)',
  },
  {
    name: 'InstrumentNotApprovedForParty',
    id: '1881015',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1881,
    type: 'int',
    codeSet: 'EntitlementRequestResultCodeSet',
    description: 'Instrument not approved for party(-ies)',
  },
  {
    name: 'NotAuthorized',
    id: '1881016',
    value: '98',
    sort: 98,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1881,
    type: 'int',
    codeSet: 'EntitlementRequestResultCodeSet',
    description: 'Not authorized',
  },
  {
    name: 'Other',
    id: '1881017',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '146',
    tag: 1881,
    type: 'int',
    codeSet: 'EntitlementRequestResultCodeSet',
    description: 'Other',
  },
  {
    name: 'Accepted',
    id: '1883001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '173',
    tag: 1883,
    type: 'int',
    codeSet: 'EntitlementStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'AcceptedWithChanges',
    id: '1883002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '173',
    tag: 1883,
    type: 'int',
    codeSet: 'EntitlementStatusCodeSet',
    description: 'Accepted with changes',
  },
  {
    name: 'Rejected',
    id: '1883003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '173',
    tag: 1883,
    type: 'int',
    codeSet: 'EntitlementStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'Pending',
    id: '1883004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '173',
    tag: 1883,
    type: 'int',
    codeSet: 'EntitlementStatusCodeSet',
    description:
      'Pending\n\nEntitlement definition request submitted that still requires an action to be taken (e.g. approval or setting up).',
  },
  {
    name: 'Requested',
    id: '1883005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '173',
    tag: 1883,
    type: 'int',
    codeSet: 'EntitlementStatusCodeSet',
    description: 'Requested\n\nEntitlement definition has been requested.',
  },
  {
    name: 'Deferred',
    id: '1883006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '183',
    tag: 1883,
    type: 'int',
    codeSet: 'EntitlementStatusCodeSet',
    description:
      'Deferred\n\nEntitlement definition request is being postponed or delayed.',
  },
  {
    name: 'ReceivedNotProcessed',
    id: '1896001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '150',
    tag: 1896,
    type: 'int',
    codeSet: 'TradeMatchAckStatusCodeSet',
    description: 'Received, not yet processed',
  },
  {
    name: 'Accepted',
    id: '1896002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '150',
    tag: 1896,
    type: 'int',
    codeSet: 'TradeMatchAckStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Rejected',
    id: '1896003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '150',
    tag: 1896,
    type: 'int',
    codeSet: 'TradeMatchAckStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'Successful',
    id: '1897001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '150',
    tag: 1897,
    type: 'int',
    codeSet: 'TradeMatchRejectReasonCodeSet',
    description: 'Successful',
  },
  {
    name: 'InvalidPartyInformation',
    id: '1897002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '150',
    tag: 1897,
    type: 'int',
    codeSet: 'TradeMatchRejectReasonCodeSet',
    description: 'Invalid party information',
  },
  {
    name: 'UnknownInstrument',
    id: '1897003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '150',
    tag: 1897,
    type: 'int',
    codeSet: 'TradeMatchRejectReasonCodeSet',
    description: 'Unknown instrument',
  },
  {
    name: 'Unauthorized',
    id: '1897004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '150',
    tag: 1897,
    type: 'int',
    codeSet: 'TradeMatchRejectReasonCodeSet',
    description: 'Not authorized to report trades',
  },
  {
    name: 'InvalidTradeType',
    id: '1897005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '150',
    tag: 1897,
    type: 'int',
    codeSet: 'TradeMatchRejectReasonCodeSet',
    description: 'Invalid trade type',
  },
  {
    name: 'Other',
    id: '1897006',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '150',
    tag: 1897,
    type: 'int',
    codeSet: 'TradeMatchRejectReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'Amount',
    id: '1923001',
    value: '0',
    added: 'FIX.5.0SP2',
    addedEP: '160',
    tag: 1923,
    type: 'int',
    codeSet: 'PriceMovementTypeCodeSet',
    description: 'Amount',
  },
  {
    name: 'Percentage',
    id: '1923002',
    value: '1',
    added: 'FIX.5.0SP2',
    addedEP: '160',
    tag: 1923,
    type: 'int',
    codeSet: 'PriceMovementTypeCodeSet',
    description: 'Percentage',
  },
  {
    name: 'InitialBlockTrade',
    id: '1904001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1904,
    type: 'int',
    codeSet: 'RegulatoryTradeIDEventCodeSet',
    description: 'Initial block trade\n\n',
  },
  {
    name: 'Allocation',
    id: '1904002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1904,
    type: 'int',
    codeSet: 'RegulatoryTradeIDEventCodeSet',
    description:
      'Allocation\n\nDetermination that the block trade will not be further allocated.',
  },
  {
    name: 'Clearing',
    id: '1904003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1904,
    type: 'int',
    codeSet: 'RegulatoryTradeIDEventCodeSet',
    description: 'Clearing',
  },
  {
    name: 'Compression',
    id: '1904004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1904,
    type: 'int',
    codeSet: 'RegulatoryTradeIDEventCodeSet',
    description: 'Compression',
  },
  {
    name: 'Novation',
    id: '1904005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1904,
    type: 'int',
    codeSet: 'RegulatoryTradeIDEventCodeSet',
    description: 'Novation',
  },
  {
    name: 'Termination',
    id: '1904006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1904,
    type: 'int',
    codeSet: 'RegulatoryTradeIDEventCodeSet',
    description: 'Termination',
  },
  {
    name: 'PostTrdVal',
    id: '1904007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 1904,
    type: 'int',
    codeSet: 'RegulatoryTradeIDEventCodeSet',
    description: 'Post-trade valuation',
  },
  {
    name: 'UniqueTransactionIdentifier',
    id: '1905001',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '275',
    tag: 1905,
    type: 'String',
    codeSet: 'RegulatoryTradeIDSourceCodeSet',
    description: 'Unique Transaction Identifier (ISO 23897)',
  },
  {
    name: 'Current',
    id: '1906001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1906,
    type: 'int',
    codeSet: 'RegulatoryTradeIDTypeCodeSet',
    description: 'Current\n\nThe default if not specified.',
  },
  {
    name: 'Previous',
    id: '1906002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1906,
    type: 'int',
    codeSet: 'RegulatoryTradeIDTypeCodeSet',
    description:
      "Previous\n\nThe previous trade's identifier when reporting a cleared trade or novation of a previous trade.",
  },
  {
    name: 'Block',
    id: '1906003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1906,
    type: 'int',
    codeSet: 'RegulatoryTradeIDTypeCodeSet',
    description:
      "Block\n\nThe block trade's identifier when reporting an allocated subtrade.",
  },
  {
    name: 'Related',
    id: '1906004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1906,
    type: 'int',
    codeSet: 'RegulatoryTradeIDTypeCodeSet',
    description: 'Related\n\nThe related trade identifier when reporting a mixed swap.',
  },
  {
    name: 'ClearedBlockTrade',
    id: '1906005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1906,
    type: 'int',
    codeSet: 'RegulatoryTradeIDTypeCodeSet',
    description:
      'Cleared block trade\n\nAssigned by the CCP to a bunched order/trade when it needs to be cleared with the standby clearing firm prior to post-trade allocation.',
  },
  {
    name: 'TradingVenueTransactionIdentifier',
    id: '1906006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '222',
    tag: 1906,
    type: 'int',
    codeSet: 'RegulatoryTradeIDTypeCodeSet',
    description:
      'Trading venue transaction identifier\n\nAssigned by the trading venue to a transaction. In the context of ESMA RTS 22 and RTS 24, this is an unique transaction identification "number generated by trading venues and disseminated to both the buying and selling parties in accordance with Article 12 of [RTS 24 on the maintenance of relevant data relating to orders in financial instruments under Article 25 of Regulation 600/2014 EU]." (quoted text from RTS 22). "Uniqueness" may be defined per relevant regulations.',
  },
  {
    name: 'ReportTrackingNumber',
    id: '1906007',
    value: '6',
    sort: 6,
    added: 'FIX.Latest',
    addedEP: '284',
    tag: 1906,
    type: 'int',
    codeSet: 'RegulatoryTradeIDTypeCodeSet',
    description:
      'Report tracking number\n\nIn the context of EMIR Refit this is a "unique code assigned to the execution of an order and common for a group of reports related to the same execution" (see Q28 in https://www.esma.europa.eu/sites/default/files/library/esma74-362-2281_final_report_guidelines_emir_refit.pdf). Also referred to as the RTN.',
  },
  {
    name: 'DoNotIntendToClear',
    id: '1924001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1924,
    type: 'int',
    codeSet: 'ClearingIntentionCodeSet',
    description: 'Do not intend to clear',
  },
  {
    name: 'IntendToClear',
    id: '1924002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1924,
    type: 'int',
    codeSet: 'ClearingIntentionCodeSet',
    description: 'Intend to clear',
  },
  {
    name: 'NonElectronic',
    id: '1927001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1927,
    type: 'int',
    codeSet: 'ConfirmationMethodCodeSet',
    description: 'Non-electronic',
  },
  {
    name: 'Electronic',
    id: '1927002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1927,
    type: 'int',
    codeSet: 'ConfirmationMethodCodeSet',
    description: 'Electronic',
  },
  {
    name: 'Unconfirmed',
    id: '1927003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 1927,
    type: 'int',
    codeSet: 'ConfirmationMethodCodeSet',
    description: 'Unconfirmed',
  },
  {
    name: 'NonElectronic',
    id: '1931001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1931,
    type: 'int',
    codeSet: 'VerificationMethodCodeSet',
    description: 'Non-electronic',
  },
  {
    name: 'Electronic',
    id: '1931002',
    value: '1',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1931,
    type: 'int',
    codeSet: 'VerificationMethodCodeSet',
    description: 'Electronic',
  },
  {
    name: 'NoException',
    id: '1932001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1932,
    type: 'int',
    codeSet: 'ClearingRequirementExceptionCodeSet',
    description: 'No exception',
  },
  {
    name: 'Exception',
    id: '1932002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '177',
    tag: 1932,
    type: 'int',
    codeSet: 'ClearingRequirementExceptionCodeSet',
    description:
      'Exception\n\nUsed to indicate an exception to a clearing requirement without elaborating on the type of exception.',
  },
  {
    name: 'EndUserException',
    id: '1932003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '177',
    tag: 1932,
    type: 'int',
    codeSet: 'ClearingRequirementExceptionCodeSet',
    description:
      'End-user exception\n\nIn the US, see CFTC Final Rule on End-User Exception to Clearing Requirements for Swaps Fact Sheet http://www.cftc.gov/ucm/groups/public/@newsroom/documents/file/eue_factsheet_final.pdf',
  },
  {
    name: 'InterAffiliateException',
    id: '1932004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '177',
    tag: 1932,
    type: 'int',
    codeSet: 'ClearingRequirementExceptionCodeSet',
    description:
      'Inter-affiliate exception\n\nIn the US, see CFTC Final Rule - Clearing Exemption for Swaps Between Certain Affiliated Entities http://www.cftc.gov//ucm/groups/public/@lrfederalregister/documents/file/2013-07970a.pdf',
  },
  {
    name: 'TreasuryAffiliateException',
    id: '1932005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '177',
    tag: 1932,
    type: 'int',
    codeSet: 'ClearingRequirementExceptionCodeSet',
    description:
      'Treasury affiliate exception\n\nIn the US, see CFTC No Action Letter 13-22 No Action Relief from the Clearing Requirement for Swaps Entered into by Eligible Treasury Affiliates http://www.cftc.gov/ucm/groups/public/@lrlettergeneral/documents/letter/13-22.pdf',
  },
  {
    name: 'CooperativeException',
    id: '1932006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '177',
    tag: 1932,
    type: 'int',
    codeSet: 'ClearingRequirementExceptionCodeSet',
    description:
      'Cooperative exception\n\nClearing exception for certain swaps entered into by cooperatives. In the US, see Regulation 50.51(a) Definition of Exempt Cooperative: https://www.federalregister.gov/articles/2013/08/22/2013-19945/clearing-exemption-for-certain-swaps-entered-into-by-cooperatives',
  },
  {
    name: 'Pay',
    id: '1933001',
    value: 'PAY',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1933,
    type: 'String',
    codeSet: 'IRSDirectionCodeSet',
    description: 'Principal is paying fixed rate\n\n',
  },
  {
    name: 'Rcv',
    id: '1933002',
    value: 'RCV',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1933,
    type: 'String',
    codeSet: 'IRSDirectionCodeSet',
    description: 'Principal is receiving fixed rate',
  },
  {
    name: 'NA',
    id: '1933003',
    value: 'NA',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1933,
    type: 'String',
    codeSet: 'IRSDirectionCodeSet',
    description: 'Swap is float/float or fixed/fixed',
  },
  {
    name: 'RT',
    id: '1934001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Real-time (RT)\n\nReport of data relating to a regulated transaction including price and volume that is to be disseminated publically. If dissemination is to be suppressed due to an end user exception or to local regulatory rules that allow suppression of certain types of transactions use TradePublishIndicator(1390)=0.',
  },
  {
    name: 'PET',
    id: '1934002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Primary economic terms (PET)\n\nReport to regulators of the full terms of a regulated transaction included in the legal confirmation.',
  },
  {
    name: 'Snapshot',
    id: '1934003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Snapshot\n\nPeriodic report of full primary economic terms data throughout the life cycle of a regulated transaction.',
  },
  {
    name: 'Confirmation',
    id: '1934004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Confirmation\n\nReport from a clearing organization of a cleared regulated transaction.',
  },
  {
    name: 'RTPET',
    id: '1934005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Combination of RT and PET\n\nA single report combining the requirements of both real-time and full primary economy terms of a regulated transaction.',
  },
  {
    name: 'PETConfirmation',
    id: '1934006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Combination of PET and confirmation\n\nA single report combining the requirements of both full primary economic terms of a regulated transaction report and confirmation.',
  },
  {
    name: 'RTPETConfirmation',
    id: '1934007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Combination of RT, PET and confirmation\n\nA single report combining the requirements of real-time and full primary economic terms of a regulated transaction report, and confirmation.',
  },
  {
    name: 'PostTrade',
    id: '1934008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Post-trade valuation\n\nPeriodic report of the ongoing mark-to-market value of a regulated transaction.',
  },
  {
    name: 'Verification',
    id: '1934009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Verification\n\nUsed by the trading counterparty to report its full primary economic terms of a regulated transaction separately to the repository.',
  },
  {
    name: 'PstTrdEvnt',
    id: '1934010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    updated: 'FIX.5.0SP2',
    updatedEP: '187',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Post-trade event\n\nReport of a regulated transaction continuation event that does not fall within the requirements for real-time reporting.',
  },
  {
    name: 'PstTrdEvntRTReportable',
    id: '1934011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Post trade event RT reportable\n\nReport of a regulated transaction continuation event that falls within the requirements for real-time reporting and public dissemination. If dissemination is to be suppressed due to an end user exception or to local regulatory rules that allow suppression of certain types of transactions, use TradePublishIndicator(1390) = 0 (Do not publish trade).',
  },
  {
    name: 'LMTF',
    id: '1934012',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Limited Details Trade\n\nDesignates a trade in instruments specified in ESMA RTS 2 Article 11 (1)(a)(i) for immediate publication of all details except the quantity. This is ESMA RTS 2 deferral flag "LMTF".',
  },
  {
    name: 'DATF',
    id: '1934013',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Daily Aggregated Trade\n\nDesignates a trade in instruments specified in ESMA RTS 2 Article 11 (1)(a)(ii) for aggregated publication of at least 5 transactions before 9:00 a.m. local time next day. This is ESMA RTS 2 deferral flag "DATF".',
  },
  {
    name: 'VOLO',
    id: '1934014',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Volume Omission Trade\n\nDesignates a trade in instruments specified in ESMA RTS 2 Article 11 (1)(b) for immediate publication of all details except the quantity. This is ESMA RTS 2 deferral flag "VOLO".',
  },
  {
    name: 'FWAF',
    id: '1934015',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Four Weeks Aggregation Trade\n\nDesignates a trade in instruments specified in ESMA RTS 2 Article 11 (1)(c) (non-sovereign debt only) for aggregated publication of transactions executed over the course of one calendar week before 9:00 a.m. local time following Tuesday. This is ESMA RTS 2 deferral flag "FWAF".',
  },
  {
    name: 'IDAF',
    id: '1934016',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Indefinite Aggregation Trade\n\nDesignates a trade in instruments specified in ESMA RTS 2 Article 11 (1)(d) (sovereign debt only) for aggregated publication of transactions executed over the course of one calendar week before 9:00 a.m. local time following Tuesday. This is ESMA RTS 2 deferral flag "IDAF".',
  },
  {
    name: 'VOLW',
    id: '1934017',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Volume Omission Trade Eligible for Subsequent Aggregated Enrichment\n\nDesignates a trade in instruments specified in ESMA RTS 2 Article 11 (1)(b) and (d) consecutively (sovereign debt only) for immediate publication of all details except the quantity. This is ESMA RTS 2 deferral flag "VOLW".',
  },
  {
    name: 'FULF',
    id: '1934018',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Full Details Trade of "Limited Details Trade"\n\nFull details of a previously reported "limited details trade (LMTF)". Designates a trade in instruments specified in ESMA RTS 2 Article 11 (1)(a)(i) which is a follow-up publication of all details before 7pm local time on the second day after initial publication. This is ESMA RTS deferral flag "FULF".',
  },
  {
    name: 'FULA',
    id: '1934019',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Full Details of "Daily Aggregated Trade"\n\nFull details of a previously reported "daily aggregated trade (DATF)". Designates a trade in instruments specified in RTS 2 Article 11 (1)(a)(ii) which is a follow-up publication of the individual transaction with full details before 7pm local time on the second day after initial publication. This is ESMA RTS 2 deferral flag "FULA".',
  },
  {
    name: 'FULV',
    id: '1934020',
    value: '19',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Full Details of "Volume Omission Trade"\n\nFull details of a previously reported "volume omission trade (VOLO)". Designates a trade in instruments specified in ESMA RTS 2 Article 11 (1)(b) which is a follow-up publication of all details before 9 am local time four weeks after initial publication. This is ESMA RTS 2 deferral flag "FULV".',
  },
  {
    name: 'FULJ',
    id: '1934021',
    value: '20',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Full Details of "Four Weeks Aggregation Trade"\n\nFull details of a previously reported "four weeks aggregation trade (FWAF)". Designates a trade in instruments specified in ESMA RTS 2 Article 11 (1)(c) (non-sovereign debt only) which is a follow-up publication of the individual transaction with full details before 9 am local time four weeks after initial publication. This is ESMA RTS 2 deferral flag "FULJ".',
  },
  {
    name: 'COAF',
    id: '1934022',
    value: '21',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Full Details in Aggregated Form of "Volume Omission Trade Eligible for Subsequent Aggregated Enrichment"\n\nFull details of a previously reported "volume omission trade eligible for subsequent aggregated enrichment (VOLW)". Designates a trade report in instruments specified in ESMA RTS 2 Article 11(1)(b) and (d) consecutively which is an aggregated publication of transactions executed over the course of one calendar week before 9:00 a.m. CET local time the following Tuesday four weeks after initial publication. This is ESMA RTS 2 deferral flag "COAF".',
  },
  {
    name: 'Order',
    id: '1934023',
    value: '22',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Order\n\nReport for order handling events to enter, change or delete orders. In the context of US CAT this is used for the event types MENO, MEOM, MEOJ, and MEOC.',
  },
  {
    name: 'ChildOrder',
    id: '1934024',
    value: '23',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Child order\n\nReport for child order handling events to enter, change or delete child orders. Child orders are created when a (parent) order is split into multiple (child) orders. In the context of US CAT this is used for the event types MECO, MECOM, and MECOC.',
  },
  {
    name: 'OrderRoute',
    id: '1934025',
    value: '24',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Order route\n\nReported when an order is routed between market participants and/or execution venues such as an exchange. In the context of US CAT this is used for the event types MEOR, MEOA and MEIR.',
  },
  {
    name: 'Trade',
    id: '1934026',
    value: '25',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Trade\n\nReport for trade handling events to enter, change or delete trades. In the context of US CAT this is used for the event types MEOT, MEOF and MEFA.',
  },
  {
    name: 'Quote',
    id: '1934027',
    value: '26',
    sort: 26,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Quote\n\nReport for quote handling events to enter, change or delete quotes. In the context of US CAT this is used for the event types MENQ, MEQR, and MEQC.',
  },
  {
    name: 'Supplement',
    id: '1934028',
    value: '27',
    sort: 27,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Supplement\n\nReported when an order, quote or trade report is split across multiple messages. The recipient must be able to create the full report by combining the initial and supplement reports. In the context of US CAT this is used for the event types MENOS, MEOMS and MEOTS.',
  },
  {
    name: 'NewTransaction',
    id: '1934029',
    value: '28',
    sort: 28,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'New transaction\n\nIn the context of EU SFTR reporting this corresponds to "action type" "NEWT".',
  },
  {
    name: 'TransactionCorrection',
    id: '1934030',
    value: '29',
    sort: 29,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Transaction correction\n\nIn the context of EU SFTR reporting this corresponds to "action type" "CORR".',
  },
  {
    name: 'TransactionModification',
    id: '1934031',
    value: '30',
    sort: 30,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Transaction modification\n\nIn the context of EU SFTR reporting this corresponds to "action type" "MODI".',
  },
  {
    name: 'CollateralUpdate',
    id: '1934032',
    value: '31',
    sort: 31,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Collateral update\n\nIn the context of EU SFTR reporting this corresponds to "action type" "COLU" if CollStatus(910)=3 (Assigned (Accepted)), or "REUU" if CollStatus(910)=5 (Reused).',
  },
  {
    name: 'MarginUpdate',
    id: '1934033',
    value: '32',
    sort: 32,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Margin update\n\nIn the context of EU SFTR reporting this corresponds to "action type" "MARU".',
  },
  {
    name: 'TransactionReportedInError',
    id: '1934034',
    value: '33',
    sort: 33,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Transaction reported in error\n\nIn the context of EU SFTR reporting this corresponds to "action type" "EROR".',
  },
  {
    name: 'TerminationEarlyTermination',
    id: '1934035',
    value: '34',
    sort: 34,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 1934,
    type: 'int',
    codeSet: 'RegulatoryReportTypeCodeSet',
    description:
      'Termination / Early termination\n\nIn the context of EU SFTR reporting this corresponds to "action type" "ETRM".',
  },
  {
    name: 'Uncollateralized',
    id: '1936001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1936,
    type: 'int',
    codeSet: 'TradeCollateralizationCodeSet',
    description: 'Uncollateralized',
  },
  {
    name: 'PartiallyCollateralized',
    id: '1936002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1936,
    type: 'int',
    codeSet: 'TradeCollateralizationCodeSet',
    description: 'Partially collateralized',
  },
  {
    name: 'OneWayCollaterallization',
    id: '1936003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1936,
    type: 'int',
    codeSet: 'TradeCollateralizationCodeSet',
    description: 'One-way collaterallization',
  },
  {
    name: 'FullyCollateralized',
    id: '1936004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1936,
    type: 'int',
    codeSet: 'TradeCollateralizationCodeSet',
    description: 'Fully collateralized',
  },
  {
    name: 'NetExposure',
    id: '1936005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 1936,
    type: 'int',
    codeSet: 'TradeCollateralizationCodeSet',
    description:
      'Net exposure\n\nIndication of whether the collateral has been provided for a net exposure, rather than for a single transaction.',
  },
  {
    name: 'Novation',
    id: '1937001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Novation',
  },
  {
    name: 'PartialNovation',
    id: '1937002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Partial novation',
  },
  {
    name: 'TradeUnwind',
    id: '1937003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '179',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Trade unwind\n\n"Trade" includes "Swaps".',
  },
  {
    name: 'PartialTradeUnwind',
    id: '1937004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '179',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Partial trade unwind\n\n"Trade" includes "Swaps".',
  },
  {
    name: 'Exercise',
    id: '1937005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Exercise',
  },
  {
    name: 'Netting',
    id: '1937006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '179',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description:
      'Compression/Netting\n\nCompression (used for OTC derivative trades) and Netting (used for Futures trades) are essentially the same business process, i.e. rolling up closely related contracts into a single trade or position.',
  },
  {
    name: 'FullNetting',
    id: '1937007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Full netting',
  },
  {
    name: 'PartialNetting',
    id: '1937008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Partial netting',
  },
  {
    name: 'Amendment',
    id: '1937009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '193',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description:
      'Amendment\n\nBased on mutual agreement between the counterparties, used to change the original or previously amended contract terms reported to a trade repository.',
  },
  {
    name: 'Increase',
    id: '1937010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Increase',
  },
  {
    name: 'CreditEvent',
    id: '1937011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Credit event',
  },
  {
    name: 'StrategicRestructuring',
    id: '1937012',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Strategic restructuring',
  },
  {
    name: 'SuccessionEventReorganization',
    id: '1937013',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Succession event reorganization',
  },
  {
    name: 'SuccessionEventRenaming',
    id: '1937014',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Succession event renaming',
  },
  {
    name: 'Porting',
    id: '1937015',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Porting',
  },
  {
    name: 'Withdrawl',
    id: '1937016',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description:
      'Withdrawal\n\nOne party withdrew from the trade prior to confirmation or clearing. Can be used with TradeReportTransType(487)=1 (Cancel).',
  },
  {
    name: 'Void',
    id: '1937017',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description:
      'Void\n\nTrade is to be ended after clearing. Can be used with TradeReportTransType(487)=1 (Cancel).',
  },
  {
    name: 'AccountTransfer',
    id: '1937018',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Account transfer',
  },
  {
    name: 'GiveUp',
    id: '1937019',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Give up',
  },
  {
    name: 'TakeUp',
    id: '1937020',
    value: '19',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'TakeUp',
  },
  {
    name: 'AveragePricing',
    id: '1937021',
    value: '20',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Average pricing',
  },
  {
    name: 'Reversal',
    id: '1937022',
    value: '21',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Reversal',
  },
  {
    name: 'AllocTrdPosting',
    id: '1937023',
    value: '22',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Allocation/Trade posting',
  },
  {
    name: 'Cascade',
    id: '1937024',
    value: '23',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description:
      'Cascade\n\nThe breakdown of a contract position to a more granular level, e.g. from a yearly position to monthly positions.',
  },
  {
    name: 'Delivery',
    id: '1937025',
    value: '24',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Delivery',
  },
  {
    name: 'OptionAsgn',
    id: '1937026',
    value: '25',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Option assignment',
  },
  {
    name: 'Expiration',
    id: '1937027',
    value: '26',
    sort: 26,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Expiration',
  },
  {
    name: 'Maturity',
    id: '1937028',
    value: '27',
    sort: 27,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Maturity',
  },
  {
    name: 'EqualPosAdj',
    id: '1937029',
    value: '28',
    sort: 28,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description: 'Equal position adjustment',
  },
  {
    name: 'UnequalPosAdj',
    id: '1937030',
    value: '29',
    sort: 29,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description:
      'Unequal position adjustment\n\nAn adjustment to either the long or short position quantity but not both.',
  },
  {
    name: 'Correction',
    id: '1937031',
    value: '30',
    sort: 30,
    added: 'FIX.5.0SP2',
    addedEP: '193',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description:
      'Correction\n\nUsed to correct an error in the contract terms of a previously submitted report to a trade repository.',
  },
  {
    name: 'EarlyTermination',
    id: '1937032',
    value: '31',
    sort: 31,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description:
      'Early termination\n\nThe transaction/contract has closed before its natural end (maturity date or end date).',
  },
  {
    name: 'Rerate',
    id: '1937033',
    value: '32',
    sort: 32,
    added: 'FIX.5.0SP2',
    addedEP: '258',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description:
      'Rerate\n\nChange in the repo rate of an open repo contract due to shift in the market conditions.',
  },
  {
    name: 'Other',
    id: '1937034',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '179',
    tag: 1937,
    type: 'int',
    codeSet: 'TradeContinuationCodeSet',
    description:
      'Other price-forming continuation data\n\nOther price-forming continuation data or lifecycle event. Include description of type in TradeContinuationText(2374).',
  },
  {
    name: 'InterestRate',
    id: '1938001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1938,
    type: 'int',
    codeSet: 'AssetClassCodeSet',
    description: 'Interest rate',
  },
  {
    name: 'Currency',
    id: '1938002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1938,
    type: 'int',
    codeSet: 'AssetClassCodeSet',
    description: 'Currency',
  },
  {
    name: 'Credit',
    id: '1938003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1938,
    type: 'int',
    codeSet: 'AssetClassCodeSet',
    description: 'Credit',
  },
  {
    name: 'Equity',
    id: '1938004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1938,
    type: 'int',
    codeSet: 'AssetClassCodeSet',
    description: 'Equity',
  },
  {
    name: 'Commodity',
    id: '1938005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1938,
    type: 'int',
    codeSet: 'AssetClassCodeSet',
    description: 'Commodity',
  },
  {
    name: 'Other',
    id: '1938006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 1938,
    type: 'int',
    codeSet: 'AssetClassCodeSet',
    description: 'Other',
  },
  {
    name: 'Cash',
    id: '1938007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1938,
    type: 'int',
    codeSet: 'AssetClassCodeSet',
    description: 'Cash',
  },
  {
    name: 'Debt',
    id: '1938008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1938,
    type: 'int',
    codeSet: 'AssetClassCodeSet',
    description: 'Debt',
  },
  {
    name: 'Fund',
    id: '1938009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1938,
    type: 'int',
    codeSet: 'AssetClassCodeSet',
    description:
      'Fund\n\nSuch as mutual fund, collective investment vehicle, investment program, specialized account program.',
  },
  {
    name: 'LoanFacility',
    id: '1938010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1938,
    type: 'int',
    codeSet: 'AssetClassCodeSet',
    description: 'Loan facility',
  },
  {
    name: 'Index',
    id: '1938011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 1938,
    type: 'int',
    codeSet: 'AssetClassCodeSet',
    description:
      'Index\n\nA main index identified as a security type, for example under EU SFTR reporting.',
  },
  {
    name: 'Metals',
    id: '1939001',
    value: '13',
    sort: 13,
    group: 'Commodity',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Metals',
  },
  {
    name: 'Bullion',
    id: '1939002',
    value: '14',
    sort: 14,
    group: 'Commodity',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Bullion',
  },
  {
    name: 'Energy',
    id: '1939003',
    value: '15',
    sort: 15,
    group: 'Commodity',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Energy',
  },
  {
    name: 'CommodityIndex',
    id: '1939004',
    value: '16',
    sort: 16,
    group: 'Commodity',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Commodity index',
  },
  {
    name: 'Agricultural',
    id: '1939005',
    value: '17',
    sort: 17,
    group: 'Commodity',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Agricultural',
  },
  {
    name: 'Environmental',
    id: '1939006',
    value: '18',
    sort: 18,
    group: 'Commodity',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Environmental',
  },
  {
    name: 'Freight',
    id: '1939007',
    value: '19',
    sort: 19,
    group: 'Commodity',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Freight',
  },
  {
    name: 'Fertilizer',
    id: '1939008',
    value: '41',
    sort: 41,
    group: 'Commodity',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Fertilizer',
  },
  {
    name: 'IndustrialProduct',
    id: '1939009',
    value: '42',
    sort: 42,
    group: 'Commodity',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Industrial product',
  },
  {
    name: 'Inflation',
    id: '1939010',
    value: '43',
    sort: 43,
    group: 'Commodity',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Inflation',
  },
  {
    name: 'Paper',
    id: '1939011',
    value: '44',
    sort: 44,
    group: 'Commodity',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Paper',
  },
  {
    name: 'Polypropylene',
    id: '1939012',
    value: '45',
    sort: 45,
    group: 'Commodity',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Polypropylene',
  },
  {
    name: 'OfficialEconomicStatistics',
    id: '1939013',
    value: '46',
    sort: 46,
    group: 'Commodity',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Official economic statistics',
  },
  {
    name: 'SingleName',
    id: '1939014',
    value: '4',
    sort: 4,
    group: 'Credit',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Single name',
  },
  {
    name: 'CreditIndex',
    id: '1939015',
    value: '5',
    sort: 5,
    group: 'Credit',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Credit index',
  },
  {
    name: 'IndexTranche',
    id: '1939016',
    value: '6',
    sort: 6,
    group: 'Credit',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Index tranche',
  },
  {
    name: 'CreditBasket',
    id: '1939017',
    value: '7',
    sort: 7,
    group: 'Credit',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Credit basket',
  },
  {
    name: 'Basket',
    id: '1939018',
    value: '3',
    sort: 3,
    group: 'Currency',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Basket [for multi-currency]',
  },
  {
    name: 'FXCrossRates',
    id: '1939019',
    value: '38',
    sort: 38,
    group: 'Currency',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'FX cross rates',
  },
  {
    name: 'FXEmergingMarkets',
    id: '1939020',
    value: '39',
    sort: 39,
    group: 'Currency',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'FX emerging markets',
  },
  {
    name: 'FXMajors',
    id: '1939021',
    value: '40',
    sort: 40,
    group: 'Currency',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'FX Majors',
  },
  {
    name: 'Government',
    id: '1939022',
    value: '20',
    sort: 20,
    group: 'Debt',
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Government',
  },
  {
    name: 'Agency',
    id: '1939023',
    value: '21',
    sort: 21,
    group: 'Debt',
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Agency',
  },
  {
    name: 'Corporate',
    id: '1939024',
    value: '22',
    sort: 22,
    group: 'Debt',
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Corporate',
  },
  {
    name: 'Financing',
    id: '1939025',
    value: '23',
    sort: 23,
    group: 'Debt',
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Financing',
  },
  {
    name: 'MoneyMarket',
    id: '1939026',
    value: '24',
    sort: 24,
    group: 'Debt',
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Money market',
  },
  {
    name: 'Mortgage',
    id: '1939027',
    value: '25',
    sort: 25,
    group: 'Debt',
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Mortgage',
  },
  {
    name: 'Municipal',
    id: '1939028',
    value: '26',
    sort: 26,
    group: 'Debt',
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Municipal',
  },
  {
    name: 'Common',
    id: '1939029',
    value: '9',
    sort: 9,
    group: 'Equity',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Common',
  },
  {
    name: 'Preferred',
    id: '1939030',
    value: '10',
    sort: 10,
    group: 'Equity',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Preferred',
  },
  {
    name: 'EquityIndex',
    id: '1939031',
    value: '11',
    sort: 11,
    group: 'Equity',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Equity index',
  },
  {
    name: 'EquityBasket',
    id: '1939032',
    value: '12',
    sort: 12,
    group: 'Equity',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Equity basket',
  },
  {
    name: 'DividendIndex',
    id: '1939033',
    value: '34',
    sort: 34,
    group: 'Equity',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Dividend index',
  },
  {
    name: 'StockDividend',
    id: '1939034',
    value: '35',
    sort: 35,
    group: 'Equity',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Stock dividend',
  },
  {
    name: 'ExchangeTradedFund',
    id: '1939035',
    value: '36',
    sort: 36,
    group: 'Equity',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Exchange traded fund',
  },
  {
    name: 'VolatilityIndex',
    id: '1939036',
    value: '37',
    sort: 37,
    group: 'Equity',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Volatility index',
  },
  {
    name: 'MutualFund',
    id: '1939037',
    value: '27',
    sort: 27,
    group: 'Fund',
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Mutual fund',
  },
  {
    name: 'CollectiveInvestmentVehicle',
    id: '1939038',
    value: '28',
    sort: 28,
    group: 'Fund',
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Collective investment vehicle',
  },
  {
    name: 'InvestmentProgram',
    id: '1939039',
    value: '29',
    sort: 29,
    group: 'Fund',
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Investment program\n\nA generalized fund for major investors.',
  },
  {
    name: 'SpecializedAccountProgram',
    id: '1939040',
    value: '30',
    sort: 30,
    group: 'Fund',
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description:
      'Specialized account program\n\nA specialized fund setup for a particular account or group of accounts.',
  },
  {
    name: 'SingleCurrency',
    id: '1939041',
    value: '1',
    sort: 1,
    group: 'Interest Rate',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Single currency',
  },
  {
    name: 'CrossCurrency',
    id: '1939042',
    value: '2',
    sort: 2,
    group: 'Interest Rate',
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Cross currency',
  },
  {
    name: 'TermLoan',
    id: '1939043',
    value: '31',
    sort: 31,
    group: 'Loan Facility',
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Term loan',
  },
  {
    name: 'BridgeLoan',
    id: '1939044',
    value: '32',
    sort: 32,
    group: 'Loan Facility',
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Bridge loan',
  },
  {
    name: 'LetterOfCredit',
    id: '1939045',
    value: '33',
    sort: 33,
    group: 'Loan Facility',
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Letter of credit',
  },
  {
    name: 'Exotic',
    id: '1939046',
    value: '8',
    sort: 8,
    group: 'Other',
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Exotic',
  },
  {
    name: 'OtherC10',
    id: '1939047',
    value: '47',
    sort: 47,
    group: 'Other',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description:
      "Other C10\n\nDefined under MiFID II (Directive 2014/65/EU) Section C(10) of Annex I and paraphrased in ESMA RTS 2 Annex III Section 10, \"Other C10\" is a financial instrument \"which is not a 'Freight derivative', any of the following interest rate derivatives sub-asset classes: 'Inflation multi-currency swap or cross-currency swap', a 'Future/forward on inflation multi-currency swaps or cross-currency swaps', an 'Inflation single currency swap', a 'Future/forward on inflation single currency swap' and any of the following equity derivatives sub-asset classes: a 'Volatility index option', a 'Volatility index future/forward', a swap with parameter return variance, a swap with parameter return volatility, a portfolio swap with parameter return variance, a portfolio swap with parameter return volatility\".",
  },
  {
    name: 'Other',
    id: '1939048',
    value: '48',
    sort: 48,
    group: 'Other',
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 1939,
    type: 'int',
    codeSet: 'AssetSubClassCodeSet',
    description: 'Other\n\nMay be used with any AssetClass(1938) values.',
  },
  {
    name: 'BasisSwap',
    id: '1941001',
    value: 'BS',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1941,
    type: 'String',
    codeSet: 'SwapClassCodeSet',
    description: 'Basis swap',
  },
  {
    name: 'IndexSwap',
    id: '1941002',
    value: 'IX',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1941,
    type: 'String',
    codeSet: 'SwapClassCodeSet',
    description: 'Index swap',
  },
  {
    name: 'BroadBasedSecuritySwap',
    id: '1941003',
    value: 'BB',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1941,
    type: 'String',
    codeSet: 'SwapClassCodeSet',
    description: 'Broad-based security swap',
  },
  {
    name: 'BasketSwap',
    id: '1941004',
    value: 'SK',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1941,
    type: 'String',
    codeSet: 'SwapClassCodeSet',
    description: 'Basket swap',
  },
  {
    name: 'Zero',
    id: '1946001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1946,
    type: 'int',
    codeSet: 'CouponTypeCodeSet',
    description: 'Zero',
  },
  {
    name: 'FixedRate',
    id: '1946002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1946,
    type: 'int',
    codeSet: 'CouponTypeCodeSet',
    description: 'Fixed rate',
  },
  {
    name: 'FloatingRate',
    id: '1946003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1946,
    type: 'int',
    codeSet: 'CouponTypeCodeSet',
    description: 'Floating rate',
  },
  {
    name: 'Structured',
    id: '1946004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1946,
    type: 'int',
    codeSet: 'CouponTypeCodeSet',
    description: 'Structured',
  },
  {
    name: 'Day',
    id: '1949001',
    value: 'D',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1949,
    type: 'String',
    codeSet: 'CouponFrequencyUnitCodeSet',
    description: 'Day',
  },
  {
    name: 'Week',
    id: '1949002',
    value: 'Wk',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1949,
    type: 'String',
    codeSet: 'CouponFrequencyUnitCodeSet',
    description: 'Week',
  },
  {
    name: 'Month',
    id: '1949003',
    value: 'Mo',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1949,
    type: 'String',
    codeSet: 'CouponFrequencyUnitCodeSet',
    description: 'Month',
  },
  {
    name: 'Year',
    id: '1949004',
    value: 'Yr',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1949,
    type: 'String',
    codeSet: 'CouponFrequencyUnitCodeSet',
    description: 'Year',
  },
  {
    name: 'Hour',
    id: '1949005',
    value: 'H',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 1949,
    type: 'String',
    codeSet: 'CouponFrequencyUnitCodeSet',
    description: 'Hour',
  },
  {
    name: 'Minute',
    id: '1949006',
    value: 'Min',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 1949,
    type: 'String',
    codeSet: 'CouponFrequencyUnitCodeSet',
    description: 'Minute',
  },
  {
    name: 'Second',
    id: '1949007',
    value: 'S',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 1949,
    type: 'String',
    codeSet: 'CouponFrequencyUnitCodeSet',
    description: 'Second',
  },
  {
    name: 'Term',
    id: '1949008',
    value: 'T',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 1949,
    type: 'String',
    codeSet: 'CouponFrequencyUnitCodeSet',
    description: 'Term',
  },
  {
    name: 'OneOne',
    id: '1950001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '200',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description:
      '1/1\n\nIf parties specify the Day Count Fraction to be 1/1 then in calculating the applicable amount, 1 is simply input into the calculation as the relevant Day Count Fraction. See also 2006 ISDA Definitions, Section 4.16. Day Count Fraction, paragraph (a).',
  },
  {
    name: 'ThirtyThreeSixtyUS',
    id: '1950002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.Latest',
    updatedEP: '266',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description: "30/360 (30U/360 or Bond Basis)\n\nSee also ISO 15022 MICO code 'A001'.",
  },
  {
    name: 'ThirtyThreeSixtySIA',
    id: '1950003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description:
      '30/360 (SIA)\n\nA variant of "30/360" - when Date1 and Date2 are both Feb. 28th or 29th convert them to 30th using the same logic in the conversion of 31st to 30th.',
  },
  {
    name: 'ThirtyThreeSixtyM',
    id: '1950004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description:
      '30/360M\n\nCommonly used day count convention for US mortgage backed securities. Feb 28th (or 29th in a leap year) is always considered as a 30th for a start date. As a comparison, in the regular 30/360 day count as used by most US agency and corporate bonds, a start date of Feb 28th (or 29th in a leap year) is still considered as the 28th (or 29th) day of a month of 30 days.',
  },
  {
    name: 'ThirtyEThreeSixty',
    id: '1950005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description: "30E/360 (Eurobond Basis)\n\nSee also ISO 15022 MICO code 'A007'.",
  },
  {
    name: 'ThirtyEThreeSixtyISDA',
    id: '1950006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '200',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description:
      '30E/360 (ISDA)\n\nDate adjustment rules are: (1) if Date1 is the last day of the month, then change Date1 to 30; (2) if D2 is the last day of the month (unless Date2 is the maturity date and Date2 is in February), then change Date2 to 30. See also 2006 ISDA Definitions, Section 4.16. Day Count Fraction, paragraph (h).',
  },
  {
    name: 'ActThreeSixty',
    id: '1950007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description: "Act/360\n\nSee also ISO 15022 MICO code 'A004'.",
  },
  {
    name: 'ActThreeSixtyFiveFixed',
    id: '1950008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description: "Act/365 (FIXED)\n\nSee also ISO 15022 MICO code 'A005'.",
  },
  {
    name: 'ActActAFB',
    id: '1950009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description: "Act/Act (AFB)\n\nSee also ISO 15022 MICO code 'A010'.",
  },
  {
    name: 'ActActICMA',
    id: '1950010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description: "Act/Act (ICMA)\n\nSee also ISO 15022 MICO code 'A006'.",
  },
  {
    name: 'ActActISMAUltimo',
    id: '1950011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description:
      'Act/Act (ICMA Ultimo)\n\nThe Act/Act (ICMA Ultimo) differs from Act/Act (ICMA) method only that it assumes that regular coupons always fall on the last day of the month.',
  },
  {
    name: 'ActActISDA',
    id: '1950012',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description: "Act/Act (ISDA)\n\nSee also ISO 15022 MICO code 'A008'.",
  },
  {
    name: 'BusTwoFiftyTwo',
    id: '1950013',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '200',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description:
      'BUS/252\n\nUsed for Brazilian Real swaps, which is based on business days instead of calendar days. The number of business days divided by 252.',
  },
  {
    name: 'ThirtyEPlusThreeSixty',
    id: '1950014',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description:
      '30E+/360\n\nVariation on 30E/360. Date adjustment rules: (1) If Date1 falls on the 31st, then change it to the 30th; (2) If Date2 falls on the 31st, then change it to 1 and increase Month2 by one, i.e. next month.',
  },
  {
    name: 'ActThreeSixtyFiveL',
    id: '1950015',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description: "Act/365L\n\nSee also ISO 15022 MICO code 'A009'.",
  },
  {
    name: 'NLThreeSixtyFive',
    id: '1950016',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description: "NL365\n\nSee also ISO 15022 MICO code 'A014'.",
  },
  {
    name: 'NLThreeSixty',
    id: '1950017',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description:
      'NL360\n\nThis is the same as Act/360, with the exception of leap days (29th February) which are ignored.',
  },
  {
    name: 'Act364',
    id: '1950018',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '200',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description:
      'Act/364\n\nThe actual number of days between Date1 and Date2, divided by 364.',
  },
  {
    name: 'ThirtyThreeSixtyFive',
    id: '1950019',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description:
      "30/365\n\nInterest is calculated based on a 30-day month in a way similar to the 30/360 (basic rule) and a 365-day year. Accrued interest to a value date on the last day of a month shall be the same as to the 30th calendar day of the same month, except for February. This means that a 31 is assumed to be a 30 and the 28 February (or 29 February for a leap year) is assumed to be a 28 (or 29). See also ISO 15022 MICO code 'A002'.",
  },
  {
    name: 'ThirtyActual',
    id: '1950020',
    value: '19',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description:
      "30/Actual\n\nInterest is calculated based on a 30-day month in a way similar to the 30/360 (basic rule) and the assumed number of days in a year in a way similar to the Actual/Actual (ICMA). Accrued interest to a value date on the last day of a month shall be the same as to the 30th calendar day of the same month, except for February. This means that a 31 is assumed to be a 30 and the 28 February (or 29 February for a leap year) is assumed to be a 28 (or 29). The assumed number of days in a year is computed as the actual number of days in the coupon period multiplied by the number of interest payments in the year. See also ISO 15022 MICO code 'A003'.",
  },
  {
    name: 'ThirtyThreeSixtyICMA',
    id: '1950021',
    value: '20',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description:
      "30/360 (ICMA or basis rule)\n\nInterest is calculated based on a 30-day month and a 360-day year. Accrued interest to a value date on the last day of a month shall be the same as to the 30 calendar day of the same month, except for February. This means that a 31 is assumed to be a 30 and the 28 February (or 29 February for a leap year) is assumed to be a 28 (or 29). It is the most commonly used 30/360 method for non-US straight and convertible bonds issued before 1 January 1999. See also ISO 15022 MICO code 'A011'.",
  },
  {
    name: 'ThirtyETwoThreeSixty',
    id: '1950022',
    value: '21',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description:
      "30E2/360 (Eurobond basis model two)\n\nInterest is calculated based on a 30-day month and a 360-day year. Accrued interest to a value date on the last day of a month shall be the same as to the 30th calendar day of the same month, except for the last day of February whose day of the month value shall be adapted to the value of the first day of the interest period if the latter is higher and if the period is one of a regular schedule. This means that a 31 is assumed to be a 30 and the 28 February of a non-leap year is assumed to be equivalent to a 29 February when the first day of the interest period is a 29, or to a 30 February when the first day of the interest period is a 30 or a 31. The 29 February of a leap year is assumed to be equivalent to a 30 February when the first day of the interest period is a 30 or a 31. Similarly, if the coupon period starts on the last day of February, it is assumed to produce only one day of interest in February as if it was starting on a 30 February when the end of the period is a 30 or a 31, or two days of interest in February when the end of the period is a 29, or three days of interest in February when it is the 28 February of a non-leap year and the end of the period is before the 29. See also ISO 15022 MICO code 'A012'.",
  },
  {
    name: 'ThirtyEThreeThreeSixty',
    id: '1950023',
    value: '22',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description:
      "30E3/360 (Eurobond basis model three)\n\nInterest is calculated based on a 30-day month and a 360-day year. Accrued interest to a value date on the last day of a month shall be the same as to the 30th calendar day of the same month. This means that a 31 is assumed to be a 30 and the 28 February (or 29 February for a leap year) is assumed to be equivalent to a 30 February. It is a variation of the 30E/360 (or Eurobond basis) method where the last day of February is always assumed to be a 30, even if it is the last day of the maturity coupon period. See also ISO 15022 MICO code 'A013'.",
  },
  {
    name: 'Other',
    id: '1950024',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 1950,
    type: 'int',
    codeSet: 'CouponDayCountCodeSet',
    description:
      "Other\n\nFor other day count method. See also ISO 15022 MICO code 'OTHR'.",
  },
  {
    name: 'Unknown',
    id: '1954001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1954,
    type: 'int',
    codeSet: 'LienSeniorityCodeSet',
    description: 'Unknown',
  },
  {
    name: 'FirstLien',
    id: '1954002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1954,
    type: 'int',
    codeSet: 'LienSeniorityCodeSet',
    description: 'First lien',
  },
  {
    name: 'SecondLien',
    id: '1954003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1954,
    type: 'int',
    codeSet: 'LienSeniorityCodeSet',
    description: 'Second lien',
  },
  {
    name: 'ThirdLien',
    id: '1954004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1954,
    type: 'int',
    codeSet: 'LienSeniorityCodeSet',
    description: 'Third lien',
  },
  {
    name: 'BridgeLoan',
    id: '1955001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1955,
    type: 'int',
    codeSet: 'LoanFacilityCodeSet',
    description: 'Bridge loan',
  },
  {
    name: 'LetterOfCredit',
    id: '1955002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1955,
    type: 'int',
    codeSet: 'LoanFacilityCodeSet',
    description: 'Letter of credit',
  },
  {
    name: 'RevolvingLoan',
    id: '1955003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1955,
    type: 'int',
    codeSet: 'LoanFacilityCodeSet',
    description: 'Revolving loan',
  },
  {
    name: 'SwinglineFunding',
    id: '1955004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1955,
    type: 'int',
    codeSet: 'LoanFacilityCodeSet',
    description: 'Swingline funding',
  },
  {
    name: 'TermLoan',
    id: '1955005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1955,
    type: 'int',
    codeSet: 'LoanFacilityCodeSet',
    description: 'Term loan',
  },
  {
    name: 'TradeClaim',
    id: '1955006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1955,
    type: 'int',
    codeSet: 'LoanFacilityCodeSet',
    description: 'Trade claim',
  },
  {
    name: 'Asian',
    id: '1956001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1956,
    type: 'int',
    codeSet: 'ReferenceEntityTypeCodeSet',
    description: 'Asian',
  },
  {
    name: 'AustralianNewZealand',
    id: '1956002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1956,
    type: 'int',
    codeSet: 'ReferenceEntityTypeCodeSet',
    description: 'Australian and New Zealand',
  },
  {
    name: 'EuropeanEmergingMarkets',
    id: '1956003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1956,
    type: 'int',
    codeSet: 'ReferenceEntityTypeCodeSet',
    description: 'European emerging markets',
  },
  {
    name: 'Japanese',
    id: '1956004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1956,
    type: 'int',
    codeSet: 'ReferenceEntityTypeCodeSet',
    description: 'Japanese',
  },
  {
    name: 'NorthAmericanHighYield',
    id: '1956005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1956,
    type: 'int',
    codeSet: 'ReferenceEntityTypeCodeSet',
    description: 'North American high yield',
  },
  {
    name: 'NorthAmericanInsurance',
    id: '1956006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1956,
    type: 'int',
    codeSet: 'ReferenceEntityTypeCodeSet',
    description: 'North American insurance',
  },
  {
    name: 'NorthAmericanInvestmentGrade',
    id: '1956007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1956,
    type: 'int',
    codeSet: 'ReferenceEntityTypeCodeSet',
    description: 'North American investment grade',
  },
  {
    name: 'Singaporean',
    id: '1956008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1956,
    type: 'int',
    codeSet: 'ReferenceEntityTypeCodeSet',
    description: 'Singaporean',
  },
  {
    name: 'WesternEuropean',
    id: '1956009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1956,
    type: 'int',
    codeSet: 'ReferenceEntityTypeCodeSet',
    description: 'Western European',
  },
  {
    name: 'WesternEuropeanInsurance',
    id: '1956010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1956,
    type: 'int',
    codeSet: 'ReferenceEntityTypeCodeSet',
    description: 'Western European insurance',
  },
  {
    name: 'BlockToBeAllocated',
    id: '1980001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1980,
    type: 'int',
    codeSet: 'BlockTrdAllocIndicatorCodeSet',
    description: 'Block to be allocated',
  },
  {
    name: 'BlockNotToBeAllocated',
    id: '1980002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1980,
    type: 'int',
    codeSet: 'BlockTrdAllocIndicatorCodeSet',
    description: 'Block not to be allocated',
  },
  {
    name: 'AllocatedTrade',
    id: '1980003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 1980,
    type: 'int',
    codeSet: 'BlockTrdAllocIndicatorCodeSet',
    description: 'Allocated trade\n\nA sub-trade of a block trade.',
  },
  {
    name: 'Bond',
    id: '2012001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 2012,
    type: 'String',
    codeSet: 'UnderlyingObligationTypeCodeSet',
    description: 'Bond',
  },
  {
    name: 'ConvertibleBond',
    id: '2012002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 2012,
    type: 'String',
    codeSet: 'UnderlyingObligationTypeCodeSet',
    description: 'Convertible bond',
  },
  {
    name: 'Mortgage',
    id: '2012003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 2012,
    type: 'String',
    codeSet: 'UnderlyingObligationTypeCodeSet',
    description: 'Mortgage',
  },
  {
    name: 'Loan',
    id: '2012004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 2012,
    type: 'String',
    codeSet: 'UnderlyingObligationTypeCodeSet',
    description: 'Loan',
  },
  {
    name: 'Bid',
    id: '40027001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40027,
    type: 'int',
    codeSet: 'CashSettlQuoteMethodCodeSet',
    description: 'Bid',
  },
  {
    name: 'Mid',
    id: '40027002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40027,
    type: 'int',
    codeSet: 'CashSettlQuoteMethodCodeSet',
    description: 'Mid',
  },
  {
    name: 'Offer',
    id: '40027003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40027,
    type: 'int',
    codeSet: 'CashSettlQuoteMethodCodeSet',
    description: 'Offer',
  },
  {
    name: 'Market',
    id: '40038001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40038,
    type: 'int',
    codeSet: 'CashSettlValuationMethodCodeSet',
    description: 'Market',
  },
  {
    name: 'Highest',
    id: '40038002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40038,
    type: 'int',
    codeSet: 'CashSettlValuationMethodCodeSet',
    description: 'Highest',
  },
  {
    name: 'AverageMarket',
    id: '40038003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40038,
    type: 'int',
    codeSet: 'CashSettlValuationMethodCodeSet',
    description: 'Average market',
  },
  {
    name: 'AverageHighest',
    id: '40038004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40038,
    type: 'int',
    codeSet: 'CashSettlValuationMethodCodeSet',
    description: 'Average highest',
  },
  {
    name: 'BlendedMarket',
    id: '40038005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40038,
    type: 'int',
    codeSet: 'CashSettlValuationMethodCodeSet',
    description: 'Blended market',
  },
  {
    name: 'BlendedHighest',
    id: '40038006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40038,
    type: 'int',
    codeSet: 'CashSettlValuationMethodCodeSet',
    description: 'Blended highest',
  },
  {
    name: 'AverageBlendedMarket',
    id: '40038007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40038,
    type: 'int',
    codeSet: 'CashSettlValuationMethodCodeSet',
    description: 'Average blended market',
  },
  {
    name: 'AverageBlendedHighest',
    id: '40038008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40038,
    type: 'int',
    codeSet: 'CashSettlValuationMethodCodeSet',
    description: 'Average blended highest',
  },
  {
    name: 'PaymentCashSettlement',
    id: '40050001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40050,
    type: 'int',
    codeSet: 'StreamTypeCodeSet',
    description: 'Payment / cash settlement',
  },
  {
    name: 'PhysicalDelivery',
    id: '40050002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40050,
    type: 'int',
    codeSet: 'StreamTypeCodeSet',
    description: 'Physical delivery',
  },
  {
    name: 'MandatoryEarlyTermination',
    id: '40091001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40091,
    type: 'int',
    codeSet: 'ProvisionTypeCodeSet',
    description: 'Mandatory early termination',
  },
  {
    name: 'OptionalEarlyTermination',
    id: '40091002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40091,
    type: 'int',
    codeSet: 'ProvisionTypeCodeSet',
    description: 'Optional early termination',
  },
  {
    name: 'Cancelable',
    id: '40091003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40091,
    type: 'int',
    codeSet: 'ProvisionTypeCodeSet',
    description: 'Cancelable',
  },
  {
    name: 'Extendable',
    id: '40091004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '254',
    tag: 40091,
    type: 'int',
    codeSet: 'ProvisionTypeCodeSet',
    description:
      'Extendable\n\nThe contract can be extended by either party usually with a specific time notice prior to the expiry date. In the context of EU SFTR reporting this corresponds to "termination optionality" code "ETSB".',
  },
  {
    name: 'MutualEarlyTermination',
    id: '40091005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 40091,
    type: 'int',
    codeSet: 'ProvisionTypeCodeSet',
    description: 'Mutual early termination',
  },
  {
    name: 'Evergreen',
    id: '40091006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 40091,
    type: 'int',
    codeSet: 'ProvisionTypeCodeSet',
    description:
      'Evergreen\n\nThe contract automatically renews after the expiry date until one party gives the other notice to terminate. In the context of EU SFTR reporting this corresponds to "termination optionality" code "EGRN".',
  },
  {
    name: 'Callable',
    id: '40091007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 40091,
    type: 'int',
    codeSet: 'ProvisionTypeCodeSet',
    description: 'Callable\n\nContract is callable.',
  },
  {
    name: 'Puttable',
    id: '40091008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 40091,
    type: 'int',
    codeSet: 'ProvisionTypeCodeSet',
    description: 'Puttable\n\nContract is puttable.',
  },
  {
    name: 'Day',
    id: '40097001',
    value: 'D',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40097,
    type: 'String',
    codeSet: 'ProvisionDateTenorUnitCodeSet',
    description: 'Day',
  },
  {
    name: 'Week',
    id: '40097002',
    value: 'Wk',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40097,
    type: 'String',
    codeSet: 'ProvisionDateTenorUnitCodeSet',
    description: 'Week',
  },
  {
    name: 'Month',
    id: '40097003',
    value: 'Mo',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40097,
    type: 'String',
    codeSet: 'ProvisionDateTenorUnitCodeSet',
    description: 'Month',
  },
  {
    name: 'Year',
    id: '40097004',
    value: 'Yr',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40097,
    type: 'String',
    codeSet: 'ProvisionDateTenorUnitCodeSet',
    description: 'Year',
  },
  {
    name: 'ExercisingParty',
    id: '40098001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40098,
    type: 'int',
    codeSet: 'ProvisionCalculationAgentCodeSet',
    description: 'Exercising party',
  },
  {
    name: 'NonExercisingParty',
    id: '40098002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40098,
    type: 'int',
    codeSet: 'ProvisionCalculationAgentCodeSet',
    description: 'Non-exercising party',
  },
  {
    name: 'MasterAgreeent',
    id: '40098003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40098,
    type: 'int',
    codeSet: 'ProvisionCalculationAgentCodeSet',
    description: 'As specified in the master agreement',
  },
  {
    name: 'Supplement',
    id: '40098004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40098,
    type: 'int',
    codeSet: 'ProvisionCalculationAgentCodeSet',
    description: 'As specified in the standard terms supplement',
  },
  {
    name: 'Buy',
    id: '40099001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40099,
    type: 'int',
    codeSet: 'ProvisionOptionSinglePartyBuyerSideCodeSet',
    description: 'Buy',
  },
  {
    name: 'Sell',
    id: '40099002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40099,
    type: 'int',
    codeSet: 'ProvisionOptionSinglePartyBuyerSideCodeSet',
    description: 'Sell',
  },
  {
    name: 'CashPrice',
    id: '40108001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40108,
    type: 'int',
    codeSet: 'ProvisionCashSettlMethodCodeSet',
    description: 'Cash price',
  },
  {
    name: 'CashPriceAlternate',
    id: '40108002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40108,
    type: 'int',
    codeSet: 'ProvisionCashSettlMethodCodeSet',
    description: 'Cash price alternate',
  },
  {
    name: 'ParYieldCurveAdjusted',
    id: '40108003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40108,
    type: 'int',
    codeSet: 'ProvisionCashSettlMethodCodeSet',
    description: 'Par yield curve adjusted',
  },
  {
    name: 'ZeroCouponYieldCurveAdjusted',
    id: '40108004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40108,
    type: 'int',
    codeSet: 'ProvisionCashSettlMethodCodeSet',
    description: 'Zero coupon yield curve adjusted',
  },
  {
    name: 'ParYieldCurveUnadjusted',
    id: '40108005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40108,
    type: 'int',
    codeSet: 'ProvisionCashSettlMethodCodeSet',
    description: 'Par yield curve unadjusted',
  },
  {
    name: 'CrossCurrency',
    id: '40108006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40108,
    type: 'int',
    codeSet: 'ProvisionCashSettlMethodCodeSet',
    description: 'Cross currency',
  },
  {
    name: 'CollateralizedPrice',
    id: '40108007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40108,
    type: 'int',
    codeSet: 'ProvisionCashSettlMethodCodeSet',
    description: 'Collateralized price',
  },
  {
    name: 'Bid',
    id: '40111001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40111,
    type: 'int',
    codeSet: 'ProvisionCashSettlQuoteTypeCodeSet',
    description: 'Bid',
  },
  {
    name: 'Mid',
    id: '40111002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40111,
    type: 'int',
    codeSet: 'ProvisionCashSettlQuoteTypeCodeSet',
    description: 'Mid',
  },
  {
    name: 'Offer',
    id: '40111003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40111,
    type: 'int',
    codeSet: 'ProvisionCashSettlQuoteTypeCodeSet',
    description: 'Offer',
  },
  {
    name: 'ExercisingPartyPays',
    id: '40111004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40111,
    type: 'int',
    codeSet: 'ProvisionCashSettlQuoteTypeCodeSet',
    description:
      'Exercising party pays\n\nSee 2000 ISDA Definitions, Section 17.2, Certain Definitions Relating to Cash Settlement, paragraph (j) for definition of "exercising party pays".',
  },
  {
    name: 'Day',
    id: '40126001',
    value: 'D',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40126,
    type: 'String',
    codeSet: 'ProvisionOptionExerciseEarliestDateOffsetUnitCodeSet',
    description: 'Day',
  },
  {
    name: 'Week',
    id: '40126002',
    value: 'Wk',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40126,
    type: 'String',
    codeSet: 'ProvisionOptionExerciseEarliestDateOffsetUnitCodeSet',
    description: 'Week',
  },
  {
    name: 'Month',
    id: '40126003',
    value: 'Mo',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40126,
    type: 'String',
    codeSet: 'ProvisionOptionExerciseEarliestDateOffsetUnitCodeSet',
    description: 'Month',
  },
  {
    name: 'Year',
    id: '40126004',
    value: 'Yr',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40126,
    type: 'String',
    codeSet: 'ProvisionOptionExerciseEarliestDateOffsetUnitCodeSet',
    description: 'Year',
  },
  {
    name: 'Unadjusted',
    id: '40144001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40144,
    type: 'int',
    codeSet: 'ProvisionOptionExerciseFixedDateTypeCodeSet',
    description: 'Unadjusted',
  },
  {
    name: 'Adjusted',
    id: '40144002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40144,
    type: 'int',
    codeSet: 'ProvisionOptionExerciseFixedDateTypeCodeSet',
    description: 'Adjusted',
  },
  {
    name: 'Unadjusted',
    id: '40173001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40173,
    type: 'int',
    codeSet: 'ProvisionCashSettlPaymentDateTypeCodeSet',
    description: 'Unadjusted',
  },
  {
    name: 'Adjusted',
    id: '40173002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40173,
    type: 'int',
    codeSet: 'ProvisionCashSettlPaymentDateTypeCodeSet',
    description: 'Adjusted',
  },
  {
    name: 'Day',
    id: '40196001',
    value: 'D',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40196,
    type: 'String',
    codeSet: 'ProtectionTermEventUnitCodeSet',
    description: 'Day',
  },
  {
    name: 'Week',
    id: '40196002',
    value: 'Wk',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40196,
    type: 'String',
    codeSet: 'ProtectionTermEventUnitCodeSet',
    description: 'Week',
  },
  {
    name: 'Month',
    id: '40196003',
    value: 'Mo',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40196,
    type: 'String',
    codeSet: 'ProtectionTermEventUnitCodeSet',
    description: 'Month',
  },
  {
    name: 'Year',
    id: '40196004',
    value: 'Yr',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40196,
    type: 'String',
    codeSet: 'ProtectionTermEventUnitCodeSet',
    description: 'Year',
  },
  {
    name: 'Business',
    id: '40197001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40197,
    type: 'int',
    codeSet: 'ProtectionTermEventDayTypeCodeSet',
    description: 'Business',
  },
  {
    name: 'Calendar',
    id: '40197002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40197,
    type: 'int',
    codeSet: 'ProtectionTermEventDayTypeCodeSet',
    description: 'Calendar',
  },
  {
    name: 'CommodityBusiness',
    id: '40197003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40197,
    type: 'int',
    codeSet: 'ProtectionTermEventDayTypeCodeSet',
    description: 'Commodity business',
  },
  {
    name: 'CurrencyBusiness',
    id: '40197004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40197,
    type: 'int',
    codeSet: 'ProtectionTermEventDayTypeCodeSet',
    description: 'Currency business',
  },
  {
    name: 'ExchangeBusiness',
    id: '40197005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40197,
    type: 'int',
    codeSet: 'ProtectionTermEventDayTypeCodeSet',
    description: 'Exchange business',
  },
  {
    name: 'ScheduledTradingDay',
    id: '40197006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40197,
    type: 'int',
    codeSet: 'ProtectionTermEventDayTypeCodeSet',
    description: 'Scheduled trading day',
  },
  {
    name: 'RestructuringMultipleHoldingObligations',
    id: '40200001',
    value: 'H',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40200,
    type: 'char',
    codeSet: 'ProtectionTermEventQualifierCodeSet',
    description:
      'Retructuring - multiple holding obligations\n\nIn relation to a restructuring credit event, unless multiple holder obligation is not specified restructurings are limited to multiple holder obligations. A multiple holder obligation means an obligation that is held by more than three holders that are not affiliates of each other and where at least two thirds of the holders must agree to the event that constitutes the restructuring credit event. ISDA 2003 Term: Multiple Holder Obligation.',
  },
  {
    name: 'RestructuringMultipleCreditEventNotices',
    id: '40200002',
    value: 'E',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40200,
    type: 'char',
    codeSet: 'ProtectionTermEventQualifierCodeSet',
    description:
      "Restructuring - multiple credit event notices\n\nPresence of this element and value set to 'true' indicates that Section 3.9 of the 2003 Credit Derivatives Definitions shall apply. Absence of this element indicates that Section 3.9 shall not apply. NOTE: Not allowed under ISDA Credit 1999.",
  },
  {
    name: 'FloatingRateInterestShortfall',
    id: '40200003',
    value: 'C',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40200,
    type: 'char',
    codeSet: 'ProtectionTermEventQualifierCodeSet',
    description: 'Floating rate interest shortfall\n\nIndicates compounding.',
  },
  {
    name: 'Brokerage',
    id: '40213001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40213,
    type: 'int',
    codeSet: 'PaymentTypeCodeSet',
    description: 'Brokerage',
  },
  {
    name: 'UpfrontFee',
    id: '40213002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40213,
    type: 'int',
    codeSet: 'PaymentTypeCodeSet',
    description: 'Upfront fee',
  },
  {
    name: 'IndependentAmountCollateral',
    id: '40213003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40213,
    type: 'int',
    codeSet: 'PaymentTypeCodeSet',
    description: 'Independent amount / collateral',
  },
  {
    name: 'PrincipalExchange',
    id: '40213004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40213,
    type: 'int',
    codeSet: 'PaymentTypeCodeSet',
    description: 'Principal exchange',
  },
  {
    name: 'NovationTermination',
    id: '40213005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40213,
    type: 'int',
    codeSet: 'PaymentTypeCodeSet',
    description: 'Novation / termination',
  },
  {
    name: 'EarlyTerminationProvision',
    id: '40213006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40213,
    type: 'int',
    codeSet: 'PaymentTypeCodeSet',
    description: 'Early termination provision',
  },
  {
    name: 'CancelableProvision',
    id: '40213007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '203',
    tag: 40213,
    type: 'int',
    codeSet: 'PaymentTypeCodeSet',
    description: 'Cancelable provision',
  },
  {
    name: 'ExtendibleProvision',
    id: '40213008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40213,
    type: 'int',
    codeSet: 'PaymentTypeCodeSet',
    description: 'Extendible provision',
  },
  {
    name: 'CapRateProvision',
    id: '40213009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40213,
    type: 'int',
    codeSet: 'PaymentTypeCodeSet',
    description: 'Cap rate provision',
  },
  {
    name: 'FloorRateProvision',
    id: '40213010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40213,
    type: 'int',
    codeSet: 'PaymentTypeCodeSet',
    description: 'Floor rate provision',
  },
  {
    name: 'OptionPremium',
    id: '40213011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40213,
    type: 'int',
    codeSet: 'PaymentTypeCodeSet',
    description: 'Option premium',
  },
  {
    name: 'SettlementPayment',
    id: '40213012',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '162',
    tag: 40213,
    type: 'int',
    codeSet: 'PaymentTypeCodeSet',
    description: 'Settlement payment',
  },
  {
    name: 'CashSettl',
    id: '40213013',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 40213,
    type: 'int',
    codeSet: 'PaymentTypeCodeSet',
    description: 'Cash settlement',
  },
  {
    name: 'SecurityLending',
    id: '40213014',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 40213,
    type: 'int',
    codeSet: 'PaymentTypeCodeSet',
    description:
      'Security lending\n\nFee that the borrower of the security or commodity pays to the lender. The basis rate is specified in PaymentFixedRate(43097). A security lending fee payment may be periodic, in which case specify PaymentFrequencyPeriod(43102) and PaymentFrequencyUnit(43103).',
  },
  {
    name: 'Rebate',
    id: '40213015',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 40213,
    type: 'int',
    codeSet: 'PaymentTypeCodeSet',
    description:
      'Rebate\n\nFor contracts calling for rebate payment(s), e.g. Securities Lending, normally specified as a fixed or floating rate rather than a fixed amount. A rebate payment may be periodic, in which case specify PaymentFrequencyPeriod(43102) and PaymentFrequencyUnit(43103).',
  },
  {
    name: 'Other',
    id: '40213016',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40213,
    type: 'int',
    codeSet: 'PaymentTypeCodeSet',
    description: 'Other',
  },
  {
    name: 'Buy',
    id: '40214001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40214,
    type: 'int',
    codeSet: 'PaymentPaySideCodeSet',
    description: 'Buy',
  },
  {
    name: 'Sell',
    id: '40214002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40214,
    type: 'int',
    codeSet: 'PaymentPaySideCodeSet',
    description: 'Sell',
  },
  {
    name: 'Standard',
    id: '40227001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40227,
    type: 'int',
    codeSet: 'PaymentSettlStyleCodeSet',
    description: 'Standard',
  },
  {
    name: 'Net',
    id: '40227002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40227,
    type: 'int',
    codeSet: 'PaymentSettlStyleCodeSet',
    description: 'Net',
  },
  {
    name: 'StandardfNet',
    id: '40227003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40227,
    type: 'int',
    codeSet: 'PaymentSettlStyleCodeSet',
    description: 'Standard and net',
  },
  {
    name: 'Periodic',
    id: '40738001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40738,
    type: 'int',
    codeSet: 'PaymentStreamTypeCodeSet',
    description: 'Periodic (default)',
  },
  {
    name: 'Initial',
    id: '40738002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40738,
    type: 'int',
    codeSet: 'PaymentStreamTypeCodeSet',
    description: 'Initial',
  },
  {
    name: 'Single',
    id: '40738003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40738,
    type: 'int',
    codeSet: 'PaymentStreamTypeCodeSet',
    description: 'Single',
  },
  {
    name: 'Dividend',
    id: '40738004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 40738,
    type: 'int',
    codeSet: 'PaymentStreamTypeCodeSet',
    description: 'Dividend',
  },
  {
    name: 'Interest',
    id: '40738005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 40738,
    type: 'int',
    codeSet: 'PaymentStreamTypeCodeSet',
    description: 'Interest',
  },
  {
    name: 'DividendReturn',
    id: '40738006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 40738,
    type: 'int',
    codeSet: 'PaymentStreamTypeCodeSet',
    description: 'Dividend return',
  },
  {
    name: 'PriceReturn',
    id: '40738007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 40738,
    type: 'int',
    codeSet: 'PaymentStreamTypeCodeSet',
    description: 'Price return',
  },
  {
    name: 'TotalReturn',
    id: '40738008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 40738,
    type: 'int',
    codeSet: 'PaymentStreamTypeCodeSet',
    description: 'Total return',
  },
  {
    name: 'Variance',
    id: '40738009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 40738,
    type: 'int',
    codeSet: 'PaymentStreamTypeCodeSet',
    description: 'Variance',
  },
  {
    name: 'Correlation',
    id: '40738010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 40738,
    type: 'int',
    codeSet: 'PaymentStreamTypeCodeSet',
    description: 'Correlation',
  },
  {
    name: 'Standard',
    id: '40744001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40744,
    type: 'int',
    codeSet: 'PaymentStreamDiscountTypeCodeSet',
    description: 'Standard',
  },
  {
    name: 'FRA',
    id: '40744002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 40744,
    type: 'int',
    codeSet: 'PaymentStreamDiscountTypeCodeSet',
    description: 'Forward Rate Agreement (FRA)',
  },
  {
    name: 'None',
    id: '40747001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40747,
    type: 'int',
    codeSet: 'PaymentStreamCompoundingMethodCodeSet',
    description: 'None',
  },
  {
    name: 'Flat',
    id: '40747002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40747,
    type: 'int',
    codeSet: 'PaymentStreamCompoundingMethodCodeSet',
    description: 'Flat',
  },
  {
    name: 'Straight',
    id: '40747003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40747,
    type: 'int',
    codeSet: 'PaymentStreamCompoundingMethodCodeSet',
    description: 'Straight',
  },
  {
    name: 'SpreadExclusive',
    id: '40747004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40747,
    type: 'int',
    codeSet: 'PaymentStreamCompoundingMethodCodeSet',
    description: 'Spread exclusive',
  },
  {
    name: 'Day',
    id: '40754001',
    value: 'D',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40754,
    type: 'String',
    codeSet: 'PaymentStreamPaymentFrequencyUnitCodeSet',
    description: 'Day',
  },
  {
    name: 'Week',
    id: '40754002',
    value: 'Wk',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40754,
    type: 'String',
    codeSet: 'PaymentStreamPaymentFrequencyUnitCodeSet',
    description: 'Week',
  },
  {
    name: 'Month',
    id: '40754003',
    value: 'Mo',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40754,
    type: 'String',
    codeSet: 'PaymentStreamPaymentFrequencyUnitCodeSet',
    description: 'Month',
  },
  {
    name: 'Year',
    id: '40754004',
    value: 'Yr',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40754,
    type: 'String',
    codeSet: 'PaymentStreamPaymentFrequencyUnitCodeSet',
    description: 'Year',
  },
  {
    name: 'Term',
    id: '40754005',
    value: 'T',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40754,
    type: 'String',
    codeSet: 'PaymentStreamPaymentFrequencyUnitCodeSet',
    description: 'Term',
  },
  {
    name: 'Day',
    id: '40760001',
    value: 'D',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40760,
    type: 'String',
    codeSet: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    description: 'Day',
  },
  {
    name: 'Week',
    id: '40760002',
    value: 'Wk',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40760,
    type: 'String',
    codeSet: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    description: 'Week',
  },
  {
    name: 'Month',
    id: '40760003',
    value: 'Mo',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40760,
    type: 'String',
    codeSet: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    description: 'Month',
  },
  {
    name: 'Year',
    id: '40760004',
    value: 'Yr',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40760,
    type: 'String',
    codeSet: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    description: 'Year',
  },
  {
    name: 'Monday',
    id: '40766001',
    value: 'MON',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40766,
    type: 'String',
    codeSet: 'PaymentStreamResetWeeklyRollConventionCodeSet',
    description: 'Monday',
  },
  {
    name: 'Tuesday',
    id: '40766002',
    value: 'TUE',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40766,
    type: 'String',
    codeSet: 'PaymentStreamResetWeeklyRollConventionCodeSet',
    description: 'Tuesday',
  },
  {
    name: 'Wednesday',
    id: '40766003',
    value: 'WED',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40766,
    type: 'String',
    codeSet: 'PaymentStreamResetWeeklyRollConventionCodeSet',
    description: 'Wednesday',
  },
  {
    name: 'Thursday',
    id: '40766004',
    value: 'THU',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40766,
    type: 'String',
    codeSet: 'PaymentStreamResetWeeklyRollConventionCodeSet',
    description: 'Thursday',
  },
  {
    name: 'Friday',
    id: '40766005',
    value: 'FRI',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40766,
    type: 'String',
    codeSet: 'PaymentStreamResetWeeklyRollConventionCodeSet',
    description: 'Friday',
  },
  {
    name: 'Saturday',
    id: '40766006',
    value: 'SAT',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40766,
    type: 'String',
    codeSet: 'PaymentStreamResetWeeklyRollConventionCodeSet',
    description: 'Saturday',
  },
  {
    name: 'Sunday',
    id: '40766007',
    value: 'SUN',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40766,
    type: 'String',
    codeSet: 'PaymentStreamResetWeeklyRollConventionCodeSet',
    description: 'Sunday',
  },
  {
    name: 'Bloomberg',
    id: '40790001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40790,
    type: 'int',
    codeSet: 'PaymentStreamRateIndexSourceCodeSet',
    description: 'Bloomberg',
  },
  {
    name: 'Reuters',
    id: '40790002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40790,
    type: 'int',
    codeSet: 'PaymentStreamRateIndexSourceCodeSet',
    description: 'Reuters',
  },
  {
    name: 'Telerate',
    id: '40790003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40790,
    type: 'int',
    codeSet: 'PaymentStreamRateIndexSourceCodeSet',
    description: 'Telerate',
  },
  {
    name: 'Other',
    id: '40790004',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40790,
    type: 'int',
    codeSet: 'PaymentStreamRateIndexSourceCodeSet',
    description: 'Other',
  },
  {
    name: 'Day',
    id: '40791001',
    value: 'D',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40791,
    type: 'String',
    codeSet: 'PaymentStreamRateIndexCurveUnitCodeSet',
    description: 'Day',
  },
  {
    name: 'Week',
    id: '40791002',
    value: 'Wk',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40791,
    type: 'String',
    codeSet: 'PaymentStreamRateIndexCurveUnitCodeSet',
    description: 'Week',
  },
  {
    name: 'Month',
    id: '40791003',
    value: 'Mo',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40791,
    type: 'String',
    codeSet: 'PaymentStreamRateIndexCurveUnitCodeSet',
    description: 'Month',
  },
  {
    name: 'Year',
    id: '40791004',
    value: 'Yr',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40791,
    type: 'String',
    codeSet: 'PaymentStreamRateIndexCurveUnitCodeSet',
    description: 'Year',
  },
  {
    name: 'Short',
    id: '40795001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40795,
    type: 'int',
    codeSet: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    description: 'Short',
  },
  {
    name: 'Long',
    id: '40795002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40795,
    type: 'int',
    codeSet: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    description: 'Long',
  },
  {
    name: 'BondEquivalentYield',
    id: '40796001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40796,
    type: 'int',
    codeSet: 'PaymentStreamRateTreatmentCodeSet',
    description: 'Bond equivalent yield',
  },
  {
    name: 'MoneyMarketYield',
    id: '40796002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40796,
    type: 'int',
    codeSet: 'PaymentStreamRateTreatmentCodeSet',
    description: 'Money market yield',
  },
  {
    name: 'Buyer',
    id: '40798001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40798,
    type: 'int',
    codeSet: 'PaymentStreamCapRateBuySideCodeSet',
    description: 'Buyer of the trade',
  },
  {
    name: 'Seller',
    id: '40798002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40798,
    type: 'int',
    codeSet: 'PaymentStreamCapRateBuySideCodeSet',
    description: 'Seller of the trade',
  },
  {
    name: 'Buyer',
    id: '40801001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40801,
    type: 'int',
    codeSet: 'PaymentStreamFloorRateBuySideCodeSet',
    description: 'Buyer of the trade',
  },
  {
    name: 'Seller',
    id: '40801002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40801,
    type: 'int',
    codeSet: 'PaymentStreamFloorRateBuySideCodeSet',
    description: 'Seller of the trade',
  },
  {
    name: 'Unweighted',
    id: '40806001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40806,
    type: 'int',
    codeSet: 'PaymentStreamAveragingMethodCodeSet',
    description: 'Unweighted',
  },
  {
    name: 'Weighted',
    id: '40806002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40806,
    type: 'int',
    codeSet: 'PaymentStreamAveragingMethodCodeSet',
    description: 'Weighted',
  },
  {
    name: 'ZeroInterestRateMethod',
    id: '40807001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40807,
    type: 'int',
    codeSet: 'PaymentStreamNegativeRateTreatmentCodeSet',
    description: 'Zero interest rate method',
  },
  {
    name: 'NegativeInterestRateMethod',
    id: '40807002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40807,
    type: 'int',
    codeSet: 'PaymentStreamNegativeRateTreatmentCodeSet',
    description: 'Negative interest rate method',
  },
  {
    name: 'Day',
    id: '40809001',
    value: 'D',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40809,
    type: 'String',
    codeSet: 'PaymentStreamInflationLagUnitCodeSet',
    description: 'Day',
  },
  {
    name: 'Week',
    id: '40809002',
    value: 'Wk',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40809,
    type: 'String',
    codeSet: 'PaymentStreamInflationLagUnitCodeSet',
    description: 'Week',
  },
  {
    name: 'Month',
    id: '40809003',
    value: 'Mo',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40809,
    type: 'String',
    codeSet: 'PaymentStreamInflationLagUnitCodeSet',
    description: 'Month',
  },
  {
    name: 'Year',
    id: '40809004',
    value: 'Yr',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40809,
    type: 'String',
    codeSet: 'PaymentStreamInflationLagUnitCodeSet',
    description: 'Year',
  },
  {
    name: 'Business',
    id: '40810001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40810,
    type: 'int',
    codeSet: 'PaymentStreamInflationLagDayTypeCodeSet',
    description: 'Business',
  },
  {
    name: 'Calendar',
    id: '40810002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40810,
    type: 'int',
    codeSet: 'PaymentStreamInflationLagDayTypeCodeSet',
    description: 'Calendar',
  },
  {
    name: 'CommodityBusiness',
    id: '40810003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40810,
    type: 'int',
    codeSet: 'PaymentStreamInflationLagDayTypeCodeSet',
    description: 'Commodity business',
  },
  {
    name: 'CurrencyBusiness',
    id: '40810004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40810,
    type: 'int',
    codeSet: 'PaymentStreamInflationLagDayTypeCodeSet',
    description: 'Currency business',
  },
  {
    name: 'ExchangeBusiness',
    id: '40810005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40810,
    type: 'int',
    codeSet: 'PaymentStreamInflationLagDayTypeCodeSet',
    description: 'Exchange business',
  },
  {
    name: 'ScheduledTradingDay',
    id: '40810006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40810,
    type: 'int',
    codeSet: 'PaymentStreamInflationLagDayTypeCodeSet',
    description: 'Scheduled trading day',
  },
  {
    name: 'None',
    id: '40811001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40811,
    type: 'int',
    codeSet: 'PaymentStreamInflationInterpolationMethodCodeSet',
    description: 'None',
  },
  {
    name: 'LinearZeroYield',
    id: '40811002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40811,
    type: 'int',
    codeSet: 'PaymentStreamInflationInterpolationMethodCodeSet',
    description: 'Linear zero yield',
  },
  {
    name: 'None',
    id: '40816001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40816,
    type: 'int',
    codeSet: 'PaymentStreamFRADiscountingCodeSet',
    description: 'None',
  },
  {
    name: 'ISDA',
    id: '40816002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40816,
    type: 'int',
    codeSet: 'PaymentStreamFRADiscountingCodeSet',
    description: 'International Swaps and Derivatives Association (ISDA)',
  },
  {
    name: 'AFMA',
    id: '40816003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40816,
    type: 'int',
    codeSet: 'PaymentStreamFRADiscountingCodeSet',
    description: 'Australian Financial Markets Association (AFMA)',
  },
  {
    name: 'Unadjusted',
    id: '40827001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40827,
    type: 'int',
    codeSet: 'NonDeliverableFixingDateTypeCodeSet',
    description: 'Unadjusted',
  },
  {
    name: 'Adjusted',
    id: '40827002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40827,
    type: 'int',
    codeSet: 'NonDeliverableFixingDateTypeCodeSet',
    description: 'Adjusted',
  },
  {
    name: 'Notional',
    id: '40829001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Notional',
  },
  {
    name: 'CashFlow',
    id: '40829002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Cash flow',
  },
  {
    name: 'FXLinkedNotional',
    id: '40829003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'FX linked notional',
  },
  {
    name: 'FixedRate',
    id: '40829004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Fixed rate',
  },
  {
    name: 'FutureValueNotional',
    id: '40829005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Future value notional',
  },
  {
    name: 'KnownAmount',
    id: '40829006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Known amount',
  },
  {
    name: 'FloatingRateMultiplier',
    id: '40829007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Floating rate multiplier',
  },
  {
    name: 'Spread',
    id: '40829008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Spread',
  },
  {
    name: 'CapRate',
    id: '40829009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Cap rate',
  },
  {
    name: 'FloorRate',
    id: '40829010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Floor rate',
  },
  {
    name: 'NonDeliverableSettlPaymentDates',
    id: '40829011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Non-deliverable settlement payment dates',
  },
  {
    name: 'NonDeliverableSettlCalculationDates',
    id: '40829012',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Non-deliverable settlement calculation dates',
  },
  {
    name: 'NonDeliverableFXFixingDates',
    id: '40829013',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Non-deliverable fixing dates.',
  },
  {
    name: 'SettlPeriodNotnl',
    id: '40829014',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Settlement period notional',
  },
  {
    name: 'SettlPeriodPx',
    id: '40829015',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Settlement period price',
  },
  {
    name: 'CalcPeriod',
    id: '40829016',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Calculation period',
  },
  {
    name: 'DividendAccrualRateMultiplier',
    id: '40829017',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Dividend accrual rate multiplier',
  },
  {
    name: 'DividendAccrualRateSpread',
    id: '40829018',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Dividend accrual rate spread',
  },
  {
    name: 'DividendAccrualCapRate',
    id: '40829019',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Dividend accrual cap rate',
  },
  {
    name: 'DividendAccrualFloorRate',
    id: '40829020',
    value: '19',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Dividend accrual floor rate',
  },
  {
    name: 'CompoundingRateMultiplier',
    id: '40829021',
    value: '20',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Compounding rate multiplier',
  },
  {
    name: 'CompoundingRateSpread',
    id: '40829022',
    value: '21',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Compounding rate spread',
  },
  {
    name: 'CompoundingCapRate',
    id: '40829023',
    value: '22',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Compounding cap rate',
  },
  {
    name: 'CompoundingFloorRate',
    id: '40829024',
    value: '23',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 40829,
    type: 'int',
    codeSet: 'PaymentScheduleTypeCodeSet',
    description: 'Compounding floor rate',
  },
  {
    name: 'Initial',
    id: '40849001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40849,
    type: 'int',
    codeSet: 'PaymentScheduleStepRelativeToCodeSet',
    description: 'Initial',
  },
  {
    name: 'Previous',
    id: '40849002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40849,
    type: 'int',
    codeSet: 'PaymentScheduleStepRelativeToCodeSet',
    description: 'Previous',
  },
  {
    name: 'Initial',
    id: '40873001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40873,
    type: 'int',
    codeSet: 'PaymentStubTypeCodeSet',
    description: 'Initial',
  },
  {
    name: 'Final',
    id: '40873002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40873,
    type: 'int',
    codeSet: 'PaymentStubTypeCodeSet',
    description: 'Final',
  },
  {
    name: 'CompoundingInitial',
    id: '40873003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 40873,
    type: 'int',
    codeSet: 'PaymentStubTypeCodeSet',
    description: 'Compounding initial',
  },
  {
    name: 'CompoundingFinal',
    id: '40873004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 40873,
    type: 'int',
    codeSet: 'PaymentStubTypeCodeSet',
    description: 'Compounding final',
  },
  {
    name: 'Short',
    id: '40874001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40874,
    type: 'int',
    codeSet: 'PaymentStubLengthCodeSet',
    description: 'Short',
  },
  {
    name: 'Long',
    id: '40874002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40874,
    type: 'int',
    codeSet: 'PaymentStubLengthCodeSet',
    description: 'Long',
  },
  {
    name: 'Business',
    id: '40920001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40920,
    type: 'int',
    codeSet: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    description: 'Business',
  },
  {
    name: 'Calendar',
    id: '40920002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40920,
    type: 'int',
    codeSet: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    description: 'Calendar',
  },
  {
    name: 'CommodityBusiness',
    id: '40920003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40920,
    type: 'int',
    codeSet: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    description: 'Commodity business',
  },
  {
    name: 'CurrencyBusiness',
    id: '40920004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40920,
    type: 'int',
    codeSet: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    description: 'Currency business',
  },
  {
    name: 'ExchangeBusiness',
    id: '40920005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40920,
    type: 'int',
    codeSet: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    description: 'Exchange business',
  },
  {
    name: 'ScheduledTradingDay',
    id: '40920006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40920,
    type: 'int',
    codeSet: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    description: 'Scheduled trading day',
  },
  {
    name: 'NotApplicable',
    id: '40921001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 40921,
    type: 'int',
    codeSet: 'BusinessDayConventionCodeSet',
    description: 'Not applicable\n\nBusiness day convention is not applicable.',
  },
  {
    name: 'None',
    id: '40921002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '195',
    tag: 40921,
    type: 'int',
    codeSet: 'BusinessDayConventionCodeSet',
    description: 'None (current day)',
  },
  {
    name: 'FollowingDay',
    id: '40921003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 40921,
    type: 'int',
    codeSet: 'BusinessDayConventionCodeSet',
    description: 'Following day\n\nThe following business day.',
  },
  {
    name: 'FloatingRateNote',
    id: '40921004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 40921,
    type: 'int',
    codeSet: 'BusinessDayConventionCodeSet',
    description: 'Floating rate note\n\nThe FRN business day convention.',
  },
  {
    name: 'ModifiedFollowingDay',
    id: '40921005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 40921,
    type: 'int',
    codeSet: 'BusinessDayConventionCodeSet',
    description: 'Modified following day\n\nThe modified following business day.',
  },
  {
    name: 'PrecedingDay',
    id: '40921006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 40921,
    type: 'int',
    codeSet: 'BusinessDayConventionCodeSet',
    description: 'Preceding day\n\nThe preceding business day.',
  },
  {
    name: 'ModifiedPrecedingDay',
    id: '40921007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 40921,
    type: 'int',
    codeSet: 'BusinessDayConventionCodeSet',
    description: 'Modified preceding day\n\nThe modified preceding business day.',
  },
  {
    name: 'NearestDay',
    id: '40921008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    updated: 'FIX.5.0SP2',
    updatedEP: '169',
    tag: 40921,
    type: 'int',
    codeSet: 'BusinessDayConventionCodeSet',
    description: 'Nearest day\n\nThe nearest applicable business day.',
  },
  {
    name: 'FirstDay',
    id: '40922001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '1st day of the month',
  },
  {
    name: 'SecondDay',
    id: '40922002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '2nd day of the month',
  },
  {
    name: 'ThirdDay',
    id: '40922003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '3rd day of the month',
  },
  {
    name: 'FourthDay',
    id: '40922004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '4th day of the month',
  },
  {
    name: 'FifthDay',
    id: '40922005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '5th day of the month',
  },
  {
    name: 'SixthDay',
    id: '40922006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '6thd day of the month',
  },
  {
    name: 'SeventhDay',
    id: '40922007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '7th day of the month',
  },
  {
    name: 'EighthDay',
    id: '40922008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '8th day of the month',
  },
  {
    name: 'NinthDay',
    id: '40922009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '9th day of the month',
  },
  {
    name: 'TenthDay',
    id: '40922010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '10th day of the month',
  },
  {
    name: 'EleventhDay',
    id: '40922011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '11th day of the month',
  },
  {
    name: 'TwelvthDay',
    id: '40922012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '12th day of the month',
  },
  {
    name: 'ThirteenthDay',
    id: '40922013',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '13th day of the month',
  },
  {
    name: 'ForteenthDay',
    id: '40922014',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '14th day of the month',
  },
  {
    name: 'FifteenthDay',
    id: '40922015',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '15th day of the month',
  },
  {
    name: 'SixteenthDay',
    id: '40922016',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '16th day of the month',
  },
  {
    name: 'SeventeenthDay',
    id: '40922017',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '17th day of the month',
  },
  {
    name: 'EighteenthDay',
    id: '40922018',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '18th day of the month',
  },
  {
    name: 'NineteenthDay',
    id: '40922019',
    value: '19',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '19th day of the month',
  },
  {
    name: 'TwentiethDay',
    id: '40922020',
    value: '20',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '20th day of the month',
  },
  {
    name: 'TwentyFirstDay',
    id: '40922021',
    value: '21',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '21st day of the month',
  },
  {
    name: 'TwentySecondDay',
    id: '40922022',
    value: '22',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '22nd day of the month',
  },
  {
    name: 'TwentyThirdDay',
    id: '40922023',
    value: '23',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '23rd day of the month',
  },
  {
    name: 'TwentyFourthDay',
    id: '40922024',
    value: '24',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '24th day of the month',
  },
  {
    name: 'TwentyFifthDay',
    id: '40922025',
    value: '25',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '25th day of the month',
  },
  {
    name: 'TwentySixthDay',
    id: '40922026',
    value: '26',
    sort: 26,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '26th day of the month',
  },
  {
    name: 'TwentySeventhDay',
    id: '40922027',
    value: '27',
    sort: 27,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '27th day of the month',
  },
  {
    name: 'TwentyEigthDa28y',
    id: '40922028',
    value: '28',
    sort: 28,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '28th day of the month',
  },
  {
    name: 'TwentyNinthDay',
    id: '40922029',
    value: '29',
    sort: 29,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '29th day of the month',
  },
  {
    name: 'ThirtiethDay',
    id: '40922030',
    value: '30',
    sort: 30,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: '30th day of the month',
  },
  {
    name: 'EOM',
    id: '40922031',
    value: 'EOM',
    sort: 31,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: 'The end of the month.\n\nUse EOM for 31st day of the month.',
  },
  {
    name: 'FRN',
    id: '40922032',
    value: 'FRN',
    sort: 32,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: 'The floating rate note convention or Eurodollar convention.',
  },
  {
    name: 'IMM',
    id: '40922033',
    value: 'IMM',
    sort: 33,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description:
      'The International Money Market settlement date, i.e. the 3rd Wednesday of the month.',
  },
  {
    name: 'IMMCAD',
    id: '40922034',
    value: 'IMMCAD',
    sort: 34,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description:
      'The last trading day/expiration day of the Canadian Derivatives Exchange.',
  },
  {
    name: 'IMMAUD',
    id: '40922035',
    value: 'IMMAUD',
    sort: 35,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description:
      'The last trading day of the Sydney Futures Exchange Australian 90-day bank accepted bill futures contract.',
  },
  {
    name: 'IMMNZD',
    id: '40922036',
    value: 'IMMNZD',
    sort: 36,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description:
      'The last trading day of the Sydney Futures Exchange New Zealand 90-day bank bill futures contract.',
  },
  {
    name: 'SFE',
    id: '40922037',
    value: 'SFE',
    sort: 37,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description:
      'The Sydney Futures Exchange 90-day bank accepted bill futures settlement dates.',
  },
  {
    name: 'NONE',
    id: '40922038',
    value: 'NONE',
    sort: 38,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: 'No adjustment',
  },
  {
    name: 'TBILL',
    id: '40922039',
    value: 'TBILL',
    sort: 39,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: 'The 13-week and 26-week U.S. Treasury Bill auction dates.',
  },
  {
    name: 'MON',
    id: '40922040',
    value: 'MON',
    sort: 40,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: 'Monday',
  },
  {
    name: 'TUE',
    id: '40922041',
    value: 'TUE',
    sort: 41,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: 'Tuesday',
  },
  {
    name: 'WED',
    id: '40922042',
    value: 'WED',
    sort: 42,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: 'Wednesday',
  },
  {
    name: 'THU',
    id: '40922043',
    value: 'THU',
    sort: 43,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: 'Thursday',
  },
  {
    name: 'FRI',
    id: '40922044',
    value: 'FRI',
    sort: 44,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: 'Friday',
  },
  {
    name: 'SAT',
    id: '40922045',
    value: 'SAT',
    sort: 45,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: 'Saturday',
  },
  {
    name: 'SUN',
    id: '40922046',
    value: 'SUN',
    sort: 46,
    added: 'FIX.5.0SP2',
    addedEP: '161',
    tag: 40922,
    type: 'String',
    codeSet: 'DateRollConventionCodeSet',
    description: 'Sunday',
  },
  {
    name: 'Base64',
    id: '2109001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '167',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 2109,
    type: 'int',
    codeSet: 'AttachmentEncodingTypeCodeSet',
    description: 'Base64 encoding\n\n',
  },
  {
    name: 'RawBinary',
    id: '2109002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '167',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 2109,
    type: 'int',
    codeSet: 'AttachmentEncodingTypeCodeSet',
    description: 'Raw binary\n\nUnencoded binary content.',
  },
  {
    name: 'AutoSpot',
    id: '2115001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '168',
    tag: 2115,
    type: 'int',
    codeSet: 'NegotiationMethodCodeSet',
    description:
      'Auto spot\n\nThe spot price for the reference or benchmark security is provided automatically.',
  },
  {
    name: 'NegotiatedSpot',
    id: '2115002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '168',
    tag: 2115,
    type: 'int',
    codeSet: 'NegotiationMethodCodeSet',
    description:
      'Negotiated spot\n\nThe spot price for the reference or benchmark security is to be negotiated.',
  },
  {
    name: 'PhoneSpot',
    id: '2115003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '168',
    updated: 'FIX.5.0SP2',
    updatedEP: '208',
    tag: 2115,
    type: 'int',
    codeSet: 'NegotiationMethodCodeSet',
    description:
      'The spot price for the reference or benchmark security is to be negotiated via phone or voice.\n\nThe spot price for the reference of benchmark security is to be negotiated via phone or voice.',
  },
  {
    name: 'AsianOut',
    id: '41011001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41011,
    type: 'int',
    codeSet: 'ComplexEventPeriodTypeCodeSet',
    description: 'Asian Out',
  },
  {
    name: 'AsianIn',
    id: '41011002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41011,
    type: 'int',
    codeSet: 'ComplexEventPeriodTypeCodeSet',
    description: 'Asian In',
  },
  {
    name: 'BarrierCap',
    id: '41011003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41011,
    type: 'int',
    codeSet: 'ComplexEventPeriodTypeCodeSet',
    description: 'Barrier Cap',
  },
  {
    name: 'BarrierFloor',
    id: '41011004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41011,
    type: 'int',
    codeSet: 'ComplexEventPeriodTypeCodeSet',
    description: 'Barrier Floor',
  },
  {
    name: 'KnockOut',
    id: '41011005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41011,
    type: 'int',
    codeSet: 'ComplexEventPeriodTypeCodeSet',
    description: 'Knock Out',
  },
  {
    name: 'KnockIn',
    id: '41011006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41011,
    type: 'int',
    codeSet: 'ComplexEventPeriodTypeCodeSet',
    description: 'Knock In',
  },
  {
    name: 'Business',
    id: '41024001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41024,
    type: 'int',
    codeSet: 'ComplexEventDateOffsetDayTypeCodeSet',
    description: 'Business',
  },
  {
    name: 'Calendar',
    id: '41024002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41024,
    type: 'int',
    codeSet: 'ComplexEventDateOffsetDayTypeCodeSet',
    description: 'Calendar',
  },
  {
    name: 'CommodityBusiness',
    id: '41024003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41024,
    type: 'int',
    codeSet: 'ComplexEventDateOffsetDayTypeCodeSet',
    description: 'Commodity business',
  },
  {
    name: 'CurrencyBusiness',
    id: '41024004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41024,
    type: 'int',
    codeSet: 'ComplexEventDateOffsetDayTypeCodeSet',
    description: 'Currency business',
  },
  {
    name: 'ExchangeBusiness',
    id: '41024005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41024,
    type: 'int',
    codeSet: 'ComplexEventDateOffsetDayTypeCodeSet',
    description: 'Exchange business',
  },
  {
    name: 'ScheduledTradingDay',
    id: '41024006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41024,
    type: 'int',
    codeSet: 'ComplexEventDateOffsetDayTypeCodeSet',
    description: 'Scheduled trading day',
  },
  {
    name: 'Close',
    id: '2121001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2121,
    type: 'int',
    codeSet: 'ComplexOptPayoutTimeCodeSet',
    description: 'Close',
  },
  {
    name: 'Open',
    id: '2121002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2121,
    type: 'int',
    codeSet: 'ComplexOptPayoutTimeCodeSet',
    description: 'Open',
  },
  {
    name: 'OfficialSettl',
    id: '2121003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2121,
    type: 'int',
    codeSet: 'ComplexOptPayoutTimeCodeSet',
    description: 'Official settlement',
  },
  {
    name: 'ValuationTime',
    id: '2121004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2121,
    type: 'int',
    codeSet: 'ComplexOptPayoutTimeCodeSet',
    description: 'Valuation time',
  },
  {
    name: 'ExcahgneSettlTime',
    id: '2121005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2121,
    type: 'int',
    codeSet: 'ComplexOptPayoutTimeCodeSet',
    description: 'Exchange settlement time',
  },
  {
    name: 'DerivativesClose',
    id: '2121006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2121,
    type: 'int',
    codeSet: 'ComplexOptPayoutTimeCodeSet',
    description: 'Derivatives close',
  },
  {
    name: 'AsSpecified',
    id: '2121007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2121,
    type: 'int',
    codeSet: 'ComplexOptPayoutTimeCodeSet',
    description: 'As specified in master confirmation',
  },
  {
    name: 'Currency1PerCurrency2',
    id: '2126001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2126,
    type: 'int',
    codeSet: 'ComplexEventQuoteBasisCodeSet',
    description: 'Currency 1 per currency 2',
  },
  {
    name: 'Currency2PerCurrency1',
    id: '2126002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2126,
    type: 'int',
    codeSet: 'ComplexEventQuoteBasisCodeSet',
    description: 'Currency 2 per currency 1',
  },
  {
    name: 'SellerNotifies',
    id: '2134001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2134,
    type: 'int',
    codeSet: 'ComplexEventCreditEventNotifyingPartyCodeSet',
    description: 'Seller notifies',
  },
  {
    name: 'BuyerNotifies',
    id: '2134002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2134,
    type: 'int',
    codeSet: 'ComplexEventCreditEventNotifyingPartyCodeSet',
    description: 'Buyer notifies',
  },
  {
    name: 'SellerOrBuyerNotifies',
    id: '2134003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2134,
    type: 'int',
    codeSet: 'ComplexEventCreditEventNotifyingPartyCodeSet',
    description: 'Seller or buyer notifies',
  },
  {
    name: 'Notional',
    id: '41038001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41038,
    type: 'int',
    codeSet: 'DeliveryScheduleTypeCodeSet',
    description: 'Notional',
  },
  {
    name: 'Delivery',
    id: '41038002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41038,
    type: 'int',
    codeSet: 'DeliveryScheduleTypeCodeSet',
    description: 'Delivery',
  },
  {
    name: 'PhysicalSettlPeriods',
    id: '41038003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41038,
    type: 'int',
    codeSet: 'DeliveryScheduleTypeCodeSet',
    description: 'Physical settlement period',
  },
  {
    name: 'Absolute',
    id: '41046001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41046,
    type: 'int',
    codeSet: 'DeliveryScheduleToleranceTypeCodeSet',
    description: 'Absolute',
  },
  {
    name: 'Percentage',
    id: '41046002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41046,
    type: 'int',
    codeSet: 'DeliveryScheduleToleranceTypeCodeSet',
    description: 'Percentage',
  },
  {
    name: 'AllTimes',
    id: '41049001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41049,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlFlowTypeCodeSet',
    description: 'All times',
  },
  {
    name: 'OnPeak',
    id: '41049002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41049,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlFlowTypeCodeSet',
    description: 'On peak',
  },
  {
    name: 'OffPeak',
    id: '41049003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41049,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlFlowTypeCodeSet',
    description: 'Off peak',
  },
  {
    name: 'Base',
    id: '41049004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41049,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlFlowTypeCodeSet',
    description: 'Base',
  },
  {
    name: 'BlockHours',
    id: '41049005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 41049,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlFlowTypeCodeSet',
    description: 'Block hours',
  },
  {
    name: 'Other',
    id: '41049006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 41049,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlFlowTypeCodeSet',
    description: 'Other',
  },
  {
    name: 'DoNotIncludeHolidays',
    id: '41050001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41050,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlHolidaysProcessingInstructionCodeSet',
    description: 'Do not include holidays',
  },
  {
    name: 'IncludeHolidays',
    id: '41050002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41050,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlHolidaysProcessingInstructionCodeSet',
    description: 'Include holidays',
  },
  {
    name: 'Monday',
    id: '41052001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41052,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlDayCodeSet',
    description: 'Monday',
  },
  {
    name: 'Tuesday',
    id: '41052002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41052,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlDayCodeSet',
    description: 'Tuesday',
  },
  {
    name: 'Wednesday',
    id: '41052003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41052,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlDayCodeSet',
    description: 'Wednesday',
  },
  {
    name: 'Thursday',
    id: '41052004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41052,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlDayCodeSet',
    description: 'Thursday',
  },
  {
    name: 'Friday',
    id: '41052005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41052,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlDayCodeSet',
    description: 'Friday',
  },
  {
    name: 'Saturday',
    id: '41052006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41052,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlDayCodeSet',
    description: 'Saturday',
  },
  {
    name: 'Sunday',
    id: '41052007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41052,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlDayCodeSet',
    description: 'Sunday',
  },
  {
    name: 'AllWeekdays',
    id: '41052008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41052,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlDayCodeSet',
    description: 'All weekdays',
  },
  {
    name: 'AllDays',
    id: '41052009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41052,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlDayCodeSet',
    description: 'All days',
  },
  {
    name: 'AllWeekends',
    id: '41052010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41052,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlDayCodeSet',
    description: 'All weekends',
  },
  {
    name: 'Hour',
    id: '41057001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41057,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlTimeTypeCodeSet',
    description:
      'Hour of the day\n\nApplicable for electricity contracts. Time value is expressed as an integer hour of the day (1-24). The delivery start/end hour is specified as the end of the included hour. For example, a start hour of "4" begins at 3 a.m.; an end hour of "20" ends at 8 p.m.; a start hour of "1" and end hour of "24" indicates midnight to midnight delivery.',
  },
  {
    name: 'Timestamp',
    id: '41057002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41057,
    type: 'int',
    codeSet: 'DeliveryScheduleSettlTimeTypeCodeSet',
    description:
      'HH:MM time format\n\nApplicable for gas contracts. Time value is expressed using a 24-hour time format. For example, a time value of "13:30" is 1:30 p.m.',
  },
  {
    name: 'Periodic',
    id: '41058001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41058,
    type: 'int',
    codeSet: 'DeliveryStreamTypeCodeSet',
    description: 'Periodic (default if not specified)',
  },
  {
    name: 'Initial',
    id: '41058002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41058,
    type: 'int',
    codeSet: 'DeliveryStreamTypeCodeSet',
    description: 'Initial',
  },
  {
    name: 'Single',
    id: '41058003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41058,
    type: 'int',
    codeSet: 'DeliveryStreamTypeCodeSet',
    description: 'Single',
  },
  {
    name: 'Firm',
    id: '41063001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41063,
    type: 'int',
    codeSet: 'DeliveryStreamDeliveryRestrictionCodeSet',
    description: 'Firm\n\nNever excused of delivery obligations.',
  },
  {
    name: 'NonFirm',
    id: '41063002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41063,
    type: 'int',
    codeSet: 'DeliveryStreamDeliveryRestrictionCodeSet',
    description:
      'Interruptable or non-firm\n\nExcused when interrupted for any reason or for no reason without liability.',
  },
  {
    name: 'ForceMajeure',
    id: '41063003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41063,
    type: 'int',
    codeSet: 'DeliveryStreamDeliveryRestrictionCodeSet',
    description: 'Force majeure\n\nExcused when prevented by force majeure.',
  },
  {
    name: 'SystemFirm',
    id: '41063004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41063,
    type: 'int',
    codeSet: 'DeliveryStreamDeliveryRestrictionCodeSet',
    description:
      'System firm\n\nMust be supplied from the owned or controlled generation of pre-existing purchased power assets of the system specified.',
  },
  {
    name: 'UnitFirm',
    id: '41063005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41063,
    type: 'int',
    codeSet: 'DeliveryStreamDeliveryRestrictionCodeSet',
    description: 'Unit firm\n\nMust be supplied from the generation assset specified.',
  },
  {
    name: 'Transfers',
    id: '41069001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41069,
    type: 'int',
    codeSet: 'DeliveryStreamTitleTransferConditionCodeSet',
    description: 'Transfers with risk of loss',
  },
  {
    name: 'DoesNotTransfer',
    id: '41069002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41069,
    type: 'int',
    codeSet: 'DeliveryStreamTitleTransferConditionCodeSet',
    description: 'Does not transfer with risk of loss',
  },
  {
    name: 'Buyer',
    id: '41075001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41075,
    type: 'int',
    codeSet: 'DeliveryStreamToleranceOptionSideCodeSet',
    description: 'Buyer',
  },
  {
    name: 'Seller',
    id: '41075002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41075,
    type: 'int',
    codeSet: 'DeliveryStreamToleranceOptionSideCodeSet',
    description: 'Seller',
  },
  {
    name: 'Buyer',
    id: '41080001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41080,
    type: 'int',
    codeSet: 'DeliveryStreamElectingPartySideCodeSet',
    description: 'Buyer',
  },
  {
    name: 'Seller',
    id: '41080002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41080,
    type: 'int',
    codeSet: 'DeliveryStreamElectingPartySideCodeSet',
    description: 'Seller',
  },
  {
    name: 'Amortizing',
    id: '1575001',
    value: 'AMTZ',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    updated: 'FIX.5.0SP2',
    updatedEP: '238',
    tag: 1575,
    type: 'String',
    codeSet: 'SwapSubClassCodeSet',
    description: 'Amortizing notional schedule',
  },
  {
    name: 'Compounding',
    id: '1575002',
    value: 'COMP',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    deprecated: 'FIX.5.0SP2',
    deprecatedEP: '238',
    tag: 1575,
    type: 'String',
    codeSet: 'SwapSubClassCodeSet',
    description: 'Compounding',
  },
  {
    name: 'ConstantNotionalSchedule',
    id: '1575003',
    value: 'CNST',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 1575,
    type: 'String',
    codeSet: 'SwapSubClassCodeSet',
    description: 'Constant notional schedule',
  },
  {
    name: 'AccretingNotionalSchedule',
    id: '1575004',
    value: 'ACRT',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 1575,
    type: 'String',
    codeSet: 'SwapSubClassCodeSet',
    description: 'Accreting notional schedule',
  },
  {
    name: 'CustomNotionalSchedule',
    id: '1575005',
    value: 'CUST',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 1575,
    type: 'String',
    codeSet: 'SwapSubClassCodeSet',
    description: 'Custom notional schedule',
  },
  {
    name: 'Straddle',
    id: '2141001',
    value: 'STD',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2141,
    type: 'String',
    codeSet: 'StrategyTypeCodeSet',
    description: 'Straddle',
  },
  {
    name: 'Strangle',
    id: '2141002',
    value: 'STG',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2141,
    type: 'String',
    codeSet: 'StrategyTypeCodeSet',
    description: 'Strangle',
  },
  {
    name: 'Butterfly',
    id: '2141003',
    value: 'BF',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2141,
    type: 'String',
    codeSet: 'StrategyTypeCodeSet',
    description: 'Butterfly',
  },
  {
    name: 'Condor',
    id: '2141004',
    value: 'CNDR',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2141,
    type: 'String',
    codeSet: 'StrategyTypeCodeSet',
    description: 'Condor',
  },
  {
    name: 'CallableInversibleSnowball',
    id: '2141005',
    value: 'CISN',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2141,
    type: 'String',
    codeSet: 'StrategyTypeCodeSet',
    description: 'Callable inversible snowball',
  },
  {
    name: 'Other',
    id: '2141006',
    value: 'OTHER',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2141,
    type: 'String',
    codeSet: 'StrategyTypeCodeSet',
    description: 'Other',
  },
  {
    name: 'Negotiation',
    id: '2143001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2143,
    type: 'int',
    codeSet: 'SettlDisruptionProvisionCodeSet',
    description: 'Negotiation',
  },
  {
    name: 'Cancellation',
    id: '2143002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 2143,
    type: 'int',
    codeSet: 'SettlDisruptionProvisionCodeSet',
    description: 'Cancellation and payment',
  },
  {
    name: 'NotApplicable',
    id: '41087001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41087,
    type: 'int',
    codeSet: 'MarketDisruptionProvisionCodeSet',
    description: 'Not applicable',
  },
  {
    name: 'Applicable',
    id: '41087002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41087,
    type: 'int',
    codeSet: 'MarketDisruptionProvisionCodeSet',
    description: 'Applicable',
  },
  {
    name: 'AsInMasterAgreement',
    id: '41087003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41087,
    type: 'int',
    codeSet: 'MarketDisruptionProvisionCodeSet',
    description: 'As specified in master agreement',
  },
  {
    name: 'AsInConfirmation',
    id: '41087004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41087,
    type: 'int',
    codeSet: 'MarketDisruptionProvisionCodeSet',
    description: 'As specified in confirmation',
  },
  {
    name: 'MasterAgreement',
    id: '41088001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41088,
    type: 'int',
    codeSet: 'MarketDisruptionFallbackProvisionCodeSet',
    description: 'As specified in master agreement',
  },
  {
    name: 'Confirmation',
    id: '41088002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41088,
    type: 'int',
    codeSet: 'MarketDisruptionFallbackProvisionCodeSet',
    description: 'As specified in confirmation',
  },
  {
    name: 'Basket',
    id: '41097001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41097,
    type: 'int',
    codeSet: 'MarketDisruptionFallbackUnderlierTypeCodeSet',
    description: 'Basket',
  },
  {
    name: 'Bond',
    id: '41097002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41097,
    type: 'int',
    codeSet: 'MarketDisruptionFallbackUnderlierTypeCodeSet',
    description: 'Bond',
  },
  {
    name: 'Cash',
    id: '41097003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41097,
    type: 'int',
    codeSet: 'MarketDisruptionFallbackUnderlierTypeCodeSet',
    description: 'Cash',
  },
  {
    name: 'Commodity',
    id: '41097004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41097,
    type: 'int',
    codeSet: 'MarketDisruptionFallbackUnderlierTypeCodeSet',
    description: 'Commodity',
  },
  {
    name: 'ConvertibleBond',
    id: '41097005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41097,
    type: 'int',
    codeSet: 'MarketDisruptionFallbackUnderlierTypeCodeSet',
    description: 'Convertible bond',
  },
  {
    name: 'Equity',
    id: '41097006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41097,
    type: 'int',
    codeSet: 'MarketDisruptionFallbackUnderlierTypeCodeSet',
    description: 'Equity',
  },
  {
    name: 'ExchangeTradedFund',
    id: '41097007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41097,
    type: 'int',
    codeSet: 'MarketDisruptionFallbackUnderlierTypeCodeSet',
    description: 'Exchange traded fund',
  },
  {
    name: 'Future',
    id: '41097008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41097,
    type: 'int',
    codeSet: 'MarketDisruptionFallbackUnderlierTypeCodeSet',
    description: 'Future',
  },
  {
    name: 'Index',
    id: '41097009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41097,
    type: 'int',
    codeSet: 'MarketDisruptionFallbackUnderlierTypeCodeSet',
    description: 'Index',
  },
  {
    name: 'Loan',
    id: '41097010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41097,
    type: 'int',
    codeSet: 'MarketDisruptionFallbackUnderlierTypeCodeSet',
    description: 'Loan',
  },
  {
    name: 'Mortgage',
    id: '41097011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41097,
    type: 'int',
    codeSet: 'MarketDisruptionFallbackUnderlierTypeCodeSet',
    description: 'Mortgage',
  },
  {
    name: 'MutualFund',
    id: '41097012',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41097,
    type: 'int',
    codeSet: 'MarketDisruptionFallbackUnderlierTypeCodeSet',
    description: 'Mutual fund',
  },
  {
    name: 'NotRequired',
    id: '41111001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41111,
    type: 'int',
    codeSet: 'ExerciseConfirmationMethodCodeSet',
    description: 'Not required',
  },
  {
    name: 'NonElectronic',
    id: '41111002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41111,
    type: 'int',
    codeSet: 'ExerciseConfirmationMethodCodeSet',
    description: 'Non-electronic',
  },
  {
    name: 'Electronic',
    id: '41111003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41111,
    type: 'int',
    codeSet: 'ExerciseConfirmationMethodCodeSet',
    description: 'Electronic',
  },
  {
    name: 'Unknown',
    id: '41111004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41111,
    type: 'int',
    codeSet: 'ExerciseConfirmationMethodCodeSet',
    description: 'Unknown at time of report',
  },
  {
    name: 'Unadjusted',
    id: '41139001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41139,
    type: 'int',
    codeSet: 'OptionExerciseDateTypeCodeSet',
    description: 'Unadjusted',
  },
  {
    name: 'Adjusted',
    id: '41139002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41139,
    type: 'int',
    codeSet: 'OptionExerciseDateTypeCodeSet',
    description: 'Adjusted',
  },
  {
    name: 'Business',
    id: '41159001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41159,
    type: 'int',
    codeSet: 'PaymentDateOffsetDayTypeCodeSet',
    description: 'Business',
  },
  {
    name: 'Calendar',
    id: '41159002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41159,
    type: 'int',
    codeSet: 'PaymentDateOffsetDayTypeCodeSet',
    description: 'Calendar',
  },
  {
    name: 'Commodity',
    id: '41159003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41159,
    type: 'int',
    codeSet: 'PaymentDateOffsetDayTypeCodeSet',
    description: 'Commodity business',
  },
  {
    name: 'Currency',
    id: '41159004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41159,
    type: 'int',
    codeSet: 'PaymentDateOffsetDayTypeCodeSet',
    description: 'Currency business',
  },
  {
    name: 'Exchange',
    id: '41159005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41159,
    type: 'int',
    codeSet: 'PaymentDateOffsetDayTypeCodeSet',
    description: 'Exchange business',
  },
  {
    name: 'Scheduled',
    id: '41159006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41159,
    type: 'int',
    codeSet: 'PaymentDateOffsetDayTypeCodeSet',
    description: 'Scheduled trading day',
  },
  {
    name: 'Prepaid',
    id: '41160001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41160,
    type: 'int',
    codeSet: 'PaymentForwardStartTypeCodeSet',
    description: 'Prepaid',
  },
  {
    name: 'Postpaid',
    id: '41160002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41160,
    type: 'int',
    codeSet: 'PaymentForwardStartTypeCodeSet',
    description: 'Post-paid',
  },
  {
    name: 'Variable',
    id: '41160003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41160,
    type: 'int',
    codeSet: 'PaymentForwardStartTypeCodeSet',
    description: 'Variable',
  },
  {
    name: 'Fixed',
    id: '41160004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41160,
    type: 'int',
    codeSet: 'PaymentForwardStartTypeCodeSet',
    description: 'Fixed',
  },
  {
    name: 'Average',
    id: '41199001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41199,
    type: 'int',
    codeSet: 'PaymentStreamSettlLevelCodeSet',
    description:
      'Average\n\nThe cumulative number of weather index units for each day in the calculation period divided by the number of days in the calculation period.',
  },
  {
    name: 'Maximum',
    id: '41199002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41199,
    type: 'int',
    codeSet: 'PaymentStreamSettlLevelCodeSet',
    description:
      'Maximum\n\nThe maximum number of weather index units for any day in the calculaiton period.',
  },
  {
    name: 'Minimum',
    id: '41199003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41199,
    type: 'int',
    codeSet: 'PaymentStreamSettlLevelCodeSet',
    description:
      'Minimum\n\nThe minimum number of weather index units for any day in the calculaiton period.',
  },
  {
    name: 'Cumulative',
    id: '41199004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41199,
    type: 'int',
    codeSet: 'PaymentStreamSettlLevelCodeSet',
    description:
      'Cumulative\n\nThe cumulative number of weather index units for each day in the calculaiton period.',
  },
  {
    name: 'Absolute',
    id: '41206001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41206,
    type: 'int',
    codeSet: 'PaymentStreamRateSpreadTypeCodeSet',
    description: 'Absolute',
  },
  {
    name: 'Percentage',
    id: '41206002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41206,
    type: 'int',
    codeSet: 'PaymentStreamRateSpreadTypeCodeSet',
    description: 'Percentage',
  },
  {
    name: 'All',
    id: '41214001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41214,
    type: 'int',
    codeSet: 'PaymentStreamPricingDayDistributionCodeSet',
    description: 'All',
  },
  {
    name: 'First',
    id: '41214002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41214,
    type: 'int',
    codeSet: 'PaymentStreamPricingDayDistributionCodeSet',
    description: 'First',
  },
  {
    name: 'Last',
    id: '41214003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41214,
    type: 'int',
    codeSet: 'PaymentStreamPricingDayDistributionCodeSet',
    description: 'Last',
  },
  {
    name: 'Penultimate',
    id: '41214004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41214,
    type: 'int',
    codeSet: 'PaymentStreamPricingDayDistributionCodeSet',
    description: 'Penultimate',
  },
  {
    name: 'EveryDay',
    id: '41228001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41228,
    type: 'int',
    codeSet: 'PaymentStreamPricingDayOfWeekCodeSet',
    description: 'Every day (the default if not specified)',
  },
  {
    name: 'Monday',
    id: '41228002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41228,
    type: 'int',
    codeSet: 'PaymentStreamPricingDayOfWeekCodeSet',
    description: 'Monday',
  },
  {
    name: 'Tuesday',
    id: '41228003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41228,
    type: 'int',
    codeSet: 'PaymentStreamPricingDayOfWeekCodeSet',
    description: 'Tuesday',
  },
  {
    name: 'Wednesday',
    id: '41228004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41228,
    type: 'int',
    codeSet: 'PaymentStreamPricingDayOfWeekCodeSet',
    description: 'Wednesday',
  },
  {
    name: 'Thursday',
    id: '41228005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41228,
    type: 'int',
    codeSet: 'PaymentStreamPricingDayOfWeekCodeSet',
    description: 'Thursday',
  },
  {
    name: 'Friday',
    id: '41228006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41228,
    type: 'int',
    codeSet: 'PaymentStreamPricingDayOfWeekCodeSet',
    description: 'Friday',
  },
  {
    name: 'Saturday',
    id: '41228007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41228,
    type: 'int',
    codeSet: 'PaymentStreamPricingDayOfWeekCodeSet',
    description: 'Saturday',
  },
  {
    name: 'Sunday',
    id: '41228008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41228,
    type: 'int',
    codeSet: 'PaymentStreamPricingDayOfWeekCodeSet',
    description: 'Sunday',
  },
  {
    name: 'Week',
    id: '41267001',
    value: 'Wk',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41267,
    type: 'String',
    codeSet: 'StreamCommodityNearbySettlDayUnitCodeSet',
    description: 'Week',
  },
  {
    name: 'Month',
    id: '41267002',
    value: 'Mo',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41267,
    type: 'String',
    codeSet: 'StreamCommodityNearbySettlDayUnitCodeSet',
    description: 'Month',
  },
  {
    name: 'Day',
    id: '41273001',
    value: 'D',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41273,
    type: 'String',
    codeSet: 'StreamCommoditySettlDateRollUnitCodeSet',
    description: 'Day',
  },
  {
    name: 'City',
    id: '41282001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41282,
    type: 'int',
    codeSet: 'StreamCommodityDataSourceIDTypeCodeSet',
    description: 'City (4 character business center code)',
  },
  {
    name: 'Airport',
    id: '41282002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41282,
    type: 'int',
    codeSet: 'StreamCommodityDataSourceIDTypeCodeSet',
    description: 'Airport (IATA standard)',
  },
  {
    name: 'WeatherStation',
    id: '41282003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41282,
    type: 'int',
    codeSet: 'StreamCommodityDataSourceIDTypeCodeSet',
    description: 'Weather station WBAN (Weather Bureau Army Navy)',
  },
  {
    name: 'WeatherIndex',
    id: '41282004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41282,
    type: 'int',
    codeSet: 'StreamCommodityDataSourceIDTypeCodeSet',
    description: 'Weather index WMO (World Meteorological Organization)',
  },
  {
    name: 'Term',
    id: '41308001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41308,
    type: 'int',
    codeSet: 'StreamNotionalCommodityFrequencyCodeSet',
    description: 'Term',
  },
  {
    name: 'PerBusinessDay',
    id: '41308002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41308,
    type: 'int',
    codeSet: 'StreamNotionalCommodityFrequencyCodeSet',
    description: 'Per business day',
  },
  {
    name: 'PerCalculationPeriod',
    id: '41308003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41308,
    type: 'int',
    codeSet: 'StreamNotionalCommodityFrequencyCodeSet',
    description: 'Per calculation period',
  },
  {
    name: 'PerSettlPeriod',
    id: '41308004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41308,
    type: 'int',
    codeSet: 'StreamNotionalCommodityFrequencyCodeSet',
    description: 'Per settlement period',
  },
  {
    name: 'PerCalendarDay',
    id: '41308005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41308,
    type: 'int',
    codeSet: 'StreamNotionalCommodityFrequencyCodeSet',
    description: 'Per calendar day',
  },
  {
    name: 'PerHour',
    id: '41308006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41308,
    type: 'int',
    codeSet: 'StreamNotionalCommodityFrequencyCodeSet',
    description: 'Per hour',
  },
  {
    name: 'PerMonth',
    id: '41308007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '169',
    tag: 41308,
    type: 'int',
    codeSet: 'StreamNotionalCommodityFrequencyCodeSet',
    description: 'Per month',
  },
  {
    name: 'Accepted',
    id: '2316001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2316,
    type: 'int',
    codeSet: 'RiskLimitReportStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Rejected',
    id: '2316002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2316,
    type: 'int',
    codeSet: 'RiskLimitReportStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'UnkRiskLmtRprtID',
    id: '2317001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2317,
    type: 'int',
    codeSet: 'RiskLimitReportRejectReasonCodeSet',
    description: 'Unknown RiskLimitReportID(1667)',
  },
  {
    name: 'UnkPty',
    id: '2317002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2317,
    type: 'int',
    codeSet: 'RiskLimitReportRejectReasonCodeSet',
    description: 'Unknown party',
  },
  {
    name: 'Other',
    id: '2317003',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2317,
    type: 'int',
    codeSet: 'RiskLimitReportRejectReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'New',
    id: '2320001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2320,
    type: 'int',
    codeSet: 'RiskLimitCheckTransTypeCodeSet',
    description: 'New',
  },
  {
    name: 'Cancel',
    id: '2320002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2320,
    type: 'int',
    codeSet: 'RiskLimitCheckTransTypeCodeSet',
    description: 'Cancel',
  },
  {
    name: 'Replace',
    id: '2320003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2320,
    type: 'int',
    codeSet: 'RiskLimitCheckTransTypeCodeSet',
    description: 'Replace',
  },
  {
    name: 'Submit',
    id: '2321001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2321,
    type: 'int',
    codeSet: 'RiskLimitCheckTypeCodeSet',
    description:
      'Submit\n\nIndicates a submission for a limit check. The RiskLimitCheckTransType(2320) indicates whether the submission is a new request, a cancel or replace/amend of a prior submission.',
  },
  {
    name: 'LimitConsumed',
    id: '2321002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2321,
    type: 'int',
    codeSet: 'RiskLimitCheckTypeCodeSet',
    description:
      'Limit consumed\n\nIndicates that the limit reserved by a prior request has been used or consumed by a transaction that occurred.',
  },
  {
    name: 'AllOrNone',
    id: '2323001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2323,
    type: 'int',
    codeSet: 'RiskLimitCheckRequestTypeCodeSet',
    description:
      'All or none (default if not specified).\n\nThe limit check request is for the full amount requested or none at all. Request can only be responded to with a full approval of the amount requested or a rejection of the request.',
  },
  {
    name: 'Partial',
    id: '2323002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2323,
    type: 'int',
    codeSet: 'RiskLimitCheckRequestTypeCodeSet',
    description:
      'Partial\n\nThe requester will accept a partial approval of the requested credit limit amount.',
  },
  {
    name: 'Approved',
    id: '2325001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2325,
    type: 'int',
    codeSet: 'RiskLimitCheckRequestStatusCodeSet',
    description:
      'Approved\n\nRequest has been accepted and processed. The credit amount requested has been reserved for the transaction.',
  },
  {
    name: 'PartiallyApproved',
    id: '2325002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2325,
    type: 'int',
    codeSet: 'RiskLimitCheckRequestStatusCodeSet',
    description:
      'Partially approved\n\nOnly a partial amount of the credit amount requested has been approved and has been reserved for the transaction.',
  },
  {
    name: 'Rejected',
    id: '2325003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2325,
    type: 'int',
    codeSet: 'RiskLimitCheckRequestStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'ApprovalPending',
    id: '2325004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2325,
    type: 'int',
    codeSet: 'RiskLimitCheckRequestStatusCodeSet',
    description: 'Approval pending',
  },
  {
    name: 'Cancelled',
    id: '2325005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2325,
    type: 'int',
    codeSet: 'RiskLimitCheckRequestStatusCodeSet',
    description: 'Cancelled',
  },
  {
    name: 'Successful',
    id: '2326001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2326,
    type: 'int',
    codeSet: 'RiskLimitCheckRequestResultCodeSet',
    description: 'Successful (default)',
  },
  {
    name: 'InvalidParty',
    id: '2326002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2326,
    type: 'int',
    codeSet: 'RiskLimitCheckRequestResultCodeSet',
    description: 'Invalid party',
  },
  {
    name: 'ReqExceedsCreditLimit',
    id: '2326003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2326,
    type: 'int',
    codeSet: 'RiskLimitCheckRequestResultCodeSet',
    description: 'Requested amount exceeds credit limit',
  },
  {
    name: 'ReqExceedsClipSizeLimit',
    id: '2326004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2326,
    type: 'int',
    codeSet: 'RiskLimitCheckRequestResultCodeSet',
    description: 'Requested amount exceeds clip size limit',
  },
  {
    name: 'ReqExceedsMaxNotional',
    id: '2326005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2326,
    type: 'int',
    codeSet: 'RiskLimitCheckRequestResultCodeSet',
    description: 'Request exceeds maximum notional order amount',
  },
  {
    name: 'Other',
    id: '2326006',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2326,
    type: 'int',
    codeSet: 'RiskLimitCheckRequestResultCodeSet',
    description: 'Other',
  },
  {
    name: 'Suspend',
    id: '2329001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2329,
    type: 'int',
    codeSet: 'PartyActionTypeCodeSet',
    description: 'Suspend',
  },
  {
    name: 'HaltTrading',
    id: '2329002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2329,
    type: 'int',
    codeSet: 'PartyActionTypeCodeSet',
    description: 'Halt trading',
  },
  {
    name: 'Reinstate',
    id: '2329003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2329,
    type: 'int',
    codeSet: 'PartyActionTypeCodeSet',
    description: 'Reinstate',
  },
  {
    name: 'Accepted',
    id: '2332001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2332,
    type: 'int',
    codeSet: 'PartyActionResponseCodeSet',
    description: 'Accepted\n\nThe action request is accepted for processing.',
  },
  {
    name: 'Completed',
    id: '2332002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2332,
    type: 'int',
    codeSet: 'PartyActionResponseCodeSet',
    description:
      'Completed\n\nThe processing of the requested action has been successfully completed.',
  },
  {
    name: 'Rejected',
    id: '2332003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2332,
    type: 'int',
    codeSet: 'PartyActionResponseCodeSet',
    description:
      'Rejected\n\nThe action request was rejected. PartyActionRejectReason(2233) should be used to specify the rejection reason',
  },
  {
    name: 'InvalidParty',
    id: '2333001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    updated: 'FIX.5.0SP2',
    updatedEP: '182',
    tag: 2333,
    type: 'int',
    codeSet: 'PartyActionRejectReasonCodeSet',
    description: 'Invalid party or parties',
  },
  {
    name: 'UnkReqParty',
    id: '2333002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2333,
    type: 'int',
    codeSet: 'PartyActionRejectReasonCodeSet',
    description: 'Unknown requesting party',
  },
  {
    name: 'NotAuthorized',
    id: '2333003',
    value: '98',
    sort: 98,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2333,
    type: 'int',
    codeSet: 'PartyActionRejectReasonCodeSet',
    description: 'Not authorized',
  },
  {
    name: 'Other',
    id: '2333004',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2333,
    type: 'int',
    codeSet: 'PartyActionRejectReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'RiskLimitRequestID',
    id: '2335001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2335,
    type: 'int',
    codeSet: 'RefRiskLimitCheckIDTypeCodeSet',
    description: 'RiskLimitRequestID(1666)',
  },
  {
    name: 'RiskLimitCheckID',
    id: '2335002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2335,
    type: 'int',
    codeSet: 'RefRiskLimitCheckIDTypeCodeSet',
    description: 'RiskLimitCheckID(2319)',
  },
  {
    name: 'OutOfBandID',
    id: '2335003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '180',
    tag: 2335,
    type: 'int',
    codeSet: 'RefRiskLimitCheckIDTypeCodeSet',
    description: 'Out of band identifier',
  },
  {
    name: 'None',
    id: '2339001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2339,
    type: 'int',
    codeSet: 'RiskLimitCheckModelTypeCodeSet',
    description:
      'None (default if not specified)\n\nNo specified limit check model is defined. Limit checks for the party will be based on parameters defined.',
  },
  {
    name: 'PlusOneModel',
    id: '2339002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2339,
    type: 'int',
    codeSet: 'RiskLimitCheckModelTypeCodeSet',
    description:
      "PlusOne model\n\nA pre-trade credit limit check model which allows trades to occur until it is determined by the clearinghouse or other designated limit checker that the party's limit(s) was breached by the most recent trade executed.",
  },
  {
    name: 'PingModel',
    id: '2339003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2339,
    type: 'int',
    codeSet: 'RiskLimitCheckModelTypeCodeSet',
    description:
      'Ping model\n\nA pre-trade credit limit check model which requires the execution venue to obtain limit approval from the Credit Provider for every transaction about to be conducted by the Credit User.',
  },
  {
    name: 'PushModel',
    id: '2339004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '171',
    tag: 2339,
    type: 'int',
    codeSet: 'RiskLimitCheckModelTypeCodeSet',
    description:
      'Push model\n\nA pre-trade credit limit check model in which the Credit Provider "pushes" to the execution venue the credit limit information allocated to each of the Credit Provider\'s counterparty or customer.',
  },
  {
    name: 'Accepted',
    id: '2343001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '172',
    tag: 2343,
    type: 'int',
    codeSet: 'RiskLimitCheckStatusCodeSet',
    description:
      'Accepted\n\nFor use when none of the more specific status enumerations apply.',
  },
  {
    name: 'Rejected',
    id: '2343002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '172',
    tag: 2343,
    type: 'int',
    codeSet: 'RiskLimitCheckStatusCodeSet',
    description:
      'Rejected\n\nFor use when none of the more specific status enumerations apply.',
  },
  {
    name: 'ClaimRequired',
    id: '2343003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '172',
    tag: 2343,
    type: 'int',
    codeSet: 'RiskLimitCheckStatusCodeSet',
    description:
      'Claim required\n\nIndicates that the clearing firm is required to accept or decline the trade.',
  },
  {
    name: 'PreDefinedLimitCheckSucceeded',
    id: '2343004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '172',
    tag: 2343,
    type: 'int',
    codeSet: 'RiskLimitCheckStatusCodeSet',
    description:
      'Pre-defined limit check succeeded\n\nIndicates a check enforced automatically by the clearing house.',
  },
  {
    name: 'PreDefinedLimitCheckFailed',
    id: '2343005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '172',
    tag: 2343,
    type: 'int',
    codeSet: 'RiskLimitCheckStatusCodeSet',
    description:
      'Pre-defined limit check failed\n\nIndicates a check enforced automatically by the clearing house.',
  },
  {
    name: 'PreDefinedAutoAcceptRuleInvoked',
    id: '2343006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '172',
    tag: 2343,
    type: 'int',
    codeSet: 'RiskLimitCheckStatusCodeSet',
    description:
      'Pre-defined auto-accept rule invoked\n\nIndicates that the clearing firm is required to accept or decline the trade because no limit or rule applies.',
  },
  {
    name: 'PreDefinedAutoRejectRuleInvoked',
    id: '2343007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '172',
    tag: 2343,
    type: 'int',
    codeSet: 'RiskLimitCheckStatusCodeSet',
    description:
      'Pre-defined auto-reject rule invoked\n\nIndicates a check enforced automatically by the clearing house. Note that clearing house rules of engagement may still require a clearing firm accept or reject the trade.',
  },
  {
    name: 'AcceptedByClearingFirm',
    id: '2343008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '172',
    tag: 2343,
    type: 'int',
    codeSet: 'RiskLimitCheckStatusCodeSet',
    description:
      'Accepted by clearing firm\n\nIndicates that explicit action by the clearing firm, and not an automatic check by the clearing house, was the basis for accepting the trade.',
  },
  {
    name: 'RejectedByClearingFirm',
    id: '2343009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '172',
    tag: 2343,
    type: 'int',
    codeSet: 'RiskLimitCheckStatusCodeSet',
    description:
      'Rejected by clearing firm\n\nIndicates that explicit action by the clearing firm, and not an automatic check by the clearing house, was the basis for rejecting the trade.',
  },
  {
    name: 'Pending',
    id: '2343010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '172',
    tag: 2343,
    type: 'int',
    codeSet: 'RiskLimitCheckStatusCodeSet',
    description:
      'Pending\n\nIndicates that one or more side level risk checks are in progress.',
  },
  {
    name: 'AcceptedByCreditHub',
    id: '2343011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '180',
    tag: 2343,
    type: 'int',
    codeSet: 'RiskLimitCheckStatusCodeSet',
    description:
      'Accepted by credit hub\n\nIndicates that a credit hub accepted the trade. An identifier assigned by the credit hub may appear in the appropriate RefRiskLimitCheckID(2334) field.',
  },
  {
    name: 'RejectedByCreditHub',
    id: '2343012',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '180',
    tag: 2343,
    type: 'int',
    codeSet: 'RiskLimitCheckStatusCodeSet',
    description:
      'Rejected by credit hub\n\nIndicates that a credit hub rejected the trade.',
  },
  {
    name: 'PendingCreditHubCheck',
    id: '2343013',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '180',
    tag: 2343,
    type: 'int',
    codeSet: 'RiskLimitCheckStatusCodeSet',
    description:
      'Pending credit hub check\n\nIndicates that a check is pending at a credit hub.',
  },
  {
    name: 'AcceptedByExecVenue',
    id: '2343014',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '180',
    tag: 2343,
    type: 'int',
    codeSet: 'RiskLimitCheckStatusCodeSet',
    description:
      'Accepted by execution venue\n\nIndicates acceptance by an execution venue, such as a SEF.',
  },
  {
    name: 'RejectedByExecVenue',
    id: '2343015',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '180',
    tag: 2343,
    type: 'int',
    codeSet: 'RiskLimitCheckStatusCodeSet',
    description:
      'Rejected by execution venue\n\nIndicates that the trade was rejected by an execution venue, such as a SEF.',
  },
  {
    name: 'None',
    id: '2347001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '176',
    tag: 2347,
    type: 'int',
    codeSet: 'RegulatoryTransactionTypeCodeSet',
    description:
      'None (default if not specified)\n\nThe transaction does not fall under any special regulatory rule or mandate.',
  },
  {
    name: 'SEFRequiredTransaction',
    id: '2347002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '176',
    tag: 2347,
    type: 'int',
    codeSet: 'RegulatoryTransactionTypeCodeSet',
    description:
      'Swap Execution Facility (SEF) required transaction\n\nThe transaction is a "Required" transaction under Dodd-Frank Act SEF Rules. "Required" transactions are subject to the trade execution mandate under section 2(h)(8) of the CEA and are not block trades.',
  },
  {
    name: 'SEFPermittedTransaction',
    id: '2347003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '176',
    tag: 2347,
    type: 'int',
    codeSet: 'RegulatoryTransactionTypeCodeSet',
    description:
      'Swap Execution Facility (SEF) permitted transaction\n\nThe transaction is a "Permitted" transaction under Dodd-Frank Act SEF Rules. "Permitted" transactions are not subject to the clearing and trade execution mandates, illiquid or bespoke swaps, or block trades.',
  },
  {
    name: 'Update',
    id: '50002001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '178',
    tag: 50002,
    type: 'int',
    codeSet: 'BatchProcessModeCodeSet',
    description: 'Update/incremental (default if not specified)',
  },
  {
    name: 'Snapshot',
    id: '50002002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '178',
    tag: 50002,
    type: 'int',
    codeSet: 'BatchProcessModeCodeSet',
    description:
      "Snapshot\n\nIndicates that messages within the batch should be considered complete, and should replace all prior information. The recipient can take action, to be decided out of band, on previously received data omitted from the batch (e.g. an account not referenced has zero collateral value, a security not referenced is no longer tradable). The scope of completeness (e.g. a complete list of collateral values for all of a given firm's accounts, a complete list of options trading on a given exchange) will be decided out of band.",
  },
  {
    name: 'Proprietary',
    id: '42192001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 42192,
    type: 'int',
    codeSet: 'DeliveryStreamDeliveryPointSourceCodeSet',
    description: 'Proprietary',
  },
  {
    name: 'EIC',
    id: '42192002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 42192,
    type: 'int',
    codeSet: 'DeliveryStreamDeliveryPointSourceCodeSet',
    description:
      'Energy Identification Code (EIC)\n\nEnergy Identification Code specifies the location or connection point codes of energy delivery. See http://www.entsog.eu/eic-codes/eic-location-codes-v or http://www.eiccodes.eu for more information and allocated values to use in DeliveryStreamDeliveryPoint(41062).',
  },
  {
    name: 'ISINOrAltInstrmtID',
    id: '2375001',
    value: 'I',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 2375,
    type: 'char',
    codeSet: 'TaxonomyTypeCodeSet',
    description:
      'ISIN or Alternate instrument identifier plus CFI\n\nIdentified through use of SecurityID(48) and SecurityIDSource(22) of ISIN or another standard source plus CFICode(461).',
  },
  {
    name: 'InterimTaxonomy',
    id: '2375002',
    value: 'E',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '179',
    tag: 2375,
    type: 'char',
    codeSet: 'TaxonomyTypeCodeSet',
    description:
      'Interim Taxonomy\n\nIdentified through use of AssetClass(1938) plus either Symbol(55) or SecurityID(48) and SecurityIDSource(22), and/or other additional instrument attributes.',
  },
  {
    name: 'ClearingMember',
    id: '2397001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '181',
    tag: 2397,
    type: 'int',
    codeSet: 'RegulatoryTradeIDScopeCodeSet',
    description: 'Clearing member',
  },
  {
    name: 'Client',
    id: '2397002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '181',
    tag: 2397,
    type: 'int',
    codeSet: 'RegulatoryTradeIDScopeCodeSet',
    description: 'Client',
  },
  {
    name: 'OrderEntry',
    id: '2402001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '183',
    tag: 2402,
    type: 'int',
    codeSet: 'EntitlementSubTypeCodeSet',
    description: 'Order entry\n\nEntitle to enter new orders',
  },
  {
    name: 'HItLift',
    id: '2402002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '183',
    tag: 2402,
    type: 'int',
    codeSet: 'EntitlementSubTypeCodeSet',
    description: 'Hit/Lift\n\nEntitle to Hit/Lift',
  },
  {
    name: 'ViewIndicativePx',
    id: '2402003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '183',
    tag: 2402,
    type: 'int',
    codeSet: 'EntitlementSubTypeCodeSet',
    description: 'View indicative prices\n\nEntitle to subscribe to indicative prices',
  },
  {
    name: 'ViewExecutablePx',
    id: '2402004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '183',
    tag: 2402,
    type: 'int',
    codeSet: 'EntitlementSubTypeCodeSet',
    description: 'View executable prices\n\nEntitle to subscribe to executable prices',
  },
  {
    name: 'SingleQuote',
    id: '2402005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '183',
    tag: 2402,
    type: 'int',
    codeSet: 'EntitlementSubTypeCodeSet',
    description: 'Single quote\n\nEntitle to submit quote request for a single quote',
  },
  {
    name: 'StreamingQuotes',
    id: '2402006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '183',
    tag: 2402,
    type: 'int',
    codeSet: 'EntitlementSubTypeCodeSet',
    description:
      'Streaming quotes\n\nEntitle to submit quote request for streaming quotes',
  },
  {
    name: 'SingleBroker',
    id: '2402007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '183',
    tag: 2402,
    type: 'int',
    codeSet: 'EntitlementSubTypeCodeSet',
    description: 'Single broker\n\nEntitle to submit quote request for a single broker',
  },
  {
    name: 'MultiBrokers',
    id: '2402008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '183',
    tag: 2402,
    type: 'int',
    codeSet: 'EntitlementSubTypeCodeSet',
    description: 'Multi brokers\n\nEntitle to submit quote request for multiple brokers',
  },
  {
    name: 'QuoteEntry',
    id: '2403001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '184',
    tag: 2403,
    type: 'int',
    codeSet: 'QuoteModelTypeCodeSet',
    description:
      'Quote entry\n\nNew quote is entered or previously submitted quote is updated in full without regard to amount executed when a subsequent quote (e.g. with the same QuoteID reference) is received by the Recipient of the quote message.',
  },
  {
    name: 'QuoteModification',
    id: '2403002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '184',
    tag: 2403,
    type: 'int',
    codeSet: 'QuoteModelTypeCodeSet',
    description:
      'Quote modification\n\nPreviously submitted quote must be present and is updated, taking into consideration the amount already executed when a subsequent quote (e.g. with the same QuoteID reference) is received by the Recipient of the quote message.',
  },
  {
    name: 'Unspecified',
    id: '2405001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '186',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 2405,
    type: 'int',
    codeSet: 'ExecMethodCodeSet',
    description:
      'Undefined/unspecified - (default when not specified)\n\nIn the context of Market Model Typology (MMT), this value represents an off book non-automated transaction type.',
  },
  {
    name: 'Manual',
    id: '2405002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '186',
    updated: 'FIX.5.0SP2',
    updatedEP: '201',
    tag: 2405,
    type: 'int',
    codeSet: 'ExecMethodCodeSet',
    description:
      'Manual\n\nThe transaction was executed in a manual or other non-automated manner, e.g. by voice directly between the counterparties. Also used to identify MTT code M "Off Book Non-Automated".',
  },
  {
    name: 'Automated',
    id: '2405003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '186',
    updated: 'FIX.5.0SP2',
    updatedEP: '228',
    tag: 2405,
    type: 'int',
    codeSet: 'ExecMethodCodeSet',
    description:
      'Automated\n\nThe transaction was executed on an automated execution platform such as an automated systematic internaliser system, broker crossing network, broker crossing system, dark pool trading, "direct to capital" systems, broker position unwind mechanisms, etc.',
  },
  {
    name: 'VoiceBrokered',
    id: '2405004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '201',
    tag: 2405,
    type: 'int',
    codeSet: 'ExecMethodCodeSet',
    description:
      'Voice brokered\n\nThe transaction was negotiated by voice through an intermediary.',
  },
  {
    name: 'DoesNotApply',
    id: '2387001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    updated: 'FIX.Latest',
    updatedEP: '282',
    tag: 2387,
    type: 'int',
    codeSet: 'TradeContingencyCodeSet',
    description:
      'Does not apply (default if not specified)\n\nThe trade is for an asset class that is not traded with contingency.',
  },
  {
    name: 'ContingentTrade',
    id: '2387002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 2387,
    type: 'int',
    codeSet: 'TradeContingencyCodeSet',
    description:
      'Contingent trade\n\nThe trade is terminated as soon as its paired trade is cleared or denied clearing.',
  },
  {
    name: 'NonContingentTrade',
    id: '2387003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 2387,
    type: 'int',
    codeSet: 'TradeContingencyCodeSet',
    description:
      'Non-contingent trade\n\nIdentifies a trade that is not contingent but is for an asset class that may be contingent.',
  },
  {
    name: 'Initial',
    id: '40993001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 40993,
    type: 'int',
    codeSet: 'PaymentSubTypeCodeSet',
    description: 'Initial (principal exchange)',
  },
  {
    name: 'Intermediate',
    id: '40993002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 40993,
    type: 'int',
    codeSet: 'PaymentSubTypeCodeSet',
    description: 'Intermediate (principal exchange)',
  },
  {
    name: 'Final',
    id: '40993003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 40993,
    type: 'int',
    codeSet: 'PaymentSubTypeCodeSet',
    description: 'Final (principal exchange)',
  },
  {
    name: 'Prepaid',
    id: '40993004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 40993,
    type: 'int',
    codeSet: 'PaymentSubTypeCodeSet',
    description: 'Prepaid (premium forward)',
  },
  {
    name: 'Postpaid',
    id: '40993005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 40993,
    type: 'int',
    codeSet: 'PaymentSubTypeCodeSet',
    description: 'Postpaid (premium forward)',
  },
  {
    name: 'Variable',
    id: '40993006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 40993,
    type: 'int',
    codeSet: 'PaymentSubTypeCodeSet',
    description: 'Variable (premium forward)',
  },
  {
    name: 'Fixed',
    id: '40993007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 40993,
    type: 'int',
    codeSet: 'PaymentSubTypeCodeSet',
    description: 'Fixed (premium forward)',
  },
  {
    name: 'Swap',
    id: '40993008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 40993,
    type: 'int',
    codeSet: 'PaymentSubTypeCodeSet',
    description:
      'Swap (premium)\n\nIndicates that the premium is to be paid in the style of payments under an IRS contract.',
  },
  {
    name: 'Conditional',
    id: '40993009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '187',
    tag: 40993,
    type: 'int',
    codeSet: 'PaymentSubTypeCodeSet',
    description: 'Conditional (principal exchange on exercise)',
  },
  {
    name: 'FixedRate',
    id: '40993010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 40993,
    type: 'int',
    codeSet: 'PaymentSubTypeCodeSet',
    description:
      'Fixed rate\n\nApplicable to PaymentType(40213)=14 (Rebate) for which PaymentFixedRate(43097) and its qualifiers supersede PaymentAmount(40217).',
  },
  {
    name: 'FloatingRate',
    id: '40993011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 40993,
    type: 'int',
    codeSet: 'PaymentSubTypeCodeSet',
    description:
      'Floating rate\n\nApplicable to PaymentType(40213)=14 (Rebate) for which PaymentFloatingRateIndex(43098) and its qualifiers supersede PaymentAmount(40217).',
  },
  {
    name: 'Accepted',
    id: '2425001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2425,
    type: 'int',
    codeSet: 'MassOrderRequestStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'AcceptedWithAdditionalEvents',
    id: '2425002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2425,
    type: 'int',
    codeSet: 'MassOrderRequestStatusCodeSet',
    description: 'Accepted with additional events',
  },
  {
    name: 'Rejected',
    id: '2425003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2425,
    type: 'int',
    codeSet: 'MassOrderRequestStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'Successful',
    id: '2426001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2426,
    type: 'int',
    codeSet: 'MassOrderRequestResultCodeSet',
    description: 'Successful',
  },
  {
    name: 'ResponseLevelNotSupported',
    id: '2426002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2426,
    type: 'int',
    codeSet: 'MassOrderRequestResultCodeSet',
    description: 'Response level not supported',
  },
  {
    name: 'InvalidMarket',
    id: '2426003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2426,
    type: 'int',
    codeSet: 'MassOrderRequestResultCodeSet',
    description: 'Invalid market',
  },
  {
    name: 'InvalidMarketSegment',
    id: '2426004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2426,
    type: 'int',
    codeSet: 'MassOrderRequestResultCodeSet',
    description: 'Invalid market segment',
  },
  {
    name: 'Other',
    id: '2426005',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2426,
    type: 'int',
    codeSet: 'MassOrderRequestResultCodeSet',
    description: 'Other',
  },
  {
    name: 'NoAck',
    id: '2427001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2427,
    type: 'int',
    codeSet: 'OrderResponseLevelCodeSet',
    description:
      'No acknowledgement\n\nResponses are provided through one or more ExecutionReport(35=8) messages.',
  },
  {
    name: 'MinimumAck',
    id: '2427002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2427,
    type: 'int',
    codeSet: 'OrderResponseLevelCodeSet',
    description:
      'Minimum acknowledgement\n\nThe minimum is any information to explain why the requested transaction was refused or led to additional events, e.g. immediate execution of an order that was entered or modified.',
  },
  {
    name: 'AckEach',
    id: '2427003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2427,
    type: 'int',
    codeSet: 'OrderResponseLevelCodeSet',
    description:
      'Acknowledge each order\n\nThe number of entries in the response is identical to the number of entries in the request.',
  },
  {
    name: 'SummaryAck',
    id: '2427004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2427,
    type: 'int',
    codeSet: 'OrderResponseLevelCodeSet',
    description:
      'Summary acknowledgement\n\nResponses are provided through a single MassOrderAck(35=DK) without entries and one or more ExecutionReport(35=8) messages.',
  },
  {
    name: 'Add',
    id: '2429001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2429,
    type: 'char',
    codeSet: 'OrderEntryActionCodeSet',
    description: 'Add',
  },
  {
    name: 'Modify',
    id: '2429002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2429,
    type: 'char',
    codeSet: 'OrderEntryActionCodeSet',
    description: 'Modify',
  },
  {
    name: 'Delete',
    id: '2429003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2429,
    type: 'char',
    codeSet: 'OrderEntryActionCodeSet',
    description: 'Delete / Cancel',
  },
  {
    name: 'Suspend',
    id: '2429004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 2429,
    type: 'char',
    codeSet: 'OrderEntryActionCodeSet',
    description: 'Suspend',
  },
  {
    name: 'Release',
    id: '2429005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2429,
    type: 'char',
    codeSet: 'OrderEntryActionCodeSet',
    description: 'Release',
  },
  {
    name: 'OrdAddedOnRequest',
    id: '2431001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2431,
    type: 'int',
    codeSet: 'ExecTypeReasonCodeSet',
    description: 'Order added upon request',
  },
  {
    name: 'OrdReplacedOnRequest',
    id: '2431002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2431,
    type: 'int',
    codeSet: 'ExecTypeReasonCodeSet',
    description: 'Order replaced upon request',
  },
  {
    name: 'OrdCxldOnRequest',
    id: '2431003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2431,
    type: 'int',
    codeSet: 'ExecTypeReasonCodeSet',
    description: 'Order cancelled upon request',
  },
  {
    name: 'UnsolicitedOrdCxl',
    id: '2431004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2431,
    type: 'int',
    codeSet: 'ExecTypeReasonCodeSet',
    description: 'Unsolicited order cancellation',
  },
  {
    name: 'NonRestingOrdAddedOnRequest',
    id: '2431005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2431,
    type: 'int',
    codeSet: 'ExecTypeReasonCodeSet',
    description: 'Non-resting order added upon request',
  },
  {
    name: 'OrdReplacedWithNonRestingOrdOnRequest',
    id: '2431006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2431,
    type: 'int',
    codeSet: 'ExecTypeReasonCodeSet',
    description: 'Order replaced with non-resting order upon request',
  },
  {
    name: 'TriggerOrdReplacedOnRequest',
    id: '2431007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2431,
    type: 'int',
    codeSet: 'ExecTypeReasonCodeSet',
    description: 'Trigger order replaced upon request',
  },
  {
    name: 'SuspendedOrdReplacedOnRequest',
    id: '2431008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2431,
    type: 'int',
    codeSet: 'ExecTypeReasonCodeSet',
    description: 'Suspended order replaced upon request',
  },
  {
    name: 'SuspendedOrdCxldOnRequest',
    id: '2431009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2431,
    type: 'int',
    codeSet: 'ExecTypeReasonCodeSet',
    description: 'Suspended order canceled upon request',
  },
  {
    name: 'OrdCxlPending',
    id: '2431010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2431,
    type: 'int',
    codeSet: 'ExecTypeReasonCodeSet',
    description: 'Order cancellation pending',
  },
  {
    name: 'PendingCxlExecuted',
    id: '2431011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2431,
    type: 'int',
    codeSet: 'ExecTypeReasonCodeSet',
    description: 'Pending cancellation executed',
  },
  {
    name: 'RestingOrdTriggered',
    id: '2431012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2431,
    type: 'int',
    codeSet: 'ExecTypeReasonCodeSet',
    description: 'Resting order triggered',
  },
  {
    name: 'SuspendedOrdActivated',
    id: '2431013',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2431,
    type: 'int',
    codeSet: 'ExecTypeReasonCodeSet',
    description: 'Suspended order activated',
  },
  {
    name: 'ActiveOrdSuspended',
    id: '2431014',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2431,
    type: 'int',
    codeSet: 'ExecTypeReasonCodeSet',
    description: 'Active order suspended',
  },
  {
    name: 'OrdExpired',
    id: '2431015',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '188',
    tag: 2431,
    type: 'int',
    codeSet: 'ExecTypeReasonCodeSet',
    description: 'Order expired',
  },
  {
    name: 'New',
    id: '2439001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2439,
    type: 'int',
    codeSet: 'TransferTransTypeCodeSet',
    description: 'New',
  },
  {
    name: 'Replace',
    id: '2439002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2439,
    type: 'int',
    codeSet: 'TransferTransTypeCodeSet',
    description: 'Replace',
  },
  {
    name: 'Cancel',
    id: '2439003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2439,
    type: 'int',
    codeSet: 'TransferTransTypeCodeSet',
    description: 'Cancel',
  },
  {
    name: 'RequestTransfer',
    id: '2440001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2440,
    type: 'int',
    codeSet: 'TransferTypeCodeSet',
    description: 'Request transfer',
  },
  {
    name: 'AcceptTransfer',
    id: '2440002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2440,
    type: 'int',
    codeSet: 'TransferTypeCodeSet',
    description: 'Accept transfer',
  },
  {
    name: 'DeclineTransfer',
    id: '2440003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2440,
    type: 'int',
    codeSet: 'TransferTypeCodeSet',
    description: 'Decline transfer',
  },
  {
    name: 'InterFirmTransfer',
    id: '2441001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2441,
    type: 'int',
    codeSet: 'TransferScopeCodeSet',
    description: 'Inter-firm transfer',
  },
  {
    name: 'IntraFirmTransfer',
    id: '2441002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2441,
    type: 'int',
    codeSet: 'TransferScopeCodeSet',
    description: 'Intra-firm transfer',
  },
  {
    name: 'CMTA',
    id: '2441003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2441,
    type: 'int',
    codeSet: 'TransferScopeCodeSet',
    description: 'Clearing Member Trade Assignment',
  },
  {
    name: 'Received',
    id: '2442001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2442,
    type: 'int',
    codeSet: 'TransferStatusCodeSet',
    description: 'Received',
  },
  {
    name: 'RejectedByIntermediary',
    id: '2442002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2442,
    type: 'int',
    codeSet: 'TransferStatusCodeSet',
    description: 'Rejected by intermediary',
  },
  {
    name: 'AcceptPending',
    id: '2442003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2442,
    type: 'int',
    codeSet: 'TransferStatusCodeSet',
    description: 'Accept pending',
  },
  {
    name: 'Accepted',
    id: '2442004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2442,
    type: 'int',
    codeSet: 'TransferStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Declined',
    id: '2442005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2442,
    type: 'int',
    codeSet: 'TransferStatusCodeSet',
    description: 'Declined',
  },
  {
    name: 'Cancelled',
    id: '2442006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2442,
    type: 'int',
    codeSet: 'TransferStatusCodeSet',
    description: 'Cancelled',
  },
  {
    name: 'Success',
    id: '2443001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2443,
    type: 'int',
    codeSet: 'TransferRejectReasonCodeSet',
    description: 'Success',
  },
  {
    name: 'InvalidParty',
    id: '2443002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2443,
    type: 'int',
    codeSet: 'TransferRejectReasonCodeSet',
    description: 'Invalid party',
  },
  {
    name: 'UnknownInstrument',
    id: '2443003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2443,
    type: 'int',
    codeSet: 'TransferRejectReasonCodeSet',
    description: 'Unknown instrument',
  },
  {
    name: 'UnauthorizedToSubmitXfer',
    id: '2443004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2443,
    type: 'int',
    codeSet: 'TransferRejectReasonCodeSet',
    description: 'Not authorized to submit transfers',
  },
  {
    name: 'UnknownPosition',
    id: '2443005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2443,
    type: 'int',
    codeSet: 'TransferRejectReasonCodeSet',
    description: 'Unknown position',
  },
  {
    name: 'Other',
    id: '2443006',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2443,
    type: 'int',
    codeSet: 'TransferRejectReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'Submit',
    id: '2444001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2444,
    type: 'int',
    codeSet: 'TransferReportTypeCodeSet',
    description: 'Submit',
  },
  {
    name: 'Alleged',
    id: '2444002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '189',
    tag: 2444,
    type: 'int',
    codeSet: 'TransferReportTypeCodeSet',
    description: 'Alleged',
  },
  {
    name: 'Unknown',
    id: '2451001',
    value: '0',
    sort: 0,
    added: 'FIX.Latest',
    addedEP: '282',
    tag: 2451,
    type: 'int',
    codeSet: 'SettlPriceDeterminationMethodCodeSet',
    description: 'Unknown',
  },
  {
    name: 'LastTradePrice',
    id: '2451002',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '282',
    tag: 2451,
    type: 'int',
    codeSet: 'SettlPriceDeterminationMethodCodeSet',
    description: 'Last trade price',
  },
  {
    name: 'LastBidPrice',
    id: '2451003',
    value: '2',
    sort: 2,
    added: 'FIX.Latest',
    addedEP: '282',
    tag: 2451,
    type: 'int',
    codeSet: 'SettlPriceDeterminationMethodCodeSet',
    description: 'Last bid price',
  },
  {
    name: 'LastOfferPrice',
    id: '2451004',
    value: '3',
    sort: 3,
    added: 'FIX.Latest',
    addedEP: '282',
    tag: 2451,
    type: 'int',
    codeSet: 'SettlPriceDeterminationMethodCodeSet',
    description: 'Last offer price',
  },
  {
    name: 'MidPrice',
    id: '2451005',
    value: '4',
    sort: 4,
    added: 'FIX.Latest',
    addedEP: '282',
    tag: 2451,
    type: 'int',
    codeSet: 'SettlPriceDeterminationMethodCodeSet',
    description:
      'Mid price\n\nThe price at the mid-point between last bid and last offer price.',
  },
  {
    name: 'AverageLastTradePrice',
    id: '2451006',
    value: '5',
    sort: 5,
    added: 'FIX.Latest',
    addedEP: '282',
    tag: 2451,
    type: 'int',
    codeSet: 'SettlPriceDeterminationMethodCodeSet',
    description:
      'Average last trade price\n\nThe average price across a bi-laterally agreed number of trades, e.g. last five trades.',
  },
  {
    name: 'AverageLastTradePeriod',
    id: '2451007',
    value: '6',
    sort: 6,
    added: 'FIX.Latest',
    addedEP: '282',
    tag: 2451,
    type: 'int',
    codeSet: 'SettlPriceDeterminationMethodCodeSet',
    description:
      'Average last trade period\n\nAverage price across bi-laterally agreed time period, e.g. last minute of trading.',
  },
  {
    name: 'UnderlyingPrice',
    id: '2451008',
    value: '7',
    sort: 7,
    added: 'FIX.Latest',
    addedEP: '282',
    tag: 2451,
    type: 'int',
    codeSet: 'SettlPriceDeterminationMethodCodeSet',
    description: 'Underlying price\n\nBased on price of underlying instrument.',
  },
  {
    name: 'CalculatedPrice',
    id: '2451009',
    value: '8',
    sort: 8,
    added: 'FIX.Latest',
    addedEP: '282',
    tag: 2451,
    type: 'int',
    codeSet: 'SettlPriceDeterminationMethodCodeSet',
    description: 'Calculated price\n\nOther calculation method, e.g. theoretical price.',
  },
  {
    name: 'ManualPrice',
    id: '2451010',
    value: '9',
    sort: 9,
    added: 'FIX.Latest',
    addedEP: '282',
    tag: 2451,
    type: 'int',
    codeSet: 'SettlPriceDeterminationMethodCodeSet',
    description: 'Manual price\n\nManually entered price.',
  },
  {
    name: 'Count',
    id: '2456001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description:
      'Count\n\nSimple count of entities or events, e.g. orders transactions during a period of time.',
  },
  {
    name: 'AverageVolume',
    id: '2456002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    updated: 'FIX.5.0SP2',
    updatedEP: '231',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description:
      'Average volume\n\nAverage quantity of entities, e.g. average volume of incoming quotes or average trade volume.',
  },
  {
    name: 'TotalVolume',
    id: '2456003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    updated: 'FIX.5.0SP2',
    updatedEP: '231',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description:
      'Total volume\n\nAggregated quantities of entities across events, e.g. total trade volume during a period of time.',
  },
  {
    name: 'Distribution',
    id: '2456004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description:
      'Distribution\n\nDistribution of entities across entity types, e.g. percentage of limit orders amongst all order types.',
  },
  {
    name: 'Ratio',
    id: '2456005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description:
      'Ratio\n\nPre-defined ratio between entities, e.g. ratio of trades triggered by buy orders.',
  },
  {
    name: 'Liquidity',
    id: '2456006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description:
      'Liquidity\n\nMeasurement of liquidity of an instrument, e.g. by providing the spread between bid and offer or the trade volume needed to move the price.',
  },
  {
    name: 'VWAP',
    id: '2456007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description: 'Volume weighted average price (VWAP)\n\nBenchmark price.',
  },
  {
    name: 'Volatility',
    id: '2456008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description:
      'Volatility\n\nVolatility of entities, e.g. price movements of incoming orders.',
  },
  {
    name: 'Duration',
    id: '2456009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description:
      'Duration\n\nTime period of events, e.g. resting period of passive orders.',
  },
  {
    name: 'Tick',
    id: '2456010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description: 'Tick\n\nPrice movement of an instrument in number of ticks.',
  },
  {
    name: 'AverageValue',
    id: '2456011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    updated: 'FIX.5.0SP2',
    updatedEP: '231',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description: 'Average value\n\nAverage quantity multiplied by price.',
  },
  {
    name: 'TotalValue',
    id: '2456012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    updated: 'FIX.5.0SP2',
    updatedEP: '231',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description:
      'Total value\n\nAggregated quantity multiplied by price; also described as turnover.',
  },
  {
    name: 'High',
    id: '2456013',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description: 'High\n\nHighest price.',
  },
  {
    name: 'Low',
    id: '2456014',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description: 'Low\n\nLowest price.',
  },
  {
    name: 'Midpoint',
    id: '2456015',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description: 'Midpoint\n\nMidpoint price between bid and offer.',
  },
  {
    name: 'First',
    id: '2456016',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description: 'First\n\nFirst price or initial value.',
  },
  {
    name: 'Last',
    id: '2456017',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description: 'Last\n\nMost recent price or value.',
  },
  {
    name: 'Final',
    id: '2456018',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description: 'Final\n\nFinal price or confirmed value.',
  },
  {
    name: 'ExchangeBest',
    id: '2456019',
    value: '19',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description: 'Exchange best\n\nBest price of a single venue regardless of volume.',
  },
  {
    name: 'ExchangeBestWithVolume',
    id: '2456020',
    value: '20',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description:
      'Exchange best with volume\n\nBest price of a single venue with volume at or above a pre-defined threshold.',
  },
  {
    name: 'ConsolidatedBest',
    id: '2456021',
    value: '21',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description:
      'Consolidated best\n\nBest price across multiple venues regardless of volume.',
  },
  {
    name: 'ConsolidatedBestWithVolume',
    id: '2456022',
    value: '22',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description:
      'Consolidated best with volume\n\nBest price across multiple venues with volume at or above a pre-defined threshold.',
  },
  {
    name: 'TWAP',
    id: '2456023',
    value: '23',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description: 'Time weighted average price (TWAP)',
  },
  {
    name: 'AverageDuration',
    id: '2456024',
    value: '24',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description: 'Average duration\n\nAverage duration of time periods of events.',
  },
  {
    name: 'AveragePrice',
    id: '2456025',
    value: '25',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description: 'Average price\n\nAverage price across entities e.g. trade prices.',
  },
  {
    name: 'TotalFees',
    id: '2456026',
    value: '26',
    sort: 26,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description: 'Total fees\n\nAggregated fees.',
  },
  {
    name: 'TotalBenefits',
    id: '2456027',
    value: '27',
    sort: 27,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description: 'Total benefits\n\nAggregated benefits.',
  },
  {
    name: 'MedianValue',
    id: '2456028',
    value: '28',
    sort: 28,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description:
      'Median value\n\nMedian quantity multiplied by price for orders or quotes.',
  },
  {
    name: 'AverageLiquidity',
    id: '2456029',
    value: '29',
    sort: 29,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description:
      'Average liquidity\n\nAverage liquidity of an instrument e.g. average effective spread.',
  },
  {
    name: 'MedianDuration',
    id: '2456030',
    value: '30',
    sort: 30,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2456,
    type: 'int',
    codeSet: 'MDStatisticTypeCodeSet',
    description: 'Median duration\n\nMedian duration of time periods of events.',
  },
  {
    name: 'BidPrices',
    id: '2457001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Bid prices',
  },
  {
    name: 'OfferPrices',
    id: '2457002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Offer prices',
  },
  {
    name: 'BidDepth',
    id: '2457003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Bid depth',
  },
  {
    name: 'OfferDepth',
    id: '2457004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Offer depth',
  },
  {
    name: 'Orders',
    id: '2457005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Orders',
  },
  {
    name: 'Quotes',
    id: '2457006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Quotes',
  },
  {
    name: 'OrdersAndQuotes',
    id: '2457007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Orders and Quotes',
  },
  {
    name: 'Trades',
    id: '2457008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Trades',
  },
  {
    name: 'TradePrices',
    id: '2457009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Trade prices',
  },
  {
    name: 'AuctionPrices',
    id: '2457010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Auction prices',
  },
  {
    name: 'OpeningPrices',
    id: '2457011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Opening prices',
  },
  {
    name: 'ClosingPrices',
    id: '2457012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Closing prices',
  },
  {
    name: 'SettlementPrices',
    id: '2457013',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Settlement prices',
  },
  {
    name: 'UnderlyingPrices',
    id: '2457014',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Underlying prices',
  },
  {
    name: 'OpenInterest',
    id: '2457015',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Open interest',
  },
  {
    name: 'IndexValues',
    id: '2457016',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Index values',
  },
  {
    name: 'MarginRates',
    id: '2457017',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Margin rates',
  },
  {
    name: 'Outages',
    id: '2457018',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Outages\n\nSystem halt due to a technical malfunction or failure.',
  },
  {
    name: 'ScheduledAuctions',
    id: '2457019',
    value: '19',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Scheduled auctions',
  },
  {
    name: 'ReferencePrices',
    id: '2457020',
    value: '20',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Reference prices',
  },
  {
    name: 'TradeValue',
    id: '2457021',
    value: '21',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Trade value\n\nTrade size multiplied by price.',
  },
  {
    name: 'MarketDataFeeItems',
    id: '2457022',
    value: '22',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Market data fee items\n\nFees related to market data access.',
  },
  {
    name: 'Rebates',
    id: '2457023',
    value: '23',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Rebates\n\nRebate items offered to the client.',
  },
  {
    name: 'Discounts',
    id: '2457024',
    value: '24',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Discounts\n\nDiscounts offered to the client.',
  },
  {
    name: 'Payments',
    id: '2457025',
    value: '25',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Payments\n\nOther benefits offered to the client.',
  },
  {
    name: 'Taxes',
    id: '2457026',
    value: '26',
    sort: 26,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Taxes\n\nTaxes incurred.',
  },
  {
    name: 'Levies',
    id: '2457027',
    value: '27',
    sort: 27,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Levies\n\nLevies incurred.',
  },
  {
    name: 'Benefits',
    id: '2457028',
    value: '28',
    sort: 28,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Benefits\n\nBenefits offered to the client.',
  },
  {
    name: 'Fees',
    id: '2457029',
    value: '29',
    sort: 29,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Fees',
  },
  {
    name: 'OrdersRFQs',
    id: '2457030',
    value: '30',
    sort: 30,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Orders and RFQs (Request for quotes)',
  },
  {
    name: 'MarketMakers',
    id: '2457031',
    value: '31',
    sort: 31,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Market makers',
  },
  {
    name: 'TradingInterruptions',
    id: '2457032',
    value: '32',
    sort: 32,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description:
      'Trading interruptions\n\nDisruption in trading due to an automatic or manual decision.',
  },
  {
    name: 'TradingSuspensions',
    id: '2457033',
    value: '33',
    sort: 33,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description:
      'Trading suspensions\n\nAn instrument is deliberately prevented from being quoted or traded due to a decision by execution venue or a competent authority.',
  },
  {
    name: 'NoQuotes',
    id: '2457034',
    value: '34',
    sort: 34,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'No quotes\n\nPeriod of no quotes received.',
  },
  {
    name: 'RequestForQuotes',
    id: '2457035',
    value: '35',
    sort: 35,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Request for quotes',
  },
  {
    name: 'TradeVolume',
    id: '2457036',
    value: '36',
    sort: 36,
    added: 'FIX.5.0SP2',
    addedEP: '236',
    tag: 2457,
    type: 'int',
    codeSet: 'MDStatisticScopeCodeSet',
    description: 'Trade volume\n\nQuantity traded.',
  },
  {
    name: 'Visible',
    id: '2458001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Visible\n\nOnly includes visible orders and/or quotes.',
  },
  {
    name: 'Hidden',
    id: '2458002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Hidden\n\nOnly includes hidden orders and/or quotes.',
  },
  {
    name: 'Indicative',
    id: '2458003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Indicative\n\nOnly includes IOIs and non-tradable quotes.',
  },
  {
    name: 'Tradeable',
    id: '2458004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Tradeable\n\nExcludes IOIs and indicative quotes.',
  },
  {
    name: 'Passive',
    id: '2458005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Passive\n\nOnly includes resting orders and tradeable quotes.',
  },
  {
    name: 'MarketConsensus',
    id: '2458006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description:
      'Market consensus\n\nOnly includes entities, e.g. trades, conforming to minimum requirements. Details to be defined out of band.',
  },
  {
    name: 'Power',
    id: '2458007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Power\n\nOutages due to power failure.',
  },
  {
    name: 'HardwareError',
    id: '2458008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Hardware error\n\nOutages due to a hardware malfunction or failure.',
  },
  {
    name: 'SoftwareError',
    id: '2458009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Software error\n\nOutages due to a software malfunction or failure.',
  },
  {
    name: 'NetworkError',
    id: '2458010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Network error\n\nOutages due to network error.',
  },
  {
    name: 'Failed',
    id: '2458011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Failed\n\nTransaction voided by the execution venue.',
  },
  {
    name: 'Executed',
    id: '2458012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Executed\n\nTotal or partial execution of an order or quote.',
  },
  {
    name: 'Entered',
    id: '2458013',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Entered\n\nOrder or quote entry.',
  },
  {
    name: 'Modified',
    id: '2458014',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Modified\n\nOrder or quote modification.',
  },
  {
    name: 'Cancelled',
    id: '2458015',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Cancelled\n\nOrder or quote cancellation.',
  },
  {
    name: 'MarketDataAccess',
    id: '2458016',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Market data access',
  },
  {
    name: 'TerminalAccess',
    id: '2458017',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Terminal access',
  },
  {
    name: 'Volume',
    id: '2458018',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Volume\n\nSpecifies sub-scope of market data per volume.',
  },
  {
    name: 'Cleared',
    id: '2458019',
    value: '19',
    sort: 19,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Cleared\n\nCleared trade.',
  },
  {
    name: 'Settled',
    id: '2458020',
    value: '20',
    sort: 20,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Settled\n\nSettled trade.',
  },
  {
    name: 'Other',
    id: '2458021',
    value: '21',
    sort: 21,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Other\n\nAny other fees incurred by the client.',
  },
  {
    name: 'Monetary',
    id: '2458022',
    value: '22',
    sort: 22,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Monetary\n\nMonetary benefits offered to the clients.',
  },
  {
    name: 'NonMonetary',
    id: '2458023',
    value: '23',
    sort: 23,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Non-monetary\n\nNon-monetary benefits offered to the clients',
  },
  {
    name: 'Gross',
    id: '2458024',
    value: '24',
    sort: 24,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Gross\n\nTotal fees excluding rebates and discounts.',
  },
  {
    name: 'LargeInScale',
    id: '2458025',
    value: '25',
    sort: 25,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description:
      'Large in scale\n\nMeans an order classified as large in scale in accordance with a regulatory definition.',
  },
  {
    name: 'NeitherHiddenNorLargeInScale',
    id: '2458026',
    value: '26',
    sort: 26,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description:
      'Neither hidden nor large in scale\n\nExcluding orders pending disclosures and LIS.',
  },
  {
    name: 'CorporateAction',
    id: '2458027',
    value: '27',
    sort: 27,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Corporate action\n\nSpecifies type of trading suspension.',
  },
  {
    name: 'VenueDecision',
    id: '2458028',
    value: '28',
    sort: 28,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Venue decision\n\nSpecifies type of trading suspension.',
  },
  {
    name: 'MinimumTimePeriod',
    id: '2458029',
    value: '29',
    sort: 29,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description:
      'Minimum time period\n\nMinimum time period for the event defined by scope.',
  },
  {
    name: 'Open',
    id: '2458030',
    value: '30',
    sort: 30,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description:
      'Open\n\nOpen status of RFQs (request for quotes), no quotes have been provided.',
  },
  {
    name: 'NotExecuted',
    id: '2458031',
    value: '31',
    sort: 31,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: "Not executed\n\nOrders or quotes that didn't execute.",
  },
  {
    name: 'Aggressive',
    id: '2458032',
    value: '32',
    sort: 32,
    added: 'FIX.5.0SP2',
    addedEP: '236',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description:
      'Aggressive\n\nOrder or Quote entered into the order book that took liquidity.',
  },
  {
    name: 'Directed',
    id: '2458033',
    value: '33',
    sort: 33,
    added: 'FIX.5.0SP2',
    addedEP: '236',
    tag: 2458,
    type: 'int',
    codeSet: 'MDStatisticSubScopeCodeSet',
    description: 'Directed\n\nAn order where execution venue is specified by the client.',
  },
  {
    name: 'EntryRate',
    id: '2459001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2459,
    type: 'int',
    codeSet: 'MDStatisticScopeTypeCodeSet',
    description: 'Entry rate',
  },
  {
    name: 'ModificationRate',
    id: '2459002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2459,
    type: 'int',
    codeSet: 'MDStatisticScopeTypeCodeSet',
    description: 'Modification rate',
  },
  {
    name: 'CancelRate',
    id: '2459003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2459,
    type: 'int',
    codeSet: 'MDStatisticScopeTypeCodeSet',
    description: 'Cancel rate',
  },
  {
    name: 'DownwardMove',
    id: '2459004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2459,
    type: 'int',
    codeSet: 'MDStatisticScopeTypeCodeSet',
    description: 'Downward move',
  },
  {
    name: 'UpwardMove',
    id: '2459005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2459,
    type: 'int',
    codeSet: 'MDStatisticScopeTypeCodeSet',
    description: 'Upward move',
  },
  {
    name: 'SlidingWindow',
    id: '2464001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2464,
    type: 'int',
    codeSet: 'MDStatisticIntervalTypeCodeSet',
    description:
      'Sliding window\n\nWindow is defined as an interval period up to the current time of dissemination, see MDStatisticIntervalPeriod (2466).',
  },
  {
    name: 'SlidingWindowPeak',
    id: '2464002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2464,
    type: 'int',
    codeSet: 'MDStatisticIntervalTypeCodeSet',
    description:
      'Sliding window peak\n\nHighest value of all sliding windows across date and/or time range. Omission of date/time range represents current day.',
  },
  {
    name: 'FixedDateRange',
    id: '2464003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2464,
    type: 'int',
    codeSet: 'MDStatisticIntervalTypeCodeSet',
    description:
      'Fixed date range\n\nInterval may be open ended on either side, see MDStatisticStartDate (2468) and MDStatisticEndDate(2469). Starting/ending time of date fields only apply to the first/last day of the date range. Additional time range may be defined with MDStatisticStartTime(2470) and MDStatisticEndTime(2471) and applies to every business day within date range, i.e. to define an identical time slice across days.',
  },
  {
    name: 'FixedTimeRange',
    id: '2464004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2464,
    type: 'int',
    codeSet: 'MDStatisticIntervalTypeCodeSet',
    description:
      'Fixed time range\n\nInterval may be open ended on either side, see MDStatisticStartTime(2470) and MDStatisticEndTime(2471).',
  },
  {
    name: 'CurrentTimeUnit',
    id: '2464005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2464,
    type: 'int',
    codeSet: 'MDStatisticIntervalTypeCodeSet',
    description:
      'Current time unit\n\nRelative time unit which has not ended yet, e.g. current day. Interval ends with the time of dissemination of the statistic. Requires the definition of an actual unit, see MDStatisticIntervalTypeUnit(2465).',
  },
  {
    name: 'PreviousTimeUnit',
    id: '2464006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2464,
    type: 'int',
    codeSet: 'MDStatisticIntervalTypeCodeSet',
    description:
      'Previous time unit\n\nRelative time unit which has ended in the past. Requires the definition of an actual unit, see MDStatisticIntervalTypeUnit(2465).',
  },
  {
    name: 'MaximumRange',
    id: '2464007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2464,
    type: 'int',
    codeSet: 'MDStatisticIntervalTypeCodeSet',
    description:
      'Maximum range\n\nUse to convey record values over the lifetime of the system or venue.',
  },
  {
    name: 'MaximumRangeUpToPreviousTimeUnit',
    id: '2464008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2464,
    type: 'int',
    codeSet: 'MDStatisticIntervalTypeCodeSet',
    description:
      'Maximum range up to previous time unit\n\nUse to convey record values over the lifetime of the system or venue but does not include the most recent time unit as it has not completed yet. Requires the definition of an actual unit, see MDStatisticIntervalTypeUnit(2465)',
  },
  {
    name: 'BuyersToSellers',
    id: '2472001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2472,
    type: 'int',
    codeSet: 'MDStatisticRatioTypeCodeSet',
    description: 'Buyers to sellers\n\n',
  },
  {
    name: 'UpticksToDownticks',
    id: '2472002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2472,
    type: 'int',
    codeSet: 'MDStatisticRatioTypeCodeSet',
    description:
      'Upticks to downticks\n\nCan also be used with a scope of multiple instruments representing an index.',
  },
  {
    name: 'MarketMakerToNonMarketMaker',
    id: '2472003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2472,
    type: 'int',
    codeSet: 'MDStatisticRatioTypeCodeSet',
    description:
      'Market maker to non-market maker\n\nUse to identify share of market making activity.',
  },
  {
    name: 'AutomatedToNonAutomated',
    id: '2472004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2472,
    type: 'int',
    codeSet: 'MDStatisticRatioTypeCodeSet',
    description:
      'Automated to non-automated\n\nUse to identify ratio of orders and quotes resulting from automated trading.',
  },
  {
    name: 'OrdersToTrades',
    id: '2472005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2472,
    type: 'int',
    codeSet: 'MDStatisticRatioTypeCodeSet',
    description: 'Orders to trades\n\nUse with scope of trades.',
  },
  {
    name: 'QuotesToTrades',
    id: '2472006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2472,
    type: 'int',
    codeSet: 'MDStatisticRatioTypeCodeSet',
    description: 'Quotes to trades\n\nUse with scope of trades.',
  },
  {
    name: 'OrdersAndQuotesToTrades',
    id: '2472007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2472,
    type: 'int',
    codeSet: 'MDStatisticRatioTypeCodeSet',
    description: 'Orders and quotes to trades\n\nUse with scope of trades.',
  },
  {
    name: 'FailedToTotalTradedValue',
    id: '2472008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2472,
    type: 'int',
    codeSet: 'MDStatisticRatioTypeCodeSet',
    description:
      'Failed to total traded value\n\nTotal value of failed trades over total traded value.',
  },
  {
    name: 'BenefitsToTotalTradedValue',
    id: '2472009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2472,
    type: 'int',
    codeSet: 'MDStatisticRatioTypeCodeSet',
    description:
      'Benefits to total traded value\n\nTotal value of all benefits over total traded value.',
  },
  {
    name: 'FeesToTotalTradedValue',
    id: '2472010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2472,
    type: 'int',
    codeSet: 'MDStatisticRatioTypeCodeSet',
    description:
      'Fees to total traded value\n\nTotal value of all fees excluding rebates over total traded value.',
  },
  {
    name: 'TradeVolumeToTotalTradedVolume',
    id: '2472011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '236',
    tag: 2472,
    type: 'int',
    codeSet: 'MDStatisticRatioTypeCodeSet',
    description:
      'Trade volume to total traded volume\n\nTotal value of failed trades over total traded value.',
  },
  {
    name: 'OrdersToTotalNumberOrders',
    id: '2472012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '236',
    tag: 2472,
    type: 'int',
    codeSet: 'MDStatisticRatioTypeCodeSet',
    description:
      'Orders to total number of orders\n\nOrders pertaining to a type over total number of orders.',
  },
  {
    name: 'Successful',
    id: '2473001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Successful (default)',
  },
  {
    name: 'InvalidOrUnknownMarket',
    id: '2473002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Invalid or unknown market',
  },
  {
    name: 'InvalidOrUnknownMarketSegment',
    id: '2473003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Invalid or unknown market segment',
  },
  {
    name: 'InvalidOrUnknownSecurityList',
    id: '2473004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Invalid or unknown security list',
  },
  {
    name: 'InvalidOrUnknownInstruments',
    id: '2473005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Invalid or unknown instrument(s)',
  },
  {
    name: 'InvalidParties',
    id: '2473006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Invalid parties',
  },
  {
    name: 'TradeDateOutOfSupportedRange',
    id: '2473007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Trade date out of supported range',
  },
  {
    name: 'UnsupportedStatisticType',
    id: '2473008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Statistic type not supported',
  },
  {
    name: 'UnsupportedScopeOrSubScope',
    id: '2473009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Scope or sub-scope not supported',
  },
  {
    name: 'UnsupportedScopeType',
    id: '2473010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Scope type not supported',
  },
  {
    name: 'MarketDepthNotSupported',
    id: '2473011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Market depth not supported',
  },
  {
    name: 'FrequencyNotSupported',
    id: '2473012',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Frequency not supported',
  },
  {
    name: 'UnsupportedStatisticInterval',
    id: '2473013',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Statistic interval not supported',
  },
  {
    name: 'UnsupportedStatisticDateRange',
    id: '2473014',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Statistic date range not supported',
  },
  {
    name: 'UnsupportedStatisticTimeRange',
    id: '2473015',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Statistic time range not supported',
  },
  {
    name: 'UnsupportedRatioType',
    id: '2473016',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Ratio type not supported',
  },
  {
    name: 'InvalidOrUnknownTradeInputSource',
    id: '2473017',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Invalid or unknown trade input source',
  },
  {
    name: 'InvalidOrUnknownTradingSession',
    id: '2473018',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Invalid or unknown trading session',
  },
  {
    name: 'UnauthorizedForStatisticRequest',
    id: '2473019',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Unauthorized for statistic request',
  },
  {
    name: 'Other',
    id: '2473020',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2473,
    type: 'int',
    codeSet: 'MDStatisticRequestResultCodeSet',
    description: 'Other (further information in Text (58) field)',
  },
  {
    name: 'Active',
    id: '2477001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2477,
    type: 'int',
    codeSet: 'MDStatisticStatusCodeSet',
    description: 'Active (default)',
  },
  {
    name: 'Inactive',
    id: '2477002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2477,
    type: 'int',
    codeSet: 'MDStatisticStatusCodeSet',
    description: 'Inactive (not disseminated)',
  },
  {
    name: 'Absolute',
    id: '2479001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2479,
    type: 'int',
    codeSet: 'MDStatisticValueTypeCodeSet',
    description: 'Absolute',
  },
  {
    name: 'Percentage',
    id: '2479002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '191',
    tag: 2479,
    type: 'int',
    codeSet: 'MDStatisticValueTypeCodeSet',
    description: 'Percentage',
  },
  {
    name: 'Financials',
    id: '2210001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 2210,
    type: 'int',
    codeSet: 'AssetGroupCodeSet',
    description:
      'Financials\n\nA categorization which usually includes rates, foreign exchange, credit, bonds and equity products or assets.',
  },
  {
    name: 'Commodities',
    id: '2210002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 2210,
    type: 'int',
    codeSet: 'AssetGroupCodeSet',
    description:
      'Commodities\n\nA categorization which usually includes hard commodities such as agricultural, metals, freight, energy products or assets.',
  },
  {
    name: 'AlternativeInvestments',
    id: '2210003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 2210,
    type: 'int',
    codeSet: 'AssetGroupCodeSet',
    description:
      'Alternative investments\n\nA categorization which usually includes weather, housing, and commodity indices products or assets.',
  },
  {
    name: 'UnknownTrade',
    id: '2487001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 2487,
    type: 'int',
    codeSet: 'CollRptRejectReasonCodeSet',
    description: 'Unknown trade or transaction',
  },
  {
    name: 'UnknownInstrument',
    id: '2487002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 2487,
    type: 'int',
    codeSet: 'CollRptRejectReasonCodeSet',
    description: 'Unknown or invalid instrument',
  },
  {
    name: 'UnknownCounterparty',
    id: '2487003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 2487,
    type: 'int',
    codeSet: 'CollRptRejectReasonCodeSet',
    description: 'Unknown or invalid counterparty',
  },
  {
    name: 'UnknownPosition',
    id: '2487004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 2487,
    type: 'int',
    codeSet: 'CollRptRejectReasonCodeSet',
    description: 'Unknown or invalid position',
  },
  {
    name: 'UnacceptableCollateral',
    id: '2487005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 2487,
    type: 'int',
    codeSet: 'CollRptRejectReasonCodeSet',
    description: 'Unacceptable or invalid type of collateral',
  },
  {
    name: 'Other',
    id: '2487006',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 2487,
    type: 'int',
    codeSet: 'CollRptRejectReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'Accepted',
    id: '2488001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 2488,
    type: 'int',
    codeSet: 'CollRptStatusCodeSet',
    description: 'Accepted (successfully processed)',
  },
  {
    name: 'Received',
    id: '2488002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 2488,
    type: 'int',
    codeSet: 'CollRptStatusCodeSet',
    description: 'Received (not yet processed)',
  },
  {
    name: 'Rejected',
    id: '2488003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '192',
    tag: 2488,
    type: 'int',
    codeSet: 'CollRptStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'ASWSpread',
    id: '2530001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '194',
    tag: 2530,
    type: 'int',
    codeSet: 'RelativeValueTypeCodeSet',
    description:
      "Asset Swap Spread\n\nASW Spread. The asset swap spread is the difference in the bond's yield (yield to maturity) and a floating interest rate (usually LIBOR), expressed in basis points.",
  },
  {
    name: 'OIS',
    id: '2530002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '194',
    tag: 2530,
    type: 'int',
    codeSet: 'RelativeValueTypeCodeSet',
    description:
      'Overnight Indexed Swap Spread\n\nOIS Spread. The overnight indexed swap spread is the spread, expressed in basis points, between the bond yield (the fixed rate) and an overnight indexed rate (e.g. Fed Funds rate, EONIA, SONIA, etc.) (the floating rate).',
  },
  {
    name: 'ZSpread',
    id: '2530003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '194',
    tag: 2530,
    type: 'int',
    codeSet: 'RelativeValueTypeCodeSet',
    description:
      'Zero Volatility Spread\n\nZ-Spread. The zero coupon spread is the constant spread added to the reference zero coupon yield curve (usually Treasury spot rate curve), expressed in basis points, to derive the adjusted yield curve used to determine the present value of the cash flows so that it equals the dirty price of the bond (i.e. accrued interested factored in).',
  },
  {
    name: 'DiscountMargin',
    id: '2530004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '194',
    tag: 2530,
    type: 'int',
    codeSet: 'RelativeValueTypeCodeSet',
    description:
      "Discount Margin\n\nThe DM is the spread, expressed in basis points, added to the bond's reference rate that will equate the bond's cash flows to its current price.",
  },
  {
    name: 'ISpread',
    id: '2530005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '194',
    tag: 2530,
    type: 'int',
    codeSet: 'RelativeValueTypeCodeSet',
    description:
      'Interpolated Spread\n\nI-Spread or I-Curve spread. The spread, expressed in basis points, added to an interpolated point on the reference yield curve.',
  },
  {
    name: 'OAS',
    id: '2530006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '194',
    tag: 2530,
    type: 'int',
    codeSet: 'RelativeValueTypeCodeSet',
    description:
      "Option Adjusted Spread\n\nOAS or OA-spread. Used to evaluate bonds with embedded (callable or put-able) options. The option adjusted spread is a constant spread, expressed in basis points, applied to each point on the spot rate curve (usually Treasury spot rate curve) where the bond's cash flow is received, such that the price of the bond is the same as the present value of its cash flows.",
  },
  {
    name: 'GSpread',
    id: '2530007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '194',
    tag: 2530,
    type: 'int',
    codeSet: 'RelativeValueTypeCodeSet',
    description:
      "G-Spread\n\nThe spread difference between the bond's yield and the interpolated yield from the government reference yield curve, expressed in basis points. It represents the curve adjusted value of the bond by accounting for the difference between the bond's benchmark yield and the interpolated government reference yield at the same point on the curve that matches the bond's remaining life.",
  },
  {
    name: 'CDSBasis',
    id: '2530008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '194',
    tag: 2530,
    type: 'int',
    codeSet: 'RelativeValueTypeCodeSet',
    description:
      'CDS Basis\n\nAlso referred to as CDS Bond Basis. The CDS basis is the spread difference between the CDS spread or premium for the obligor and the Z-Spread or the ASW spread of the same reference or obligor bond, expressed in basis points.',
  },
  {
    name: 'CDSInterpolatedBasis',
    id: '2530009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '194',
    tag: 2530,
    type: 'int',
    codeSet: 'RelativeValueTypeCodeSet',
    description:
      "CDS Interpolated Basis\n\nAlso referred to as CDS Bond Interpolated Basis. The CDS interpolated basis is the difference between the reference or obligor bond's Z Spread or ASW spread and an interpolated point on CDS curve that matches the maturity of the reference bond, expressed in basis points.",
  },
  {
    name: 'DV01',
    id: '2530010',
    value: '10',
    sort: 10,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 2530,
    type: 'int',
    codeSet: 'RelativeValueTypeCodeSet',
    description:
      'DV01\n\nThe currency value change in response to a move of one basis point in the yield of the instrument. Typically used as a measure of interest rate risk of a single bond. Also known as "basis point value" or BPV.',
  },
  {
    name: 'PV01',
    id: '2530011',
    value: '11',
    sort: 11,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 2530,
    type: 'int',
    codeSet: 'RelativeValueTypeCodeSet',
    description:
      'PV01\n\nThe present value change in response to a move of one basis point all along the yield curve used for the instrument. In certain cases the DV01 and PV01 values may be the same.',
  },
  {
    name: 'CS01',
    id: '2530012',
    value: '12',
    sort: 12,
    added: 'FIX.Latest',
    addedEP: '272',
    tag: 2530,
    type: 'int',
    codeSet: 'RelativeValueTypeCodeSet',
    description:
      'CS01\n\nCredit spread sensitivity. Represents the change in value of a (CDS) transaction for a one basis point change in the credit spread.',
  },
  {
    name: 'Bid',
    id: '2532001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '194',
    tag: 2532,
    type: 'int',
    codeSet: 'RelativeValueSideCodeSet',
    description: 'Bid',
  },
  {
    name: 'Mid',
    id: '2532002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '194',
    tag: 2532,
    type: 'int',
    codeSet: 'RelativeValueSideCodeSet',
    description: 'Mid',
  },
  {
    name: 'Offer',
    id: '2532003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '194',
    tag: 2532,
    type: 'int',
    codeSet: 'RelativeValueSideCodeSet',
    description: 'Offer',
  },
  {
    name: 'StartInstrumentRefData',
    id: '2535001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2535,
    type: 'int',
    codeSet: 'MDReportEventCodeSet',
    description: 'Start of instrument reference data\n\n',
  },
  {
    name: 'EndInstrumentRefData',
    id: '2535002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2535,
    type: 'int',
    codeSet: 'MDReportEventCodeSet',
    description: 'End of instrument reference data\n\n',
  },
  {
    name: 'StartOffMarketTrades',
    id: '2535003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2535,
    type: 'int',
    codeSet: 'MDReportEventCodeSet',
    description: 'Start of off-market trades\n\n',
  },
  {
    name: 'EndOffMarketTrades',
    id: '2535004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2535,
    type: 'int',
    codeSet: 'MDReportEventCodeSet',
    description: 'End of off-market trades\n\n',
  },
  {
    name: 'StartOrderBookTrades',
    id: '2535005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2535,
    type: 'int',
    codeSet: 'MDReportEventCodeSet',
    description: 'Start of order book trades\n\n',
  },
  {
    name: 'EndOrderBookTrades',
    id: '2535006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2535,
    type: 'int',
    codeSet: 'MDReportEventCodeSet',
    description: 'End of order book trades\n\n',
  },
  {
    name: 'StartOpenInterest',
    id: '2535007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2535,
    type: 'int',
    codeSet: 'MDReportEventCodeSet',
    description: 'Start of open interest\n\n',
  },
  {
    name: 'EndOpenInterest',
    id: '2535008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2535,
    type: 'int',
    codeSet: 'MDReportEventCodeSet',
    description: 'End of open interest\n\n',
  },
  {
    name: 'StartSettlementPrices',
    id: '2535009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2535,
    type: 'int',
    codeSet: 'MDReportEventCodeSet',
    description: 'Start of settlement prices\n\n',
  },
  {
    name: 'EndSettlementPrices',
    id: '2535010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2535,
    type: 'int',
    codeSet: 'MDReportEventCodeSet',
    description: 'End of settlement prices\n\n',
  },
  {
    name: 'StartStatsRefData',
    id: '2535011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2535,
    type: 'int',
    codeSet: 'MDReportEventCodeSet',
    description: 'Start of statistics reference data\n\n',
  },
  {
    name: 'EndStatsRefData',
    id: '2535012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2535,
    type: 'int',
    codeSet: 'MDReportEventCodeSet',
    description: 'End of statistics reference data\n\n',
  },
  {
    name: 'StartStatistics',
    id: '2535013',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2535,
    type: 'int',
    codeSet: 'MDReportEventCodeSet',
    description: 'Start of statistics\n\n',
  },
  {
    name: 'EndStatistics',
    id: '2535014',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2535,
    type: 'int',
    codeSet: 'MDReportEventCodeSet',
    description: 'End of statistics\n\n',
  },
  {
    name: 'Active',
    id: '2542001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2542,
    type: 'int',
    codeSet: 'MarketSegmentStatusCodeSet',
    description: 'Active\n\nMarket segment is active, i.e. trading is possible.',
  },
  {
    name: 'Inactive',
    id: '2542002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2542,
    type: 'int',
    codeSet: 'MarketSegmentStatusCodeSet',
    description:
      'Inactive\n\nMarket segment has previously been active and is now inactive.',
  },
  {
    name: 'Published',
    id: '2542003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2542,
    type: 'int',
    codeSet: 'MarketSegmentStatusCodeSet',
    description:
      'Published\n\nMarket segment information is provided prior to its first activation.',
  },
  {
    name: 'Pool',
    id: '2543001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2543,
    type: 'int',
    codeSet: 'MarketSegmentTypeCodeSet',
    description:
      'Pool\n\nUsed when multiple market segments are being grouped or pooled together.',
  },
  {
    name: 'Retail',
    id: '2543002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2543,
    type: 'int',
    codeSet: 'MarketSegmentTypeCodeSet',
    description: 'Retail\n\n',
  },
  {
    name: 'Wholesale',
    id: '2543003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2543,
    type: 'int',
    codeSet: 'MarketSegmentTypeCodeSet',
    description: 'Wholesale\n\n',
  },
  {
    name: 'InterProductSpread',
    id: '2544001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2544,
    type: 'int',
    codeSet: 'MarketSegmentSubTypeCodeSet',
    description:
      'Inter-product spread\n\nComplex instruments which consist of leg instruments from different products, e.g. a location spread which include country-specific products in each leg instrument.',
  },
  {
    name: 'MarketSegmentPoolMember',
    id: '2547001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2547,
    type: 'int',
    codeSet: 'MarketSegmentRelationshipCodeSet',
    description:
      'Market segment pool member\n\nMarket segments represent constituents of the pool identified.',
  },
  {
    name: 'RetailSegment',
    id: '2547002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2547,
    type: 'int',
    codeSet: 'MarketSegmentRelationshipCodeSet',
    description:
      'Retail segment\n\nRetail segment related to wholesale segment identified.',
  },
  {
    name: 'WholesaleSegment',
    id: '2547003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2547,
    type: 'int',
    codeSet: 'MarketSegmentRelationshipCodeSet',
    description:
      'Wholesale segment\n\nWholesale segment related to retail segment identified.',
  },
  {
    name: 'No',
    id: '2559001',
    value: 'N',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2559,
    type: 'Boolean',
    codeSet: 'QuoteSideIndicatorCodeSet',
    description: 'Single sided quotes are not allowed\n\n',
  },
  {
    name: 'Yes',
    id: '2559002',
    value: 'Y',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2559,
    type: 'Boolean',
    codeSet: 'QuoteSideIndicatorCodeSet',
    description: 'Single sided quotes are allowed\n\n',
  },
  {
    name: 'NoPriority',
    id: '2570001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2570,
    type: 'int',
    codeSet: 'CustomerPriorityCodeSet',
    description: 'No priority\n\n',
  },
  {
    name: 'UnconditionalPriority',
    id: '2570002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2570,
    type: 'int',
    codeSet: 'CustomerPriorityCodeSet',
    description: 'Unconditional priority\n\n',
  },
  {
    name: 'Shares',
    id: '2579001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2579,
    type: 'int',
    codeSet: 'SettlSubMethodCodeSet',
    description: 'Shares\n\n',
  },
  {
    name: 'Derivatives',
    id: '2579002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2579,
    type: 'int',
    codeSet: 'SettlSubMethodCodeSet',
    description: 'Derivatives\n\n',
  },
  {
    name: 'PaymentVsPayment',
    id: '2579003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2579,
    type: 'int',
    codeSet: 'SettlSubMethodCodeSet',
    description: 'Payment vs payment\n\n',
  },
  {
    name: 'Notional',
    id: '2579004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2579,
    type: 'int',
    codeSet: 'SettlSubMethodCodeSet',
    description: 'Notional\n\n',
  },
  {
    name: 'Cascade',
    id: '2579005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2579,
    type: 'int',
    codeSet: 'SettlSubMethodCodeSet',
    description: 'Cascade\n\n',
  },
  {
    name: 'Repurchase',
    id: '2579006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2579,
    type: 'int',
    codeSet: 'SettlSubMethodCodeSet',
    description: 'Repurchase\n\n',
  },
  {
    name: 'Other',
    id: '2579007',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2579,
    type: 'int',
    codeSet: 'SettlSubMethodCodeSet',
    description: 'Other\n\n',
  },
  {
    name: 'Automatic',
    id: '2592001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2592,
    type: 'int',
    codeSet: 'CalculationMethodCodeSet',
    description: 'Automatic (default)\n\n',
  },
  {
    name: 'Manual',
    id: '2592002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '195',
    tag: 2592,
    type: 'int',
    codeSet: 'CalculationMethodCodeSet',
    description: 'Manual\n\n',
  },
  {
    name: 'MarketValuation',
    id: '2632001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '197',
    tag: 2632,
    type: 'int',
    codeSet: 'CollateralAmountTypeCodeSet',
    description: 'Market valuation (the default)',
  },
  {
    name: 'PortfolioValue',
    id: '2632002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '197',
    tag: 2632,
    type: 'int',
    codeSet: 'CollateralAmountTypeCodeSet',
    description: 'Portfolio value before processing pledge request',
  },
  {
    name: 'ValueConfirmed',
    id: '2632003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '197',
    tag: 2632,
    type: 'int',
    codeSet: 'CollateralAmountTypeCodeSet',
    description: 'Value confirmed as "locked-up" for processing a pledge request',
  },
  {
    name: 'CollateralCreditValue',
    id: '2632004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '197',
    tag: 2632,
    type: 'int',
    codeSet: 'CollateralAmountTypeCodeSet',
    description: 'Credit value of collateral at CCP processing a pledge request',
  },
  {
    name: 'AdditionalCollateralValue',
    id: '2632005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '227',
    tag: 2632,
    type: 'int',
    codeSet: 'CollateralAmountTypeCodeSet',
    description:
      'Additional collateral value\n\nAdditional collateral deposited by the collateral provider at trade or post-trade. CollateralPercentOverage(2690) gives the overage percent',
  },
  {
    name: 'EstimatedMarketValuation',
    id: '2632006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 2632,
    type: 'int',
    codeSet: 'CollateralAmountTypeCodeSet',
    description:
      'Estimated market valuation\n\nEstimated market valuation of collateral. In the context of EU SFTR this may be used for value of re-use of collateral.',
  },
  {
    name: 'Unspecified',
    id: '2641001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '204',
    tag: 2641,
    type: 'int',
    codeSet: 'CommissionAmountTypeCodeSet',
    description: 'Unspecified',
  },
  {
    name: 'Acceptance',
    id: '2641002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '204',
    tag: 2641,
    type: 'int',
    codeSet: 'CommissionAmountTypeCodeSet',
    description: "Acceptance\n\nThe bank's charge for issuing a Letter of Credit.",
  },
  {
    name: 'Broker',
    id: '2641003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '204',
    tag: 2641,
    type: 'int',
    codeSet: 'CommissionAmountTypeCodeSet',
    description: "Broker\n\nThe executing broker's commission.",
  },
  {
    name: 'ClearingBroker',
    id: '2641004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '204',
    tag: 2641,
    type: 'int',
    codeSet: 'CommissionAmountTypeCodeSet',
    description: "Clearing broker\n\nThe clearing broker's commission.",
  },
  {
    name: 'Retail',
    id: '2641005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '204',
    tag: 2641,
    type: 'int',
    codeSet: 'CommissionAmountTypeCodeSet',
    description: 'Retail\n\nCommission charged by or related to retail sales.',
  },
  {
    name: 'SalesCommission',
    id: '2641006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '204',
    tag: 2641,
    type: 'int',
    codeSet: 'CommissionAmountTypeCodeSet',
    description: 'Sales commission\n\nThe commission charged by the sales desk.',
  },
  {
    name: 'LocalCommission',
    id: '2641007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '204',
    tag: 2641,
    type: 'int',
    codeSet: 'CommissionAmountTypeCodeSet',
    description:
      'Local commission\n\nCommission paid to local broker in a cross-border transaction.',
  },
  {
    name: 'ResearchPayment',
    id: '2641008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '233',
    updated: 'FIX.5.0SP2',
    updatedEP: '240',
    tag: 2641,
    type: 'int',
    codeSet: 'CommissionAmountTypeCodeSet',
    description: 'Research payment',
  },
  {
    name: 'Close',
    id: '42217001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42217,
    type: 'int',
    codeSet: 'CashSettlPriceDefaultCodeSet',
    description: 'Close\n\nOfficial closing price.',
  },
  {
    name: 'Hedge',
    id: '42217002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42217,
    type: 'int',
    codeSet: 'CashSettlPriceDefaultCodeSet',
    description: 'Hedge\n\nDetermined by the hedging party.',
  },
  {
    name: 'Close',
    id: '2599001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 2599,
    type: 'int',
    codeSet: 'ComplexEventPVFinalPriceElectionFallbackCodeSet',
    description:
      'Close\n\nIn respect of the "early final valuation date", the provisions for "future present value close" shall apply.',
  },
  {
    name: 'HedgeElection',
    id: '2599002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 2599,
    type: 'int',
    codeSet: 'ComplexEventPVFinalPriceElectionFallbackCodeSet',
    description:
      'Hedge election\n\nIn respect of the "early final valuation date", the provisions for "future present value hedge execution" shall apply.',
  },
  {
    name: 'ExDate',
    id: '42246001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42246,
    type: 'int',
    codeSet: 'DividendEntitlementEventCodeSet',
    description: 'Ex-date\n\nDividend entitlement is on the dividend ex-date.',
  },
  {
    name: 'RecordDate',
    id: '42246002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42246,
    type: 'int',
    codeSet: 'DividendEntitlementEventCodeSet',
    description: 'Record date\n\nDividend entitlement is on the dividend record date.',
  },
  {
    name: 'RecordAmount',
    id: '42247001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42247,
    type: 'int',
    codeSet: 'DividendAmountTypeCodeSet',
    description:
      'Record amount\n\n100% of the gross cash dividend per share paid over record date during relevant dividend period.',
  },
  {
    name: 'ExAmount',
    id: '42247002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42247,
    type: 'int',
    codeSet: 'DividendAmountTypeCodeSet',
    description:
      'Ex amount\n\n100% of gross cash dividend per share paid after the ex-dividend date during relevant dividend period.',
  },
  {
    name: 'PaidAmount',
    id: '42247003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42247,
    type: 'int',
    codeSet: 'DividendAmountTypeCodeSet',
    description:
      'Paid amount\n\n100% of gross cash dividend per share paid during relevant dividend period.',
  },
  {
    name: 'PerMasterConfirm',
    id: '42247004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42247,
    type: 'int',
    codeSet: 'DividendAmountTypeCodeSet',
    description:
      'As specified in master confirmation\n\nThe amount is determined as provided in the relevant master confirmation.',
  },
  {
    name: 'PotentialAdjustment',
    id: '42258001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42258,
    type: 'int',
    codeSet: 'NonCashDividendTreatmentCodeSet',
    description:
      'Potential adjustment event\n\nThe treatment of any non-cash dividend shall be determined in accordance with the potential adjustment event provisions.',
  },
  {
    name: 'CashEquivalent',
    id: '42258002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42258,
    type: 'int',
    codeSet: 'NonCashDividendTreatmentCodeSet',
    description:
      'Cash equivalent\n\nAny non-cash dividend shall be treated as a declared cash equivalent dividend.',
  },
  {
    name: 'EquityAmountReceiver',
    id: '42259001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42259,
    type: 'int',
    codeSet: 'DividendCompositionCodeSet',
    description:
      'Equity amount receiver election\n\nThe equity amount receiver determines the composition of dividends (subject to conditions).',
  },
  {
    name: 'CalculationAgent',
    id: '42259002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42259,
    type: 'int',
    codeSet: 'DividendCompositionCodeSet',
    description:
      'Calculation agent election\n\nThe calculation agent determines the composition of dividends (subject to conditions).',
  },
  {
    name: 'Bid',
    id: '2601001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 2601,
    type: 'int',
    codeSet: 'StrikeIndexQuoteCodeSet',
    description: 'Bid\n\n',
  },
  {
    name: 'Mid',
    id: '2601002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 2601,
    type: 'int',
    codeSet: 'StrikeIndexQuoteCodeSet',
    description: 'Mid',
  },
  {
    name: 'Offer',
    id: '2601003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 2601,
    type: 'int',
    codeSet: 'StrikeIndexQuoteCodeSet',
    description: 'Offer',
  },
  {
    name: 'CalculationAgent',
    id: '2602001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 2602,
    type: 'int',
    codeSet: 'ExtraordinaryEventAdjustmentMethodCodeSet',
    description:
      'Calculation agent\n\nThe Calculation Agent has the right to adjust the terms of the trade following a corporate action.',
  },
  {
    name: 'OptionsExchange',
    id: '2602002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 2602,
    type: 'int',
    codeSet: 'ExtraordinaryEventAdjustmentMethodCodeSet',
    description:
      'Options exchange\n\nThe trade will be adjusted in accordance with any adjustment made by the exchange on which options on the underlying are listed.',
  },
  {
    name: 'Initial',
    id: '42604001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42604,
    type: 'int',
    codeSet: 'PaymentStreamInterpolationPeriodCodeSet',
    description: 'Initial\n\nInterpolation is applicable to the initial period only.',
  },
  {
    name: 'InitialAndFinal',
    id: '42604002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42604,
    type: 'int',
    codeSet: 'PaymentStreamInterpolationPeriodCodeSet',
    description:
      'Initial and final\n\nInterpolation is applicable to the initial and final periods only.',
  },
  {
    name: 'Final',
    id: '42604003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42604,
    type: 'int',
    codeSet: 'PaymentStreamInterpolationPeriodCodeSet',
    description: 'Final\n\nInterpolation is applicable to the final period only.',
  },
  {
    name: 'AnyPeriod',
    id: '42604004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42604,
    type: 'int',
    codeSet: 'PaymentStreamInterpolationPeriodCodeSet',
    description: 'Any period\n\nInterpolation is applicable to any non-standard period.',
  },
  {
    name: 'Volatility',
    id: '42674001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42674,
    type: 'int',
    codeSet: 'PaymentStreamLinkStrikePriceTypeCodeSet',
    description: 'Volatility',
  },
  {
    name: 'Variance',
    id: '42674002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42674,
    type: 'int',
    codeSet: 'PaymentStreamLinkStrikePriceTypeCodeSet',
    description: 'Variance',
  },
  {
    name: 'Previous',
    id: '42679001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42679,
    type: 'int',
    codeSet: 'PaymentStreamRealizedVarianceMethodCodeSet',
    description:
      'Previous\n\nFor a return on day T, the observed price on T-1 must be in range.',
  },
  {
    name: 'Last',
    id: '42679002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42679,
    type: 'int',
    codeSet: 'PaymentStreamRealizedVarianceMethodCodeSet',
    description:
      'Last\n\nFor a return on day T, the observed price on T must be in range.',
  },
  {
    name: 'Both',
    id: '42679003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42679,
    type: 'int',
    codeSet: 'PaymentStreamRealizedVarianceMethodCodeSet',
    description:
      'Both\n\nFor a return on day T, the observed prices on both T and T-1 must be in range.',
  },
  {
    name: 'FlatFee',
    id: '42707001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42707,
    type: 'int',
    codeSet: 'ProvisionBreakFeeElectionCodeSet',
    description: 'Flat fee',
  },
  {
    name: 'AmortizedFee',
    id: '42707002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42707,
    type: 'int',
    codeSet: 'ProvisionBreakFeeElectionCodeSet',
    description: 'Amortized fee',
  },
  {
    name: 'FundingFee',
    id: '42707003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42707,
    type: 'int',
    codeSet: 'ProvisionBreakFeeElectionCodeSet',
    description: 'Funding fee',
  },
  {
    name: 'FlatAndFundingFee',
    id: '42707004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42707,
    type: 'int',
    codeSet: 'ProvisionBreakFeeElectionCodeSet',
    description: 'Flat fee and funding fee',
  },
  {
    name: 'AmortizedAndFundingFee',
    id: '42707005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42707,
    type: 'int',
    codeSet: 'ProvisionBreakFeeElectionCodeSet',
    description: 'Amortized fee and funding fee',
  },
  {
    name: 'PriceValuation',
    id: '42710001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42710,
    type: 'int',
    codeSet: 'ReturnRateDateModeCodeSet',
    description: 'Price valuation',
  },
  {
    name: 'DividendValuation',
    id: '42710002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42710,
    type: 'int',
    codeSet: 'ReturnRateDateModeCodeSet',
    description: 'Dividend valuation',
  },
  {
    name: 'Initial',
    id: '42736001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42736,
    type: 'int',
    codeSet: 'ReturnRatePriceSequenceCodeSet',
    description: 'Initial',
  },
  {
    name: 'Interim',
    id: '42736002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42736,
    type: 'int',
    codeSet: 'ReturnRatePriceSequenceCodeSet',
    description: 'Interim',
  },
  {
    name: 'Final',
    id: '42736003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42736,
    type: 'int',
    codeSet: 'ReturnRatePriceSequenceCodeSet',
    description: 'Final',
  },
  {
    name: 'Open',
    id: '42748001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42748,
    type: 'int',
    codeSet: 'ReturnRateQuoteTimeTypeCodeSet',
    description: 'Open\n\nThe official opening time of the exchange on valuation date.',
  },
  {
    name: 'OfficialSettlPx',
    id: '42748002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42748,
    type: 'int',
    codeSet: 'ReturnRateQuoteTimeTypeCodeSet',
    description:
      'Official settlement price time\n\nThe time at which the official settlement price is determined.',
  },
  {
    name: 'Xetra',
    id: '42748003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42748,
    type: 'int',
    codeSet: 'ReturnRateQuoteTimeTypeCodeSet',
    description:
      'XETRA\n\nThe time at which the official settlement price (following the auction by the exchange) is determined by the exchange.',
  },
  {
    name: 'Close',
    id: '42748004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42748,
    type: 'int',
    codeSet: 'ReturnRateQuoteTimeTypeCodeSet',
    description: 'Close\n\nThe official closing time of the exchange on valuation date.',
  },
  {
    name: 'DerivativesClose',
    id: '42748005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42748,
    type: 'int',
    codeSet: 'ReturnRateQuoteTimeTypeCodeSet',
    description:
      'Derivatives close\n\nThe official closing time for derivative trading of the exchange on valuation date.',
  },
  {
    name: 'High',
    id: '42748006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42748,
    type: 'int',
    codeSet: 'ReturnRateQuoteTimeTypeCodeSet',
    description: 'High\n\nThe high price for the day.',
  },
  {
    name: 'Low',
    id: '42748007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42748,
    type: 'int',
    codeSet: 'ReturnRateQuoteTimeTypeCodeSet',
    description: 'Low\n\nThe low price for the day.',
  },
  {
    name: 'AsSpecifiedInMasterConfirmation',
    id: '42748008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42748,
    type: 'int',
    codeSet: 'ReturnRateQuoteTimeTypeCodeSet',
    description: 'As specified in the master confirmation',
  },
  {
    name: 'None',
    id: '42759001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42759,
    type: 'int',
    codeSet: 'ReturnRateValuationPriceOptionCodeSet',
    description: 'None (the default)',
  },
  {
    name: 'FuturesPrice',
    id: '42759002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42759,
    type: 'int',
    codeSet: 'ReturnRateValuationPriceOptionCodeSet',
    description:
      'Futures price\n\nThe official settlement price as announced by the related futures exchange is applicable.',
  },
  {
    name: 'OptionsPrice',
    id: '42759003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42759,
    type: 'int',
    codeSet: 'ReturnRateValuationPriceOptionCodeSet',
    description:
      'Options price\n\nThe official settlement price as announced by the related options exchange is applicable.',
  },
  {
    name: 'Gross',
    id: '42766001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42766,
    type: 'int',
    codeSet: 'ReturnRatePriceBasisCodeSet',
    description: 'Gross\n\n',
  },
  {
    name: 'Net',
    id: '42766002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42766,
    type: 'int',
    codeSet: 'ReturnRatePriceBasisCodeSet',
    description: 'Net',
  },
  {
    name: 'Accrued',
    id: '42766003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42766,
    type: 'int',
    codeSet: 'ReturnRatePriceBasisCodeSet',
    description: 'Accrued',
  },
  {
    name: 'CleanNet',
    id: '42766004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42766,
    type: 'int',
    codeSet: 'ReturnRatePriceBasisCodeSet',
    description: 'Clean net',
  },
  {
    name: 'AbsoluteTerms',
    id: '42769001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42769,
    type: 'int',
    codeSet: 'ReturnRatePriceTypeCodeSet',
    description: 'Absolute terms',
  },
  {
    name: 'PercentageOfNotional',
    id: '42769002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42769,
    type: 'int',
    codeSet: 'ReturnRatePriceTypeCodeSet',
    description: 'Percentage of notional',
  },
  {
    name: 'Execution',
    id: '42787001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42787,
    type: 'int',
    codeSet: 'StreamNotionalAdjustmentsCodeSet',
    description:
      'Execution\n\nThe adjustments to the number of units are governed by an execution clause.',
  },
  {
    name: 'PortfolioRebalancing',
    id: '42787002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42787,
    type: 'int',
    codeSet: 'StreamNotionalAdjustmentsCodeSet',
    description:
      'Portfolio rebalancing\n\nThe adjustments to the number of units are governed by a portfolio rebalancing clause.',
  },
  {
    name: 'Standard',
    id: '42787003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 42787,
    type: 'int',
    codeSet: 'StreamNotionalAdjustmentsCodeSet',
    description:
      'Standard\n\nThe adjustments to the number of units are not governed by any specific clause.',
  },
  {
    name: 'Execution',
    id: '2617001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 2617,
    type: 'int',
    codeSet: 'UnderlyingNotionalAdjustmentsCodeSet',
    description:
      'Execution\n\nThe adjustments to the number of units are governed by an execution clause.',
  },
  {
    name: 'PortfolioRebalancing',
    id: '2617002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 2617,
    type: 'int',
    codeSet: 'UnderlyingNotionalAdjustmentsCodeSet',
    description:
      'Portfolio rebalancing\n\nThe adjustments to the number of units are governed by a portfolio rebalancing clause.',
  },
  {
    name: 'Standard',
    id: '2617003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '208',
    tag: 2617,
    type: 'int',
    codeSet: 'UnderlyingNotionalAdjustmentsCodeSet',
    description:
      'Standrd\n\nThe adjustments to the number of units are not governed by any specific clause.',
  },
  {
    name: 'NoRemunerationPaid',
    id: '2356001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '209',
    tag: 2356,
    type: 'int',
    codeSet: 'RemunerationIndicatorCodeSet',
    description: 'No remuneration paid',
  },
  {
    name: 'RemunerationPaid',
    id: '2356002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '209',
    tag: 2356,
    type: 'int',
    codeSet: 'RemunerationIndicatorCodeSet',
    description: 'Remuneration paid',
  },
  {
    name: 'Disabled',
    id: '2355001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '214',
    tag: 2355,
    type: 'int',
    codeSet: 'PartyRiskLimitStatusCodeSet',
    description: 'Disabled\n\nRisk limits for party is disabled.',
  },
  {
    name: 'Enabled',
    id: '2355002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '214',
    tag: 2355,
    type: 'int',
    codeSet: 'PartyRiskLimitStatusCodeSet',
    description: 'Enabled\n\nRisk limits for party is enabled.',
  },
  {
    name: 'NonAlgorithmicTrade',
    id: '2667001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 2667,
    type: 'int',
    codeSet: 'AlgorithmicTradeIndicatorCodeSet',
    description: 'Non-algorithmic trade',
  },
  {
    name: 'AlgorithmicTrade',
    id: '2667002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 2667,
    type: 'int',
    codeSet: 'AlgorithmicTradeIndicatorCodeSet',
    description:
      'Algorithmic trade\n\nIn the context of ESMA MiFID II, a trade has to be flagged as "algorithmic" if at least one of the matched orders was submitted by a trading algorithm. See Directive 2014/65/EU Article 4(1)(39).',
  },
  {
    name: 'PreTradeTransparencyWaiver',
    id: '2669001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 2669,
    type: 'int',
    codeSet: 'TrdRegPublicationTypeCodeSet',
    description:
      'Pre-trade transparency waiver\n\nThere are allowable waivers from the obligation to make public current bid/offer prices and trading depth. In the context of MiFIR, see Article 3 and Article 4.',
  },
  {
    name: 'PostTradeDeferral',
    id: '2669002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 2669,
    type: 'int',
    codeSet: 'TrdRegPublicationTypeCodeSet',
    description:
      'Post-trade deferral\n\nThere are allowable deferrals for the post-trade publication of trade transactions. In the context of MiFIR, see Article 7(1).',
  },
  {
    name: 'ExemptFromPublication',
    id: '2669003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    tag: 2669,
    type: 'int',
    codeSet: 'TrdRegPublicationTypeCodeSet',
    description:
      'Exempt from publication\n\nThere are allowable exemptions for the post-trade publication of trade transactions. In the context of ESMA exemptions are specified in RTS 22 Annex I, Table 2, Field 65 and RTS 2 Article 14(1) and Article 15(1).',
  },
  {
    name: 'OrderLevelPublicationToSubscribers',
    id: '2669004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    updated: 'FIX.Latest',
    updatedEP: '264',
    tag: 2669,
    type: 'int',
    codeSet: 'TrdRegPublicationTypeCodeSet',
    description:
      'Order level publication to subscribers\n\nIndividual orders are displayed outside of the execution venue but only to subscribers. In the context of US CAT this can be used by Alternative Trading Systems (ATSs) to provide additional information related to price distribution.',
  },
  {
    name: 'PriceLevelPublicationToSubscribers',
    id: '2669005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    updated: 'FIX.Latest',
    updatedEP: '264',
    tag: 2669,
    type: 'int',
    codeSet: 'TrdRegPublicationTypeCodeSet',
    description:
      'Price level publication to subscribers\n\nAggregated orders are displayed outside of the execution venue but only to subscribers. In the context of US CAT this can be used by Alternative Trading Systems (ATSs) to provide additional information related to price distribution.',
  },
  {
    name: 'OrderLevelPublicationToThePublic',
    id: '2669006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    updated: 'FIX.Latest',
    updatedEP: '264',
    tag: 2669,
    type: 'int',
    codeSet: 'TrdRegPublicationTypeCodeSet',
    description:
      'Order level publication to the public\n\nIndividual orders are displayed outside of the execution venue via public quotation. In the context of US CAT this can be used by Alternative Trading Systems (ATSs) to provide additional information related to price distribution.',
  },
  {
    name: 'PublicationInternalToExecutionVenue',
    id: '2669007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    updated: 'FIX.Latest',
    updatedEP: '264',
    tag: 2669,
    type: 'int',
    codeSet: 'TrdRegPublicationTypeCodeSet',
    description:
      'Publication internal to execution venue\n\nOrders are not displayed outside of the execution venue. In the context of US CAT this can be used by Alternative Trading Systems (ATSs) to provide additional information related to price distribution.',
  },
  {
    name: 'NoBookOrderDueToAverageSpreadPrice',
    id: '2670001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    updated: 'FIX.5.0SP2',
    updatedEP: '229',
    tag: 2670,
    type: 'int',
    codeSet: 'TrdRegPublicationReasonCodeSet',
    description:
      'No preceding order in book as transaction price set within average spread of a liquid instrument\n\nPer MiFIR Article 4(1)(b)(i) the obligation to place a public order can be waived for transactions of liquid instruments on "systems that formalise negotiated transactions which are made within the current volume weighted spread reflected on the order book or the quotes of the market makers of the trading venue operating that system, subject to the conditions set out in Article 5" of MiFIR on volume caps. "Liquid markets" as per MiFIR Article 2(17)(b) are assessed by the regulator for the purposes of MiFIR Articles 4, 5 and 14. For ESMA RTS 1, RTS 6 and RTS 22 this is the waiver "NLIQ" flag.',
  },
  {
    name: 'NoBookOrderDueToRefPrice',
    id: '2670002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    updated: 'FIX.5.0SP2',
    updatedEP: '236',
    tag: 2670,
    type: 'int',
    codeSet: 'TrdRegPublicationReasonCodeSet',
    description:
      'No preceding order in book as transaction price depends on system-set reference price for an illiquid instrument\n\nPer MiFIR Article 4(1)(b)(ii) the obligation to place a public order can be waived for "negotiated transactions which are in an illiquid share, depositary receipt, ETF, certificate or other similar financial instrument that does not fall within the meaning of a liquid market, and are dealt within a percentage of a suitable reference price, being a percentage and a reference price set in advance by the system operator." For ESMA RTS 1, this is the "OILQ" flag.',
  },
  {
    name: 'NoBookOrderDueToOtherConditions',
    id: '2670003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    updated: 'FIX.5.0SP2',
    updatedEP: '229',
    tag: 2670,
    type: 'int',
    codeSet: 'TrdRegPublicationReasonCodeSet',
    description:
      'No preceding order in book as transaction price is for transaction subject to conditions other than current market price\n\nPer MiFIR Article 4(1)(b)(iii), the obligation to place a public order can be waived in "systems that formalise negotiated transactions which are subject to conditions other than the current market price of that financial instrument." For ESMA RTS1, RTS 6 and RTS 22 this is the waiver flag "PRIC".',
  },
  {
    name: 'NoPublicPriceDueToRefPrice',
    id: '2670004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    updated: 'FIX.5.0SP2',
    updatedEP: '229',
    tag: 2670,
    type: 'int',
    codeSet: 'TrdRegPublicationReasonCodeSet',
    description:
      'No public price for preceding order as public reference price was used for matching orders\n\nPer MiFIR Article 4(1)(a) the obligation to place a public order can be waived for "systems matching orders based on a trading methodology by which the price of the financial instrument is derived from the trading venue where that financial instrument was first admitted to trading or the most relevant market in terms of liquidity, where that reference price is widely published and is regarded by market participants as a reliable reference price." For ESMA RTS 1, RTS 6 and RTS 22 this is the waiver flag "RFPT".',
  },
  {
    name: 'NoPublicPriceDueToIlliquid',
    id: '2670005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    updated: 'FIX.5.0SP2',
    updatedEP: '229',
    tag: 2670,
    type: 'int',
    codeSet: 'TrdRegPublicationReasonCodeSet',
    description:
      'No public price quoted as instrument is illiquid\n\nAccording to MiFIR Article 4(1)(b)(ii) and Article 14(1) the obligation to publish the quote prior to closing the trade may be waived if it was made in an illiquid instrument. However, according to MiFIR Article 14(1) and Article 18(2), systematic internalisers shall still disclose quotes to their clients upon request. This obligation may also be waived in case of bonds, structured finance products, emission allowances and derivatives. For ESMA RTS 1, RTS 2, RTS 6 and RTS 22 this is the waiver flag "ILQD".',
  },
  {
    name: 'NoPublicPriceDueToOrderSize',
    id: '2670006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    updated: 'FIX.5.0SP2',
    updatedEP: '229',
    tag: 2670,
    type: 'int',
    codeSet: 'TrdRegPublicationReasonCodeSet',
    description:
      'No public price quoted due to "Size"\n\nIn the context of ESMA, as per MiFIR Article 4(1)(c) and Article 14(2), the systematic internaliser was not obliged to quote prior to closing the trade as the trade was above the standard market size. In accordance to MiFIR Article 9(1)(b) and Article 18(10), market operators, investment firms and systematic internalisers may be waived, in accordance to guidance from the Competent Authorities, from making public prices for derivative instruments which are above a side specific to the instrument. For ESMA RTS 1, RTS 2, RTS 6 and RTS 22 this is the waiver flag "SIZE".',
  },
  {
    name: 'DeferralDueToLargeInScale',
    id: '2670007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    updated: 'FIX.5.0SP2',
    updatedEP: '229',
    tag: 2670,
    type: 'int',
    codeSet: 'TrdRegPublicationReasonCodeSet',
    description:
      'Deferral due to "Large in Scale"\n\nPer MiFID Article 14, publication deferral is permitted if the transaction is large in scale compared to a standard market size, as set in RTS 1/Annex II (thresholds for "large in scale") and RTS 2/Annex III ("LIS and SSTI thresholds"). For ESMA RTS 1 and RTS 2, this is the "LRGS" flag.',
  },
  {
    name: 'DeferralDueToIlliquid',
    id: '2670008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    tag: 2670,
    type: 'int',
    codeSet: 'TrdRegPublicationReasonCodeSet',
    description:
      'Deferral due to "Illiquid Instrument"\n\nPublication deferral is permitted if the transaction\'s instrument is illiquid, as defined by regulator\'s stipulation. For ESMA RTS 2, this is the "ILQD" flag.',
  },
  {
    name: 'DeferralDueToSizeSpecific',
    id: '2670009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '216',
    updated: 'FIX.5.0SP2',
    updatedEP: '229',
    tag: 2670,
    type: 'int',
    codeSet: 'TrdRegPublicationReasonCodeSet',
    description:
      'Deferral due to "Size Specific"\n\nPer MiFIR Article 11, publication deferral is permitted if the transaction is greater than the stipulated \'Size Specific to the financial instrument\' threshold. For ESMA RTS 2, this is the "SIZE" flag.',
  },
  {
    name: 'NoPublicPriceDueToLargeInScale',
    id: '2670010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    tag: 2670,
    type: 'int',
    codeSet: 'TrdRegPublicationReasonCodeSet',
    description:
      'No public price and/or size quoted as transaction is "large in scale"\n\nIn the context of ESMA, as per MiFIR Article 4(1)(c) and Article 9(1)(a), the trading venue was not obliged to quote prior to closing the trade as the order size was above normal market size.',
  },
  {
    name: 'NoPublicPriceSizeDueToOrderHidden',
    id: '2670011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 2670,
    type: 'int',
    codeSet: 'TrdRegPublicationReasonCodeSet',
    description:
      'No public price and/or size quoted due to order being hidden\n\nIn the context of ESMA, as per MiFIR Article 4(1)(d) and Article 9(1)(a), a transaction arising from an order that was not fully pre-trade transparent due to all or part of it being held in a trading venue order management facility, such as a reserve order.',
  },
  {
    name: 'ExemptedDueToSecuritiesFinancingTransaction',
    id: '2670012',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    tag: 2670,
    type: 'int',
    codeSet: 'TrdRegPublicationReasonCodeSet',
    description:
      'Exempted due to securities financing transaction\n\nPer ESMA RTS 22, Annex I, Table 2, Field 65: a transaction which "falls within the scope of activity but is exempted from reporting under Securities Financing Transaction Regulation".',
  },
  {
    name: 'ExemptedDueToESCBPolicyTransaction',
    id: '2670013',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    tag: 2670,
    type: 'int',
    codeSet: 'TrdRegPublicationReasonCodeSet',
    description:
      'Exempted due to European System of Central Banks (ESCB) policy transaction\n\nPer ESMA RTS2, Article 14(1), and Article 15(1): "A transaction shall be considered to be entered into by a member of the European System of Central Banks (ESCB) in performance of monetary, foreign exchange and financial stability policy [is exempted from publication] … [The regulation] shall not apply to the following types of transaction entered into by a member of the ESCB for the performance of one of the tasks referred to in Article 14: transaction entered into for the management of its own funds; transaction entered into for administrative purposes or for the staff of the member of the ESCB which include transactions conducted in the capacity as administrator of a pension scheme for its staff; transactions entered into for its investment portfolio pursuant to obligations under national law."',
  },
  {
    name: 'ExceptionDueToReportByPaper',
    id: '2670014',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2670,
    type: 'int',
    codeSet: 'TrdRegPublicationReasonCodeSet',
    description:
      'Exception due to report by paper\n\nIncomplete report due to submission by paper (form). In the context of US CAT this is Form T pursuant to FINRA Trade Reporting Rules.',
  },
  {
    name: 'ExceptionDueToTradeExecutedWithNonReportingParty',
    id: '2670015',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2670,
    type: 'int',
    codeSet: 'TrdRegPublicationReasonCodeSet',
    description:
      'Exception due to trade with non-reporting party\n\nIncomplete report due to counterparty of the reporting party being absent. In the context of US CAT this is when a trade was executed by a non-FINRA member and reported to the TRF by the FINRA member counterparty.',
  },
  {
    name: 'ExceptionDueToIntraFirmOrder',
    id: '2670016',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2670,
    type: 'int',
    codeSet: 'TrdRegPublicationReasonCodeSet',
    description:
      'Exception due to intra-firm order\n\nIncomplete report due to intra–firm order filled from firm’s proprietary account.',
  },
  {
    name: 'ReportedOutsideReportingHours',
    id: '2670017',
    value: '16',
    sort: 16,
    added: 'FIX.Latest',
    addedEP: '268',
    tag: 2670,
    type: 'int',
    codeSet: 'TrdRegPublicationReasonCodeSet',
    description:
      'Reported outside of reporting hours\n\nIn the context of ESMA, trades published after the trade reporting facility being used (e.g. APA for trades brought onto a trading venue) closes, will be reported the following business day and not flagged as deferred (as the MiFID deferral regime is not applicable). This value distinguishes these types of trades from trades executed (and published) on the same business day. It is recommended that this value be set by the trade reporting facility, e.g. APAs, (as opposed to publishing investment firms) to ensure the most accurate use of this value.',
  },
  {
    name: 'NoPublicPxDueToPreTradeWaiver',
    id: '2670018',
    value: '17',
    sort: 17,
    added: 'FIX.Latest',
    addedEP: '283',
    tag: 2670,
    type: 'int',
    codeSet: 'TrdRegPublicationReasonCodeSet',
    description:
      'No public price quoted due to usage of a pre-trade transparency waiver\n\nPer FCA policy statement PS23/4, this is the "NETW" flag for negotiated trades in accordance to MiFIR Article 4(1)(b).',
  },
  {
    name: 'NoCross',
    id: '2523001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '218',
    tag: 2523,
    type: 'int',
    codeSet: 'CrossedIndicatorCodeSet',
    description: 'No cross\n\nCrossing did not occur.',
  },
  {
    name: 'CrossRejected',
    id: '2523002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '218',
    tag: 2523,
    type: 'int',
    codeSet: 'CrossedIndicatorCodeSet',
    description:
      'Cross rejected\n\nCrossing occurred but execution was prevented, e.g. due to self-match prevention.',
  },
  {
    name: 'CrossAccepted',
    id: '2523003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '218',
    tag: 2523,
    type: 'int',
    codeSet: 'CrossedIndicatorCodeSet',
    description: 'Cross accepted\n\nCrossing occurred but execution was permitted.',
  },
  {
    name: 'AggregatedOrder',
    id: '2594001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '222',
    tag: 2594,
    type: 'int',
    codeSet: 'OrderAttributeTypeCodeSet',
    description:
      'Aggregated order\n\nIn the context of ESMA RTS 24 Article 2(3), when OrderAttributeValue(2595)=Y, it signifies that the order consists of several orders aggregated together. This maps to ESMA RTS value "AGGR".',
  },
  {
    name: 'PendingAllocation',
    id: '2594002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '222',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 2594,
    type: 'int',
    codeSet: 'OrderAttributeTypeCodeSet',
    description:
      'Order pending allocation\n\nIn the context of ESMA RTS 24 Article 2(2), when OrderAttributeValue(2595)=Y, it signifies that the order submitter "is authorized under the legislation of a Member State to allocate an order to its client following submission of the order to the trading venue and has not yet allocated the order to its client at the time of the submission of the order". This maps to ESMA RTS value "PNAL".',
  },
  {
    name: 'LiquidityProvisionActivityOrder',
    id: '2594003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '222',
    tag: 2594,
    type: 'int',
    codeSet: 'OrderAttributeTypeCodeSet',
    description:
      'Liquidity provision activity order\n\nIn the context of ESMA RTS 24 Article 3, when OrderAttributeValue(2595)=Y, it signifies that the order was submitted "as part of a market making strategy pursuant to Articles 17 and 18 of Directive 2014/65/EU, or is submitted as part of another activity in accordance with Article 3" (of RTS 24).',
  },
  {
    name: 'RiskReductionOrder',
    id: '2594004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '222',
    tag: 2594,
    type: 'int',
    codeSet: 'OrderAttributeTypeCodeSet',
    description:
      'Risk reduction order\n\nIn the context of ESMA RTS 22 Article 4(2)(i), when OrderAttributeValue(2595)=Y, it signifies that the commodity derivative order is a transaction "to reduce risk in an objectively measurable way in accordance with Article 57 of Directive 2014/65/EU".',
  },
  {
    name: 'AlgorithmicOrder',
    id: '2594005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '222',
    tag: 2594,
    type: 'int',
    codeSet: 'OrderAttributeTypeCodeSet',
    description:
      'Algorithmic order\n\nWhen OrderAttributeValue(2595)=Y, it signifies the order submitted to the dealer/investment firm resulted from an algorithm.',
  },
  {
    name: 'SystematicInternaliserOrder',
    id: '2594006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '222',
    updated: 'FIX.Latest',
    updatedEP: '289',
    tag: 2594,
    type: 'int',
    codeSet: 'OrderAttributeTypeCodeSet',
    description:
      'Authorised reporter order\n\nWhen OrderAttributeValue(2595)=Y, it signifies the order is submitted by an authorised reporter who is responsible for reporting trades resulting from the order. This may be a systematic internaliser.',
  },
  {
    name: 'AllExecutionsSubmittedToAPA',
    id: '2594007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    tag: 2594,
    type: 'int',
    codeSet: 'OrderAttributeTypeCodeSet',
    description:
      "All executions for the order are to be submitted to an APA\n\nAll executions from this order that may need to be trade reported by the order submitter under MiFID II rules will be submitted by the order receiver on the submitter's behalf to the Approved Publication Arrangement (APA) facility specified in OrderAttributeValue(2595). ESMA RTS 1.",
  },
  {
    name: 'OrderExecutionInstructedByClient',
    id: '2594008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    tag: 2594,
    type: 'int',
    codeSet: 'OrderAttributeTypeCodeSet',
    description:
      "Order execution instructed by client\n\nIn the context of ESMA RTS 22, Annex I, Table 2, Field 59, when OrderAttributeValue(2595)=Y, it signifies that the execution (e.g. the details of the trade including the venue of execution) was instructed by a client or by another person from outside the Investment Firm but within the same group (Field 59 'CLIENT' in ESMA 2016-1452 Guidelines).",
  },
  {
    name: 'LargeInScale',
    id: '2594009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 2594,
    type: 'int',
    codeSet: 'OrderAttributeTypeCodeSet',
    description:
      'Large in scale order\n\nIn the context of MiFIR Article 4(1)(c) and Article 9(1)(a), when OrderAttributeValue(2595)=Y, it signifies that the order size is large in scale compared to normal market size.',
  },
  {
    name: 'Hidden',
    id: '2594010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    updated: 'FIX.5.0SP2',
    updatedEP: '253',
    tag: 2594,
    type: 'int',
    codeSet: 'OrderAttributeTypeCodeSet',
    description:
      'Hidden order\n\nIn the context of MiFIR Article 4(1)(d) and Article 9(1)(a), when OrderAttributeValue(2595)=Y, it signifies that the order is held in an order management facility of the trading venue pending disclosure.',
  },
  {
    name: 'SubjectToEUSTO',
    id: '2594011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '250',
    updated: 'FIX.5.0SP2',
    updatedEP: '255',
    tag: 2594,
    type: 'int',
    codeSet: 'OrderAttributeTypeCodeSet',
    description:
      "Subject to EU share trading obligation (STO)\n\nThis attribute is mutually exclusive with OrderAttributeType(2594)=14 (Exempt from STO), but not mutually exclusive with OrderAttributeType(2594)=11 (Subject to UK STO).\n\nIn the context of the trading obligation for shares (STO) under ESMA's Article 23 of MiFIR, it signifies that the order is subject to the rules defined by ESMA.",
  },
  {
    name: 'SubjectToUKSTO',
    id: '2594012',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '250',
    updated: 'FIX.5.0SP2',
    updatedEP: '255',
    tag: 2594,
    type: 'int',
    codeSet: 'OrderAttributeTypeCodeSet',
    description:
      "Subject to UK share trading obligation (STO)\n\nThis attribute is mutually exclusive with OrderAttributeType(2594)=14 (Exempt from STO), but not mutually exclusive with OrderAttributeType(2594)=10 (Subject to EU STO).\n\nIn the context of the trading obligation for shares (STO) under ESMA's Article 23 of MiFIR, it signifies that the order is subject to UK rules defined by the FCA.",
  },
  {
    name: 'RepresentativeOrder',
    id: '2594013',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2594,
    type: 'int',
    codeSet: 'OrderAttributeTypeCodeSet',
    description:
      'Representative order\n\nOrder was originated to represent an order received by the broker from a customer/client.',
  },
  {
    name: 'LinkageType',
    id: '2594014',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2594,
    type: 'int',
    codeSet: 'OrderAttributeTypeCodeSet',
    description:
      'Linkage type\n\nOrder is subject to regulatory linkage requirements related to customer/client orders. Can be used for US CAT order and trade level linkages between customer/client orders and representative orders.',
  },
  {
    name: 'ExemptFromSTO',
    id: '2594015',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '255',
    tag: 2594,
    type: 'int',
    codeSet: 'OrderAttributeTypeCodeSet',
    description:
      "Exempt from share trading obligation (STO)\n\nThis attribute is mutually exclusive with OrderAttributeType(2594)=10 = (Subject to EU STO) and OrderAttributeType(2594)=11 = (Subject to UK STO). It can be used to override standing instructions for a trading obligation for shares (STO). It overrides the standing instructions in their entirety.\n\nIn the context of STO under ESMA's Article 23 of MiFIR, it signifies that the order is exempt from any share trading obligation.",
  },
  {
    name: 'NotReported',
    id: '2524001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '222',
    updated: 'FIX.5.0SP2',
    updatedEP: '237',
    tag: 2524,
    type: 'int',
    codeSet: 'TradeReportingIndicatorCodeSet',
    description:
      'Trade has not (yet) been reported\n\nDepending on the regulatory regime the trade is reportable and the recipient may be responsible for reporting.',
  },
  {
    name: 'OnBook',
    id: '2524002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '222',
    updated: 'FIX.5.0SP2',
    updatedEP: '237',
    tag: 2524,
    type: 'int',
    codeSet: 'TradeReportingIndicatorCodeSet',
    description:
      'Trade has been or will be reported by a trading venue as an "on-book" trade',
  },
  {
    name: 'SISeller',
    id: '2524003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '222',
    updated: 'FIX.Latest',
    updatedEP: '283',
    tag: 2524,
    type: 'int',
    codeSet: 'TradeReportingIndicatorCodeSet',
    description:
      'Trade has or will be reported as a seller trade by the authorised reporter',
  },
  {
    name: 'SIBuyer',
    id: '2524004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '222',
    updated: 'FIX.Latest',
    updatedEP: '283',
    tag: 2524,
    type: 'int',
    codeSet: 'TradeReportingIndicatorCodeSet',
    description:
      'Trade has or will be reported as a buyer trade by the authorised reporter',
  },
  {
    name: 'NonSISeller',
    id: '2524005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '222',
    updated: 'FIX.Latest',
    updatedEP: '283',
    tag: 2524,
    type: 'int',
    codeSet: 'TradeReportingIndicatorCodeSet',
    description:
      'Trade has or will be reported as a seller trade by an entity other than the authorised reporter',
  },
  {
    name: 'SubDelegationByFirm',
    id: '2524006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '222',
    updated: 'FIX.5.0SP2',
    updatedEP: '237',
    tag: 2524,
    type: 'int',
    codeSet: 'TradeReportingIndicatorCodeSet',
    description:
      'Trade has been or will be reported under a sub-delegation arrangement by an investment firm to a reporting facility (e.g. APA) on behalf of another investment firm',
  },
  {
    name: 'Reportable',
    id: '2524007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '237',
    tag: 2524,
    type: 'int',
    codeSet: 'TradeReportingIndicatorCodeSet',
    description:
      'Trade has been or will be reported\n\nDepending on the regulatory regime the recipient is not responsible for reporting.',
  },
  {
    name: 'NonSIBuyer',
    id: '2524008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '237',
    updated: 'FIX.Latest',
    updatedEP: '283',
    tag: 2524,
    type: 'int',
    codeSet: 'TradeReportingIndicatorCodeSet',
    description:
      'Trade has been or will be reported as a buyer trade by an entity other than the authorised reporter',
  },
  {
    name: 'OffBook',
    id: '2524009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '237',
    tag: 2524,
    type: 'int',
    codeSet: 'TradeReportingIndicatorCodeSet',
    description:
      'Trade has been or will be reported by a trading venue as an "off-book" trade',
  },
  {
    name: 'NotReportable',
    id: '2524010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '237',
    tag: 2524,
    type: 'int',
    codeSet: 'TradeReportingIndicatorCodeSet',
    description:
      'Trade is not reportable\n\nThe (non-equity) instrument does not need to be reported by any party, e.g. because it is not deemed to have been traded on a trading venue.',
  },
  {
    name: 'None',
    id: '2675001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2675,
    type: 'int',
    codeSet: 'MassActionReasonCodeSet',
    description: 'No special reason (default)',
  },
  {
    name: 'TradingRiskControl',
    id: '2675002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2675,
    type: 'int',
    codeSet: 'MassActionReasonCodeSet',
    description:
      'Trading risk control\n\nGeneral violation of trading rules. Can be used if specific reason is unavailable or must not be disclosed.',
  },
  {
    name: 'ClearingRiskControl',
    id: '2675003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2675,
    type: 'int',
    codeSet: 'MassActionReasonCodeSet',
    description:
      'Clearing risk control\n\nGeneral violation of clearing rules. Can be used if specific reason is unavailable or must not be disclosed.',
  },
  {
    name: 'MarketMakerProtection',
    id: '2675004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2675,
    type: 'int',
    codeSet: 'MassActionReasonCodeSet',
    description:
      'Market maker protection\n\nSpecific action taken to prevent further executions for a market maker.',
  },
  {
    name: 'StopTrading',
    id: '2675005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2675,
    type: 'int',
    codeSet: 'MassActionReasonCodeSet',
    description:
      'Stop trading\n\nSpecific action taken in conjunction with the prevention of further trading. Scope can be defined with TargetParties component.',
  },
  {
    name: 'EmergencyAction',
    id: '2675006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2675,
    type: 'int',
    codeSet: 'MassActionReasonCodeSet',
    description:
      'Emergency action\n\nSpecific action taken due to an emergency condition. Scope can be defined with TargetParties component.',
  },
  {
    name: 'SessionLossLogout',
    id: '2675007',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2675,
    type: 'int',
    codeSet: 'MassActionReasonCodeSet',
    description:
      'Session loss or logout\n\nProtection of trader or firm after having lost connectivity.',
  },
  {
    name: 'DuplicateLogin',
    id: '2675008',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2675,
    type: 'int',
    codeSet: 'MassActionReasonCodeSet',
    description: 'Duplicate login\n\nTrader only allowed to login once.',
  },
  {
    name: 'ProductNotTraded',
    id: '2675009',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2675,
    type: 'int',
    codeSet: 'MassActionReasonCodeSet',
    description:
      'Product not traded\n\nProduct not available for trading, e.g. in a halted state.',
  },
  {
    name: 'InstrumentNotTraded',
    id: '2675010',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2675,
    type: 'int',
    codeSet: 'MassActionReasonCodeSet',
    description:
      'Instrument not traded\n\nInstrument not available for trading, e.g. due to intra-day expiration.',
  },
  {
    name: 'CompleInstrumentDeleted',
    id: '2675011',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2675,
    type: 'int',
    codeSet: 'MassActionReasonCodeSet',
    description:
      'Complex instrument deleted\n\nRemoval of complex instrument, e.g. due to expiry, leading to mass action on open orders.',
  },
  {
    name: 'CircuitBreakerActivated',
    id: '2675012',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2675,
    type: 'int',
    codeSet: 'MassActionReasonCodeSet',
    description:
      'Circuit breaker activated\n\nTrading interruption leading to mass action on open orders.',
  },
  {
    name: 'Other',
    id: '2675013',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2675,
    type: 'int',
    codeSet: 'MassActionReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'OrderSuspended',
    id: '2677001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2677,
    type: 'int',
    codeSet: 'NotAffectedReasonCodeSet',
    description: 'Order suspended',
  },
  {
    name: 'InstrumentSuspended',
    id: '2677002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2677,
    type: 'int',
    codeSet: 'NotAffectedReasonCodeSet',
    description: 'Instrument suspended',
  },
  {
    name: 'NoChange',
    id: '2679001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2679,
    type: 'int',
    codeSet: 'OrderOwnershipIndicatorCodeSet',
    description: 'No change of ownership (default)',
  },
  {
    name: 'ExecutingPartyChange',
    id: '2679002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2679,
    type: 'int',
    codeSet: 'OrderOwnershipIndicatorCodeSet',
    description:
      'Change of ownership to executing party\n\nExecuting party can be given either implicitly via session attributes or explicitly via Parties component. The party taking over ownership must also be the one submitting the request.',
  },
  {
    name: 'EnteringPartyChange',
    id: '2679003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2679,
    type: 'int',
    codeSet: 'OrderOwnershipIndicatorCodeSet',
    description:
      'Change of ownership to entering party\n\nEntering party can be given either implicitly via session attributes or explicitly via Parties component. The party taking over ownership must also be the one submitting the request.',
  },
  {
    name: 'SpecifiedPartyChange',
    id: '2679004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '223',
    tag: 2679,
    type: 'int',
    codeSet: 'OrderOwnershipIndicatorCodeSet',
    description:
      'Change of ownership to specified party\n\nOwnership is transferred by a third party from/to the parties specified via Parties component together with PartyRoleQualifier(2376) = Current(18) and New(19).',
  },
  {
    name: 'StandardITM',
    id: '2681001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '224',
    tag: 2681,
    type: 'int',
    codeSet: 'InTheMoneyConditionCodeSet',
    description:
      "Standard in-the-money\n\nThe option's strike price is less than the underlying settlement price for a call or greater than the underlying settlement price for a put.",
  },
  {
    name: 'ATMITM',
    id: '2681002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '224',
    tag: 2681,
    type: 'int',
    codeSet: 'InTheMoneyConditionCodeSet',
    description:
      "At-the-money is in-the-money\n\nThe option's strike price of either the put or call is equal to the underlying settlement price in addition to standard in-the-money behavior.",
  },
  {
    name: 'ATMCallITM',
    id: '2681003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '224',
    tag: 2681,
    type: 'int',
    codeSet: 'InTheMoneyConditionCodeSet',
    description:
      "At-the-money call is in-the-money\n\nThe call option's strike price is equal to the underlying settlement price in addition to standard in-the-money behavior.",
  },
  {
    name: 'ATMPutITM',
    id: '2681004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '224',
    tag: 2681,
    type: 'int',
    codeSet: 'InTheMoneyConditionCodeSet',
    description:
      "At-the-money put is in-the-money\n\nThe put option's strike price is equal to the underlying settlement price in addition to standard in-the-money behavior.",
  },
  {
    name: 'NoRestriction',
    id: '2704001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    tag: 2704,
    type: 'int',
    codeSet: 'ExDestinationTypeCodeSet',
    description:
      'No restriction\n\nMay be used for MiFID II to indicate no restriction on where the order is executed.',
  },
  {
    name: 'TradedOnlyOnTradingVenue',
    id: '2704002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    tag: 2704,
    type: 'int',
    codeSet: 'ExDestinationTypeCodeSet',
    description:
      'Can be traded only on a trading venue\n\nMay be used for MiFID II to indicate the order can only be executed on a trading venue.',
  },
  {
    name: 'TradedOnlyOnSI',
    id: '2704003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    tag: 2704,
    type: 'int',
    codeSet: 'ExDestinationTypeCodeSet',
    description:
      'Can be traded only on a Systematic Internaliser (SI)\n\nMay be used for MiFID II to indicate the order can only be executed on a Systematic Internaliser.',
  },
  {
    name: 'TradedOnTradingVenueOrSI',
    id: '2704004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '228',
    tag: 2704,
    type: 'int',
    codeSet: 'ExDestinationTypeCodeSet',
    description:
      'Can be traded on a trading venue or Systematic internaliser (SI)\n\nMay be used for MiFID II to indicate the order can be executed on either a trading venue or a Systematic Internaliser.',
  },
  {
    name: 'Normal',
    id: '2705001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '229',
    tag: 2705,
    type: 'int',
    codeSet: 'MarketConditionCodeSet',
    description:
      'Normal\n\nThe condition of the market in the absence of "stressed" or "exceptional" conditions.',
  },
  {
    name: 'Stressed',
    id: '2705002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '229',
    tag: 2705,
    type: 'int',
    codeSet: 'MarketConditionCodeSet',
    description:
      'Stressed\n\nIn the context of ESMA RTS 8 Article 6: Trading venues shall set out the parameters to identify stressed market conditions in terms of significant short-term changes of price and volume. Trading venues shall consider the resumption of trading after volatility interruptions as stressed market conditions.',
  },
  {
    name: 'Exceptional',
    id: '2705003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '229',
    tag: 2705,
    type: 'int',
    codeSet: 'MarketConditionCodeSet',
    description:
      'Exceptional\n\nIn the context of ESMA RTS 8 Article 3: Due to (a) a situation of extreme volatility; (b) war, industrial action, civil unrest or cyber sabotage; (c) disorderly trading conditions, e.g. due to technical issues; (d) unavailability of risk management facilities.',
  },
  {
    name: 'QuoteAboveStandardMarketSize',
    id: '2707001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '229',
    tag: 2707,
    type: 'int',
    codeSet: 'QuoteAttributeTypeCodeSet',
    description:
      'Quote is above standard market size\n\nIn the context of ESMA pre-trade transparency under MiFIR to make prices public, the quote size is above standard market size, therefore the price is not made public. Applicable for cash equities instruments.',
  },
  {
    name: 'QuoteAboveSpecificInstrumentSize',
    id: '2707002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '229',
    tag: 2707,
    type: 'int',
    codeSet: 'QuoteAttributeTypeCodeSet',
    description:
      'Quote is above size specific to the instrument\n\nIn the context of ESMA pre-trade transparency under MiFID to make public prices, the quote size is above the size specific to the instrument, therefore the price is not or will not be made public. Applicable for non-cash equities instruments.',
  },
  {
    name: 'QuoteApplicableForLiquidtyProvisionActivity',
    id: '2707003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '229',
    tag: 2707,
    type: 'int',
    codeSet: 'QuoteAttributeTypeCodeSet',
    description:
      'Quote applicable for liquidity provision activity\n\nIn the context of ESMA RTS 24 Article 3, when QuoteAttributeValue(2708)=Y, it signifies that the quote was submitted "as part of a market making strategy pursuant to Articles 17 and 18 of Directive 2014/65/EU, or is submitted as part of another activity in accordance with Article 3" (of RTS 24).',
  },
  {
    name: 'QuoteIssuerStatus',
    id: '2707004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2707,
    type: 'int',
    codeSet: 'QuoteAttributeTypeCodeSet',
    description:
      'Quote issuer status\n\nIndicate whether quote issuer is available or not. Can be used in the context of US CAT to indicate if a market maker’s quote is open (O) or closed (C) whenever the quote is sent to an inter-dealer quotation system.',
  },
  {
    name: 'BidOrAskRequest',
    id: '2707005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2707,
    type: 'int',
    codeSet: 'QuoteAttributeTypeCodeSet',
    description:
      'Bid or ask request\n\nIndicate explicitly whether a request for a quote is a request for a bid or an ask.',
  },
  {
    name: 'AccruedInterestIsFactored',
    id: '2710001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '230',
    tag: 2710,
    type: 'int',
    codeSet: 'PriceQualifierCodeSet',
    description:
      'Accrued interest (if any) is factored into the price\n\nThe price is either "dirty" or the security is in default or soon to be defaulted. I.e. on fill there will be no separate accrued interest amount. This is often called a "flat" price.',
  },
  {
    name: 'TaxIsFactored',
    id: '2710002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '230',
    tag: 2710,
    type: 'int',
    codeSet: 'PriceQualifierCodeSet',
    description:
      "Tax is factored into the price\n\nThe security's price includes applicable taxes, e.g. Japanese government bonds.",
  },
  {
    name: 'BondAmortizationIsFactored',
    id: '2710003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '230',
    tag: 2710,
    type: 'int',
    codeSet: 'PriceQualifierCodeSet',
    description:
      "The effect of bond amortization or the floating rate index offset is factored into the price\n\nThe security's price includes the effect of bond amortization or a floating rate index. For example this qualifier would apply to the normal pricing of index-linked UK gilt bonds but not to US or EU index-linked bonds.",
  },
  {
    name: 'Range1',
    id: '2711001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2711,
    type: 'int',
    codeSet: 'MDValueTierCodeSet',
    description: 'Range 1',
  },
  {
    name: 'Range2',
    id: '2711002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2711,
    type: 'int',
    codeSet: 'MDValueTierCodeSet',
    description: 'Range 2',
  },
  {
    name: 'Range3',
    id: '2711003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2711,
    type: 'int',
    codeSet: 'MDValueTierCodeSet',
    description: 'Range 3',
  },
  {
    name: 'Contributes',
    id: '2712001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2712,
    type: 'int',
    codeSet: 'MiscFeeQualifierCodeSet',
    description:
      'Contributes (default)\n\nFee contributes to the trade or transaction economics.',
  },
  {
    name: 'DoesNotContribute',
    id: '2712002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '231',
    tag: 2712,
    type: 'int',
    codeSet: 'MiscFeeQualifierCodeSet',
    description:
      'Does not contribute\n\nFee does not contribute to the trade or transaction economics.',
  },
  {
    name: 'ResearchPaymentAccount',
    id: '2725001',
    value: '0',
    sort: 0,
    group: 'Research Payment',
    added: 'FIX.5.0SP2',
    addedEP: '233',
    tag: 2725,
    type: 'int',
    codeSet: 'CommissionAmountSubTypeCodeSet',
    description: 'Research payment account (RPA)',
  },
  {
    name: 'CommissionSharingAgreement',
    id: '2725002',
    value: '1',
    sort: 1,
    group: 'Research Payment',
    added: 'FIX.5.0SP2',
    addedEP: '233',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 2725,
    type: 'int',
    codeSet: 'CommissionAmountSubTypeCodeSet',
    description: 'Commission sharing agreement (CSA)',
  },
  {
    name: 'OtherTypeResearchPayment',
    id: '2725003',
    value: '2',
    sort: 2,
    group: 'Research Payment',
    added: 'FIX.5.0SP2',
    addedEP: '233',
    tag: 2725,
    type: 'int',
    codeSet: 'CommissionAmountSubTypeCodeSet',
    description:
      'Other type of research payment\n\nA type of research payment other than RPA or CSA.',
  },
  {
    name: 'ArgusMcCloskey',
    id: '2736001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 2736,
    type: 'int',
    codeSet: 'CommodityFinalPriceTypeCodeSet',
    description: 'Argus McCloskey',
  },
  {
    name: 'Baltic',
    id: '2736002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 2736,
    type: 'int',
    codeSet: 'CommodityFinalPriceTypeCodeSet',
    description: 'Baltic',
  },
  {
    name: 'Exchange',
    id: '2736003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 2736,
    type: 'int',
    codeSet: 'CommodityFinalPriceTypeCodeSet',
    description: 'Exchange',
  },
  {
    name: 'GlobalCoal',
    id: '2736004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 2736,
    type: 'int',
    codeSet: 'CommodityFinalPriceTypeCodeSet',
    description: 'Global Coal',
  },
  {
    name: 'IHSMcCloskey',
    id: '2736005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 2736,
    type: 'int',
    codeSet: 'CommodityFinalPriceTypeCodeSet',
    description: 'IHS McCloskey',
  },
  {
    name: 'Platts',
    id: '2736006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 2736,
    type: 'int',
    codeSet: 'CommodityFinalPriceTypeCodeSet',
    description: 'Platts',
  },
  {
    name: 'Other',
    id: '2736007',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 2736,
    type: 'int',
    codeSet: 'CommodityFinalPriceTypeCodeSet',
    description: 'Other',
  },
  {
    name: 'AdmitToTradeRequestDate',
    id: '2748001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 2748,
    type: 'int',
    codeSet: 'ReferenceDataDateTypeCodeSet',
    description:
      'Date of request for admission to trading\n\nIn the context of MiFID II ESMA RTS 23 this is defined as "Date and time the issuer has approved admission to trading or trading in its financial instruments on a trading venue." (Reference: Annex I Table 3 Field 9)',
  },
  {
    name: 'AdmitToTradeApprovalDate',
    id: '2748002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 2748,
    type: 'int',
    codeSet: 'ReferenceDataDateTypeCodeSet',
    description:
      'Date of approval of admission to trading\n\nIn the context of MiFID II ESMA RTS 23 this is defined as "Date and time of the request for admission to trading on the trading venue." (Reference: Annex I Table 3 Field 10)',
  },
  {
    name: 'AdmitToTradeOrFirstTradeDate',
    id: '2748003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 2748,
    type: 'int',
    codeSet: 'ReferenceDataDateTypeCodeSet',
    description:
      'Date of admission to trading or date of first trade\n\nIn the context of MiFID II ESMA RTS 23 this is defined as "Date and time of the admission to trading on the trading venue or the date and time when the instrument was first traded or an order or quote was first received by the trading venue." (Reference: Annex I Table 3 Field 11)',
  },
  {
    name: 'TerminationDate',
    id: '2748004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '235',
    tag: 2748,
    type: 'int',
    codeSet: 'ReferenceDataDateTypeCodeSet',
    description:
      'Termination date\n\nIn the context of MiFID II ESMA RTS 23 this is defined as "Where available, the date and time when the financial instrument ceases to be traded or to be admitted to trading on the trading venue." (Reference: Annex I Table 3 Field 12)',
  },
  {
    name: 'Dividend',
    id: '2753001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 2753,
    type: 'int',
    codeSet: 'ReturnTriggerCodeSet',
    description: 'Dividend',
  },
  {
    name: 'Variance',
    id: '2753002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 2753,
    type: 'int',
    codeSet: 'ReturnTriggerCodeSet',
    description: 'Variance',
  },
  {
    name: 'Volatility',
    id: '2753003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 2753,
    type: 'int',
    codeSet: 'ReturnTriggerCodeSet',
    description: 'Volatility',
  },
  {
    name: 'TotalReturn',
    id: '2753004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 2753,
    type: 'int',
    codeSet: 'ReturnTriggerCodeSet',
    description: 'Total return',
  },
  {
    name: 'ContractForDifference',
    id: '2753005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 2753,
    type: 'int',
    codeSet: 'ReturnTriggerCodeSet',
    description: 'Contract for difference',
  },
  {
    name: 'CreditDefault',
    id: '2753006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 2753,
    type: 'int',
    codeSet: 'ReturnTriggerCodeSet',
    description: 'Credit default',
  },
  {
    name: 'SpreadBet',
    id: '2753007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 2753,
    type: 'int',
    codeSet: 'ReturnTriggerCodeSet',
    description: 'Spread bet',
  },
  {
    name: 'Price',
    id: '2753008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 2753,
    type: 'int',
    codeSet: 'ReturnTriggerCodeSet',
    description: 'Price',
  },
  {
    name: 'ForwardPriceUnderlyingInstrument',
    id: '2753009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 2753,
    type: 'int',
    codeSet: 'ReturnTriggerCodeSet',
    description: 'Forward price of underlying instrument',
  },
  {
    name: 'Other',
    id: '2753010',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '238',
    tag: 2753,
    type: 'int',
    codeSet: 'ReturnTriggerCodeSet',
    description: 'Other',
  },
  {
    name: 'TimeWeightedAveragePrice',
    id: '2763001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '240',
    tag: 2763,
    type: 'int',
    codeSet: 'AveragePriceTypeCodeSet',
    description:
      'Time weighted average price\n\nTWAP is the simple average price of a security over a specified time without regard to the volume traded.',
  },
  {
    name: 'VolumeWeightedAveragePrice',
    id: '2763002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '240',
    tag: 2763,
    type: 'int',
    codeSet: 'AveragePriceTypeCodeSet',
    description:
      'Volume weighted average price\n\nVWAP is the sum of the currency amount traded for all trades in the averaging group (price times quantity) divided by the total quantity.',
  },
  {
    name: 'PercentOfVolumeAveragePrice',
    id: '2763003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '240',
    updated: 'FIX.Latest',
    updatedEP: '271',
    tag: 2763,
    type: 'int',
    codeSet: 'AveragePriceTypeCodeSet',
    description:
      'Percent of volume average price\n\nPOV is the sum of the currency amount traded for all trades executed as part of an order intended to purchase a specified percentage of the total volume of an instrument, divided by the total quantity.',
  },
  {
    name: 'LimitOrderAveragePrice',
    id: '2763004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '240',
    tag: 2763,
    type: 'int',
    codeSet: 'AveragePriceTypeCodeSet',
    description:
      'Limit order average price\n\nThe limit order average price is the currency amount of all trades executed to fill a limit order, divided by the total quantity.',
  },
  {
    name: 'Added',
    id: '2767001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '240',
    tag: 2767,
    type: 'int',
    codeSet: 'AllocGroupStatusCodeSet',
    description:
      'Added\n\nThis trade has been associated with the group for the first time.',
  },
  {
    name: 'Canceled',
    id: '2767002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '240',
    tag: 2767,
    type: 'int',
    codeSet: 'AllocGroupStatusCodeSet',
    description: 'Canceled\n\nThis trade has been removed from the group.',
  },
  {
    name: 'Replaced',
    id: '2767003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '240',
    tag: 2767,
    type: 'int',
    codeSet: 'AllocGroupStatusCodeSet',
    description: 'Replaced\n\nThis trade already in the group has been updated.',
  },
  {
    name: 'Changed',
    id: '2767004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '241',
    tag: 2767,
    type: 'int',
    codeSet: 'AllocGroupStatusCodeSet',
    description:
      'Changed\n\nAn allocated trade or give-up has moved from one allocation group to another.',
  },
  {
    name: 'Pending',
    id: '2767005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '241',
    tag: 2767,
    type: 'int',
    codeSet: 'AllocGroupStatusCodeSet',
    description:
      'Pending\n\nA request to assign or change an allocation group is pending.',
  },
  {
    name: 'Accepted',
    id: '2768001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '241',
    tag: 2768,
    type: 'int',
    codeSet: 'AllocRequestStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Rejected',
    id: '2768002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '241',
    tag: 2768,
    type: 'int',
    codeSet: 'AllocRequestStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'NoMatchingConfirmation',
    id: '2773001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2773,
    type: 'int',
    codeSet: 'MatchExceptionTypeCodeSet',
    description: 'No matching confirmation',
  },
  {
    name: 'NoMatchingAllocation',
    id: '2773002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2773,
    type: 'int',
    codeSet: 'MatchExceptionTypeCodeSet',
    description: 'No matching allocation',
  },
  {
    name: 'AllocationDataElementMissing',
    id: '2773003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2773,
    type: 'int',
    codeSet: 'MatchExceptionTypeCodeSet',
    description: 'Allocation data element missing',
  },
  {
    name: 'ConfirmationDataElementMissing',
    id: '2773004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2773,
    type: 'int',
    codeSet: 'MatchExceptionTypeCodeSet',
    description: 'Confirmation data element missing',
  },
  {
    name: 'DataDifferenceNotWithinTolerance',
    id: '2773005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2773,
    type: 'int',
    codeSet: 'MatchExceptionTypeCodeSet',
    description: 'Data difference not within tolerance',
  },
  {
    name: 'MatchWithinTolerance',
    id: '2773006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2773,
    type: 'int',
    codeSet: 'MatchExceptionTypeCodeSet',
    description: 'Match within tolerance',
  },
  {
    name: 'Other',
    id: '2773007',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2773,
    type: 'int',
    codeSet: 'MatchExceptionTypeCodeSet',
    description: 'Other',
  },
  {
    name: 'AccruedInterest',
    id: '2774001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2774,
    type: 'int',
    codeSet: 'MatchExceptionElementTypeCodeSet',
    description: 'Accrued interest',
  },
  {
    name: 'DealPrice',
    id: '2774002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2774,
    type: 'int',
    codeSet: 'MatchExceptionElementTypeCodeSet',
    description: 'Deal price',
  },
  {
    name: 'TradeDate',
    id: '2774003',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2774,
    type: 'int',
    codeSet: 'MatchExceptionElementTypeCodeSet',
    description: 'Trade date\n\nTolerance not applicable',
  },
  {
    name: 'SettlementDate',
    id: '2774004',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2774,
    type: 'int',
    codeSet: 'MatchExceptionElementTypeCodeSet',
    description: 'Settlement date\n\nTolerance not applicable',
  },
  {
    name: 'SideIndicator',
    id: '2774005',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2774,
    type: 'int',
    codeSet: 'MatchExceptionElementTypeCodeSet',
    description: 'Side indicator\n\nTolerance not applicable',
  },
  {
    name: 'TradedCurrency',
    id: '2774006',
    value: '6',
    sort: 6,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2774,
    type: 'int',
    codeSet: 'MatchExceptionElementTypeCodeSet',
    description: 'Traded currency\n\nTolerance not applicable',
  },
  {
    name: 'AccountID',
    id: '2774007',
    value: '7',
    sort: 7,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2774,
    type: 'int',
    codeSet: 'MatchExceptionElementTypeCodeSet',
    description: 'Account ID\n\nTolerance not applicable',
  },
  {
    name: 'ExecutingBrokerID',
    id: '2774008',
    value: '8',
    sort: 8,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2774,
    type: 'int',
    codeSet: 'MatchExceptionElementTypeCodeSet',
    description: 'Executing broker ID\n\nTolerance not applicable',
  },
  {
    name: 'SettlementCurrencyAndAmount',
    id: '2774009',
    value: '9',
    sort: 9,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2774,
    type: 'int',
    codeSet: 'MatchExceptionElementTypeCodeSet',
    description: 'Settlement currency and amount',
  },
  {
    name: 'InvestmentManagerID',
    id: '2774010',
    value: '10',
    sort: 10,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2774,
    type: 'int',
    codeSet: 'MatchExceptionElementTypeCodeSet',
    description: 'Investment manager ID\n\nTolerance not applicable',
  },
  {
    name: 'NetAmount',
    id: '2774011',
    value: '11',
    sort: 11,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2774,
    type: 'int',
    codeSet: 'MatchExceptionElementTypeCodeSet',
    description: 'Net amount',
  },
  {
    name: 'PlaceOfSettlement',
    id: '2774012',
    value: '12',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2774,
    type: 'int',
    codeSet: 'MatchExceptionElementTypeCodeSet',
    description: 'Place of settlement\n\nTolerance not applicable',
  },
  {
    name: 'Commissions',
    id: '2774013',
    value: '13',
    sort: 13,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2774,
    type: 'int',
    codeSet: 'MatchExceptionElementTypeCodeSet',
    description: 'Commissions',
  },
  {
    name: 'SecurityIdentifier',
    id: '2774014',
    value: '14',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2774,
    type: 'int',
    codeSet: 'MatchExceptionElementTypeCodeSet',
    description: 'Security identifier\n\nTolerance not applicable',
  },
  {
    name: 'QualityAllocated',
    id: '2774015',
    value: '15',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2774,
    type: 'int',
    codeSet: 'MatchExceptionElementTypeCodeSet',
    description: 'Quantity allocated',
  },
  {
    name: 'Principal',
    id: '2774016',
    value: '16',
    sort: 16,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2774,
    type: 'int',
    codeSet: 'MatchExceptionElementTypeCodeSet',
    description: 'Principal',
  },
  {
    name: 'Fees',
    id: '2774017',
    value: '17',
    sort: 17,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2774,
    type: 'int',
    codeSet: 'MatchExceptionElementTypeCodeSet',
    description: 'Fees',
  },
  {
    name: 'Tax',
    id: '2774018',
    value: '18',
    sort: 18,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2774,
    type: 'int',
    codeSet: 'MatchExceptionElementTypeCodeSet',
    description: 'Tax',
  },
  {
    name: 'FixedAmount',
    id: '2779001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2779,
    type: 'int',
    codeSet: 'MatchExceptionToleranceValueTypeCodeSet',
    description: 'Fixed amount\n\nDefault if not specified',
  },
  {
    name: 'Percentage',
    id: '2779002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2779,
    type: 'int',
    codeSet: 'MatchExceptionToleranceValueTypeCodeSet',
    description: 'Percentage',
  },
  {
    name: 'Mandatory',
    id: '2782001',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2782,
    type: 'int',
    codeSet: 'MatchingDataPointIndicatorCodeSet',
    description: 'Mandatory',
  },
  {
    name: 'Optional',
    id: '2782002',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '246',
    tag: 2782,
    type: 'int',
    codeSet: 'MatchingDataPointIndicatorCodeSet',
    description: 'Optional',
  },
  {
    name: 'New',
    id: '2788001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '247',
    tag: 2788,
    type: 'int',
    codeSet: 'TradeAggregationTransTypeCodeSet',
    description: 'New',
  },
  {
    name: 'Cancel',
    id: '2788002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '247',
    tag: 2788,
    type: 'int',
    codeSet: 'TradeAggregationTransTypeCodeSet',
    description: 'Cancel',
  },
  {
    name: 'Replace',
    id: '2788003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '247',
    tag: 2788,
    type: 'int',
    codeSet: 'TradeAggregationTransTypeCodeSet',
    description: 'Replace',
  },
  {
    name: 'Accepted',
    id: '2790001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '247',
    tag: 2790,
    type: 'int',
    codeSet: 'TradeAggregationRequestStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Rejected',
    id: '2790002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '247',
    tag: 2790,
    type: 'int',
    codeSet: 'TradeAggregationRequestStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'UnknownOrders',
    id: '2791001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '247',
    tag: 2791,
    type: 'int',
    codeSet: 'TradeAggregationRejectReasonCodeSet',
    description: 'Unknown order(s)',
  },
  {
    name: 'UnknownExecutionFills',
    id: '2791002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '247',
    tag: 2791,
    type: 'int',
    codeSet: 'TradeAggregationRejectReasonCodeSet',
    description: 'Unknown execution/fill(s)',
  },
  {
    name: 'Other',
    id: '2791003',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '247',
    tag: 2791,
    type: 'int',
    codeSet: 'TradeAggregationRejectReasonCodeSet',
    description: 'Other',
  },
  {
    name: 'Regular',
    id: '2795001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '247',
    tag: 2795,
    type: 'int',
    codeSet: 'OffshoreIndicatorCodeSet',
    description:
      'Regular - Default if not specified.\n\nThe notion of onshore and offshore rates does not apply.',
  },
  {
    name: 'Offshore',
    id: '2795002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '247',
    tag: 2795,
    type: 'int',
    codeSet: 'OffshoreIndicatorCodeSet',
    description:
      'Offshore\n\nUsed to indicate that the rate specified is an offshore rate which differs from its onshore rate.',
  },
  {
    name: 'Onshore',
    id: '2795003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '247',
    tag: 2795,
    type: 'int',
    codeSet: 'OffshoreIndicatorCodeSet',
    description:
      'Onshore\n\nUsed to indicate that the rate specified is an onshore rate which differs from its offshore rate.',
  },
  {
    name: 'New',
    id: '2804001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2804,
    type: 'int',
    codeSet: 'PayReportTransTypeCodeSet',
    description: 'New',
  },
  {
    name: 'Replace',
    id: '2804002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2804,
    type: 'int',
    codeSet: 'PayReportTransTypeCodeSet',
    description: 'Replace',
  },
  {
    name: 'Status',
    id: '2804003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2804,
    type: 'int',
    codeSet: 'PayReportTransTypeCodeSet',
    description:
      'Status\n\nAn unsolicited message reporting the current progress status of the payment.',
  },
  {
    name: 'Received',
    id: '2806001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2806,
    type: 'int',
    codeSet: 'PayReportStatusCodeSet',
    description: 'Received, not yet processed',
  },
  {
    name: 'Accepted',
    id: '2806002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2806,
    type: 'int',
    codeSet: 'PayReportStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Rejected',
    id: '2806003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2806,
    type: 'int',
    codeSet: 'PayReportStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'Disputed',
    id: '2806004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2806,
    type: 'int',
    codeSet: 'PayReportStatusCodeSet',
    description:
      'Disputed\n\nUsed when there is some type of mismatch that can be resolved.',
  },
  {
    name: 'New',
    id: '2811001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2811,
    type: 'int',
    codeSet: 'PayRequestTransTypeCodeSet',
    description: 'New',
  },
  {
    name: 'Cancel',
    id: '2811002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2811,
    type: 'int',
    codeSet: 'PayRequestTransTypeCodeSet',
    description: 'Cancel',
  },
  {
    name: 'Received',
    id: '2813001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2813,
    type: 'int',
    codeSet: 'PayRequestStatusCodeSet',
    description: 'Received, not yet processed',
  },
  {
    name: 'Accepted',
    id: '2813002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2813,
    type: 'int',
    codeSet: 'PayRequestStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Rejected',
    id: '2813003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2813,
    type: 'int',
    codeSet: 'PayRequestStatusCodeSet',
    description: 'Rejected',
  },
  {
    name: 'Disputed',
    id: '2813004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2813,
    type: 'int',
    codeSet: 'PayRequestStatusCodeSet',
    description:
      'Disputed\n\nUsed when there is some type of mismatch that can be resolved.',
  },
  {
    name: 'DebitPay',
    id: '2819001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2819,
    type: 'int',
    codeSet: 'PostTradePaymentDebitOrCreditCodeSet',
    description: 'Debit / Pay',
  },
  {
    name: 'CreditReceive',
    id: '2819002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2819,
    type: 'int',
    codeSet: 'PostTradePaymentDebitOrCreditCodeSet',
    description: 'Credit / Receive',
  },
  {
    name: 'New',
    id: '2823001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2823,
    type: 'int',
    codeSet: 'PostTradePaymentStatusCodeSet',
    description: 'New\n\nPayment is awaiting confirmation from the recipient.',
  },
  {
    name: 'Initiated',
    id: '2823002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2823,
    type: 'int',
    codeSet: 'PostTradePaymentStatusCodeSet',
    description:
      'Initiated\n\nPayment is confirmed by the recipient and has been scheduled.',
  },
  {
    name: 'Pending',
    id: '2823003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2823,
    type: 'int',
    codeSet: 'PostTradePaymentStatusCodeSet',
    description:
      'Pending\n\nPayment has been instructed to the payment service but status is unknown.',
  },
  {
    name: 'Confirmed',
    id: '2823004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2823,
    type: 'int',
    codeSet: 'PostTradePaymentStatusCodeSet',
    description: 'Confirmed\n\nPayment is complete and confirmed by the payment service.',
  },
  {
    name: 'Rejected',
    id: '2823005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '249',
    tag: 2823,
    type: 'int',
    codeSet: 'PostTradePaymentStatusCodeSet',
    description: 'Rejected\n\nPayment was rejected by the payment service.',
  },
  {
    name: 'UniqueClOrdID',
    id: '2829001',
    value: 'N',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2829,
    type: 'Boolean',
    codeSet: 'DuplicateClOrdIDIndicatorCodeSet',
    description: 'Unique ClOrdID(11)',
  },
  {
    name: 'DuplicateClOrdID',
    id: '2829002',
    value: 'Y',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2829,
    type: 'Boolean',
    codeSet: 'DuplicateClOrdIDIndicatorCodeSet',
    description: 'Duplicate ClOrdID(11)',
  },
  {
    name: 'CustomerOrClient',
    id: '2830001',
    value: 'C',
    sort: 12,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2830,
    type: 'char',
    codeSet: 'EventInitiatorTypeCodeSet',
    description: 'Customer or client',
  },
  {
    name: 'ExchangeOrExecutionVenue',
    id: '2830002',
    value: 'E',
    sort: 14,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2830,
    type: 'char',
    codeSet: 'EventInitiatorTypeCodeSet',
    description: 'Exchange or execution venue',
  },
  {
    name: 'FirmOrBroker',
    id: '2830003',
    value: 'F',
    sort: 15,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2830,
    type: 'char',
    codeSet: 'EventInitiatorTypeCodeSet',
    description: 'Firm or broker',
  },
  {
    name: 'Bid',
    id: '2831001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2831,
    type: 'int',
    codeSet: 'NBBOEntryTypeCodeSet',
    description: 'Bid\n\nMay apply to price or quantity.',
  },
  {
    name: 'Offer',
    id: '2831002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2831,
    type: 'int',
    codeSet: 'NBBOEntryTypeCodeSet',
    description: 'Offer\n\nMay apply to price or quantity.',
  },
  {
    name: 'MidPrice',
    id: '2831003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2831,
    type: 'int',
    codeSet: 'NBBOEntryTypeCodeSet',
    description: 'Mid-price',
  },
  {
    name: 'NotApplicable',
    id: '2834001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2834,
    type: 'int',
    codeSet: 'NBBOSourceCodeSet',
    description:
      'Not applicable\n\nDefault if not specified. NBBO information is not applicable. NBBOEntryType(2831), NBBOPrice(2832), and NBBOQty(2833) must be omitted.',
  },
  {
    name: 'Direct',
    id: '2834002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2834,
    type: 'int',
    codeSet: 'NBBOSourceCodeSet',
    description:
      'Direct\n\nInformation is retrieved directly from an exchange or other electronic execution venue. There may be a performance advantage compared to retrieving the information from a source consolidating multiple feeds.',
  },
  {
    name: 'SIP',
    id: '2834003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2834,
    type: 'int',
    codeSet: 'NBBOSourceCodeSet',
    description:
      'Securities Information Processor\n\nThe Securities Information Processor (SIP) links the U.S. markets by processing and consolidating all protected bid/ask quotes and trades from every trading venue into a single, easily consumed data feed.',
  },
  {
    name: 'Hybrid',
    id: '2834004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2834,
    type: 'int',
    codeSet: 'NBBOSourceCodeSet',
    description:
      'Hybrid\n\nA combination of two or more data feeds is used as NBBO source. In the context of US CAT this is used for a combination of direct and SIP feeds.',
  },
  {
    name: 'MultipleQuotesAllowed',
    id: '2837001',
    value: 'N',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2837,
    type: 'Boolean',
    codeSet: 'SingleQuoteIndicatorCodeSet',
    description: 'Multiple quotes allowed',
  },
  {
    name: 'OnlyOneQuoteAllowed',
    id: '2837002',
    value: 'Y',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2837,
    type: 'Boolean',
    codeSet: 'SingleQuoteIndicatorCodeSet',
    description: 'Only one quote allowed',
  },
  {
    name: 'NotManuallyCaptured',
    id: '2839001',
    value: 'N',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2839,
    type: 'Boolean',
    codeSet: 'TrdRegTimestampManualIndicatorCodeSet',
    description: 'Not manually captured',
  },
  {
    name: 'ManuallyCaptured',
    id: '2839002',
    value: 'Y',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '253',
    tag: 2839,
    type: 'Boolean',
    codeSet: 'TrdRegTimestampManualIndicatorCodeSet',
    description: 'Manually captured',
  },
  {
    name: 'MoneyMarketFund',
    id: '2844001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 2844,
    type: 'int',
    codeSet: 'CollateralReinvestmentTypeCodeSet',
    description:
      'Money market fund\n\nRegistered money market fund. In the context of EU SFTR reporting this corresponds to code "MMFT".',
  },
  {
    name: 'OtherComingledPool',
    id: '2844002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 2844,
    type: 'int',
    codeSet: 'CollateralReinvestmentTypeCodeSet',
    description:
      'Other comingled pool\n\nAny commingled pool other than money market fund. In the context of EU SFTR reporting this corresponds to code "OCMP".',
  },
  {
    name: 'RepoMarket',
    id: '2844003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 2844,
    type: 'int',
    codeSet: 'CollateralReinvestmentTypeCodeSet',
    description:
      'Repo market\n\nThe repurchase agreement market. In the context of EU SFTR reporting this corresponds to code "REPM".',
  },
  {
    name: 'DirectPurchaseOfSecurities',
    id: '2844004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 2844,
    type: 'int',
    codeSet: 'CollateralReinvestmentTypeCodeSet',
    description:
      'Direct purchase of securities\n\nIn the context of EU SFTR reporting this corresponds to code "SDPU".',
  },
  {
    name: 'OtherInvestments',
    id: '2844005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 2844,
    type: 'int',
    codeSet: 'CollateralReinvestmentTypeCodeSet',
    description:
      'Other investments\n\nIn the context of EU SFTR reporting this corresponds to code "OTHR".',
  },
  {
    name: 'Repo',
    id: '2846001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 2846,
    type: 'int',
    codeSet: 'FundingSourceCodeSet',
    description:
      'Repurchase agreement\n\nRepurchase agreements or Buy Sellbacks. In the context of EU SFTR reporting this corresponds to code "REPO".',
  },
  {
    name: 'Cash',
    id: '2846002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 2846,
    type: 'int',
    codeSet: 'FundingSourceCodeSet',
    description:
      'Cash\n\nCash collateral from securities lending. In the context of EU SFTR reporting this corresponds to code "SECL".',
  },
  {
    name: 'FreeCedits',
    id: '2846003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 2846,
    type: 'int',
    codeSet: 'FundingSourceCodeSet',
    description:
      'Free credits\n\nIn the context of EU SFTR reporting this corresponds to code "FREE".',
  },
  {
    name: 'CustomerShortSales',
    id: '2846004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 2846,
    type: 'int',
    codeSet: 'FundingSourceCodeSet',
    description:
      'Customer short sales\n\nProceeds from customer short sales. In the context of EU SFTR reporting this corresponds to code "CSHS".',
  },
  {
    name: 'BrokerShortSales',
    id: '2846005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 2846,
    type: 'int',
    codeSet: 'FundingSourceCodeSet',
    description:
      'Broker short sales\n\nProceeds from broker short sales. In the context of EU SFTR reporting this corresponds to code "BSHS".',
  },
  {
    name: 'UnsecuredBorrowing',
    id: '2846006',
    value: '5',
    sort: 5,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 2846,
    type: 'int',
    codeSet: 'FundingSourceCodeSet',
    description:
      'Unsecured borrowing\n\nIn the context of EU SFTR reporting this corresponds to code "UBOR".',
  },
  {
    name: 'Other',
    id: '2846007',
    value: '99',
    sort: 99,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 2846,
    type: 'int',
    codeSet: 'FundingSourceCodeSet',
    description:
      'Other\n\nIn the context of EU SFTR reporting this corresponds to code "OTHR".',
  },
  {
    name: 'Posted',
    id: '2851001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 2851,
    type: 'int',
    codeSet: 'MarginDirectionCodeSet',
    description:
      'Posted\n\nThe party or account that is the object of the report posted margin.',
  },
  {
    name: 'Received',
    id: '2851002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 2851,
    type: 'int',
    codeSet: 'MarginDirectionCodeSet',
    description:
      'Received\n\nThe party or account that is the object of the report received margin.',
  },
  {
    name: 'ExclusiveArrangement',
    id: '2872001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 2872,
    type: 'int',
    codeSet: 'TransactionAttributeTypeCodeSet',
    description:
      "Exclusive arrangement\n\nIn the context of securities borrowing and lending transaction, an indication of whether the borrower has exclusive access to borrow from the lender's securities portfolio. Not applicable to commodities. TransactionAttributeValue(2873) takes Y or N value.",
  },
  {
    name: 'CollateralReuse',
    id: '2872002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 2872,
    type: 'int',
    codeSet: 'TransactionAttributeTypeCodeSet',
    description:
      'Collateral reuse\n\nIndication of whether the collateral taker can reuse the securities provided as collateral for the transaction. TransactionAttributeValue(tbd2873) takes Y or N value.',
  },
  {
    name: 'CollateralArrangmentType',
    id: '2872003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '254',
    tag: 2872,
    type: 'int',
    codeSet: 'TransactionAttributeTypeCodeSet',
    description:
      'Collateral arrangement type\n\nIn the context of securities financing transactions, indicates the type of collateral arrangement. For EU SFTR reporting, TransactionAttributeValue(2873) may take ESMA assigned values "TTCA" (title transfer), "SICA" (securities financial interest), or "SIUR" (securities financial interest with right of use).',
  },
  {
    name: 'NoRoutingArrangmentInPlace',
    id: '2883001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '256',
    tag: 2883,
    type: 'int',
    codeSet: 'RoutingArrangmentIndicatorCodeSet',
    description: 'No routing arrangement in place',
  },
  {
    name: 'RoutingArrangementInPlace',
    id: '2883002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '256',
    tag: 2883,
    type: 'int',
    codeSet: 'RoutingArrangmentIndicatorCodeSet',
    description: 'Routing arrangement in place',
  },
  {
    name: 'NonFIXSource',
    id: '2888001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '259',
    tag: 2888,
    type: 'int',
    codeSet: 'RelatedOrderIDSourceCodeSet',
    description: 'Non-FIX Source',
  },
  {
    name: 'SystemOrderIdentifier',
    id: '2888002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '259',
    tag: 2888,
    type: 'int',
    codeSet: 'RelatedOrderIDSourceCodeSet',
    description:
      'Order identifier\n\nCan be used to refer to an order identifier assigned by the party accepting the order, e.g. OrderID(37).',
  },
  {
    name: 'ClientOrderIdentifier',
    id: '2888003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '259',
    tag: 2888,
    type: 'int',
    codeSet: 'RelatedOrderIDSourceCodeSet',
    description:
      'Client order identifier\n\nCan be used to refer to an order identifier assigned by the party initiating the order, e.g. ClOrdID(11).',
  },
  {
    name: 'SecondaryOrderIdentifier',
    id: '2888004',
    value: '3',
    sort: 3,
    added: 'FIX.5.0SP2',
    addedEP: '259',
    tag: 2888,
    type: 'int',
    codeSet: 'RelatedOrderIDSourceCodeSet',
    description:
      'Secondary order identifier\n\nCan be used to refer to an additional order identifier assigned by the party accepting the order, e.g. SecondaryOrderID(198).',
  },
  {
    name: 'SecondaryClientOrderIdentifier',
    id: '2888005',
    value: '4',
    sort: 4,
    added: 'FIX.5.0SP2',
    addedEP: '259',
    tag: 2888,
    type: 'int',
    codeSet: 'RelatedOrderIDSourceCodeSet',
    description:
      'Secondary client order identifier\n\nCan be used to refer to an additional order identifier assigned by the party initiating the order, e.g. SecondaryClOrdID(526).',
  },
  {
    name: 'NotSpecified',
    id: '2890001',
    value: '0',
    sort: 0,
    added: 'FIX.5.0SP2',
    addedEP: '259',
    tag: 2890,
    type: 'int',
    codeSet: 'OrderRelationshipCodeSet',
    description: 'Not specified',
  },
  {
    name: 'OrderAggregation',
    id: '2890002',
    value: '1',
    sort: 1,
    added: 'FIX.5.0SP2',
    addedEP: '259',
    tag: 2890,
    type: 'int',
    codeSet: 'OrderRelationshipCodeSet',
    description:
      'Order aggregation\n\nOrder has been subject to a bundling of multiple orders to a single new order identified outside of the component.',
  },
  {
    name: 'OrderSplit',
    id: '2890003',
    value: '2',
    sort: 2,
    added: 'FIX.5.0SP2',
    addedEP: '259',
    tag: 2890,
    type: 'int',
    codeSet: 'OrderRelationshipCodeSet',
    description:
      'Order split\n\nOrder has been created as a child order of the order identified outside of the component.',
  },
  {
    name: 'CUSIP',
    id: '2897001',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '273',
    tag: 2897,
    type: 'String',
    codeSet: 'CurrencyCodeSourceCodeSet',
    description: 'CUSIP',
  },
  {
    name: 'SEDOL',
    id: '2897002',
    value: '2',
    sort: 2,
    added: 'FIX.Latest',
    addedEP: '273',
    tag: 2897,
    type: 'String',
    codeSet: 'CurrencyCodeSourceCodeSet',
    description: 'SEDOL',
  },
  {
    name: 'ISINNumber',
    id: '2897003',
    value: '4',
    sort: 4,
    added: 'FIX.Latest',
    addedEP: '273',
    tag: 2897,
    type: 'String',
    codeSet: 'CurrencyCodeSourceCodeSet',
    description: 'ISIN',
  },
  {
    name: 'ISOCurrencyCode',
    id: '2897004',
    value: '6',
    sort: 6,
    added: 'FIX.Latest',
    addedEP: '273',
    tag: 2897,
    type: 'String',
    codeSet: 'CurrencyCodeSourceCodeSet',
    description: 'ISO Currency Code (ISO 4217)',
  },
  {
    name: 'FinancialInstrumentGlobalIdentifier',
    id: '2897005',
    value: 'S',
    sort: 27,
    added: 'FIX.Latest',
    addedEP: '273',
    tag: 2897,
    type: 'String',
    codeSet: 'CurrencyCodeSourceCodeSet',
    description:
      'Financial Instrument Global Identifier\n\nAn Object Management Group (OMG) standard. Also referred to as FIGI. Formerly known as "Bloomberg Open Symbology BBGID".',
  },
  {
    name: 'DigitalTokenIdentifier',
    id: '2897006',
    value: 'Y',
    sort: 33,
    added: 'FIX.Latest',
    addedEP: '273',
    tag: 2897,
    type: 'String',
    codeSet: 'CurrencyCodeSourceCodeSet',
    description: 'Digital Token Identifier (ISO 24165)',
  },
  {
    name: 'NotMultiJrsdctnEligible',
    id: '2963001',
    value: '0',
    sort: 0,
    added: 'FIX.Latest',
    addedEP: '277',
    tag: 2963,
    type: 'int',
    codeSet: 'MultiJurisdictionReportingIndicatorCodeSet',
    description: 'Trade not eligible for multi-jurisdiction reporting',
  },
  {
    name: 'MultiJrsdctnEligible',
    id: '2963002',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '277',
    tag: 2963,
    type: 'int',
    codeSet: 'MultiJurisdictionReportingIndicatorCodeSet',
    description: 'Trade eligible for multi-jurisdiction reporting',
  },
  {
    name: 'CancelAggressive',
    id: '2964001',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '280',
    tag: 2964,
    type: 'int',
    codeSet: 'SelfMatchPreventionInstructionCodeSet',
    description: 'Cancel aggressive\n\nCancel incoming order.',
  },
  {
    name: 'CancelPassive',
    id: '2964002',
    value: '2',
    sort: 2,
    added: 'FIX.Latest',
    addedEP: '280',
    tag: 2964,
    type: 'int',
    codeSet: 'SelfMatchPreventionInstructionCodeSet',
    description:
      'Cancel passive\n\nCancel resting order with the same SelfMatchPreventionID(2362).',
  },
  {
    name: 'CancelAggressivePassive',
    id: '2964003',
    value: '3',
    sort: 3,
    added: 'FIX.Latest',
    addedEP: '280',
    tag: 2964,
    type: 'int',
    codeSet: 'SelfMatchPreventionInstructionCodeSet',
    description:
      'Cancel aggressive and passive\n\nCancel both incoming and resting order with the same SelfMatchPreventionID(2362).',
  },
  {
    name: 'Received',
    id: '2966001',
    value: '0',
    sort: 0,
    added: 'FIX.Latest',
    addedEP: '281',
    tag: 2966,
    type: 'int',
    codeSet: 'SettlStatusRequestStatusCodeSet',
    description: 'Received, not yet processed',
  },
  {
    name: 'Accepted',
    id: '2966002',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '281',
    tag: 2966,
    type: 'int',
    codeSet: 'SettlStatusRequestStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Rejected',
    id: '2966003',
    value: '2',
    sort: 2,
    added: 'FIX.Latest',
    addedEP: '281',
    tag: 2966,
    type: 'int',
    codeSet: 'SettlStatusRequestStatusCodeSet',
    description: 'Rejected\n\nRejection reason provided in RejectText(1328).',
  },
  {
    name: 'Received',
    id: '2973001',
    value: '0',
    sort: 0,
    added: 'FIX.Latest',
    addedEP: '281',
    tag: 2973,
    type: 'int',
    codeSet: 'SettlStatusReportStatusCodeSet',
    description: 'Received, not yet processed',
  },
  {
    name: 'Accepted',
    id: '2973002',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '281',
    tag: 2973,
    type: 'int',
    codeSet: 'SettlStatusReportStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Rejected',
    id: '2973003',
    value: '2',
    sort: 2,
    added: 'FIX.Latest',
    addedEP: '281',
    tag: 2973,
    type: 'int',
    codeSet: 'SettlStatusReportStatusCodeSet',
    description: 'Rejected\n\nRejection reason provided in RejectText(1328).',
  },
  {
    name: 'TradeType',
    id: '2980001',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '285',
    tag: 2980,
    type: 'int',
    codeSet: 'AllocGroupSubQtyTypeCodeSet',
    description: 'Trade type',
  },
  {
    name: 'TradePublicationIndicator',
    id: '2980002',
    value: '2',
    sort: 2,
    added: 'FIX.Latest',
    addedEP: '285',
    tag: 2980,
    type: 'int',
    codeSet: 'AllocGroupSubQtyTypeCodeSet',
    description: 'Trade publication indicator',
  },
  {
    name: 'OrderHandlingInstruction',
    id: '2980003',
    value: '3',
    sort: 3,
    added: 'FIX.Latest',
    addedEP: '285',
    tag: 2980,
    type: 'int',
    codeSet: 'AllocGroupSubQtyTypeCodeSet',
    description: 'Order handling instruction',
  },
  {
    name: 'Realtime',
    id: '2993001',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '288',
    tag: 2993,
    type: 'int',
    codeSet: 'MetricsCalculationPriceSourceCodeSet',
    description:
      'Real-time\n\nReal-time market prices used as the data source in metrics/analytics calculation.',
  },
  {
    name: 'EndOfDay',
    id: '2993002',
    value: '2',
    sort: 2,
    added: 'FIX.Latest',
    addedEP: '288',
    tag: 2993,
    type: 'int',
    codeSet: 'MetricsCalculationPriceSourceCodeSet',
    description:
      'End of day\n\nOfficial end of day price (marking) used as the data source in metrics/analytics calculation.',
  },
  {
    name: 'BlackScholes',
    id: '2994001',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '288',
    tag: 2994,
    type: 'int',
    codeSet: 'AssetValuationModelCodeSet',
    description: 'Black-Scholes',
  },
  {
    name: 'Whaley',
    id: '2994002',
    value: '2',
    sort: 2,
    added: 'FIX.Latest',
    addedEP: '288',
    tag: 2994,
    type: 'int',
    codeSet: 'AssetValuationModelCodeSet',
    description: 'Whaley',
  },
  {
    name: 'Bachelier',
    id: '2994003',
    value: '3',
    sort: 3,
    added: 'FIX.Latest',
    addedEP: '288',
    tag: 2994,
    type: 'int',
    codeSet: 'AssetValuationModelCodeSet',
    description: 'Bachelier',
  },
  {
    name: 'Kirk',
    id: '2994004',
    value: '4',
    sort: 4,
    added: 'FIX.Latest',
    addedEP: '288',
    tag: 2994,
    type: 'int',
    codeSet: 'AssetValuationModelCodeSet',
    description: 'Kirk',
  },
  {
    name: 'Curran',
    id: '2994005',
    value: '5',
    sort: 5,
    added: 'FIX.Latest',
    addedEP: '288',
    tag: 2994,
    type: 'int',
    codeSet: 'AssetValuationModelCodeSet',
    description: 'Curran',
  },
  {
    name: 'Black76',
    id: '2994006',
    value: '6',
    sort: 6,
    added: 'FIX.Latest',
    addedEP: '288',
    tag: 2994,
    type: 'int',
    codeSet: 'AssetValuationModelCodeSet',
    description: 'Black-76',
  },
  {
    name: 'Binomial',
    id: '2994007',
    value: '7',
    sort: 7,
    added: 'FIX.Latest',
    addedEP: '288',
    tag: 2994,
    type: 'int',
    codeSet: 'AssetValuationModelCodeSet',
    description: 'Binomial',
  },
  {
    name: 'OtherModel',
    id: '2994008',
    value: '99',
    sort: 99,
    added: 'FIX.Latest',
    addedEP: '288',
    tag: 2994,
    type: 'int',
    codeSet: 'AssetValuationModelCodeSet',
    description: 'Other model',
  },
  {
    name: 'New',
    id: '3016001',
    value: '0',
    sort: 0,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3016,
    type: 'int',
    codeSet: 'AlgoCertificateRequestTransTypeCodeSet',
    description: 'New',
  },
  {
    name: 'Cancel',
    id: '3016002',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3016,
    type: 'int',
    codeSet: 'AlgoCertificateRequestTransTypeCodeSet',
    description: 'Cancel',
  },
  {
    name: 'Received',
    id: '3017001',
    value: '0',
    sort: 0,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3017,
    type: 'int',
    codeSet: 'AlgoCertificateRequestStatusCodeSet',
    description: 'Received, not yet processed',
  },
  {
    name: 'Accepted',
    id: '3017002',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3017,
    type: 'int',
    codeSet: 'AlgoCertificateRequestStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Rejected',
    id: '3017003',
    value: '2',
    sort: 2,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3017,
    type: 'int',
    codeSet: 'AlgoCertificateRequestStatusCodeSet',
    description: 'Rejected\n\nRejection reason provided in RejectText(1328).',
  },
  {
    name: 'New',
    id: '3020001',
    value: '0',
    sort: 0,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3020,
    type: 'int',
    codeSet: 'AlgoCertificateReportTransTypeCodeSet',
    description: 'New',
  },
  {
    name: 'Cancel',
    id: '3020002',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3020,
    type: 'int',
    codeSet: 'AlgoCertificateReportTransTypeCodeSet',
    description: 'Cancel',
  },
  {
    name: 'Replace',
    id: '3020003',
    value: '2',
    sort: 2,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3020,
    type: 'int',
    codeSet: 'AlgoCertificateReportTransTypeCodeSet',
    description: 'Replace',
  },
  {
    name: 'Received',
    id: '3021001',
    value: '0',
    sort: 0,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3021,
    type: 'int',
    codeSet: 'AlgoCertificateReportStatusCodeSet',
    description: 'Received, not yet processed',
  },
  {
    name: 'Accepted',
    id: '3021002',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3021,
    type: 'int',
    codeSet: 'AlgoCertificateReportStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Rejected',
    id: '3021003',
    value: '2',
    sort: 2,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3021,
    type: 'int',
    codeSet: 'AlgoCertificateReportStatusCodeSet',
    description: 'Rejected\n\nRejection reason provided in RejectText(1328).',
  },
  {
    name: 'Draft',
    id: '3022001',
    value: '0',
    sort: 0,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3022,
    type: 'int',
    codeSet: 'AlgoCertificateStatusCodeSet',
    description: 'Draft\n\nCertificate identifier assigned.',
  },
  {
    name: 'Approved',
    id: '3022002',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3022,
    type: 'int',
    codeSet: 'AlgoCertificateStatusCodeSet',
    description: 'Approved\n\nAlgorithm approved by authorized person.',
  },
  {
    name: 'Submitted',
    id: '3022003',
    value: '2',
    sort: 2,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3022,
    type: 'int',
    codeSet: 'AlgoCertificateStatusCodeSet',
    description: 'Submitted\n\nAlgorithm sent to venue.',
  },
  {
    name: 'Under',
    id: '3058001',
    value: '0',
    sort: 0,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3058,
    type: 'int',
    codeSet: 'TestThresholdTypeCodeSet',
    description: 'Under',
  },
  {
    name: 'Over',
    id: '3058002',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3058,
    type: 'int',
    codeSet: 'TestThresholdTypeCodeSet',
    description: 'Over',
  },
  {
    name: 'New',
    id: '3064001',
    value: '0',
    sort: 0,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3064,
    type: 'int',
    codeSet: 'TestSuiteRequestTransTypeCodeSet',
    description: 'New',
  },
  {
    name: 'Cancel',
    id: '3064002',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3064,
    type: 'int',
    codeSet: 'TestSuiteRequestTransTypeCodeSet',
    description: 'Cancel',
  },
  {
    name: 'Received',
    id: '3065001',
    value: '0',
    sort: 0,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3065,
    type: 'int',
    codeSet: 'TestSuiteRequestStatusCodeSet',
    description: 'Received, not yet processed',
  },
  {
    name: 'Accepted',
    id: '3065002',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3065,
    type: 'int',
    codeSet: 'TestSuiteRequestStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Rejected',
    id: '3065003',
    value: '2',
    sort: 2,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3065,
    type: 'int',
    codeSet: 'TestSuiteRequestStatusCodeSet',
    description: 'Rejected\n\nRejection reason provided in RejectText(1328).',
  },
  {
    name: 'Start',
    id: '3067001',
    value: '0',
    sort: 0,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3067,
    type: 'int',
    codeSet: 'TestActionTypeCodeSet',
    description: 'Start',
  },
  {
    name: 'Stop',
    id: '3067002',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3067,
    type: 'int',
    codeSet: 'TestActionTypeCodeSet',
    description: 'Stop',
  },
  {
    name: 'State',
    id: '3067003',
    value: '2',
    sort: 2,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3067,
    type: 'int',
    codeSet: 'TestActionTypeCodeSet',
    description: 'State',
  },
  {
    name: 'Received',
    id: '3068001',
    value: '0',
    sort: 0,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3068,
    type: 'int',
    codeSet: 'TestActionRequestStatusCodeSet',
    description: 'Received, not yet processed',
  },
  {
    name: 'Accepted',
    id: '3068002',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3068,
    type: 'int',
    codeSet: 'TestActionRequestStatusCodeSet',
    description: 'Accepted',
  },
  {
    name: 'Rejected',
    id: '3068003',
    value: '2',
    sort: 2,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3068,
    type: 'int',
    codeSet: 'TestActionRequestStatusCodeSet',
    description: 'Rejected\n\nRejection reason provided in RejectText(1328).',
  },
  {
    name: 'Scheduled',
    id: '3069001',
    value: '0',
    sort: 0,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3069,
    type: 'int',
    codeSet: 'TestSuiteActivityStateCodeSet',
    description: 'Scheduled\n\nTest suite is currently being executed.',
  },
  {
    name: 'Completed',
    id: '3069002',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3069,
    type: 'int',
    codeSet: 'TestSuiteActivityStateCodeSet',
    description:
      'Completed\n\nTest suite has run to completion and test status information is available.',
  },
  {
    name: 'Cancelled',
    id: '3069003',
    value: '2',
    sort: 2,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3069,
    type: 'int',
    codeSet: 'TestSuiteActivityStateCodeSet',
    description:
      'Cancelled\n\nTest suite has not run to completion due to a cancellation by the user or an abnormal termination by the test system. Test suite status information is undefined.',
  },
  {
    name: 'Undefined',
    id: '3070001',
    value: '0',
    sort: 0,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3070,
    type: 'int',
    codeSet: 'TestSuiteStatusCodeSet',
    description: 'Undefined',
  },
  {
    name: 'Pass',
    id: '3070002',
    value: '1',
    sort: 1,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3070,
    type: 'int',
    codeSet: 'TestSuiteStatusCodeSet',
    description: 'Pass',
  },
  {
    name: 'Fail',
    id: '3070003',
    value: '2',
    sort: 2,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3070,
    type: 'int',
    codeSet: 'TestSuiteStatusCodeSet',
    description: 'Fail',
  },
  {
    name: 'Warning',
    id: '3070004',
    value: '3',
    sort: 3,
    added: 'FIX.Latest',
    addedEP: '292',
    tag: 3070,
    type: 'int',
    codeSet: 'TestSuiteStatusCodeSet',
    description: 'Warning',
  },
];

const batch3: ISpecEnums[] = [];

const batch4: ISpecEnums[] = [];

export const ENUMS: ISpecEnums[] = batch1.concat(batch2, batch3, batch4);
